export const citiesData = [
  {
    type: 'cityName',
    value: 'TEZPUR, ASSAM',
    masterId: 21264,
  },
  {
    type: 'cityName',
    value: 'GANGAPUR (BHILWARA), RAJASTHAN',
    masterId: 21263,
  },
  {
    type: 'cityName',
    value: 'MAA AMBIKA BHAWANI, BIHAR',
    masterId: 18708,
  },
  {
    type: 'cityName',
    value: 'PANJIM, GOA',
    masterId: 21262,
  },
  {
    type: 'cityName',
    value: 'KOTA, KARNATAKA',
    masterId: 21261,
  },
  {
    type: 'cityName',
    value: 'AMB  ANDAURA, HIMACHAL PRADESH',
    masterId: 10135,
  },
  {
    type: 'cityName',
    value: 'ANGAR, MAHARASHTRA',
    masterId: 10205,
  },
  {
    type: 'cityName',
    value: 'ITEHAR, MADHYA PRADESH',
    masterId: 17838,
  },
  {
    type: 'cityName',
    value: 'AMLAI, MADHYA PRADESH',
    masterId: 10163,
  },
  {
    type: 'cityName',
    value: 'ANGADIPURAM, KERALA',
    masterId: 10201,
  },
  {
    type: 'cityName',
    value: 'AMBIAPUR, UTTAR PRADESH',
    masterId: 21011,
  },
  {
    type: 'cityName',
    value: 'ADESAR, GUJARAT',
    masterId: 18518,
  },
  {
    type: 'cityName',
    value: 'ASRANADA, RAJASTHAN',
    masterId: 10279,
  },
  {
    type: 'cityName',
    value: 'NEYYOOR, TAMIL NADU',
    masterId: 13989,
  },
  {
    type: 'cityName',
    value: 'AMBUR, TAMIL NADU',
    masterId: 10153,
  },
  {
    type: 'cityName',
    value: 'ABADA, WEST BENGAL',
    masterId: 17877,
  },
  {
    type: 'cityName',
    value: 'AHMEDABAD, GUJARAT',
    masterId: 10055,
  },
  {
    type: 'cityName',
    value: 'AMBIKESHWAR, MADHYA PRADESH',
    masterId: 17875,
  },
  {
    type: 'cityName',
    value: 'AMBARI, WEST BENGAL',
    masterId: 10148,
  },
  {
    type: 'cityName',
    value: 'ARBAGATTA H, KARNATAKA',
    masterId: 18073,
  },
  {
    type: 'cityName',
    value: 'ULHASNAGAR, MAHARASHTRA',
    masterId: 15662,
  },
  {
    type: 'cityName',
    value: 'CHINNALAPATTI, TAMIL NADU',
    masterId: 11110,
  },
  {
    type: 'cityName',
    value: 'KALNA, WEST BENGAL',
    masterId: 12422,
  },
  {
    type: 'cityName',
    value: 'AMBIKAPUR, CHHATTISGARH',
    masterId: 10152,
  },
  {
    type: 'cityName',
    value: 'AMBALE, MAHARASHTRA',
    masterId: 10145,
  },
  {
    type: 'cityName',
    value: 'ASTHAL BOHAR, CHHATTISGARH',
    masterId: 18352,
  },
  {
    type: 'cityName',
    value: 'AKBARPUR, UTTAR PRADESH',
    masterId: 10077,
  },
  {
    type: 'cityName',
    value: 'ABU ROAD, RAJASTHAN',
    masterId: 10015,
  },
  {
    type: 'cityName',
    value: 'ABOHAR, PUNJAB',
    masterId: 10014,
  },
  {
    type: 'cityName',
    value: 'AMBASSA, TRIPURA',
    masterId: 16791,
  },
  {
    type: 'cityName',
    value: 'ABUTARA, WEST BENGAL',
    masterId: 16189,
  },
  {
    type: 'cityName',
    value: 'AMBARI, MAHARASHTRA',
    masterId: 19128,
  },
  {
    type: 'cityName',
    value: 'AMBIVLI, MAHARASHTRA',
    masterId: 17710,
  },
  {
    type: 'cityName',
    value: 'ADGAON BUZURG, MAHARASHTRA',
    masterId: 10027,
  },
  {
    type: 'cityName',
    value: 'AACHEGAON, MAHARASHTRA',
    masterId: 17715,
  },
  {
    type: 'cityName',
    value: 'ACHALGANJ, UTTAR PRADESH',
    masterId: 16701,
  },
  {
    type: 'cityName',
    value: 'ANCHELI, GUJARAT',
    masterId: 10194,
  },
  {
    type: 'cityName',
    value: 'AZIMGANJ, WEST BENGAL',
    masterId: 10324,
  },
  {
    type: 'cityName',
    value: 'FAIZABAD, UTTAR PRADESH',
    masterId: 11551,
  },
  {
    type: 'cityName',
    value: 'ARCHIPATHAR, ASSAM',
    masterId: 18978,
  },
  {
    type: 'cityName',
    value: 'ADONI, ANDHRA PRADESH',
    masterId: 10035,
  },
  {
    type: 'cityName',
    value: 'ADILABAD, TELANGANA',
    masterId: 10028,
  },
  {
    type: 'cityName',
    value: 'ADAS, GUJARAT',
    masterId: 10022,
  },
  {
    type: 'cityName',
    value: 'ADARI ROAD, GUJARAT',
    masterId: 17590,
  },
  {
    type: 'cityName',
    value: 'GOTPARA, WEST BENGAL',
    masterId: 11789,
  },
  {
    type: 'cityName',
    value: 'KODIHALLI, KARNATAKA',
    masterId: 18010,
  },
  {
    type: 'cityName',
    value: 'ANDUL, WEST BENGAL',
    masterId: 16186,
  },
  {
    type: 'cityName',
    value: 'ADHIKARI, WEST BENGAL',
    masterId: 16012,
  },
  {
    type: 'cityName',
    value: 'ADAMPUR, HARYANA',
    masterId: 10021,
  },
  {
    type: 'cityName',
    value: 'ADRA, WEST BENGAL',
    masterId: 10037,
  },
  {
    type: 'cityName',
    value: 'ADVANCE STARTER, BIHAR',
    masterId: 18801,
  },
  {
    type: 'cityName',
    value: 'TRISHBIGHA, WEST BENGAL',
    masterId: 15607,
  },
  {
    type: 'cityName',
    value: 'ADUTHURAI, TAMIL NADU',
    masterId: 10039,
  },
  {
    type: 'cityName',
    value: 'JABALPUR, MADHYA PRADESH',
    masterId: 12098,
  },
  {
    type: 'cityName',
    value: 'ADITYAPUR, JHARKHAND',
    masterId: 10033,
  },
  {
    type: 'cityName',
    value: 'ADAVALI, MAHARASHTRA',
    masterId: 10023,
  },
  {
    type: 'cityName',
    value: 'ADDERLEY, BIHAR',
    masterId: 20786,
  },
  {
    type: 'cityName',
    value: 'AMRELI, GUJARAT',
    masterId: 10175,
  },
  {
    type: 'cityName',
    value: 'AULENDA, UTTAR PRADESH',
    masterId: 10304,
  },
  {
    type: 'cityName',
    value: 'ANANT PETH, MADHYA PRADESH',
    masterId: 17874,
  },
  {
    type: 'cityName',
    value: 'ARNEJ, GUJARAT',
    masterId: 10250,
  },
  {
    type: 'cityName',
    value: 'ANEKAL, KARNATAKA',
    masterId: 18078,
  },
  {
    type: 'cityName',
    value: 'ATELI, HARYANA ',
    masterId: 18351,
  },
  {
    type: 'cityName',
    value: 'GAJERAPARA, GUJARAT',
    masterId: 18478,
  },
  {
    type: 'cityName',
    value: 'ANGAMALY, KERALA',
    masterId: 10203,
  },
  {
    type: 'cityName',
    value: 'DAGARI, UTTAR PRADESH',
    masterId: 11190,
  },
  {
    type: 'cityName',
    value: 'ARANGHATA, UTTAR PRADESH',
    masterId: 21055,
  },
  {
    type: 'cityName',
    value: 'AGRA, UTTAR PRADESH',
    masterId: 10048,
  },
  {
    type: 'cityName',
    value: 'AGRADWIP, WEST BENGAL',
    masterId: 16232,
  },
  {
    type: 'cityName',
    value: 'AGAS, GUJARAT',
    masterId: 20800,
  },
  {
    type: 'cityName',
    value: 'AMBAGAON, CHHATTISGARH',
    masterId: 10138,
  },
  {
    type: 'cityName',
    value: 'ANGADI, GUJARAT',
    masterId: 17956,
  },
  {
    type: 'cityName',
    value: 'AGASOD, MADHYA PRADESH',
    masterId: 17876,
  },
  {
    type: 'cityName',
    value: 'AGRAN DHULGAON, MAHARASHTRA',
    masterId: 17713,
  },
  {
    type: 'cityName',
    value: 'ANGAI, RAJASTHAN',
    masterId: 17239,
  },
  {
    type: 'cityName',
    value: 'AMGURI, ASSAM',
    masterId: 10159,
  },
  {
    type: 'cityName',
    value: 'AMARGOL, KARNATAKA',
    masterId: 10131,
  },
  {
    type: 'cityName',
    value: 'AGARAM SIBBANDI, TAMIL NADU',
    masterId: 17008,
  },
  {
    type: 'cityName',
    value: 'AMGAON, MAHARASHTRA',
    masterId: 10157,
  },
  {
    type: 'cityName',
    value: 'ASIRGARH, MADHYA PRADESH',
    masterId: 17871,
  },
  {
    type: 'cityName',
    value: 'AMARGARH, MADHYA PRADESH',
    masterId: 10130,
  },
  {
    type: 'cityName',
    value: 'AGTHORI, ASSAM',
    masterId: 18954,
  },
  {
    type: 'cityName',
    value: 'AGARTALA, TRIPURA',
    masterId: 10042,
  },
  {
    type: 'cityName',
    value: 'ANGUA, WEST BENGAL',
    masterId: 16185,
  },
  {
    type: 'cityName',
    value: 'AGORI KHAS, UTTAR PRADESH',
    masterId: 10047,
  },
  {
    type: 'cityName',
    value: 'MARKEL, CHHATTISGARH',
    masterId: 13491,
  },
  {
    type: 'cityName',
    value: 'ACHHNERA, UTTAR PRADESH',
    masterId: 10018,
  },
  {
    type: 'cityName',
    value: 'ABHAIPUR, BIHAR',
    masterId: 10011,
  },
  {
    type: 'cityName',
    value: 'AHERWADI, KARNATAKA',
    masterId: 10051,
  },
  {
    type: 'cityName',
    value: 'AHMEDGARH, PUNJAB',
    masterId: 10056,
  },
  {
    type: 'cityName',
    value: 'AJHARAIL, BIHAR',
    masterId: 18800,
  },
  {
    type: 'cityName',
    value: 'AHALYAPUR, UTTAR PRADESH',
    masterId: 18207,
  },
  {
    type: 'cityName',
    value: 'AHIMANPUR, GUJARAT',
    masterId: 16697,
  },
  {
    type: 'cityName',
    value: 'AHIRAN, WEST BENGAL',
    masterId: 10052,
  },
  {
    type: 'cityName',
    value: 'ADARSH NAGAR, RAJASTHAN',
    masterId: 17404,
  },
  {
    type: 'cityName',
    value: 'AHERA, UTTAR PRADESH',
    masterId: 16698,
  },
  {
    type: 'cityName',
    value: 'AHIRAULI, UTTAR PRADESH',
    masterId: 16696,
  },
  {
    type: 'cityName',
    value: 'ADHINPUR, UTTAR PRADESH',
    masterId: 19167,
  },
  {
    type: 'cityName',
    value: 'GANDHIDHAM, GUJARAT',
    masterId: 11620,
  },
  {
    type: 'cityName',
    value: 'AJARAKA, RAJASTHAN',
    masterId: 10069,
  },
  {
    type: 'cityName',
    value: 'ALGAWAN, UTTAR PRADESH',
    masterId: 10103,
  },
  {
    type: 'cityName',
    value: 'MOTI PUR BRIDGE, UTTAR PRADESH',
    masterId: 18692,
  },
  {
    type: 'cityName',
    value: 'AJMER, RAJASTHAN',
    masterId: 10073,
  },
  {
    type: 'cityName',
    value: 'MAILAM, UTTAR PRADESH',
    masterId: 16946,
  },
  {
    type: 'cityName',
    value: 'ATHIPATTU, TAMIL NADU',
    masterId: 17050,
  },
  {
    type: 'cityName',
    value: 'ATTIPATTU PUDU NAGAR.H, TAMIL NADU',
    masterId: 20986,
  },
  {
    type: 'cityName',
    value: 'VASO-ALINDRA, GUJARAT',
    masterId: 18521,
  },
  {
    type: 'cityName',
    value: 'AIT, UTTAR PRADESH',
    masterId: 10063,
  },
  {
    type: 'cityName',
    value: 'AJGAIN, UTTAR PRADESH',
    masterId: 16695,
  },
  {
    type: 'cityName',
    value: 'ANJAR, GUJARAT',
    masterId: 10209,
  },
  {
    type: 'cityName',
    value: 'AJHAI, UTTAR PRADESH',
    masterId: 16694,
  },
  {
    type: 'cityName',
    value: 'SHAHABAD, UTTAR PRADESH',
    masterId: 15040,
  },
  {
    type: 'cityName',
    value: 'AJIT, RAJASTHAN',
    masterId: 17712,
  },
  {
    type: 'cityName',
    value: 'ARAKKONAM, TAMIL NADU',
    masterId: 10231,
  },
  {
    type: 'cityName',
    value: 'AJJAKOLLU, TELANGANA',
    masterId: 16834,
  },
  {
    type: 'cityName',
    value: 'AJITWAL, PUNJAB',
    masterId: 17426,
  },
  {
    type: 'cityName',
    value: 'AJNOD, MADHYA PRADESH',
    masterId: 20885,
  },
  {
    type: 'cityName',
    value: 'NAGPUR, MAHARASHTRA',
    masterId: 13813,
  },
  {
    type: 'cityName',
    value: 'AJJAMPUR, KARNATAKA',
    masterId: 10072,
  },
  {
    type: 'cityName',
    value: 'AJAIBPUR, UTTAR PRADESH',
    masterId: 21006,
  },
  {
    type: 'cityName',
    value: 'JAGIROAD, ASSAM',
    masterId: 12121,
  },
  {
    type: 'cityName',
    value: 'AJIT GILL MATTA, PUNJAB',
    masterId: 17403,
  },
  {
    type: 'cityName',
    value: 'ARJUNI, MAHARASHTRA',
    masterId: 10247,
  },
  {
    type: 'cityName',
    value: 'ABJUGANJ, BIHAR',
    masterId: 18802,
  },
  {
    type: 'cityName',
    value: 'AKOLA, MAHARASHTRA',
    masterId: 10081,
  },
  {
    type: 'cityName',
    value: 'AKKAMPET, ANDHRA PRADESH',
    masterId: 20728,
  },
  {
    type: 'cityName',
    value: 'AKODIA, MADHYA PRADESH',
    masterId: 10080,
  },
  {
    type: 'cityName',
    value: 'AKANAPET, ANDHRA PRADESH',
    masterId: 10075,
  },
  {
    type: 'cityName',
    value: 'ADARKI, MAHARASHTRA',
    masterId: 17714,
  },
  {
    type: 'cityName',
    value: 'AKAIPUR HALT, WEST BENGAL',
    masterId: 21198,
  },
  {
    type: 'cityName',
    value: 'KHAIRABAD, UTTAR PRADESH',
    masterId: 12679,
  },
  {
    type: 'cityName',
    value: 'AKKIHEBBALU, KARNATAKA',
    masterId: 18079,
  },
  {
    type: 'cityName',
    value: 'ARAMBAKKAM, TAMIL NADU',
    masterId: 17002,
  },
  {
    type: 'cityName',
    value: 'AKBARNAGAR, BIHAR',
    masterId: 10076,
  },
  {
    type: 'cityName',
    value: 'ADHYATMIK NAGAR, UTTAR PRADESH',
    masterId: 16700,
  },
  {
    type: 'cityName',
    value: 'KADABGAON, MAHARASHTRA',
    masterId: 12312,
  },
  {
    type: 'cityName',
    value: 'AKOT, MAHARASHTRA',
    masterId: 10083,
  },
  {
    type: 'cityName',
    value: 'ANAKAPALLE, ANDHRA PRADESH',
    masterId: 10181,
  },
  {
    type: 'cityName',
    value: 'AKOLNER, MAHARASHTRA',
    masterId: 10082,
  },
  {
    type: 'cityName',
    value: 'AKRA, WEST BENGAL',
    masterId: 21186,
  },
  {
    type: 'cityName',
    value: 'PIMPRI-CHINCHWAD, MAHARASHTRA',
    masterId: 14403,
  },
  {
    type: 'cityName',
    value: 'ANKUSPUR, UTTAR PRADESH ',
    masterId: 16690,
  },
  {
    type: 'cityName',
    value: 'AKALTARA, CHHATTISGARH',
    masterId: 10074,
  },
  {
    type: 'cityName',
    value: 'ANGALAKUDURU, ANDHRA PRADESH',
    masterId: 10202,
  },
  {
    type: 'cityName',
    value: 'ANKLESHWAR, GUJARAT',
    masterId: 10212,
  },
  {
    type: 'cityName',
    value: 'AKIVIDU, ANDHRA PRADESH',
    masterId: 10078,
  },
  {
    type: 'cityName',
    value: 'AKORA, UTTAR PRADESH',
    masterId: 17240,
  },
  {
    type: 'cityName',
    value: 'AKASHI, JHARKHAND',
    masterId: 18206,
  },
  {
    type: 'cityName',
    value: 'ATTILI, ANDHRA PRADESH',
    masterId: 10299,
  },
  {
    type: 'cityName',
    value: 'ALAI, UTTARAKHAND',
    masterId: 10086,
  },
  {
    type: 'cityName',
    value: 'ALAL, PUNJAB ',
    masterId: 17402,
  },
  {
    type: 'cityName',
    value: 'ALIA BADA, GUJARAT',
    masterId: 10104,
  },
  {
    type: 'cityName',
    value: 'AMLETHA, GUJARAT',
    masterId: 18516,
  },
  {
    type: 'cityName',
    value: 'ALER, ANDHRA PRADESH',
    masterId: 10102,
  },
  {
    type: 'cityName',
    value: 'ALGAPUR, ASSAM',
    masterId: 18977,
  },
  {
    type: 'cityName',
    value: 'ALIGARH, UTTAR PRADESH',
    masterId: 10105,
  },
  {
    type: 'cityName',
    value: 'ALAKKUDI, TAMIL NADU',
    masterId: 17051,
  },
  {
    type: 'cityName',
    value: 'ALAPPUZHA, KERALA',
    masterId: 10096,
  },
  {
    type: 'cityName',
    value: 'LOTLAPALLE, ANDHRA PRADESH',
    masterId: 13169,
  },
  {
    type: 'cityName',
    value: 'ALAMPUR, GUJARAT',
    masterId: 10087,
  },
  {
    type: 'cityName',
    value: 'ALMAW, UTTAR PRADESH ',
    masterId: 16692,
  },
  {
    type: 'cityName',
    value: 'ALANDI, MAHARASHTRA',
    masterId: 17711,
  },
  {
    type: 'cityName',
    value: 'AALNIYA, RAJASTHAN',
    masterId: 17243,
  },
  {
    type: 'cityName',
    value: 'AKELAHANSPUR, UTTAR PRADESH',
    masterId: 16693,
  },
  {
    type: 'cityName',
    value: 'ALAPAKKAM, TAMIL NADU',
    masterId: 17007,
  },
  {
    type: 'cityName',
    value: 'ALAMPUR ROAD, ANDHRA PRADESH',
    masterId: 10088,
  },
  {
    type: 'cityName',
    value: 'AMLORI SARSAR, BIHAR',
    masterId: 18846,
  },
  {
    type: 'cityName',
    value: 'ARIYALUR, TAMIL NADU',
    masterId: 10245,
  },
  {
    type: 'cityName',
    value: 'ANKLAV, GUJARAT',
    masterId: 18563,
  },
  {
    type: 'cityName',
    value: 'ALWAL, ANDHRA PRADESH',
    masterId: 10119,
  },
  {
    type: 'cityName',
    value: 'ALLAHABAD, UTTAR PRADESH',
    masterId: 10109,
  },
  {
    type: 'cityName',
    value: 'ATAMANDA, UTTAR PRADESH',
    masterId: 16681,
  },
  {
    type: 'cityName',
    value: 'MUNIGUDA, ORISSA',
    masterId: 13729,
  },
  {
    type: 'cityName',
    value: 'ARAMBAG, WEST BENGAL',
    masterId: 21223,
  },
  {
    type: 'cityName',
    value: 'ROHINA, MAHARASHTRA',
    masterId: 14749,
  },
  {
    type: 'cityName',
    value: 'AMRUTHAPURA, KARNATAKA',
    masterId: 10180,
  },
  {
    type: 'cityName',
    value: 'AMILA, UTTAR PRADESH',
    masterId: 21052,
  },
  {
    type: 'cityName',
    value: 'AMADI, MAHARASHTRA',
    masterId: 17709,
  },
  {
    type: 'cityName',
    value: 'AMETHI, UTTAR PRADESH',
    masterId: 10156,
  },
  {
    type: 'cityName',
    value: 'AMJONGA, ASSAM',
    masterId: 18953,
  },
  {
    type: 'cityName',
    value: 'AZAMGARH, UTTAR PRADESH',
    masterId: 10323,
  },
  {
    type: 'cityName',
    value: 'AMRAVATI, MAHARASHTRA',
    masterId: 10174,
  },
  {
    type: 'cityName',
    value: 'AMIN, HARYANA',
    masterId: 18354,
  },
  {
    type: 'cityName',
    value: 'AMALSAD, GUJARAT',
    masterId: 10125,
  },
  {
    type: 'cityName',
    value: 'AMLA, MADHYA PRADESH',
    masterId: 10162,
  },
  {
    type: 'cityName',
    value: 'AMLI, RAJASTHAN',
    masterId: 10165,
  },
  {
    type: 'cityName',
    value: 'AMLO-KARGALI, JHARKHAND',
    masterId: 18205,
  },
  {
    type: 'cityName',
    value: 'AMALPUR, GUJARAT',
    masterId: 19100,
  },
  {
    type: 'cityName',
    value: 'AHMADPUR, WEST BENGAL',
    masterId: 10053,
  },
  {
    type: 'cityName',
    value: 'AMMAPALI, BIHAR',
    masterId: 18799,
  },
  {
    type: 'cityName',
    value: 'AMMUGUDA, ANDHRA PRADESH',
    masterId: 10169,
  },
  {
    type: 'cityName',
    value: 'AMROHA, UTTAR PRADESH',
    masterId: 10178,
  },
  {
    type: 'cityName',
    value: 'AMMASANDRA, KARNATAKA',
    masterId: 10167,
  },
  {
    type: 'cityName',
    value: 'AMMAPET, TAMIL NADU',
    masterId: 17005,
  },
  {
    type: 'cityName',
    value: 'AMARAVILA, KERALA',
    masterId: 17934,
  },
  {
    type: 'cityName',
    value: 'AMANWADI, MAHARASHTRA',
    masterId: 17748,
  },
  {
    type: 'cityName',
    value: 'AMLAKHURD, MADHYA PRADESH',
    masterId: 10164,
  },
  {
    type: 'cityName',
    value: 'VETTOOR-CHERUNNIYOOR, KERALA',
    masterId: 15862,
  },
  {
    type: 'cityName',
    value: 'AMTA, WEST BENGAL',
    masterId: 21237,
  },
  {
    type: 'cityName',
    value: 'AMALNER, MAHARASHTRA',
    masterId: 10124,
  },
  {
    type: 'cityName',
    value: 'ASLANA, MADHYA PRADESH',
    masterId: 10275,
  },
  {
    type: 'cityName',
    value: 'HIMALA, MADHYA PRADESH',
    masterId: 11984,
  },
  {
    type: 'cityName',
    value: 'AMMANABROLU, ANDHRA PRADESH',
    masterId: 10166,
  },
  {
    type: 'cityName',
    value: 'ANNECHAKANAHALLI, KARNATAKA',
    masterId: 18076,
  },
  {
    type: 'cityName',
    value: 'ANCHURI, WEST BENGAL',
    masterId: 16207,
  },
  {
    type: 'cityName',
    value: 'ANANTARAJUPET, ANDHRA PRADESH',
    masterId: 10188,
  },
  {
    type: 'cityName',
    value: 'ANANDAPUR, KARNATAKA',
    masterId: 10184,
  },
  {
    type: 'cityName',
    value: 'ANGUL, ORISSA',
    masterId: 10206,
  },
  {
    type: 'cityName',
    value: 'ANGADGERI, KARNATAKA',
    masterId: 18077,
  },
  {
    type: 'cityName',
    value: 'ANKORAH AKORHA, BIHAR',
    masterId: 10215,
  },
  {
    type: 'cityName',
    value: 'AJANTI, MADHYA PRADESH',
    masterId: 10067,
  },
  {
    type: 'cityName',
    value: 'SAVKHEDE, MAHARASHTRA',
    masterId: 14993,
  },
  {
    type: 'cityName',
    value: 'ANKOLA, KARNATAKA',
    masterId: 10213,
  },
  {
    type: 'cityName',
    value: 'ARANG, CHHATTISGARH',
    masterId: 10236,
  },
  {
    type: 'cityName',
    value: 'ANAND, GUJARAT',
    masterId: 10183,
  },
  {
    type: 'cityName',
    value: 'ANNANUR, TAMIL NADU',
    masterId: 20973,
  },
  {
    type: 'cityName',
    value: 'MULGAON, MAHARASHTRA',
    masterId: 13706,
  },
  {
    type: 'cityName',
    value: 'AANATHANDAVAPURAM, TAMIL NADU',
    masterId: 17009,
  },
  {
    type: 'cityName',
    value: 'AURI, UTTAR PRADESH',
    masterId: 10311,
  },
  {
    type: 'cityName',
    value: 'AMNAPUR, MAHARASHTRA',
    masterId: 17553,
  },
  {
    type: 'cityName',
    value: 'CHAPARI, WEST BENGAL',
    masterId: 11008,
  },
  {
    type: 'cityName',
    value: 'ANANDPUR SAHIB, PUNJAB',
    masterId: 10186,
  },
  {
    type: 'cityName',
    value: 'ANANTNAG, JAMMU AND KASHMIR',
    masterId: 20828,
  },
  {
    type: 'cityName',
    value: 'ANTU, UTTAR PRADESH',
    masterId: 10223,
  },
  {
    type: 'cityName',
    value: 'ANANGUR, TAMIL NADU',
    masterId: 17004,
  },
  {
    type: 'cityName',
    value: 'ANNAVARAM, ANDHRA PRADESH',
    masterId: 10217,
  },
  {
    type: 'cityName',
    value: 'ARUMUGANERI, TAMIL NADU',
    masterId: 10257,
  },
  {
    type: 'cityName',
    value: 'RAHTUIYA, UTTAR PRADESH',
    masterId: 14551,
  },
  {
    type: 'cityName',
    value: 'ARAON, UTTAR PRADESH',
    masterId: 16687,
  },
  {
    type: 'cityName',
    value: 'AMONI, ASSAM',
    masterId: 10170,
  },
  {
    type: 'cityName',
    value: 'ARGARA, JHARKHAND',
    masterId: 16183,
  },
  {
    type: 'cityName',
    value: 'MYSORE, KARNATAKA',
    masterId: 13774,
  },
  {
    type: 'cityName',
    value: 'MYSURU, KARNATAKA',
    masterId: 13774,
  },
  {
    type: 'cityName',
    value: 'AMARPURA, RAJASTHAN',
    masterId: 10132,
  },
  {
    type: 'cityName',
    value: 'ANUPPAMBATTU, TAMIL NADU',
    masterId: 20988,
  },
  {
    type: 'cityName',
    value: 'SOBHAGANJ, WEST BENGAL',
    masterId: 15245,
  },
  {
    type: 'cityName',
    value: 'ALIPUR DUAR, WEST BENGAL',
    masterId: 16188,
  },
  {
    type: 'cityName',
    value: 'ANDANAPPETTAI, TAMIL NADU',
    masterId: 17003,
  },
  {
    type: 'cityName',
    value: 'ANUPGANJ, UTTAR PRADESH',
    masterId: 16184,
  },
  {
    type: 'cityName',
    value: 'ANUPGARH, RAJASTHAN',
    masterId: 17238,
  },
  {
    type: 'cityName',
    value: 'KUTHATHUPATTI, TAMIL NADU',
    masterId: 13060,
  },
  {
    type: 'cityName',
    value: 'AMARPUR JORASI, RAJASTHAN',
    masterId: 18355,
  },
  {
    type: 'cityName',
    value: 'ARUPPUKKOTTAI, TAMIL NADU',
    masterId: 10259,
  },
  {
    type: 'cityName',
    value: 'APPIKATLA, ANDHRA PRADESH',
    masterId: 10228,
  },
  {
    type: 'cityName',
    value: 'AYODHIYAPATINAM, TAMIL NADU',
    masterId: 10320,
  },
  {
    type: 'cityName',
    value: 'ANUPPUR, MADHYA PRADESH',
    masterId: 10225,
  },
  {
    type: 'cityName',
    value: 'APURVA PH, WEST BENGAL',
    masterId: 21089,
  },
  {
    type: 'cityName',
    value: 'ANAPARTHY, ANDHRA PRADESH',
    masterId: 10190,
  },
  {
    type: 'cityName',
    value: 'APTA, MAHARASHTRA',
    masterId: 10229,
  },
  {
    type: 'cityName',
    value: 'ASHAPURA GOMAT, RAJASTHAN',
    masterId: 10267,
  },
  {
    type: 'cityName',
    value: 'ARRAH, BIHAR',
    masterId: 10254,
  },
  {
    type: 'cityName',
    value: 'ARAG, MAHARASHTRA',
    masterId: 17708,
  },
  {
    type: 'cityName',
    value: 'ARUNACHAL, ASSAM',
    masterId: 10258,
  },
  {
    type: 'cityName',
    value: 'AMARDA ROAD, ORISSA',
    masterId: 10127,
  },
  {
    type: 'cityName',
    value: 'SHREEPURA, RAJASTHAN',
    masterId: 15124,
  },
  {
    type: 'cityName',
    value: 'ANGAAR GHAT, BIHAR',
    masterId: 18845,
  },
  {
    type: 'cityName',
    value: 'ARIGADA, JHARKHAND',
    masterId: 16013,
  },
  {
    type: 'cityName',
    value: 'ARGUL, ORISSA',
    masterId: 16824,
  },
  {
    type: 'cityName',
    value: 'ARALAGUPPE, KARNATAKA',
    masterId: 18075,
  },
  {
    type: 'cityName',
    value: 'AMHERA, UTTAR PRADESH',
    masterId: 16691,
  },
  {
    type: 'cityName',
    value: 'ANTRI, MADHYA PRADESH',
    masterId: 17873,
  },
  {
    type: 'cityName',
    value: 'AUNRIHAR, UTTAR PRADESH',
    masterId: 10306,
  },
  {
    type: 'cityName',
    value: 'ARAKU, ANDHRA PRADESH',
    masterId: 10232,
  },
  {
    type: 'cityName',
    value: 'ARKHA, UTTAR PRADESH',
    masterId: 17872,
  },
  {
    type: 'cityName',
    value: 'ARAUL-BARANDA, UTTAR PRADESH',
    masterId: 16686,
  },
  {
    type: 'cityName',
    value: 'ARAND, CHHATTISGARH',
    masterId: 10235,
  },
  {
    type: 'cityName',
    value: 'CHANDANWAS, RAJASTHAN',
    masterId: 10977,
  },
  {
    type: 'cityName',
    value: 'ARUNNAGAR, MAHARASHTRA',
    masterId: 17747,
  },
  {
    type: 'cityName',
    value: 'ARJUNAHALLI, KARNATAKA',
    masterId: 18108,
  },
  {
    type: 'cityName',
    value: 'AROOR, KERALA',
    masterId: 10253,
  },
  {
    type: 'cityName',
    value: 'ATRAMPUR, UTTAR PRADESH',
    masterId: 16680,
  },
  {
    type: 'cityName',
    value: 'AREPALLI HALT, ANDHRA PRADESH',
    masterId: 10244,
  },
  {
    type: 'cityName',
    value: 'ITAHARA, BIHAR',
    masterId: 12091,
  },
  {
    type: 'cityName',
    value: 'ARARIYA, BIHAR',
    masterId: 19082,
  },
  {
    type: 'cityName',
    value: 'ARASALU, KARNATAKA',
    masterId: 18074,
  },
  {
    type: 'cityName',
    value: 'ARNI ROAD, TAMIL NADU',
    masterId: 10252,
  },
  {
    type: 'cityName',
    value: 'NARAYANPUR, UTTAR PRADESH',
    masterId: 13891,
  },
  {
    type: 'cityName',
    value: 'ARELI, UTTAR PRADESH',
    masterId: 16685,
  },
  {
    type: 'cityName',
    value: 'ARJANSAR, RAJASTHAN',
    masterId: 10246,
  },
  {
    type: 'cityName',
    value: 'ASIFABAD ROAD, ANDHRA PRADESH',
    masterId: 10273,
  },
  {
    type: 'cityName',
    value: 'AASAN, HARYANA',
    masterId: 17242,
  },
  {
    type: 'cityName',
    value: 'ASARA, UTTAR PRADESH',
    masterId: 16683,
  },
  {
    type: 'cityName',
    value: 'ASANBONI, JHARKHAND',
    masterId: 16182,
  },
  {
    type: 'cityName',
    value: 'ATHSARAI, UTTAR PRADESH',
    masterId: 21024,
  },
  {
    type: 'cityName',
    value: 'AMBASAMUDRAM, TAMIL NADU',
    masterId: 10150,
  },
  {
    type: 'cityName',
    value: 'ASAUDHA, HARYANA',
    masterId: 18353,
  },
  {
    type: 'cityName',
    value: 'ARSENI, UTTAR PRADESH',
    masterId: 16684,
  },
  {
    type: 'cityName',
    value: 'AMARSAHID JAGDEO PD., BIHAR',
    masterId: 20744,
  },
  {
    type: 'cityName',
    value: 'ARSIKERE, KARNATAKA',
    masterId: 10255,
  },
  {
    type: 'cityName',
    value: 'ASHOK NAGAR, MADHYA PRADESH',
    masterId: 10268,
  },
  {
    type: 'cityName',
    value: 'ASHOK NAGAR RD, WEST BENGAL',
    masterId: 21244,
  },
  {
    type: 'cityName',
    value: 'ASLAODA, MADHYA PRADESH',
    masterId: 10276,
  },
  {
    type: 'cityName',
    value: 'ASLOO, RAJASTHAN',
    masterId: 17283,
  },
  {
    type: 'cityName',
    value: 'ASANSOL, WEST BENGAL',
    masterId: 10265,
  },
  {
    type: 'cityName',
    value: 'ASANGAON, MAHARASHTRA',
    masterId: 17707,
  },
  {
    type: 'cityName',
    value: 'ASPARI, ANDHRA PRADESH',
    masterId: 19046,
  },
  {
    type: 'cityName',
    value: 'AMRITSAR, PUNJAB',
    masterId: 10177,
  },
  {
    type: 'cityName',
    value: 'ASOATI, HARYANA',
    masterId: 10277,
  },
  {
    type: 'cityName',
    value: 'ASHTEGAON, MAHARASHTRA',
    masterId: 17706,
  },
  {
    type: 'cityName',
    value: 'MAJALI, KARNATAKA',
    masterId: 13285,
  },
  {
    type: 'cityName',
    value: 'ATA, UTTAR PRADESH',
    masterId: 16682,
  },
  {
    type: 'cityName',
    value: 'ATARRA, UTTAR PRADESH',
    masterId: 10285,
  },
  {
    type: 'cityName',
    value: 'ATGAON, MAHARASHTRA',
    masterId: 17704,
  },
  {
    type: 'cityName',
    value: 'ANTA, RAJASTHAN',
    masterId: 10222,
  },
  {
    type: 'cityName',
    value: 'ATWA KURSATH, UTTAR PRADESH',
    masterId: 16678,
  },
  {
    type: 'cityName',
    value: 'ATHMAL GOLA, BIHAR',
    masterId: 10290,
  },
  {
    type: 'cityName',
    value: 'ALTAGRAM, WEST BENGAL',
    masterId: 16187,
  },
  {
    type: 'cityName',
    value: 'AITHAL, UTTARAKHAND',
    masterId: 10064,
  },
  {
    type: 'cityName',
    value: 'DHARIPUR, BIHAR',
    masterId: 11367,
  },
  {
    type: 'cityName',
    value: 'ANANTAPUR, ANDHRA PRADESH',
    masterId: 10187,
  },
  {
    type: 'cityName',
    value: 'AWANTIPURA, JAMMU AND KASHMIR',
    masterId: 20831,
  },
  {
    type: 'cityName',
    value: 'CHICHGOHAN, MADHYA PRADESH',
    masterId: 11071,
  },
  {
    type: 'cityName',
    value: 'ANTARAURA, UTTAR PRADESH ',
    masterId: 16689,
  },
  {
    type: 'cityName',
    value: 'ATRU, RAJASTHAN',
    masterId: 10297,
  },
  {
    type: 'cityName',
    value: 'ATTABIRA, ORISSA',
    masterId: 10298,
  },
  {
    type: 'cityName',
    value: 'ATARI, PUNJAB',
    masterId: 10284,
  },
  {
    type: 'cityName',
    value: 'ATTUR, TAMIL NADU',
    masterId: 10301,
  },
  {
    type: 'cityName',
    value: 'ATUL, GUJARAT',
    masterId: 10302,
  },
  {
    type: 'cityName',
    value: 'ATWA MUTHIA, UTTAR PRADESH',
    masterId: 16677,
  },
  {
    type: 'cityName',
    value: 'ALUABARI ROAD, WEST BENGAL',
    masterId: 10116,
  },
  {
    type: 'cityName',
    value: 'ANUGRAHA N ROAD, BIHAR',
    masterId: 10224,
  },
  {
    type: 'cityName',
    value: 'AGSAULI, UTTAR PRADESH',
    masterId: 16699,
  },
  {
    type: 'cityName',
    value: 'AURANGNAGAR, HARYANA',
    masterId: 18350,
  },
  {
    type: 'cityName',
    value: 'AUNG, UTTAR PRADESH',
    masterId: 21031,
  },
  {
    type: 'cityName',
    value: 'ATRAULI, UTTAR PRADESH',
    masterId: 16679,
  },
  {
    type: 'cityName',
    value: 'ANUPSHAHAR, RAJASTHAN',
    masterId: 16688,
  },
  {
    type: 'cityName',
    value: 'AAUWA, RAJASTHAN',
    masterId: 17241,
  },
  {
    type: 'cityName',
    value: 'ASVALI, MAHARASHTRA',
    masterId: 17705,
  },
  {
    type: 'cityName',
    value: 'CHENNAI, TAMIL NADU',
    masterId: 11036,
  },
  {
    type: 'cityName',
    value: 'AVIDHA, GUJARAT',
    masterId: 18514,
  },
  {
    type: 'cityName',
    value: 'ARUVANKADU, TAMIL NADU',
    masterId: 10260,
  },
  {
    type: 'cityName',
    value: 'AMRUTVEL, GUJARAT',
    masterId: 18515,
  },
  {
    type: 'cityName',
    value: 'ARAVALLI, ANDHRA PRADESH',
    masterId: 20731,
  },
  {
    type: 'cityName',
    value: 'ANAVARDIKHANPET, TAMIL NADU',
    masterId: 10192,
  },
  {
    type: 'cityName',
    value: 'ABHANPUR, CHHATTISGARH',
    masterId: 18623,
  },
  {
    type: 'cityName',
    value: 'MURDAV, MAHARASHTRA',
    masterId: 13743,
  },
  {
    type: 'cityName',
    value: 'KUNNICODE, KERALA',
    masterId: 13029,
  },
  {
    type: 'cityName',
    value: 'AVALAHALLI, KARNATAKA',
    masterId: 18072,
  },
  {
    type: 'cityName',
    value: 'AURANGABAD, MAHARASHTRA',
    masterId: 10310,
  },
  {
    type: 'cityName',
    value: 'AWAGARH, UTTAR PRADESH',
    masterId: 16676,
  },
  {
    type: 'cityName',
    value: 'ALEWAHI, MAHARASHTRA',
    masterId: 17749,
  },
  {
    type: 'cityName',
    value: 'ALAWALPUR, PUNJAB',
    masterId: 17401,
  },
  {
    type: 'cityName',
    value: 'ASWAPURAM, TELANGANA',
    masterId: 10281,
  },
  {
    type: 'cityName',
    value: 'AGWANPUR, UTTAR PRADESH',
    masterId: 18848,
  },
  {
    type: 'cityName',
    value: 'AWAPUR, BIHAR',
    masterId: 20776,
  },
  {
    type: 'cityName',
    value: 'ALWAR, RAJASTHAN',
    masterId: 10120,
  },
  {
    type: 'cityName',
    value: 'AWASANI, BIHAR',
    masterId: 18797,
  },
  {
    type: 'cityName',
    value: 'ALWAR TIRUNAGRI, TAMIL NADU',
    masterId: 17006,
  },
  {
    type: 'cityName',
    value: 'ALUVA, KERALA',
    masterId: 10118,
  },
  {
    type: 'cityName',
    value: 'AMARSAR, GUJARAT',
    masterId: 10134,
  },
  {
    type: 'cityName',
    value: 'ASOKHAR, MADHYA PRADESH',
    masterId: 10278,
  },
  {
    type: 'cityName',
    value: 'ALLURU, ANDHRA PRADESH',
    masterId: 10113,
  },
  {
    type: 'cityName',
    value: 'AYANDUR, TAMIL NADU',
    masterId: 17001,
  },
  {
    type: 'cityName',
    value: 'AYYALUR, TAMIL NADU',
    masterId: 19045,
  },
  {
    type: 'cityName',
    value: 'AKSHAYWAT R NGR, BIHAR',
    masterId: 10084,
  },
  {
    type: 'cityName',
    value: 'ABHAYAPURI ASAM, ASSAM',
    masterId: 19081,
  },
  {
    type: 'cityName',
    value: 'AZARA, ASSAM',
    masterId: 18952,
  },
  {
    type: 'cityName',
    value: 'AZHWARKURICHI, TAMIL NADU',
    masterId: 19151,
  },
  {
    type: 'cityName',
    value: 'AYYAMPET, TAMIL NADU',
    masterId: 17000,
  },
  {
    type: 'cityName',
    value: 'BARHAT, BIHAR',
    masterId: 10533,
  },
  {
    type: 'cityName',
    value: 'BANDRA, MAHARASHTRA',
    masterId: 20895,
  },
  {
    type: 'cityName',
    value: 'BARALA, WEST BENGAL',
    masterId: 17231,
  },
  {
    type: 'cityName',
    value: 'BANDAR PH, WEST BENGAL',
    masterId: 21232,
  },
  {
    type: 'cityName',
    value: 'BABINA, UTTAR PRADESH',
    masterId: 10328,
  },
  {
    type: 'cityName',
    value: 'BARGACHIA, WEST BENGAL',
    masterId: 20782,
  },
  {
    type: 'cityName',
    value: 'BAAD, UTTAR PRADESH',
    masterId: 19168,
  },
  {
    type: 'cityName',
    value: 'BARKA, UTTAR PRADESH',
    masterId: 16647,
  },
  {
    type: 'cityName',
    value: 'BHADER GAV, GUJARAT',
    masterId: 18511,
  },
  {
    type: 'cityName',
    value: 'BALIAKHERI, UTTAR PRADESH',
    masterId: 16661,
  },
  {
    type: 'cityName',
    value: 'BHAGEGA, RAJASTHAN',
    masterId: 17220,
  },
  {
    type: 'cityName',
    value: 'BAGWADA, GUJARAT',
    masterId: 17897,
  },
  {
    type: 'cityName',
    value: 'BARHARAGANJ, UTTAR PRADESH',
    masterId: 16648,
  },
  {
    type: 'cityName',
    value: 'NARAWN, BIHAR',
    masterId: 13888,
  },
  {
    type: 'cityName',
    value: 'BHABHAR, GUJARAT',
    masterId: 10653,
  },
  {
    type: 'cityName',
    value: 'BALENAHALLI, KARNATAKA',
    masterId: 10427,
  },
  {
    type: 'cityName',
    value: 'BANIHAL, JAMMU AND KASHMIR',
    masterId: 20824,
  },
  {
    type: 'cityName',
    value: 'BABHANGAON, WEST BENGAL',
    masterId: 18796,
  },
  {
    type: 'cityName',
    value: 'BANDH, UTTAR PRADESH',
    masterId: 16657,
  },
  {
    type: 'cityName',
    value: 'BAHIR KHANDA, WEST BENGAL',
    masterId: 21221,
  },
  {
    type: 'cityName',
    value: 'BASSI, RAJASTHAN',
    masterId: 10576,
  },
  {
    type: 'cityName',
    value: 'BHALEJ, GUJARAT',
    masterId: 18510,
  },
  {
    type: 'cityName',
    value: 'BAJAKARE, KARNATAKA',
    masterId: 18069,
  },
  {
    type: 'cityName',
    value: 'BHAN KARI, RAJASTHAN',
    masterId: 10692,
  },
  {
    type: 'cityName',
    value: 'MEHARPUR, BIHAR',
    masterId: 13557,
  },
  {
    type: 'cityName',
    value: 'BAKAL, CHHATTISGARH',
    masterId: 17869,
  },
  {
    type: 'cityName',
    value: 'PUTALUR, TAMIL NADU',
    masterId: 14523,
  },
  {
    type: 'cityName',
    value: 'BALE, MAHARASHTRA',
    masterId: 10425,
  },
  {
    type: 'cityName',
    value: 'BAITALPUR, UTTAR PRADESH',
    masterId: 18622,
  },
  {
    type: 'cityName',
    value: 'BALUGAON, ORISSA',
    masterId: 10443,
  },
  {
    type: 'cityName',
    value: 'BRAHMAPUR, ORISSA',
    masterId: 10906,
  },
  {
    type: 'cityName',
    value: 'BIRAMBAD, RAJASTHAN',
    masterId: 10842,
  },
  {
    type: 'cityName',
    value: 'BAMUR, ORISSA',
    masterId: 10455,
  },
  {
    type: 'cityName',
    value: 'JODHPUR, RAJASTHAN',
    masterId: 12273,
  },
  {
    type: 'cityName',
    value: 'AIDHI, UTTAR PRADESH',
    masterId: 10060,
  },
  {
    type: 'cityName',
    value: 'SOE, JHARKHAND',
    masterId: 15247,
  },
  {
    type: 'cityName',
    value: 'BAMOR, MADHYA PRADESH',
    masterId: 10453,
  },
  {
    type: 'cityName',
    value: 'BAOLI, UTTAR PRADESH',
    masterId: 16651,
  },
  {
    type: 'cityName',
    value: 'BELAPUR, MAHARASHTRA',
    masterId: 10617,
  },
  {
    type: 'cityName',
    value: 'BAIRPUR, BIHAR',
    masterId: 16708,
  },
  {
    type: 'cityName',
    value: 'BALLUPUR, UTTAR PRADESH',
    masterId: 18844,
  },
  {
    type: 'cityName',
    value: 'GANJ BASODA, MADHYA PRADESH',
    masterId: 11642,
  },
  {
    type: 'cityName',
    value: 'BAR, RAJASTHAN',
    masterId: 10498,
  },
  {
    type: 'cityName',
    value: 'BILARA, RAJASTHAN',
    masterId: 10822,
  },
  {
    type: 'cityName',
    value: 'DUVRI KALAN, MADHYA PRADESH',
    masterId: 17900,
  },
  {
    type: 'cityName',
    value: 'BARH, BIHAR',
    masterId: 10528,
  },
  {
    type: 'cityName',
    value: 'BARI, RAJASTHAN',
    masterId: 17230,
  },
  {
    type: 'cityName',
    value: 'BHARATGARH, PUNJAB',
    masterId: 20931,
  },
  {
    type: 'cityName',
    value: 'BARAL, UTTAR PRADESH',
    masterId: 10506,
  },
  {
    type: 'cityName',
    value: 'BARANAGAR ROAD, PUNJAB',
    masterId: 20956,
  },
  {
    type: 'cityName',
    value: 'BAHARU, WEST BENGAL',
    masterId: 20780,
  },
  {
    type: 'cityName',
    value: 'BHAINSWAL, HARYANA',
    masterId: 18340,
  },
  {
    type: 'cityName',
    value: 'BATESAR, UTTAR PRADESH',
    masterId: 21043,
  },
  {
    type: 'cityName',
    value: 'BATALA, PUNJAB',
    masterId: 10582,
  },
  {
    type: 'cityName',
    value: 'BAIHATOLA, MADHYA PRADESH',
    masterId: 10394,
  },
  {
    type: 'cityName',
    value: 'BURHANPUR, MADHYA PRADESH',
    masterId: 10927,
  },
  {
    type: 'cityName',
    value: 'BARUVA, ANDHRA PRADESH',
    masterId: 19043,
  },
  {
    type: 'cityName',
    value: 'BALWARA, RAJASTHAN',
    masterId: 20962,
  },
  {
    type: 'cityName',
    value: 'BHADWAD, MAHARASHTRA',
    masterId: 20899,
  },
  {
    type: 'cityName',
    value: 'BELLARY, KARNATAKA',
    masterId: 10626,
  },
  {
    type: 'cityName',
    value: 'BEYAD, GUJARAT',
    masterId: 19095,
  },
  {
    type: 'cityName',
    value: 'BARAN, RAJASTHAN',
    masterId: 10508,
  },
  {
    type: 'cityName',
    value: 'BABRALA, UTTAR PRADESH',
    masterId: 10331,
  },
  {
    type: 'cityName',
    value: 'BAIDYABATI, WEST BENGAL',
    masterId: 21075,
  },
  {
    type: 'cityName',
    value: 'ANANDPUR, GUJARAT',
    masterId: 10185,
  },
  {
    type: 'cityName',
    value: 'WADA, MADHYA PRADESH',
    masterId: 17562,
  },
  {
    type: 'cityName',
    value: 'BHACHBHAR, RAJASTHAN',
    masterId: 17221,
  },
  {
    type: 'cityName',
    value: 'BULBULCHANDI, WEST BENGAL',
    masterId: 16166,
  },
  {
    type: 'cityName',
    value: 'BABLAD, KARNATAKA',
    masterId: 18071,
  },
  {
    type: 'cityName',
    value: 'BARBENDA, WEST BENGAL',
    masterId: 16233,
  },
  {
    type: 'cityName',
    value: 'BENOYBADALDINESHBAG, WEST BENGAL',
    masterId: 21133,
  },
  {
    type: 'cityName',
    value: 'BABARPUR, HARYANA',
    masterId: 18583,
  },
  {
    type: 'cityName',
    value: 'KURHALGURI, ASSAM',
    masterId: 13039,
  },
  {
    type: 'cityName',
    value: 'BARABAR, BIHAR',
    masterId: 18786,
  },
  {
    type: 'cityName',
    value: 'BARA BANI, WEST BENGAL',
    masterId: 21098,
  },
  {
    type: 'cityName',
    value: 'BABAGANJ, UTTAR PRADESH',
    masterId: 16675,
  },
  {
    type: 'cityName',
    value: 'BARABANKI, UTTAR PRADESH',
    masterId: 10499,
  },
  {
    type: 'cityName',
    value: 'BALRAI, UTTAR PRADESH',
    masterId: 21017,
  },
  {
    type: 'cityName',
    value: 'BHYABLA HALT, WEST BENGAL',
    masterId: 21164,
  },
  {
    type: 'cityName',
    value: 'SHIV DAS PURI MARG, UTTAR PRADESH',
    masterId: 18584,
  },
  {
    type: 'cityName',
    value: 'BALARAMPUR, WEST BENGAL',
    masterId: 10422,
  },
  {
    type: 'cityName',
    value: 'BARI BRAHMAN, JAMMU AND KASHMIR',
    masterId: 10537,
  },
  {
    type: 'cityName',
    value: 'BARBIL, ORISSA',
    masterId: 10516,
  },
  {
    type: 'cityName',
    value: 'BABUGARH, UTTAR PRADESH',
    masterId: 10332,
  },
  {
    type: 'cityName',
    value: 'BALABHADRAPURAM, ANDHRA PRADESH',
    masterId: 10413,
  },
  {
    type: 'cityName',
    value: 'BABUPUR, UTTAR PRADESH',
    masterId: 17898,
  },
  {
    type: 'cityName',
    value: 'BASIN BRIDGE JUNCTION, TAMIL NADU',
    masterId: 16999,
  },
  {
    type: 'cityName',
    value: 'BAG BAZAR, WEST BENGAL',
    masterId: 21135,
  },
  {
    type: 'cityName',
    value: 'BHUBANESWAR, ORISSA',
    masterId: 10779,
  },
  {
    type: 'cityName',
    value: 'BIRATI, MADHYA PRADESH',
    masterId: 20890,
  },
  {
    type: 'cityName',
    value: 'BARBATPUR, MADHYA PRADESH',
    masterId: 10515,
  },
  {
    type: 'cityName',
    value: 'BHABUA, BIHAR',
    masterId: 10655,
  },
  {
    type: 'cityName',
    value: 'BODARWAR, UTTAR PRADESH',
    masterId: 16614,
  },
  {
    type: 'cityName',
    value: 'GWALIOR, MADHYA PRADESH',
    masterId: 11878,
  },
  {
    type: 'cityName',
    value: 'BAREILLY, UTTAR PRADESH',
    masterId: 10520,
  },
  {
    type: 'cityName',
    value: 'BACHWARA, BIHAR',
    masterId: 10335,
  },
  {
    type: 'cityName',
    value: 'BHOWRA, JHARKHAND',
    masterId: 18197,
  },
  {
    type: 'cityName',
    value: 'BANSDIH, UTTAR PRADESH',
    masterId: 16652,
  },
  {
    type: 'cityName',
    value: 'BAINCHIGRAM, WEST BENGAL',
    masterId: 21074,
  },
  {
    type: 'cityName',
    value: 'BERCHHA, MADHYA PRADESH',
    masterId: 10638,
  },
  {
    type: 'cityName',
    value: 'BACHELI, CHHATTISGARH',
    masterId: 10333,
  },
  {
    type: 'cityName',
    value: 'BOCHASAN, GUJARAT',
    masterId: 18502,
  },
  {
    type: 'cityName',
    value: 'BAGAHA BISHUNPUR, BIHAR',
    masterId: 18795,
  },
  {
    type: 'cityName',
    value: 'BALICHAK, WEST BENGAL',
    masterId: 10429,
  },
  {
    type: 'cityName',
    value: 'MALHIPUR, UTTAR PRADESH',
    masterId: 13317,
  },
  {
    type: 'cityName',
    value: 'BICHPURI, UTTAR PRADESH',
    masterId: 16625,
  },
  {
    type: 'cityName',
    value: 'BACHARPUR, BIHAR',
    masterId: 20777,
  },
  {
    type: 'cityName',
    value: 'BARACHAK, WEST BENGAL',
    masterId: 10501,
  },
  {
    type: 'cityName',
    value: 'BARCHI ROAD, MADHYA PRADESH',
    masterId: 10518,
  },
  {
    type: 'cityName',
    value: 'MUMBAI, MAHARASHTRA',
    masterId: 13713,
  },
  {
    type: 'cityName',
    value: 'BHUCHCHU, PUNJAB',
    masterId: 10780,
  },
  {
    type: 'cityName',
    value: 'BHAWI, RAJASTHAN',
    masterId: 17215,
  },
  {
    type: 'cityName',
    value: 'BONIDANGA, JHARKHAND',
    masterId: 18193,
  },
  {
    type: 'cityName',
    value: 'VRINDAVAN, UTTAR PRADESH',
    masterId: 19211,
  },
  {
    type: 'cityName',
    value: 'BADA BANDHA, ORISSA',
    masterId: 17529,
  },
  {
    type: 'cityName',
    value: 'BADHAI BALAMGRH, PUNJAB',
    masterId: 17400,
  },
  {
    type: 'cityName',
    value: 'BASUDEBPUR, WEST BENGAL',
    masterId: 17542,
  },
  {
    type: 'cityName',
    value: 'BINDUBASINI, JHARKHAND',
    masterId: 18195,
  },
  {
    type: 'cityName',
    value: 'BANDEL, WEST BENGAL',
    masterId: 10471,
  },
  {
    type: 'cityName',
    value: 'BHADRACHALAM, TELANGANA',
    masterId: 10667,
  },
  {
    type: 'cityName',
    value: 'BADODAR, GUJARAT',
    masterId: 10354,
  },
  {
    type: 'cityName',
    value: 'BODELI, GUJARAT',
    masterId: 18501,
  },
  {
    type: 'cityName',
    value: 'BADGAM, JAMMU AND KASHMIR',
    masterId: 20835,
  },
  {
    type: 'cityName',
    value: 'BADANAGUPPE, KARNATAKA',
    masterId: 18107,
  },
  {
    type: 'cityName',
    value: 'BHEDIA, WEST BENGAL',
    masterId: 10733,
  },
  {
    type: 'cityName',
    value: 'BADHADA, GUJARAT',
    masterId: 18513,
  },
  {
    type: 'cityName',
    value: 'BADHAL, RAJASTHAN',
    masterId: 17282,
  },
  {
    type: 'cityName',
    value: 'BODHAN, TELANGANA',
    masterId: 10866,
  },
  {
    type: 'cityName',
    value: 'BHUDPUR, UTTAR PRADESH',
    masterId: 18337,
  },
  {
    type: 'cityName',
    value: 'BUDHI, JAMMU AND KASHMIR',
    masterId: 10916,
  },
  {
    type: 'cityName',
    value: 'BHADLI, MAHARASHTRA',
    masterId: 10664,
  },
  {
    type: 'cityName',
    value: 'BHADAIYAN, UTTAR PRADESH',
    masterId: 16774,
  },
  {
    type: 'cityName',
    value: 'VADAKARA, KERALA',
    masterId: 15725,
  },
  {
    type: 'cityName',
    value: 'BANDHUA KALAN, UTTAR PRADESH',
    masterId: 16656,
  },
  {
    type: 'cityName',
    value: 'BADHAKHANDIET, ORISSA',
    masterId: 17527,
  },
  {
    type: 'cityName',
    value: 'MIRZAPUR, UTTAR PRADESH',
    masterId: 13599,
  },
  {
    type: 'cityName',
    value: 'BORDOLONI, ASSAM',
    masterId: 18937,
  },
  {
    type: 'cityName',
    value: 'ADAGAL, KARNATAKA',
    masterId: 10020,
  },
  {
    type: 'cityName',
    value: 'BUDHMA, BIHAR',
    masterId: 18835,
  },
  {
    type: 'cityName',
    value: 'BAIDYANATHDHAM, JHARKHAND',
    masterId: 20841,
  },
  {
    type: 'cityName',
    value: 'BHODWAL MAJRI, HARYANA',
    masterId: 18339,
  },
  {
    type: 'cityName',
    value: 'GALPURA, UTTAR PRADESH',
    masterId: 11613,
  },
  {
    type: 'cityName',
    value: 'BIDANPUR, UTTAR PRADESH',
    masterId: 10800,
  },
  {
    type: 'cityName',
    value: 'BAHALDA ROAD, ODISHA',
    masterId: 20913,
  },
  {
    type: 'cityName',
    value: 'BADALPUR PH, WEST BENGAL',
    masterId: 21088,
  },
  {
    type: 'cityName',
    value: 'BADA PADAGAON, ORISSA',
    masterId: 17528,
  },
  {
    type: 'cityName',
    value: 'BUDHAPANK, ORISSA',
    masterId: 17512,
  },
  {
    type: 'cityName',
    value: 'BANDARUPALLE, ANDHRA PRADESH',
    masterId: 10470,
  },
  {
    type: 'cityName',
    value: 'BRINDABANPUR, WEST BENGAL',
    masterId: 21124,
  },
  {
    type: 'cityName',
    value: 'BHADRAULI, UTTAR PRADESH',
    masterId: 21042,
  },
  {
    type: 'cityName',
    value: 'BARADIGHI, WEST BENGAL',
    masterId: 21103,
  },
  {
    type: 'cityName',
    value: 'BUDH SINGH WALA, RAJASTHAN',
    masterId: 17203,
  },
  {
    type: 'cityName',
    value: 'BORDUBI, ASSAM',
    masterId: 18936,
  },
  {
    type: 'cityName',
    value: 'BADNAPUR, MAHARASHTRA',
    masterId: 10351,
  },
  {
    type: 'cityName',
    value: 'BASUDEOPUR CHANDEL, BIHAR',
    masterId: 18843,
  },
  {
    type: 'cityName',
    value: 'BADVEL, ANDHRA PRADESH',
    masterId: 10360,
  },
  {
    type: 'cityName',
    value: 'BHADRAVATI, KARNATAKA',
    masterId: 10670,
  },
  {
    type: 'cityName',
    value: 'BANDANWARA, RAJASTHAN',
    masterId: 10467,
  },
  {
    type: 'cityName',
    value: 'BADHWA BARA, MADHYA PRADESH',
    masterId: 10343,
  },
  {
    type: 'cityName',
    value: 'BODWAD, MAHARASHTRA',
    masterId: 10870,
  },
  {
    type: 'cityName',
    value: 'BIRDHOL, RAJASTHAN',
    masterId: 10845,
  },
  {
    type: 'cityName',
    value: 'BADARWAS, MADHYA PRADESH',
    masterId: 10340,
  },
  {
    type: 'cityName',
    value: 'BASAI, HARYANA',
    masterId: 18344,
  },
  {
    type: 'cityName',
    value: 'BADE ARAPUR, CHHATTISGARH',
    masterId: 10341,
  },
  {
    type: 'cityName',
    value: 'BUDDIREDDIPPATI, TAMIL NADU',
    masterId: 10914,
  },
  {
    type: 'cityName',
    value: 'BINDAYAKA, RAJASTHAN',
    masterId: 17205,
  },
  {
    type: 'cityName',
    value: 'BIDYADHARPUR, WEST BENGAL',
    masterId: 21171,
  },
  {
    type: 'cityName',
    value: 'BADKULLA, WEST BENGAL',
    masterId: 10346,
  },
  {
    type: 'cityName',
    value: 'BIHIYA, BIHAR',
    masterId: 10807,
  },
  {
    type: 'cityName',
    value: 'BEAS, PUNJAB',
    masterId: 10603,
  },
  {
    type: 'cityName',
    value: 'BELDANGA, WEST BENGAL',
    masterId: 10621,
  },
  {
    type: 'cityName',
    value: 'BASERI, RAJASTHAN',
    masterId: 17227,
  },
  {
    type: 'cityName',
    value: 'BEDHAM, RAJASTHAN',
    masterId: 17225,
  },
  {
    type: 'cityName',
    value: 'BEBEJIA, ASSAM',
    masterId: 18943,
  },
  {
    type: 'cityName',
    value: 'BHUPDEOPUR, CHHATTISGARH',
    masterId: 10786,
  },
  {
    type: 'cityName',
    value: 'BEHTAGOKUL, UTTAR PRADESH',
    masterId: 10611,
  },
  {
    type: 'cityName',
    value: 'BAGHDIHI, ORISSA',
    masterId: 10373,
  },
  {
    type: 'cityName',
    value: 'BAJAJ HALL, RAJASTHAN',
    masterId: 17703,
  },
  {
    type: 'cityName',
    value: 'BEOHARI, MADHYA PRADESH',
    masterId: 10637,
  },
  {
    type: 'cityName',
    value: 'BIHAR SHARIF, BIHAR',
    masterId: 10806,
  },
  {
    type: 'cityName',
    value: 'BIHAT, BIHAR',
    masterId: 18779,
  },
  {
    type: 'cityName',
    value: 'BENIGANJ, UTTAR PRADESH',
    masterId: 16638,
  },
  {
    type: 'cityName',
    value: 'BUNDKI, UTTAR PRADESH',
    masterId: 16612,
  },
  {
    type: 'cityName',
    value: 'BELA, BIHAR',
    masterId: 10614,
  },
  {
    type: 'cityName',
    value: 'BELKERA, MADHYA PRADESH',
    masterId: 18103,
  },
  {
    type: 'cityName',
    value: 'BUDAUN, UTTAR PRADESH',
    masterId: 10913,
  },
  {
    type: 'cityName',
    value: 'BEML NAGAR, KARNATAKA',
    masterId: 18102,
  },
  {
    type: 'cityName',
    value: 'BEML, KARNATAKA',
    masterId: 18063,
  },
  {
    type: 'cityName',
    value: 'BIROHI, UTTAR PRADESH',
    masterId: 16620,
  },
  {
    type: 'cityName',
    value: 'BHEERPUR, UTTAR PRADESH',
    masterId: 19174,
  },
  {
    type: 'cityName',
    value: 'BELUR, WEST BENGAL',
    masterId: 21078,
  },
  {
    type: 'cityName',
    value: 'BEAWAR, RAJASTHAN',
    masterId: 10604,
  },
  {
    type: 'cityName',
    value: 'BERO, WEST BENGAL',
    masterId: 18198,
  },
  {
    type: 'cityName',
    value: 'BARETH, MADHYA PRADESH',
    masterId: 10523,
  },
  {
    type: 'cityName',
    value: 'BHETASI, GUJARAT',
    masterId: 18560,
  },
  {
    type: 'cityName',
    value: 'BETAWAD, MAHARASHTRA',
    masterId: 10645,
  },
  {
    type: 'cityName',
    value: 'BELBONI, WEST BENGAL',
    masterId: 21126,
  },
  {
    type: 'cityName',
    value: 'BUGGANIPALLI, ANDHRA PRADESH',
    masterId: 10920,
  },
  {
    type: 'cityName',
    value: 'BORHAT, ASSAM',
    masterId: 10891,
  },
  {
    type: 'cityName',
    value: 'BAHAWAL BASI, PUNJAB',
    masterId: 17399,
  },
  {
    type: 'cityName',
    value: 'BARABHATI, MAHARASHTRA',
    masterId: 17700,
  },
  {
    type: 'cityName',
    value: 'BAGTHAR, RAJASTHAN',
    masterId: 17281,
  },
  {
    type: 'cityName',
    value: 'BHORAS BUDRUKH, MAHARASHTRA',
    masterId: 16014,
  },
  {
    type: 'cityName',
    value: 'DIYODAR, BIHAR',
    masterId: 11445,
  },
  {
    type: 'cityName',
    value: 'BILLOCHPURA, UTTAR PRADESH',
    masterId: 16623,
  },
  {
    type: 'cityName',
    value: 'BHOPATPUR, UTTAR PRADESH',
    masterId: 16628,
  },
  {
    type: 'cityName',
    value: 'BHENDI, JHARKHAND',
    masterId: 17692,
  },
  {
    type: 'cityName',
    value: 'PALLIKERE, KERALA',
    masterId: 14166,
  },
  {
    type: 'cityName',
    value: 'BHABTA, WEST BENGAL',
    masterId: 10654,
  },
  {
    type: 'cityName',
    value: 'BAHELIA BUZURG, UTTAR PRADESH',
    masterId: 16669,
  },
  {
    type: 'cityName',
    value: 'BYATRAYANHALLI, KARNATAKA ',
    masterId: 18058,
  },
  {
    type: 'cityName',
    value: 'BHESANA, RAJASTHAN',
    masterId: 10736,
  },
  {
    type: 'cityName',
    value: 'BHANDARTIKURI, WEST BENGAL',
    masterId: 16173,
  },
  {
    type: 'cityName',
    value: 'BHONGIR, ANDHRA PRADESH',
    masterId: 10770,
  },
  {
    type: 'cityName',
    value: 'BAGALIA, WEST BENGAL',
    masterId: 10363,
  },
  {
    type: 'cityName',
    value: 'BALAGARH, WEST BENGAL',
    masterId: 10415,
  },
  {
    type: 'cityName',
    value: 'BANGARI, BIHAR',
    masterId: 17544,
  },
  {
    type: 'cityName',
    value: 'BUDGE BUDGE, CHHATTISGARH',
    masterId: 20792,
  },
  {
    type: 'cityName',
    value: 'BAGBAHARA, CHHATTISGARH',
    masterId: 10367,
  },
  {
    type: 'cityName',
    value: 'BARA GUDHA, HARYANA',
    masterId: 18346,
  },
  {
    type: 'cityName',
    value: 'BAGADIA, ORISSA',
    masterId: 17546,
  },
  {
    type: 'cityName',
    value: 'BHAGWANPUR DESUA, BIHAR',
    masterId: 18840,
  },
  {
    type: 'cityName',
    value: 'BAGILA, WEST BENGAL',
    masterId: 21072,
  },
  {
    type: 'cityName',
    value: 'BANTA RAGHUNATHGARH, RAJASTHAN',
    masterId: 17233,
  },
  {
    type: 'cityName',
    value: 'BAGHAULI, UTTAR PRADESH',
    masterId: 10372,
  },
  {
    type: 'cityName',
    value: 'BAGAHAI ROAD, MADHYA PRADESH',
    masterId: 10362,
  },
  {
    type: 'cityName',
    value: 'BORRA, ANDHRA PRADESH',
    masterId: 10897,
  },
  {
    type: 'cityName',
    value: 'BAGHA JATIN, WEST BENGAL',
    masterId: 21173,
  },
  {
    type: 'cityName',
    value: 'BAGALKOT, KARNATAKA',
    masterId: 10364,
  },
  {
    type: 'cityName',
    value: 'BANGURKELA, ORISSA',
    masterId: 17543,
  },
  {
    type: 'cityName',
    value: 'BAGULA, ASSAM',
    masterId: 20738,
  },
  {
    type: 'cityName',
    value: 'BARGOLAI, ASSAM',
    masterId: 16175,
  },
  {
    type: 'cityName',
    value: 'BELAGAVI, KARNATAKA',
    masterId: 10616,
  },
  {
    type: 'cityName',
    value: 'BAGUMARA, GUJARAT',
    masterId: 10382,
  },
  {
    type: 'cityName',
    value: 'BANGARMAU, UTTAR PRADESH',
    masterId: 16655,
  },
  {
    type: 'cityName',
    value: 'BORGAON, MAHARASHTRA',
    masterId: 17686,
  },
  {
    type: 'cityName',
    value: 'BOGINADI, ASSAM',
    masterId: 18939,
  },
  {
    type: 'cityName',
    value: 'BOGRI TO EKERIA, WEST BENGAL',
    masterId: 16168,
  },
  {
    type: 'cityName',
    value: 'BHAGALPUR, BIHAR',
    masterId: 10675,
  },
  {
    type: 'cityName',
    value: 'BAGESHPURA, KARNATAKA',
    masterId: 18070,
  },
  {
    type: 'cityName',
    value: 'BAGHUAPAL, ORISSA',
    masterId: 10374,
  },
  {
    type: 'cityName',
    value: 'BHAGWANPURA, RAJASTHAN',
    masterId: 17867,
  },
  {
    type: 'cityName',
    value: 'BHONGAON, UTTAR PRADESH',
    masterId: 10769,
  },
  {
    type: 'cityName',
    value: 'KRISHNADEBPUR, WEST BENGAL',
    masterId: 12952,
  },
  {
    type: 'cityName',
    value: 'BELIAGHATA ROAD, WEST BENGAL',
    masterId: 21156,
  },
  {
    type: 'cityName',
    value: 'BIGGABAS RAMSARA, RAJASTHAN',
    masterId: 17277,
  },
  {
    type: 'cityName',
    value: 'BAGARPUR, UTTAR PRADESH',
    masterId: 16671,
  },
  {
    type: 'cityName',
    value: 'BEGUSARAI, BIHAR',
    masterId: 10609,
  },
  {
    type: 'cityName',
    value: 'BISUGIRSHARIF, ANDHRA PRADESH',
    masterId: 10856,
  },
  {
    type: 'cityName',
    value: 'MOHGAON, MADHYA PRADESH',
    masterId: 13621,
  },
  {
    type: 'cityName',
    value: 'BHAGTANWALA, PUNJAB',
    masterId: 20950,
  },
  {
    type: 'cityName',
    value: 'BAIRGANIA, BIHAR',
    masterId: 10402,
  },
  {
    type: 'cityName',
    value: 'BAIGUDA, ORISSA',
    masterId: 16015,
  },
  {
    type: 'cityName',
    value: 'BHIGWAN, MAHARASHTRA',
    masterId: 10737,
  },
  {
    type: 'cityName',
    value: 'BAGEWADI, KARNATAKA',
    masterId: 18106,
  },
  {
    type: 'cityName',
    value: 'BEGDEWADI, MAHARASHTRA',
    masterId: 17697,
  },
  {
    type: 'cityName',
    value: 'BAGRI SAJJANPUR, RAJASTHAN',
    masterId: 10380,
  },
  {
    type: 'cityName',
    value: 'BANGRIPOSI, ODISHA',
    masterId: 20909,
  },
  {
    type: 'cityName',
    value: 'BAHADURGARH, HARYANA',
    masterId: 10385,
  },
  {
    type: 'cityName',
    value: 'BHARUCH, GUJARAT',
    masterId: 10708,
  },
  {
    type: 'cityName',
    value: 'BANDAI, UTTAR PRADESH',
    masterId: 17236,
  },
  {
    type: 'cityName',
    value: 'BHATIEL, GUJARAT',
    masterId: 20801,
  },
  {
    type: 'cityName',
    value: 'BHOYANI, GUJARAT',
    masterId: 17690,
  },
  {
    type: 'cityName',
    value: 'BHOJRAS, RAJASTHAN',
    masterId: 17210,
  },
  {
    type: 'cityName',
    value: 'JALALA, MADHYA PRADESH',
    masterId: 16511,
  },
  {
    type: 'cityName',
    value: 'BLOCK HUT A, UTTAR PRADESH',
    masterId: 16616,
  },
  {
    type: 'cityName',
    value: 'BADLAGHAT, BIHAR',
    masterId: 10347,
  },
  {
    type: 'cityName',
    value: 'BODHADI BUJRUG, MAHARASHTRA',
    masterId: 10865,
  },
  {
    type: 'cityName',
    value: 'BATHUA BAZAR, UTTAR PRADESH',
    masterId: 18841,
  },
  {
    type: 'cityName',
    value: 'BLOCK HUT B, UTTAR PRADESH',
    masterId: 16615,
  },
  {
    type: 'cityName',
    value: 'BHADRAK, ORISSA',
    masterId: 10669,
  },
  {
    type: 'cityName',
    value: 'BAHORA CHANDEL, UTTAR PRADESH',
    masterId: 16667,
  },
  {
    type: 'cityName',
    value: 'BAHADURPUR, UTTAR PRADESH',
    masterId: 19175,
  },
  {
    type: 'cityName',
    value: 'BHADRI, UTTAR PRADESH',
    masterId: 16637,
  },
  {
    type: 'cityName',
    value: 'SURAT, GUJARAT',
    masterId: 15353,
  },
  {
    type: 'cityName',
    value: 'BHATON KI GALI, RAJASTHAN',
    masterId: 17216,
  },
  {
    type: 'cityName',
    value: 'BHAIRGACHHI, WEST BENGAL',
    masterId: 21145,
  },
  {
    type: 'cityName',
    value: 'BHILGAON, ASSAM',
    masterId: 17746,
  },
  {
    type: 'cityName',
    value: 'BHAGIRATHPUR, UTTAR PRADESH',
    masterId: 16773,
  },
  {
    type: 'cityName',
    value: 'BEHTA HAZIPUR, UTTAR PRADESH',
    masterId: 16639,
  },
  {
    type: 'cityName',
    value: 'BAHERI, UTTAR PRADESH',
    masterId: 10388,
  },
  {
    type: 'cityName',
    value: 'BARHAJ BAZAR, UTTAR PRADESH',
    masterId: 16649,
  },
  {
    type: 'cityName',
    value: 'BHEJA, ORISSA',
    masterId: 10734,
  },
  {
    type: 'cityName',
    value: 'BADHARI KALAN, UTTAR PRADESH',
    masterId: 16672,
  },
  {
    type: 'cityName',
    value: 'BAHIRA KALIBARI (HAL, WEST BENGAL',
    masterId: 21154,
  },
  {
    type: 'cityName',
    value: 'BHURKUNDA, JHARKHAND',
    masterId: 10788,
  },
  {
    type: 'cityName',
    value: 'BAGHOI POND, BIHAR',
    masterId: 18793,
  },
  {
    type: 'cityName',
    value: 'BHAKRAULI, UTTAR PRADESH',
    masterId: 16635,
  },
  {
    type: 'cityName',
    value: 'BHILWARA, RAJASTHAN',
    masterId: 10744,
  },
  {
    type: 'cityName',
    value: 'BEHULA, WEST BENGAL',
    masterId: 10612,
  },
  {
    type: 'cityName',
    value: 'BARAHAT, BIHAR',
    masterId: 10503,
  },
  {
    type: 'cityName',
    value: 'BHALKI, KARNATAKA',
    masterId: 10687,
  },
  {
    type: 'cityName',
    value: 'BAHRAM, PUNJAB',
    masterId: 17398,
  },
  {
    type: 'cityName',
    value: 'BAGHMARA, BIHAR ',
    masterId: 18794,
  },
  {
    type: 'cityName',
    value: 'BHANDARIDAH, JHARKHAND',
    masterId: 16017,
  },
  {
    type: 'cityName',
    value: 'BHULI, JHARKHAND',
    masterId: 18196,
  },
  {
    type: 'cityName',
    value: 'BHAYNA, WEST BENGAL',
    masterId: 21144,
  },
  {
    type: 'cityName',
    value: 'BHONE, MAHARASHTRA',
    masterId: 10768,
  },
  {
    type: 'cityName',
    value: 'BHALUKPONG, ARUNACHAL PRADESH',
    masterId: 19073,
  },
  {
    type: 'cityName',
    value: 'BISHANPUR, BIHAR',
    masterId: 18774,
  },
  {
    type: 'cityName',
    value: 'BHANSI, CHHATTISGARH',
    masterId: 10699,
  },
  {
    type: 'cityName',
    value: 'BOLPUR, WEST BENGAL',
    masterId: 10880,
  },
  {
    type: 'cityName',
    value: 'BAHRUPIYA HALT, WEST BENGAL',
    masterId: 21206,
  },
  {
    type: 'cityName',
    value: 'BHADRESHWAR, PUNJAB',
    masterId: 20926,
  },
  {
    type: 'cityName',
    value: 'BAIRABI, MIZORAM ',
    masterId: 17550,
  },
  {
    type: 'cityName',
    value: 'BHUYAR, MAHARASHTRA',
    masterId: 17689,
  },
  {
    type: 'cityName',
    value: 'BECHARAJI, GUJARAT',
    masterId: 18512,
  },
  {
    type: 'cityName',
    value: 'BHAROLI, PUNJAB',
    masterId: 10706,
  },
  {
    type: 'cityName',
    value: 'VIDISHA, MADHYA PRADESH',
    masterId: 15864,
  },
  {
    type: 'cityName',
    value: 'BHISHA, BIHAR',
    masterId: 20775,
  },
  {
    type: 'cityName',
    value: 'BHATTU, HARYANA',
    masterId: 10723,
  },
  {
    type: 'cityName',
    value: 'BHATIYA, GUJARAT',
    masterId: 10717,
  },
  {
    type: 'cityName',
    value: 'BHANWARTONK, CHHATTISGARH',
    masterId: 10701,
  },
  {
    type: 'cityName',
    value: 'BHATEL, GUJARAT',
    masterId: 10713,
  },
  {
    type: 'cityName',
    value: 'SHAHPURA, MADHYA PRADESH',
    masterId: 15050,
  },
  {
    type: 'cityName',
    value: 'BHATPAR RANI, UTTAR PRADESH',
    masterId: 10721,
  },
  {
    type: 'cityName',
    value: 'BHATASA, UTTAR PRADESH',
    masterId: 16631,
  },
  {
    type: 'cityName',
    value: 'BHANDU MOTIDAU, GUJARAT ',
    masterId: 18509,
  },
  {
    type: 'cityName',
    value: 'BHUA, UTTAR PRADESH',
    masterId: 16627,
  },
  {
    type: 'cityName',
    value: 'BHUJ, GUJARAT',
    masterId: 10782,
  },
  {
    type: 'cityName',
    value: 'BARHARWA, JHARKHAND',
    masterId: 10532,
  },
  {
    type: 'cityName',
    value: 'BECHHIWARA, RAJASTHAN',
    masterId: 19141,
  },
  {
    type: 'cityName',
    value: 'BALLUANA, PUNJAB',
    masterId: 17396,
  },
  {
    type: 'cityName',
    value: 'BHAYAVADAR, GUJARAT',
    masterId: 18506,
  },
  {
    type: 'cityName',
    value: 'CHANDRANATHPUR, ASSAM',
    masterId: 10992,
  },
  {
    type: 'cityName',
    value: 'BARI SADRI, RAJASTHAN',
    masterId: 17229,
  },
  {
    type: 'cityName',
    value: 'BHILAI, CHHATTISGARH',
    masterId: 10741,
  },
  {
    type: 'cityName',
    value: 'BIRPUR, RAJASTHAN',
    masterId: 18837,
  },
  {
    type: 'cityName',
    value: 'BICHIA, UTTAR PRADESH',
    masterId: 10797,
  },
  {
    type: 'cityName',
    value: 'BARKICHANPI, JHARKHAND',
    masterId: 18199,
  },
  {
    type: 'cityName',
    value: 'BIDADI, KARNATAKA',
    masterId: 10799,
  },
  {
    type: 'cityName',
    value: 'BIDAR, KARNATAKA',
    masterId: 10801,
  },
  {
    type: 'cityName',
    value: 'BHAIROPUR, MADHYA PRADESH',
    masterId: 17866,
  },
  {
    type: 'cityName',
    value: 'BELGAHANA, CHHATTISGARH',
    masterId: 10622,
  },
  {
    type: 'cityName',
    value: 'BIGGA, RAJASTHAN',
    masterId: 17206,
  },
  {
    type: 'cityName',
    value: 'BHOPAL, MADHYA PRADESH',
    masterId: 10772,
  },
  {
    type: 'cityName',
    value: 'BORIDRA, GUJARAT',
    masterId: 18500,
  },
  {
    type: 'cityName',
    value: 'BIRNAGAR, WEST BENGAL',
    masterId: 10846,
  },
  {
    type: 'cityName',
    value: 'BIJOOR, KARNATAKA',
    masterId: 10813,
  },
  {
    type: 'cityName',
    value: 'BHIRA, UTTAR PRADESH',
    masterId: 10756,
  },
  {
    type: 'cityName',
    value: 'BHAINSLANA, RAJASTHAN',
    masterId: 17218,
  },
  {
    type: 'cityName',
    value: 'BILADI, MADHYA PRADESH',
    masterId: 10821,
  },
  {
    type: 'cityName',
    value: 'BILKHA, GUJARAT',
    masterId: 10833,
  },
  {
    type: 'cityName',
    value: 'BHILPUR, GUJARAT',
    masterId: 19101,
  },
  {
    type: 'cityName',
    value: 'BILIMORA, GUJARAT',
    masterId: 10831,
  },
  {
    type: 'cityName',
    value: 'BHIMTAL, RAJASTHAN',
    masterId: 16248,
  },
  {
    type: 'cityName',
    value: 'BINA, MADHYA PRADESH',
    masterId: 10838,
  },
  {
    type: 'cityName',
    value: 'BRIJ NAGAR, RAJASTHAN',
    masterId: 17204,
  },
  {
    type: 'cityName',
    value: 'BORDI, GUJARAT',
    masterId: 10890,
  },
  {
    type: 'cityName',
    value: 'BAHILPURWA, RAJASTHAN',
    masterId: 17870,
  },
  {
    type: 'cityName',
    value: 'BHEEMPURA, RAJASTHAN',
    masterId: 20966,
  },
  {
    type: 'cityName',
    value: 'BANSI PAHARPUR, RAJASTHAN',
    masterId: 10487,
  },
  {
    type: 'cityName',
    value: 'BIR, MADHYA PRADESH',
    masterId: 17698,
  },
  {
    type: 'cityName',
    value: 'BIRA, UTTAR PRADESH',
    masterId: 21056,
  },
  {
    type: 'cityName',
    value: 'BHIWANDI, MAHARASHTRA',
    masterId: 10758,
  },
  {
    type: 'cityName',
    value: 'BIRAUL, BIHAR',
    masterId: 18775,
  },
  {
    type: 'cityName',
    value: 'BIRRAJPUR, JHARKHAND',
    masterId: 18194,
  },
  {
    type: 'cityName',
    value: 'BHISWA, MAHARASHTRA',
    masterId: 18780,
  },
  {
    type: 'cityName',
    value: 'BISHENGARH, RAJASTHAN',
    masterId: 20963,
  },
  {
    type: 'cityName',
    value: 'BISALWAS KALAN, RAJASTHAN',
    masterId: 10849,
  },
  {
    type: 'cityName',
    value: 'BHIND, MADHYA PRADESH',
    masterId: 10752,
  },
  {
    type: 'cityName',
    value: 'BARDOLI, GUJARAT',
    masterId: 10519,
  },
  {
    type: 'cityName',
    value: 'BAIHATA, ASSAM',
    masterId: 18951,
  },
  {
    type: 'cityName',
    value: 'BAHJOI, UTTAR PRADESH',
    masterId: 10389,
  },
  {
    type: 'cityName',
    value: 'BIJROTHA, UTTAR PRADESH',
    masterId: 16772,
  },
  {
    type: 'cityName',
    value: 'BIJBIARA, JAMMU AND KASHMIR',
    masterId: 20829,
  },
  {
    type: 'cityName',
    value: 'BAREJADI, GUJARAT',
    masterId: 10521,
  },
  {
    type: 'cityName',
    value: 'BHOJUDIH, JHARKHAND',
    masterId: 10765,
  },
  {
    type: 'cityName',
    value: 'BIJNI, ASSAM',
    masterId: 10811,
  },
  {
    type: 'cityName',
    value: 'BAJRANGARH, MADHYA PRADESH',
    masterId: 10405,
  },
  {
    type: 'cityName',
    value: 'BIJAULI, UTTAR PRADESH',
    masterId: 16624,
  },
  {
    type: 'cityName',
    value: 'BIJULI, BIHAR',
    masterId: 18778,
  },
  {
    type: 'cityName',
    value: 'BIJORA, RAJASTHAN',
    masterId: 10814,
  },
  {
    type: 'cityName',
    value: 'BAJEKAN, HARYANA',
    masterId: 18349,
  },
  {
    type: 'cityName',
    value: 'BRAHMAJAN, ASSAM',
    masterId: 18976,
  },
  {
    type: 'cityName',
    value: 'BARAJAMDA, JHARKHAND',
    masterId: 10504,
  },
  {
    type: 'cityName',
    value: 'WEST BENGAL, RAJASTHAN',
    masterId: 16190,
  },
  {
    type: 'cityName',
    value: 'BIJAINAGAR, RAJASTHAN',
    masterId: 10810,
  },
  {
    type: 'cityName',
    value: 'DHAMPUR, UTTAR PRADESH',
    masterId: 11340,
  },
  {
    type: 'cityName',
    value: 'VIJAYAPURA, KARNATAKA',
    masterId: 15872,
  },
  {
    type: 'cityName',
    value: 'ROAD BIJAIPUR BHOREY, MADHYA PRADESH',
    masterId: 18655,
  },
  {
    type: 'cityName',
    value: 'GHATIYARI, MADHYA PRADESH',
    masterId: 11696,
  },
  {
    type: 'cityName',
    value: 'BARRAJPUR, UTTAR PRADESH',
    masterId: 10558,
  },
  {
    type: 'cityName',
    value: 'BHAJERA, RAJASTHAN',
    masterId: 17279,
  },
  {
    type: 'cityName',
    value: 'BIJURI, MADHYA PRADESH',
    masterId: 10815,
  },
  {
    type: 'cityName',
    value: 'BAJPATTI, BIHAR',
    masterId: 20758,
  },
  {
    type: 'cityName',
    value: 'BARO, BIHAR',
    masterId: 10550,
  },
  {
    type: 'cityName',
    value: 'BAJUD, GUJARAT',
    masterId: 10406,
  },
  {
    type: 'cityName',
    value: 'BHOJAWAS, HARYANA',
    masterId: 18338,
  },
  {
    type: 'cityName',
    value: 'BANGALBAREE, WEST BENGAL',
    masterId: 19186,
  },
  {
    type: 'cityName',
    value: 'BAKRA ROAD, RAJASTHAN',
    masterId: 10410,
  },
  {
    type: 'cityName',
    value: 'BARKHERA, MADHYA PRADESH',
    masterId: 10542,
  },
  {
    type: 'cityName',
    value: 'BARKAKHANA AVOIDING, JHARKHAND',
    masterId: 18200,
  },
  {
    type: 'cityName',
    value: 'BHIKAMKOR, RAJASTHAN',
    masterId: 17214,
  },
  {
    type: 'cityName',
    value: 'BHANKODA, GUJARAT',
    masterId: 18507,
  },
  {
    type: 'cityName',
    value: 'BUDHAKHERA, HARYANA',
    masterId: 17896,
  },
  {
    type: 'cityName',
    value: 'BEGUN KODAR, WEST BENGAL',
    masterId: 16174,
  },
  {
    type: 'cityName',
    value: 'KOTHIYA, BIHAR',
    masterId: 12921,
  },
  {
    type: 'cityName',
    value: 'BANKHEDI, MADHYA PRADESH',
    masterId: 10481,
  },
  {
    type: 'cityName',
    value: 'BAKHRI, BIHAR',
    masterId: 18790,
  },
  {
    type: 'cityName',
    value: 'BANDIKUI, RAJASTHAN',
    masterId: 10473,
  },
  {
    type: 'cityName',
    value: 'MOODAHADU, KARNATAKA',
    masterId: 13630,
  },
  {
    type: 'cityName',
    value: 'BHUKARKA, RAJASTHAN',
    masterId: 17208,
  },
  {
    type: 'cityName',
    value: 'BAKARKUDI, JHARKHAND',
    masterId: 18203,
  },
  {
    type: 'cityName',
    value: 'BAKKAS, UTTAR PRADESH',
    masterId: 16665,
  },
  {
    type: 'cityName',
    value: 'BONA KALU, ANDHRA PRADESH',
    masterId: 10884,
  },
  {
    type: 'cityName',
    value: 'BAKULHA, UTTAR PRADESH',
    masterId: 16662,
  },
  {
    type: 'cityName',
    value: 'BAKUDI, JHARKHAND',
    masterId: 18202,
  },
  {
    type: 'cityName',
    value: 'BIKANER, RAJASTHAN',
    masterId: 10817,
  },
  {
    type: 'cityName',
    value: 'BAKAINA, UTTAR PRADESH',
    masterId: 16666,
  },
  {
    type: 'cityName',
    value: 'RAJKOT, GUJARAT',
    masterId: 14587,
  },
  {
    type: 'cityName',
    value: 'BANKRA NAYABAJ, WEST BENGAL',
    masterId: 21234,
  },
  {
    type: 'cityName',
    value: 'BIKNA, WEST BENGAL',
    masterId: 21128,
  },
  {
    type: 'cityName',
    value: 'PAHUR, UTTAR PRADESH',
    masterId: 14128,
  },
  {
    type: 'cityName',
    value: 'BAKHTIYARPUR, BIHAR',
    masterId: 10409,
  },
  {
    type: 'cityName',
    value: 'BAKASPUR, JHARKHAND',
    masterId: 19103,
  },
  {
    type: 'cityName',
    value: 'BHAKARAPET, ANDHRA PRADESH',
    masterId: 10682,
  },
  {
    type: 'cityName',
    value: 'BHALUKA ROAD F, WEST BENGAL',
    masterId: 10688,
  },
  {
    type: 'cityName',
    value: 'BAKROL, GUJARAT',
    masterId: 18562,
  },
  {
    type: 'cityName',
    value: 'BALIKOTIA, ASSAM',
    masterId: 18950,
  },
  {
    type: 'cityName',
    value: 'BAKSHA, UTTAR PRADESH',
    masterId: 16663,
  },
  {
    type: 'cityName',
    value: 'BOKARO STEEL CITY, JHARKHAND',
    masterId: 10875,
  },
  {
    type: 'cityName',
    value: 'BIKRAM SHILA, BIHAR',
    masterId: 10819,
  },
  {
    type: 'cityName',
    value: 'BINDUKURI, ASSAM',
    masterId: 18940,
  },
  {
    type: 'cityName',
    value: 'BAIKUNTH, CHHATTISGARH',
    masterId: 10396,
  },
  {
    type: 'cityName',
    value: 'BAKTAL, MADHYA PRADESH',
    masterId: 10411,
  },
  {
    type: 'cityName',
    value: 'BAKOTHIKHAS, UTTAR PRADESH',
    masterId: 16664,
  },
  {
    type: 'cityName',
    value: 'BHIKNOOR, TELANGANA',
    masterId: 16821,
  },
  {
    type: 'cityName',
    value: 'BAKAYANWALA, RAJASTHAN',
    masterId: 17397,
  },
  {
    type: 'cityName',
    value: 'VALSAD, GUJARAT',
    masterId: 15762,
  },
  {
    type: 'cityName',
    value: 'BAJALTA, JAMMU AND KASHMIR',
    masterId: 19074,
  },
  {
    type: 'cityName',
    value: 'BARLAI, MADHYA PRADESH',
    masterId: 10544,
  },
  {
    type: 'cityName',
    value: 'BOLDA, MAHARASHTRA',
    masterId: 17864,
  },
  {
    type: 'cityName',
    value: 'BHILAD, GUJARAT',
    masterId: 10739,
  },
  {
    type: 'cityName',
    value: 'BELDA, WEST BENGAL',
    masterId: 10620,
  },
  {
    type: 'cityName',
    value: 'BHILDI, GUJARAT',
    masterId: 10742,
  },
  {
    type: 'cityName',
    value: 'BALAUDA TAKUN, MADHYA PRADESH',
    masterId: 20886,
  },
  {
    type: 'cityName',
    value: 'KANDIPUR, UTTAR PRADESH',
    masterId: 12476,
  },
  {
    type: 'cityName',
    value: 'BELAGULA, KARNATAKA',
    masterId: 18064,
  },
  {
    type: 'cityName',
    value: 'BALANGIR, ORISSA',
    masterId: 17524,
  },
  {
    type: 'cityName',
    value: 'BALURGHAT, WEST BENGAL',
    masterId: 10444,
  },
  {
    type: 'cityName',
    value: 'BHALOJALA HALT, PUNJAB',
    masterId: 20935,
  },
  {
    type: 'cityName',
    value: 'BELACOBA, WEST BENGAL',
    masterId: 10615,
  },
  {
    type: 'cityName',
    value: 'BALLEKERE, KARNATAKA',
    masterId: 18068,
  },
  {
    type: 'cityName',
    value: 'BANTANAHAL, ANDHRA PRADESH',
    masterId: 10492,
  },
  {
    type: 'cityName',
    value: 'BALAMU, UTTAR PRADESH',
    masterId: 10417,
  },
  {
    type: 'cityName',
    value: 'BHOLLDIH, JHARKHAND',
    masterId: 20842,
  },
  {
    type: 'cityName',
    value: 'BHALUMASKA, ORISSA',
    masterId: 10690,
  },
  {
    type: 'cityName',
    value: 'BHALUKMARI, ASSAM',
    masterId: 10689,
  },
  {
    type: 'cityName',
    value: 'BALLYGUNGE JN, PUNJAB',
    masterId: 20952,
  },
  {
    type: 'cityName',
    value: 'BOLINA DOABA, PUNJAB',
    masterId: 17387,
  },
  {
    type: 'cityName',
    value: 'BARLANGA, JHARKHAND',
    masterId: 18231,
  },
  {
    type: 'cityName',
    value: 'BHALAVNI, MAHARASHTRA',
    masterId: 10685,
  },
  {
    type: 'cityName',
    value: 'BELANKI, MAHARASHTRA',
    masterId: 17696,
  },
  {
    type: 'cityName',
    value: 'GHATTI, RAJASTHAN',
    masterId: 11702,
  },
  {
    type: 'cityName',
    value: 'BISHUNAPUR, UTTAR PRADESH',
    masterId: 10853,
  },
  {
    type: 'cityName',
    value: 'BALAPALLE, ANDHRA PRADESH',
    masterId: 19044,
  },
  {
    type: 'cityName',
    value: 'BADULIPAR, ASSAM',
    masterId: 10359,
  },
  {
    type: 'cityName',
    value: 'BILPUR, UTTAR PRADESH',
    masterId: 10835,
  },
  {
    type: 'cityName',
    value: 'BILASPUR, UTTAR PRADESH',
    masterId: 10824,
  },
  {
    type: 'cityName',
    value: 'BALAGANUR, KARNATAKA',
    masterId: 10414,
  },
  {
    type: 'cityName',
    value: 'BALA, GUJARAT',
    masterId: 10412,
  },
  {
    type: 'cityName',
    value: 'BELSIRI, ASSAM',
    masterId: 18941,
  },
  {
    type: 'cityName',
    value: 'BALASIRING, JHARKHAND',
    masterId: 18201,
  },
  {
    type: 'cityName',
    value: 'RUPSA, ORISSA',
    masterId: 14773,
  },
  {
    type: 'cityName',
    value: 'BOLSA, MAHARASHTRA',
    masterId: 10881,
  },
  {
    type: 'cityName',
    value: 'BALSAMAND, RAJASTHAN',
    masterId: 18348,
  },
  {
    type: 'cityName',
    value: 'BELSONDHA, CHHATTISGARH',
    masterId: 10629,
  },
  {
    type: 'cityName',
    value: 'BELASAR, RAJASTHAN',
    masterId: 17224,
  },
  {
    type: 'cityName',
    value: 'BALOTRA, RAJASTHAN',
    masterId: 10438,
  },
  {
    type: 'cityName',
    value: 'BELTHARA, UTTAR PRADESH',
    masterId: 10631,
  },
  {
    type: 'cityName',
    value: 'BILHAUR, UTTAR PRADESH',
    masterId: 10829,
  },
  {
    type: 'cityName',
    value: 'BALAWALI, UTTAR PRADESH',
    masterId: 10423,
  },
  {
    type: 'cityName',
    value: 'BOLWAD, MAHARASHTRA',
    masterId: 17687,
  },
  {
    type: 'cityName',
    value: 'BILESHWAR, GUJARAT',
    masterId: 10826,
  },
  {
    type: 'cityName',
    value: 'BOLAI, MADHYA PRADESH',
    masterId: 10877,
  },
  {
    type: 'cityName',
    value: 'BALLY GHAT, WEST BENGAL',
    masterId: 21191,
  },
  {
    type: 'cityName',
    value: 'BUDHLADA, PUNJAB',
    masterId: 10917,
  },
  {
    type: 'cityName',
    value: 'BAGHMAR, MADHYA PRADESH',
    masterId: 18204,
  },
  {
    type: 'cityName',
    value: 'BELMURI, WEST BENGAL',
    masterId: 21208,
  },
  {
    type: 'cityName',
    value: 'BAMRA, ORISSA',
    masterId: 10454,
  },
  {
    type: 'cityName',
    value: 'BIMBARI, MAHARASHTRA',
    masterId: 17688,
  },
  {
    type: 'cityName',
    value: 'BISSAMCUTTACK, ORISSA',
    masterId: 10855,
  },
  {
    type: 'cityName',
    value: 'BHIMADOLE, ANDHRA PRADESH',
    masterId: 10746,
  },
  {
    type: 'cityName',
    value: 'BARMER, RAJASTHAN',
    masterId: 10547,
  },
  {
    type: 'cityName',
    value: 'BASMAT, MAHARASHTRA',
    masterId: 10575,
  },
  {
    type: 'cityName',
    value: 'BAMANGACHHI, WEST BENGAL',
    masterId: 21152,
  },
  {
    type: 'cityName',
    value: 'BHIMGARA, WEST BENGAL',
    masterId: 16170,
  },
  {
    type: 'cityName',
    value: 'BRAHMANAGUDEM, ANDHRA PRADESH',
    masterId: 10904,
  },
  {
    type: 'cityName',
    value: 'BAMUNIGAON, ASSAM ',
    masterId: 18948,
  },
  {
    type: 'cityName',
    value: 'BAMANGRAM, WEST BENGAL',
    masterId: 16179,
  },
  {
    type: 'cityName',
    value: 'BETAMCHERLA, ANDHRA PRADESH',
    masterId: 10644,
  },
  {
    type: 'cityName',
    value: 'BAMANHERI, UTTAR PRADESH',
    masterId: 16778,
  },
  {
    type: 'cityName',
    value: 'BARAW MORE, BIHAR',
    masterId: 18784,
  },
  {
    type: 'cityName',
    value: 'BAMNIA, MADHYA PRADESH',
    masterId: 10451,
  },
  {
    type: 'cityName',
    value: 'BRIDGMANGANJ, UTTAR PRADESH',
    masterId: 16613,
  },
  {
    type: 'cityName',
    value: 'BIRANG KHERA, PUNJAB',
    masterId: 10843,
  },
  {
    type: 'cityName',
    value: 'BELLAMKONDA, ANDHRA PRADESH',
    masterId: 10624,
  },
  {
    type: 'cityName',
    value: 'MOTIHARI, BIHAR',
    masterId: 13666,
  },
  {
    type: 'cityName',
    value: 'BHIMKHOJ, CHHATTISGARH',
    masterId: 10749,
  },
  {
    type: 'cityName',
    value: 'BAMLA, HARYANA',
    masterId: 10450,
  },
  {
    type: 'cityName',
    value: 'BHIMANA, RAJASTHAN',
    masterId: 17213,
  },
  {
    type: 'cityName',
    value: 'BAMANI, MAHARASHTRA',
    masterId: 17702,
  },
  {
    type: 'cityName',
    value: 'BAMAN WALI, RAJASTHAN',
    masterId: 17237,
  },
  {
    type: 'cityName',
    value: 'BOLARUM, ANDHRA PRADESH',
    masterId: 10878,
  },
  {
    type: 'cityName',
    value: 'BRAHMAPURI, MAHARASHTRA',
    masterId: 17684,
  },
  {
    type: 'cityName',
    value: 'BRAHMANAPALLI, ANDHRA PRADESH',
    masterId: 10905,
  },
  {
    type: 'cityName',
    value: 'BADAMPAHAR, ODISHA',
    masterId: 20924,
  },
  {
    type: 'cityName',
    value: 'BHEEMARLAI, RAJASTHAN',
    masterId: 17278,
  },
  {
    type: 'cityName',
    value: 'VIKRAMPUR, MADHYA PRADESH',
    masterId: 15882,
  },
  {
    type: 'cityName',
    value: 'BHIMRANA, GUJARAT',
    masterId: 18558,
  },
  {
    type: 'cityName',
    value: 'BHIMASAR, GUJARAT',
    masterId: 18505,
  },
  {
    type: 'cityName',
    value: 'BAMSIN, RAJASTHAN',
    masterId: 20960,
  },
  {
    type: 'cityName',
    value: 'BAMHRAULI, UTTAR PRADESH',
    masterId: 10449,
  },
  {
    type: 'cityName',
    value: 'BHANER MINAWADA, GUJARAT',
    masterId: 18508,
  },
  {
    type: 'cityName',
    value: 'BAMHANI, MAHARASHTRA',
    masterId: 17701,
  },
  {
    type: 'cityName',
    value: 'BAMIANA, UTTAR PRADESH',
    masterId: 16659,
  },
  {
    type: 'cityName',
    value: 'MILAOLI, MADHYA PRADESH',
    masterId: 17806,
  },
  {
    type: 'cityName',
    value: 'BIBINAGAR, ANDHRA PRADESH',
    masterId: 10795,
  },
  {
    type: 'cityName',
    value: 'BANNI KOPPA, KARNATAKA',
    masterId: 18065,
  },
  {
    type: 'cityName',
    value: 'BIBHUTIBHUSHAN, WEST BENGAL',
    masterId: 21168,
  },
  {
    type: 'cityName',
    value: 'BINAUR, UTTAR PRADESH',
    masterId: 16771,
  },
  {
    type: 'cityName',
    value: 'BANSHTOLA, WEST BENGAL',
    masterId: 16229,
  },
  {
    type: 'cityName',
    value: 'BIMAN BUNDER, WEST BENGAL',
    masterId: 21137,
  },
  {
    type: 'cityName',
    value: 'BANI, ORISSA',
    masterId: 18788,
  },
  {
    type: 'cityName',
    value: 'BAHANAGA BAZAR, ORISSA',
    masterId: 17526,
  },
  {
    type: 'cityName',
    value: 'BANCHARI, HARYANA',
    masterId: 18347,
  },
  {
    type: 'cityName',
    value: 'BANDA, UTTAR PRADESH',
    masterId: 10465,
  },
  {
    type: 'cityName',
    value: 'BARUNDANI, RAJASTHAN',
    masterId: 17228,
  },
  {
    type: 'cityName',
    value: 'ROURKELA, ORISSA',
    masterId: 14758,
  },
  {
    type: 'cityName',
    value: 'BUNIADPUR, WEST BENGAL',
    masterId: 10925,
  },
  {
    type: 'cityName',
    value: 'BOHANI, MADHYA PRADESH',
    masterId: 10871,
  },
  {
    type: 'cityName',
    value: 'BANDHUA, BIHAR',
    masterId: 20746,
  },
  {
    type: 'cityName',
    value: 'BARNAGAR, MADHYA PRADESH',
    masterId: 10548,
  },
  {
    type: 'cityName',
    value: 'BHANGALA, PUNJAB',
    masterId: 17389,
  },
  {
    type: 'cityName',
    value: 'BANGUR GRAM, RAJASTHAN',
    masterId: 17235,
  },
  {
    type: 'cityName',
    value: 'ABHAYAPURI, ASSAM',
    masterId: 10012,
  },
  {
    type: 'cityName',
    value: 'BABHANJOT, UTTAR PRADESH',
    masterId: 16674,
  },
  {
    type: 'cityName',
    value: 'BHIMNATH, GUJARAT',
    masterId: 18559,
  },
  {
    type: 'cityName',
    value: 'BANBIHARI GWALIPUR, ORISSA',
    masterId: 17523,
  },
  {
    type: 'cityName',
    value: 'BUDHNI, MADHYA PRADESH',
    masterId: 10918,
  },
  {
    type: 'cityName',
    value: 'BANGAON JN, HARYANA',
    masterId: 20821,
  },
  {
    type: 'cityName',
    value: 'BINJHOL, HARYANA',
    masterId: 18336,
  },
  {
    type: 'cityName',
    value: 'BANKIM NAGAR, WEST BENGAL',
    masterId: 21147,
  },
  {
    type: 'cityName',
    value: 'BYRANAYAKANAHALLI, KARNATAKA',
    masterId: 18057,
  },
  {
    type: 'cityName',
    value: 'BANMANKHI, BIHAR',
    masterId: 18787,
  },
  {
    type: 'cityName',
    value: 'BANK OF INDIA BLDG, UTTAR PRADESH',
    masterId: 16654,
  },
  {
    type: 'cityName',
    value: 'BEVINAHALU, ANDHRA PRADESH',
    masterId: 10652,
  },
  {
    type: 'cityName',
    value: 'BANGI NIHAL SINGH, PUNJAB',
    masterId: 17394,
  },
  {
    type: 'cityName',
    value: 'GOVINDGARH, RAJASTHAN',
    masterId: 11794,
  },
  {
    type: 'cityName',
    value: 'BARAGAON, UTTAR PRADESH',
    masterId: 16776,
  },
  {
    type: 'cityName',
    value: 'BARNALA, PUNJAB',
    masterId: 10549,
  },
  {
    type: 'cityName',
    value: 'BHINDAR, RAJASTHAN',
    masterId: 17212,
  },
  {
    type: 'cityName',
    value: 'BANAR, RAJASTHAN',
    masterId: 10460,
  },
  {
    type: 'cityName',
    value: 'BENODA, MADHYA PRADESH',
    masterId: 17695,
  },
  {
    type: 'cityName',
    value: 'BHANAPUR, KARNATAKA',
    masterId: 10693,
  },
  {
    type: 'cityName',
    value: 'BENIPATTI PIRAPUR, BIHAR',
    masterId: 18783,
  },
  {
    type: 'cityName',
    value: 'BANARHAT, WEST BENGAL',
    masterId: 16177,
  },
  {
    type: 'cityName',
    value: 'BHANKALA, UTTAR PRADESH',
    masterId: 16633,
  },
  {
    type: 'cityName',
    value: 'BHAGWANPUR, BIHAR',
    masterId: 10677,
  },
  {
    type: 'cityName',
    value: 'BANAS, RAJASTHAN',
    masterId: 10461,
  },
  {
    type: 'cityName',
    value: 'BANSINALA HALT, BIHAR',
    masterId: 20747,
  },
  {
    type: 'cityName',
    value: 'BANSAPAHAR, UTTAR PRADESH',
    masterId: 16653,
  },
  {
    type: 'cityName',
    value: 'BHAGWANSAR RAIWAY, RAJASTHAN',
    masterId: 17219,
  },
  {
    type: 'cityName',
    value: 'BHARTHANA, UTTAR PRADESH',
    masterId: 10707,
  },
  {
    type: 'cityName',
    value: 'BAIDYANATH, GUJARAT',
    masterId: 17525,
  },
  {
    type: 'cityName',
    value: 'MANGALURU, KARNATAKA',
    masterId: 13414,
  },
  {
    type: 'cityName',
    value: 'BANDAKPUR, MADHYA PRADESH',
    masterId: 10466,
  },
  {
    type: 'cityName',
    value: 'BINNAGURI, WEST BENGAL',
    masterId: 10840,
  },
  {
    type: 'cityName',
    value: 'BHANVAD, GUJARAT',
    masterId: 10700,
  },
  {
    type: 'cityName',
    value: 'BHIWANI, HARYANA',
    masterId: 10759,
  },
  {
    type: 'cityName',
    value: 'BHANDEWARI, MAHARASHTRA',
    masterId: 17694,
  },
  {
    type: 'cityName',
    value: 'BARHNI, UTTAR PRADESH',
    masterId: 10535,
  },
  {
    type: 'cityName',
    value: 'BORSAD, GUJARAT',
    masterId: 18557,
  },
  {
    type: 'cityName',
    value: 'BOBAS, RAJASTHAN',
    masterId: 10860,
  },
  {
    type: 'cityName',
    value: 'BANGROD, MADHYA PRADESH',
    masterId: 10478,
  },
  {
    type: 'cityName',
    value: 'RAGHUNATHPUR, BIHAR',
    masterId: 14543,
  },
  {
    type: 'cityName',
    value: 'BAROG, HIMACHAL PRADESH',
    masterId: 10552,
  },
  {
    type: 'cityName',
    value: 'BHAIRONGARH, MADHYA PRADESH',
    masterId: 10680,
  },
  {
    type: 'cityName',
    value: 'BOINCHI, WEST BENGAL',
    masterId: 16167,
  },
  {
    type: 'cityName',
    value: 'BHOJO, ASSAM',
    masterId: 10762,
  },
  {
    type: 'cityName',
    value: 'BORKHEDI, MAHARASHTRA',
    masterId: 17685,
  },
  {
    type: 'cityName',
    value: 'PHANASAVALE, MAHARASHTRA',
    masterId: 14382,
  },
  {
    type: 'cityName',
    value: 'BOKO, ASSAM',
    masterId: 18938,
  },
  {
    type: 'cityName',
    value: 'BHOKAR, MAHARASHTRA',
    masterId: 10766,
  },
  {
    type: 'cityName',
    value: 'BOMADRA, RAJASTHAN',
    masterId: 10882,
  },
  {
    type: 'cityName',
    value: 'BOMMAGONDANAKERE, KARNATAKA',
    masterId: 18059,
  },
  {
    type: 'cityName',
    value: 'BHONRA, RAJASTHAN',
    masterId: 10771,
  },
  {
    type: 'cityName',
    value: 'BOINDA, ORISSA',
    masterId: 10872,
  },
  {
    type: 'cityName',
    value: 'BHOGPUR, WEST BENGAL',
    masterId: 19187,
  },
  {
    type: 'cityName',
    value: 'BOISAR, MAHARASHTRA',
    masterId: 10873,
  },
  {
    type: 'cityName',
    value: 'BAGHDOGRA, WEST BENGAL',
    masterId: 16018,
  },
  {
    type: 'cityName',
    value: 'BOROTI, MAHARASHTRA',
    masterId: 10896,
  },
  {
    type: 'cityName',
    value: 'BAORI THIKRIA, RAJASTHAN',
    masterId: 17232,
  },
  {
    type: 'cityName',
    value: 'BHAVDHARI, HARYANA',
    masterId: 18358,
  },
  {
    type: 'cityName',
    value: 'BHATGAON, CHHATTISGARH',
    masterId: 18621,
  },
  {
    type: 'cityName',
    value: 'MAKRANA, RAJASTHAN',
    masterId: 13293,
  },
  {
    type: 'cityName',
    value: 'BHADOHI, UTTAR PRADESH',
    masterId: 10665,
  },
  {
    type: 'cityName',
    value: 'BARRACKPORE, WEST BENGAL',
    masterId: 10557,
  },
  {
    type: 'cityName',
    value: 'BELLAMPALLI, ANDHRA PRADESH',
    masterId: 10625,
  },
  {
    type: 'cityName',
    value: 'BADARPUR, ASSAM',
    masterId: 10339,
  },
  {
    type: 'cityName',
    value: 'BERHAMPORE, WEST BENGAL',
    masterId: 10639,
  },
  {
    type: 'cityName',
    value: 'BAHADURPUR, WEST BENGAL',
    masterId: 10387,
  },
  {
    type: 'cityName',
    value: 'BENAPUR, WEST BENGAL',
    masterId: 16227,
  },
  {
    type: 'cityName',
    value: 'BANAPURA, MADHYA PRADESH',
    masterId: 10459,
  },
  {
    type: 'cityName',
    value: 'BENIPURGRAM HALT, BIHAR',
    masterId: 20763,
  },
  {
    type: 'cityName',
    value: 'BELPAHAR, ORISSA',
    masterId: 10628,
  },
  {
    type: 'cityName',
    value: 'BORHAPJAN, ASSAM',
    masterId: 18935,
  },
  {
    type: 'cityName',
    value: 'BHUGAON, MAHARASHTRA',
    masterId: 10781,
  },
  {
    type: 'cityName',
    value: 'BHOPALKA, GUJARAT',
    masterId: 10773,
  },
  {
    type: 'cityName',
    value: 'BUDHA PUSHKAR, RAJASTHAN',
    masterId: 17202,
  },
  {
    type: 'cityName',
    value: 'BAGHPAT, UTTAR PRADESH',
    masterId: 16670,
  },
  {
    type: 'cityName',
    value: 'BANPUR, WEST BENGAL',
    masterId: 21140,
  },
  {
    type: 'cityName',
    value: 'BARIPADA, ORISSA',
    masterId: 10539,
  },
  {
    type: 'cityName',
    value: 'BAPATLA, ANDHRA PRADESH',
    masterId: 10495,
  },
  {
    type: 'cityName',
    value: 'BALHARSHAH, MAHARASHTRA',
    masterId: 10428,
  },
  {
    type: 'cityName',
    value: 'BHOJIPURA, UTTAR PRADESH',
    masterId: 10761,
  },
  {
    type: 'cityName',
    value: 'BARIPURA, UTTAR PRADESH',
    masterId: 18561,
  },
  {
    type: 'cityName',
    value: 'BARPETA, ASSAM',
    masterId: 10556,
  },
  {
    type: 'cityName',
    value: 'BALPUR HALT, CHHATTISGARH',
    masterId: 10439,
  },
  {
    type: 'cityName',
    value: 'BHOGPUR, PUNJAB',
    masterId: 10760,
  },
  {
    type: 'cityName',
    value: 'BANPASH, WEST BENGAL',
    masterId: 10485,
  },
  {
    type: 'cityName',
    value: 'BHAUPUR, UTTAR PRADESH',
    masterId: 21009,
  },
  {
    type: 'cityName',
    value: 'BURHPURA, UTTAR PRADESH',
    masterId: 19176,
  },
  {
    type: 'cityName',
    value: 'BADAMPUDI, ANDHRA PRADESH',
    masterId: 10338,
  },
  {
    type: 'cityName',
    value: 'BAZPUR, UTTARAKHAND',
    masterId: 10602,
  },
  {
    type: 'cityName',
    value: 'BANKURA, WEST BENGAL',
    masterId: 10482,
  },
  {
    type: 'cityName',
    value: 'BARAHMUAFI, UTTAR PRADESH',
    masterId: 16650,
  },
  {
    type: 'cityName',
    value: 'BHAGWANGOLA, WEST BENGAL',
    masterId: 10676,
  },
  {
    type: 'cityName',
    value: 'BHANOHAD, PUNJAB',
    masterId: 17388,
  },
  {
    type: 'cityName',
    value: 'BOMMIDI, TAMIL NADU',
    masterId: 10883,
  },
  {
    type: 'cityName',
    value: 'MORCHHI, MADHYA PRADESH',
    masterId: 13645,
  },
  {
    type: 'cityName',
    value: 'BAGRI, RAJASTHAN',
    masterId: 10379,
  },
  {
    type: 'cityName',
    value: 'BIGHAPUR, UTTAR PRADESH',
    masterId: 10805,
  },
  {
    type: 'cityName',
    value: 'BAKHLETA, MADHYA PRADESH',
    masterId: 10408,
  },
  {
    type: 'cityName',
    value: 'BHATTIPROLU, ANDHRA PRADESH',
    masterId: 10722,
  },
  {
    type: 'cityName',
    value: 'BARAKALAN, UTTAR PRADESH',
    masterId: 21060,
  },
  {
    type: 'cityName',
    value: 'BELERHAT, WEST BENGAL',
    masterId: 16228,
  },
  {
    type: 'cityName',
    value: 'BALLALPUR, WEST BENGAL',
    masterId: 19188,
  },
  {
    type: 'cityName',
    value: 'MAHMADPURA, RAJASTHAN',
    masterId: 13260,
  },
  {
    type: 'cityName',
    value: 'BIRSOLA, MAHARASHTRA',
    masterId: 20903,
  },
  {
    type: 'cityName',
    value: 'BARANG, ORISSA',
    masterId: 10509,
  },
  {
    type: 'cityName',
    value: 'BALARAMAPURAM, KERALA',
    masterId: 10421,
  },
  {
    type: 'cityName',
    value: 'KADAMWASTI, MAHARASHTRA',
    masterId: 12319,
  },
  {
    type: 'cityName',
    value: 'BEERAHALLI, KARNATAKA',
    masterId: 18104,
  },
  {
    type: 'cityName',
    value: 'BIRBANS, JHARKHAND',
    masterId: 10844,
  },
  {
    type: 'cityName',
    value: 'VADODARA, GUJARAT',
    masterId: 15741,
  },
  {
    type: 'cityName',
    value: 'BARUA CHAK, UTTAR PRADESH',
    masterId: 16644,
  },
  {
    type: 'cityName',
    value: 'WARTHI, MAHARASHTRA',
    masterId: 15950,
  },
  {
    type: 'cityName',
    value: 'BARDA, WEST BENGAL',
    masterId: 21228,
  },
  {
    type: 'cityName',
    value: 'BERIA DAULAT, UTTARAKHAND',
    masterId: 16250,
  },
  {
    type: 'cityName',
    value: 'BARADEV, UTTAR PRADESH',
    masterId: 16777,
  },
  {
    type: 'cityName',
    value: 'BHARWARI, UTTAR PRADESH',
    masterId: 10711,
  },
  {
    type: 'cityName',
    value: 'BARGARH, UTTAR PRADESH',
    masterId: 10525,
  },
  {
    type: 'cityName',
    value: 'BARGARH, ORISSA',
    masterId: 10524,
  },
  {
    type: 'cityName',
    value: 'BARGAON GUJAR, MADHYA PRADESH',
    masterId: 17868,
  },
  {
    type: 'cityName',
    value: 'BURGULA, TELANGANA',
    masterId: 16820,
  },
  {
    type: 'cityName',
    value: 'BARAIGRAM, ASSAM',
    masterId: 18947,
  },
  {
    type: 'cityName',
    value: 'SIHODA, MADHYA PRADESH',
    masterId: 15152,
  },
  {
    type: 'cityName',
    value: 'BARGAWAN, MADHYA PRADESH',
    masterId: 10526,
  },
  {
    type: 'cityName',
    value: 'SARDI, CHHATTISGARH',
    masterId: 14948,
  },
  {
    type: 'cityName',
    value: 'BARHI, JHARKHAND',
    masterId: 10534,
  },
  {
    type: 'cityName',
    value: 'GURIPATHAR, ASSAM',
    masterId: 11859,
  },
  {
    type: 'cityName',
    value: 'BHIRINGI, MADHYA PRADESH',
    masterId: 16169,
  },
  {
    type: 'cityName',
    value: 'BAIRI, BIHAR',
    masterId: 18791,
  },
  {
    type: 'cityName',
    value: 'BRACE BRIDGE, WEST BENGAL',
    masterId: 20921,
  },
  {
    type: 'cityName',
    value: 'BRAJRAJNAGAR, ORISSA',
    masterId: 10908,
  },
  {
    type: 'cityName',
    value: 'BAHRAICH, UTTAR PRADESH',
    masterId: 10391,
  },
  {
    type: 'cityName',
    value: 'BARKAKANA, JHARKHAND',
    masterId: 10541,
  },
  {
    type: 'cityName',
    value: 'BHARAT KHAND, BIHAR',
    masterId: 18782,
  },
  {
    type: 'cityName',
    value: 'BARKIPONA, JHARKHAND',
    masterId: 18232,
  },
  {
    type: 'cityName',
    value: 'BORAKI, UTTAR PRADESH',
    masterId: 21007,
  },
  {
    type: 'cityName',
    value: 'BARWALA ROAD, GUJARAT',
    masterId: 20814,
  },
  {
    type: 'cityName',
    value: 'BRAYLA CHAURASI, MADHYA PRADESH',
    masterId: 10909,
  },
  {
    type: 'cityName',
    value: 'BAR LANGFER, ASSAM',
    masterId: 18980,
  },
  {
    type: 'cityName',
    value: 'BEEROLIYA, RAJASTHAN',
    masterId: 17280,
  },
  {
    type: 'cityName',
    value: 'CHAKRADHARPUR, JHARKHAND',
    masterId: 10960,
  },
  {
    type: 'cityName',
    value: 'BRAHAMANI PH, ORISSA',
    masterId: 17513,
  },
  {
    type: 'cityName',
    value: 'BARAMULA, JAMMU AND KASHMIR',
    masterId: 20840,
  },
  {
    type: 'cityName',
    value: 'BERMO, JHARKHAND',
    masterId: 10640,
  },
  {
    type: 'cityName',
    value: 'BIRMITRAPUR, ORISSA',
    masterId: 17514,
  },
  {
    type: 'cityName',
    value: 'BARAMATI, MAHARASHTRA',
    masterId: 10507,
  },
  {
    type: 'cityName',
    value: 'BARMI, UTTAR PRADESH',
    masterId: 17392,
  },
  {
    type: 'cityName',
    value: 'BARHAN, UTTAR PRADESH',
    masterId: 10531,
  },
  {
    type: 'cityName',
    value: 'RUNKHERA, MADHYA PRADESH',
    masterId: 14767,
  },
  {
    type: 'cityName',
    value: 'BORIDAND, MADHYA PRADESH',
    masterId: 10893,
  },
  {
    type: 'cityName',
    value: 'BARUA NAGAR, ASSAM',
    masterId: 18946,
  },
  {
    type: 'cityName',
    value: 'BERORE, RAJASTHAN',
    masterId: 17223,
  },
  {
    type: 'cityName',
    value: 'BARUIPUR JN, WEST BENGAL',
    masterId: 20920,
  },
  {
    type: 'cityName',
    value: 'BISHARPARA KODALIA, WEST BENGAL',
    masterId: 21149,
  },
  {
    type: 'cityName',
    value: 'BARPALI, ORISSA',
    masterId: 10553,
  },
  {
    type: 'cityName',
    value: 'SARAIYA, UTTAR PRADESH',
    masterId: 14939,
  },
  {
    type: 'cityName',
    value: 'BAGRAKOT, WEST BENGAL',
    masterId: 16181,
  },
  {
    type: 'cityName',
    value: 'BARAKAR, WEST BENGAL',
    masterId: 10505,
  },
  {
    type: 'cityName',
    value: 'BORDI, MAHARASHTRA',
    masterId: 17739,
  },
  {
    type: 'cityName',
    value: 'BIAORA, MADHYA PRADESH',
    masterId: 10794,
  },
  {
    type: 'cityName',
    value: 'BIRARI, UTTAR PRADESH ',
    masterId: 16621,
  },
  {
    type: 'cityName',
    value: 'BARARA BUZURG, UTTAR PRADESH',
    masterId: 16775,
  },
  {
    type: 'cityName',
    value: 'BIRSINGHPUR, MADHYA PRADESH',
    masterId: 10847,
  },
  {
    type: 'cityName',
    value: 'BARWA KALAN, UTTAR PRADESH',
    masterId: 16643,
  },
  {
    type: 'cityName',
    value: 'BIRAPURUSOTAMPUR, ORISSA',
    masterId: 17516,
  },
  {
    type: 'cityName',
    value: 'BARTARA, UTTAR PRADESH',
    masterId: 16645,
  },
  {
    type: 'cityName',
    value: 'BARITHENGARH P.H, ORISSA',
    masterId: 17521,
  },
  {
    type: 'cityName',
    value: 'BHORTEX, MAHARASHTRA',
    masterId: 10776,
  },
  {
    type: 'cityName',
    value: 'BHAIROGANJ, BIHAR',
    masterId: 10679,
  },
  {
    type: 'cityName',
    value: 'TORNIYA, MADHYA PRADESH',
    masterId: 15601,
  },
  {
    type: 'cityName',
    value: 'BORVIHIR, MAHARASHTRA',
    masterId: 16019,
  },
  {
    type: 'cityName',
    value: 'BARIWALA, PUNJAB',
    masterId: 10540,
  },
  {
    type: 'cityName',
    value: 'BARWADIH, JHARKHAND',
    masterId: 10564,
  },
  {
    type: 'cityName',
    value: 'BAHERWA, UTTAR PRADESH',
    masterId: 16668,
  },
  {
    type: 'cityName',
    value: 'BRAHIYA, BIHAR',
    masterId: 10902,
  },
  {
    type: 'cityName',
    value: 'BARETA, PUNJAB',
    masterId: 10522,
  },
  {
    type: 'cityName',
    value: 'BHANISAR HARAWATAN, RAJASTHAN',
    masterId: 17217,
  },
  {
    type: 'cityName',
    value: 'BHAINSA, UTTAR PRADESH',
    masterId: 16822,
  },
  {
    type: 'cityName',
    value: 'BANSBERIA, WEST BENGAL',
    masterId: 10486,
  },
  {
    type: 'cityName',
    value: 'VARANASI, UTTAR PRADESH',
    masterId: 15786,
  },
  {
    type: 'cityName',
    value: 'BIRSHIBPUR, WEST BENGAL',
    masterId: 16619,
  },
  {
    type: 'cityName',
    value: 'BANSLOI BRIDGE, WEST BENGAL',
    masterId: 16176,
  },
  {
    type: 'cityName',
    value: 'BULANDSHAHR, UTTAR PRADESH',
    masterId: 10921,
  },
  {
    type: 'cityName',
    value: 'BASUCHAK, UTTAR PRADESH',
    masterId: 16640,
  },
  {
    type: 'cityName',
    value: 'BASKATWA B. H., BIHAR',
    masterId: 20748,
  },
  {
    type: 'cityName',
    value: 'BASULDANGA, WEST BENGAL',
    masterId: 20923,
  },
  {
    type: 'cityName',
    value: 'BANIYA SANDA, RAJASTHAN',
    masterId: 19140,
  },
  {
    type: 'cityName',
    value: 'BHARSENDI, MADHYA PRADESH',
    masterId: 17865,
  },
  {
    type: 'cityName',
    value: 'GOBARDHANPUR, ORISSA',
    masterId: 11728,
  },
  {
    type: 'cityName',
    value: 'BANSADHARA, ORISSA',
    masterId: 17522,
  },
  {
    type: 'cityName',
    value: 'BADSHAHPUR, UTTAR PRADESH',
    masterId: 10358,
  },
  {
    type: 'cityName',
    value: 'BASUGAON, ASSAM',
    masterId: 18945,
  },
  {
    type: 'cityName',
    value: 'BHAGSAR, PUNJAB',
    masterId: 17390,
  },
  {
    type: 'cityName',
    value: 'BASIRHAT, WEST BENGAL',
    masterId: 21165,
  },
  {
    type: 'cityName',
    value: 'BASBARI, ASSAM',
    masterId: 10574,
  },
  {
    type: 'cityName',
    value: 'BHUPALSAGAR, RAJASTHAN ',
    masterId: 17207,
  },
  {
    type: 'cityName',
    value: 'BASUKINATH, JHARKHAND',
    masterId: 10580,
  },
  {
    type: 'cityName',
    value: 'BANSKHO, RAJASTHAN',
    masterId: 10489,
  },
  {
    type: 'cityName',
    value: 'KIRATPUR, UTTAR PRADESH',
    masterId: 12793,
  },
  {
    type: 'cityName',
    value: 'BHUSAWAL, MAHARASHTRA',
    masterId: 10790,
  },
  {
    type: 'cityName',
    value: 'BHASILA, WEST BENGAL',
    masterId: 21158,
  },
  {
    type: 'cityName',
    value: 'BATASPUR, WEST BENGAL',
    masterId: 10583,
  },
  {
    type: 'cityName',
    value: 'BODENAHALLI, ANDHRA PRADESH',
    masterId: 10864,
  },
  {
    type: 'cityName',
    value: 'BANASANDRA, KARNATAKA',
    masterId: 18067,
  },
  {
    type: 'cityName',
    value: 'BILASPUR, CHHATTISGARH',
    masterId: 10823,
  },
  {
    type: 'cityName',
    value: 'BISHANPUR, HARYANA',
    masterId: 18335,
  },
  {
    type: 'cityName',
    value: 'BASSI PATHANAM, PUNJAB',
    masterId: 10577,
  },
  {
    type: 'cityName',
    value: 'BISHRAMPUR, CHHATTISGARH',
    masterId: 10852,
  },
  {
    type: 'cityName',
    value: 'JODA, ORISSA',
    masterId: 12272,
  },
  {
    type: 'cityName',
    value: 'BARSI TAKLI, MAHARASHTRA',
    masterId: 17699,
  },
  {
    type: 'cityName',
    value: 'BANSIPUR, BIHAR',
    masterId: 10488,
  },
  {
    type: 'cityName',
    value: 'BESROLI, RAJASTHAN',
    masterId: 10642,
  },
  {
    type: 'cityName',
    value: 'TELGI, KARNATAKA',
    masterId: 15469,
  },
  {
    type: 'cityName',
    value: 'BAHADUR SINGH W, PUNJAB',
    masterId: 10384,
  },
  {
    type: 'cityName',
    value: 'BASSI BERISAL, RAJASTHAN',
    masterId: 17226,
  },
  {
    type: 'cityName',
    value: 'BASTI, UTTAR PRADESH',
    masterId: 10579,
  },
  {
    type: 'cityName',
    value: 'BASANTAPUR, ORISSA',
    masterId: 10569,
  },
  {
    type: 'cityName',
    value: 'BISALPUR, UTTAR PRADESH',
    masterId: 16618,
  },
  {
    type: 'cityName',
    value: 'BANESWAR, WEST BENGAL',
    masterId: 16230,
  },
  {
    type: 'cityName',
    value: 'BHAISWARA, UTTAR PRADESH',
    masterId: 16249,
  },
  {
    type: 'cityName',
    value: 'BHIWADI, GUJARAT',
    masterId: 17211,
  },
  {
    type: 'cityName',
    value: 'BASAR, TELANGANA',
    masterId: 16009,
  },
  {
    type: 'cityName',
    value: 'BARSATHI, UTTAR PRADESH',
    masterId: 16646,
  },
  {
    type: 'cityName',
    value: 'BELAUTI, BIHAR',
    masterId: 10618,
  },
  {
    type: 'cityName',
    value: 'BHARWA SUMERPUR, UTTAR PRADESH',
    masterId: 10710,
  },
  {
    type: 'cityName',
    value: 'BARASAT, PUNJAB',
    masterId: 20953,
  },
  {
    type: 'cityName',
    value: 'BIHTA, BIHAR',
    masterId: 10809,
  },
  {
    type: 'cityName',
    value: 'BUTI BORI, MAHARASHTRA',
    masterId: 10934,
  },
  {
    type: 'cityName',
    value: 'BALAGHAT JN, MADHYA PRADESH',
    masterId: 20871,
  },
  {
    type: 'cityName',
    value: 'BOTAD, GUJARAT',
    masterId: 10900,
  },
  {
    type: 'cityName',
    value: 'BATADRAWA, ASSAM',
    masterId: 18944,
  },
  {
    type: 'cityName',
    value: 'BHARATPUR, RAJASTHAN',
    masterId: 10704,
  },
  {
    type: 'cityName',
    value: 'BATHNAHA, BIHAR',
    masterId: 18842,
  },
  {
    type: 'cityName',
    value: 'VISHARATGANJ, UTTAR PRADESH',
    masterId: 15905,
  },
  {
    type: 'cityName',
    value: 'BETTADNAGENHALI, KARNATAKA',
    masterId: 18062,
  },
  {
    type: 'cityName',
    value: 'BETTIAH, BIHAR',
    masterId: 10649,
  },
  {
    type: 'cityName',
    value: 'BITHAULI, BIHAR',
    masterId: 18836,
  },
  {
    type: 'cityName',
    value: 'BATHINDA, PUNJAB',
    masterId: 10586,
  },
  {
    type: 'cityName',
    value: 'BHAWANIPUR, UTTAR PRADESH',
    masterId: 10730,
  },
  {
    type: 'cityName',
    value: 'BHATKAL, KARNATAKA',
    masterId: 10718,
  },
  {
    type: 'cityName',
    value: 'BANKATA, UTTAR PRADESH',
    masterId: 10480,
  },
  {
    type: 'cityName',
    value: 'BATHNA KRITTI BAS, WEST BENGAL',
    masterId: 21189,
  },
  {
    type: 'cityName',
    value: 'BHARATKUND, UTTAR PRADESH',
    masterId: 16632,
  },
  {
    type: 'cityName',
    value: 'BHARAT KUP, UTTAR PRADESH',
    masterId: 10703,
  },
  {
    type: 'cityName',
    value: 'BORTALAO, MAHARASHTRA',
    masterId: 10899,
  },
  {
    type: 'cityName',
    value: 'BATTULAPURAM, ANDHRA PRADESH',
    masterId: 19042,
  },
  {
    type: 'cityName',
    value: 'BHITAURA, UTTAR PRADESH',
    masterId: 10757,
  },
  {
    type: 'cityName',
    value: 'BABATPUR, UTTAR PRADESH',
    masterId: 10326,
  },
  {
    type: 'cityName',
    value: 'BETHAMPUDI, ANDHRA PRADESH',
    masterId: 10646,
  },
  {
    type: 'cityName',
    value: 'BETHERIA GHOLA, WEST BENGAL',
    masterId: 21195,
  },
  {
    type: 'cityName',
    value: 'BETNOTI, ORISSA',
    masterId: 10648,
  },
  {
    type: 'cityName',
    value: 'BUTARI, PUNJAB',
    masterId: 10933,
  },
  {
    type: 'cityName',
    value: 'DALELPUR, UTTAR PRADESH',
    masterId: 11202,
  },
  {
    type: 'cityName',
    value: 'BETUR, WEST BENGAL',
    masterId: 21118,
  },
  {
    type: 'cityName',
    value: 'BITROL, UTTAR PRADESH',
    masterId: 16617,
  },
  {
    type: 'cityName',
    value: 'BASTOI, UTTAR PRADESH',
    masterId: 16641,
  },
  {
    type: 'cityName',
    value: 'BASTA, ORISSA',
    masterId: 10578,
  },
  {
    type: 'cityName',
    value: 'BHATISUDA, MADHYA PRADESH',
    masterId: 10716,
  },
  {
    type: 'cityName',
    value: 'BATASI, WEST BENGAL',
    masterId: 21101,
  },
  {
    type: 'cityName',
    value: 'BHUTESHWAR, UTTAR PRADESH',
    masterId: 18503,
  },
  {
    type: 'cityName',
    value: 'BHATNI, UTTAR PRADESH',
    masterId: 10720,
  },
  {
    type: 'cityName',
    value: 'BHATIAN, PUNJAB',
    masterId: 20932,
  },
  {
    type: 'cityName',
    value: 'BITRAGUNTA, ANDHRA PRADESH',
    masterId: 10859,
  },
  {
    type: 'cityName',
    value: 'BARAUT, UTTAR PRADESH',
    masterId: 10512,
  },
  {
    type: 'cityName',
    value: 'TARAS, ORISSA',
    masterId: 15444,
  },
  {
    type: 'cityName',
    value: 'BATUVA, ANDHRA PRADESH',
    masterId: 19041,
  },
  {
    type: 'cityName',
    value: 'BARSHI, MAHARASHTRA',
    masterId: 10560,
  },
  {
    type: 'cityName',
    value: 'JAITPUR, UTTAR PRADESH',
    masterId: 12136,
  },
  {
    type: 'cityName',
    value: 'BETHUADAHARI, WEST BENGAL',
    masterId: 10647,
  },
  {
    type: 'cityName',
    value: 'BALIMARA, ASSAM',
    masterId: 18949,
  },
  {
    type: 'cityName',
    value: 'BASWA, HARYANA',
    masterId: 10581,
  },
  {
    type: 'cityName',
    value: 'BARADWAR, CHHATTISGARH',
    masterId: 10502,
  },
  {
    type: 'cityName',
    value: 'BHUTAKIA BHIMSA, GUJARAT',
    masterId: 18504,
  },
  {
    type: 'cityName',
    value: 'BURAHA BHARTHARA, UTTAR PRADESH',
    masterId: 16611,
  },
  {
    type: 'cityName',
    value: 'BHUDA, RAJASTHAN',
    masterId: 17209,
  },
  {
    type: 'cityName',
    value: 'BUNDI, RAJASTHAN',
    masterId: 10924,
  },
  {
    type: 'cityName',
    value: 'BADMAL, ORISSA',
    masterId: 10350,
  },
  {
    type: 'cityName',
    value: 'BAUDPUR, ORISSA',
    masterId: 17541,
  },
  {
    type: 'cityName',
    value: 'BARUNA, BIHAR',
    masterId: 20784,
  },
  {
    type: 'cityName',
    value: 'BIMALAGARH, ORISSA',
    masterId: 17517,
  },
  {
    type: 'cityName',
    value: 'BAGAHA, BIHAR',
    masterId: 10361,
  },
  {
    type: 'cityName',
    value: 'BUGLANWALI, RAJASTHAN',
    masterId: 17200,
  },
  {
    type: 'cityName',
    value: 'BHURJIHA BARAGN, UTTAR PRADESH',
    masterId: 16626,
  },
  {
    type: 'cityName',
    value: 'BUGIA, RAJASTHAN',
    masterId: 17201,
  },
  {
    type: 'cityName',
    value: 'BURHAR, MADHYA PRADESH',
    masterId: 10928,
  },
  {
    type: 'cityName',
    value: 'BALLIA, UTTAR PRADESH',
    masterId: 10436,
  },
  {
    type: 'cityName',
    value: 'BARAUNI FLAG, BIHAR',
    masterId: 18785,
  },
  {
    type: 'cityName',
    value: 'MAHIPANI, JHARKHAND',
    masterId: 13258,
  },
  {
    type: 'cityName',
    value: 'BOMMASAMUDRAM, ANDHRA PRADESH',
    masterId: 16998,
  },
  {
    type: 'cityName',
    value: 'BARIARPUR, BIHAR',
    masterId: 10538,
  },
  {
    type: 'cityName',
    value: 'CHANDRAPUR, MAHARASHTRA',
    masterId: 10993,
  },
  {
    type: 'cityName',
    value: 'BINDAURA, UTTAR PRADESH',
    masterId: 16622,
  },
  {
    type: 'cityName',
    value: 'BADAUSHA, UTTAR PRADESH',
    masterId: 16673,
  },
  {
    type: 'cityName',
    value: 'BAYTU, RAJASTHAN',
    masterId: 10598,
  },
  {
    type: 'cityName',
    value: 'BHADUTALA, WEST BENGAL',
    masterId: 21086,
  },
  {
    type: 'cityName',
    value: 'BHARAULI, MADHYA PRADESH',
    masterId: 10705,
  },
  {
    type: 'cityName',
    value: 'BURHWAL, UTTAR PRADESH',
    masterId: 10929,
  },
  {
    type: 'cityName',
    value: 'BABHNAN, UTTAR PRADESH',
    masterId: 10327,
  },
  {
    type: 'cityName',
    value: 'BAURIA, WEST BENGAL',
    masterId: 10591,
  },
  {
    type: 'cityName',
    value: 'BALAMPUR, MADHYA PRADESH',
    masterId: 10416,
  },
  {
    type: 'cityName',
    value: 'BHAVNAGAR, GUJARAT',
    masterId: 10727,
  },
  {
    type: 'cityName',
    value: 'FARIDABAD, HARYANA',
    masterId: 11563,
  },
  {
    type: 'cityName',
    value: 'BIKKAVOLU, ANDHRA PRADESH',
    masterId: 10818,
  },
  {
    type: 'cityName',
    value: 'BISWAN, UTTAR PRADESH',
    masterId: 10857,
  },
  {
    type: 'cityName',
    value: 'BOGOLU, ANDHRA PRADESH',
    masterId: 19039,
  },
  {
    type: 'cityName',
    value: 'BURUNGWADI, MAHARASHTRA',
    masterId: 10931,
  },
  {
    type: 'cityName',
    value: 'BANAVAR, KARNATAKA',
    masterId: 19112,
  },
  {
    type: 'cityName',
    value: 'BHIMAVARAM, ANDHRA PRADESH',
    masterId: 10748,
  },
  {
    type: 'cityName',
    value: 'BALIPARA, ASSAM',
    masterId: 10430,
  },
  {
    type: 'cityName',
    value: 'BEDETTI, ASSAM',
    masterId: 18942,
  },
  {
    type: 'cityName',
    value: 'BAHMANI WALA, PUNJAB',
    masterId: 17424,
  },
  {
    type: 'cityName',
    value: 'BARWA - NALOI, HARYANA',
    masterId: 18345,
  },
  {
    type: 'cityName',
    value: 'BIWAI, RAJASTHAN',
    masterId: 17276,
  },
  {
    type: 'cityName',
    value: 'BINWALIYA, RAJASTHAN',
    masterId: 18776,
  },
  {
    type: 'cityName',
    value: 'BAGWALI, PUNJAB',
    masterId: 10383,
  },
  {
    type: 'cityName',
    value: 'BEWAR BHOJAN, RAJASTHAN',
    masterId: 17222,
  },
  {
    type: 'cityName',
    value: 'BANWALI, RAJASTHAN',
    masterId: 17393,
  },
  {
    type: 'cityName',
    value: 'BOWAICHANDI, WEST BENGAL',
    masterId: 21114,
  },
  {
    type: 'cityName',
    value: 'BUREWALA, PUNJAB',
    masterId: 17386,
  },
  {
    type: 'cityName',
    value: 'BHADAURA, UTTAR PRADESH',
    masterId: 10659,
  },
  {
    type: 'cityName',
    value: 'BELWAI, UTTAR PRADESH',
    masterId: 10634,
  },
  {
    type: 'cityName',
    value: 'BHAWANIPATNA, ORISSA',
    masterId: 10729,
  },
  {
    type: 'cityName',
    value: 'BAWANI KHERA, HARYANA',
    masterId: 10595,
  },
  {
    type: 'cityName',
    value: 'BAWAL, HARYANA',
    masterId: 10594,
  },
  {
    type: 'cityName',
    value: 'BHAWANI MANDI, MADHYA PRADESH',
    masterId: 10728,
  },
  {
    type: 'cityName',
    value: 'BURDWAN, WEST BENGAL',
    masterId: 10926,
  },
  {
    type: 'cityName',
    value: 'BURAMARA, ODISHA',
    masterId: 20911,
  },
  {
    type: 'cityName',
    value: 'BHAWANIPUR KALAN, UTTAR PRADESH',
    masterId: 16630,
  },
  {
    type: 'cityName',
    value: 'BHAWANIPUR, BIHAR',
    masterId: 18839,
  },
  {
    type: 'cityName',
    value: 'CHELASI, RAJASTHAN',
    masterId: 17197,
  },
  {
    type: 'cityName',
    value: 'BARWA SAGAR, UTTAR PRADESH',
    masterId: 10563,
  },
  {
    type: 'cityName',
    value: 'BHARATWADA, MAHARASHTRA',
    masterId: 17693,
  },
  {
    type: 'cityName',
    value: 'BHADWASI, RAJASTHAN',
    masterId: 10673,
  },
  {
    type: 'cityName',
    value: 'BANGARAPET, KARNATAKA',
    masterId: 10475,
  },
  {
    type: 'cityName',
    value: 'BHIWAPUR, MAHARASHTRA',
    masterId: 17691,
  },
  {
    type: 'cityName',
    value: 'BARWAHA, MADHYA PRADESH',
    masterId: 10565,
  },
  {
    type: 'cityName',
    value: 'BEHMAN DIWANA, PUNJAB',
    masterId: 17391,
  },
  {
    type: 'cityName',
    value: 'BADDOWAL, PUNJAB',
    masterId: 17425,
  },
  {
    type: 'cityName',
    value: 'BALOD, CHHATTISGARH',
    masterId: 10437,
  },
  {
    type: 'cityName',
    value: 'BANGA, PUNJAB',
    masterId: 17395,
  },
  {
    type: 'cityName',
    value: 'BARWALA, HARYANA',
    masterId: 10566,
  },
  {
    type: 'cityName',
    value: 'BARSUAN, ORISSA',
    masterId: 17520,
  },
  {
    type: 'cityName',
    value: 'BHANGA, ASSAM',
    masterId: 16634,
  },
  {
    type: 'cityName',
    value: 'BOKAJAN, ASSAM',
    masterId: 10874,
  },
  {
    type: 'cityName',
    value: 'BANDARKHAL, ASSAM',
    masterId: 10468,
  },
  {
    type: 'cityName',
    value: 'BHEDUASOL, WEST BENGAL',
    masterId: 16172,
  },
  {
    type: 'cityName',
    value: 'BILLI, UTTAR PRADESH',
    masterId: 18777,
  },
  {
    type: 'cityName',
    value: 'BHEDAURI, UTTAR PRADESH',
    masterId: 10732,
  },
  {
    type: 'cityName',
    value: 'BAYANA, RAJASTHAN',
    masterId: 10597,
  },
  {
    type: 'cityName',
    value: 'BARPATHAR, ASSAM',
    masterId: 10554,
  },
  {
    type: 'cityName',
    value: 'BRUNDAMAL, ORISSA',
    masterId: 17540,
  },
  {
    type: 'cityName',
    value: 'BUXAR, BIHAR',
    masterId: 10936,
  },
  {
    type: 'cityName',
    value: 'PICHANDARKOVIL, TAMIL NADU',
    masterId: 16904,
  },
  {
    type: 'cityName',
    value: 'BAMANHAT, WEST BENGAL',
    masterId: 16178,
  },
  {
    type: 'cityName',
    value: 'HARNYA, MADHYA PRADESH',
    masterId: 11946,
  },
  {
    type: 'cityName',
    value: 'YADGIR, KARNATAKA',
    masterId: 15967,
  },
  {
    type: 'cityName',
    value: 'BANSI TAALAB, RAJASTHAN',
    masterId: 17234,
  },
  {
    type: 'cityName',
    value: 'BHITI, UTTAR PRADESH ',
    masterId: 16629,
  },
  {
    type: 'cityName',
    value: 'BARYARAM, UTTAR PRADESH',
    masterId: 16642,
  },
  {
    type: 'cityName',
    value: 'BELHA, CHHATTISGARH',
    masterId: 10623,
  },
  {
    type: 'cityName',
    value: 'BANAHI, BIHAR',
    masterId: 10458,
  },
  {
    type: 'cityName',
    value: 'BAINDUR, KARNATAKA',
    masterId: 10400,
  },
  {
    type: 'cityName',
    value: 'BAIJNATHPUR, BIHAR',
    masterId: 18792,
  },
  {
    type: 'cityName',
    value: 'BHAHAI, UTTAR PRADESH',
    masterId: 16636,
  },
  {
    type: 'cityName',
    value: 'BHAYANDAR, MAHARASHTRA',
    masterId: 10731,
  },
  {
    type: 'cityName',
    value: 'BARSALI, MADHYA PRADESH',
    masterId: 10559,
  },
  {
    type: 'cityName',
    value: 'BASULYASUTAHATA, WEST BENGAL',
    masterId: 21229,
  },
  {
    type: 'cityName',
    value: 'BHATAPARA, CHHATTISGARH',
    masterId: 10712,
  },
  {
    type: 'cityName',
    value: 'BETGARA, WEST BENGAL',
    masterId: 18234,
  },
  {
    type: 'cityName',
    value: 'BYREE, ORISSA',
    masterId: 17511,
  },
  {
    type: 'cityName',
    value: 'BEGUNIA, ORISSA',
    masterId: 17519,
  },
  {
    type: 'cityName',
    value: 'NAMOL, PUNJAB',
    masterId: 17311,
  },
  {
    type: 'cityName',
    value: 'VIJAYAWADA, ANDHRA PRADESH',
    masterId: 15873,
  },
  {
    type: 'cityName',
    value: 'BARRA BAZAR, WEST BENGAL',
    masterId: 21134,
  },
  {
    type: 'cityName',
    value: 'BELIATOR, WEST BENGAL',
    masterId: 21125,
  },
  {
    type: 'cityName',
    value: 'BILGA, PUNJAB',
    masterId: 10827,
  },
  {
    type: 'cityName',
    value: 'BAZIDA JATTAN, HARYANA',
    masterId: 18343,
  },
  {
    type: 'cityName',
    value: 'BHAINI KHURD, HARYANA',
    masterId: 18341,
  },
  {
    type: 'cityName',
    value: 'BAZARSAU, WEST BENGAL',
    masterId: 10600,
  },
  {
    type: 'cityName',
    value: 'BHIMSEN, UTTAR PRADESH',
    masterId: 10751,
  },
  {
    type: 'cityName',
    value: 'BAGNAN, WEST BENGAL',
    masterId: 10376,
  },
  {
    type: 'cityName',
    value: 'BARSOLA, HARYANA',
    masterId: 10561,
  },
  {
    type: 'cityName',
    value: 'BISRA, ORISSA',
    masterId: 10854,
  },
  {
    type: 'cityName',
    value: 'BANSJORA, JHARKHAND',
    masterId: 18233,
  },
  {
    type: 'cityName',
    value: 'BETUL, MADHYA PRADESH',
    masterId: 10650,
  },
  {
    type: 'cityName',
    value: 'BASAI, MADHYA PRADESH',
    masterId: 10568,
  },
  {
    type: 'cityName',
    value: 'CHAKIA, BIHAR',
    masterId: 10958,
  },
  {
    type: 'cityName',
    value: 'CABIN, CHHATTISGARH',
    masterId: 17745,
  },
  {
    type: 'cityName',
    value: 'MUNDI, MADHYA PRADESH',
    masterId: 13721,
  },
  {
    type: 'cityName',
    value: 'ACHOLI, RAJASTHAN',
    masterId: 10019,
  },
  {
    type: 'cityName',
    value: 'CHANPATIA, BIHAR',
    masterId: 11007,
  },
  {
    type: 'cityName',
    value: 'CHAKRAJMAL, UTTAR PRADESH',
    masterId: 16606,
  },
  {
    type: 'cityName',
    value: 'CHOTA AMBONA, JHARKHAND',
    masterId: 18189,
  },
  {
    type: 'cityName',
    value: 'CHAMUA, BIHAR',
    masterId: 18772,
  },
  {
    type: 'cityName',
    value: 'KANNUR, KERALA',
    masterId: 12506,
  },
  {
    type: 'cityName',
    value: 'CHAURADANO, BIHAR',
    masterId: 20769,
  },
  {
    type: 'cityName',
    value: 'CHATRAPUR, ORISSA',
    masterId: 11020,
  },
  {
    type: 'cityName',
    value: 'KANYAKUMARI, TAMIL NADU',
    masterId: 12515,
  },
  {
    type: 'cityName',
    value: 'CHUNAR, UTTAR PRADESH',
    masterId: 16011,
  },
  {
    type: 'cityName',
    value: 'CHAS ROAD, WEST BENGAL',
    masterId: 17589,
  },
  {
    type: 'cityName',
    value: 'CHHANSARA, GUJARAT',
    masterId: 18556,
  },
  {
    type: 'cityName',
    value: 'CHATTERHAT, BIHAR',
    masterId: 16163,
  },
  {
    type: 'cityName',
    value: 'CHHATA ASCHAURA, BIHAR',
    masterId: 16593,
  },
  {
    type: 'cityName',
    value: 'CHATAUD, CHHATTISGARH',
    masterId: 18619,
  },
  {
    type: 'cityName',
    value: 'CHAUHANI, MADHYA PRADESH',
    masterId: 17861,
  },
  {
    type: 'cityName',
    value: 'CHANGRABANDHA, WEST BENGAL',
    masterId: 21106,
  },
  {
    type: 'cityName',
    value: 'COIMBATORE, TAMIL NADU',
    masterId: 11162,
  },
  {
    type: 'cityName',
    value: 'CHARBHUJA, RAJASTHAN',
    masterId: 17198,
  },
  {
    type: 'cityName',
    value: 'CHAUBE, JHARKHAND',
    masterId: 20850,
  },
  {
    type: 'cityName',
    value: 'CHHAN, MADHYA PRADESH',
    masterId: 11054,
  },
  {
    type: 'cityName',
    value: 'CUMBUM, ANDHRA PRADESH',
    masterId: 11172,
  },
  {
    type: 'cityName',
    value: 'CHITBARAGAON, UTTAR PRADESH',
    masterId: 11130,
  },
  {
    type: 'cityName',
    value: 'CHIK BALLAPUR, KARNATAKA',
    masterId: 19113,
  },
  {
    type: 'cityName',
    value: 'CHAUBEPUR, UTTAR PRADESH',
    masterId: 16599,
  },
  {
    type: 'cityName',
    value: 'CHAIBASA, JHARKHAND',
    masterId: 10949,
  },
  {
    type: 'cityName',
    value: 'CHARBATIA, ORISSA',
    masterId: 17508,
  },
  {
    type: 'cityName',
    value: 'CHINNABABUSAMUDRAM, TAMIL NADU',
    masterId: 16994,
  },
  {
    type: 'cityName',
    value: 'CHAND BHAN, PUNJAB',
    masterId: 17383,
  },
  {
    type: 'cityName',
    value: 'CHURAIBARI, TRIPURA',
    masterId: 18926,
  },
  {
    type: 'cityName',
    value: 'CHAURI CHAURA, UTTAR PRADESH',
    masterId: 11025,
  },
  {
    type: 'cityName',
    value: 'CHIGICHERLA, ANDHRA PRADESH',
    masterId: 11075,
  },
  {
    type: 'cityName',
    value: 'C CABIN, CHHATTISGARH',
    masterId: 18620,
  },
  {
    type: 'cityName',
    value: 'CHICHOLI BUZURG, MAHARASHTRA',
    masterId: 17682,
  },
  {
    type: 'cityName',
    value: 'CHICHONDA, MADHYA PRADESH',
    masterId: 17860,
  },
  {
    type: 'cityName',
    value: 'OBULAPURAM, ANDHRA PRADESH',
    masterId: 14069,
  },
  {
    type: 'cityName',
    value: 'CHICHAKI, JHARKHAND',
    masterId: 11070,
  },
  {
    type: 'cityName',
    value: 'CHANCHELAV, GUJARAT',
    masterId: 18499,
  },
  {
    type: 'cityName',
    value: 'CHICHOLI, MAHARASHTRA',
    masterId: 17744,
  },
  {
    type: 'cityName',
    value: 'CHHUCHHAPURA, GUJARAT',
    masterId: 18494,
  },
  {
    type: 'cityName',
    value: 'KAKINADA, ANDHRA PRADESH',
    masterId: 12359,
  },
  {
    type: 'cityName',
    value: 'BHRUGUPUR, GUJARAT',
    masterId: 10778,
  },
  {
    type: 'cityName',
    value: 'CHAUDHRIBANDH, JHARKHAND',
    masterId: 20845,
  },
  {
    type: 'cityName',
    value: 'CANDRABANDA HALT, KARNATAKA',
    masterId: 20865,
  },
  {
    type: 'cityName',
    value: 'CHEDHABANNI, BIHAR',
    masterId: 18770,
  },
  {
    type: 'cityName',
    value: 'CHANDIGARH, CHANDIGARH',
    masterId: 10982,
  },
  {
    type: 'cityName',
    value: 'CHANDRAKONA, WEST BENGAL',
    masterId: 10991,
  },
  {
    type: 'cityName',
    value: 'CHAKDAHA, WEST BENGAL',
    masterId: 10955,
  },
  {
    type: 'cityName',
    value: 'CHANDNI, MADHYA PRADESH',
    masterId: 18191,
  },
  {
    type: 'cityName',
    value: 'CHANDKHERA ROAD, GUJARAT',
    masterId: 20809,
  },
  {
    type: 'cityName',
    value: 'CHUDIYALA MOHANPUR, UTTAR PRADESH',
    masterId: 16256,
  },
  {
    type: 'cityName',
    value: 'CHIDAMBARAM, TAMIL NADU',
    masterId: 11074,
  },
  {
    type: 'cityName',
    value: 'CHANDAULI, UTTAR PRADESH',
    masterId: 10978,
  },
  {
    type: 'cityName',
    value: 'CHANDPARA, WEST BENGAL',
    masterId: 21167,
  },
  {
    type: 'cityName',
    value: 'CHANDERA, KERALA',
    masterId: 17955,
  },
  {
    type: 'cityName',
    value: 'CHHANDRAULI, UTTAR PRADESH',
    masterId: 16595,
  },
  {
    type: 'cityName',
    value: 'CHANDISAR, GUJARAT',
    masterId: 18498,
  },
  {
    type: 'cityName',
    value: 'CHANDRESAL, RAJASTHAN',
    masterId: 10996,
  },
  {
    type: 'cityName',
    value: 'CHEBROLU, ANDHRA PRADESH',
    masterId: 11031,
  },
  {
    type: 'cityName',
    value: 'CHEKATE G PALEM, ANDHRA PRADESH',
    masterId: 11032,
  },
  {
    type: 'cityName',
    value: 'CHEGRO, JHARKHAND',
    masterId: 20844,
  },
  {
    type: 'cityName',
    value: 'CHIHERU, PUNJAB',
    masterId: 11076,
  },
  {
    type: 'cityName',
    value: 'CHAKITING, ASSAM',
    masterId: 18934,
  },
  {
    type: 'cityName',
    value: 'CANNING, WEST BENGAL',
    masterId: 21254,
  },
  {
    type: 'cityName',
    value: 'CHENGAIL, WEST BENGAL',
    masterId: 16161,
  },
  {
    type: 'cityName',
    value: 'CHARALI, ASSAM',
    masterId: 18975,
  },
  {
    type: 'cityName',
    value: 'CHOLANG, PUNJAB',
    masterId: 17423,
  },
  {
    type: 'cityName',
    value: 'CHINNADAGUDI HUNDI, KARNATAKA',
    masterId: 18050,
  },
  {
    type: 'cityName',
    value: 'CHANDRAGIRI, ANDHRA PRADESH',
    masterId: 10989,
  },
  {
    type: 'cityName',
    value: 'CHANDAGIRIKOPAL, KARNATAKA',
    masterId: 18054,
  },
  {
    type: 'cityName',
    value: 'CHENGALPATTU, TAMIL NADU',
    masterId: 11034,
  },
  {
    type: 'cityName',
    value: 'CHIRGAON, UTTAR PRADESH',
    masterId: 11124,
  },
  {
    type: 'cityName',
    value: 'CHHAYGAON, MADHYA PRADESH',
    masterId: 18928,
  },
  {
    type: 'cityName',
    value: 'CHAYGAON, ASSAM',
    masterId: 18929,
  },
  {
    type: 'cityName',
    value: 'CHANDANNAGAR, WEST BENGAL',
    masterId: 10976,
  },
  {
    type: 'cityName',
    value: 'CHANGSARI, ASSAM',
    masterId: 11001,
  },
  {
    type: 'cityName',
    value: 'CHEGUNTA, TELANGANA',
    masterId: 16819,
  },
  {
    type: 'cityName',
    value: 'CHINGAVANAM, KERALA',
    masterId: 11104,
  },
  {
    type: 'cityName',
    value: 'CHARGOLA, ASSAM',
    masterId: 18930,
  },
  {
    type: 'cityName',
    value: 'CHANGANASSERY, KERALA',
    masterId: 11000,
  },
  {
    type: 'cityName',
    value: 'CHANDAUSI, UTTAR PRADESH',
    masterId: 10979,
  },
  {
    type: 'cityName',
    value: 'CHAWAPAIL, PUNJAB',
    masterId: 11030,
  },
  {
    type: 'cityName',
    value: 'CHAF, UTTAR PRADESH',
    masterId: 16609,
  },
  {
    type: 'cityName',
    value: 'CHARMAL, ORISSA',
    masterId: 17539,
  },
  {
    type: 'cityName',
    value: 'CHABUA, ASSAM',
    masterId: 10945,
  },
  {
    type: 'cityName',
    value: 'CHAND KHIRA BAGAN, ASSAM',
    masterId: 18932,
  },
  {
    type: 'cityName',
    value: 'CHAURE BAZAR, UTTAR PRADESH',
    masterId: 16597,
  },
  {
    type: 'cityName',
    value: 'CHAUBEESI, UTTAR PRADESH',
    masterId: 16769,
  },
  {
    type: 'cityName',
    value: 'CHAKARBHATHA, CHHATTISGARH',
    masterId: 10951,
  },
  {
    type: 'cityName',
    value: 'CHANCHAI, WEST BENGAL',
    masterId: 21066,
  },
  {
    type: 'cityName',
    value: 'CHACHER, MAHARASHTRA',
    masterId: 10946,
  },
  {
    type: 'cityName',
    value: 'CHANDIA, MADHYA PRADESH',
    masterId: 10981,
  },
  {
    type: 'cityName',
    value: 'CHHADA, MADHYA PRADESH',
    masterId: 17538,
  },
  {
    type: 'cityName',
    value: 'SRIKAKULAM, ANDHRA PRADESH',
    masterId: 15288,
  },
  {
    type: 'cityName',
    value: 'TELARI, UTTAR PRADESH',
    masterId: 15467,
  },
  {
    type: 'cityName',
    value: 'CHHANVA, ODISHA',
    masterId: 20918,
  },
  {
    type: 'cityName',
    value: 'CHIPLUN, MAHARASHTRA',
    masterId: 11118,
  },
  {
    type: 'cityName',
    value: 'CHIRAI BG, GUJARAT ',
    masterId: 18493,
  },
  {
    type: 'cityName',
    value: 'CHITHARI, UTTAR PRADESH',
    masterId: 16591,
  },
  {
    type: 'cityName',
    value: 'CHATA, UTTAR PRADESH',
    masterId: 11015,
  },
  {
    type: 'cityName',
    value: 'CHITHODA, MAHARASHTRA',
    masterId: 18492,
  },
  {
    type: 'cityName',
    value: 'CHAKERI, UTTAR PRADESH',
    masterId: 21035,
  },
  {
    type: 'cityName',
    value: 'CHALLAKERE, KARNATAKA',
    masterId: 10969,
  },
  {
    type: 'cityName',
    value: 'CHOLA, UTTAR PRADESH',
    masterId: 11145,
  },
  {
    type: 'cityName',
    value: 'DHARANGAON, MAHARASHTRA',
    masterId: 11361,
  },
  {
    type: 'cityName',
    value: 'CHHALESAR, UTTAR PRADESH',
    masterId: 16596,
  },
  {
    type: 'cityName',
    value: 'KADODARA, GUJARAT',
    masterId: 12333,
  },
  {
    type: 'cityName',
    value: 'CHHINA, PUNJAB',
    masterId: 17381,
  },
  {
    type: 'cityName',
    value: 'CHANNANI, RAJASTHAN',
    masterId: 11003,
  },
  {
    type: 'cityName',
    value: 'CHHAN ARORIAN, JAMMU AND KASHMIR',
    masterId: 11055,
  },
  {
    type: 'cityName',
    value: 'CHARDUAR, ASSAM',
    masterId: 18981,
  },
  {
    type: 'cityName',
    value: 'CHAUK, BIHAR',
    masterId: 11022,
  },
  {
    type: 'cityName',
    value: 'CHHAPI, GUJARAT',
    masterId: 11059,
  },
  {
    type: 'cityName',
    value: 'CHEPPAD, KERALA',
    masterId: 17932,
  },
  {
    type: 'cityName',
    value: 'CHATRAPATTI, TAMIL NADU',
    masterId: 11019,
  },
  {
    type: 'cityName',
    value: 'CHILKAHAR, UTTAR PRADESH',
    masterId: 11092,
  },
  {
    type: 'cityName',
    value: 'CHHARRAH, WEST BENGAL',
    masterId: 11061,
  },
  {
    type: 'cityName',
    value: 'CHORGI, KARNATAKA',
    masterId: 11151,
  },
  {
    type: 'cityName',
    value: 'CHIRMIRI, CHHATTISGARH',
    masterId: 11126,
  },
  {
    type: 'cityName',
    value: 'CHAMRUA, UTTARAKHAND',
    masterId: 16604,
  },
  {
    type: 'cityName',
    value: 'CHINNASALEM, TAMIL NADU',
    masterId: 11112,
  },
  {
    type: 'cityName',
    value: 'CHAMPAHATI, UTTAR PRADESH',
    masterId: 21057,
  },
  {
    type: 'cityName',
    value: 'CHANETHI, UTTAR PRADESH',
    masterId: 16601,
  },
  {
    type: 'cityName',
    value: 'CHURARU TAKRALA, HIMACHAL PRADESH',
    masterId: 18244,
  },
  {
    type: 'cityName',
    value: 'CHITTA, KARNATAKA',
    masterId: 18048,
  },
  {
    type: 'cityName',
    value: 'CHAMPION REEF, KARNATAKA',
    masterId: 18055,
  },
  {
    type: 'cityName',
    value: 'CHERUVATHUR, KERALA',
    masterId: 11049,
  },
  {
    type: 'cityName',
    value: 'CHHAPRAWAT, UTTAR PRADESH',
    masterId: 16594,
  },
  {
    type: 'cityName',
    value: 'CHARLAPALLI, ANDHRA PRADESH',
    masterId: 11013,
  },
  {
    type: 'cityName',
    value: 'CHHAPRA, BIHAR',
    masterId: 11060,
  },
  {
    type: 'cityName',
    value: 'CHHEHARTA, PUNJAB',
    masterId: 20946,
  },
  {
    type: 'cityName',
    value: 'CHILHIA, UTTAR PRADESH',
    masterId: 18190,
  },
  {
    type: 'cityName',
    value: 'CHETTIYAPATTY, TAMIL NADU',
    masterId: 16995,
  },
  {
    type: 'cityName',
    value: 'CHIKSANA, RAJASTHAN',
    masterId: 17196,
  },
  {
    type: 'cityName',
    value: 'CHILBILA, UTTAR PRADESH',
    masterId: 11089,
  },
  {
    type: 'cityName',
    value: 'CHITALI, MAHARASHTRA',
    masterId: 11129,
  },
  {
    type: 'cityName',
    value: 'TENALI, ANDHRA PRADESH',
    masterId: 15472,
  },
  {
    type: 'cityName',
    value: 'KANCHIPURAM, TAMIL NADU',
    masterId: 12470,
  },
  {
    type: 'cityName',
    value: 'CHUNGAJAN, ASSAM',
    masterId: 18927,
  },
  {
    type: 'cityName',
    value: 'CHHAJLI, PUNJAB',
    masterId: 11053,
  },
  {
    type: 'cityName',
    value: 'CHINNAGANJAM, ANDHRA PRADESH',
    masterId: 11109,
  },
  {
    type: 'cityName',
    value: 'CHHATNA, WEST BENGAL',
    masterId: 11062,
  },
  {
    type: 'cityName',
    value: 'CHAMPAJHAR, ORISSA',
    masterId: 17510,
  },
  {
    type: 'cityName',
    value: 'CHAMARAJ, GUJARAT',
    masterId: 10971,
  },
  {
    type: 'cityName',
    value: 'CHARAMULA KUSUM, CHHATTISGARH',
    masterId: 11010,
  },
  {
    type: 'cityName',
    value: 'CHIRAWA, RAJASTHAN',
    masterId: 11122,
  },
  {
    type: 'cityName',
    value: 'CHIKSUGAR, KARNATAKA',
    masterId: 18051,
  },
  {
    type: 'cityName',
    value: 'CHAK PAKHHEWALA, PUNJAB',
    masterId: 17384,
  },
  {
    type: 'cityName',
    value: 'CHAUTH KA BRWRA, RAJASTHAN',
    masterId: 11026,
  },
  {
    type: 'cityName',
    value: 'CHARKHI DADRI, HARYANA',
    masterId: 11012,
  },
  {
    type: 'cityName',
    value: 'CHAKDAYALA, JAMMU AND KASHMIR',
    masterId: 10956,
  },
  {
    type: 'cityName',
    value: 'CHOKI SORATH, GUJARAT',
    masterId: 19088,
  },
  {
    type: 'cityName',
    value: 'CHOWKA GHAT BRIDGE, UTTAR PRADESH',
    masterId: 16590,
  },
  {
    type: 'cityName',
    value: 'CHAKAND, BIHAR',
    masterId: 18833,
  },
  {
    type: 'cityName',
    value: 'CHIKHLI, MAHARASHTRA',
    masterId: 11079,
  },
  {
    type: 'cityName',
    value: 'CHALAKUDY, KERALA',
    masterId: 10965,
  },
  {
    type: 'cityName',
    value: 'CHARKHEDA KHURD, MADHYA PRADESH',
    masterId: 17863,
  },
  {
    type: 'cityName',
    value: 'CHAK BANWALA, PUNJAB',
    masterId: 17385,
  },
  {
    type: 'cityName',
    value: 'CHAK KALI LAIT, UTTAR PRADESH',
    masterId: 16608,
  },
  {
    type: 'cityName',
    value: 'CHAUKIMAN, PUNJAB',
    masterId: 17382,
  },
  {
    type: 'cityName',
    value: 'CHOTKI MASAURHI, BIHAR',
    masterId: 18768,
  },
  {
    type: 'cityName',
    value: 'GAREPALLI, TELANGANA',
    masterId: 16816,
  },
  {
    type: 'cityName',
    value: 'CHIKNI ROAD, MAHARASHTRA',
    masterId: 11083,
  },
  {
    type: 'cityName',
    value: 'HIRANA, MADHYA PRADESH',
    masterId: 11999,
  },
  {
    type: 'cityName',
    value: 'CHIKODI, KARNATAKA',
    masterId: 11084,
  },
  {
    type: 'cityName',
    value: 'CHAKMAKRAND, BIHAR',
    masterId: 18773,
  },
  {
    type: 'cityName',
    value: 'CHAKSU, RAJASTHAN',
    masterId: 10961,
  },
  {
    type: 'cityName',
    value: 'CHAK SAFAURA, UTTAR PRADESH',
    masterId: 16607,
  },
  {
    type: 'cityName',
    value: 'KARWI, UTTAR PRADESH',
    masterId: 12575,
  },
  {
    type: 'cityName',
    value: 'CHAKULIA, WEST BENGAL',
    masterId: 10962,
  },
  {
    type: 'cityName',
    value: 'CHERUKUVADA, ANDHRA PRADESH',
    masterId: 19037,
  },
  {
    type: 'cityName',
    value: 'CHIKKANDAWADI, KARNATAKA',
    masterId: 18052,
  },
  {
    type: 'cityName',
    value: 'CHALKHOWA, ASSAM',
    masterId: 18933,
  },
  {
    type: 'cityName',
    value: 'CHAKUR, MAHARASHTRA',
    masterId: 10963,
  },
  {
    type: 'cityName',
    value: 'CANTT, UTTAR PRADESH',
    masterId: 16247,
  },
  {
    type: 'cityName',
    value: 'CHALALA, GUJARAT',
    masterId: 10966,
  },
  {
    type: 'cityName',
    value: 'CHALSA, WEST BENGAL',
    masterId: 16226,
  },
  {
    type: 'cityName',
    value: 'CHANDLODIYA, GUJARAT',
    masterId: 18497,
  },
  {
    type: 'cityName',
    value: 'CHILIKIDARA, ORISSA',
    masterId: 11091,
  },
  {
    type: 'cityName',
    value: 'CHINTALPALLI, ANDHRA PRADESH',
    masterId: 11114,
  },
  {
    type: 'cityName',
    value: 'CHHULHA, MADHYA PRADESH',
    masterId: 11069,
  },
  {
    type: 'cityName',
    value: 'KAHALGAON, BIHAR',
    masterId: 12340,
  },
  {
    type: 'cityName',
    value: 'CHALAGERI, KARNATAKA',
    masterId: 10964,
  },
  {
    type: 'cityName',
    value: 'COLONELGANJ, UTTAR PRADESH',
    masterId: 11164,
  },
  {
    type: 'cityName',
    value: 'CHILIKA, ORISSA',
    masterId: 11090,
  },
  {
    type: 'cityName',
    value: 'CHUCHELA KALAN, UTTAR PRADESH',
    masterId: 16589,
  },
  {
    type: 'cityName',
    value: 'KOLLIDAM, TAMIL NADU',
    masterId: 16958,
  },
  {
    type: 'cityName',
    value: 'CHILO, RAJASTHAN',
    masterId: 11094,
  },
  {
    type: 'cityName',
    value: 'CASTLEROCK, KARNATAKA',
    masterId: 10940,
  },
  {
    type: 'cityName',
    value: 'KOZHIKODE, KERALA',
    masterId: 12947,
  },
  {
    type: 'cityName',
    value: 'CHILAKALAPUDI, ANDHRA PRADESH',
    masterId: 11085,
  },
  {
    type: 'cityName',
    value: 'CHILUVURU, ANDHRA PRADESH',
    masterId: 11098,
  },
  {
    type: 'cityName',
    value: 'CHIRALA, ANDHRA PRADESH',
    masterId: 11120,
  },
  {
    type: 'cityName',
    value: 'CAMPIRGANJ, UTTAR PRADESH',
    masterId: 16610,
  },
  {
    type: 'cityName',
    value: 'CINNAMARA, ASSAM',
    masterId: 11159,
  },
  {
    type: 'cityName',
    value: 'CHEMANCHERI, KERALA',
    masterId: 17933,
  },
  {
    type: 'cityName',
    value: 'AGURU, ANDHRA PRADESH',
    masterId: 10050,
  },
  {
    type: 'cityName',
    value: 'CHIKKAMAGALURU, KARNATAKA',
    masterId: 18053,
  },
  {
    type: 'cityName',
    value: 'CHAMARAJAPURA, KARNATAKA',
    masterId: 18056,
  },
  {
    type: 'cityName',
    value: 'CHAMARAJANAGAR, KARNATAKA',
    masterId: 10972,
  },
  {
    type: 'cityName',
    value: 'CHAMROLA, UTTAR PRADESH',
    masterId: 16605,
  },
  {
    type: 'cityName',
    value: 'CHAU MAHLA, RAJASTHAN',
    masterId: 11021,
  },
  {
    type: 'cityName',
    value: 'CHIMALPAHAD, ANDHRA PRADESH',
    masterId: 11100,
  },
  {
    type: 'cityName',
    value: 'LAKSHMIPUR, WEST BENGAL',
    masterId: 13094,
  },
  {
    type: 'cityName',
    value: 'CHINTAMANI, KARNATAKA',
    masterId: 18049,
  },
  {
    type: 'cityName',
    value: 'CHALAMA, ANDHRA PRADESH',
    masterId: 10967,
  },
  {
    type: 'cityName',
    value: 'CHITTORGARH, RAJASTHAN',
    masterId: 11139,
  },
  {
    type: 'cityName',
    value: 'KANPUR, UTTAR PRADESH',
    masterId: 12509,
  },
  {
    type: 'cityName',
    value: 'CHANDARI, UTTAR PRADESH',
    masterId: 21036,
  },
  {
    type: 'cityName',
    value: 'CHINCHOLI, KARNATAKA',
    masterId: 11102,
  },
  {
    type: 'cityName',
    value: 'CHANDUR, MAHARASHTRA',
    masterId: 10997,
  },
  {
    type: 'cityName',
    value: 'CHANDAN, BIHAR',
    masterId: 20756,
  },
  {
    type: 'cityName',
    value: 'CHIANKI, JHARKHAND',
    masterId: 18230,
  },
  {
    type: 'cityName',
    value: 'CHENGANNUR, KERALA',
    masterId: 11035,
  },
  {
    type: 'cityName',
    value: 'CHAUNRAH, UTTAR PRADESH',
    masterId: 16598,
  },
  {
    type: 'cityName',
    value: 'CHANDIL, JHARKHAND',
    masterId: 10984,
  },
  {
    type: 'cityName',
    value: 'CHANDER NAGAR, UTTAR PRADESH',
    masterId: 16603,
  },
  {
    type: 'cityName',
    value: 'CHANDAK, UTTAR PRADESH',
    masterId: 10975,
  },
  {
    type: 'cityName',
    value: 'CHANDAWAL, RAJASTHAN',
    masterId: 10980,
  },
  {
    type: 'cityName',
    value: 'CHANDANPAHARI, JHARKHAND',
    masterId: 18192,
  },
  {
    type: 'cityName',
    value: 'BHADWA, JHARKHAND',
    masterId: 10672,
  },
  {
    type: 'cityName',
    value: 'CHANDAR, GOA',
    masterId: 16164,
  },
  {
    type: 'cityName',
    value: 'HOOGHLY, WEST BENGAL',
    masterId: 12022,
  },
  {
    type: 'cityName',
    value: 'CHANDAUNA HALT, BIHAR',
    masterId: 20774,
  },
  {
    type: 'cityName',
    value: 'COOCH BEHAR, WEST BENGAL',
    masterId: 16158,
  },
  {
    type: 'cityName',
    value: 'CHHOTA GUDHA, RAJASTHAN',
    masterId: 17274,
  },
  {
    type: 'cityName',
    value: 'CHITROD, GUJARAT',
    masterId: 18489,
  },
  {
    type: 'cityName',
    value: 'COROMANDEL, KARNATAKA',
    masterId: 18047,
  },
  {
    type: 'cityName',
    value: 'CHOMUN, RAJASTHAN',
    masterId: 17195,
  },
  {
    type: 'cityName',
    value: 'CHHOTI ODAI, RAJASTHAN',
    masterId: 11068,
  },
  {
    type: 'cityName',
    value: 'CHIRAILA, BIHAR',
    masterId: 19083,
  },
  {
    type: 'cityName',
    value: 'CHINCHPADA, MAHARASHTRA',
    masterId: 11103,
  },
  {
    type: 'cityName',
    value: 'CHHIPADOHAR, JHARKHAND',
    masterId: 11065,
  },
  {
    type: 'cityName',
    value: 'CHANDIPOSI, ORISSA',
    masterId: 17509,
  },
  {
    type: 'cityName',
    value: 'CHAMPA, CHHATTISGARH',
    masterId: 10973,
  },
  {
    type: 'cityName',
    value: 'COOPERS HALT, WEST BENGAL',
    masterId: 21200,
  },
  {
    type: 'cityName',
    value: 'KAPTANGANJ, UTTAR PRADESH',
    masterId: 12522,
  },
  {
    type: 'cityName',
    value: 'ROHA, ASSAM',
    masterId: 14746,
  },
  {
    type: 'cityName',
    value: 'CHAKARLAPALLI, ANDHRA PRADESH',
    masterId: 10953,
  },
  {
    type: 'cityName',
    value: 'CHINPAI, WEST BENGAL',
    masterId: 16160,
  },
  {
    type: 'cityName',
    value: 'KHAKHARIYA, GUJARAT',
    masterId: 12690,
  },
  {
    type: 'cityName',
    value: 'SUMITRAPURAM, ANDHRA PRADESH',
    masterId: 15336,
  },
  {
    type: 'cityName',
    value: 'CHAPRAKATA, ASSAM',
    masterId: 18931,
  },
  {
    type: 'cityName',
    value: 'CHANDPUR, UTTAR PRADESH',
    masterId: 10988,
  },
  {
    type: 'cityName',
    value: 'CHANNAPATNA, KARNATAKA',
    masterId: 11004,
  },
  {
    type: 'cityName',
    value: 'OBRA, UTTAR PRADESH',
    masterId: 14068,
  },
  {
    type: 'cityName',
    value: 'CHERUKARA, KERALA',
    masterId: 11045,
  },
  {
    type: 'cityName',
    value: 'CHIRAKKAL, KERALA',
    masterId: 17954,
  },
  {
    type: 'cityName',
    value: 'CHAMPAPUKUR, WEST BENGAL',
    masterId: 21163,
  },
  {
    type: 'cityName',
    value: 'CAPPER QUARRY, TAMIL NADU',
    masterId: 16997,
  },
  {
    type: 'cityName',
    value: 'CHERAGRAM BH., WEST BENGAL',
    masterId: 21218,
  },
  {
    type: 'cityName',
    value: 'CHARKHARI, UTTAR PRADESH',
    masterId: 16770,
  },
  {
    type: 'cityName',
    value: 'CHITTARANJAN, WEST BENGAL',
    masterId: 11137,
  },
  {
    type: 'cityName',
    value: 'CHARKHERA, MADHYA PRADESH',
    masterId: 17862,
  },
  {
    type: 'cityName',
    value: 'CHAURAKHERI, RAJASTHAN',
    masterId: 11024,
  },
  {
    type: 'cityName',
    value: 'CHORAL, MADHYA PRADESH',
    masterId: 11149,
  },
  {
    type: 'cityName',
    value: 'CHAUTARA, ASSAM',
    masterId: 16162,
  },
  {
    type: 'cityName',
    value: 'CHANDRAPURA, JHARKHAND',
    masterId: 10994,
  },
  {
    type: 'cityName',
    value: 'CHARPOKHARI, BIHAR',
    masterId: 18771,
  },
  {
    type: 'cityName',
    value: 'BARARI, BIHAR',
    masterId: 10511,
  },
  {
    type: 'cityName',
    value: 'CHUDAWA, MAHARASHTRA',
    masterId: 11156,
  },
  {
    type: 'cityName',
    value: 'CHUREB, UTTAR PRADESH',
    masterId: 16588,
  },
  {
    type: 'cityName',
    value: 'CHIRAUD, HARYANA',
    masterId: 11121,
  },
  {
    type: 'cityName',
    value: 'CARRON, WEST BENGAL',
    masterId: 16165,
  },
  {
    type: 'cityName',
    value: 'CHIRAYINKEEZHU, KERALA',
    masterId: 11123,
  },
  {
    type: 'cityName',
    value: 'NYAYAPUR, BIHAR',
    masterId: 14065,
  },
  {
    type: 'cityName',
    value: 'CANDOLIM, GOA',
    masterId: 18572,
  },
  {
    type: 'cityName',
    value: 'CHANASMA, GUJARAT',
    masterId: 10974,
  },
  {
    type: 'cityName',
    value: 'CHALISGAON, MAHARASHTRA',
    masterId: 10968,
  },
  {
    type: 'cityName',
    value: 'CHAK SIKANDER, BIHAR',
    masterId: 18834,
  },
  {
    type: 'cityName',
    value: 'CHITTAPUR, KARNATAKA',
    masterId: 11136,
  },
  {
    type: 'cityName',
    value: 'CHITRADURGA, KARNATAKA',
    masterId: 11134,
  },
  {
    type: 'cityName',
    value: 'CUTTACK, ORISSA',
    masterId: 11174,
  },
  {
    type: 'cityName',
    value: 'CHHOTA UDEPUR, GUJARAT',
    masterId: 18495,
  },
  {
    type: 'cityName',
    value: 'CHITGIDDA, ANDHRA PRADESH',
    masterId: 11131,
  },
  {
    type: 'cityName',
    value: 'CHITAHRA, MADHYA PRADESH',
    masterId: 17859,
  },
  {
    type: 'cityName',
    value: 'CHHATAINI, MADHYA PRADESH',
    masterId: 16592,
  },
  {
    type: 'cityName',
    value: 'BARAWARA, RAJASTHAN',
    masterId: 10513,
  },
  {
    type: 'cityName',
    value: 'CHHIT MAKANDPUR, BIHAR',
    masterId: 18769,
  },
  {
    type: 'cityName',
    value: 'KANADUKATHAN, TAMIL NADU',
    masterId: 12460,
  },
  {
    type: 'cityName',
    value: 'CHITTOOR, ANDHRA PRADESH',
    masterId: 11138,
  },
  {
    type: 'cityName',
    value: 'KOTTAMKARA, KERALA',
    masterId: 12932,
  },
  {
    type: 'cityName',
    value: 'CHINTA PARRU HALT, ANDHRA PRADESH',
    masterId: 20729,
  },
  {
    type: 'cityName',
    value: 'CHETHAR, JHARKHAND',
    masterId: 17683,
  },
  {
    type: 'cityName',
    value: 'CHATRA, WEST BENGAL',
    masterId: 11018,
  },
  {
    type: 'cityName',
    value: 'CHITRAVAD, GUJARAT',
    masterId: 18490,
  },
  {
    type: 'cityName',
    value: 'CHITTERI, TAMIL NADU',
    masterId: 17049,
  },
  {
    type: 'cityName',
    value: 'CHITRASANI, GUJARAT',
    masterId: 18491,
  },
  {
    type: 'cityName',
    value: 'CHITRAPUR (H), KARNATAKA',
    masterId: 11135,
  },
  {
    type: 'cityName',
    value: 'CHHINTANWALA, PUNJAB',
    masterId: 17380,
  },
  {
    type: 'cityName',
    value: 'CHITYALA, ANDHRA PRADESH',
    masterId: 11143,
  },
  {
    type: 'cityName',
    value: 'KUNKUDUMELLI, ANDHRA PRADESH',
    masterId: 13026,
  },
  {
    type: 'cityName',
    value: 'CHOUPALE, MAHARASHTRA',
    masterId: 11154,
  },
  {
    type: 'cityName',
    value: 'HARHUNA, UTTAR PRADESH',
    masterId: 11929,
  },
  {
    type: 'cityName',
    value: 'CUDDALORE, TAMIL NADU',
    masterId: 11170,
  },
  {
    type: 'cityName',
    value: 'CHURU, RAJASTHAN',
    masterId: 11158,
  },
  {
    type: 'cityName',
    value: 'RATANPUR, BIHAR',
    masterId: 14685,
  },
  {
    type: 'cityName',
    value: 'CAUVERY, TAMIL NADU',
    masterId: 17958,
  },
  {
    type: 'cityName',
    value: 'CAVALRY BARRCKS, ANDHRA PRADESH',
    masterId: 10941,
  },
  {
    type: 'cityName',
    value: 'CHAVADIPALAYAM, TAMIL NADU',
    masterId: 16996,
  },
  {
    type: 'cityName',
    value: 'KOVILPATTI, TAMIL NADU',
    masterId: 12941,
  },
  {
    type: 'cityName',
    value: 'GADU, GUJARAT',
    masterId: 11594,
  },
  {
    type: 'cityName',
    value: 'CHERUVU MADHAVARAM, ANDHRA PRADESH',
    masterId: 19036,
  },
  {
    type: 'cityName',
    value: 'CHAINWA, BIHAR',
    masterId: 10950,
  },
  {
    type: 'cityName',
    value: 'CHHINDWARA, MADHYA PRADESH',
    masterId: 11064,
  },
  {
    type: 'cityName',
    value: 'CHUHRIWALA DHANNA, PUNJAB',
    masterId: 17428,
  },
  {
    type: 'cityName',
    value: 'CHONDHI, MAHARASHTRA',
    masterId: 17743,
  },
  {
    type: 'cityName',
    value: 'CHOWRIGACHA, WEST BENGAL',
    masterId: 16159,
  },
  {
    type: 'cityName',
    value: 'CHARAWAN, PUNJAB',
    masterId: 16600,
  },
  {
    type: 'cityName',
    value: 'CHOWARA, KERALA',
    masterId: 17953,
  },
  {
    type: 'cityName',
    value: 'CHANOD, GUJARAT',
    masterId: 11006,
  },
  {
    type: 'cityName',
    value: 'CHANDSARA, UTTAR PRADESH',
    masterId: 16602,
  },
  {
    type: 'cityName',
    value: 'CHHAYAPURI, GUJARAT',
    masterId: 18496,
  },
  {
    type: 'cityName',
    value: 'CHERIYANAD, KERALA',
    masterId: 11041,
  },
  {
    type: 'cityName',
    value: 'CHIPYANA BUZURG, UTTAR PRADESH',
    masterId: 21021,
  },
  {
    type: 'cityName',
    value: 'DEULA, WEST BENGAL',
    masterId: 21064,
  },
  {
    type: 'cityName',
    value: 'DATIA, MADHYA PRADESH',
    masterId: 11250,
  },
  {
    type: 'cityName',
    value: 'DHARMABAD, MAHARASHTRA',
    masterId: 11369,
  },
  {
    type: 'cityName',
    value: 'DHABAN, RAJASTHAN',
    masterId: 11326,
  },
  {
    type: 'cityName',
    value: 'DAHINSARA JN, GUJARAT',
    masterId: 20816,
  },
  {
    type: 'cityName',
    value: 'DEVARAGUDDA, KARNATAKA',
    masterId: 11310,
  },
  {
    type: 'cityName',
    value: 'DAHEGAON, MAHARASHTRA',
    masterId: 16818,
  },
  {
    type: 'cityName',
    value: 'DHANG, BIHAR',
    masterId: 20767,
  },
  {
    type: 'cityName',
    value: 'DAROJI, KARNATAKA',
    masterId: 11237,
  },
  {
    type: 'cityName',
    value: 'DHAMORA, UTTAR PRADESH',
    masterId: 11339,
  },
  {
    type: 'cityName',
    value: 'DHANETA, UTTAR PRADESH',
    masterId: 11347,
  },
  {
    type: 'cityName',
    value: 'KATGHORA, CHHATTISGARH',
    masterId: 12594,
  },
  {
    type: 'cityName',
    value: 'DAGMAGPUR, UTTAR PRADESH',
    masterId: 16586,
  },
  {
    type: 'cityName',
    value: 'DAUD KHAN, UTTAR PRADESH',
    masterId: 16582,
  },
  {
    type: 'cityName',
    value: 'DANWAR, UTTAR PRADESH',
    masterId: 11228,
  },
  {
    type: 'cityName',
    value: 'DARA, RAJASTHAN',
    masterId: 11232,
  },
  {
    type: 'cityName',
    value: 'DHARI, GUJARAT',
    masterId: 11366,
  },
  {
    type: 'cityName',
    value: 'DHASA, GUJARAT',
    masterId: 11378,
  },
  {
    type: 'cityName',
    value: 'DAGRU, PUNJAB',
    masterId: 17378,
  },
  {
    type: 'cityName',
    value: 'DEVALGAON AUCHR, MAHARASHTRA',
    masterId: 11306,
  },
  {
    type: 'cityName',
    value: 'JALALAB, PUNJAB',
    masterId: 17379,
  },
  {
    type: 'cityName',
    value: 'JALANDHER, PUNJAB',
    masterId: 19137,
  },
  {
    type: 'cityName',
    value: 'DHANUVACHAPURAM, KERALA',
    masterId: 11356,
  },
  {
    type: 'cityName',
    value: 'AZADPUR, DELHI',
    masterId: 18591,
  },
  {
    type: 'cityName',
    value: 'DABHOI, GUJARAT',
    masterId: 18555,
  },
  {
    type: 'cityName',
    value: 'DABRA, MADHYA PRADESH',
    masterId: 11184,
  },
  {
    type: 'cityName',
    value: 'DHUBRI, ASSAM',
    masterId: 11406,
  },
  {
    type: 'cityName',
    value: 'DEOBAND, UTTAR PRADESH',
    masterId: 11280,
  },
  {
    type: 'cityName',
    value: 'DARBHANGA, BIHAR',
    masterId: 11234,
  },
  {
    type: 'cityName',
    value: 'DABLI RATHAN, RAJASTHAN',
    masterId: 11182,
  },
  {
    type: 'cityName',
    value: 'NAGAZIRA, MADHYA PRADESH',
    masterId: 13802,
  },
  {
    type: 'cityName',
    value: 'TADASIGATTA, KARNATAKA',
    masterId: 15376,
  },
  {
    type: 'cityName',
    value: 'DABLA, RAJASTHAN',
    masterId: 17194,
  },
  {
    type: 'cityName',
    value: 'DEVRABANDHAULI, BIHAR',
    masterId: 20773,
  },
  {
    type: 'cityName',
    value: 'DABOLIM, GOA',
    masterId: 18571,
  },
  {
    type: 'cityName',
    value: 'DHABLAN, PUNJAB',
    masterId: 17422,
  },
  {
    type: 'cityName',
    value: 'DERABABA NANAK, PUNJAB',
    masterId: 20945,
  },
  {
    type: 'cityName',
    value: 'DABHODA, GUJARAT',
    masterId: 18488,
  },
  {
    type: 'cityName',
    value: 'DEBIPUR, WEST BENGAL',
    masterId: 21073,
  },
  {
    type: 'cityName',
    value: 'DABHAURA, UTTAR PRADESH',
    masterId: 11178,
  },
  {
    type: 'cityName',
    value: 'DIBRUGARH, ASSAM',
    masterId: 11422,
  },
  {
    type: 'cityName',
    value: 'DABASAPETE, KARNATAKA',
    masterId: 18046,
  },
  {
    type: 'cityName',
    value: 'DAYA BASTI, DELHI',
    masterId: 18590,
  },
  {
    type: 'cityName',
    value: 'DAKSHIN BARASAT, WEST BENGAL',
    masterId: 21249,
  },
  {
    type: 'cityName',
    value: 'DODDABALLAPURA, KARNATAKA',
    masterId: 11448,
  },
  {
    type: 'cityName',
    value: 'DABILPUR, ANDHRA PRADESH',
    masterId: 11179,
  },
  {
    type: 'cityName',
    value: 'DUBIA, ASSAM',
    masterId: 16564,
  },
  {
    type: 'cityName',
    value: 'DIGBOI, ASSAM',
    masterId: 11425,
  },
  {
    type: 'cityName',
    value: 'DHING BAZAR, ASSAM',
    masterId: 18921,
  },
  {
    type: 'cityName',
    value: 'MAGUDANCHAVADI, TAMIL NADU',
    masterId: 16949,
  },
  {
    type: 'cityName',
    value: 'DAMCHARA, ASSAM',
    masterId: 11215,
  },
  {
    type: 'cityName',
    value: 'DHANDHUKA, GUJARAT',
    masterId: 11345,
  },
  {
    type: 'cityName',
    value: 'DAL CHAPRA, BIHAR',
    masterId: 16585,
  },
  {
    type: 'cityName',
    value: 'DHANICHHA, BIHAR',
    masterId: 18762,
  },
  {
    type: 'cityName',
    value: 'DAUND, MAHARASHTRA',
    masterId: 11254,
  },
  {
    type: 'cityName',
    value: 'DURAUNDHA, BIHAR',
    masterId: 11495,
  },
  {
    type: 'cityName',
    value: 'KHALARI, MADHYA PRADESH',
    masterId: 12693,
  },
  {
    type: 'cityName',
    value: 'DOMVIVALI CONTROL CA, MAHARASHTRA',
    masterId: 20905,
  },
  {
    type: 'cityName',
    value: 'DHONDHA DIH, UTTAR PRADESH ',
    masterId: 16571,
  },
  {
    type: 'cityName',
    value: 'DONDAICHA, MAHARASHTRA',
    masterId: 11458,
  },
  {
    type: 'cityName',
    value: 'DUGDA, JHARKHAND',
    masterId: 20857,
  },
  {
    type: 'cityName',
    value: 'DEEDARGANJ, BIHAR',
    masterId: 20753,
  },
  {
    type: 'cityName',
    value: 'DHINDSA, PUNJAB',
    masterId: 17374,
  },
  {
    type: 'cityName',
    value: 'LUDHIANA, PUNJAB',
    masterId: 13171,
  },
  {
    type: 'cityName',
    value: 'DAMDIM, WEST BENGAL',
    masterId: 16225,
  },
  {
    type: 'cityName',
    value: 'DARIMETA, MAHARASHTRA',
    masterId: 17854,
  },
  {
    type: 'cityName',
    value: 'DEHRADUN, UTTARAKHAND',
    masterId: 11272,
  },
  {
    type: 'cityName',
    value: 'DUDHAUNDA, UTTAR PRADESH',
    masterId: 16562,
  },
  {
    type: 'cityName',
    value: 'DUDHNOI, ASSAM',
    masterId: 18972,
  },
  {
    type: 'cityName',
    value: 'DAUDPUR, BIHAR',
    masterId: 11252,
  },
  {
    type: 'cityName',
    value: 'DADHDEVI, RAJASTHAN',
    masterId: 17193,
  },
  {
    type: 'cityName',
    value: 'DUDHWA, UTTAR PRADESH',
    masterId: 18326,
  },
  {
    type: 'cityName',
    value: 'DHAMDHAMA, JHARKHAND',
    masterId: 18922,
  },
  {
    type: 'cityName',
    value: 'DUDWINDI, PUNJAB',
    masterId: 17370,
  },
  {
    type: 'cityName',
    value: 'DEBAGRAM, WEST BENGAL',
    masterId: 11264,
  },
  {
    type: 'cityName',
    value: 'DEEG, RAJASTHAN',
    masterId: 11267,
  },
  {
    type: 'cityName',
    value: 'DELANG, ORISSA',
    masterId: 11277,
  },
  {
    type: 'cityName',
    value: 'DEHU ROAD, MAHARASHTRA',
    masterId: 11275,
  },
  {
    type: 'cityName',
    value: 'ELURU, ANDHRA PRADESH',
    masterId: 11529,
  },
  {
    type: 'cityName',
    value: 'DEWRAKOT, UTTAR PRADESH',
    masterId: 16577,
  },
  {
    type: 'cityName',
    value: 'DEMU, JHARKHAND',
    masterId: 18229,
  },
  {
    type: 'cityName',
    value: 'DEOKALI, UTTAR PRADESH',
    masterId: 16580,
  },
  {
    type: 'cityName',
    value: 'DIYODAR, GUJARAT',
    masterId: 11446,
  },
  {
    type: 'cityName',
    value: 'DEORIA, UTTAR PRADESH',
    masterId: 11289,
  },
  {
    type: 'cityName',
    value: 'DEPALSAR, RAJASTHAN',
    masterId: 17273,
  },
  {
    type: 'cityName',
    value: 'DADRI, UTTAR PRADESH',
    masterId: 11188,
  },
  {
    type: 'cityName',
    value: 'DESARI, BIHAR',
    masterId: 11297,
  },
  {
    type: 'cityName',
    value: 'DET, RAJASTHAN',
    masterId: 17189,
  },
  {
    type: 'cityName',
    value: 'DEVARAI, KARNATAKA',
    masterId: 18041,
  },
  {
    type: 'cityName',
    value: 'DEWALGAON, MAHARASHTRA',
    masterId: 17678,
  },
  {
    type: 'cityName',
    value: 'DEOGAN, ORISSA',
    masterId: 17505,
  },
  {
    type: 'cityName',
    value: 'DINDIGUL, TAMIL NADU',
    masterId: 11436,
  },
  {
    type: 'cityName',
    value: 'DIGHWARA, BIHAR',
    masterId: 11427,
  },
  {
    type: 'cityName',
    value: 'DINDU G PURAM H, ANDHRA PRADESH',
    masterId: 18991,
  },
  {
    type: 'cityName',
    value: 'DONGRI BUZURG, MAHARASHTRA',
    masterId: 17673,
  },
  {
    type: 'cityName',
    value: 'DANGIDHAR, MADHYA PRADESH',
    masterId: 17856,
  },
  {
    type: 'cityName',
    value: 'DURGADA, ANDHRA PRADESH',
    masterId: 11497,
  },
  {
    type: 'cityName',
    value: 'DHAGARIA, WEST BENGAL',
    masterId: 21120,
  },
  {
    type: 'cityName',
    value: 'DONGARGARH, CHHATTISGARH',
    masterId: 11460,
  },
  {
    type: 'cityName',
    value: 'DIGHA, WEST BENGAL',
    masterId: 11426,
  },
  {
    type: 'cityName',
    value: 'DIGHAL, HARYANA',
    masterId: 18327,
  },
  {
    type: 'cityName',
    value: 'DEOGHAR, JHARKHAND',
    masterId: 11281,
  },
  {
    type: 'cityName',
    value: 'DUNGRI, GUJARAT',
    masterId: 11493,
  },
  {
    type: 'cityName',
    value: 'DUNGAR, GUJARAT',
    masterId: 11490,
  },
  {
    type: 'cityName',
    value: 'DHULIYAN, WEST BENGAL',
    masterId: 11411,
  },
  {
    type: 'cityName',
    value: 'DONGARGAON, MADHYA PRADESH',
    masterId: 18617,
  },
  {
    type: 'cityName',
    value: 'DURGANAGAR, WEST BENGAL',
    masterId: 21148,
  },
  {
    type: 'cityName',
    value: 'DURGAUTI, BIHAR',
    masterId: 11499,
  },
  {
    type: 'cityName',
    value: 'DURGAPURI, MADHYA PRADESH',
    masterId: 19123,
  },
  {
    type: 'cityName',
    value: 'DHENGLI PP GOAN, MAHARASHTRA',
    masterId: 11385,
  },
  {
    type: 'cityName',
    value: 'DUGDOL, GUJARAT',
    masterId: 20794,
  },
  {
    type: 'cityName',
    value: 'DURGAPUR, WEST BENGAL',
    masterId: 11498,
  },
  {
    type: 'cityName',
    value: 'DAGORI, CHHATTISGARH',
    masterId: 11192,
  },
  {
    type: 'cityName',
    value: 'RANIGAON, MAHARASHTRA',
    masterId: 14661,
  },
  {
    type: 'cityName',
    value: 'DIGARU, ASSAM',
    masterId: 11424,
  },
  {
    type: 'cityName',
    value: 'DHIGAWARA, RAJASTHAN',
    masterId: 11387,
  },
  {
    type: 'cityName',
    value: 'DAGAON, ASSAM',
    masterId: 18925,
  },
  {
    type: 'cityName',
    value: 'DIGHORI, MAHARASHTRA',
    masterId: 17675,
  },
  {
    type: 'cityName',
    value: 'DAINA, UTTAR PRADESH',
    masterId: 11198,
  },
  {
    type: 'cityName',
    value: 'DAINHAT, WEST BENGAL',
    masterId: 16156,
  },
  {
    type: 'cityName',
    value: 'DAHOD, GUJARAT',
    masterId: 11197,
  },
  {
    type: 'cityName',
    value: 'DOBHI, UTTAR PRADESH',
    masterId: 11447,
  },
  {
    type: 'cityName',
    value: 'DHRANGADHRA, GUJARAT',
    masterId: 11404,
  },
  {
    type: 'cityName',
    value: 'DINHATA, WEST BENGAL',
    masterId: 11438,
  },
  {
    type: 'cityName',
    value: 'DHULE, MAHARASHTRA',
    masterId: 11409,
  },
  {
    type: 'cityName',
    value: 'DHINOJ, GUJARAT',
    masterId: 11390,
  },
  {
    type: 'cityName',
    value: 'DHAKURIA, HARYANA',
    masterId: 20822,
  },
  {
    type: 'cityName',
    value: 'DHODA KHEDI, HARYANA',
    masterId: 18329,
  },
  {
    type: 'cityName',
    value: 'DEVANAHALLI, KARNATAKA',
    masterId: 18043,
  },
  {
    type: 'cityName',
    value: 'DETHLI, GUJARAT',
    masterId: 19086,
  },
  {
    type: 'cityName',
    value: 'DADHAL INAAM, GUJARAT',
    masterId: 18487,
  },
  {
    type: 'cityName',
    value: 'DOLA MAZRA, HARYANA',
    masterId: 16567,
  },
  {
    type: 'cityName',
    value: 'DHANBAD, JHARKHAND',
    masterId: 11344,
  },
  {
    type: 'cityName',
    value: 'DHACHANA, BIHAR',
    masterId: 18764,
  },
  {
    type: 'cityName',
    value: 'DHINDA, RAJASTHAN',
    masterId: 11389,
  },
  {
    type: 'cityName',
    value: 'DHONE, ANDHRA PRADESH',
    masterId: 11401,
  },
  {
    type: 'cityName',
    value: 'DHOLPUR, RAJASTHAN',
    masterId: 11399,
  },
  {
    type: 'cityName',
    value: 'HING KI MANDI, RAJASTHAN',
    masterId: 16756,
  },
  {
    type: 'cityName',
    value: 'DICHPALLY, TELANGANA',
    masterId: 16833,
  },
  {
    type: 'cityName',
    value: 'DAHAPARA DHAM, WEST BENGAL',
    masterId: 16157,
  },
  {
    type: 'cityName',
    value: 'DAPPAR, PUNJAB',
    masterId: 11231,
  },
  {
    type: 'cityName',
    value: 'DHARAKHOH, MADHYA PRADESH',
    masterId: 17852,
  },
  {
    type: 'cityName',
    value: 'BARODA, RAJASTHAN',
    masterId: 10551,
  },
  {
    type: 'cityName',
    value: 'DHIRGANJ, UTTAR PRADESH',
    masterId: 16572,
  },
  {
    type: 'cityName',
    value: 'DHURANA, HARYANA',
    masterId: 18328,
  },
  {
    type: 'cityName',
    value: 'DHIRERA, RAJASTHAN',
    masterId: 11391,
  },
  {
    type: 'cityName',
    value: 'LALUK, ASSAM',
    masterId: 13105,
  },
  {
    type: 'cityName',
    value: 'DHAVALAS, MAHARASHTRA',
    masterId: 11382,
  },
  {
    type: 'cityName',
    value: 'DHAMARA GHAT, BIHAR',
    masterId: 11336,
  },
  {
    type: 'cityName',
    value: 'DHUBULIA, WEST BENGAL',
    masterId: 11407,
  },
  {
    type: 'cityName',
    value: 'DHARIWAL, PUNJAB',
    masterId: 11368,
  },
  {
    type: 'cityName',
    value: 'DANIAWAN, BIHAR',
    masterId: 18766,
  },
  {
    type: 'cityName',
    value: 'DHARODI, HARYANA',
    masterId: 18330,
  },
  {
    type: 'cityName',
    value: 'DIDWANA, RAJASTHAN',
    masterId: 11423,
  },
  {
    type: 'cityName',
    value: 'DIBAI, UTTAR PRADESH',
    masterId: 11419,
  },
  {
    type: 'cityName',
    value: 'DHOLI BHAL, GUJARAT ',
    masterId: 18482,
  },
  {
    type: 'cityName',
    value: 'DUGGIRALA, ANDHRA PRADESH',
    masterId: 11477,
  },
  {
    type: 'cityName',
    value: 'DHARUADIHI, ORISSA',
    masterId: 11374,
  },
  {
    type: 'cityName',
    value: 'DILAWARNAGAR, UTTAR PRADESH',
    masterId: 11431,
  },
  {
    type: 'cityName',
    value: 'DHANSIMLA, WEST BENGAL',
    masterId: 21121,
  },
  {
    type: 'cityName',
    value: 'DING, HARYANA',
    masterId: 11437,
  },
  {
    type: 'cityName',
    value: 'DIPORE, MAHARASHTRA',
    masterId: 17674,
  },
  {
    type: 'cityName',
    value: 'DIPA, ASSAM',
    masterId: 16149,
  },
  {
    type: 'cityName',
    value: 'DHANAPUR, ORISSA',
    masterId: 11342,
  },
  {
    type: 'cityName',
    value: 'DHUVA, GUJARAT',
    masterId: 11418,
  },
  {
    type: 'cityName',
    value: 'DOHRIGHAT, UTTAR PRADESH',
    masterId: 11451,
  },
  {
    type: 'cityName',
    value: 'DHING, ASSAM',
    masterId: 18973,
  },
  {
    type: 'cityName',
    value: 'THANE, MAHARASHTRA',
    masterId: 15497,
  },
  {
    type: 'cityName',
    value: 'DHILWAN, PUNJAB',
    masterId: 11388,
  },
  {
    type: 'cityName',
    value: 'DARJEELING, WEST BENGAL',
    masterId: 11236,
  },
  {
    type: 'cityName',
    value: 'DAOTUHAJA, ASSAM',
    masterId: 11229,
  },
  {
    type: 'cityName',
    value: 'DEEDARGANJ, UTTAR PRADESH',
    masterId: 16581,
  },
  {
    type: 'cityName',
    value: 'DULIAJAN, ASSAM',
    masterId: 11479,
  },
  {
    type: 'cityName',
    value: 'DEOJHAR, ORISSA',
    masterId: 16021,
  },
  {
    type: 'cityName',
    value: 'DHORAJI, GUJARAT',
    masterId: 11402,
  },
  {
    type: 'cityName',
    value: 'DOLAJI KA KHERA, RAJASTHAN',
    masterId: 17182,
  },
  {
    type: 'cityName',
    value: 'DODJALA H, KARNATAKA',
    masterId: 18040,
  },
  {
    type: 'cityName',
    value: 'BARABHITA, WEST BENGAL',
    masterId: 10500,
  },
  {
    type: 'cityName',
    value: 'DHURANI JWAS, BIHAR',
    masterId: 18760,
  },
  {
    type: 'cityName',
    value: 'DUNGURIPALI, ORISSA',
    masterId: 11494,
  },
  {
    type: 'cityName',
    value: 'DAKOR, GUJARAT',
    masterId: 11199,
  },
  {
    type: 'cityName',
    value: 'DANKUNI, WEST BENGAL',
    masterId: 21192,
  },
  {
    type: 'cityName',
    value: 'DAKSHIN BARI, RAJASTHAN',
    masterId: 20972,
  },
  {
    type: 'cityName',
    value: 'DAHAR KA BALAJI, RAJASTHAN',
    masterId: 17192,
  },
  {
    type: 'cityName',
    value: 'DEVARAKONDA, ANDHRA PRADESH',
    masterId: 11311,
  },
  {
    type: 'cityName',
    value: 'DONAKONDA, ANDHRA PRADESH',
    masterId: 11457,
  },
  {
    type: 'cityName',
    value: 'DANKAUR, UTTAR PRADESH',
    masterId: 11223,
  },
  {
    type: 'cityName',
    value: 'DAKSHIN DURGAPR, WEST BENGAL',
    masterId: 21202,
  },
  {
    type: 'cityName',
    value: 'DIHAKHO, ASSAM',
    masterId: 11430,
  },
  {
    type: 'cityName',
    value: 'DEKARGAON, ASSAM',
    masterId: 16022,
  },
  {
    type: 'cityName',
    value: 'DINKAR GRAM SIM, BIHAR',
    masterId: 11439,
  },
  {
    type: 'cityName',
    value: 'DHARMKUNDI, MADHYA PRADESH',
    masterId: 17851,
  },
  {
    type: 'cityName',
    value: 'DORNAKAL, ANDHRA PRADESH',
    masterId: 11466,
  },
  {
    type: 'cityName',
    value: 'DHEKIAJILI ROAD, ASSAM',
    masterId: 16023,
  },
  {
    type: 'cityName',
    value: 'BONDHUGUDA, ORISSA',
    masterId: 10885,
  },
  {
    type: 'cityName',
    value: 'DIKOM, ASSAM',
    masterId: 18919,
  },
  {
    type: 'cityName',
    value: 'KANEKALLU, KARNATAKA',
    masterId: 12480,
  },
  {
    type: 'cityName',
    value: 'KOTA, RAJASTHAN',
    masterId: 12899,
  },
  {
    type: 'cityName',
    value: 'KARAIKUDI, TAMIL NADU',
    masterId: 12526,
  },
  {
    type: 'cityName',
    value: 'DHUANKHERI, MADHYA PRADESH',
    masterId: 17849,
  },
  {
    type: 'cityName',
    value: 'DARREKASA, MAHARASHTRA',
    masterId: 11238,
  },
  {
    type: 'cityName',
    value: 'DHULKOT, HARYANA',
    masterId: 11412,
  },
  {
    type: 'cityName',
    value: 'DUMRI KHURD, MAHARASHTRA',
    masterId: 18185,
  },
  {
    type: 'cityName',
    value: 'DOKUR, TELANGANA',
    masterId: 16817,
  },
  {
    type: 'cityName',
    value: 'DHANAKWADA, GUJARAT',
    masterId: 18553,
  },
  {
    type: 'cityName',
    value: 'DOKWA, RAJASTHAN',
    masterId: 17271,
  },
  {
    type: 'cityName',
    value: 'DUDHWAKHARA, RAJASTHAN',
    masterId: 17181,
  },
  {
    type: 'cityName',
    value: 'GOVARDHANWADI, MAHARASHTRA',
    masterId: 11792,
  },
  {
    type: 'cityName',
    value: 'DALADI, GUJARAT',
    masterId: 11200,
  },
  {
    type: 'cityName',
    value: 'DOULTA, MADHYA PRADESH',
    masterId: 16566,
  },
  {
    type: 'cityName',
    value: 'TALESAMAN, MAHARASHTRA',
    masterId: 15407,
  },
  {
    type: 'cityName',
    value: 'DALMERA, RAJASTHAN',
    masterId: 11207,
  },
  {
    type: 'cityName',
    value: 'BANIKHEDI, MADHYA PRADESH',
    masterId: 10479,
  },
  {
    type: 'cityName',
    value: 'DALDALI, ASSAM',
    masterId: 16155,
  },
  {
    type: 'cityName',
    value: 'DALAN, BIHAR',
    masterId: 18832,
  },
  {
    type: 'cityName',
    value: 'DHALGAON, MAHARASHTRA',
    masterId: 11332,
  },
  {
    type: 'cityName',
    value: 'DHOLA, GUJARAT',
    masterId: 11396,
  },
  {
    type: 'cityName',
    value: 'DALKHOLA, WEST BENGAL',
    masterId: 11204,
  },
  {
    type: 'cityName',
    value: 'DHAULIMUHAN, ORISSA',
    masterId: 17504,
  },
  {
    type: 'cityName',
    value: 'DILDARNAGAR, UTTAR PRADESH',
    masterId: 11432,
  },
  {
    type: 'cityName',
    value: 'DALGAON, WEST BENGAL',
    masterId: 11203,
  },
  {
    type: 'cityName',
    value: 'DALPATPUR, UTTAR PRADESH',
    masterId: 11208,
  },
  {
    type: 'cityName',
    value: 'MAHAMMADPUR, WEST BENGAL',
    masterId: 13242,
  },
  {
    type: 'cityName',
    value: 'DULAKHA PATNA PH, ORISSA',
    masterId: 17503,
  },
  {
    type: 'cityName',
    value: 'DALELNAGAR, UTTAR PRADESH',
    masterId: 11201,
  },
  {
    type: 'cityName',
    value: 'DULLAHAPUR, UTTAR PRADESH',
    masterId: 11480,
  },
  {
    type: 'cityName',
    value: 'DILWA, BIHAR',
    masterId: 20750,
  },
  {
    type: 'cityName',
    value: 'DALIMGAON, WEST BENGAL',
    masterId: 16154,
  },
  {
    type: 'cityName',
    value: 'DHOLBAJA, MADHYA PRADESH ',
    masterId: 17850,
  },
  {
    type: 'cityName',
    value: 'DAMODAR, JHARKHAND ',
    masterId: 18188,
  },
  {
    type: 'cityName',
    value: 'DUMRI BIHAR, JHARKHAND',
    masterId: 16024,
  },
  {
    type: 'cityName',
    value: 'DHEMAJI, ASSAM',
    masterId: 11384,
  },
  {
    type: 'cityName',
    value: 'DHARMADOM, KERALA',
    masterId: 17952,
  },
  {
    type: 'cityName',
    value: 'DAMNAGAR, GUJARAT',
    masterId: 11217,
  },
  {
    type: 'cityName',
    value: 'DUMERTA, ORISSA',
    masterId: 17502,
  },
  {
    type: 'cityName',
    value: 'GORAKHPUR, UTTAR PRADESH',
    masterId: 11771,
  },
  {
    type: 'cityName',
    value: 'DHAMALGAON, ASSAM',
    masterId: 11333,
  },
  {
    type: 'cityName',
    value: 'MADHEPURA, BIHAR',
    masterId: 13208,
  },
  {
    type: 'cityName',
    value: 'DILMILI, CHHATTISGARH',
    masterId: 11433,
  },
  {
    type: 'cityName',
    value: 'DHARAMTUL, ASSAM',
    masterId: 11360,
  },
  {
    type: 'cityName',
    value: 'DUMURDAHADHAM, WEST BENGAL',
    masterId: 11486,
  },
  {
    type: 'cityName',
    value: 'DHARMAVARAM, ANDHRA PRADESH',
    masterId: 11372,
  },
  {
    type: 'cityName',
    value: 'DHAMANGAON, MAHARASHTRA',
    masterId: 11334,
  },
  {
    type: 'cityName',
    value: 'DAMANJODI, ORISSA',
    masterId: 11213,
  },
  {
    type: 'cityName',
    value: 'DAMOH, MADHYA PRADESH',
    masterId: 11218,
  },
  {
    type: 'cityName',
    value: 'SOLAN, HIMACHAL PRADESH',
    masterId: 15251,
  },
  {
    type: 'cityName',
    value: 'DHARAMPUR, UTTAR PRADESH',
    masterId: 19177,
  },
  {
    type: 'cityName',
    value: 'DHARMANAGAR, TRIPURA',
    masterId: 16790,
  },
  {
    type: 'cityName',
    value: 'DUMURIPUT, ORISSA',
    masterId: 11487,
  },
  {
    type: 'cityName',
    value: 'DUMRI, BIHAR',
    masterId: 11485,
  },
  {
    type: 'cityName',
    value: 'DHIMSIRI, UTTAR PRADESH',
    masterId: 21039,
  },
  {
    type: 'cityName',
    value: 'DIGUVAMETTA, ANDHRA PRADESH',
    masterId: 11429,
  },
  {
    type: 'cityName',
    value: 'DHAMUA, WEST BENGAL',
    masterId: 21260,
  },
  {
    type: 'cityName',
    value: 'DIMAPUR, NAGALAND',
    masterId: 11434,
  },
  {
    type: 'cityName',
    value: 'DALMAU, UTTAR PRADESH',
    masterId: 11206,
  },
  {
    type: 'cityName',
    value: 'DAMOY, MADHYA PRADESH',
    masterId: 17857,
  },
  {
    type: 'cityName',
    value: 'DHUMDANGI, WEST BENGAL',
    masterId: 16151,
  },
  {
    type: 'cityName',
    value: 'DHANARI, UTTAR PRADESH',
    masterId: 17272,
  },
  {
    type: 'cityName',
    value: 'DEGANA, RAJASTHAN',
    masterId: 11269,
  },
  {
    type: 'cityName',
    value: 'DANDUPUR, UTTAR PRADESH',
    masterId: 11221,
  },
  {
    type: 'cityName',
    value: 'DHONDI, MAHARASHTRA',
    masterId: 11400,
  },
  {
    type: 'cityName',
    value: 'DANDI MAL, ORISSA',
    masterId: 17506,
  },
  {
    type: 'cityName',
    value: 'DHAMNI, MAHARASHTRA',
    masterId: 17677,
  },
  {
    type: 'cityName',
    value: 'DANEA, JHARKHAND',
    masterId: 16025,
  },
  {
    type: 'cityName',
    value: 'DANGARI, ASSAM',
    masterId: 16584,
  },
  {
    type: 'cityName',
    value: 'DHANIAKHALI HALT, WEST BENGAL',
    masterId: 21216,
  },
  {
    type: 'cityName',
    value: 'DAUNDAJ GAON, MAHARASHTRA',
    masterId: 17742,
  },
  {
    type: 'cityName',
    value: 'JAIPUR, RAJASTHAN',
    masterId: 12126,
  },
  {
    type: 'cityName',
    value: 'DHENKANAL, ORISSA',
    masterId: 11386,
  },
  {
    type: 'cityName',
    value: 'DHANOLI, MAHARASHTRA',
    masterId: 16765,
  },
  {
    type: 'cityName',
    value: 'DHANMANDAL, ORISSA',
    masterId: 11351,
  },
  {
    type: 'cityName',
    value: 'DINANAGAR, PUNJAB',
    masterId: 11435,
  },
  {
    type: 'cityName',
    value: 'DHANPUR, GUJARAT',
    masterId: 16574,
  },
  {
    type: 'cityName',
    value: 'DANDKHORA, BIHAR',
    masterId: 18767,
  },
  {
    type: 'cityName',
    value: 'DHANDHERA, UTTARAKHAND',
    masterId: 16766,
  },
  {
    type: 'cityName',
    value: 'DHANAURI, BIHAR',
    masterId: 11343,
  },
  {
    type: 'cityName',
    value: 'DUNGARPUR, RAJASTHAN',
    masterId: 11492,
  },
  {
    type: 'cityName',
    value: 'DANTAN, WEST BENGAL',
    masterId: 11224,
  },
  {
    type: 'cityName',
    value: 'DALASANUR, KARNATAKA',
    masterId: 18045,
  },
  {
    type: 'cityName',
    value: 'DHANSURA, GUJARAT',
    masterId: 11355,
  },
  {
    type: 'cityName',
    value: 'DONKINAVALASA, ANDHRA PRADESH',
    masterId: 11461,
  },
  {
    type: 'cityName',
    value: 'DHANGARWA, GUJARAT',
    masterId: 16575,
  },
  {
    type: 'cityName',
    value: 'DANIYAWAN BZR H, BIHAR',
    masterId: 16026,
  },
  {
    type: 'cityName',
    value: 'RAJDHANWAR, JHARKHAND',
    masterId: 18213,
  },
  {
    type: 'cityName',
    value: 'DHANSU, HARYANA',
    masterId: 11354,
  },
  {
    type: 'cityName',
    value: 'DAUSA, RAJASTHAN',
    masterId: 11256,
  },
  {
    type: 'cityName',
    value: 'DORAHA, PUNJAB',
    masterId: 11464,
  },
  {
    type: 'cityName',
    value: 'DUNDLOD, RAJASTHAN',
    masterId: 11488,
  },
  {
    type: 'cityName',
    value: 'DAUN KALAN, PUNJAB',
    masterId: 17376,
  },
  {
    type: 'cityName',
    value: 'DHODAR, MADHYA PRADESH',
    masterId: 11392,
  },
  {
    type: 'cityName',
    value: 'DODH, PUNJAB',
    masterId: 17371,
  },
  {
    type: 'cityName',
    value: 'DEORI, MADHYA PRADESH',
    masterId: 11288,
  },
  {
    type: 'cityName',
    value: 'DHODRA MOHAR, MADHYA PRADESH',
    masterId: 11393,
  },
  {
    type: 'cityName',
    value: 'DEVGARH MADRIYA, RAJASTHAN',
    masterId: 17188,
  },
  {
    type: 'cityName',
    value: 'DOMOHANI, WEST BENGAL',
    masterId: 21105,
  },
  {
    type: 'cityName',
    value: 'DHOLKA, GUJARAT',
    masterId: 18481,
  },
  {
    type: 'cityName',
    value: 'DOKHRA, JHARKHAND',
    masterId: 18186,
  },
  {
    type: 'cityName',
    value: 'DUKHERI, HARYANA',
    masterId: 18372,
  },
  {
    type: 'cityName',
    value: 'DHOLI, BIHAR',
    masterId: 11398,
  },
  {
    type: 'cityName',
    value: 'DHUNDHARA, RAJASTHAN',
    masterId: 17185,
  },
  {
    type: 'cityName',
    value: 'DEO ROAD, BIHAR',
    masterId: 17375,
  },
  {
    type: 'cityName',
    value: 'DEHRI-ON-SONE, BIHAR',
    masterId: 11274,
  },
  {
    type: 'cityName',
    value: 'DHAKIA TIWARI, UTTAR PRADESH',
    masterId: 16576,
  },
  {
    type: 'cityName',
    value: 'DEOTALA, WEST BENGAL',
    masterId: 11290,
  },
  {
    type: 'cityName',
    value: 'DAVOL, GUJARAT',
    masterId: 18554,
  },
  {
    type: 'cityName',
    value: 'DOHNA, UTTAR PRADESH',
    masterId: 16568,
  },
  {
    type: 'cityName',
    value: 'DORNAHALLI, KARNATAKA',
    masterId: 18039,
  },
  {
    type: 'cityName',
    value: 'GOLGANDA, ORISSA',
    masterId: 11750,
  },
  {
    type: 'cityName',
    value: 'DOSAPADU, ANDHRA PRADESH',
    masterId: 19034,
  },
  {
    type: 'cityName',
    value: 'DHAPDHAPI, WEST BENGAL',
    masterId: 21183,
  },
  {
    type: 'cityName',
    value: 'DEVARAPALLI, ANDHRA PRADESH',
    masterId: 11312,
  },
  {
    type: 'cityName',
    value: 'BODRI, CHHATTISGARH',
    masterId: 10869,
  },
  {
    type: 'cityName',
    value: 'DHODDAMPATTI, TAMIL NADU',
    masterId: 17047,
  },
  {
    type: 'cityName',
    value: 'DHARMAPURI, TAMIL NADU',
    masterId: 11370,
  },
  {
    type: 'cityName',
    value: 'DHOLIPAL, RAJASTHAN ',
    masterId: 17186,
  },
  {
    type: 'cityName',
    value: 'INIAR, BIHAR',
    masterId: 12075,
  },
  {
    type: 'cityName',
    value: 'DIPLANA, RAJASTHAN',
    masterId: 17183,
  },
  {
    type: 'cityName',
    value: 'DHIRPUR, HARYANA',
    masterId: 17373,
  },
  {
    type: 'cityName',
    value: 'DHUPDHARA, ASSAM',
    masterId: 18920,
  },
  {
    type: 'cityName',
    value: 'DANGOAPOSI, JHARKHAND',
    masterId: 11222,
  },
  {
    type: 'cityName',
    value: 'DAPSAURA, UTTAR PRADESH',
    masterId: 16583,
  },
  {
    type: 'cityName',
    value: 'DALPAT SINGHPUR, RAJASTHAN',
    masterId: 17191,
  },
  {
    type: 'cityName',
    value: 'DIPHU, ASSAM',
    masterId: 11440,
  },
  {
    type: 'cityName',
    value: 'DEPUR PH, ORISSA',
    masterId: 16027,
  },
  {
    type: 'cityName',
    value: 'DADPUR, BIHAR',
    masterId: 11187,
  },
  {
    type: 'cityName',
    value: 'DEVPURA, RAJASTHAN',
    masterId: 11322,
  },
  {
    type: 'cityName',
    value: 'DHUPGURI, WEST BENGAL',
    masterId: 11414,
  },
  {
    type: 'cityName',
    value: 'DHANERA, GUJARAT',
    masterId: 11346,
  },
  {
    type: 'cityName',
    value: 'DABIRPURA, ANDHRA PRADESH',
    masterId: 11180,
  },
  {
    type: 'cityName',
    value: 'DULARIA, MADHYA PRADESH',
    masterId: 17848,
  },
  {
    type: 'cityName',
    value: 'DEBARI, RAJASTHAN',
    masterId: 11265,
  },
  {
    type: 'cityName',
    value: 'DEORAHA BABA, UTTAR PRADESH',
    masterId: 16579,
  },
  {
    type: 'cityName',
    value: 'DARSHAN NAGAR, UTTAR PRADESH',
    masterId: 18765,
  },
  {
    type: 'cityName',
    value: 'DARAGANJ, UTTAR PRADESH',
    masterId: 16767,
  },
  {
    type: 'cityName',
    value: 'DEORA GRAM, MADHYA PRADESH',
    masterId: 17853,
  },
  {
    type: 'cityName',
    value: 'DAMRU GHUTU, WEST BENGAL',
    masterId: 21079,
  },
  {
    type: 'cityName',
    value: 'DHARHARA, BIHAR',
    masterId: 11365,
  },
  {
    type: 'cityName',
    value: 'DAGARKHERI, MADHYA PRADESH',
    masterId: 17858,
  },
  {
    type: 'cityName',
    value: 'KALOL, GUJARAT',
    masterId: 12423,
  },
  {
    type: 'cityName',
    value: 'DAURALA, UTTAR PRADESH',
    masterId: 11255,
  },
  {
    type: 'cityName',
    value: 'DEORANIAN, UTTAR PRADESH',
    masterId: 16578,
  },
  {
    type: 'cityName',
    value: 'DARIYA GANJ, UTTAR PRADESH',
    masterId: 18581,
  },
  {
    type: 'cityName',
    value: 'DHARMINIYA, BIHAR',
    masterId: 18761,
  },
  {
    type: 'cityName',
    value: 'DHARUR, ANDHRA PRADESH',
    masterId: 11376,
  },
  {
    type: 'cityName',
    value: 'DHARESHWAR, RAJASTHAN',
    masterId: 11364,
  },
  {
    type: 'cityName',
    value: 'DHURWASIN, MADHYA PRADESH',
    masterId: 11416,
  },
  {
    type: 'cityName',
    value: 'DASHARATHPUR, BIHAR',
    masterId: 11244,
  },
  {
    type: 'cityName',
    value: 'KADUR, KARNATAKA',
    masterId: 12335,
  },
  {
    type: 'cityName',
    value: 'DHARAULI, UTTAR PRADESH',
    masterId: 16764,
  },
  {
    type: 'cityName',
    value: 'DHAREWADA, GUJARAT',
    masterId: 18552,
  },
  {
    type: 'cityName',
    value: 'DEROWAN P. H., JHARKHAND',
    masterId: 11294,
  },
  {
    type: 'cityName',
    value: 'DALLI RAJHARA, CHHATTISGARH',
    masterId: 11205,
  },
  {
    type: 'cityName',
    value: 'MASURI, UTTAR PRADESH',
    masterId: 13506,
  },
  {
    type: 'cityName',
    value: 'DOSVADA, GUJARAT',
    masterId: 11467,
  },
  {
    type: 'cityName',
    value: 'DUSKHEDA, MAHARASHTRA',
    masterId: 17672,
  },
  {
    type: 'cityName',
    value: 'SHRI KRISHNA NAGAR, BIHAR',
    masterId: 18639,
  },
  {
    type: 'cityName',
    value: 'DESHWAL, RAJASTHAN',
    masterId: 11300,
  },
  {
    type: 'cityName',
    value: 'DARASURAM, TAMIL NADU',
    masterId: 17048,
  },
  {
    type: 'cityName',
    value: 'DASARA, JHARKHAND',
    masterId: 20851,
  },
  {
    type: 'cityName',
    value: 'DAUSNI, UTTARAKHAND',
    masterId: 11257,
  },
  {
    type: 'cityName',
    value: 'DASHNAGAR, WEST BENGAL',
    masterId: 21081,
  },
  {
    type: 'cityName',
    value: 'DESHNOK, RAJASTHAN',
    masterId: 11299,
  },
  {
    type: 'cityName',
    value: 'DESHAPRAN P.H., WEST BENGAL',
    masterId: 11298,
  },
  {
    type: 'cityName',
    value: 'DANISHPET, TAMIL NADU',
    masterId: 16993,
  },
  {
    type: 'cityName',
    value: 'DHANSIRI, ASSAM',
    masterId: 18974,
  },
  {
    type: 'cityName',
    value: 'DALSINGH SARAI, BIHAR',
    masterId: 11209,
  },
  {
    type: 'cityName',
    value: 'DASAMPATTI, TAMIL NADU',
    masterId: 16992,
  },
  {
    type: 'cityName',
    value: 'DESANG, ASSAM',
    masterId: 18923,
  },
  {
    type: 'cityName',
    value: 'DHATRIGRAM, WEST BENGAL',
    masterId: 11379,
  },
  {
    type: 'cityName',
    value: 'DITOKCHERRA, ASSAM',
    masterId: 11441,
  },
  {
    type: 'cityName',
    value: 'DEULTY, WEST BENGAL',
    masterId: 16153,
  },
  {
    type: 'cityName',
    value: 'DANTLA, RAJASTHAN',
    masterId: 17895,
  },
  {
    type: 'cityName',
    value: 'DETROJ, GUJARAT',
    masterId: 18484,
  },
  {
    type: 'cityName',
    value: 'JAGATPUR, CHHATTISGARH',
    masterId: 12113,
  },
  {
    type: 'cityName',
    value: 'DHAMTAN SAHIB, HARYANA',
    masterId: 18332,
  },
  {
    type: 'cityName',
    value: 'DALTONGANJ, JHARKHAND',
    masterId: 11210,
  },
  {
    type: 'cityName',
    value: 'DIVITI PALLI, ANDHRA PRADESH',
    masterId: 11444,
  },
  {
    type: 'cityName',
    value: 'DANTARDA KALAN, MADHYA PRADESH',
    masterId: 17855,
  },
  {
    type: 'cityName',
    value: 'DHAMTARI, CHHATTISGARH',
    masterId: 18618,
  },
  {
    type: 'cityName',
    value: 'DHUTRA, ORISSA',
    masterId: 11417,
  },
  {
    type: 'cityName',
    value: 'DATIWLI, MAHARASHTRA',
    masterId: 17680,
  },
  {
    type: 'cityName',
    value: 'DATEWAS, PUNJAB',
    masterId: 17377,
  },
  {
    type: 'cityName',
    value: 'DANGTAL, ASSAM',
    masterId: 18924,
  },
  {
    type: 'cityName',
    value: 'DHAURA, MADHYA PRADESH',
    masterId: 11381,
  },
  {
    type: 'cityName',
    value: 'DUAN, WEST BENGAL',
    masterId: 21085,
  },
  {
    type: 'cityName',
    value: 'DABTARA, UTTAR PRADESH',
    masterId: 11185,
  },
  {
    type: 'cityName',
    value: 'DUBAHA, BIHAR',
    masterId: 11470,
  },
  {
    type: 'cityName',
    value: 'DUDHANI, MAHARASHTRA',
    masterId: 11475,
  },
  {
    type: 'cityName',
    value: 'DUDAHI, UTTAR PRADESH',
    masterId: 16563,
  },
  {
    type: 'cityName',
    value: 'DHURI, PUNJAB',
    masterId: 11415,
  },
  {
    type: 'cityName',
    value: 'DUBRAJPUR, WEST BENGAL',
    masterId: 11471,
  },
  {
    type: 'cityName',
    value: 'DUDIA, RAJASTHAN',
    masterId: 16565,
  },
  {
    type: 'cityName',
    value: 'DAULATPUR, HARYANA',
    masterId: 18333,
  },
  {
    type: 'cityName',
    value: 'DHAURMUI JAGHNA, RAJASTHAN',
    masterId: 17187,
  },
  {
    type: 'cityName',
    value: 'DUMKA, JHARKHAND',
    masterId: 11483,
  },
  {
    type: 'cityName',
    value: 'DUMRA, BIHAR',
    masterId: 20760,
  },
  {
    type: 'cityName',
    value: 'MILAK, UTTAR PRADESH',
    masterId: 13586,
  },
  {
    type: 'cityName',
    value: 'DHAURSALAR, UTTAR PRADESH',
    masterId: 19170,
  },
  {
    type: 'cityName',
    value: 'DESUR, KARNATAKA',
    masterId: 16991,
  },
  {
    type: 'cityName',
    value: 'DUMRAON, BIHAR',
    masterId: 11484,
  },
  {
    type: 'cityName',
    value: 'DURG, CHHATTISGARH',
    masterId: 11496,
  },
  {
    type: 'cityName',
    value: 'DUSIPETA, ANDHRA PRADESH',
    masterId: 11500,
  },
  {
    type: 'cityName',
    value: 'DOOM DOOMA, ASSAM',
    masterId: 18918,
  },
  {
    type: 'cityName',
    value: 'DUPADU, ANDHRA PRADESH',
    masterId: 19033,
  },
  {
    type: 'cityName',
    value: 'DELVADA, GUJARAT',
    masterId: 18485,
  },
  {
    type: 'cityName',
    value: 'THOLAHUNASE, KARNATAKA',
    masterId: 15531,
  },
  {
    type: 'cityName',
    value: 'DEVGAM, GUJARAT',
    masterId: 18483,
  },
  {
    type: 'cityName',
    value: 'DILLI DEWAN GANJ, BIHAR',
    masterId: 18759,
  },
  {
    type: 'cityName',
    value: 'DEOLALI, MAHARASHTRA',
    masterId: 11283,
  },
  {
    type: 'cityName',
    value: 'DHALBHUMGARH, JHARKHAND',
    masterId: 18187,
  },
  {
    type: 'cityName',
    value: 'DEVTHANA, MAHARASHTRA',
    masterId: 17679,
  },
  {
    type: 'cityName',
    value: 'DORAVART CHTRAM, ANDHRA PRADESH',
    masterId: 19035,
  },
  {
    type: 'cityName',
    value: 'DAILWARA, UTTAR PRADESH',
    masterId: 16768,
  },
  {
    type: 'cityName',
    value: 'DARWAD, MAHARASHTRA',
    masterId: 11241,
  },
  {
    type: 'cityName',
    value: 'DEWANGANJ, MADHYA PRADESH',
    masterId: 11323,
  },
  {
    type: 'cityName',
    value: 'DINGWAHI, UTTAR PRADESH',
    masterId: 16569,
  },
  {
    type: 'cityName',
    value: 'DWARKAGANJ, UTTAR PRADESH',
    masterId: 17847,
  },
  {
    type: 'cityName',
    value: 'DWARKA, GUJARAT',
    masterId: 11508,
  },
  {
    type: 'cityName',
    value: 'DHUWALA, RAJASTHAN',
    masterId: 17184,
  },
  {
    type: 'cityName',
    value: 'DHAUNI, BIHAR',
    masterId: 11380,
  },
  {
    type: 'cityName',
    value: 'DIWANA, HARYANA',
    masterId: 18373,
  },
  {
    type: 'cityName',
    value: 'DOIWALA, UTTARAKHAND',
    masterId: 11452,
  },
  {
    type: 'cityName',
    value: 'DWARAPUDI, ANDHRA PRADESH',
    masterId: 11507,
  },
  {
    type: 'cityName',
    value: 'DHARWAD, KARNATAKA',
    masterId: 11377,
  },
  {
    type: 'cityName',
    value: 'DEWANHAT, WEST BENGAL',
    masterId: 16152,
  },
  {
    type: 'cityName',
    value: 'KHAVATI, MAHARASHTRA',
    masterId: 12738,
  },
  {
    type: 'cityName',
    value: 'DEWAS, MADHYA PRADESH',
    masterId: 11325,
  },
  {
    type: 'cityName',
    value: 'DANTEWADA, CHHATTISGARH',
    masterId: 11225,
  },
  {
    type: 'cityName',
    value: 'CHAR, RAJASTHAN',
    masterId: 11009,
  },
  {
    type: 'cityName',
    value: 'DUHAI, UTTAR PRADESH',
    masterId: 16763,
  },
  {
    type: 'cityName',
    value: 'DHANA KHERLI, UTTAR PRADESH',
    masterId: 11341,
  },
  {
    type: 'cityName',
    value: 'WYNDHAMGANJ, UTTAR PRADESH',
    masterId: 15963,
  },
  {
    type: 'cityName',
    value: 'DANAWADA, GUJARAT',
    masterId: 11219,
  },
  {
    type: 'cityName',
    value: 'DUHRU, UTTAR PRADESH',
    masterId: 16762,
  },
  {
    type: 'cityName',
    value: 'DUMARIYA, RAJASTHAN',
    masterId: 11482,
  },
  {
    type: 'cityName',
    value: 'DARIYABAD, UTTAR PRADESH',
    masterId: 11235,
  },
  {
    type: 'cityName',
    value: 'DUDHIA KHURD, UTTAR PRADESH',
    masterId: 16561,
  },
  {
    type: 'cityName',
    value: 'DARYAPUR, UTTAR PRADESH',
    masterId: 19169,
  },
  {
    type: 'cityName',
    value: 'DIYURI, UTTAR PRADESH',
    masterId: 16246,
  },
  {
    type: 'cityName',
    value: 'DASUYA, PUNJAB',
    masterId: 11246,
  },
  {
    type: 'cityName',
    value: 'DAHINA ZAINABAD, HARYANA',
    masterId: 18334,
  },
  {
    type: 'cityName',
    value: 'DURGACHAK, WEST BENGAL',
    masterId: 21230,
  },
  {
    type: 'cityName',
    value: 'DURGA CHAK TOWN, WEST BENGAL',
    masterId: 21231,
  },
  {
    type: 'cityName',
    value: 'DHANA LADANPUR, HARYANA',
    masterId: 18331,
  },
  {
    type: 'cityName',
    value: 'DARAZPUR, HARYANA',
    masterId: 19102,
  },
  {
    type: 'cityName',
    value: 'ERODE, TAMIL NADU',
    masterId: 11538,
  },
  {
    type: 'cityName',
    value: 'EDDULADODDI, ANDHRA PRADESH',
    masterId: 11516,
  },
  {
    type: 'cityName',
    value: 'EDEN GARDENS, WEST BENGAL',
    masterId: 21132,
  },
  {
    type: 'cityName',
    value: 'ERIYODU, TAMIL NADU',
    masterId: 17046,
  },
  {
    type: 'cityName',
    value: 'EGATTUR HALT, TAMIL NADU',
    masterId: 20981,
  },
  {
    type: 'cityName',
    value: 'IRANAGALLU, ANDHRA PRADESH',
    masterId: 19079,
  },
  {
    type: 'cityName',
    value: 'EKCHARI, BIHAR',
    masterId: 11523,
  },
  {
    type: 'cityName',
    value: 'EKLAKHI, WEST BENGAL',
    masterId: 11524,
  },
  {
    type: 'cityName',
    value: 'EKDIL, UTTAR PRADESH',
    masterId: 21015,
  },
  {
    type: 'cityName',
    value: 'NAGARI, ANDHRA PRADESH',
    masterId: 13798,
  },
  {
    type: 'cityName',
    value: 'EKMA, BIHAR',
    masterId: 11527,
  },
  {
    type: 'cityName',
    value: 'EZHUKONE, KERALA',
    masterId: 11550,
  },
  {
    type: 'cityName',
    value: 'EKANGARSARAI, BIHAR',
    masterId: 11522,
  },
  {
    type: 'cityName',
    value: 'ELAMANOOR, TAMIL NADU',
    masterId: 16989,
  },
  {
    type: 'cityName',
    value: 'EZHIMALA, KERALA',
    masterId: 11549,
  },
  {
    type: 'cityName',
    value: 'ELAVUR, TAMIL NADU',
    masterId: 16988,
  },
  {
    type: 'cityName',
    value: 'ELLENABAD, HARYANA',
    masterId: 18325,
  },
  {
    type: 'cityName',
    value: 'ENNORE, TAMIL NADU',
    masterId: 16987,
  },
  {
    type: 'cityName',
    value: 'ERICH, UTTAR PRADESH',
    masterId: 16560,
  },
  {
    type: 'cityName',
    value: 'ERNAKULAM, KERALA',
    masterId: 11537,
  },
  {
    type: 'cityName',
    value: 'ISIVI, ANDHRA PRADESH',
    masterId: 19024,
  },
  {
    type: 'cityName',
    value: 'ITARSI, MADHYA PRADESH',
    masterId: 12093,
  },
  {
    type: 'cityName',
    value: 'ETAH, UTTAR PRADESH',
    masterId: 11543,
  },
  {
    type: 'cityName',
    value: 'EDAKKAD, KERALA ',
    masterId: 17930,
  },
  {
    type: 'cityName',
    value: 'ETTUMANOOR, KERALA',
    masterId: 11548,
  },
  {
    type: 'cityName',
    value: 'ETTIMADAI, TAMIL NADU',
    masterId: 11547,
  },
  {
    type: 'cityName',
    value: 'ETTAPUR ROAD, TAMIL NADU',
    masterId: 11546,
  },
  {
    type: 'cityName',
    value: 'ELATHUR, KERALA',
    masterId: 17951,
  },
  {
    type: 'cityName',
    value: 'ETMADPUR, UTTAR PRADESH',
    masterId: 16761,
  },
  {
    type: 'cityName',
    value: 'ETAWAH, UTTAR PRADESH',
    masterId: 11544,
  },
  {
    type: 'cityName',
    value: 'KAPPIL, KERALA',
    masterId: 12519,
  },
  {
    type: 'cityName',
    value: 'EZHUPUNNA, KERALA',
    masterId: 17950,
  },
  {
    type: 'cityName',
    value: 'FALNA, RAJASTHAN',
    masterId: 11558,
  },
  {
    type: 'cityName',
    value: 'FATEHABAD, UTTAR PRADESH',
    masterId: 21040,
  },
  {
    type: 'cityName',
    value: 'FATEHNAGAR, RAJASTHAN',
    masterId: 11570,
  },
  {
    type: 'cityName',
    value: 'FAKHARPUR, UTTAR PRADESH',
    masterId: 16559,
  },
  {
    type: 'cityName',
    value: 'FARRUKHABAD, UTTAR PRADESH',
    masterId: 11566,
  },
  {
    type: 'cityName',
    value: 'FORBESGANJ, BIHAR',
    masterId: 11579,
  },
  {
    type: 'cityName',
    value: 'FARIDKOT, PUNJAB',
    masterId: 11564,
  },
  {
    type: 'cityName',
    value: 'FETEHGARH CHURN, PUNJAB',
    masterId: 20941,
  },
  {
    type: 'cityName',
    value: 'FATEHGARH, HARYANA',
    masterId: 18323,
  },
  {
    type: 'cityName',
    value: 'FATEHGARH, UTTAR PRADESH',
    masterId: 11568,
  },
  {
    type: 'cityName',
    value: 'FATEHGARH SAHIB, PUNJAB',
    masterId: 11569,
  },
  {
    type: 'cityName',
    value: 'FARAH, UTTAR PRADESH',
    masterId: 11559,
  },
  {
    type: 'cityName',
    value: 'FEROKE, KERALA',
    masterId: 11574,
  },
  {
    type: 'cityName',
    value: 'FAZILKA, PUNJAB',
    masterId: 11573,
  },
  {
    type: 'cityName',
    value: 'FAKHRABAD, ANDHRA PRADESH',
    masterId: 11554,
  },
  {
    type: 'cityName',
    value: 'FURKATING, ASSAM',
    masterId: 11582,
  },
  {
    type: 'cityName',
    value: 'FAKIRAGRAM, ASSAM',
    masterId: 11555,
  },
  {
    type: 'cityName',
    value: 'PHULERA, RAJASTHAN',
    masterId: 14388,
  },
  {
    type: 'cityName',
    value: 'PHULAD, RAJASTHAN',
    masterId: 17089,
  },
  {
    type: 'cityName',
    value: 'PARANGARPAR, WEST BENGAL',
    masterId: 14234,
  },
  {
    type: 'cityName',
    value: 'FALIMARI, WEST BENGAL',
    masterId: 16224,
  },
  {
    type: 'cityName',
    value: 'PHULESWAR, WEST BENGAL',
    masterId: 14389,
  },
  {
    type: 'cityName',
    value: 'PHULIA, WEST BENGAL',
    masterId: 21253,
  },
  {
    type: 'cityName',
    value: 'FALAKNUMA, ANDHRA PRADESH',
    masterId: 11557,
  },
  {
    type: 'cityName',
    value: 'FARUKH NAGAR, HARYANA',
    masterId: 18324,
  },
  {
    type: 'cityName',
    value: 'FANGO, BIHAR',
    masterId: 18984,
  },
  {
    type: 'cityName',
    value: 'FARHEDI, UTTAR PRADESH',
    masterId: 16557,
  },
  {
    type: 'cityName',
    value: 'FARIDAHA, UTTAR PRADESH',
    masterId: 16556,
  },
  {
    type: 'cityName',
    value: 'FARHATNAGAR, UTTAR PRADESH',
    masterId: 16558,
  },
  {
    type: 'cityName',
    value: 'FURSUNGI, MAHARASHTRA',
    masterId: 17741,
  },
  {
    type: 'cityName',
    value: 'SUROTH, RAJASTHAN',
    masterId: 15364,
  },
  {
    type: 'cityName',
    value: 'FAQARSAR, PUNJAB',
    masterId: 17369,
  },
  {
    type: 'cityName',
    value: 'FATEH SINGHWALA, RAJASTHAN',
    masterId: 17180,
  },
  {
    type: 'cityName',
    value: 'FATEHPUR CHAORASI, UTTAR PRADESH',
    masterId: 16555,
  },
  {
    type: 'cityName',
    value: 'FATEHABAD CH.JN, MADHYA PRADESH',
    masterId: 20884,
  },
  {
    type: 'cityName',
    value: 'FURSATGANJ, UTTAR PRADESH',
    masterId: 11583,
  },
  {
    type: 'cityName',
    value: 'FATUHI, RAJASTHAN',
    masterId: 17179,
  },
  {
    type: 'cityName',
    value: 'FATEHPUR, UTTAR PRADESH',
    masterId: 11571,
  },
  {
    type: 'cityName',
    value: 'FATEHPUR SIKRI, UTTAR PRADESH',
    masterId: 11572,
  },
  {
    type: 'cityName',
    value: 'MAUJIPUR, BIHAR',
    masterId: 13525,
  },
  {
    type: 'cityName',
    value: 'FAIZULLAPUR, UTTAR PRADESH',
    masterId: 11553,
  },
  {
    type: 'cityName',
    value: 'FIROZABAD, UTTAR PRADESH',
    masterId: 11575,
  },
  {
    type: 'cityName',
    value: 'TAFAZALPURA, UTTAR PRADESH',
    masterId: 17406,
  },
  {
    type: 'cityName',
    value: 'FEROZEPUR, PUNJAB',
    masterId: 17367,
  },
  {
    type: 'cityName',
    value: 'FIROZPUR , PUNJAB',
    masterId: 11577,
  },
  {
    type: 'cityName',
    value: 'KACHHBALI, MAHARASHTRA',
    masterId: 12308,
  },
  {
    type: 'cityName',
    value: 'GUDHA, RAJASTHAN',
    masterId: 11805,
  },
  {
    type: 'cityName',
    value: 'GALAN, MAHARASHTRA',
    masterId: 17670,
  },
  {
    type: 'cityName',
    value: 'KUSMUNDA, CHHATTISGARH',
    masterId: 13056,
  },
  {
    type: 'cityName',
    value: 'GOALDIH, WEST BENGAL',
    masterId: 16028,
  },
  {
    type: 'cityName',
    value: 'GAIPURA, UTTAR PRADESH',
    masterId: 11601,
  },
  {
    type: 'cityName',
    value: 'GANGAGHAT, JHARKHAND',
    masterId: 16551,
  },
  {
    type: 'cityName',
    value: 'GALGALIA, BIHAR',
    masterId: 16029,
  },
  {
    type: 'cityName',
    value: 'GHUSIA, BIHAR',
    masterId: 18747,
  },
  {
    type: 'cityName',
    value: 'GAUCHHARI, BIHAR',
    masterId: 18830,
  },
  {
    type: 'cityName',
    value: 'GANESHGANJ, MADHYA PRADESH',
    masterId: 11625,
  },
  {
    type: 'cityName',
    value: 'GAJARA BAHARA, MADHYA PRADESH',
    masterId: 17846,
  },
  {
    type: 'cityName',
    value: 'GAJU, UTTAR PRADESH',
    masterId: 16552,
  },
  {
    type: 'cityName',
    value: 'GHATLA, RAJASTHAN',
    masterId: 17740,
  },
  {
    type: 'cityName',
    value: 'RAMCHANDRABATI, WEST BENGAL',
    masterId: 14615,
  },
  {
    type: 'cityName',
    value: 'GANJAM, ORISSA',
    masterId: 11644,
  },
  {
    type: 'cityName',
    value: 'GOGA MEDI, RAJASTHAN',
    masterId: 17173,
  },
  {
    type: 'cityName',
    value: 'GAMANI, ASSAM',
    masterId: 18551,
  },
  {
    type: 'cityName',
    value: 'GANGAGANJ, UTTAR PRADESH',
    masterId: 11629,
  },
  {
    type: 'cityName',
    value: 'GHANAULI, PUNJAB',
    masterId: 11686,
  },
  {
    type: 'cityName',
    value: 'GAIGAON, MAHARASHTRA',
    masterId: 17671,
  },
  {
    type: 'cityName',
    value: 'GURPA, BIHAR',
    masterId: 11863,
  },
  {
    type: 'cityName',
    value: 'GANJKHWAJA, UTTAR PRADESH',
    masterId: 16549,
  },
  {
    type: 'cityName',
    value: 'GADARWARA, MADHYA PRADESH',
    masterId: 11588,
  },
  {
    type: 'cityName',
    value: 'GARHA, BIHAR',
    masterId: 20761,
  },
  {
    type: 'cityName',
    value: 'GAUTAMDHARA, JHARKHAND',
    masterId: 18184,
  },
  {
    type: 'cityName',
    value: 'GAUR, UTTAR PRADESH',
    masterId: 16760,
  },
  {
    type: 'cityName',
    value: 'GAINJAHWA, UTTAR PRADESH',
    masterId: 16554,
  },
  {
    type: 'cityName',
    value: 'GAYA, BIHAR',
    masterId: 11681,
  },
  {
    type: 'cityName',
    value: 'GAURI BAZAR, UTTAR PRADESH',
    masterId: 11672,
  },
  {
    type: 'cityName',
    value: 'GARHBETA, WEST BENGAL',
    masterId: 11654,
  },
  {
    type: 'cityName',
    value: 'GUBBI, KARNATAKA',
    masterId: 11799,
  },
  {
    type: 'cityName',
    value: 'GAURIBIDANUR, KARNATAKA',
    masterId: 11673,
  },
  {
    type: 'cityName',
    value: 'GOBARDANGA, WEST BENGAL',
    masterId: 21246,
  },
  {
    type: 'cityName',
    value: 'BALIKUDA, ORISSA',
    masterId: 17545,
  },
  {
    type: 'cityName',
    value: 'GARH BANALI, BIHAR',
    masterId: 18756,
  },
  {
    type: 'cityName',
    value: 'GULABPURA, RAJASTHAN',
    masterId: 11817,
  },
  {
    type: 'cityName',
    value: 'GODBHAGA, ORISSA',
    masterId: 17500,
  },
  {
    type: 'cityName',
    value: 'GOBRA, WEST BENGAL',
    masterId: 21193,
  },
  {
    type: 'cityName',
    value: 'GOBARWAHI, MAHARASHTRA',
    masterId: 17667,
  },
  {
    type: 'cityName',
    value: 'DEHKELA, JHARKHAND',
    masterId: 11270,
  },
  {
    type: 'cityName',
    value: 'G CABIN, CHHATTISGARH',
    masterId: 18616,
  },
  {
    type: 'cityName',
    value: 'GACHHIPURA, RAJASTHAN',
    masterId: 11585,
  },
  {
    type: 'cityName',
    value: 'GOCHARAN, WEST BENGAL',
    masterId: 21181,
  },
  {
    type: 'cityName',
    value: 'GHAZIPUR, UTTAR PRADESH',
    masterId: 11704,
  },
  {
    type: 'cityName',
    value: 'GONDA, UTTAR PRADESH',
    masterId: 11760,
  },
  {
    type: 'cityName',
    value: 'GODHRA, GUJARAT',
    masterId: 11733,
  },
  {
    type: 'cityName',
    value: 'GIDDERBAHA, PUNJAB',
    masterId: 11718,
  },
  {
    type: 'cityName',
    value: 'GOONDA BIHAR, JHARKHAND',
    masterId: 18182,
  },
  {
    type: 'cityName',
    value: 'GADRA, RAJASTHAN',
    masterId: 17178,
  },
  {
    type: 'cityName',
    value: 'GARLADINNE, ANDHRA PRADESH',
    masterId: 11663,
  },
  {
    type: 'cityName',
    value: 'GADAG, KARNATAKA',
    masterId: 11587,
  },
  {
    type: 'cityName',
    value: 'GAUDGAON, KARNATAKA',
    masterId: 17668,
  },
  {
    type: 'cityName',
    value: 'GIDNAHALLI, KARNATAKA',
    masterId: 18100,
  },
  {
    type: 'cityName',
    value: 'GODHA, UTTAR PRADESH',
    masterId: 16537,
  },
  {
    type: 'cityName',
    value: 'GUDGERI, KARNATAKA',
    masterId: 11804,
  },
  {
    type: 'cityName',
    value: 'GONDA KACHEHARI, UTTAR PRADESH',
    masterId: 16536,
  },
  {
    type: 'cityName',
    value: 'GHUNDANKHAPA, MADHYA PRADESH',
    masterId: 17843,
  },
  {
    type: 'cityName',
    value: 'GONDAL, GUJARAT',
    masterId: 11761,
  },
  {
    type: 'cityName',
    value: 'GUDMA, MAHARASHTRA',
    masterId: 11812,
  },
  {
    type: 'cityName',
    value: 'GANGAIKONDAN, TAMIL NADU',
    masterId: 16986,
  },
  {
    type: 'cityName',
    value: 'GOVARDHAN, UTTAR PRADESH',
    masterId: 11791,
  },
  {
    type: 'cityName',
    value: 'ONTIPALLE, ANDHRA PRADESH',
    masterId: 14084,
  },
  {
    type: 'cityName',
    value: 'POCHAMPALLI, ANDHRA PRADESH',
    masterId: 14434,
  },
  {
    type: 'cityName',
    value: 'VETLAPALEM, ANDHRA PRADESH',
    masterId: 15859,
  },
  {
    type: 'cityName',
    value: 'GODAMGURA, ANDHRA PRADESH',
    masterId: 11731,
  },
  {
    type: 'cityName',
    value: 'GUDUR, ANDHRA PRADESH',
    masterId: 11813,
  },
  {
    type: 'cityName',
    value: 'GANGADHARA, TELANGANA',
    masterId: 20996,
  },
  {
    type: 'cityName',
    value: 'GUDIVADA, ANDHRA PRADESH',
    masterId: 11808,
  },
  {
    type: 'cityName',
    value: 'GADHWALA, RAJASTHAN',
    masterId: 17270,
  },
  {
    type: 'cityName',
    value: 'GHOKSADANGA, WEST BENGAL',
    masterId: 11708,
  },
  {
    type: 'cityName',
    value: 'GUINDY, MADHYA PRADESH',
    masterId: 20888,
  },
  {
    type: 'cityName',
    value: 'GHORADONGRI, MADHYA PRADESH',
    masterId: 11710,
  },
  {
    type: 'cityName',
    value: 'GUNDARDEHI, CHHATTISGARH',
    masterId: 11838,
  },
  {
    type: 'cityName',
    value: 'GHATERA, MADHYA PRADESH',
    masterId: 11694,
  },
  {
    type: 'cityName',
    value: 'GARH BARUARI, BIHAR',
    masterId: 18755,
  },
  {
    type: 'cityName',
    value: 'KELAWADI, KARNATAKA',
    masterId: 12643,
  },
  {
    type: 'cityName',
    value: 'GEDE, WEST BENGAL',
    masterId: 21138,
  },
  {
    type: 'cityName',
    value: 'GIR GADHDA, GUJARAT',
    masterId: 18474,
  },
  {
    type: 'cityName',
    value: 'JATLI, RAJASTHAN',
    masterId: 12212,
  },
  {
    type: 'cityName',
    value: 'GUNJARIA, WEST BENGAL',
    masterId: 16138,
  },
  {
    type: 'cityName',
    value: 'GARIFA, WEST BENGAL',
    masterId: 16146,
  },
  {
    type: 'cityName',
    value: 'GANDHIGRAM, GUJARAT',
    masterId: 18983,
  },
  {
    type: 'cityName',
    value: 'GHOGHA, BIHAR',
    masterId: 11707,
  },
  {
    type: 'cityName',
    value: 'GANGADHARA, GUJARAT',
    masterId: 11627,
  },
  {
    type: 'cityName',
    value: 'GARHMUKTESAR BR, UTTAR PRADESH',
    masterId: 11656,
  },
  {
    type: 'cityName',
    value: 'GANGAPUR CITY, RAJASTHAN',
    masterId: 11632,
  },
  {
    type: 'cityName',
    value: 'GULLAGUDA, ANDHRA PRADESH',
    masterId: 11825,
  },
  {
    type: 'cityName',
    value: 'IZZATNAGAR, UTTAR PRADESH',
    masterId: 16710,
  },
  {
    type: 'cityName',
    value: 'GHOGHARDIHA, BIHAR',
    masterId: 18751,
  },
  {
    type: 'cityName',
    value: 'GOSAINGANJ, UTTAR PRADESH',
    masterId: 11781,
  },
  {
    type: 'cityName',
    value: 'GOVINDGARH KHKR, PUNJAB',
    masterId: 18357,
  },
  {
    type: 'cityName',
    value: 'GANGATIKURI, WEST BENGAL',
    masterId: 16222,
  },
  {
    type: 'cityName',
    value: 'GURGAON, HARYANA',
    masterId: 11856,
  },
  {
    type: 'cityName',
    value: 'GORAM GHAT, RAJASTHAN',
    masterId: 17172,
  },
  {
    type: 'cityName',
    value: 'GANGNAPUR, WEST BENGAL',
    masterId: 21197,
  },
  {
    type: 'cityName',
    value: 'GANGARAR, RAJASTHAN',
    masterId: 11634,
  },
  {
    type: 'cityName',
    value: 'GHUNGHUTI, MADHYA PRADESH',
    masterId: 11715,
  },
  {
    type: 'cityName',
    value: 'GHORAGHATA, WEST BENGAL',
    masterId: 21082,
  },
  {
    type: 'cityName',
    value: 'GHOVARASH GHONA, WEST BENGAL',
    masterId: 21162,
  },
  {
    type: 'cityName',
    value: 'GAGARIYA, RAJASTHAN',
    masterId: 17177,
  },
  {
    type: 'cityName',
    value: 'GHUGHULI, UTTAR PRADESH',
    masterId: 11714,
  },
  {
    type: 'cityName',
    value: 'GOLEWALA, PUNJAB',
    masterId: 17358,
  },
  {
    type: 'cityName',
    value: 'GHATIGAON, MADHYA PRADESH',
    masterId: 17845,
  },
  {
    type: 'cityName',
    value: 'GEHRI BHAGI, PUNJAB',
    masterId: 17363,
  },
  {
    type: 'cityName',
    value: 'GARWA ROAD, JHARKHAND',
    masterId: 11668,
  },
  {
    type: 'cityName',
    value: 'GHEVRA, DELHI',
    masterId: 18589,
  },
  {
    type: 'cityName',
    value: 'GAGGAR, PUNJAB',
    masterId: 17366,
  },
  {
    type: 'cityName',
    value: 'GHAGWAL, JAMMU AND KASHMIR',
    masterId: 11685,
  },
  {
    type: 'cityName',
    value: 'GURSAHAIGANJ, UTTAR PRADESH',
    masterId: 11867,
  },
  {
    type: 'cityName',
    value: 'GOLLAHALLI, KARNATAKA',
    masterId: 18099,
  },
  {
    type: 'cityName',
    value: 'GADADHARPUR, WEST BENGAL',
    masterId: 11586,
  },
  {
    type: 'cityName',
    value: 'GHORPARAN, BIHAR',
    masterId: 20752,
  },
  {
    type: 'cityName',
    value: 'GOHANA, HARYANA',
    masterId: 18319,
  },
  {
    type: 'cityName',
    value: 'GHANTIKHAL NDPR, ORISSA',
    masterId: 17501,
  },
  {
    type: 'cityName',
    value: 'GANDHIPURAM HAL, ANDHRA PRADESH',
    masterId: 11623,
  },
  {
    type: 'cityName',
    value: 'GARHWA, JHARKHAND',
    masterId: 11659,
  },
  {
    type: 'cityName',
    value: 'GIDHAUR, BIHAR',
    masterId: 11719,
  },
  {
    type: 'cityName',
    value: 'GHORI, UTTAR PRADESH',
    masterId: 16541,
  },
  {
    type: 'cityName',
    value: 'GURU HAR SAHAI, PUNJAB',
    masterId: 17356,
  },
  {
    type: 'cityName',
    value: 'GHASARA HALT, UTTAR PRADESH',
    masterId: 21022,
  },
  {
    type: 'cityName',
    value: 'GHAGHRA GHAT, UTTAR PRADESH',
    masterId: 16543,
  },
  {
    type: 'cityName',
    value: 'GARHARA, BIHAR',
    masterId: 11653,
  },
  {
    type: 'cityName',
    value: 'GUWAHATI, ASSAM',
    masterId: 11877,
  },
  {
    type: 'cityName',
    value: 'GUDUVANCHERY, TAMIL NADU',
    masterId: 17045,
  },
  {
    type: 'cityName',
    value: 'GARIA, PUNJAB',
    masterId: 20954,
  },
  {
    type: 'cityName',
    value: 'GHOGHI BARIYARPUR, BIHAR',
    masterId: 18750,
  },
  {
    type: 'cityName',
    value: 'GIDDALUR, ANDHRA PRADESH',
    masterId: 11717,
  },
  {
    type: 'cityName',
    value: 'GANIDHAM, BIHAR',
    masterId: 18757,
  },
  {
    type: 'cityName',
    value: 'GIDHNI, WEST BENGAL',
    masterId: 16144,
  },
  {
    type: 'cityName',
    value: 'GAISAL, WEST BENGAL',
    masterId: 16223,
  },
  {
    type: 'cityName',
    value: 'GHIALA, PUNJAB',
    masterId: 17361,
  },
  {
    type: 'cityName',
    value: 'GILL, PUNJAB',
    masterId: 11720,
  },
  {
    type: 'cityName',
    value: 'GINIGERA, KARNATAKA',
    masterId: 11721,
  },
  {
    type: 'cityName',
    value: 'GORIA, RAJASTHAN',
    masterId: 17268,
  },
  {
    type: 'cityName',
    value: 'GAINSARI, UTTAR PRADESH',
    masterId: 16553,
  },
  {
    type: 'cityName',
    value: 'GARHI SANDRA, RAJASTHAN',
    masterId: 17175,
  },
  {
    type: 'cityName',
    value: 'GIRDHARPUR, RAJASTHAN',
    masterId: 16539,
  },
  {
    type: 'cityName',
    value: 'GEEDAM, CHHATTISGARH',
    masterId: 11683,
  },
  {
    type: 'cityName',
    value: 'GANGAZARI, MAHARASHTRA',
    masterId: 11637,
  },
  {
    type: 'cityName',
    value: 'GUJHANDI, JHARKHAND',
    masterId: 11815,
  },
  {
    type: 'cityName',
    value: 'RASALPURA, BIHAR',
    masterId: 14677,
  },
  {
    type: 'cityName',
    value: 'GAJJALAKONDA, ANDHRA PRADESH',
    masterId: 11605,
  },
  {
    type: 'cityName',
    value: 'GAJRAULA, UTTAR PRADESH',
    masterId: 11606,
  },
  {
    type: 'cityName',
    value: 'GANJMURADABAD, UTTAR PRADESH',
    masterId: 16548,
  },
  {
    type: 'cityName',
    value: 'GAJSINGHPUR, RAJASTHAN',
    masterId: 11607,
  },
  {
    type: 'cityName',
    value: 'BANNERUGHATTA, KARNATAKA',
    masterId: 18105,
  },
  {
    type: 'cityName',
    value: 'GURUDIJHATIA, ORISSA',
    masterId: 17495,
  },
  {
    type: 'cityName',
    value: 'JAITO, PUNJAB',
    masterId: 12135,
  },
  {
    type: 'cityName',
    value: 'GAJUWALA, PUNJAB',
    masterId: 18322,
  },
  {
    type: 'cityName',
    value: 'GOLA GOKARANATH, UTTAR PRADESH',
    masterId: 11747,
  },
  {
    type: 'cityName',
    value: 'GHATAKA VARANA, RAJASTHAN',
    masterId: 11692,
  },
  {
    type: 'cityName',
    value: 'GADHAKDA, GUJARAT',
    masterId: 18480,
  },
  {
    type: 'cityName',
    value: 'GOKALGARH, HARYANA ',
    masterId: 18318,
  },
  {
    type: 'cityName',
    value: 'GUSKHARA, WEST BENGAL',
    masterId: 11875,
  },
  {
    type: 'cityName',
    value: 'GRAM KHARIKA, BIHAR',
    masterId: 18744,
  },
  {
    type: 'cityName',
    value: 'GOLAKGANJ, ASSAM',
    masterId: 11749,
  },
  {
    type: 'cityName',
    value: 'GOKAK, KARNATAKA',
    masterId: 11741,
  },
  {
    type: 'cityName',
    value: 'GOKULPUR, WEST BENGAL',
    masterId: 16142,
  },
  {
    type: 'cityName',
    value: 'GUNDLA KAMMA, ANDHRA PRADESH',
    masterId: 11839,
  },
  {
    type: 'cityName',
    value: 'GANKHERA, MAHARASHTRA',
    masterId: 17669,
  },
  {
    type: 'cityName',
    value: 'GHALL KALAN, PUNJAB',
    masterId: 17362,
  },
  {
    type: 'cityName',
    value: 'GARLA, ANDHRA PRADESH',
    masterId: 11662,
  },
  {
    type: 'cityName',
    value: 'GOLABAI, ORISSA',
    masterId: 17498,
  },
  {
    type: 'cityName',
    value: 'BALWA, UTTAR PRADESH',
    masterId: 16660,
  },
  {
    type: 'cityName',
    value: 'GAJULAGUDEM, ANDHRA PRADESH',
    masterId: 11608,
  },
  {
    type: 'cityName',
    value: 'GULABHGANJ, MADHYA PRADESH',
    masterId: 11816,
  },
  {
    type: 'cityName',
    value: 'GOLAGHAT, ASSAM',
    masterId: 11748,
  },
  {
    type: 'cityName',
    value: 'GULAOTHI, UTTAR PRADESH',
    masterId: 11819,
  },
  {
    type: 'cityName',
    value: 'GALSI, WEST BENGAL',
    masterId: 16147,
  },
  {
    type: 'cityName',
    value: 'GUGALWA KIRTAN, RAJASTHAN ',
    masterId: 17169,
  },
  {
    type: 'cityName',
    value: 'GULMA, WEST BENGAL',
    masterId: 18743,
  },
  {
    type: 'cityName',
    value: 'GULANA, RAJASTHAN',
    masterId: 11818,
  },
  {
    type: 'cityName',
    value: 'GOLLAPROLLU, ANDHRA PRADESH',
    masterId: 11755,
  },
  {
    type: 'cityName',
    value: 'GOALPARA, ASSAM',
    masterId: 11727,
  },
  {
    type: 'cityName',
    value: 'GAHLOTA, RAJASTHAN',
    masterId: 11598,
  },
  {
    type: 'cityName',
    value: 'GULLIPADU, ANDHRA PRADESH',
    masterId: 11827,
  },
  {
    type: 'cityName',
    value: 'GOLLAPALLY, ANDHRA PRADESH',
    masterId: 11754,
  },
  {
    type: 'cityName',
    value: 'GARMADI, GUJARAT',
    masterId: 18476,
  },
  {
    type: 'cityName',
    value: 'GUDDIMETTA, ANDHRA PRADESH',
    masterId: 11803,
  },
  {
    type: 'cityName',
    value: 'SRIKUNTH, JHARKHAND',
    masterId: 15291,
  },
  {
    type: 'cityName',
    value: 'KANPUR GOODS MARSHAL, UTTAR PRADESH',
    masterId: 21023,
  },
  {
    type: 'cityName',
    value: 'GURAMKHEDI, MADHYA PRADESH',
    masterId: 11851,
  },
  {
    type: 'cityName',
    value: 'GUMADA, ANDHRA PRADESH',
    masterId: 11829,
  },
  {
    type: 'cityName',
    value: 'KHARAGPUR, WEST BENGAL',
    masterId: 12717,
  },
  {
    type: 'cityName',
    value: 'GUMANDEV, GUJARAT',
    masterId: 18472,
  },
  {
    type: 'cityName',
    value: 'GUMGAON, MAHARASHTRA',
    masterId: 17665,
  },
  {
    type: 'cityName',
    value: 'GOMANGALAM, TAMIL NADU',
    masterId: 16985,
  },
  {
    type: 'cityName',
    value: 'GAMHARIA, JHARKHAND',
    masterId: 11615,
  },
  {
    type: 'cityName',
    value: 'GUMIA, JHARKHAND',
    masterId: 11830,
  },
  {
    type: 'cityName',
    value: 'PARWANOO, HIMACHAL PRADESH',
    masterId: 14273,
  },
  {
    type: 'cityName',
    value: 'GOMOH, JHARKHAND',
    masterId: 11756,
  },
  {
    type: 'cityName',
    value: 'GAHMAR, BIHAR',
    masterId: 11599,
  },
  {
    type: 'cityName',
    value: 'GUMTO, ARUNACHAL PRADESH',
    masterId: 16030,
  },
  {
    type: 'cityName',
    value: 'GAURIYAMAU, UTTAR PRADESH',
    masterId: 16759,
  },
  {
    type: 'cityName',
    value: 'GURMURA, UTTAR PRADESH',
    masterId: 16532,
  },
  {
    type: 'cityName',
    value: 'GOPAL NAGAR, ANDHRA PRADESH',
    masterId: 20736,
  },
  {
    type: 'cityName',
    value: 'GONIANA, PUNJAB',
    masterId: 11762,
  },
  {
    type: 'cityName',
    value: 'GNANABHARATHI, KARNATAKA',
    masterId: 18038,
  },
  {
    type: 'cityName',
    value: 'GANDHINAGAR, GUJARAT',
    masterId: 11621,
  },
  {
    type: 'cityName',
    value: 'GOVINDGARH MALIKPUR, RAJASTHAN',
    masterId: 17170,
  },
  {
    type: 'cityName',
    value: 'GAURIGANJ, UTTAR PRADESH',
    masterId: 11674,
  },
  {
    type: 'cityName',
    value: 'GANGADHARPUR, ORISSA',
    masterId: 11628,
  },
  {
    type: 'cityName',
    value: 'GANGAULI, UTTAR PRADESH',
    masterId: 18831,
  },
  {
    type: 'cityName',
    value: 'GANGAKHED, MAHARASHTRA',
    masterId: 11630,
  },
  {
    type: 'cityName',
    value: 'GUNJI, WEST BENGAL',
    masterId: 18098,
  },
  {
    type: 'cityName',
    value: 'GARH NOKHA, BIHAR',
    masterId: 18754,
  },
  {
    type: 'cityName',
    value: 'GONGLE, MAHARASHTRA',
    masterId: 18615,
  },
  {
    type: 'cityName',
    value: 'GANGINENI, ANDHRA PRADESH',
    masterId: 19032,
  },
  {
    type: 'cityName',
    value: 'GANGANIYAN, BIHAR',
    masterId: 18758,
  },
  {
    type: 'cityName',
    value: 'GHANPUR, ANDHRA PRADESH',
    masterId: 11687,
  },
  {
    type: 'cityName',
    value: 'GUNUPUR, ORISSA',
    masterId: 17496,
  },
  {
    type: 'cityName',
    value: 'GODHANI, MAHARASHTRA',
    masterId: 17666,
  },
  {
    type: 'cityName',
    value: 'GADIGANUR, KARNATAKA',
    masterId: 11593,
  },
  {
    type: 'cityName',
    value: 'GANGRAUL, UTTAR PRADESH',
    masterId: 21005,
  },
  {
    type: 'cityName',
    value: 'GANDHI SMRITI, GUJARAT',
    masterId: 18580,
  },
  {
    type: 'cityName',
    value: 'GUNTUR, ANDHRA PRADESH',
    masterId: 11850,
  },
  {
    type: 'cityName',
    value: 'GAUNTRA, UTTAR PRADESH',
    masterId: 16546,
  },
  {
    type: 'cityName',
    value: 'GANNAUR, HARYANA',
    masterId: 11646,
  },
  {
    type: 'cityName',
    value: 'GONDWANAVISAPUR, MAHARASHTRA',
    masterId: 16031,
  },
  {
    type: 'cityName',
    value: 'GANGIWARA, MADHYA PRADESH',
    masterId: 11638,
  },
  {
    type: 'cityName',
    value: 'GAHNDRAN, PUNJAB',
    masterId: 18477,
  },
  {
    type: 'cityName',
    value: 'GHOTI, MAHARASHTRA',
    masterId: 17844,
  },
  {
    type: 'cityName',
    value: 'GOHAD ROAD, MADHYA PRADESH',
    masterId: 11737,
  },
  {
    type: 'cityName',
    value: 'PONMLAI GLD RCK, TAMIL NADU',
    masterId: 14450,
  },
  {
    type: 'cityName',
    value: 'GIDARPINDI, PUNJAB',
    masterId: 17359,
  },
  {
    type: 'cityName',
    value: 'GHOGRAPUR, ASSAM',
    masterId: 18916,
  },
  {
    type: 'cityName',
    value: 'GHUTIARI SHARIF, WEST BENGAL',
    masterId: 21176,
  },
  {
    type: 'cityName',
    value: 'GHORGHAT, BIHAR',
    masterId: 18749,
  },
  {
    type: 'cityName',
    value: 'GOSSAIGAON HAT, ASSAM',
    masterId: 11782,
  },
  {
    type: 'cityName',
    value: 'GAROT, MADHYA PRADESH',
    masterId: 11665,
  },
  {
    type: 'cityName',
    value: 'GOKARNA, KARNATAKA',
    masterId: 11742,
  },
  {
    type: 'cityName',
    value: 'GOILKERA, JHARKHAND',
    masterId: 11739,
  },
  {
    type: 'cityName',
    value: 'GOLE, RAJASTHAN',
    masterId: 18243,
  },
  {
    type: 'cityName',
    value: 'GOGAMUKH, ASSAM',
    masterId: 11735,
  },
  {
    type: 'cityName',
    value: 'GOP JAM, GUJARAT',
    masterId: 11767,
  },
  {
    type: 'cityName',
    value: 'GHOSIPURA, MADHYA PRADESH',
    masterId: 16540,
  },
  {
    type: 'cityName',
    value: 'GOPINATHPUR, WEST BENGAL',
    masterId: 21110,
  },
  {
    type: 'cityName',
    value: 'GHOSRANA, RAJASTHAN',
    masterId: 17174,
  },
  {
    type: 'cityName',
    value: 'GOT, UTTAR PRADESH',
    masterId: 16535,
  },
  {
    type: 'cityName',
    value: 'GOTAN, RAJASTHAN',
    masterId: 11783,
  },
  {
    type: 'cityName',
    value: 'GOVINDNAGAR, UTTAR PRADESH',
    masterId: 18473,
  },
  {
    type: 'cityName',
    value: 'GOBINDPUR DUGLI, UTTAR PRADESH',
    masterId: 16538,
  },
  {
    type: 'cityName',
    value: 'GOVINDPURI, UTTAR PRADESH',
    masterId: 11796,
  },
  {
    type: 'cityName',
    value: 'RAJGANGPUR, ORISSA',
    masterId: 14579,
  },
  {
    type: 'cityName',
    value: 'SATAPATI, WEST BENGAL',
    masterId: 14966,
  },
  {
    type: 'cityName',
    value: 'GHATPRABHA, KARNATAKA',
    masterId: 11700,
  },
  {
    type: 'cityName',
    value: 'GHATPINDRAI, MADHYA PRADESH',
    masterId: 17894,
  },
  {
    type: 'cityName',
    value: 'KAVARAIPETTAI, TAMIL NADU',
    masterId: 12619,
  },
  {
    type: 'cityName',
    value: 'GUDIPUDI, ANDHRA PRADESH',
    masterId: 11807,
  },
  {
    type: 'cityName',
    value: 'GOGIPOTHIA, BIHAR ',
    masterId: 18746,
  },
  {
    type: 'cityName',
    value: 'GARPOS, ORISSA',
    masterId: 11666,
  },
  {
    type: 'cityName',
    value: 'GORAPUR, ANDHRA PRADESH',
    masterId: 11773,
  },
  {
    type: 'cityName',
    value: 'GULAPALYAMU, ANDHRA PRADESH',
    masterId: 11820,
  },
  {
    type: 'cityName',
    value: 'GAUTAMPURA ROAD, MADHYA PRADESH',
    masterId: 20882,
  },
  {
    type: 'cityName',
    value: 'GANGAYAPALLE, ANDHRA PRADESH',
    masterId: 11636,
  },
  {
    type: 'cityName',
    value: 'GOHPUR, ASSAM',
    masterId: 11738,
  },
  {
    type: 'cityName',
    value: 'GOURDAHA (HALT), WEST BENGAL',
    masterId: 21175,
  },
  {
    type: 'cityName',
    value: 'GURLA, RAJASTHAN',
    masterId: 11861,
  },
  {
    type: 'cityName',
    value: 'GARHANI, BIHAR',
    masterId: 18753,
  },
  {
    type: 'cityName',
    value: 'GULBARGA, KARNATAKA',
    masterId: 11823,
  },
  {
    type: 'cityName',
    value: 'GHARAUNDA, HARYANA',
    masterId: 11690,
  },
  {
    type: 'cityName',
    value: 'GURAP, WEST BENGAL',
    masterId: 21210,
  },
  {
    type: 'cityName',
    value: 'GARKHA, UTTAR PRADESH',
    masterId: 18752,
  },
  {
    type: 'cityName',
    value: 'GARH DHRUBESWAR, WEST BENGAL',
    masterId: 11652,
  },
  {
    type: 'cityName',
    value: 'GAREA BIHAR, JHARKHAND',
    masterId: 20847,
  },
  {
    type: 'cityName',
    value: 'GARUGUBILLI, ANDHRA PRADESH',
    masterId: 11667,
  },
  {
    type: 'cityName',
    value: 'RAMACHANDRAPUR, ORISSA',
    masterId: 17441,
  },
  {
    type: 'cityName',
    value: 'GIRIDIH, JHARKHAND',
    masterId: 11723,
  },
  {
    type: 'cityName',
    value: 'GOLA ROAD, JHARKHAND',
    masterId: 16221,
  },
  {
    type: 'cityName',
    value: 'MANGROL, RAJASTHAN',
    masterId: 13424,
  },
  {
    type: 'cityName',
    value: 'GHORASAHAN, BIHAR',
    masterId: 11711,
  },
  {
    type: 'cityName',
    value: 'GIR HADMATIYA, GUJARAT',
    masterId: 19089,
  },
  {
    type: 'cityName',
    value: 'GARRA, MADHYA PRADESH',
    masterId: 20872,
  },
  {
    type: 'cityName',
    value: 'GURIYA, RAJASTHAN',
    masterId: 11860,
  },
  {
    type: 'cityName',
    value: 'GATRA HALT, MAHARASHTRA',
    masterId: 20902,
  },
  {
    type: 'cityName',
    value: 'GORINJA, GUJARAT',
    masterId: 11779,
  },
  {
    type: 'cityName',
    value: 'GURHA KEMLA, HARYANA',
    masterId: 18316,
  },
  {
    type: 'cityName',
    value: 'GOREKHANATH, ORISSA',
    masterId: 17537,
  },
  {
    type: 'cityName',
    value: 'GORAUL, BIHAR',
    masterId: 11774,
  },
  {
    type: 'cityName',
    value: 'GARHMAU, UTTAR PRADESH',
    masterId: 16547,
  },
  {
    type: 'cityName',
    value: 'GHORMARA, JHARKHAND',
    masterId: 11712,
  },
  {
    type: 'cityName',
    value: 'GANGARAMPUR, WEST BENGAL',
    masterId: 11633,
  },
  {
    type: 'cityName',
    value: 'MANIKPUR, UTTAR PRADESH',
    masterId: 13432,
  },
  {
    type: 'cityName',
    value: 'KOLHAPUR, MAHARASHTRA',
    masterId: 12843,
  },
  {
    type: 'cityName',
    value: 'GURNEY, PUNJAB',
    masterId: 11862,
  },
  {
    type: 'cityName',
    value: 'GURRA, MADHYA PRADESH',
    masterId: 11864,
  },
  {
    type: 'cityName',
    value: 'GANGPUR, WEST BENGAL',
    masterId: 21068,
  },
  {
    type: 'cityName',
    value: 'GORPHAR, BIHAR',
    masterId: 18745,
  },
  {
    type: 'cityName',
    value: 'GURLI RAMGARHWA, UTTAR PRADESH',
    masterId: 16533,
  },
  {
    type: 'cityName',
    value: 'GURARU, BIHAR',
    masterId: 11852,
  },
  {
    type: 'cityName',
    value: 'GAROPARA, WEST BENGAL',
    masterId: 18917,
  },
  {
    type: 'cityName',
    value: 'GHORAWADI, MAHARASHTRA',
    masterId: 17893,
  },
  {
    type: 'cityName',
    value: 'GAURA, UTTAR PRADESH',
    masterId: 11670,
  },
  {
    type: 'cityName',
    value: 'GORAYA, PUNJAB',
    masterId: 11775,
  },
  {
    type: 'cityName',
    value: 'GURTURI, HARYANA',
    masterId: 18228,
  },
  {
    type: 'cityName',
    value: 'GODHANESWAR, GUJARAT',
    masterId: 17499,
  },
  {
    type: 'cityName',
    value: 'GUAGACHHA, ASSAM',
    masterId: 18915,
  },
  {
    type: 'cityName',
    value: 'GARNA SAHIB, PUNJAB',
    masterId: 17364,
  },
  {
    type: 'cityName',
    value: 'GHOSUNDA, RAJASTHAN',
    masterId: 17269,
  },
  {
    type: 'cityName',
    value: 'GOSAINGRAM, WEST BENGAL',
    masterId: 16141,
  },
  {
    type: 'cityName',
    value: 'GAUSGANJ, UTTAR PRADESH',
    masterId: 16544,
  },
  {
    type: 'cityName',
    value: 'GHOSI, UTTAR PRADESH',
    masterId: 21051,
  },
  {
    type: 'cityName',
    value: 'GODAPIASAL, WEST BENGAL',
    masterId: 16143,
  },
  {
    type: 'cityName',
    value: 'GHASO KALAN, HARYANA',
    masterId: 18320,
  },
  {
    type: 'cityName',
    value: 'GURDASPUR, PUNJAB',
    masterId: 11855,
  },
  {
    type: 'cityName',
    value: 'KIWLARI, MADHYA PRADESH',
    masterId: 12804,
  },
  {
    type: 'cityName',
    value: 'GUIR SARANGA, WEST BENGAL',
    masterId: 21113,
  },
  {
    type: 'cityName',
    value: 'GARHSHANKAR, PUNJAB',
    masterId: 17365,
  },
  {
    type: 'cityName',
    value: 'GAURI SHRI RAM, UTTAR PRADESH',
    masterId: 16545,
  },
  {
    type: 'cityName',
    value: 'GURSAR SHNEWALA, PUNJAB',
    masterId: 11868,
  },
  {
    type: 'cityName',
    value: 'GHATKESAR, ANDHRA PRADESH',
    masterId: 11697,
  },
  {
    type: 'cityName',
    value: 'GOLANTHARA, ORISSA',
    masterId: 17497,
  },
  {
    type: 'cityName',
    value: 'GOURINATHDHAM, WEST BENGAL',
    masterId: 16140,
  },
  {
    type: 'cityName',
    value: 'GOTHAJ, GUJARAT',
    masterId: 11786,
  },
  {
    type: 'cityName',
    value: 'GUMTHAL, UTTAR PRADESH',
    masterId: 11833,
  },
  {
    type: 'cityName',
    value: 'GHUTAI, UTTAR PRADESH',
    masterId: 19071,
  },
  {
    type: 'cityName',
    value: 'GHUTKU, CHHATTISGARH',
    masterId: 11716,
  },
  {
    type: 'cityName',
    value: 'GUNTAKAL, ANDHRA PRADESH',
    masterId: 11849,
  },
  {
    type: 'cityName',
    value: 'GOTLAM, ANDHRA PRADESH',
    masterId: 11788,
  },
  {
    type: 'cityName',
    value: 'GHATAMPUR, UTTAR PRADESH',
    masterId: 11693,
  },
  {
    type: 'cityName',
    value: 'GHATPURI, UTTAR PRADESH',
    masterId: 16542,
  },
  {
    type: 'cityName',
    value: 'GUMTALI, PUNJAB',
    masterId: 17357,
  },
  {
    type: 'cityName',
    value: 'GOTRA, UTTAR PRADESH',
    masterId: 16534,
  },
  {
    type: 'cityName',
    value: 'GHATSHILA, JHARKHAND',
    masterId: 11701,
  },
  {
    type: 'cityName',
    value: 'REVELGANJGHAT, BIHAR',
    masterId: 14733,
  },
  {
    type: 'cityName',
    value: 'GHATNANDUR, MAHARASHTRA',
    masterId: 11698,
  },
  {
    type: 'cityName',
    value: 'FARHADA, CHHATTISGARH',
    masterId: 11562,
  },
  {
    type: 'cityName',
    value: 'GHATVAD, GUJARAT',
    masterId: 18475,
  },
  {
    type: 'cityName',
    value: 'GOTHAN, GUJARAT',
    masterId: 11787,
  },
  {
    type: 'cityName',
    value: 'GOLA PATI, MADHYA PRADESH',
    masterId: 17842,
  },
  {
    type: 'cityName',
    value: 'KIRIBURU, JHARKHAND',
    masterId: 19106,
  },
  {
    type: 'cityName',
    value: 'GULARBHOJ, UTTARAKHAND',
    masterId: 16255,
  },
  {
    type: 'cityName',
    value: 'MAHULIA, JHARKHAND',
    masterId: 13270,
  },
  {
    type: 'cityName',
    value: 'GUDUM, CHHATTISGARH',
    masterId: 20791,
  },
  {
    type: 'cityName',
    value: 'GARH JAIPUR, WEST BENGAL',
    masterId: 12127,
  },
  {
    type: 'cityName',
    value: 'GHAZIABAD, UTTAR PRADESH',
    masterId: 11703,
  },
  {
    type: 'cityName',
    value: 'GUNTAKODURU, ANDHRA PRADESH',
    masterId: 19030,
  },
  {
    type: 'cityName',
    value: 'GUMA, JHARKHAND',
    masterId: 20860,
  },
  {
    type: 'cityName',
    value: 'GORUMAHISANI, ODISHA',
    masterId: 20914,
  },
  {
    type: 'cityName',
    value: 'GUNA, MADHYA PRADESH',
    masterId: 11834,
  },
  {
    type: 'cityName',
    value: 'GHUNAS, PUNJAB',
    masterId: 17360,
  },
  {
    type: 'cityName',
    value: 'GAURIPUR, ASSAM',
    masterId: 11675,
  },
  {
    type: 'cityName',
    value: 'GANAGAPUR ROAD, KARNATAKA',
    masterId: 11616,
  },
  {
    type: 'cityName',
    value: 'GURUDAS NAGAR, PUNJAB',
    masterId: 20957,
  },
  {
    type: 'cityName',
    value: 'GUNDRATIMADUGU, ANDHRA PRADESH',
    masterId: 11843,
  },
  {
    type: 'cityName',
    value: 'GURUVAYUR, KERALA',
    masterId: 11873,
  },
  {
    type: 'cityName',
    value: 'GURHI, MADHYA PRADESH',
    masterId: 11858,
  },
  {
    type: 'cityName',
    value: 'GUMANIHAT, WEST BENGAL',
    masterId: 16139,
  },
  {
    type: 'cityName',
    value: 'GANGUWADA, ANDHRA PRADESH',
    masterId: 19031,
  },
  {
    type: 'cityName',
    value: 'GUNERU BAMORI, MADHYA PRADESH',
    masterId: 11847,
  },
  {
    type: 'cityName',
    value: 'GHOLVAD, MAHARASHTRA',
    masterId: 11709,
  },
  {
    type: 'cityName',
    value: 'GOVINDPUR, JHARKHAND',
    masterId: 18183,
  },
  {
    type: 'cityName',
    value: 'GOVINDGARH, PUNJAB',
    masterId: 11793,
  },
  {
    type: 'cityName',
    value: 'GOVIND GARH, RAJASTHAN',
    masterId: 17171,
  },
  {
    type: 'cityName',
    value: 'GARIVIDI, ANDHRA PRADESH',
    masterId: 11660,
  },
  {
    type: 'cityName',
    value: 'GUDLAVALLERU, ANDHRA PRADESH',
    masterId: 11811,
  },
  {
    type: 'cityName',
    value: 'GOVINDI MARWAR, RAJASTHAN',
    masterId: 11795,
  },
  {
    type: 'cityName',
    value: 'GORESWAR, ASSAM',
    masterId: 11778,
  },
  {
    type: 'cityName',
    value: 'GIRWAR, MADHYA PRADESH',
    masterId: 11724,
  },
  {
    type: 'cityName',
    value: 'GANJ DUNDWARA, UTTAR PRADESH',
    masterId: 11643,
  },
  {
    type: 'cityName',
    value: 'GADWAL, ANDHRA PRADESH',
    masterId: 11596,
  },
  {
    type: 'cityName',
    value: 'GHOSWAR, BIHAR',
    masterId: 18748,
  },
  {
    type: 'cityName',
    value: 'GANNAVARAM, ANDHRA PRADESH',
    masterId: 11647,
  },
  {
    type: 'cityName',
    value: 'GANGAWAPUR, UTTAR PRADESH',
    masterId: 16550,
  },
  {
    type: 'cityName',
    value: 'GAUSHALA, UTTARAKHAND',
    masterId: 11676,
  },
  {
    type: 'cityName',
    value: 'GOINDWAL SAHIB, PUNJAB',
    masterId: 20938,
  },
  {
    type: 'cityName',
    value: 'GOWDAVALLI, ANDHRA PRADESH',
    masterId: 11797,
  },
  {
    type: 'cityName',
    value: 'GEONG, HARYANA',
    masterId: 18321,
  },
  {
    type: 'cityName',
    value: 'GOOTY, ANDHRA PRADESH',
    masterId: 11765,
  },
  {
    type: 'cityName',
    value: 'GUDIYATTAM, TAMIL NADU',
    masterId: 11810,
  },
  {
    type: 'cityName',
    value: 'GYANPUR ROAD, UTTAR PRADESH',
    masterId: 11879,
  },
  {
    type: 'cityName',
    value: 'GURAZALA, ANDHRA PRADESH',
    masterId: 19029,
  },
  {
    type: 'cityName',
    value: 'GAJULAPALLI, ANDHRA PRADESH',
    masterId: 11609,
  },
  {
    type: 'cityName',
    value: 'PURANA GUAMALATI, WEST BENGAL',
    masterId: 14507,
  },
  {
    type: 'cityName',
    value: 'GAZOLE, WEST BENGAL',
    masterId: 11682,
  },
  {
    type: 'cityName',
    value: 'GZ SANDHWAN, PUNJAB',
    masterId: 19135,
  },
  {
    type: 'cityName',
    value: 'DADRI GHAT, UTTAR PRADESH ',
    masterId: 16587,
  },
  {
    type: 'cityName',
    value: 'HARGAON, UTTAR PRADESH',
    masterId: 16757,
  },
  {
    type: 'cityName',
    value: 'HARWADA, KARNATAKA',
    masterId: 11954,
  },
  {
    type: 'cityName',
    value: 'BAH, UTTAR PRADESH',
    masterId: 20608,
  },
  {
    type: 'cityName',
    value: 'HARIPAD, KERALA',
    masterId: 11938,
  },
  {
    type: 'cityName',
    value: 'HOSA AGRAHARA LAKE, KARNATAKA',
    masterId: 18026,
  },
  {
    type: 'cityName',
    value: 'HAMIRHATI, WEST BENGAL',
    masterId: 21123,
  },
  {
    type: 'cityName',
    value: 'HINDAUN, RAJASTHAN',
    masterId: 11990,
  },
  {
    type: 'cityName',
    value: 'HAPA, GUJARAT',
    masterId: 11918,
  },
  {
    type: 'cityName',
    value: 'HASTHAVARAM, ANDHRA PRADESH',
    masterId: 11958,
  },
  {
    type: 'cityName',
    value: 'HASSAN, KARNATAKA',
    masterId: 11957,
  },
  {
    type: 'cityName',
    value: 'HATHURAN, GUJARAT',
    masterId: 11966,
  },
  {
    type: 'cityName',
    value: 'HATIBARI, ORISSA',
    masterId: 16137,
  },
  {
    type: 'cityName',
    value: 'HATI, MADHYA PRADESH',
    masterId: 18613,
  },
  {
    type: 'cityName',
    value: 'HAUR, WEST BENGAL',
    masterId: 16219,
  },
  {
    type: 'cityName',
    value: 'HABRA, MADHYA PRADESH',
    masterId: 20891,
  },
  {
    type: 'cityName',
    value: 'HOSHANGABAD, MADHYA PRADESH',
    masterId: 12030,
  },
  {
    type: 'cityName',
    value: 'HABIBPUR, WEST BENGAL',
    masterId: 21252,
  },
  {
    type: 'cityName',
    value: 'HADOBHANGI, ORISSA',
    masterId: 19028,
  },
  {
    type: 'cityName',
    value: 'HOMBAL, KARNATAKA',
    masterId: 12020,
  },
  {
    type: 'cityName',
    value: 'HBL NAGAR, TELANGANA',
    masterId: 16032,
  },
  {
    type: 'cityName',
    value: 'HAIBARGAON, ASSAM',
    masterId: 18971,
  },
  {
    type: 'cityName',
    value: 'HARPAR BOCHAHA, BIHAR',
    masterId: 20745,
  },
  {
    type: 'cityName',
    value: 'HEBSUR, KARNATAKA',
    masterId: 11977,
  },
  {
    type: 'cityName',
    value: 'HALBARGA, KARNATAKA',
    masterId: 18035,
  },
  {
    type: 'cityName',
    value: 'HABIBWALA, UTTAR PRADESH',
    masterId: 16531,
  },
  {
    type: 'cityName',
    value: 'BHILAI H CABIN, CHHATTISGARH',
    masterId: 18614,
  },
  {
    type: 'cityName',
    value: 'HARICHANDRAPURAM, ANDHRA PRADESH',
    masterId: 19026,
  },
  {
    type: 'cityName',
    value: 'HARICHANDANPUR, ORISSA',
    masterId: 11931,
  },
  {
    type: 'cityName',
    value: 'HARCHANDPUR, UTTAR PRADESH',
    masterId: 11923,
  },
  {
    type: 'cityName',
    value: 'HARISHCHANDRAPUR, WEST BENGAL',
    masterId: 11942,
  },
  {
    type: 'cityName',
    value: 'HARDA, MADHYA PRADESH',
    masterId: 11924,
  },
  {
    type: 'cityName',
    value: 'HIRNODA, RAJASTHAN',
    masterId: 12004,
  },
  {
    type: 'cityName',
    value: 'HALDIBARI, WEST BENGAL',
    masterId: 11899,
  },
  {
    type: 'cityName',
    value: 'HARISHDADPUR PH, WEST BENGAL',
    masterId: 21236,
  },
  {
    type: 'cityName',
    value: 'HADDINAGUNDU, KARNATAKA',
    masterId: 11881,
  },
  {
    type: 'cityName',
    value: 'HARDAS BIGHA, BIHAR',
    masterId: 11925,
  },
  {
    type: 'cityName',
    value: 'HADGAON, MAHARASHTRA',
    masterId: 17738,
  },
  {
    type: 'cityName',
    value: 'HANDIA, UTTAR PRADESH',
    masterId: 11913,
  },
  {
    type: 'cityName',
    value: 'HODAL, HARYANA',
    masterId: 12014,
  },
  {
    type: 'cityName',
    value: 'HIRDAMALI, MAHARASHTRA',
    masterId: 17664,
  },
  {
    type: 'cityName',
    value: 'KORMA, JHARKHAND',
    masterId: 12888,
  },
  {
    type: 'cityName',
    value: 'HARIDASPUR, ORISSA',
    masterId: 17492,
  },
  {
    type: 'cityName',
    value: 'HARDATTPUR, UTTAR PRADESH',
    masterId: 16758,
  },
  {
    type: 'cityName',
    value: 'HARDUA, MADHYA PRADESH',
    masterId: 11928,
  },
  {
    type: 'cityName',
    value: 'HALDWANI, UTTARAKHAND',
    masterId: 11901,
  },
  {
    type: 'cityName',
    value: 'HARDORAWAL, PUNJAB',
    masterId: 20942,
  },
  {
    type: 'cityName',
    value: 'HEGGERE, KARNATAKA',
    masterId: 18030,
  },
  {
    type: 'cityName',
    value: 'HIMAYATNAGAR, MAHARASHTRA',
    masterId: 11985,
  },
  {
    type: 'cityName',
    value: 'HENRYA PH, WEST BENGAL',
    masterId: 21093,
  },
  {
    type: 'cityName',
    value: 'HER, MAHARASHTRA',
    masterId: 11981,
  },
  {
    type: 'cityName',
    value: 'HETAMPUR, MADHYA PRADESH',
    masterId: 16135,
  },
  {
    type: 'cityName',
    value: 'HAFIZPETA, ANDHRA PRADESH',
    masterId: 11884,
  },
  {
    type: 'cityName',
    value: 'HOTGI, MAHARASHTRA',
    masterId: 12034,
  },
  {
    type: 'cityName',
    value: 'HOGLA, WEST BENGAL',
    masterId: 21250,
  },
  {
    type: 'cityName',
    value: 'HAIDARGARH, UTTAR PRADESH',
    masterId: 11891,
  },
  {
    type: 'cityName',
    value: 'HAGARI, KARNATAKA',
    masterId: 11887,
  },
  {
    type: 'cityName',
    value: 'HARDUAGANJ, UTTAR PRADESH',
    masterId: 16528,
  },
  {
    type: 'cityName',
    value: 'HARANGUL, MAHARASHTRA',
    masterId: 11922,
  },
  {
    type: 'cityName',
    value: 'HEMAGIRI, CHHATTISGARH',
    masterId: 11978,
  },
  {
    type: 'cityName',
    value: 'HINGANGHAT, MAHARASHTRA',
    masterId: 11992,
  },
  {
    type: 'cityName',
    value: 'NEELOOR, KARNATAKA',
    masterId: 13956,
  },
  {
    type: 'cityName',
    value: 'HEHEGARA, JHARKHAND',
    masterId: 18179,
  },
  {
    type: 'cityName',
    value: 'HIREHALLI, KARNATAKA',
    masterId: 18029,
  },
  {
    type: 'cityName',
    value: 'HARISHPUR, UTTAR PRADESH',
    masterId: 16220,
  },
  {
    type: 'cityName',
    value: 'HABANGHATA, KARNATAKA',
    masterId: 18036,
  },
  {
    type: 'cityName',
    value: 'HAJIGARH, WEST BENGAL',
    masterId: 21209,
  },
  {
    type: 'cityName',
    value: 'HILSA, BIHAR',
    masterId: 11983,
  },
  {
    type: 'cityName',
    value: 'HIND-SHAMLI, UTTAR PRADESH',
    masterId: 17353,
  },
  {
    type: 'cityName',
    value: 'GUHIPUR, ORISSA',
    masterId: 11814,
  },
  {
    type: 'cityName',
    value: 'HARINAGAR, BIHAR',
    masterId: 11937,
  },
  {
    type: 'cityName',
    value: 'HOJAI, ASSAM',
    masterId: 12015,
  },
  {
    type: 'cityName',
    value: 'HUGRAJULI, ASSAM',
    masterId: 18912,
  },
  {
    type: 'cityName',
    value: 'HAJIPUR, BIHAR',
    masterId: 11893,
  },
  {
    type: 'cityName',
    value: 'HELAK, RAJASTHAN',
    masterId: 17267,
  },
  {
    type: 'cityName',
    value: 'HAILAKANDI, ASSAM',
    masterId: 11892,
  },
  {
    type: 'cityName',
    value: 'HIRAKUD, ORISSA',
    masterId: 11997,
  },
  {
    type: 'cityName',
    value: 'HARKIYAKHAL, RAJASTHAN',
    masterId: 11943,
  },
  {
    type: 'cityName',
    value: 'HAKIMPUR, UTTAR PRADESH',
    masterId: 11895,
  },
  {
    type: 'cityName',
    value: 'HIWARKHED, MAHARASHTRA',
    masterId: 12007,
  },
  {
    type: 'cityName',
    value: 'HOLE ALUR, KARNATAKA',
    masterId: 12017,
  },
  {
    type: 'cityName',
    value: 'HADALA BHAL, GUJARAT',
    masterId: 19093,
  },
  {
    type: 'cityName',
    value: 'HALUDPUKUR, JHARKHAND',
    masterId: 20858,
  },
  {
    type: 'cityName',
    value: 'HALDI ROAD, UTTARAKHAND',
    masterId: 11898,
  },
  {
    type: 'cityName',
    value: 'HALDAUR, UTTAR PRADESH',
    masterId: 11897,
  },
  {
    type: 'cityName',
    value: 'HEELALIGE, KARNATAKA',
    masterId: 18031,
  },
  {
    type: 'cityName',
    value: 'HOLALKERE, KARNATAKA',
    masterId: 12016,
  },
  {
    type: 'cityName',
    value: 'HALLIKHED, KARNATAKA',
    masterId: 20864,
  },
  {
    type: 'cityName',
    value: 'HALAKATTA, KARNATAKA',
    masterId: 16033,
  },
  {
    type: 'cityName',
    value: 'HOLENARASIPUR, KARNATAKA',
    masterId: 12019,
  },
  {
    type: 'cityName',
    value: 'HALDHARPUR, UTTAR PRADESH',
    masterId: 16530,
  },
  {
    type: 'cityName',
    value: 'KANCHRAPARA, WEST BENGAL',
    masterId: 12471,
  },
  {
    type: 'cityName',
    value: 'HALIYURU, KARNATAKA',
    masterId: 18034,
  },
  {
    type: 'cityName',
    value: 'HIRNAWALI, RAJASTHAN',
    masterId: 17162,
  },
  {
    type: 'cityName',
    value: 'HILARA, ASSAM',
    masterId: 11982,
  },
  {
    type: 'cityName',
    value: 'RANGIBASAN, WEST BENGAL',
    masterId: 14655,
  },
  {
    type: 'cityName',
    value: 'HADMATIYA, GUJARAT',
    masterId: 11882,
  },
  {
    type: 'cityName',
    value: 'HUMMA, ORISSA',
    masterId: 17536,
  },
  {
    type: 'cityName',
    value: 'HUMNABAD, KARNATAKA',
    masterId: 12042,
  },
  {
    type: 'cityName',
    value: 'HAMRE, JAMMU AND KASHMIR',
    masterId: 20838,
  },
  {
    type: 'cityName',
    value: 'HAMIRGARH, RAJASTHAN',
    masterId: 11909,
  },
  {
    type: 'cityName',
    value: 'HANUMANGARH, RAJASTHAN',
    masterId: 11916,
  },
  {
    type: 'cityName',
    value: 'HIMMATANA, PUNJAB',
    masterId: 11986,
  },
  {
    type: 'cityName',
    value: 'HINDUMALKOT, RAJASTHAN',
    masterId: 17352,
  },
  {
    type: 'cityName',
    value: 'HELEM, ASSAM',
    masterId: 18914,
  },
  {
    type: 'cityName',
    value: 'HANUMAN GARH, RAJASTHAN',
    masterId: 19143,
  },
  {
    type: 'cityName',
    value: 'HEMPUR, UTTAR PRADESH',
    masterId: 18913,
  },
  {
    type: 'cityName',
    value: 'HURMUJPUR, UTTAR PRADESH',
    masterId: 16524,
  },
  {
    type: 'cityName',
    value: 'HIMMATPURA, HARYANA',
    masterId: 17354,
  },
  {
    type: 'cityName',
    value: 'HAMIRA, PUNJAB',
    masterId: 11908,
  },
  {
    type: 'cityName',
    value: 'TAMBADSHET, MAHARASHTRA',
    masterId: 15418,
  },
  {
    type: 'cityName',
    value: 'HARMUTI, ASSAM',
    masterId: 11944,
  },
  {
    type: 'cityName',
    value: 'HIND MOTOR, WEST BENGAL',
    masterId: 21077,
  },
  {
    type: 'cityName',
    value: 'HATHBANDH, CHHATTISGARH',
    masterId: 11960,
  },
  {
    type: 'cityName',
    value: 'KARKI, KARNATAKA',
    masterId: 12559,
  },
  {
    type: 'cityName',
    value: 'HASANABAD, WEST BENGAL',
    masterId: 21166,
  },
  {
    type: 'cityName',
    value: 'HINDOL, ORISSA',
    masterId: 17530,
  },
  {
    type: 'cityName',
    value: 'HENDEGIR, JHARKHAND',
    masterId: 18226,
  },
  {
    type: 'cityName',
    value: 'HARANGAON, UTTAR PRADESH',
    masterId: 17892,
  },
  {
    type: 'cityName',
    value: 'HANUMANAHALLI, KARNATAKA',
    masterId: 18097,
  },
  {
    type: 'cityName',
    value: 'HANAKERE, KARNATAKA',
    masterId: 11912,
  },
  {
    type: 'cityName',
    value: 'HINGOLI, MAHARASHTRA',
    masterId: 11994,
  },
  {
    type: 'cityName',
    value: 'HINAUTARAMBAN, MADHYA PRADESH',
    masterId: 11989,
  },
  {
    type: 'cityName',
    value: 'HANUMAN CIRCLE, ANDHRA PRADESH',
    masterId: 19027,
  },
  {
    type: 'cityName',
    value: 'HARSANA KALAN, HARYANA',
    masterId: 18315,
  },
  {
    type: 'cityName',
    value: 'HANDAPA, ORISSA',
    masterId: 17494,
  },
  {
    type: 'cityName',
    value: 'HANSARA, ASSAM',
    masterId: 17493,
  },
  {
    type: 'cityName',
    value: 'HANSI, HARYANA',
    masterId: 11914,
  },
  {
    type: 'cityName',
    value: 'HESALANG, WEST BENGAL',
    masterId: 18178,
  },
  {
    type: 'cityName',
    value: 'HANSPURA, MADHYA PRADESH',
    masterId: 18741,
  },
  {
    type: 'cityName',
    value: 'HALDIA, BIHAR ',
    masterId: 18742,
  },
  {
    type: 'cityName',
    value: 'HONAGANAHALLI, KARNATAKA',
    masterId: 18028,
  },
  {
    type: 'cityName',
    value: 'HAMILTONGANJ, WEST BENGAL',
    masterId: 11907,
  },
  {
    type: 'cityName',
    value: 'DABLI, MAHARASHTRA',
    masterId: 11181,
  },
  {
    type: 'cityName',
    value: 'HARIPUR, RAJASTHAN',
    masterId: 11940,
  },
  {
    type: 'cityName',
    value: 'HAMPAPURA, KARNATAKA',
    masterId: 18033,
  },
  {
    type: 'cityName',
    value: 'HUPPUGUDA, ANDHRA PRADESH',
    masterId: 12048,
  },
  {
    type: 'cityName',
    value: 'HARIPUR GRAM, ORISSA',
    masterId: 17491,
  },
  {
    type: 'cityName',
    value: 'HINOTIA PIPALKHERA, MADHYA PRADESH',
    masterId: 17841,
  },
  {
    type: 'cityName',
    value: 'HARIPAL, WEST BENGAL',
    masterId: 20781,
  },
  {
    type: 'cityName',
    value: 'HATPURANI, BIHAR',
    masterId: 18737,
  },
  {
    type: 'cityName',
    value: 'HATPURAINI, BIHAR',
    masterId: 11969,
  },
  {
    type: 'cityName',
    value: 'HASANPUR, BIHAR',
    masterId: 18738,
  },
  {
    type: 'cityName',
    value: 'HARPALPUR, MADHYA PRADESH',
    masterId: 11948,
  },
  {
    type: 'cityName',
    value: 'HIRAPUR, MAHARASHTRA',
    masterId: 17840,
  },
  {
    type: 'cityName',
    value: 'HAPA ROAD, GUJARAT',
    masterId: 19094,
  },
  {
    type: 'cityName',
    value: 'HOSAPETE, KARNATAKA',
    masterId: 12029,
  },
  {
    type: 'cityName',
    value: 'HAPUR, UTTAR PRADESH',
    masterId: 11919,
  },
  {
    type: 'cityName',
    value: 'HIRENANDURU, KARNATAKA',
    masterId: 12001,
  },
  {
    type: 'cityName',
    value: 'HARPALOO, RAJASTHAN',
    masterId: 17164,
  },
  {
    type: 'cityName',
    value: 'GANGPUR, MADHYA PRADESH',
    masterId: 11640,
  },
  {
    type: 'cityName',
    value: 'HARUBERA, JHARKHAND',
    masterId: 18180,
  },
  {
    type: 'cityName',
    value: 'HIRODIH, JHARKHAND',
    masterId: 20854,
  },
  {
    type: 'cityName',
    value: 'HARHRAS QILAH, UTTAR PRADESH',
    masterId: 21062,
  },
  {
    type: 'cityName',
    value: 'CHHINDIKAMATH, MADHYA PRADESH',
    masterId: 11063,
  },
  {
    type: 'cityName',
    value: 'HARTHALA, UTTAR PRADESH',
    masterId: 16526,
  },
  {
    type: 'cityName',
    value: 'HADMADIYA, GUJARAT',
    masterId: 18471,
  },
  {
    type: 'cityName',
    value: 'HARAUNI, UTTAR PRADESH',
    masterId: 16529,
  },
  {
    type: 'cityName',
    value: 'HARPUR NAG, BIHAR',
    masterId: 18740,
  },
  {
    type: 'cityName',
    value: 'HIRA NAGAR, JAMMU AND KASHMIR',
    masterId: 11996,
  },
  {
    type: 'cityName',
    value: 'HARUA ROAD, WEST BENGAL',
    masterId: 21159,
  },
  {
    type: 'cityName',
    value: 'HARPALGANJ, UTTAR PRADESH',
    masterId: 16034,
  },
  {
    type: 'cityName',
    value: 'DEVINAGAR, UTTAR PRADESH',
    masterId: 11318,
  },
  {
    type: 'cityName',
    value: 'HILLAR SHAHABAD HALT, JAMMU AND KASHMIR',
    masterId: 20825,
  },
  {
    type: 'cityName',
    value: 'HARISINGA, ASSAM',
    masterId: 18970,
  },
  {
    type: 'cityName',
    value: 'HARISH NAGAR HALT, WEST BENGAL',
    masterId: 21139,
  },
  {
    type: 'cityName',
    value: 'HARNAUT, BIHAR',
    masterId: 11945,
  },
  {
    type: 'cityName',
    value: 'HARAD, MADHYA PRADESH',
    masterId: 11920,
  },
  {
    type: 'cityName',
    value: 'HARRAWALA, UTTARAKHAND',
    masterId: 11950,
  },
  {
    type: 'cityName',
    value: 'HASIMARA, WEST BENGAL',
    masterId: 11956,
  },
  {
    type: 'cityName',
    value: 'HASAN BAZAR, BIHAR',
    masterId: 18739,
  },
  {
    type: 'cityName',
    value: 'BIDARAKERE, KARNATAKA',
    masterId: 10802,
  },
  {
    type: 'cityName',
    value: 'HANSDIHA, JHARKHAND',
    masterId: 18181,
  },
  {
    type: 'cityName',
    value: 'HARSOLI, RAJASTHAN',
    masterId: 11952,
  },
  {
    type: 'cityName',
    value: 'HARISHANKER RD, ORISSA',
    masterId: 11941,
  },
  {
    type: 'cityName',
    value: 'HISVAHAL, MAHARASHTRA',
    masterId: 17663,
  },
  {
    type: 'cityName',
    value: 'HASANPARTI RD, ANDHRA PRADESH',
    masterId: 11955,
  },
  {
    type: 'cityName',
    value: 'HUSAINPUR, PUNJAB',
    masterId: 16523,
  },
  {
    type: 'cityName',
    value: 'HISAR, HARYANA',
    masterId: 12006,
  },
  {
    type: 'cityName',
    value: 'HOSUR, TAMIL NADU',
    masterId: 12033,
  },
  {
    type: 'cityName',
    value: 'HANSIAWAS, RAJASTHAN',
    masterId: 17165,
  },
  {
    type: 'cityName',
    value: 'HOSHIARPUR, PUNJAB',
    masterId: 12031,
  },
  {
    type: 'cityName',
    value: 'HARSINGPUR GOBA, UTTAR PRADESH',
    masterId: 16527,
  },
  {
    type: 'cityName',
    value: 'HOTAR, JHARKHAND',
    masterId: 20861,
  },
  {
    type: 'cityName',
    value: 'HATHRAS, UTTAR PRADESH',
    masterId: 11965,
  },
  {
    type: 'cityName',
    value: 'HATUNDI, RAJASTHAN',
    masterId: 17163,
  },
  {
    type: 'cityName',
    value: 'RANCHI, JHARKHAND',
    masterId: 14647,
  },
  {
    type: 'cityName',
    value: 'HATHIGADH, GUJARAT',
    masterId: 11963,
  },
  {
    type: 'cityName',
    value: 'HATHRAS ROAD, UTTAR PRADESH',
    masterId: 19178,
  },
  {
    type: 'cityName',
    value: 'HATKANANGALE, MAHARASHTRA',
    masterId: 11967,
  },
  {
    type: 'cityName',
    value: 'BARBALI, ASSAM',
    masterId: 10514,
  },
  {
    type: 'cityName',
    value: 'HATHNAPUR, MADHYA PRADESH',
    masterId: 17891,
  },
  {
    type: 'cityName',
    value: 'HITNAL, KARNATAKA',
    masterId: 18095,
  },
  {
    type: 'cityName',
    value: 'HATRA ROAD, MADHYA PRADESH',
    masterId: 20869,
  },
  {
    type: 'cityName',
    value: 'HATHWA, BIHAR',
    masterId: 18829,
  },
  {
    type: 'cityName',
    value: 'HATHIDAH, BIHAR',
    masterId: 11961,
  },
  {
    type: 'cityName',
    value: 'HATHIDAH UPPER, BIHAR',
    masterId: 11962,
  },
  {
    type: 'cityName',
    value: 'HOLAMBI KALAN, DELHI',
    masterId: 18588,
  },
  {
    type: 'cityName',
    value: 'HUNASANAHALLI, KARNATAKA',
    masterId: 18025,
  },
  {
    type: 'cityName',
    value: 'HINDUPUR, ANDHRA PRADESH',
    masterId: 11991,
  },
  {
    type: 'cityName',
    value: 'HALVAD, GUJARAT',
    masterId: 11906,
  },
  {
    type: 'cityName',
    value: 'HONNAVALLI, KARNATAKA',
    masterId: 18027,
  },
  {
    type: 'cityName',
    value: 'HAMSAVARAM, ANDHRA PRADESH',
    masterId: 11911,
  },
  {
    type: 'cityName',
    value: 'HAVERI, KARNATAKA',
    masterId: 11972,
  },
  {
    type: 'cityName',
    value: 'HARIDWAR, UTTARAKHAND',
    masterId: 11932,
  },
  {
    type: 'cityName',
    value: 'KOLKATA, WEST BENGAL',
    masterId: 12847,
  },
  {
    type: 'cityName',
    value: 'HATWAR, WEST BENGAL',
    masterId: 16136,
  },
  {
    type: 'cityName',
    value: 'HANWANT, RAJASTHAN',
    masterId: 11917,
  },
  {
    type: 'cityName',
    value: 'MOSOKA, ASSAM',
    masterId: 13656,
  },
  {
    type: 'cityName',
    value: 'KADAPA, ANDHRA PRADESH',
    masterId: 12322,
  },
  {
    type: 'cityName',
    value: 'HANDIAYA, PUNJAB',
    masterId: 17355,
  },
  {
    type: 'cityName',
    value: 'HOOGHLY GHAT, WEST BENGAL',
    masterId: 16134,
  },
  {
    type: 'cityName',
    value: 'HADIYAL, RAJASTHAN',
    masterId: 17167,
  },
  {
    type: 'cityName',
    value: 'SIRNIA, BIHAR',
    masterId: 15213,
  },
  {
    type: 'cityName',
    value: 'HAZARIBAGH, JHARKHAND',
    masterId: 18227,
  },
  {
    type: 'cityName',
    value: 'SURIYA, JHARKHAND',
    masterId: 15361,
  },
  {
    type: 'cityName',
    value: 'HAZRAT NAGAR, UTTAR PRADESH',
    masterId: 16525,
  },
  {
    type: 'cityName',
    value: 'HAFIZPUR, UTTAR PRADESH',
    masterId: 11885,
  },
  {
    type: 'cityName',
    value: 'INDARA, UTTAR PRADESH',
    masterId: 12068,
  },
  {
    type: 'cityName',
    value: 'MAI, BIHAR',
    masterId: 18701,
  },
  {
    type: 'cityName',
    value: 'IB, ORISSA',
    masterId: 12051,
  },
  {
    type: 'cityName',
    value: 'INDRABIL, WEST BENGAL',
    masterId: 12072,
  },
  {
    type: 'cityName',
    value: 'ICHCHANGADU, TAMIL NADU',
    masterId: 16984,
  },
  {
    type: 'cityName',
    value: 'ICHAULI, UTTAR PRADESH',
    masterId: 12053,
  },
  {
    type: 'cityName',
    value: 'IDAR, GUJARAT',
    masterId: 12058,
  },
  {
    type: 'cityName',
    value: 'INDARGARH, RAJASTHAN',
    masterId: 12069,
  },
  {
    type: 'cityName',
    value: 'IRADATGANJ, UTTAR PRADESH',
    masterId: 16519,
  },
  {
    type: 'cityName',
    value: 'IDALHOND, KARNATAKA',
    masterId: 18024,
  },
  {
    type: 'cityName',
    value: 'INDALVAI, TELANGANA',
    masterId: 16814,
  },
  {
    type: 'cityName',
    value: 'INDEMAU, UTTAR PRADESH',
    masterId: 16522,
  },
  {
    type: 'cityName',
    value: 'INDUPALLI, ANDHRA PRADESH',
    masterId: 19025,
  },
  {
    type: 'cityName',
    value: 'INDI ROAD, KARNATAKA',
    masterId: 12070,
  },
  {
    type: 'cityName',
    value: 'ISHARDASPUR, UTTAR PRADESH',
    masterId: 16518,
  },
  {
    type: 'cityName',
    value: 'SIDLAGHATTA, KARNATAKA',
    masterId: 17977,
  },
  {
    type: 'cityName',
    value: 'IRINGAL, KERALA',
    masterId: 17949,
  },
  {
    type: 'cityName',
    value: 'IGATPURI, MAHARASHTRA',
    masterId: 12059,
  },
  {
    type: 'cityName',
    value: 'INGUR, TAMIL NADU',
    masterId: 16983,
  },
  {
    type: 'cityName',
    value: 'INGORALA, GUJARAT',
    masterId: 12074,
  },
  {
    type: 'cityName',
    value: 'INGOHTA, UTTAR PRADESH',
    masterId: 16521,
  },
  {
    type: 'cityName',
    value: 'KALLETUMKARA, KERALA',
    masterId: 12414,
  },
  {
    type: 'cityName',
    value: 'IKRAN, RAJASTHAN',
    masterId: 17161,
  },
  {
    type: 'cityName',
    value: 'IKDORI, MADHYA PRADESH',
    masterId: 19124,
  },
  {
    type: 'cityName',
    value: 'ITIKYALA, ANDHRA PRADESH',
    masterId: 12094,
  },
  {
    type: 'cityName',
    value: 'IKKAR, UTTARAKHAND',
    masterId: 12060,
  },
  {
    type: 'cityName',
    value: 'EKLERA, MADHYA PRADESH',
    masterId: 11525,
  },
  {
    type: 'cityName',
    value: 'SILAIMAN, TAMIL NADU',
    masterId: 16884,
  },
  {
    type: 'cityName',
    value: 'ILLOO, WEST BENGAL',
    masterId: 16132,
  },
  {
    type: 'cityName',
    value: 'ISMAILPUR, BIHAR',
    masterId: 16517,
  },
  {
    type: 'cityName',
    value: 'IMLI, BIHAR',
    masterId: 17839,
  },
  {
    type: 'cityName',
    value: 'IBRAHIMPUR, KARNATAKA',
    masterId: 16815,
  },
  {
    type: 'cityName',
    value: 'INDORE, MADHYA PRADESH',
    masterId: 12071,
  },
  {
    type: 'cityName',
    value: 'INNANJE, KARNATAKA',
    masterId: 18094,
  },
  {
    type: 'cityName',
    value: 'INTEKANNE, ANDHRA PRADESH',
    masterId: 12077,
  },
  {
    type: 'cityName',
    value: 'INDAPUR, MAHARASHTRA',
    masterId: 12067,
  },
  {
    type: 'cityName',
    value: 'INDAS, WEST BENGAL',
    masterId: 21116,
  },
  {
    type: 'cityName',
    value: 'ICHHAPUR DEFENCE ESTATE, WEST BENGAL',
    masterId: 16133,
  },
  {
    type: 'cityName',
    value: 'ICHCHAPURAM, ANDHRA PRADESH',
    masterId: 12054,
  },
  {
    type: 'cityName',
    value: 'ISLAMPUR, BIHAR',
    masterId: 12085,
  },
  {
    type: 'cityName',
    value: 'IQBALPURA, UTTAR PRADESH',
    masterId: 16245,
  },
  {
    type: 'cityName',
    value: 'IQBALGADH, GUJARAT',
    masterId: 18470,
  },
  {
    type: 'cityName',
    value: 'ISRANA, HARYANA',
    masterId: 18371,
  },
  {
    type: 'cityName',
    value: 'IRGAON, JHARKHAND',
    masterId: 19108,
  },
  {
    type: 'cityName',
    value: 'ERAVIPURAM, KERALA',
    masterId: 10001,
  },
  {
    type: 'cityName',
    value: 'ISARDA, RAJASTHAN',
    masterId: 12081,
  },
  {
    type: 'cityName',
    value: 'ISHURWARA, MADHYA PRADESH',
    masterId: 12082,
  },
  {
    type: 'cityName',
    value: 'ISMAILA-B, HARYANA',
    masterId: 12087,
  },
  {
    type: 'cityName',
    value: 'ITOLA, GUJARAT',
    masterId: 12095,
  },
  {
    type: 'cityName',
    value: 'INTIYATHOK, UTTAR PRADESH',
    masterId: 16520,
  },
  {
    type: 'cityName',
    value: 'ITKI, JHARKHAND',
    masterId: 18177,
  },
  {
    type: 'cityName',
    value: 'ITWARI, MAHARASHTRA',
    masterId: 17661,
  },
  {
    type: 'cityName',
    value: 'JALNA, MAHARASHTRA',
    masterId: 12157,
  },
  {
    type: 'cityName',
    value: 'JALIYA, GUJARAT',
    masterId: 12155,
  },
  {
    type: 'cityName',
    value: 'JHALIDA, WEST BENGAL',
    masterId: 12245,
  },
  {
    type: 'cityName',
    value: 'JALSU, RAJASTHAN',
    masterId: 12161,
  },
  {
    type: 'cityName',
    value: 'JADAR, GUJARAT',
    masterId: 18468,
  },
  {
    type: 'cityName',
    value: 'JALALGARH, BIHAR',
    masterId: 18736,
  },
  {
    type: 'cityName',
    value: 'JAIS, UTTAR PRADESH',
    masterId: 12130,
  },
  {
    type: 'cityName',
    value: 'JHAJHA, BIHAR',
    masterId: 12241,
  },
  {
    type: 'cityName',
    value: 'JAKANUR, KARNATAKA',
    masterId: 18022,
  },
  {
    type: 'cityName',
    value: 'JAWALI, RAJASTHAN',
    masterId: 12221,
  },
  {
    type: 'cityName',
    value: 'JALIYA DEVANI, GUJARAT',
    masterId: 12156,
  },
  {
    type: 'cityName',
    value: 'JAMNAGAR, GUJARAT',
    masterId: 12178,
  },
  {
    type: 'cityName',
    value: 'JAMA, JHARKHAND',
    masterId: 12166,
  },
  {
    type: 'cityName',
    value: 'JARANGDIH, JHARKHAND',
    masterId: 16035,
  },
  {
    type: 'cityName',
    value: 'JAORA, MADHYA PRADESH',
    masterId: 12196,
  },
  {
    type: 'cityName',
    value: 'JANDRAPETA, ANDHRA PRADESH',
    masterId: 12188,
  },
  {
    type: 'cityName',
    value: 'JARI, GUJARAT',
    masterId: 20795,
  },
  {
    type: 'cityName',
    value: 'JAMMU, JAMMU AND KASHMIR',
    masterId: 12177,
  },
  {
    type: 'cityName',
    value: 'JAITPURA, UTTAR PRADESH',
    masterId: 21046,
  },
  {
    type: 'cityName',
    value: 'JHAUA, BIHAR',
    masterId: 18826,
  },
  {
    type: 'cityName',
    value: 'JAMUA, JHARKHAND',
    masterId: 17837,
  },
  {
    type: 'cityName',
    value: 'JAMBUR, GUJARAT',
    masterId: 18464,
  },
  {
    type: 'cityName',
    value: 'JALLALABD, PUNJAB',
    masterId: 19136,
  },
  {
    type: 'cityName',
    value: 'JANG BAHADUR GANJ, UTTAR PRADESH',
    masterId: 16507,
  },
  {
    type: 'cityName',
    value: 'JGMBLA KSHNPRM, ANDHRA PRADESH',
    masterId: 12238,
  },
  {
    type: 'cityName',
    value: 'JOGBANI, BIHAR',
    masterId: 12276,
  },
  {
    type: 'cityName',
    value: 'JAMADOBA, JHARKHAND',
    masterId: 18175,
  },
  {
    type: 'cityName',
    value: 'JAHANGIRABAD, UTTAR PRADESH',
    masterId: 16515,
  },
  {
    type: 'cityName',
    value: 'JADOLI KA BAS, RAJASTHAN',
    masterId: 17160,
  },
  {
    type: 'cityName',
    value: 'JABUGAM, GUJARAT',
    masterId: 18469,
  },
  {
    type: 'cityName',
    value: 'JHABELWALI, PUNJAB',
    masterId: 17347,
  },
  {
    type: 'cityName',
    value: 'JABRI, MADHYA PRADESH',
    masterId: 12099,
  },
  {
    type: 'cityName',
    value: 'CHANDAN, RAJASTHAN',
    masterId: 17199,
  },
  {
    type: 'cityName',
    value: 'JADCHERLA, TELANGANA',
    masterId: 12100,
  },
  {
    type: 'cityName',
    value: 'JUNICHAVAND, GUJARAT',
    masterId: 18457,
  },
  {
    type: 'cityName',
    value: 'JUCHANDRA, MAHARASHTRA',
    masterId: 20898,
  },
  {
    type: 'cityName',
    value: 'JASODA, UTTAR PRADESH',
    masterId: 17836,
  },
  {
    type: 'cityName',
    value: 'JAGDALPUR, CHHATTISGARH',
    masterId: 12115,
  },
  {
    type: 'cityName',
    value: 'MDR87, RAJASTHAN',
    masterId: 17111,
  },
  {
    type: 'cityName',
    value: 'JETHA, CHHATTISGARH',
    masterId: 17156,
  },
  {
    type: 'cityName',
    value: 'JAM JODHPUR JN, GUJARAT',
    masterId: 16036,
  },
  {
    type: 'cityName',
    value: 'JHARRADIH, CHHATTISGARH',
    masterId: 12252,
  },
  {
    type: 'cityName',
    value: 'JAGDEVWALA, RAJASTHAN',
    masterId: 12116,
  },
  {
    type: 'cityName',
    value: 'JAGUDAN, GUJARAT',
    masterId: 18467,
  },
  {
    type: 'cityName',
    value: 'JADABPUR, WEST BENGAL',
    masterId: 20779,
  },
  {
    type: 'cityName',
    value: 'JAGDISHPUR, BIHAR',
    masterId: 19084,
  },
  {
    type: 'cityName',
    value: 'JIWDHARA, BIHAR',
    masterId: 18825,
  },
  {
    type: 'cityName',
    value: 'JARUDA NARAA, UTTAR PRADESH',
    masterId: 16505,
  },
  {
    type: 'cityName',
    value: 'NAKAHA JUNGLE, UTTAR PRADESH',
    masterId: 16391,
  },
  {
    type: 'cityName',
    value: 'JENAPUR, ORISSA',
    masterId: 17486,
  },
  {
    type: 'cityName',
    value: 'JEONATHPUR, UTTAR PRADESH',
    masterId: 16503,
  },
  {
    type: 'cityName',
    value: 'JALESWAR, ORISSA',
    masterId: 12153,
  },
  {
    type: 'cityName',
    value: 'JENAPUR P.H, ORISSA',
    masterId: 17485,
  },
  {
    type: 'cityName',
    value: 'JAITSAR, RAJASTHAN',
    masterId: 12137,
  },
  {
    type: 'cityName',
    value: 'SECBAD JAMES ST, GUJARAT',
    masterId: 20819,
  },
  {
    type: 'cityName',
    value: 'JEUR, MAHARASHTRA',
    masterId: 12235,
  },
  {
    type: 'cityName',
    value: 'JIADHAL DIGHALGARA, ASSAM',
    masterId: 18910,
  },
  {
    type: 'cityName',
    value: 'JAFARGANJ, UTTAR PRADESH',
    masterId: 16516,
  },
  {
    type: 'cityName',
    value: 'JOGIARA, BIHAR',
    masterId: 12278,
  },
  {
    type: 'cityName',
    value: 'JOGESWAR BIHAR, JHARKHAND',
    masterId: 18172,
  },
  {
    type: 'cityName',
    value: 'JAGDISHPUR, JHARKHAND',
    masterId: 12117,
  },
  {
    type: 'cityName',
    value: 'JAGADAL, WEST BENGAL',
    masterId: 18093,
  },
  {
    type: 'cityName',
    value: 'JAGANNATH TEMPLE, KERALA',
    masterId: 17490,
  },
  {
    type: 'cityName',
    value: 'JOGIDIH, UTTAR PRADESH',
    masterId: 18171,
  },
  {
    type: 'cityName',
    value: 'JANGIGANJ, UTTAR PRADESH ',
    masterId: 16506,
  },
  {
    type: 'cityName',
    value: 'JHAGADIA, GUJARAT',
    masterId: 18461,
  },
  {
    type: 'cityName',
    value: 'JAGESHARGANJ, UTTAR PRADESH',
    masterId: 12119,
  },
  {
    type: 'cityName',
    value: 'JUGIJAN, ASSAM',
    masterId: 12290,
  },
  {
    type: 'cityName',
    value: 'JIGNI KHAS, UTTAR PRADESH',
    masterId: 16494,
  },
  {
    type: 'cityName',
    value: 'JATINGA LUMPUR, ASSAM',
    masterId: 12210,
  },
  {
    type: 'cityName',
    value: 'JHARGRAM, WEST BENGAL',
    masterId: 12250,
  },
  {
    type: 'cityName',
    value: 'JAGRAON, PUNJAB',
    masterId: 12122,
  },
  {
    type: 'cityName',
    value: 'JOGENDRA NAGAR, TRIPURA',
    masterId: 16789,
  },
  {
    type: 'cityName',
    value: 'JALALPUR, UTTAR PRADESH',
    masterId: 16510,
  },
  {
    type: 'cityName',
    value: 'JASWANTNAGAR, UTTAR PRADESH',
    masterId: 12209,
  },
  {
    type: 'cityName',
    value: 'JOGIWALA, PUNJAB',
    masterId: 16254,
  },
  {
    type: 'cityName',
    value: 'JAGJIVAN HALT, BIHAR',
    masterId: 20741,
  },
  {
    type: 'cityName',
    value: 'JAKHAURA, UTTAR PRADESH',
    masterId: 16512,
  },
  {
    type: 'cityName',
    value: 'JHAMATPUR BAHARAN, WEST BENGAL',
    masterId: 16130,
  },
  {
    type: 'cityName',
    value: 'JEHANABAD, BIHAR',
    masterId: 12228,
  },
  {
    type: 'cityName',
    value: 'SH17, BIHAR',
    masterId: 16720,
  },
  {
    type: 'cityName',
    value: 'JHINGURA, UTTAR PRADESH',
    masterId: 16496,
  },
  {
    type: 'cityName',
    value: 'JHALRA, UTTAR PRADESH',
    masterId: 17265,
  },
  {
    type: 'cityName',
    value: 'JHIR, RAJASTHAN',
    masterId: 12256,
  },
  {
    type: 'cityName',
    value: 'JHAJJAR, HARYANA',
    masterId: 12242,
  },
  {
    type: 'cityName',
    value: 'JETHUKE, PUNJAB',
    masterId: 17348,
  },
  {
    type: 'cityName',
    value: 'JAKHAL, HARYANA',
    masterId: 12142,
  },
  {
    type: 'cityName',
    value: 'JHIMRI, JHARKHAND',
    masterId: 18174,
  },
  {
    type: 'cityName',
    value: 'JAKHIM, BIHAR',
    masterId: 12146,
  },
  {
    type: 'cityName',
    value: 'JHANSI, UTTAR PRADESH',
    masterId: 12248,
  },
  {
    type: 'cityName',
    value: 'JUNEHTA, MADHYA PRADESH',
    masterId: 17832,
  },
  {
    type: 'cityName',
    value: 'JHAWAR, PUNJAB',
    masterId: 16499,
  },
  {
    type: 'cityName',
    value: 'JHUSI, WEST BENGAL',
    masterId: 16495,
  },
  {
    type: 'cityName',
    value: 'JIGNA, UTTAR PRADESH',
    masterId: 12260,
  },
  {
    type: 'cityName',
    value: 'JALILA, GUJARAT',
    masterId: 18466,
  },
  {
    type: 'cityName',
    value: 'JIND, HARYANA',
    masterId: 12263,
  },
  {
    type: 'cityName',
    value: 'ZIRA, GUJARAT',
    masterId: 17405,
  },
  {
    type: 'cityName',
    value: 'JIRAT, WEST BENGAL',
    masterId: 12270,
  },
  {
    type: 'cityName',
    value: 'JITE, MAHARASHTRA',
    masterId: 17655,
  },
  {
    type: 'cityName',
    value: 'JAJAU, UTTAR PRADESH',
    masterId: 16513,
  },
  {
    type: 'cityName',
    value: 'JAJAN PATTI, RAJASTHAN',
    masterId: 16514,
  },
  {
    type: 'cityName',
    value: 'JIAGANJ, WEST BENGAL',
    masterId: 12259,
  },
  {
    type: 'cityName',
    value: 'JAIJON DOABA, PUNJAB',
    masterId: 17351,
  },
  {
    type: 'cityName',
    value: 'JHINJHAK, UTTAR PRADESH',
    masterId: 12255,
  },
  {
    type: 'cityName',
    value: 'JAJPUR K ROAD, ORISSA',
    masterId: 12141,
  },
  {
    type: 'cityName',
    value: 'JHUNJHUNU, RAJASTHAN',
    masterId: 12258,
  },
  {
    type: 'cityName',
    value: 'JHANJHARPUR, BIHAR',
    masterId: 18827,
  },
  {
    type: 'cityName',
    value: 'JEJURI, MAHARASHTRA',
    masterId: 12229,
  },
  {
    type: 'cityName',
    value: 'JAI JAI WANTI, HARYANA',
    masterId: 18314,
  },
  {
    type: 'cityName',
    value: 'JOJWA, GUJARAT',
    masterId: 17153,
  },
  {
    type: 'cityName',
    value: 'JAKOLARI, PUNJAB',
    masterId: 17350,
  },
  {
    type: 'cityName',
    value: 'JAKHWADA, GUJARAT',
    masterId: 12147,
  },
  {
    type: 'cityName',
    value: 'JAKHALABANDHA, ASSAM',
    masterId: 12143,
  },
  {
    type: 'cityName',
    value: 'JANKIDAIPUR, ORISSA',
    masterId: 17488,
  },
  {
    type: 'cityName',
    value: 'NAINIYA, MADHYA PRADESH',
    masterId: 13826,
  },
  {
    type: 'cityName',
    value: 'JAHANI KHERA, UTTAR PRADESH',
    masterId: 16755,
  },
  {
    type: 'cityName',
    value: 'JAKHOD KHERA, HARYANA',
    masterId: 18313,
  },
  {
    type: 'cityName',
    value: 'KAURIAA JUNGLE, UTTAR PRADESH',
    masterId: 16471,
  },
  {
    type: 'cityName',
    value: 'JALALKHALI HALT, WEST BENGAL',
    masterId: 21190,
  },
  {
    type: 'cityName',
    value: 'JANKAMPET, ANDHRA PRADESH',
    masterId: 12193,
  },
  {
    type: 'cityName',
    value: 'JAKHANIAN, UTTAR PRADESH',
    masterId: 12144,
  },
  {
    type: 'cityName',
    value: 'BALRAMPUR, UTTAR PRADESH',
    masterId: 10440,
  },
  {
    type: 'cityName',
    value: 'JHAREKAPUR, UTTAR PRADESH',
    masterId: 16501,
  },
  {
    type: 'cityName',
    value: 'JAKHAPURA, ORISSA',
    masterId: 12145,
  },
  {
    type: 'cityName',
    value: 'JAULKHERA, MADHYA PRADESH',
    masterId: 17835,
  },
  {
    type: 'cityName',
    value: 'JAKSI, GUJARAT',
    masterId: 18550,
  },
  {
    type: 'cityName',
    value: 'JEKOT, GUJARAT',
    masterId: 18547,
  },
  {
    type: 'cityName',
    value: 'JITA KHERI, HARYANA',
    masterId: 18308,
  },
  {
    type: 'cityName',
    value: 'JALGAON, MAHARASHTRA',
    masterId: 12154,
  },
  {
    type: 'cityName',
    value: 'BAMBHAURA, UTTAR PRADESH',
    masterId: 10448,
  },
  {
    type: 'cityName',
    value: 'JULMI, RAJASTHAN',
    masterId: 17151,
  },
  {
    type: 'cityName',
    value: 'JULGAON DECCAN, MAHARASHTRA',
    masterId: 17654,
  },
  {
    type: 'cityName',
    value: 'JHILAHI, UTTAR PRADESH',
    masterId: 16498,
  },
  {
    type: 'cityName',
    value: 'JALALSI P.H., WEST BENGAL',
    masterId: 21235,
  },
  {
    type: 'cityName',
    value: 'LALPUR, UTTAR PRADESH',
    masterId: 13104,
  },
  {
    type: 'cityName',
    value: 'JHILO, RAJASTHAN',
    masterId: 16497,
  },
  {
    type: 'cityName',
    value: 'JALIYA MATH, GUJARAT',
    masterId: 18465,
  },
  {
    type: 'cityName',
    value: 'JAMUNDHANA KALAN, UTTAR PRADESH',
    masterId: 12185,
  },
  {
    type: 'cityName',
    value: 'JALPUR, UTTAR PRADESH',
    masterId: 19179,
  },
  {
    type: 'cityName',
    value: 'JETALSAR, GUJARAT',
    masterId: 12231,
  },
  {
    type: 'cityName',
    value: 'JHAMAT, UTTAR PRADESH',
    masterId: 17346,
  },
  {
    type: 'cityName',
    value: 'JHALWARA, MADHYA PRADESH',
    masterId: 12247,
  },
  {
    type: 'cityName',
    value: 'JHALAWAR, RAJASTHAN',
    masterId: 12243,
  },
  {
    type: 'cityName',
    value: 'JALAMB, MAHARASHTRA',
    masterId: 12151,
  },
  {
    type: 'cityName',
    value: 'JAMBHALI, MAHARASHTRA',
    masterId: 17660,
  },
  {
    type: 'cityName',
    value: 'JAMDHA, MAHARASHTRA',
    masterId: 16037,
  },
  {
    type: 'cityName',
    value: 'JAMGAON, CHHATTISGARH',
    masterId: 12172,
  },
  {
    type: 'cityName',
    value: 'JAMGURI, ASSAM',
    masterId: 18911,
  },
  {
    type: 'cityName',
    value: 'JAMIRA HALT, BIHAR',
    masterId: 20740,
  },
  {
    type: 'cityName',
    value: 'JAMUNAMUKH, ASSAM',
    masterId: 12184,
  },
  {
    type: 'cityName',
    value: 'JAMIKUNTA, ANDHRA PRADESH',
    masterId: 12173,
  },
  {
    type: 'cityName',
    value: 'JAMALPUR, BIHAR',
    masterId: 12167,
  },
  {
    type: 'cityName',
    value: 'JIMIDIPETA, ORISSA',
    masterId: 12262,
  },
  {
    type: 'cityName',
    value: 'PRATAPPUR, WEST BENGAL',
    masterId: 14468,
  },
  {
    type: 'cityName',
    value: 'JAMIRA, ASSAM',
    masterId: 18627,
  },
  {
    type: 'cityName',
    value: 'JAMSAR, RAJASTHAN',
    masterId: 17266,
  },
  {
    type: 'cityName',
    value: 'JAMTARA, JHARKHAND',
    masterId: 12182,
  },
  {
    type: 'cityName',
    value: 'JAMUI, BIHAR',
    masterId: 12183,
  },
  {
    type: 'cityName',
    value: 'JAMBARA, MADHYA PRADESH',
    masterId: 12170,
  },
  {
    type: 'cityName',
    value: 'JULANA, HARYANA',
    masterId: 12291,
  },
  {
    type: 'cityName',
    value: 'JUNAGADH, GUJARAT',
    masterId: 12294,
  },
  {
    type: 'cityName',
    value: 'JANIYANA, RAJASTHAN',
    masterId: 17158,
  },
  {
    type: 'cityName',
    value: 'JANGHAI, UTTAR PRADESH',
    masterId: 12191,
  },
  {
    type: 'cityName',
    value: 'JHINKPANI, JHARKHAND',
    masterId: 18173,
  },
  {
    type: 'cityName',
    value: 'JANAKI NAGAR, BIHAR',
    masterId: 16131,
  },
  {
    type: 'cityName',
    value: 'JANDIALA, PUNJAB',
    masterId: 12187,
  },
  {
    type: 'cityName',
    value: 'JAYNGR MAJLIPUR, WEST BENGAL',
    masterId: 21180,
  },
  {
    type: 'cityName',
    value: 'BAMANGORA, JHARKHAND',
    masterId: 10446,
  },
  {
    type: 'cityName',
    value: 'JUNNARDEO, MADHYA PRADESH',
    masterId: 12297,
  },
  {
    type: 'cityName',
    value: 'JAGANNATHPUR, ORISSA',
    masterId: 18176,
  },
  {
    type: 'cityName',
    value: 'PUPRI, BIHAR',
    masterId: 14506,
  },
  {
    type: 'cityName',
    value: 'SUKHABANDH, ORISSA',
    masterId: 15314,
  },
  {
    type: 'cityName',
    value: 'JAINTIPUR, PUNJAB',
    masterId: 17420,
  },
  {
    type: 'cityName',
    value: 'JINTI, MAHARASHTRA',
    masterId: 12267,
  },
  {
    type: 'cityName',
    value: 'JAUNPUR, UTTAR PRADESH',
    masterId: 12215,
  },
  {
    type: 'cityName',
    value: 'JAGNATHJI ROAD, RAJASTHAN',
    masterId: 20964,
  },
  {
    type: 'cityName',
    value: 'JENAL, GUJARAT',
    masterId: 20797,
  },
  {
    type: 'cityName',
    value: 'JO JAGABOR, GUJARAT',
    masterId: 17154,
  },
  {
    type: 'cityName',
    value: 'JANWAL, MAHARASHTRA',
    masterId: 12195,
  },
  {
    type: 'cityName',
    value: 'ASALPUR, RAJASTHAN',
    masterId: 10264,
  },
  {
    type: 'cityName',
    value: 'JOBA, MADHYA PRADESH',
    masterId: 18611,
  },
  {
    type: 'cityName',
    value: 'JOYCHANDI PAHAR, WEST BENGAL',
    masterId: 12288,
  },
  {
    type: 'cityName',
    value: 'JUHAPURA, RAJASTHAN',
    masterId: 18459,
  },
  {
    type: 'cityName',
    value: 'JODHKAN, HARYANA',
    masterId: 18307,
  },
  {
    type: 'cityName',
    value: 'JOGAL, ODISHA',
    masterId: 20907,
  },
  {
    type: 'cityName',
    value: 'RIYA-SHYAMDAS, RAJASTHAN',
    masterId: 14744,
  },
  {
    type: 'cityName',
    value: 'JONHA, JHARKHAND',
    masterId: 18170,
  },
  {
    type: 'cityName',
    value: 'KACHEGUDA J OUS, TELANGANA',
    masterId: 16795,
  },
  {
    type: 'cityName',
    value: 'JORAI, WEST BENGAL',
    masterId: 16128,
  },
  {
    type: 'cityName',
    value: 'JALORE, RAJASTHAN',
    masterId: 12158,
  },
  {
    type: 'cityName',
    value: 'JALALPUR DHAI, UTTAR PRADESH',
    masterId: 12150,
  },
  {
    type: 'cityName',
    value: 'JALPAIGURI, WEST BENGAL',
    masterId: 12159,
  },
  {
    type: 'cityName',
    value: 'JHANTIPAHARI, WEST BENGAL',
    masterId: 12249,
  },
  {
    type: 'cityName',
    value: 'JADUPUDI, ANDHRA PRADESH',
    masterId: 19064,
  },
  {
    type: 'cityName',
    value: 'JAPLA, JHARKHAND',
    masterId: 12198,
  },
  {
    type: 'cityName',
    value: 'JEEYAPURAM, TAMIL NADU',
    masterId: 16982,
  },
  {
    type: 'cityName',
    value: 'JOURA, MADHYA PRADESH',
    masterId: 17834,
  },
  {
    type: 'cityName',
    value: 'JALALPUR PANWARA, UTTAR PRADESH',
    masterId: 16509,
  },
  {
    type: 'cityName',
    value: 'JHAPANDANGA, WEST BENGAL',
    masterId: 21211,
  },
  {
    type: 'cityName',
    value: 'JAKPUR, WEST BENGAL',
    masterId: 19189,
  },
  {
    type: 'cityName',
    value: 'JENAPUR ROAD, ORISSA',
    masterId: 17534,
  },
  {
    type: 'cityName',
    value: 'JAMALPUR SHEIKHAN, HARYANA',
    masterId: 18312,
  },
  {
    type: 'cityName',
    value: 'JOGIGHOPA, ASSAM',
    masterId: 12279,
  },
  {
    type: 'cityName',
    value: 'SARAIKELA, JHARKHAND',
    masterId: 14938,
  },
  {
    type: 'cityName',
    value: 'JAUGRAM, WEST BENGAL',
    masterId: 21212,
  },
  {
    type: 'cityName',
    value: 'JIRIBAM, MANIPUR',
    masterId: 17555,
  },
  {
    type: 'cityName',
    value: 'JUGPURA, ORISSA',
    masterId: 20906,
  },
  {
    type: 'cityName',
    value: 'JARGAON, UTTAR PRADESH',
    masterId: 12200,
  },
  {
    type: 'cityName',
    value: 'JERUWAKHERA, MADHYA PRADESH',
    masterId: 12230,
  },
  {
    type: 'cityName',
    value: 'JORKIAN, RAJASTHAN',
    masterId: 17152,
  },
  {
    type: 'cityName',
    value: 'JADRAMA KUNTI, KARNATAKA',
    masterId: 18023,
  },
  {
    type: 'cityName',
    value: 'JHARLI, HARYANA',
    masterId: 12251,
  },
  {
    type: 'cityName',
    value: 'RAGHUNATHGANJ, WEST BENGAL',
    masterId: 14541,
  },
  {
    type: 'cityName',
    value: 'JAROLI, ORISSA',
    masterId: 16040,
  },
  {
    type: 'cityName',
    value: 'JAIRAMNAGAR, CHHATTISGARH',
    masterId: 12129,
  },
  {
    type: 'cityName',
    value: 'JIRANIA, TRIPURA',
    masterId: 16784,
  },
  {
    type: 'cityName',
    value: 'JIRON, UTTAR PRADESH',
    masterId: 16492,
  },
  {
    type: 'cityName',
    value: 'JARAPADA, ORISSA',
    masterId: 17487,
  },
  {
    type: 'cityName',
    value: 'JHARO KHAS, UTTAR PRADESH',
    masterId: 16500,
  },
  {
    type: 'cityName',
    value: 'JUGGAUR, UTTAR PRADESH',
    masterId: 12289,
  },
  {
    type: 'cityName',
    value: 'JORAVASAN, GUJARAT',
    masterId: 12285,
  },
  {
    type: 'cityName',
    value: 'CHIKKAJAJUR, KARNATAKA',
    masterId: 11081,
  },
  {
    type: 'cityName',
    value: 'JUNA RAJUVADIYA, GUJARAT',
    masterId: 18458,
  },
  {
    type: 'cityName',
    value: 'JORAMOW, JHARKHAND',
    masterId: 12284,
  },
  {
    type: 'cityName',
    value: 'JIRWAN, MADHYA PRADESH',
    masterId: 12271,
  },
  {
    type: 'cityName',
    value: 'JURIAGAON, ASSAM',
    masterId: 18908,
  },
  {
    type: 'cityName',
    value: 'JORANDA, ORISSA',
    masterId: 17483,
  },
  {
    type: 'cityName',
    value: 'JASAI, RAJASTHAN',
    masterId: 17659,
  },
  {
    type: 'cityName',
    value: 'YAMUNA SOUTH BANK, UTTAR PRADESH',
    masterId: 16257,
  },
  {
    type: 'cityName',
    value: 'JALESAR, UTTAR PRADESH',
    masterId: 16508,
  },
  {
    type: 'cityName',
    value: 'JAISINDER, RAJASTHAN',
    masterId: 17159,
  },
  {
    type: 'cityName',
    value: 'JHARSUGUDA, ORISSA',
    masterId: 12253,
  },
  {
    type: 'cityName',
    value: 'JHARSUGUDA MARG, ORISSA',
    masterId: 18612,
  },
  {
    type: 'cityName',
    value: 'JASWANTGARH, RAJASTHAN',
    masterId: 17157,
  },
  {
    type: 'cityName',
    value: 'JASALI, GUJARAT',
    masterId: 18549,
  },
  {
    type: 'cityName',
    value: 'JATAULA SAMPHKA, HARYANA ',
    masterId: 18310,
  },
  {
    type: 'cityName',
    value: 'JASSOWAL, PUNJAB',
    masterId: 17349,
  },
  {
    type: 'cityName',
    value: 'JAISALMER, RAJASTHAN',
    masterId: 12131,
  },
  {
    type: 'cityName',
    value: 'JASIDIH, JHARKHAND',
    masterId: 12204,
  },
  {
    type: 'cityName',
    value: 'JAYSINGPUR, MAHARASHTRA',
    masterId: 12225,
  },
  {
    type: 'cityName',
    value: 'JASHAPAR, GUJARAT',
    masterId: 18548,
  },
  {
    type: 'cityName',
    value: 'JASRA, UTTAR PRADESH',
    masterId: 12208,
  },
  {
    type: 'cityName',
    value: 'SARALA, ORISSA',
    masterId: 17435,
  },
  {
    type: 'cityName',
    value: 'JASIA, HARYANA',
    masterId: 18311,
  },
  {
    type: 'cityName',
    value: 'JARANDESHWAR, MAHARASHTRA',
    masterId: 12199,
  },
  {
    type: 'cityName',
    value: 'JAGATBELA, UTTAR PRADESH',
    masterId: 12112,
  },
  {
    type: 'cityName',
    value: 'JATDUMRI, BIHAR',
    masterId: 18735,
  },
  {
    type: 'cityName',
    value: 'JHOKTAHAL SING, PUNJAB',
    masterId: 17345,
  },
  {
    type: 'cityName',
    value: 'JAITHARI, MADHYA PRADESH',
    masterId: 12134,
  },
  {
    type: 'cityName',
    value: 'JETHIAN, BIHAR',
    masterId: 18909,
  },
  {
    type: 'cityName',
    value: 'JOLARPETTAI, TAMIL NADU',
    masterId: 12281,
  },
  {
    type: 'cityName',
    value: 'JHITKIA, WEST BENGAL',
    masterId: 18734,
  },
  {
    type: 'cityName',
    value: 'JAITPUR KALAN, UTTAR PRADESH',
    masterId: 21044,
  },
  {
    type: 'cityName',
    value: 'SANKARI, WEST BENGAL',
    masterId: 14909,
  },
  {
    type: 'cityName',
    value: 'JOTANA, GUJARAT',
    masterId: 18460,
  },
  {
    type: 'cityName',
    value: 'JUTOGH, HIMACHAL PRADESH',
    masterId: 12299,
  },
  {
    type: 'cityName',
    value: 'JATKANHAR, CHHATTISGARH',
    masterId: 12211,
  },
  {
    type: 'cityName',
    value: 'JATH, MAHARASHTRA',
    masterId: 17737,
  },
  {
    type: 'cityName',
    value: 'JATUSANA, HARYANA',
    masterId: 12214,
  },
  {
    type: 'cityName',
    value: 'JORHAT, ASSAM',
    masterId: 12286,
  },
  {
    type: 'cityName',
    value: 'JAITIPUR, UTTAR PRADESH',
    masterId: 18828,
  },
  {
    type: 'cityName',
    value: 'JETALVAD, GUJARAT',
    masterId: 12232,
  },
  {
    type: 'cityName',
    value: 'JAITWARA, MADHYA PRADESH',
    masterId: 12138,
  },
  {
    type: 'cityName',
    value: 'JETHI, GUJARAT',
    masterId: 18462,
  },
  {
    type: 'cityName',
    value: 'JARAUNA, UTTAR PRADESH',
    masterId: 16754,
  },
  {
    type: 'cityName',
    value: 'JUBBASAHANI, BIHAR',
    masterId: 20765,
  },
  {
    type: 'cityName',
    value: 'JALANDHAR, PUNJAB',
    masterId: 12152,
  },
  {
    type: 'cityName',
    value: 'CANTT AREA, RAJASTHAN',
    masterId: 17275,
  },
  {
    type: 'cityName',
    value: 'JAGADHRI, HARYANA',
    masterId: 12106,
  },
  {
    type: 'cityName',
    value: 'JUJHARPUR, MADHYA PRADESH',
    masterId: 17833,
  },
  {
    type: 'cityName',
    value: 'JUJOMURA, ORISSA',
    masterId: 17535,
  },
  {
    type: 'cityName',
    value: 'JAULKA, MAHARASHTRA',
    masterId: 17658,
  },
  {
    type: 'cityName',
    value: 'JHULASAN, GUJARAT',
    masterId: 18546,
  },
  {
    type: 'cityName',
    value: 'JUNONA, MAHARASHTRA',
    masterId: 17653,
  },
  {
    type: 'cityName',
    value: 'JHUNPA, HARYANA',
    masterId: 18309,
  },
  {
    type: 'cityName',
    value: 'KUMMETHA, ANDHRA PRADESH',
    masterId: 13010,
  },
  {
    type: 'cityName',
    value: 'JAVALE, MAHARASHTRA',
    masterId: 17657,
  },
  {
    type: 'cityName',
    value: 'JAMWALA, GUJARAT',
    masterId: 18463,
  },
  {
    type: 'cityName',
    value: 'SURENDRANAGAR, GUJARAT',
    masterId: 15357,
  },
  {
    type: 'cityName',
    value: 'JIBANTI, WEST BENGAL',
    masterId: 16129,
  },
  {
    type: 'cityName',
    value: 'GARHOLI, RAJASTHAN',
    masterId: 11658,
  },
  {
    type: 'cityName',
    value: 'JAWAI BANDH, RAJASTHAN',
    masterId: 12218,
  },
  {
    type: 'cityName',
    value: 'JAWAHARPUR KAMSAN, UTTAR PRADESH',
    masterId: 16504,
  },
  {
    type: 'cityName',
    value: 'JAJIWAL, RAJASTHAN',
    masterId: 12140,
  },
  {
    type: 'cityName',
    value: 'JIWA ARAIN, PUNJAB',
    masterId: 17344,
  },
  {
    type: 'cityName',
    value: 'JAWAHARNAGAR, TRIPURA',
    masterId: 17419,
  },
  {
    type: 'cityName',
    value: 'NAYAGAON, RAJASTHAN',
    masterId: 13946,
  },
  {
    type: 'cityName',
    value: 'JWALAPUR, UTTARAKHAND',
    masterId: 12301,
  },
  {
    type: 'cityName',
    value: 'JHARWASA, RAJASTHAN',
    masterId: 17155,
  },
  {
    type: 'cityName',
    value: 'JIRONA, MAHARASHTRA',
    masterId: 17656,
  },
  {
    type: 'cityName',
    value: 'JAYNAGAR, BIHAR',
    masterId: 12224,
  },
  {
    type: 'cityName',
    value: 'JONE KARRANG, ASSAM',
    masterId: 18982,
  },
  {
    type: 'cityName',
    value: 'JAI SAMAND ROAD, RAJASTHAN',
    masterId: 12125,
  },
  {
    type: 'cityName',
    value: 'JEYPORE, ORISSA',
    masterId: 12237,
  },
  {
    type: 'cityName',
    value: 'KAURARA, UTTAR PRADESH',
    masterId: 21018,
  },
  {
    type: 'cityName',
    value: 'KHANDALA, MAHARASHTRA',
    masterId: 12707,
  },
  {
    type: 'cityName',
    value: 'KHAIRADIH, BIHAR',
    masterId: 18727,
  },
  {
    type: 'cityName',
    value: 'KADI, GUJARAT',
    masterId: 12330,
  },
  {
    type: 'cityName',
    value: 'KUMRADOL, JHARKHAND',
    masterId: 18156,
  },
  {
    type: 'cityName',
    value: 'KADIYADRA, GUJARAT',
    masterId: 18456,
  },
  {
    type: 'cityName',
    value: 'KODAGANUR, KARNATAKA',
    masterId: 12808,
  },
  {
    type: 'cityName',
    value: 'KURHAGADA, JHARKHAND',
    masterId: 18155,
  },
  {
    type: 'cityName',
    value: 'KAGANGARH, PUNJAB',
    masterId: 17427,
  },
  {
    type: 'cityName',
    value: 'KALHAR, MADHYA PRADESH',
    masterId: 12392,
  },
  {
    type: 'cityName',
    value: 'KERALA, RAJASTHAN',
    masterId: 12656,
  },
  {
    type: 'cityName',
    value: 'KALIYAGANJ, WEST BENGAL',
    masterId: 12400,
  },
  {
    type: 'cityName',
    value: 'KARANJGAON, MAHARASHTRA',
    masterId: 12536,
  },
  {
    type: 'cityName',
    value: 'KAIMARKALAN, MADHYA PRADESH',
    masterId: 17830,
  },
  {
    type: 'cityName',
    value: 'KAILI, UTTAR PRADESH',
    masterId: 16487,
  },
  {
    type: 'cityName',
    value: 'KALANA, RAJASTHAN',
    masterId: 12376,
  },
  {
    type: 'cityName',
    value: 'KALAS, KARNATAKA',
    masterId: 18020,
  },
  {
    type: 'cityName',
    value: 'KAMAKHYAGURI, WEST BENGAL',
    masterId: 12436,
  },
  {
    type: 'cityName',
    value: 'KAMALPUR, UTTAR PRADESH',
    masterId: 21004,
  },
  {
    type: 'cityName',
    value: 'SATINANDI, WEST BENGAL',
    masterId: 14974,
  },
  {
    type: 'cityName',
    value: 'PADRA, GUJARAT',
    masterId: 14114,
  },
  {
    type: 'cityName',
    value: 'KANOH, HIMACHAL PRADESH',
    masterId: 12508,
  },
  {
    type: 'cityName',
    value: 'KANSIYA NES, GUJARAT',
    masterId: 18454,
  },
  {
    type: 'cityName',
    value: 'KALUBATHAN, JHARKHAND',
    masterId: 18224,
  },
  {
    type: 'cityName',
    value: 'KAOTHA, MAHARASHTRA',
    masterId: 16480,
  },
  {
    type: 'cityName',
    value: 'KAKAPORE, JAMMU AND KASHMIR',
    masterId: 20832,
  },
  {
    type: 'cityName',
    value: 'KALAKALESWAR, ORISSA',
    masterId: 12370,
  },
  {
    type: 'cityName',
    value: 'KHARIAPIPRA, BIHAR',
    masterId: 18726,
  },
  {
    type: 'cityName',
    value: 'VADDESWARAM, ANDHRA PRADESH',
    masterId: 15734,
  },
  {
    type: 'cityName',
    value: 'MADARA, UTTAR PRADESH',
    masterId: 13200,
  },
  {
    type: 'cityName',
    value: 'KAMAN ROAD, MAHARASHTRA',
    masterId: 20897,
  },
  {
    type: 'cityName',
    value: 'KAKRAHA REST HOUSE, UTTAR PRADESH',
    masterId: 16485,
  },
  {
    type: 'cityName',
    value: 'KARAIKURICHI, TAMIL NADU',
    masterId: 16972,
  },
  {
    type: 'cityName',
    value: 'KHARIO, JHARKHAND',
    masterId: 18222,
  },
  {
    type: 'cityName',
    value: 'KHARAR, PUNJAB',
    masterId: 20934,
  },
  {
    type: 'cityName',
    value: 'KIRATPUR SAHIB, PUNJAB',
    masterId: 12794,
  },
  {
    type: 'cityName',
    value: 'KULTHAMABDULLASHAH H, PUNJAB',
    masterId: 17327,
  },
  {
    type: 'cityName',
    value: 'DELANGAKOTHABAR, ORISSA',
    masterId: 11278,
  },
  {
    type: 'cityName',
    value: 'KASU, MAHARASHTRA',
    masterId: 12585,
  },
  {
    type: 'cityName',
    value: 'KHATAULI, UTTAR PRADESH',
    masterId: 12731,
  },
  {
    type: 'cityName',
    value: 'KHATKHURA, WEST BENGAL',
    masterId: 16213,
  },
  {
    type: 'cityName',
    value: 'CONTAI, WEST BENGAL',
    masterId: 11165,
  },
  {
    type: 'cityName',
    value: 'KATOL, MAHARASHTRA',
    masterId: 12604,
  },
  {
    type: 'cityName',
    value: 'KACHNA, WEST BENGAL',
    masterId: 18823,
  },
  {
    type: 'cityName',
    value: 'KATHAUTIA, JHARKHAND',
    masterId: 18819,
  },
  {
    type: 'cityName',
    value: 'KALAMNA, MAHARASHTRA',
    masterId: 12375,
  },
  {
    type: 'cityName',
    value: 'KATHIVAKKAM, TAMIL NADU',
    masterId: 20985,
  },
  {
    type: 'cityName',
    value: 'KALAVUR, KERALA',
    masterId: 17928,
  },
  {
    type: 'cityName',
    value: 'KHAJRI, MADHYA PRADESH',
    masterId: 18607,
  },
  {
    type: 'cityName',
    value: 'KARWAR, KARNATAKA',
    masterId: 12574,
  },
  {
    type: 'cityName',
    value: 'KANWAT, RAJASTHAN',
    masterId: 17145,
  },
  {
    type: 'cityName',
    value: 'KARAMADAI, TAMIL NADU',
    masterId: 16971,
  },
  {
    type: 'cityName',
    value: 'KAYDI HALT, MADHYA PRADESH',
    masterId: 20873,
  },
  {
    type: 'cityName',
    value: 'KAYAR, MAHARASHTRA',
    masterId: 12630,
  },
  {
    type: 'cityName',
    value: 'KURABALAKOTA, ANDHRA PRADESH',
    masterId: 13034,
  },
  {
    type: 'cityName',
    value: 'KUREBHAR, UTTAR PRADESH',
    masterId: 16449,
  },
  {
    type: 'cityName',
    value: 'KAREA KDMBGACHI, WEST BENGAL',
    masterId: 21153,
  },
  {
    type: 'cityName',
    value: 'KHANDBARA, MAHARASHTRA',
    masterId: 12708,
  },
  {
    type: 'cityName',
    value: 'KASHANATTI, KARNATAKA',
    masterId: 18016,
  },
  {
    type: 'cityName',
    value: 'KARLABAHALI, ORISSA',
    masterId: 12560,
  },
  {
    type: 'cityName',
    value: 'KHAMIL GHAT, RAJASTHAN',
    masterId: 17140,
  },
  {
    type: 'cityName',
    value: 'KHABRA KALAN, HARYANA',
    masterId: 17141,
  },
  {
    type: 'cityName',
    value: 'KOPPAL, KARNATAKA',
    masterId: 12880,
  },
  {
    type: 'cityName',
    value: 'KOTABOMMALI, ANDHRA PRADESH',
    masterId: 12900,
  },
  {
    type: 'cityName',
    value: 'KARBIGWAN, UTTAR PRADESH',
    masterId: 12542,
  },
  {
    type: 'cityName',
    value: 'KUBERPUR, UTTAR PRADESH',
    masterId: 16746,
  },
  {
    type: 'cityName',
    value: 'PUTTUR, KARNATAKA',
    masterId: 14528,
  },
  {
    type: 'cityName',
    value: 'KUMRABAD ROHINI, JHARKHAND',
    masterId: 13012,
  },
  {
    type: 'cityName',
    value: 'KABRAI, UTTAR PRADESH',
    masterId: 16491,
  },
  {
    type: 'cityName',
    value: 'KANJARI, GUJARAT',
    masterId: 12492,
  },
  {
    type: 'cityName',
    value: 'KRISHNA BALLABH SAHA, JHARKHAND',
    masterId: 18158,
  },
  {
    type: 'cityName',
    value: 'KASBE SUKENE, MAHARASHTRA',
    masterId: 17647,
  },
  {
    type: 'cityName',
    value: 'KADAMBATHUR, TAMIL NADU',
    masterId: 16981,
  },
  {
    type: 'cityName',
    value: 'KASU BEGU, PUNJAB',
    masterId: 17339,
  },
  {
    type: 'cityName',
    value: 'KHOIRABARI, ASSAM',
    masterId: 18899,
  },
  {
    type: 'cityName',
    value: 'KUCHMAN, UTTAR PRADESH',
    masterId: 12968,
  },
  {
    type: 'cityName',
    value: 'BONDAMUNDA K CABIN, ORISSA',
    masterId: 17481,
  },
  {
    type: 'cityName',
    value: 'KRISHNA CANAL, ANDHRA PRADESH',
    masterId: 12950,
  },
  {
    type: 'cityName',
    value: 'KURICHEDU, ANDHRA PRADESH',
    masterId: 13040,
  },
  {
    type: 'cityName',
    value: 'KALCHINI, WEST BENGAL',
    masterId: 16124,
  },
  {
    type: 'cityName',
    value: 'KATCHANAVILAI, TAMIL NADU',
    masterId: 16966,
  },
  {
    type: 'cityName',
    value: 'PILERU, ANDHRA PRADESH',
    masterId: 14395,
  },
  {
    type: 'cityName',
    value: 'KASIMPUR, UTTAR PRADESH',
    masterId: 12584,
  },
  {
    type: 'cityName',
    value: 'KECHKI, JHARKHAND',
    masterId: 12635,
  },
  {
    type: 'cityName',
    value: 'KENCHANALA, KARNATAKA',
    masterId: 18014,
  },
  {
    type: 'cityName',
    value: 'KALASAMUDRAM, ANDHRA PRADESH',
    masterId: 12380,
  },
  {
    type: 'cityName',
    value: 'CHARIBANA, UTTAR PRADESH',
    masterId: 11011,
  },
  {
    type: 'cityName',
    value: 'KACHNARA ROAD, MADHYA PRADESH',
    masterId: 12310,
  },
  {
    type: 'cityName',
    value: 'KACHHLA BRIDGE, UTTAR PRADESH',
    masterId: 16490,
  },
  {
    type: 'cityName',
    value: 'KALGAPUR, KARNATAKA',
    masterId: 12390,
  },
  {
    type: 'cityName',
    value: 'KHONKAR, MADHYA PRADESH',
    masterId: 17823,
  },
  {
    type: 'cityName',
    value: 'KERAKAT, UTTAR PRADESH',
    masterId: 12655,
  },
  {
    type: 'cityName',
    value: 'KACHHIA, UTTAR PRADESH',
    masterId: 18626,
  },
  {
    type: 'cityName',
    value: 'KRISHNACHANDRAPUR, ORISSA',
    masterId: 12951,
  },
  {
    type: 'cityName',
    value: 'KUNDARKI, UTTAR PRADESH',
    masterId: 13021,
  },
  {
    type: 'cityName',
    value: 'GOODS SHED COLONY, KARNATAKA',
    masterId: 18037,
  },
  {
    type: 'cityName',
    value: 'KODIMBALA, KARNATAKA',
    masterId: 18009,
  },
  {
    type: 'cityName',
    value: 'KHED BRAHMA, GUJARAT',
    masterId: 19090,
  },
  {
    type: 'cityName',
    value: 'KHADKI, MAHARASHTRA',
    masterId: 17734,
  },
  {
    type: 'cityName',
    value: 'KORADACHERI, TAMIL NADU',
    masterId: 12882,
  },
  {
    type: 'cityName',
    value: 'KOHANDAUR, UTTAR PRADESH',
    masterId: 16455,
  },
  {
    type: 'cityName',
    value: 'BORIPARDHI, MAHARASHTRA',
    masterId: 10894,
  },
  {
    type: 'cityName',
    value: 'KODIGEHALLI, KARNATAKA',
    masterId: 18011,
  },
  {
    type: 'cityName',
    value: 'KUDGI, KARNATAKA',
    masterId: 18006,
  },
  {
    type: 'cityName',
    value: 'KHARDAHA, MADHYA PRADESH',
    masterId: 16215,
  },
  {
    type: 'cityName',
    value: 'NARWAR, MADHYA PRADESH',
    masterId: 13910,
  },
  {
    type: 'cityName',
    value: 'KUNDHELA, GUJARAT',
    masterId: 18543,
  },
  {
    type: 'cityName',
    value: 'KANDHARAN, RAJASTHAN ',
    masterId: 17147,
  },
  {
    type: 'cityName',
    value: 'BUBAVAV, GUJARAT',
    masterId: 10911,
  },
  {
    type: 'cityName',
    value: 'KHUDAGANJ, UTTAR PRADESH',
    masterId: 16750,
  },
  {
    type: 'cityName',
    value: 'KENDUJHARGARH, ORISSA',
    masterId: 12649,
  },
  {
    type: 'cityName',
    value: 'KOHDAD, MADHYA PRADESH',
    masterId: 17820,
  },
  {
    type: 'cityName',
    value: 'KENDUKONA, ASSAM',
    masterId: 18901,
  },
  {
    type: 'cityName',
    value: 'KANKROLI, RAJASTHAN',
    masterId: 12502,
  },
  {
    type: 'cityName',
    value: 'KUNDALGARH, RAJASTHAN',
    masterId: 17129,
  },
  {
    type: 'cityName',
    value: 'BALSI, ORISSA',
    masterId: 10442,
  },
  {
    type: 'cityName',
    value: 'KESAMUDRAM, ANDHRA PRADESH',
    masterId: 12658,
  },
  {
    type: 'cityName',
    value: 'NANDAMBAKKAM, TAMIL NADU',
    masterId: 17035,
  },
  {
    type: 'cityName',
    value: 'KUDATINI, KARNATAKA',
    masterId: 12971,
  },
  {
    type: 'cityName',
    value: 'KADAYANALLUR, TAMIL NADU',
    masterId: 12327,
  },
  {
    type: 'cityName',
    value: 'KADAKOLA, KARNATAKA',
    masterId: 12314,
  },
  {
    type: 'cityName',
    value: 'KONDAPURAM, ANDHRA PRADESH',
    masterId: 12868,
  },
  {
    type: 'cityName',
    value: 'KUMEDPUR, BIHAR',
    masterId: 13006,
  },
  {
    type: 'cityName',
    value: 'KADIPUR SANI, UTTAR PRADESH',
    masterId: 16488,
  },
  {
    type: 'cityName',
    value: 'KADIPUR, UTTAR PRADESH',
    masterId: 16489,
  },
  {
    type: 'cityName',
    value: 'KHULDIL, UTTAR PRADESH',
    masterId: 16458,
  },
  {
    type: 'cityName',
    value: 'KENDRI, CHHATTISGARH',
    masterId: 18610,
  },
  {
    type: 'cityName',
    value: 'KANDARPUR, ORISSA',
    masterId: 17475,
  },
  {
    type: 'cityName',
    value: 'KUSUNDA, JHARKHAND',
    masterId: 18221,
  },
  {
    type: 'cityName',
    value: 'KHADUR SAHIB, PUNJAB',
    masterId: 20937,
  },
  {
    type: 'cityName',
    value: 'KUDSAD, GUJARAT',
    masterId: 12978,
  },
  {
    type: 'cityName',
    value: 'KHADARPET, ANDHRA PRADESH',
    masterId: 12673,
  },
  {
    type: 'cityName',
    value: 'KADETHAN, MAHARASHTRA',
    masterId: 12328,
  },
  {
    type: 'cityName',
    value: 'KIRODIMALNAGAR, CHHATTISGARH',
    masterId: 12797,
  },
  {
    type: 'cityName',
    value: 'KADUTURUTTI, KERALA',
    masterId: 19120,
  },
  {
    type: 'cityName',
    value: 'KADAMBUR, TAMIL NADU',
    masterId: 12318,
  },
  {
    type: 'cityName',
    value: 'KHADAVLI, MAHARASHTRA',
    masterId: 17641,
  },
  {
    type: 'cityName',
    value: 'KADABARI HAT, WEST BENGAL',
    masterId: 16126,
  },
  {
    type: 'cityName',
    value: 'KETTANDAPATTI, TAMIL NADU',
    masterId: 16964,
  },
  {
    type: 'cityName',
    value: 'KHARDI, MAHARASHTRA',
    masterId: 17637,
  },
  {
    type: 'cityName',
    value: 'KANAKPUR, UTTAR PRADESH',
    masterId: 12462,
  },
  {
    type: 'cityName',
    value: 'KARAMBELE, GUJARAT',
    masterId: 12531,
  },
  {
    type: 'cityName',
    value: 'KENDUAPADA, ORISSA',
    masterId: 17470,
  },
  {
    type: 'cityName',
    value: 'KASEETAR, JHARKHAND',
    masterId: 20856,
  },
  {
    type: 'cityName',
    value: 'KRISHNAMMAKONA, ANDHRA PRADESH',
    masterId: 12954,
  },
  {
    type: 'cityName',
    value: 'KARENGI, UTTAR PRADESH',
    masterId: 12544,
  },
  {
    type: 'cityName',
    value: 'KAPSETI, UTTAR PRADESH',
    masterId: 12521,
  },
  {
    type: 'cityName',
    value: 'KAITHLIGHAT, HIMACHAL PRADESH',
    masterId: 12354,
  },
  {
    type: 'cityName',
    value: 'KARKHELI, MAHARASHTRA',
    masterId: 12558,
  },
  {
    type: 'cityName',
    value: 'KEM, MAHARASHTRA',
    masterId: 12646,
  },
  {
    type: 'cityName',
    value: 'KUKMA, GUJARAT',
    masterId: 12983,
  },
  {
    type: 'cityName',
    value: 'KHEM KARAN, PUNJAB',
    masterId: 20948,
  },
  {
    type: 'cityName',
    value: 'KEMPALSAD, MAHARASHTRA',
    masterId: 17642,
  },
  {
    type: 'cityName',
    value: 'KEMRI, UTTAR PRADESH',
    masterId: 16469,
  },
  {
    type: 'cityName',
    value: 'KOTALA, ANDHRA PRADESH',
    masterId: 12903,
  },
  {
    type: 'cityName',
    value: 'KELANPUR, GUJARAT',
    masterId: 18448,
  },
  {
    type: 'cityName',
    value: 'KOIRIPUR, UTTAR PRADESH',
    masterId: 12830,
  },
  {
    type: 'cityName',
    value: 'KIRIHARAPUR, UTTAR PRADESH',
    masterId: 12795,
  },
  {
    type: 'cityName',
    value: 'KESRI, HARYANA',
    masterId: 18300,
  },
  {
    type: 'cityName',
    value: 'KESRISINGHPUR, RAJASTHAN',
    masterId: 12664,
  },
  {
    type: 'cityName',
    value: 'KELA DEVI, RAJASTHAN',
    masterId: 17142,
  },
  {
    type: 'cityName',
    value: 'KHEKRA, UTTAR PRADESH',
    masterId: 16461,
  },
  {
    type: 'cityName',
    value: 'KAGANKARAI, TAMIL NADU',
    masterId: 16980,
  },
  {
    type: 'cityName',
    value: 'KELZAR, MAHARASHTRA',
    masterId: 17643,
  },
  {
    type: 'cityName',
    value: 'KOPARIA, BIHAR',
    masterId: 12878,
  },
  {
    type: 'cityName',
    value: 'KALPATTICHATRAM, TAMIL NADU',
    masterId: 16975,
  },
  {
    type: 'cityName',
    value: 'KARANJADI, MAHARASHTRA',
    masterId: 12535,
  },
  {
    type: 'cityName',
    value: 'KUREEKAD, KERALA',
    masterId: 17920,
  },
  {
    type: 'cityName',
    value: 'WARASGAON, GUJARAT',
    masterId: 15946,
  },
  {
    type: 'cityName',
    value: 'KATPHAL, MAHARASHTRA',
    masterId: 12605,
  },
  {
    type: 'cityName',
    value: 'KATKA, UTTAR PRADESH',
    masterId: 16472,
  },
  {
    type: 'cityName',
    value: 'KANORE, RAJASTHAN',
    masterId: 17146,
  },
  {
    type: 'cityName',
    value: 'KAFURPUR, UTTAR PRADESH',
    masterId: 12337,
  },
  {
    type: 'cityName',
    value: 'KUMARANALLUR, KERALA',
    masterId: 17944,
  },
  {
    type: 'cityName',
    value: 'KHAJRI, JHARKHAND',
    masterId: 18608,
  },
  {
    type: 'cityName',
    value: 'KOHAND, HARYANA',
    masterId: 18296,
  },
  {
    type: 'cityName',
    value: 'KUNDARA, KERALA',
    masterId: 13020,
  },
  {
    type: 'cityName',
    value: 'KOCHEWAHI, MADHYA PRADESH',
    masterId: 20875,
  },
  {
    type: 'cityName',
    value: 'KARAPGAON, MADHYA PRADESH',
    masterId: 17828,
  },
  {
    type: 'cityName',
    value: 'KHAGA, UTTAR PRADESH',
    masterId: 12677,
  },
  {
    type: 'cityName',
    value: 'KOTA, CHHATTISGARH',
    masterId: 12898,
  },
  {
    type: 'cityName',
    value: 'RASOOLI, HARYANA',
    masterId: 14680,
  },
  {
    type: 'cityName',
    value: 'KALLIGUDI, TAMIL NADU',
    masterId: 16977,
  },
  {
    type: 'cityName',
    value: 'KATANGI, MADHYA PRADESH',
    masterId: 20876,
  },
  {
    type: 'cityName',
    value: 'KATGHAR , UTTAR PRADESH',
    masterId: 12593,
  },
  {
    type: 'cityName',
    value: 'KHAGARIA, BIHAR',
    masterId: 12678,
  },
  {
    type: 'cityName',
    value: 'KALGURKI, KARNATAKA',
    masterId: 18092,
  },
  {
    type: 'cityName',
    value: 'KANKURGACHHI ROAD JN, PUNJAB',
    masterId: 20955,
  },
  {
    type: 'cityName',
    value: 'KANG KHURD, PUNJAB',
    masterId: 17341,
  },
  {
    type: 'cityName',
    value: 'KUPGAL, ANDHRA PRADESH',
    masterId: 13031,
  },
  {
    type: 'cityName',
    value: 'KATHGODAM, UTTARAKHAND',
    masterId: 12597,
  },
  {
    type: 'cityName',
    value: 'KURSEONG, WEST BENGAL',
    masterId: 13044,
  },
  {
    type: 'cityName',
    value: 'KASARAGOD, KERALA',
    masterId: 12578,
  },
  {
    type: 'cityName',
    value: 'KHONGSARA, CHHATTISGARH',
    masterId: 12763,
  },
  {
    type: 'cityName',
    value: 'KARIGANURU, KARNATAKA',
    masterId: 12549,
  },
  {
    type: 'cityName',
    value: 'KANGINHAL, KARNATAKA',
    masterId: 12484,
  },
  {
    type: 'cityName',
    value: 'KULGACHIA, WEST BENGAL',
    masterId: 16212,
  },
  {
    type: 'cityName',
    value: 'KARUNGUZHI, TAMIL NADU',
    masterId: 16970,
  },
  {
    type: 'cityName',
    value: 'KAHILIYA, UTTAR PRADESH',
    masterId: 12342,
  },
  {
    type: 'cityName',
    value: 'KHAIGOAN, MADHYA PRADESH',
    masterId: 17825,
  },
  {
    type: 'cityName',
    value: 'KHIRAI, WEST BENGAL',
    masterId: 18442,
  },
  {
    type: 'cityName',
    value: 'KHAT, MAHARASHTRA',
    masterId: 12730,
  },
  {
    type: 'cityName',
    value: 'KHANNA BANJARI, MADHYA PRADESH',
    masterId: 12714,
  },
  {
    type: 'cityName',
    value: 'KHARBAO, MAHARASHTRA',
    masterId: 20896,
  },
  {
    type: 'cityName',
    value: 'KHORANA, GUJARAT',
    masterId: 12765,
  },
  {
    type: 'cityName',
    value: 'KHODIYAR, GUJARAT',
    masterId: 12759,
  },
  {
    type: 'cityName',
    value: 'KHANDHERI, GUJARAT',
    masterId: 12710,
  },
  {
    type: 'cityName',
    value: 'KHUDLAPUR, UTTAR PRADESH',
    masterId: 16749,
  },
  {
    type: 'cityName',
    value: 'KANKATHER, UTTAR PRADESH',
    masterId: 12497,
  },
  {
    type: 'cityName',
    value: 'KHED, MAHARASHTRA',
    masterId: 12740,
  },
  {
    type: 'cityName',
    value: 'KHANTAPARA, ORISSA',
    masterId: 16119,
  },
  {
    type: 'cityName',
    value: 'KASHINAGAR HALT, WEST BENGAL',
    masterId: 21257,
  },
  {
    type: 'cityName',
    value: 'MAQSOODANPUR, UTTAR PRADESH',
    masterId: 13477,
  },
  {
    type: 'cityName',
    value: 'KHATKAR KALAN, PUNJAB',
    masterId: 17333,
  },
  {
    type: 'cityName',
    value: 'KURHANI, BIHAR',
    masterId: 18716,
  },
  {
    type: 'cityName',
    value: 'KHAJRAHA, UTTAR PRADESH',
    masterId: 19180,
  },
  {
    type: 'cityName',
    value: 'KHANJA, UTTAR PRADESH',
    masterId: 16464,
  },
  {
    type: 'cityName',
    value: 'KHERA KALAN, DELHI',
    masterId: 18578,
  },
  {
    type: 'cityName',
    value: 'KHOTKHOTI, ASSAM',
    masterId: 18897,
  },
  {
    type: 'cityName',
    value: 'KETHOHALLI, KARNATAKA',
    masterId: 18013,
  },
  {
    type: 'cityName',
    value: 'KUSMHI, UTTAR PRADESH',
    masterId: 13055,
  },
  {
    type: 'cityName',
    value: 'KHANYAN, WEST BENGAL',
    masterId: 12715,
  },
  {
    type: 'cityName',
    value: 'KUNDA HARNAMGNJ, UTTAR PRADESH',
    masterId: 13017,
  },
  {
    type: 'cityName',
    value: 'KHANAPUR DECCAN, KARNATAKA',
    masterId: 18012,
  },
  {
    type: 'cityName',
    value: 'KACHNARA, MADHYA PRADESH',
    masterId: 17890,
  },
  {
    type: 'cityName',
    value: 'KHOH, UTTAR PRADESH',
    masterId: 18299,
  },
  {
    type: 'cityName',
    value: 'KALIPALLI, ORISSA',
    masterId: 17476,
  },
  {
    type: 'cityName',
    value: 'KHARIK, BIHAR',
    masterId: 18725,
  },
  {
    type: 'cityName',
    value: 'KACHERA, RAJASTHAN',
    masterId: 17480,
  },
  {
    type: 'cityName',
    value: 'KHARKHARI, JHARKHAND',
    masterId: 18369,
  },
  {
    type: 'cityName',
    value: 'MANPURA, MADHYA PRADESH',
    masterId: 13460,
  },
  {
    type: 'cityName',
    value: 'KHARAK, HARYANA',
    masterId: 12718,
  },
  {
    type: 'cityName',
    value: 'KHARESHWAR, GUJARAT',
    masterId: 18446,
  },
  {
    type: 'cityName',
    value: 'KHAIRAHI, UTTAR PRADESH',
    masterId: 16468,
  },
  {
    type: 'cityName',
    value: 'KHARSIA, CHHATTISGARH',
    masterId: 12726,
  },
  {
    type: 'cityName',
    value: 'KHHERA SANDHAN, UTTAR PRADESH',
    masterId: 16460,
  },
  {
    type: 'cityName',
    value: 'SRIKALAHASTI, ANDHRA PRADESH',
    masterId: 15289,
  },
  {
    type: 'cityName',
    value: 'KHATGAON, MAHARASHTRA',
    masterId: 12732,
  },
  {
    type: 'cityName',
    value: 'KHUTAUNA, BIHAR',
    masterId: 18818,
  },
  {
    type: 'cityName',
    value: 'KHATU, RAJASTHAN',
    masterId: 12736,
  },
  {
    type: 'cityName',
    value: 'KHED, RAJASTHAN',
    masterId: 19150,
  },
  {
    type: 'cityName',
    value: 'KHURHAND, UTTAR PRADESH',
    masterId: 12772,
  },
  {
    type: 'cityName',
    value: 'KARAINTHI, HARYANA',
    masterId: 18303,
  },
  {
    type: 'cityName',
    value: 'KHERODA, RAJASTHAN',
    masterId: 17136,
  },
  {
    type: 'cityName',
    value: 'KONDAPALLI, ANDHRA PRADESH',
    masterId: 12867,
  },
  {
    type: 'cityName',
    value: 'KHARI AMRAPUR, GUJARAT',
    masterId: 18445,
  },
  {
    type: 'cityName',
    value: 'TUMAKURU, KARNATAKA',
    masterId: 15616,
  },
  {
    type: 'cityName',
    value: 'KIZHA AMBUR, TAMIL NADU',
    masterId: 16960,
  },
  {
    type: 'cityName',
    value: 'KALLIDAIKURICHI, TAMIL NADU',
    masterId: 19153,
  },
  {
    type: 'cityName',
    value: 'KHAIRAR JUNCTION, UTTAR PRADESH',
    masterId: 16467,
  },
  {
    type: 'cityName',
    value: 'KHIRIA KHURD, UTTAR PRADESH',
    masterId: 16459,
  },
  {
    type: 'cityName',
    value: 'KOLAGHAT, WEST BENGAL',
    masterId: 16117,
  },
  {
    type: 'cityName',
    value: 'KILLE, TAMIL NADU',
    masterId: 16962,
  },
  {
    type: 'cityName',
    value: 'KULDIHA, ODISHA',
    masterId: 20917,
  },
  {
    type: 'cityName',
    value: 'KARAIKAL, PUDUCHERRY',
    masterId: 12525,
  },
  {
    type: 'cityName',
    value: 'KETHORA, MADHYA PRADESH',
    masterId: 12665,
  },
  {
    type: 'cityName',
    value: 'KIM, GUJARAT',
    masterId: 12785,
  },
  {
    type: 'cityName',
    value: 'KAPASAN, RAJASTHAN',
    masterId: 12518,
  },
  {
    type: 'cityName',
    value: 'CHILLAR, HARYANA',
    masterId: 11093,
  },
  {
    type: 'cityName',
    value: 'KHAI PHEME KI, PUNJAB',
    masterId: 17334,
  },
  {
    type: 'cityName',
    value: 'KATIHAR, BIHAR',
    masterId: 12602,
  },
  {
    type: 'cityName',
    value: 'KHIDIRPUR, WEST BENGAL',
    masterId: 21130,
  },
  {
    type: 'cityName',
    value: 'MAHULKHALI, ORISSA',
    masterId: 13271,
  },
  {
    type: 'cityName',
    value: 'KALISEN PH, WEST BENGAL',
    masterId: 16123,
  },
  {
    type: 'cityName',
    value: 'UPULIALAPUR, ORISSA',
    masterId: 15707,
  },
  {
    type: 'cityName',
    value: 'KITHA, JHARKHAND',
    masterId: 17821,
  },
  {
    type: 'cityName',
    value: 'LAKHIMPUR, UTTAR PRADESH',
    masterId: 16744,
  },
  {
    type: 'cityName',
    value: 'KINANA, HARYANA',
    masterId: 18297,
  },
  {
    type: 'cityName',
    value: 'KIUL, BIHAR',
    masterId: 12803,
  },
  {
    type: 'cityName',
    value: 'MANAKJOORI, UTTAR PRADESH',
    masterId: 13351,
  },
  {
    type: 'cityName',
    value: 'KANWARPURA, RAJASTHAN',
    masterId: 17263,
  },
  {
    type: 'cityName',
    value: 'KALAYAT, HARYANA',
    masterId: 18306,
  },
  {
    type: 'cityName',
    value: 'KANSUDHI, GUJARAT',
    masterId: 18453,
  },
  {
    type: 'cityName',
    value: 'KAJGAON, MAHARASHTRA',
    masterId: 12355,
  },
  {
    type: 'cityName',
    value: 'KHAJURHAT, UTTAR PRADESH',
    masterId: 16466,
  },
  {
    type: 'cityName',
    value: 'KASGANJ, UTTAR PRADESH',
    masterId: 16477,
  },
  {
    type: 'cityName',
    value: 'KARAJGI, KARNATAKA',
    masterId: 12528,
  },
  {
    type: 'cityName',
    value: 'NAROTIMPUR, BIHAR',
    masterId: 13900,
  },
  {
    type: 'cityName',
    value: 'KHAJAULI, BIHAR',
    masterId: 12682,
  },
  {
    type: 'cityName',
    value: 'GUNDALAMMAPALEM, ANDHRA PRADESH',
    masterId: 11837,
  },
  {
    type: 'cityName',
    value: 'KANJIKODE, KERALA',
    masterId: 12494,
  },
  {
    type: 'cityName',
    value: 'KHUMGAON BURTI, MAHARASHTRA',
    masterId: 17636,
  },
  {
    type: 'cityName',
    value: 'JHALU, UTTAR PRADESH',
    masterId: 16502,
  },
  {
    type: 'cityName',
    value: 'KAJORA, WEST BENGAL',
    masterId: 16125,
  },
  {
    type: 'cityName',
    value: 'KANNAUJ, UTTAR PRADESH',
    masterId: 12505,
  },
  {
    type: 'cityName',
    value: 'KHOJIPURA, MADHYA PRADESH',
    masterId: 17889,
  },
  {
    type: 'cityName',
    value: 'KURINJIPADI, TAMIL NADU',
    masterId: 16952,
  },
  {
    type: 'cityName',
    value: 'KRISHNARAJASAGARA, KARNATAKA',
    masterId: 18091,
  },
  {
    type: 'cityName',
    value: 'KAJGAON, UTTAR PRADESH',
    masterId: 16486,
  },
  {
    type: 'cityName',
    value: 'RAGHUNATHPUR, WEST BENGAL',
    masterId: 14545,
  },
  {
    type: 'cityName',
    value: 'KHIJADIYA, GUJARAT',
    masterId: 12754,
  },
  {
    type: 'cityName',
    value: 'KHAJWANA, RAJASTHAN',
    masterId: 12687,
  },
  {
    type: 'cityName',
    value: 'KHURJA, UTTAR PRADESH',
    masterId: 12774,
  },
  {
    type: 'cityName',
    value: 'KARONJI, CHHATTISGARH',
    masterId: 12566,
  },
  {
    type: 'cityName',
    value: 'KANKI, WEST BENGAL',
    masterId: 12499,
  },
  {
    type: 'cityName',
    value: 'KAIKALA, WEST BENGAL',
    masterId: 21220,
  },
  {
    type: 'cityName',
    value: 'KANKAHA, UTTAR PRADESH',
    masterId: 12496,
  },
  {
    type: 'cityName',
    value: 'KATKAMSANDI, JHARKHAND',
    masterId: 18161,
  },
  {
    type: 'cityName',
    value: 'BAUCHHAR, MADHYA PRADESH',
    masterId: 10590,
  },
  {
    type: 'cityName',
    value: 'KALKUND, MADHYA PRADESH',
    masterId: 12402,
  },
  {
    type: 'cityName',
    value: 'KURUKSHETRA, HARYANA',
    masterId: 13048,
  },
  {
    type: 'cityName',
    value: 'KHETRI, ASSAM',
    masterId: 12751,
  },
  {
    type: 'cityName',
    value: 'KEKATUMAR, MAHARASHTRA',
    masterId: 17644,
  },
  {
    type: 'cityName',
    value: 'KAKIRIGUMA, ORISSA',
    masterId: 12360,
  },
  {
    type: 'cityName',
    value: 'KALKALIGHAT, ASSAM',
    masterId: 18907,
  },
  {
    type: 'cityName',
    value: 'MAHJIDIA, BIHAR',
    masterId: 13259,
  },
  {
    type: 'cityName',
    value: 'KARKELI, MADHYA PRADESH',
    masterId: 12557,
  },
  {
    type: 'cityName',
    value: 'KAKORI, UTTAR PRADESH',
    masterId: 12363,
  },
  {
    type: 'cityName',
    value: 'KALA BAKRA, PUNJAB',
    masterId: 17343,
  },
  {
    type: 'cityName',
    value: 'KAIKALURU, ANDHRA PRADESH',
    masterId: 12346,
  },
  {
    type: 'cityName',
    value: 'KAKLUR, CHHATTISGARH',
    masterId: 12362,
  },
  {
    type: 'cityName',
    value: 'KAMALAPURAM, ANDHRA PRADESH',
    masterId: 12437,
  },
  {
    type: 'cityName',
    value: 'KASTLA KASAMBAD, UTTAR PRADESH',
    masterId: 16475,
  },
  {
    type: 'cityName',
    value: 'KHIRKIYA, MADHYA PRADESH',
    masterId: 12756,
  },
  {
    type: 'cityName',
    value: 'KHUNKHUNA, RAJASTHAN',
    masterId: 17135,
  },
  {
    type: 'cityName',
    value: 'KARUKHIRAHAR NAGAR, BIHAR',
    masterId: 18729,
  },
  {
    type: 'cityName',
    value: 'KOT KAPURA, PUNJAB',
    masterId: 12897,
  },
  {
    type: 'cityName',
    value: 'KALLAKKUDI PLGH, TAMIL NADU',
    masterId: 12407,
  },
  {
    type: 'cityName',
    value: 'KOKPARA, JHARKHAND',
    masterId: 18160,
  },
  {
    type: 'cityName',
    value: 'KALAIKUNDA, WEST BENGAL',
    masterId: 16218,
  },
  {
    type: 'cityName',
    value: 'KHAKHRALA ROAD, GUJARAT',
    masterId: 20813,
  },
  {
    type: 'cityName',
    value: 'KARAHIA, UTTAR PRADESH',
    masterId: 21061,
  },
  {
    type: 'cityName',
    value: 'KAKRALA, PUNJAB ',
    masterId: 16484,
  },
  {
    type: 'cityName',
    value: 'KAIKARAM, ANDHRA PRADESH',
    masterId: 12347,
  },
  {
    type: 'cityName',
    value: 'KURASTI KALAN, UTTAR PRADESH',
    masterId: 21029,
  },
  {
    type: 'cityName',
    value: 'KATH KUIYAN, UTTAR PRADESH',
    masterId: 16474,
  },
  {
    type: 'cityName',
    value: 'KHUTAHA, BIHAR',
    masterId: 12777,
  },
  {
    type: 'cityName',
    value: 'KUNNAKUDI, TAMIL NADU',
    masterId: 17039,
  },
  {
    type: 'cityName',
    value: 'KANAKPURA, JAIPUR, RAJASTHAN',
    masterId: 12463,
  },
  {
    type: 'cityName',
    value: 'KANKAVALI, MAHARASHTRA',
    masterId: 12498,
  },
  {
    type: 'cityName',
    value: 'KILAKADAYAM, TAMIL NADU',
    masterId: 16963,
  },
  {
    type: 'cityName',
    value: 'KHERLI, RAJASTHAN',
    masterId: 12748,
  },
  {
    type: 'cityName',
    value: 'KULWA, UTTAR PRADESH',
    masterId: 12998,
  },
  {
    type: 'cityName',
    value: 'KALANAD, KERALA',
    masterId: 17929,
  },
  {
    type: 'cityName',
    value: 'KULPAHAR, UTTAR PRADESH',
    masterId: 12995,
  },
  {
    type: 'cityName',
    value: 'KIRAOLI, UTTAR PRADESH',
    masterId: 12792,
  },
  {
    type: 'cityName',
    value: 'KALAMBHA, MAHARASHTRA',
    masterId: 17652,
  },
  {
    type: 'cityName',
    value: 'KATLICHERRA, ASSAM',
    masterId: 18968,
  },
  {
    type: 'cityName',
    value: 'KHALILABAD, UTTAR PRADESH',
    masterId: 12694,
  },
  {
    type: 'cityName',
    value: 'KALDARI, ANDHRA PRADESH',
    masterId: 12388,
  },
  {
    type: 'cityName',
    value: 'KAITHAL, HARYANA',
    masterId: 12352,
  },
  {
    type: 'cityName',
    value: 'KOLLENGODE, KERALA',
    masterId: 17946,
  },
  {
    type: 'cityName',
    value: 'KALLAGAM, TAMIL NADU',
    masterId: 16978,
  },
  {
    type: 'cityName',
    value: 'KALANGANI, TAMIL NADU',
    masterId: 16979,
  },
  {
    type: 'cityName',
    value: 'KHALAIGRAM, WEST BENGAL',
    masterId: 16120,
  },
  {
    type: 'cityName',
    value: 'JAJELA, RAJASTHAN',
    masterId: 12139,
  },
  {
    type: 'cityName',
    value: 'KOLHADI, MAHARASHTRA ',
    masterId: 17819,
  },
  {
    type: 'cityName',
    value: 'KAULI, PUNJAB',
    masterId: 17336,
  },
  {
    type: 'cityName',
    value: 'KAMALGANJ, UTTAR PRADESH',
    masterId: 12438,
  },
  {
    type: 'cityName',
    value: 'KALIJAI, ORISSA',
    masterId: 17477,
  },
  {
    type: 'cityName',
    value: 'KALKA, HARYANA',
    masterId: 12401,
  },
  {
    type: 'cityName',
    value: 'KALIKAPUR, WEST BENGAL',
    masterId: 21170,
  },
  {
    type: 'cityName',
    value: 'KADLIMATTI, KARNATAKA',
    masterId: 18021,
  },
  {
    type: 'cityName',
    value: 'KALAMBOLI, MAHARASHTRA',
    masterId: 12373,
  },
  {
    type: 'cityName',
    value: 'KALAMASSERY, KERALA',
    masterId: 17948,
  },
  {
    type: 'cityName',
    value: 'KALANAUR, HARYANA',
    masterId: 12377,
  },
  {
    type: 'cityName',
    value: 'KAMGACHHI, WEST BENGAL',
    masterId: 12447,
  },
  {
    type: 'cityName',
    value: 'KALINAGAR, WEST BENGAL',
    masterId: 16483,
  },
  {
    type: 'cityName',
    value: 'KOTALPUKUR, JHARKHAND',
    masterId: 12904,
  },
  {
    type: 'cityName',
    value: 'KAMALPURGRAM, CHHATTISGARH',
    masterId: 12440,
  },
  {
    type: 'cityName',
    value: 'S.KAILASAPURAM, TAMIL NADU',
    masterId: 14778,
  },
  {
    type: 'cityName',
    value: 'KARICODE, KERALA',
    masterId: 12548,
  },
  {
    type: 'cityName',
    value: 'KHALARI, JHARKHAND',
    masterId: 12692,
  },
  {
    type: 'cityName',
    value: 'TIGHARIYA, MADHYA PRADESH',
    masterId: 15550,
  },
  {
    type: 'cityName',
    value: 'KOLATHUR, TAMIL NADU',
    masterId: 17042,
  },
  {
    type: 'cityName',
    value: 'KUSHALPURA, HARYANA',
    masterId: 17127,
  },
  {
    type: 'cityName',
    value: 'KAULSERI, PUNJAB',
    masterId: 17335,
  },
  {
    type: 'cityName',
    value: 'MARTHANDAM, TAMIL NADU',
    masterId: 13493,
  },
  {
    type: 'cityName',
    value: 'KALMITAR, CHHATTISGARH',
    masterId: 12421,
  },
  {
    type: 'cityName',
    value: 'KALLURU, ANDHRA PRADESH',
    masterId: 12420,
  },
  {
    type: 'cityName',
    value: 'ZANZROLI, MAHARASHTRA',
    masterId: 16005,
  },
  {
    type: 'cityName',
    value: 'KALWAN HALT, GUJARAT',
    masterId: 20820,
  },
  {
    type: 'cityName',
    value: 'KALITALAVDI, GUJARAT',
    masterId: 20808,
  },
  {
    type: 'cityName',
    value: 'KILLIANWALI, PUNJAB',
    masterId: 17417,
  },
  {
    type: 'cityName',
    value: 'KALWAN, HARYANA',
    masterId: 17651,
  },
  {
    type: 'cityName',
    value: 'KOLAKALUR, ANDHRA PRADESH',
    masterId: 12836,
  },
  {
    type: 'cityName',
    value: 'KALYANI GHOSHPARA, WEST BENGAL',
    masterId: 21241,
  },
  {
    type: 'cityName',
    value: 'KALLUR YEDAHLI, KARNATAKA',
    masterId: 18019,
  },
  {
    type: 'cityName',
    value: 'KALYANI SIMANTA, WEST BENGAL',
    masterId: 21240,
  },
  {
    type: 'cityName',
    value: 'KALYANI SILPANCHAL, WEST BENGAL',
    masterId: 21242,
  },
  {
    type: 'cityName',
    value: 'KOLAYAT, RAJASTHAN',
    masterId: 12839,
  },
  {
    type: 'cityName',
    value: 'KALEEM, GOA',
    masterId: 17150,
  },
  {
    type: 'cityName',
    value: 'KAIMA, MADHYA PRADESH',
    masterId: 12350,
  },
  {
    type: 'cityName',
    value: 'KHAMARGACHHI, WEST BENGAL',
    masterId: 12697,
  },
  {
    type: 'cityName',
    value: 'KAMATHE, MAHARASHTRA',
    masterId: 12445,
  },
  {
    type: 'cityName',
    value: 'KHAMBHALIA, GUJARAT',
    masterId: 12702,
  },
  {
    type: 'cityName',
    value: 'KAMAREDDI, ANDHRA PRADESH',
    masterId: 12443,
  },
  {
    type: 'cityName',
    value: 'KODUMUDI, TAMIL NADU',
    masterId: 12821,
  },
  {
    type: 'cityName',
    value: 'KARIMUDDINPUR, UTTAR PRADESH',
    masterId: 12551,
  },
  {
    type: 'cityName',
    value: 'KUMHAR MARENGA, BIHAR',
    masterId: 13007,
  },
  {
    type: 'cityName',
    value: 'KUMAHU, BIHAR',
    masterId: 18719,
  },
  {
    type: 'cityName',
    value: 'KAMARGANJ, BIHAR',
    masterId: 18732,
  },
  {
    type: 'cityName',
    value: 'KALAMALLA, ANDHRA PRADESH',
    masterId: 12372,
  },
  {
    type: 'cityName',
    value: 'KARMAHAT, JHARKHAND',
    masterId: 18163,
  },
  {
    type: 'cityName',
    value: 'KUMHARI, CHHATTISGARH',
    masterId: 13008,
  },
  {
    type: 'cityName',
    value: 'KAIMGANJ, UTTAR PRADESH',
    masterId: 12351,
  },
  {
    type: 'cityName',
    value: 'KOMAKHAN, CHHATTISGARH',
    masterId: 12858,
  },
  {
    type: 'cityName',
    value: 'KHAMKHED, MAHARASHTRA ',
    masterId: 17640,
  },
  {
    type: 'cityName',
    value: 'KAMTAUL, BIHAR',
    masterId: 12458,
  },
  {
    type: 'cityName',
    value: 'KAMLI, GUJARAT',
    masterId: 18455,
  },
  {
    type: 'cityName',
    value: 'KELAMANGALAM, TAMIL NADU',
    masterId: 16965,
  },
  {
    type: 'cityName',
    value: 'PANDEWAR, CHHATTISGARH',
    masterId: 14198,
  },
  {
    type: 'cityName',
    value: 'KANNAMANGALAM, TAMIL NADU',
    masterId: 16973,
  },
  {
    type: 'cityName',
    value: 'MENDHA, MAHARASHTRA',
    masterId: 17619,
  },
  {
    type: 'cityName',
    value: 'CHIRKUNDA, JHARKHAND',
    masterId: 11125,
  },
  {
    type: 'cityName',
    value: 'MANDAWARA, RAJASTHAN',
    masterId: 13388,
  },
  {
    type: 'cityName',
    value: 'KUMANDIH, JHARKHAND ',
    masterId: 18157,
  },
  {
    type: 'cityName',
    value: 'KISHAN MANPURA, RAJASTHAN',
    masterId: 17134,
  },
  {
    type: 'cityName',
    value: 'KAMALNAGAR, KARNATAKA',
    masterId: 12439,
  },
  {
    type: 'cityName',
    value: 'KAMALPUR, BIHAR',
    masterId: 18733,
  },
  {
    type: 'cityName',
    value: 'TADWALE, MAHARASHTRA',
    masterId: 15385,
  },
  {
    type: 'cityName',
    value: 'KUMARGANJ, WEST BENGAL',
    masterId: 16116,
  },
  {
    type: 'cityName',
    value: 'KUMRUL, WEST BENGAL',
    masterId: 21117,
  },
  {
    type: 'cityName',
    value: 'SAIYADRAJA, UTTAR PRADESH',
    masterId: 14820,
  },
  {
    type: 'cityName',
    value: 'KUMAR SADRA, CHHATTISGARH',
    masterId: 12999,
  },
  {
    type: 'cityName',
    value: 'KUMSI, KARNATAKA',
    masterId: 18090,
  },
  {
    type: 'cityName',
    value: 'KAMSHET, MAHARASHTRA',
    masterId: 12457,
  },
  {
    type: 'cityName',
    value: 'KHAMMAM, TELANGANA',
    masterId: 12704,
  },
  {
    type: 'cityName',
    value: 'KUMARHATTI, HIMACHAL PRADESH',
    masterId: 13000,
  },
  {
    type: 'cityName',
    value: 'KUMBAKONAM, TAMIL NADU',
    masterId: 13001,
  },
  {
    type: 'cityName',
    value: 'KARMAD, MAHARASHTRA',
    masterId: 12563,
  },
  {
    type: 'cityName',
    value: 'KOMATIPALLI, ANDHRA PRADESH',
    masterId: 12862,
  },
  {
    type: 'cityName',
    value: 'KATNI, MADHYA PRADESH',
    masterId: 12603,
  },
  {
    type: 'cityName',
    value: 'KANKRA MIRZANGR, WEST BENGAL',
    masterId: 21160,
  },
  {
    type: 'cityName',
    value: 'KADALUNDI, KERALA',
    masterId: 12316,
  },
  {
    type: 'cityName',
    value: 'KANAD, GUJARAT',
    masterId: 17947,
  },
  {
    type: 'cityName',
    value: 'KHANPUR AHIR, RAJASTHAN',
    masterId: 17138,
  },
  {
    type: 'cityName',
    value: 'KANIYAMBADI, TAMIL NADU',
    masterId: 16974,
  },
  {
    type: 'cityName',
    value: 'KANAIBAZAR, ASSAM',
    masterId: 18906,
  },
  {
    type: 'cityName',
    value: 'KANCHANPUR, MADHYA PRADESH',
    masterId: 16482,
  },
  {
    type: 'cityName',
    value: 'KANDRA, JHARKHAND',
    masterId: 12477,
  },
  {
    type: 'cityName',
    value: 'KANHAD GAON, MADHYA PRADESH',
    masterId: 20870,
  },
  {
    type: 'cityName',
    value: 'KANDRORI, HIMACHAL PRADESH ',
    masterId: 18242,
  },
  {
    type: 'cityName',
    value: 'KHANDEL, RAJASTHAN',
    masterId: 17139,
  },
  {
    type: 'cityName',
    value: 'KHANDIP, RAJASTHAN',
    masterId: 12711,
  },
  {
    type: 'cityName',
    value: 'KISHANGANJ, BIHAR',
    masterId: 12798,
  },
  {
    type: 'cityName',
    value: 'KHANUDIH, JHARKHAND',
    masterId: 18223,
  },
  {
    type: 'cityName',
    value: 'KATHUNANGAL, PUNJAB',
    masterId: 17337,
  },
  {
    type: 'cityName',
    value: 'VARI, MAHARASHTRA',
    masterId: 15790,
  },
  {
    type: 'cityName',
    value: 'KASHINAGAR, ORISSA',
    masterId: 17472,
  },
  {
    type: 'cityName',
    value: 'KONCH, UTTAR PRADESH',
    masterId: 16454,
  },
  {
    type: 'cityName',
    value: 'KANHE, MAHARASHTRA',
    masterId: 17649,
  },
  {
    type: 'cityName',
    value: 'KANTHAN, MAHARASHTRA',
    masterId: 12514,
  },
  {
    type: 'cityName',
    value: 'KANHAIPUR, BIHAR',
    masterId: 12486,
  },
  {
    type: 'cityName',
    value: 'KRISHNGR CTY, WEST BENGAL',
    masterId: 12963,
  },
  {
    type: 'cityName',
    value: 'KARANJALI  HALT, WEST BENGAL',
    masterId: 21255,
  },
  {
    type: 'cityName',
    value: 'KANJARA, MAHARASHTRA',
    masterId: 17473,
  },
  {
    type: 'cityName',
    value: 'KANAKOT, GUJARAT',
    masterId: 12461,
  },
  {
    type: 'cityName',
    value: 'KALANWALI, HARYANA',
    masterId: 12378,
  },
  {
    type: 'cityName',
    value: 'KANAMALO PALLE, ANDHRA PRADESH',
    masterId: 12465,
  },
  {
    type: 'cityName',
    value: 'KANALUS, GUJARAT',
    masterId: 12464,
  },
  {
    type: 'cityName',
    value: 'KANIMAHULI, JHARKHAND',
    masterId: 17474,
  },
  {
    type: 'cityName',
    value: 'KHANNA, PUNJAB',
    masterId: 12713,
  },
  {
    type: 'cityName',
    value: 'KHINANIYAN, HARYANA',
    masterId: 18356,
  },
  {
    type: 'cityName',
    value: 'KANINA, HARYANA',
    masterId: 18304,
  },
  {
    type: 'cityName',
    value: 'KUNNATHUR, TAMIL NADU',
    masterId: 16953,
  },
  {
    type: 'cityName',
    value: 'KUNDGOL, KARNATAKA',
    masterId: 13022,
  },
  {
    type: 'cityName',
    value: 'KHANAPUR, KARNATAKA',
    masterId: 12706,
  },
  {
    type: 'cityName',
    value: 'KENDRAPARA, ORISSA',
    masterId: 12648,
  },
  {
    type: 'cityName',
    value: 'KENDPOSI, JHARKHAND',
    masterId: 12647,
  },
  {
    type: 'cityName',
    value: 'KANKINARA, WEST BENGAL',
    masterId: 16217,
  },
  {
    type: 'cityName',
    value: 'KANHARGAON NAKA, MAHARASHTRA',
    masterId: 17650,
  },
  {
    type: 'cityName',
    value: 'KUNURI, WEST BENGAL',
    masterId: 16211,
  },
  {
    type: 'cityName',
    value: 'KANAROAN, JHARKHAND',
    masterId: 18169,
  },
  {
    type: 'cityName',
    value: 'KUNERU, ANDHRA PRADESH',
    masterId: 13024,
  },
  {
    type: 'cityName',
    value: 'KANCHAUSI, UTTAR PRADESH',
    masterId: 21012,
  },
  {
    type: 'cityName',
    value: 'KARNA SUBARNA, WEST BENGAL',
    masterId: 16122,
  },
  {
    type: 'cityName',
    value: 'KANASAR, RAJASTHAN',
    masterId: 12466,
  },
  {
    type: 'cityName',
    value: 'KANTH, UTTAR PRADESH',
    masterId: 12513,
  },
  {
    type: 'cityName',
    value: 'KINWAT, MAHARASHTRA',
    masterId: 12790,
  },
  {
    type: 'cityName',
    value: 'KHANDWA, MADHYA PRADESH',
    masterId: 12712,
  },
  {
    type: 'cityName',
    value: 'KANIYOOR, KARNATAKA',
    masterId: 18018,
  },
  {
    type: 'cityName',
    value: 'NELAKOSIGI, ANDHRA PRADESH',
    masterId: 13961,
  },
  {
    type: 'cityName',
    value: 'KARONDA, MADHYA PRADESH',
    masterId: 17827,
  },
  {
    type: 'cityName',
    value: 'KODI, MAHARASHTRA',
    masterId: 12819,
  },
  {
    type: 'cityName',
    value: 'KODUMUNDA, KERALA',
    masterId: 17923,
  },
  {
    type: 'cityName',
    value: 'KODINAR, GUJARAT',
    masterId: 12820,
  },
  {
    type: 'cityName',
    value: 'MARWAR KORI, RAJASTHAN',
    masterId: 20968,
  },
  {
    type: 'cityName',
    value: 'KONNAGAR, WEST BENGAL',
    masterId: 21076,
  },
  {
    type: 'cityName',
    value: 'KOHLI, MAHARASHTRA',
    masterId: 18295,
  },
  {
    type: 'cityName',
    value: 'KOHIR DECCAN, ANDHRA PRADESH',
    masterId: 12827,
  },
  {
    type: 'cityName',
    value: 'KHODRI, CHHATTISGARH',
    masterId: 12760,
  },
  {
    type: 'cityName',
    value: 'KOKRAJHAR, ASSAM',
    masterId: 12833,
  },
  {
    type: 'cityName',
    value: 'KORUKKUPET, TAMIL NADU',
    masterId: 17041,
  },
  {
    type: 'cityName',
    value: 'KOKA, MAHARASHTRA',
    masterId: 18294,
  },
  {
    type: 'cityName',
    value: 'KOLAD, MAHARASHTRA',
    masterId: 12835,
  },
  {
    type: 'cityName',
    value: 'KOTLA, ANDHRA PRADESH',
    masterId: 17415,
  },
  {
    type: 'cityName',
    value: 'KOLE, JHARKHAND',
    masterId: 17733,
  },
  {
    type: 'cityName',
    value: 'KESHOLI, RAJASTHAN',
    masterId: 17260,
  },
  {
    type: 'cityName',
    value: 'KOLNUR, ANDHRA PRADESH',
    masterId: 12855,
  },
  {
    type: 'cityName',
    value: 'MADURAI, TAMIL NADU',
    masterId: 13215,
  },
  {
    type: 'cityName',
    value: 'KONA, ANDHRA PRADESH',
    masterId: 20737,
  },
  {
    type: 'cityName',
    value: 'KONNUR, ANDHRA PRADESH',
    masterId: 12871,
  },
  {
    type: 'cityName',
    value: 'RANTH-BHANWAR, MADHYA PRADESH',
    masterId: 14672,
  },
  {
    type: 'cityName',
    value: 'KHUSRUPUR, BIHAR',
    masterId: 12776,
  },
  {
    type: 'cityName',
    value: 'KHORI, HARYANA',
    masterId: 18298,
  },
  {
    type: 'cityName',
    value: 'KOTHI, HIMACHAL PRADESH',
    masterId: 12920,
  },
  {
    type: 'cityName',
    value: 'KOTTUR, TELANGANA',
    masterId: 16811,
  },
  {
    type: 'cityName',
    value: 'KODURU, ANDHRA PRADESH',
    masterId: 12824,
  },
  {
    type: 'cityName',
    value: 'KIRLOSKARVADI, MAHARASHTRA',
    masterId: 12796,
  },
  {
    type: 'cityName',
    value: 'KHOWANG, ASSAM',
    masterId: 18896,
  },
  {
    type: 'cityName',
    value: 'KACHUJOR, WEST BENGAL',
    masterId: 16127,
  },
  {
    type: 'cityName',
    value: 'KHEROL, GUJARAT',
    masterId: 18444,
  },
  {
    type: 'cityName',
    value: 'KOSMA, UTTAR PRADESH',
    masterId: 16453,
  },
  {
    type: 'cityName',
    value: 'KAMPTEE, MAHARASHTRA',
    masterId: 12454,
  },
  {
    type: 'cityName',
    value: 'JHARPOKHARIA, BIHAR',
    masterId: 17484,
  },
  {
    type: 'cityName',
    value: 'KUMARCHINTAMANPUR, BIHAR',
    masterId: 18852,
  },
  {
    type: 'cityName',
    value: 'VELLORE, TAMIL NADU',
    masterId: 15835,
  },
  {
    type: 'cityName',
    value: 'KAUWAPUR, UTTAR PRADESH',
    masterId: 16470,
  },
  {
    type: 'cityName',
    value: 'KOPARGAON, MAHARASHTRA',
    masterId: 12877,
  },
  {
    type: 'cityName',
    value: 'KARPURIGRAM, BIHAR',
    masterId: 12567,
  },
  {
    type: 'cityName',
    value: 'KALPI, UTTAR PRADESH',
    masterId: 12426,
  },
  {
    type: 'cityName',
    value: 'KOPAGANJ, UTTAR PRADESH',
    masterId: 21050,
  },
  {
    type: 'cityName',
    value: 'KEREJANGA, ORISSA',
    masterId: 17469,
  },
  {
    type: 'cityName',
    value: 'KALIPAHARI, WEST BENGAL',
    masterId: 12399,
  },
  {
    type: 'cityName',
    value: 'KASIMPUR KHERI, UTTAR PRADESH',
    masterId: 16476,
  },
  {
    type: 'cityName',
    value: 'KANTAKAPALLE, ANDHRA PRADESH',
    masterId: 12512,
  },
  {
    type: 'cityName',
    value: 'KAPALI, ORISSA',
    masterId: 18167,
  },
  {
    type: 'cityName',
    value: 'KOPAI, WEST BENGAL',
    masterId: 12876,
  },
  {
    type: 'cityName',
    value: 'KOTTA PNDLPALLI, ANDHRA PRADESH',
    masterId: 12928,
  },
  {
    type: 'cityName',
    value: 'KUPPAM, ANDHRA PRADESH',
    masterId: 13032,
  },
  {
    type: 'cityName',
    value: 'KAPAN, CHHATTISGARH',
    masterId: 12517,
  },
  {
    type: 'cityName',
    value: 'KARANPURA, RAJASTHAN',
    masterId: 17262,
  },
  {
    type: 'cityName',
    value: 'SHAJAPUR, MADHYA PRADESH',
    masterId: 15054,
  },
  {
    type: 'cityName',
    value: 'KARUPPUR, TAMIL NADU',
    masterId: 16968,
  },
  {
    type: 'cityName',
    value: 'KANNAPURAM, KERALA',
    masterId: 12504,
  },
  {
    type: 'cityName',
    value: 'KALYANPUR ROAD, BIHAR',
    masterId: 12434,
  },
  {
    type: 'cityName',
    value: 'KOTAPAR ROAD, CHHATTISGARH',
    masterId: 12905,
  },
  {
    type: 'cityName',
    value: 'KOPA SAMHOTA, BIHAR',
    masterId: 18722,
  },
  {
    type: 'cityName',
    value: 'KANJIRAMATTOM, KERALA',
    masterId: 17926,
  },
  {
    type: 'cityName',
    value: 'ISHWARNAGAR, RAJASTHAN',
    masterId: 12084,
  },
  {
    type: 'cityName',
    value: 'KARANPURATO, JHARKHAND',
    masterId: 18165,
  },
  {
    type: 'cityName',
    value: 'KRISHNAPURAM, ANDHRA PRADESH',
    masterId: 12957,
  },
  {
    type: 'cityName',
    value: 'KASHIPUR, UTTARAKHAND',
    masterId: 12580,
  },
  {
    type: 'cityName',
    value: 'KAIPADA ROAD, ORISSA',
    masterId: 17479,
  },
  {
    type: 'cityName',
    value: 'KARUNAGAPPALLY, KERALA',
    masterId: 12572,
  },
  {
    type: 'cityName',
    value: 'KAPREN, RAJASTHAN',
    masterId: 12520,
  },
  {
    type: 'cityName',
    value: 'KONDAGUNTA, ANDHRA PRADESH',
    masterId: 12866,
  },
  {
    type: 'cityName',
    value: 'KHAIRATABAD, ANDHRA PRADESH',
    masterId: 12680,
  },
  {
    type: 'cityName',
    value: 'KALA AKHAR, MADHYA PRADESH',
    masterId: 12365,
  },
  {
    type: 'cityName',
    value: 'KALACHAND, ASSAM',
    masterId: 12367,
  },
  {
    type: 'cityName',
    value: 'BEKAL, KERALA',
    masterId: 10613,
  },
  {
    type: 'cityName',
    value: 'KANDHLA, UTTAR PRADESH',
    masterId: 16481,
  },
  {
    type: 'cityName',
    value: 'KAUKUNTLA, ANDHRA PRADESH',
    masterId: 12612,
  },
  {
    type: 'cityName',
    value: 'KODERMA, JHARKHAND',
    masterId: 12818,
  },
  {
    type: 'cityName',
    value: 'KAILARAS, MADHYA PRADESH',
    masterId: 17831,
  },
  {
    type: 'cityName',
    value: 'KURGUNTA, KARNATAKA',
    masterId: 13038,
  },
  {
    type: 'cityName',
    value: 'MUSTAFAPUR, WEST BENGAL',
    masterId: 13761,
  },
  {
    type: 'cityName',
    value: 'KHEDULI, RAJASTHAN',
    masterId: 12743,
  },
  {
    type: 'cityName',
    value: 'KHORIKOTIA, ASSAM',
    masterId: 18898,
  },
  {
    type: 'cityName',
    value: 'KOLAR, KARNATAKA',
    masterId: 12837,
  },
  {
    type: 'cityName',
    value: 'KAREPALLI, ANDHRA PRADESH',
    masterId: 12545,
  },
  {
    type: 'cityName',
    value: 'KAHER , GUJARAT',
    masterId: 12341,
  },
  {
    type: 'cityName',
    value: 'KORATTI ANGADI, KERALA',
    masterId: 17901,
  },
  {
    type: 'cityName',
    value: 'KHARIAR ROAD, CHHATTISGARH',
    masterId: 12723,
  },
  {
    type: 'cityName',
    value: 'KORBA, CHHATTISGARH',
    masterId: 12885,
  },
  {
    type: 'cityName',
    value: 'KHUDIRAM B PUSA, BIHAR',
    masterId: 12768,
  },
  {
    type: 'cityName',
    value: 'KIRODA, RAJASTHAN',
    masterId: 19142,
  },
  {
    type: 'cityName',
    value: 'KHARWA CHANDA, RAJASTHAN',
    masterId: 12728,
  },
  {
    type: 'cityName',
    value: 'KARAD, MAHARASHTRA',
    masterId: 12524,
  },
  {
    type: 'cityName',
    value: 'KIRANDUL, CHHATTISGARH',
    masterId: 12791,
  },
  {
    type: 'cityName',
    value: 'KARAUNDHANA, UTTAR PRADESH',
    masterId: 21037,
  },
  {
    type: 'cityName',
    value: 'KARTARPUR, PUNJAB',
    masterId: 12568,
  },
  {
    type: 'cityName',
    value: 'KOREGAON, MAHARASHTRA',
    masterId: 12886,
  },
  {
    type: 'cityName',
    value: 'KURANGA, GUJARAT',
    masterId: 18438,
  },
  {
    type: 'cityName',
    value: 'KARGAON, MAHARASHTRA ',
    masterId: 17648,
  },
  {
    type: 'cityName',
    value: 'KHAIRTHAL, RAJASTHAN',
    masterId: 12681,
  },
  {
    type: 'cityName',
    value: 'KORAHIA, BIHAR',
    masterId: 18721,
  },
  {
    type: 'cityName',
    value: 'KARAHAT, ASSAM',
    masterId: 16479,
  },
  {
    type: 'cityName',
    value: 'KHAPRI, MAHARASHTRA',
    masterId: 17639,
  },
  {
    type: 'cityName',
    value: 'KORAI, ORISSA',
    masterId: 12883,
  },
  {
    type: 'cityName',
    value: 'KARJODA, GUJARAT',
    masterId: 18452,
  },
  {
    type: 'cityName',
    value: 'KARJARA, BIHAR',
    masterId: 18730,
  },
  {
    type: 'cityName',
    value: 'KARAKKAD, KERALA',
    masterId: 17925,
  },
  {
    type: 'cityName',
    value: 'KHARA, RAJASTHAN',
    masterId: 17137,
  },
  {
    type: 'cityName',
    value: 'KARKEND, JHARKHAND',
    masterId: 18164,
  },
  {
    type: 'cityName',
    value: 'KYAARKOPPA, KARNATAKA',
    masterId: 18005,
  },
  {
    type: 'cityName',
    value: 'KURKURA, JHARKHAND',
    masterId: 18154,
  },
  {
    type: 'cityName',
    value: 'KOTARLIYA, CHHATTISGARH',
    masterId: 12906,
  },
  {
    type: 'cityName',
    value: 'KURALI, PUNJAB',
    masterId: 13035,
  },
  {
    type: 'cityName',
    value: 'CHAKARIYA, MADHYA PRADESH',
    masterId: 10952,
  },
  {
    type: 'cityName',
    value: 'KURLA MAIN, MADHYA PRADESH',
    masterId: 17633,
  },
  {
    type: 'cityName',
    value: 'KARAMTOLA, JHARKHAND',
    masterId: 18166,
  },
  {
    type: 'cityName',
    value: 'KARMABAD BH, JHARKHAND',
    masterId: 20846,
  },
  {
    type: 'cityName',
    value: 'KUARMUNDA, ORISSA',
    masterId: 17468,
  },
  {
    type: 'cityName',
    value: 'KUMARAMANGALAM, TAMIL NADU',
    masterId: 17945,
  },
  {
    type: 'cityName',
    value: 'KUMARIPUR, BIHAR',
    masterId: 18717,
  },
  {
    type: 'cityName',
    value: 'KARIMNAGAR, TELANGANA',
    masterId: 12550,
  },
  {
    type: 'cityName',
    value: 'KHORASON ROAD, UTTAR PRADESH',
    masterId: 12766,
  },
  {
    type: 'cityName',
    value: 'KARENAHALLI, KARNATAKA',
    masterId: 18017,
  },
  {
    type: 'cityName',
    value: 'KRISHNAI, ASSAM',
    masterId: 18895,
  },
  {
    type: 'cityName',
    value: 'KRISHNARAJANAGARA, KARNATAKA',
    masterId: 12958,
  },
  {
    type: 'cityName',
    value: 'KURNOOL, ANDHRA PRADESH',
    masterId: 13042,
  },
  {
    type: 'cityName',
    value: 'KONANUR, KARNATAKA',
    masterId: 18008,
  },
  {
    type: 'cityName',
    value: 'KURAWAN, MADHYA PRADESH',
    masterId: 17887,
  },
  {
    type: 'cityName',
    value: 'KORAUNA, BIHAR',
    masterId: 18720,
  },
  {
    type: 'cityName',
    value: 'LALGOLA, WEST BENGAL',
    masterId: 13100,
  },
  {
    type: 'cityName',
    value: 'KURUPPUMTHARA, KERALA',
    masterId: 17919,
  },
  {
    type: 'cityName',
    value: 'KAREPUR, MAHARASHTRA',
    masterId: 12546,
  },
  {
    type: 'cityName',
    value: 'SUNAPUR, ORISSA',
    masterId: 15339,
  },
  {
    type: 'cityName',
    value: 'KARARI, MADHYA PRADESH',
    masterId: 16478,
  },
  {
    type: 'cityName',
    value: 'KARUR, TAMIL NADU',
    masterId: 12573,
  },
  {
    type: 'cityName',
    value: 'KARRA, JHARKHAND',
    masterId: 18162,
  },
  {
    type: 'cityName',
    value: 'KARISATH, BIHAR',
    masterId: 12552,
  },
  {
    type: 'cityName',
    value: 'KHARSALIYA, GUJARAT',
    masterId: 12725,
  },
  {
    type: 'cityName',
    value: 'KRISHNASHILLA, UTTAR PRADESH',
    masterId: 12961,
  },
  {
    type: 'cityName',
    value: 'KOHAR SINGH WALA, PUNJAB',
    masterId: 17329,
  },
  {
    type: 'cityName',
    value: 'KHURAHAT, UTTAR PRADESH',
    masterId: 16457,
  },
  {
    type: 'cityName',
    value: 'KHARKATA, JHARKHAND',
    masterId: 16214,
  },
  {
    type: 'cityName',
    value: 'NAZARPUR, MADHYA PRADESH',
    masterId: 13950,
  },
  {
    type: 'cityName',
    value: 'KARAULI, UTTAR PRADESH',
    masterId: 17144,
  },
  {
    type: 'cityName',
    value: 'KARAUTA, BIHAR',
    masterId: 18849,
  },
  {
    type: 'cityName',
    value: 'KEERANUR, TAMIL NADU',
    masterId: 17043,
  },
  {
    type: 'cityName',
    value: 'KARAVADI, ANDHRA PRADESH',
    masterId: 12541,
  },
  {
    type: 'cityName',
    value: 'KURUD, CHHATTISGARH',
    masterId: 18606,
  },
  {
    type: 'cityName',
    value: 'KHARA MP, MADHYA PRADESH',
    masterId: 20868,
  },
  {
    type: 'cityName',
    value: 'KRISHNAMOHAN (HALT), WEST BENGAL',
    masterId: 21184,
  },
  {
    type: 'cityName',
    value: 'KADIRI, ANDHRA PRADESH',
    masterId: 12332,
  },
  {
    type: 'cityName',
    value: 'KURAIYA, UTTAR PRADESH',
    masterId: 16450,
  },
  {
    type: 'cityName',
    value: 'KARAMSAD, GUJARAT',
    masterId: 20799,
  },
  {
    type: 'cityName',
    value: 'KHARAWAR, HARYANA',
    masterId: 18370,
  },
  {
    type: 'cityName',
    value: 'KHETA SARAI, UTTAR PRADESH',
    masterId: 12750,
  },
  {
    type: 'cityName',
    value: 'KHASA, PUNJAB',
    masterId: 20947,
  },
  {
    type: 'cityName',
    value: 'KOSAI, TELANGANA',
    masterId: 17732,
  },
  {
    type: 'cityName',
    value: 'KUDALA SANGAMA, KARNATAKA',
    masterId: 18007,
  },
  {
    type: 'cityName',
    value: 'KOSAMBA, GUJARAT',
    masterId: 12892,
  },
  {
    type: 'cityName',
    value: 'KASHIABARI, WEST BENGAL',
    masterId: 18904,
  },
  {
    type: 'cityName',
    value: 'KESHABPUR, WEST BENGAL',
    masterId: 21225,
  },
  {
    type: 'cityName',
    value: 'KASHI CHAK, BIHAR',
    masterId: 12579,
  },
  {
    type: 'cityName',
    value: 'KESHOD, GUJARAT',
    masterId: 12662,
  },
  {
    type: 'cityName',
    value: 'KARSINDHU, HARYANA',
    masterId: 18301,
  },
  {
    type: 'cityName',
    value: 'KHALISPUR, UTTAR PRADESH',
    masterId: 12695,
  },
  {
    type: 'cityName',
    value: 'KISHANGARH, RAJASTHAN',
    masterId: 12799,
  },
  {
    type: 'cityName',
    value: 'KALI SINDH, MADHYA PRADESH',
    masterId: 12393,
  },
  {
    type: 'cityName',
    value: 'KESHWARI, JHARKHAND',
    masterId: 20849,
  },
  {
    type: 'cityName',
    value: 'KOSLI, HARYANA',
    masterId: 12895,
  },
  {
    type: 'cityName',
    value: 'KHODSEONI, MAHARASHTRA',
    masterId: 17824,
  },
  {
    type: 'cityName',
    value: 'LOHARRE, UTTAR PRADESH',
    masterId: 13152,
  },
  {
    type: 'cityName',
    value: 'KESLA, MADHYA PRADESH',
    masterId: 18609,
  },
  {
    type: 'cityName',
    value: 'VATTIGAL, KARNATAKA',
    masterId: 15808,
  },
  {
    type: 'cityName',
    value: 'GURUJALA, KARNATAKA',
    masterId: 11870,
  },
  {
    type: 'cityName',
    value: 'KANASAR NAWADA, JHARKHAND',
    masterId: 18168,
  },
  {
    type: 'cityName',
    value: 'KESINGA, ORISSA',
    masterId: 12663,
  },
  {
    type: 'cityName',
    value: 'KHUSHAL NAGAR, UTTAR PRADESH',
    masterId: 19171,
  },
  {
    type: 'cityName',
    value: 'KHEMASULI, WEST BENGAL',
    masterId: 16118,
  },
  {
    type: 'cityName',
    value: 'KISHANPUR, BIHAR',
    masterId: 12800,
  },
  {
    type: 'cityName',
    value: 'KANSPUR GUGAULI, UTTAR PRADESH',
    masterId: 21030,
  },
  {
    type: 'cityName',
    value: 'KASTURI, UTTAR PRADESH',
    masterId: 16243,
  },
  {
    type: 'cityName',
    value: 'KASARA, MAHARASHTRA',
    masterId: 12577,
  },
  {
    type: 'cityName',
    value: 'KASTHA, BIHAR',
    masterId: 18820,
  },
  {
    type: 'cityName',
    value: 'KISTAMSETIPALLI, ANDHRA PRADESH',
    masterId: 12801,
  },
  {
    type: 'cityName',
    value: 'KASHTI, MAHARASHTRA',
    masterId: 12582,
  },
  {
    type: 'cityName',
    value: 'KUSHTAUR, WEST BENGAL',
    masterId: 13054,
  },
  {
    type: 'cityName',
    value: 'KASHIPURA, GUJARAT',
    masterId: 19091,
  },
  {
    type: 'cityName',
    value: 'KOSI KALAN, UTTAR PRADESH',
    masterId: 12894,
  },
  {
    type: 'cityName',
    value: 'KESAVARAM, ANDHRA PRADESH',
    masterId: 12660,
  },
  {
    type: 'cityName',
    value: 'KHERI SALWA, RAJASTHAN',
    masterId: 12746,
  },
  {
    type: 'cityName',
    value: 'KASARWADI, MAHARASHTRA',
    masterId: 17736,
  },
  {
    type: 'cityName',
    value: 'KALAMESHWAR, MAHARASHTRA',
    masterId: 12374,
  },
  {
    type: 'cityName',
    value: 'KOTSHILA, WEST BENGAL',
    masterId: 12927,
  },
  {
    type: 'cityName',
    value: 'KUSIARGAON, BIHAR',
    masterId: 18715,
  },
  {
    type: 'cityName',
    value: 'KUMTA, KARNATAKA',
    masterId: 13013,
  },
  {
    type: 'cityName',
    value: 'KUSHTALA, RAJASTHAN',
    masterId: 13053,
  },
  {
    type: 'cityName',
    value: 'KATHLAL, GUJARAT',
    masterId: 18545,
  },
  {
    type: 'cityName',
    value: 'KATOGHAN, UTTAR PRADESH',
    masterId: 21026,
  },
  {
    type: 'cityName',
    value: 'KAITHALKUCHI, ASSAM',
    masterId: 18969,
  },
  {
    type: 'cityName',
    value: 'KOTHACHERUVU, ANDHRA PRADESH',
    masterId: 12911,
  },
  {
    type: 'cityName',
    value: 'KANTADI, WEST BENGAL',
    masterId: 12511,
  },
  {
    type: 'cityName',
    value: 'KATAIYA DANDI, UTTAR PRADESH',
    masterId: 16751,
  },
  {
    type: 'cityName',
    value: 'KOT FATTA, PUNJAB',
    masterId: 17416,
  },
  {
    type: 'cityName',
    value: 'KEUTOGUDA, ORISSA',
    masterId: 12667,
  },
  {
    type: 'cityName',
    value: 'KOTH, GUJARAT',
    masterId: 18440,
  },
  {
    type: 'cityName',
    value: 'KAYASTHAGRAM, ASSAM',
    masterId: 18902,
  },
  {
    type: 'cityName',
    value: 'KOTLA GUJRAN, PUNJAB',
    masterId: 20940,
  },
  {
    type: 'cityName',
    value: 'KOTGAON, MAHARASHTRA',
    masterId: 17635,
  },
  {
    type: 'cityName',
    value: 'KATRAS, JHARKHAND',
    masterId: 12606,
  },
  {
    type: 'cityName',
    value: 'KHUTAHA, MADHYA PRADESH',
    masterId: 19125,
  },
  {
    type: 'cityName',
    value: 'KOTHARI ROAD, CHHATTISGARH',
    masterId: 12918,
  },
  {
    type: 'cityName',
    value: 'KATAHRI, UTTAR PRADESH',
    masterId: 17418,
  },
  {
    type: 'cityName',
    value: 'KATHOLA, UTTAR PRADESH',
    masterId: 16473,
  },
  {
    type: 'cityName',
    value: 'KATHUA, JAMMU AND KASHMIR',
    masterId: 12600,
  },
  {
    type: 'cityName',
    value: 'KANTI, BIHAR',
    masterId: 18822,
  },
  {
    type: 'cityName',
    value: 'KHALTIPUR, WEST BENGAL',
    masterId: 12696,
  },
  {
    type: 'cityName',
    value: 'KATHAJODI, ORISSA',
    masterId: 17471,
  },
  {
    type: 'cityName',
    value: 'KYATANEAKERI RD, KARNATAKA',
    masterId: 13071,
  },
  {
    type: 'cityName',
    value: 'KOTAKADRA, ANDHRA PRADESH',
    masterId: 12902,
  },
  {
    type: 'cityName',
    value: 'KATANGI KHURD, MADHYA PRADESH',
    masterId: 17826,
  },
  {
    type: 'cityName',
    value: 'BHOMWARA, MADHYA PRADESH',
    masterId: 10767,
  },
  {
    type: 'cityName',
    value: 'KOTLI KALAN, PUNJAB',
    masterId: 12923,
  },
  {
    type: 'cityName',
    value: 'KUMTHA KHURD, MAHARASHTRA',
    masterId: 13014,
  },
  {
    type: 'cityName',
    value: 'KANTAKOSH, BIHAR',
    masterId: 18731,
  },
  {
    type: 'cityName',
    value: 'KATKOLA, GUJARAT',
    masterId: 18450,
  },
  {
    type: 'cityName',
    value: 'KANTALIYA, WEST BENGAL',
    masterId: 17264,
  },
  {
    type: 'cityName',
    value: 'KUTTALAM, TAMIL NADU',
    masterId: 13063,
  },
  {
    type: 'cityName',
    value: 'KOTMA, MADHYA PRADESH',
    masterId: 12924,
  },
  {
    type: 'cityName',
    value: 'KATHANA, GUJARAT',
    masterId: 18451,
  },
  {
    type: 'cityName',
    value: 'KIRTYANAND NAGAR, BIHAR',
    masterId: 18723,
  },
  {
    type: 'cityName',
    value: 'SAWANRAWAN, CHHATTISGARH',
    masterId: 14996,
  },
  {
    type: 'cityName',
    value: 'KOTANA, RAJASTHAN',
    masterId: 16747,
  },
  {
    type: 'cityName',
    value: 'KATEPURNA, MAHARASHTRA',
    masterId: 17645,
  },
  {
    type: 'cityName',
    value: 'KOTHA PAKKI, RAJASTHAN',
    masterId: 17132,
  },
  {
    type: 'cityName',
    value: 'KATHAL PUKHURI, ASSAM',
    masterId: 18903,
  },
  {
    type: 'cityName',
    value: 'KUDRA, BIHAR',
    masterId: 12977,
  },
  {
    type: 'cityName',
    value: 'KOTHAR, RAJASTHAN',
    masterId: 17888,
  },
  {
    type: 'cityName',
    value: 'KOTRA, MADHYA PRADESH',
    masterId: 17131,
  },
  {
    type: 'cityName',
    value: 'KATOSAN, GUJARAT',
    masterId: 18449,
  },
  {
    type: 'cityName',
    value: 'KATAREAH, BIHAR',
    masterId: 12589,
  },
  {
    type: 'cityName',
    value: 'KUTURUKHAMAR PH, ORISSA',
    masterId: 17548,
  },
  {
    type: 'cityName',
    value: 'KOTMISUNAR, CHHATTISGARH',
    masterId: 12925,
  },
  {
    type: 'cityName',
    value: 'KHUTBAV, MAHARASHTRA',
    masterId: 12778,
  },
  {
    type: 'cityName',
    value: 'KUTTIPPURAM, KERALA',
    masterId: 13065,
  },
  {
    type: 'cityName',
    value: 'KOTHAVALASA, ANDHRA PRADESH',
    masterId: 12919,
  },
  {
    type: 'cityName',
    value: 'KOTDWARA, UTTARAKHAND',
    masterId: 12909,
  },
  {
    type: 'cityName',
    value: 'KATHUWAS, HARYANA',
    masterId: 17143,
  },
  {
    type: 'cityName',
    value: 'KATAKHAL, ASSAM',
    masterId: 12586,
  },
  {
    type: 'cityName',
    value: 'KOTTAYAM, KERALA',
    masterId: 12936,
  },
  {
    type: 'cityName',
    value: 'KOTTAIYUR, TAMIL NADU',
    masterId: 16956,
  },
  {
    type: 'cityName',
    value: 'KHUTWANSA, MADHYA PRADESH',
    masterId: 17822,
  },
  {
    type: 'cityName',
    value: 'KULIKARAI, TAMIL NADU',
    masterId: 16954,
  },
  {
    type: 'cityName',
    value: 'KULHARIA, BIHAR',
    masterId: 12992,
  },
  {
    type: 'cityName',
    value: 'KASBA, BIHAR',
    masterId: 16216,
  },
  {
    type: 'cityName',
    value: 'KARUKKUTTY, KERALA',
    masterId: 19119,
  },
  {
    type: 'cityName',
    value: 'KUCHAI, ODISHA',
    masterId: 20912,
  },
  {
    type: 'cityName',
    value: 'KOOCHAVARAM, TELANGANA ',
    masterId: 16812,
  },
  {
    type: 'cityName',
    value: 'KUDCHI, KARNATAKA',
    masterId: 12974,
  },
  {
    type: 'cityName',
    value: 'MOODALKATTE, KARNATAKA',
    masterId: 13631,
  },
  {
    type: 'cityName',
    value: 'KELBAIWADI, MAHARASHTRA',
    masterId: 12644,
  },
  {
    type: 'cityName',
    value: 'KUDNI, HARYANA',
    masterId: 17328,
  },
  {
    type: 'cityName',
    value: 'KURSELA, BIHAR',
    masterId: 13043,
  },
  {
    type: 'cityName',
    value: 'KAURHA, UTTAR PRADESH',
    masterId: 12613,
  },
  {
    type: 'cityName',
    value: 'KUSUGALI, KARNATAKA',
    masterId: 13057,
  },
  {
    type: 'cityName',
    value: 'KUMAR GHAT, TRIPURA',
    masterId: 16783,
  },
  {
    type: 'cityName',
    value: 'GHUDAWAN, MADHYA PRADESH',
    masterId: 11713,
  },
  {
    type: 'cityName',
    value: 'KUHI, MAHARASHTRA',
    masterId: 17634,
  },
  {
    type: 'cityName',
    value: 'KULALI, KARNATAKA',
    masterId: 12986,
  },
  {
    type: 'cityName',
    value: 'KORUKONDA, ANDHRA PRADESH',
    masterId: 12890,
  },
  {
    type: 'cityName',
    value: 'KUKA, PUNJAB',
    masterId: 17130,
  },
  {
    type: 'cityName',
    value: 'KALLAYI, KERALA',
    masterId: 17927,
  },
  {
    type: 'cityName',
    value: 'KULHA-HALT, UTTAR PRADESH',
    masterId: 16451,
  },
  {
    type: 'cityName',
    value: 'KURAM, MAHARASHTRA',
    masterId: 17038,
  },
  {
    type: 'cityName',
    value: 'KUMARBAGH, BIHAR',
    masterId: 18718,
  },
  {
    type: 'cityName',
    value: 'KUMBALAM, KERALA',
    masterId: 17921,
  },
  {
    type: 'cityName',
    value: 'KARNAL, HARYANA',
    masterId: 12565,
  },
  {
    type: 'cityName',
    value: 'KUND, HARYANA',
    masterId: 18293,
  },
  {
    type: 'cityName',
    value: 'KUP, PUNJAB',
    masterId: 13030,
  },
  {
    type: 'cityName',
    value: 'KHURDPUR, PUNJAB',
    masterId: 16042,
  },
  {
    type: 'cityName',
    value: 'KURETHA, BIHAR',
    masterId: 17818,
  },
  {
    type: 'cityName',
    value: 'KHURDHA, ORISSA',
    masterId: 12771,
  },
  {
    type: 'cityName',
    value: 'KHAJURAHO, MADHYA PRADESH',
    masterId: 12685,
  },
  {
    type: 'cityName',
    value: 'KHUKHRANA, HARYANA',
    masterId: 17330,
  },
  {
    type: 'cityName',
    value: 'KORARI, UTTAR PRADESH',
    masterId: 16748,
  },
  {
    type: 'cityName',
    value: 'RAMSINGHPURA, RAJASTHAN',
    masterId: 14640,
  },
  {
    type: 'cityName',
    value: 'KHUMTAI, ASSAM',
    masterId: 12769,
  },
  {
    type: 'cityName',
    value: 'GAINADA, ORISSA',
    masterId: 11600,
  },
  {
    type: 'cityName',
    value: 'KANWAR, UTTAR PRADESH',
    masterId: 21025,
  },
  {
    type: 'cityName',
    value: 'KHIRSADOH, MADHYA PRADESH',
    masterId: 12757,
  },
  {
    type: 'cityName',
    value: 'KAVAS, RAJASTHAN',
    masterId: 18544,
  },
  {
    type: 'cityName',
    value: 'KAPARPURA, BIHAR',
    masterId: 18821,
  },
  {
    type: 'cityName',
    value: 'KHURMABAD, BIHAR',
    masterId: 18724,
  },
  {
    type: 'cityName',
    value: 'KADAVAKUDURU, ANDHRA PRADESH',
    masterId: 12325,
  },
  {
    type: 'cityName',
    value: 'KAVALANDE, KARNATAKA',
    masterId: 18015,
  },
  {
    type: 'cityName',
    value: 'KARANPUR, UTTAR PRADESH',
    masterId: 12538,
  },
  {
    type: 'cityName',
    value: 'KOLWA, RAJASTHAN',
    masterId: 12856,
  },
  {
    type: 'cityName',
    value: 'KHAMBHAT, GUJARAT',
    masterId: 18447,
  },
  {
    type: 'cityName',
    value: 'KESHAVGANJ, RAJASTHAN',
    masterId: 17261,
  },
  {
    type: 'cityName',
    value: 'KAVATHE MAHANKL, MAHARASHTRA',
    masterId: 12620,
  },
  {
    type: 'cityName',
    value: 'KIZH VELUR, TAMIL NADU',
    masterId: 16961,
  },
  {
    type: 'cityName',
    value: 'KARUVALLI, TAMIL NADU',
    masterId: 16967,
  },
  {
    type: 'cityName',
    value: 'KARAKAVALASA, ANDHRA PRADESH',
    masterId: 12529,
  },
  {
    type: 'cityName',
    value: 'KAVUTARAM, ANDHRA PRADESH',
    masterId: 12624,
  },
  {
    type: 'cityName',
    value: 'KAVANUR, TAMIL NADU',
    masterId: 17044,
  },
  {
    type: 'cityName',
    value: 'KAPADVANJ, GUJARAT',
    masterId: 12516,
  },
  {
    type: 'cityName',
    value: 'KAVARAIPPETTAI, TAMIL NADU',
    masterId: 19161,
  },
  {
    type: 'cityName',
    value: 'KOSHIARA, JHARKHAND',
    masterId: 18159,
  },
  {
    type: 'cityName',
    value: 'KOVVUR, ANDHRA PRADESH',
    masterId: 12943,
  },
  {
    type: 'cityName',
    value: 'KALLUR, KARNATAKA',
    masterId: 12419,
  },
  {
    type: 'cityName',
    value: 'KARUVATTA, KERALA',
    masterId: 17924,
  },
  {
    type: 'cityName',
    value: 'KADAKKAVOOR, KERALA',
    masterId: 12313,
  },
  {
    type: 'cityName',
    value: 'KUSUMBHI, UTTAR PRADESH',
    masterId: 16448,
  },
  {
    type: 'cityName',
    value: 'KAVALI, ANDHRA PRADESH',
    masterId: 12616,
  },
  {
    type: 'cityName',
    value: 'KHERVADI, MAHARASHTRA',
    masterId: 18443,
  },
  {
    type: 'cityName',
    value: 'KATWA, WEST BENGAL',
    masterId: 12611,
  },
  {
    type: 'cityName',
    value: 'KAWAR, JHARKHAND',
    masterId: 19105,
  },
  {
    type: 'cityName',
    value: 'KUNDWA CHAINPUR, BIHAR',
    masterId: 20768,
  },
  {
    type: 'cityName',
    value: 'KARWANDIYA, BIHAR',
    masterId: 18728,
  },
  {
    type: 'cityName',
    value: 'KAKDWIP, WEST BENGAL',
    masterId: 21258,
  },
  {
    type: 'cityName',
    value: 'KHURIYAL, BIHAR',
    masterId: 12773,
  },
  {
    type: 'cityName',
    value: 'KAWARGAON, CHHATTISGARH',
    masterId: 12626,
  },
  {
    type: 'cityName',
    value: 'KACHHWA, UTTAR PRADESH',
    masterId: 18302,
  },
  {
    type: 'cityName',
    value: 'KIVARLI, RAJASTHAN',
    masterId: 17133,
  },
  {
    type: 'cityName',
    value: 'KHOJEWALA, PUNJAB',
    masterId: 17332,
  },
  {
    type: 'cityName',
    value: 'KAMPUR, ASSAM',
    masterId: 12455,
  },
  {
    type: 'cityName',
    value: 'KUMBHAWAS, HARYANA',
    masterId: 18317,
  },
  {
    type: 'cityName',
    value: 'KACHEWANI, MAHARASHTRA',
    masterId: 12307,
  },
  {
    type: 'cityName',
    value: 'BAHADURPUR, BIHAR',
    masterId: 10386,
  },
  {
    type: 'cityName',
    value: 'KOILWAR, BIHAR',
    masterId: 12829,
  },
  {
    type: 'cityName',
    value: 'KURDUWADI, MAHARASHTRA',
    masterId: 13037,
  },
  {
    type: 'cityName',
    value: 'KUSWA, UTTAR PRADESH',
    masterId: 18220,
  },
  {
    type: 'cityName',
    value: 'KUNWARIYA, RAJASTHAN',
    masterId: 17128,
  },
  {
    type: 'cityName',
    value: 'KANJAI, MADHYA PRADESH',
    masterId: 17829,
  },
  {
    type: 'cityName',
    value: 'KALIAN CHAK, JHARKHAND',
    masterId: 18225,
  },
  {
    type: 'cityName',
    value: 'KAMPIL, UTTAR PRADESH',
    masterId: 16752,
  },
  {
    type: 'cityName',
    value: 'DHADHESRI, RAJASTHAN',
    masterId: 11328,
  },
  {
    type: 'cityName',
    value: 'KAPURTHALA, PUNJAB',
    masterId: 12523,
  },
  {
    type: 'cityName',
    value: 'KURUMURTHI, ANDHRA PRADESH',
    masterId: 13050,
  },
  {
    type: 'cityName',
    value: 'KARIMGANJ, ASSAM',
    masterId: 18905,
  },
  {
    type: 'cityName',
    value: 'KHARKHAUDA, UTTAR PRADESH',
    masterId: 16462,
  },
  {
    type: 'cityName',
    value: 'KAMARBANDHA ALI, ASSAM',
    masterId: 12442,
  },
  {
    type: 'cityName',
    value: 'KITHAM, UTTAR PRADESH',
    masterId: 16456,
  },
  {
    type: 'cityName',
    value: 'KUDIKADU, TAMIL NADU',
    masterId: 17040,
  },
  {
    type: 'cityName',
    value: 'KANIYAPURAM, KERALA',
    masterId: 12491,
  },
  {
    type: 'cityName',
    value: 'KETTI, TAMIL NADU',
    masterId: 12666,
  },
  {
    type: 'cityName',
    value: 'KATA, MAHARASHTRA',
    masterId: 17646,
  },
  {
    type: 'cityName',
    value: 'KARELI, MADHYA PRADESH',
    masterId: 12543,
  },
  {
    type: 'cityName',
    value: 'KALYAR, WEST BENGAL',
    masterId: 21112,
  },
  {
    type: 'cityName',
    value: 'KHAIRATIYA BH R, UTTAR PRADESH',
    masterId: 18853,
  },
  {
    type: 'cityName',
    value: 'KHURAI, MADHYA PRADESH',
    masterId: 12770,
  },
  {
    type: 'cityName',
    value: 'KAJRAT NAWADIH, JHARKHAND',
    masterId: 12357,
  },
  {
    type: 'cityName',
    value: 'KIDIYANAGAR, GUJARAT',
    masterId: 18441,
  },
  {
    type: 'cityName',
    value: 'KAYAMKULAM, KERALA',
    masterId: 12628,
  },
  {
    type: 'cityName',
    value: 'KADIAM, ANDHRA PRADESH',
    masterId: 12331,
  },
  {
    type: 'cityName',
    value: 'KALYANKOT, RAJASTHAN',
    masterId: 17149,
  },
  {
    type: 'cityName',
    value: 'KHANDIKAR, ASSAM',
    masterId: 18900,
  },
  {
    type: 'cityName',
    value: 'KOTTAPALLI, ANDHRA PRADESH',
    masterId: 12934,
  },
  {
    type: 'cityName',
    value: 'KALYANPUR, WEST BENGAL',
    masterId: 21203,
  },
  {
    type: 'cityName',
    value: 'KAMAKHYA, ASSAM',
    masterId: 12846,
  },
  {
    type: 'cityName',
    value: 'KARUPPATTY, TAMIL NADU',
    masterId: 16969,
  },
  {
    type: 'cityName',
    value: 'KUSUMKASA, CHHATTISGARH',
    masterId: 20790,
  },
  {
    type: 'cityName',
    value: 'KAILAHAT, UTTAR PRADESH',
    masterId: 12349,
  },
  {
    type: 'cityName',
    value: 'KOVILVENNI, TAMIL NADU',
    masterId: 16955,
  },
  {
    type: 'cityName',
    value: 'KARCHHUE, BIHAR',
    masterId: 18850,
  },
  {
    type: 'cityName',
    value: 'KARHIYA BHADELI, MADHYA PRADESH',
    masterId: 12547,
  },
  {
    type: 'cityName',
    value: 'KARIHA, PUNJAB',
    masterId: 17340,
  },
  {
    type: 'cityName',
    value: 'KIZHAPULIYUR, TAMIL NADU',
    masterId: 16959,
  },
  {
    type: 'cityName',
    value: 'KHADA, UTTAR PRADESH',
    masterId: 12670,
  },
  {
    type: 'cityName',
    value: 'KURUMBUR, TAMIL NADU',
    masterId: 13049,
  },
  {
    type: 'cityName',
    value: 'KULUKKALLUR, KERALA',
    masterId: 17922,
  },
  {
    type: 'cityName',
    value: 'KANHANGAD, KERALA',
    masterId: 12487,
  },
  {
    type: 'cityName',
    value: 'KILA ZAFARGARH, HARYANA',
    masterId: 18368,
  },
  {
    type: 'cityName',
    value: 'KHANDRAWALI, UTTAR PRADESH',
    masterId: 16465,
  },
  {
    type: 'cityName',
    value: 'KAZIPET, ANDHRA PRADESH',
    masterId: 12634,
  },
  {
    type: 'cityName',
    value: 'KAZIPET E CABIN, TELANGANA',
    masterId: 16813,
  },
  {
    type: 'cityName',
    value: 'KAZIPARA, WEST BENGAL',
    masterId: 16121,
  },
  {
    type: 'cityName',
    value: 'KHIMEL, RAJASTHAN',
    masterId: 17259,
  },
  {
    type: 'cityName',
    value: 'KUAKHERA, UTTAR PRADESH',
    masterId: 16452,
  },
  {
    type: 'cityName',
    value: 'KUZHITHURAI, TAMIL NADU',
    masterId: 13070,
  },
  {
    type: 'cityName',
    value: 'MADHUPUR, JHARKHAND',
    masterId: 13213,
  },
  {
    type: 'cityName',
    value: 'KATAR SINGHWALA, PUNJAB',
    masterId: 17338,
  },
  {
    type: 'cityName',
    value: 'KHUDDA KORALA, PUNJAB',
    masterId: 17331,
  },
  {
    type: 'cityName',
    value: 'LAKHPAT, GUJARAT',
    masterId: 18436,
  },
  {
    type: 'cityName',
    value: 'LACHHIPUR, RAJASTHAN',
    masterId: 17467,
  },
  {
    type: 'cityName',
    value: 'LOHARDAGA, JHARKHAND',
    masterId: 18149,
  },
  {
    type: 'cityName',
    value: 'LAKHOLI, CHHATTISGARH',
    masterId: 13089,
  },
  {
    type: 'cityName',
    value: 'LAKHO, BIHAR',
    masterId: 18817,
  },
  {
    type: 'cityName',
    value: 'LUSHALA, GUJARAT',
    masterId: 18431,
  },
  {
    type: 'cityName',
    value: 'LOTANA, GUJARAT',
    masterId: 17122,
  },
  {
    type: 'cityName',
    value: 'LOHAPUR, WEST BENGAL',
    masterId: 16115,
  },
  {
    type: 'cityName',
    value: 'LALITPUR, UTTAR PRADESH',
    masterId: 13103,
  },
  {
    type: 'cityName',
    value: 'LADNUN, RAJASTHAN',
    masterId: 13075,
  },
  {
    type: 'cityName',
    value: 'LAUL, MAHARASHTRA',
    masterId: 13128,
  },
  {
    type: 'cityName',
    value: 'BISARE, BIHAR',
    masterId: 10850,
  },
  {
    type: 'cityName',
    value: 'LAIN BAZAR, UTTAR PRADESH',
    masterId: 18713,
  },
  {
    type: 'cityName',
    value: 'LAMBHUA, UTTAR PRADESH',
    masterId: 13108,
  },
  {
    type: 'cityName',
    value: 'DHANORA, MAHARASHTRA',
    masterId: 11352,
  },
  {
    type: 'cityName',
    value: 'DILKUSHA CABIN, UTTAR PRADESH',
    masterId: 16570,
  },
  {
    type: 'cityName',
    value: 'LILABARI, ASSAM',
    masterId: 18151,
  },
  {
    type: 'cityName',
    value: 'LABAN, RAJASTHAN',
    masterId: 13072,
  },
  {
    type: 'cityName',
    value: 'LATABOR, CHHATTISGARH',
    masterId: 20789,
  },
  {
    type: 'cityName',
    value: 'LEBUTALA, WEST BENGAL',
    masterId: 21157,
  },
  {
    type: 'cityName',
    value: 'LAIBURWA H, UTTAR PRADESH',
    masterId: 16447,
  },
  {
    type: 'cityName',
    value: 'LALBAG BH, BIHAR',
    masterId: 20751,
  },
  {
    type: 'cityName',
    value: 'LUCKNOW, UTTAR PRADESH',
    masterId: 13170,
  },
  {
    type: 'cityName',
    value: 'SAIKULI, WEST BENGAL',
    masterId: 14816,
  },
  {
    type: 'cityName',
    value: 'LINCH, GUJARAT',
    masterId: 18435,
  },
  {
    type: 'cityName',
    value: 'LOKUR, TAMIL NADU',
    masterId: 18003,
  },
  {
    type: 'cityName',
    value: 'LANGCHOLIET, ASSAM',
    masterId: 18891,
  },
  {
    type: 'cityName',
    value: 'LONDA, KARNATAKA',
    masterId: 13162,
  },
  {
    type: 'cityName',
    value: 'LIDHORA KHURD, MADHYA PRADESH',
    masterId: 13137,
  },
  {
    type: 'cityName',
    value: 'LADHUKA, PUNJAB',
    masterId: 17326,
  },
  {
    type: 'cityName',
    value: 'LEDARMER, RAJASTHAN',
    masterId: 20967,
  },
  {
    type: 'cityName',
    value: 'LODIPUR BISHNPR, UTTAR PRADESH',
    masterId: 13150,
  },
  {
    type: 'cityName',
    value: 'LANDHAURA, UTTARAKHAND',
    masterId: 16443,
  },
  {
    type: 'cityName',
    value: 'LADHOWAL, PUNJAB',
    masterId: 13074,
  },
  {
    type: 'cityName',
    value: 'JAGANATHPUR, ORISSA',
    masterId: 12108,
  },
  {
    type: 'cityName',
    value: 'LAKKIDI, KERALA',
    masterId: 17918,
  },
  {
    type: 'cityName',
    value: 'SAMUKJAN, ASSAM',
    masterId: 14883,
  },
  {
    type: 'cityName',
    value: 'LAKHAKHERA, MADHYA PRADESH',
    masterId: 17817,
  },
  {
    type: 'cityName',
    value: 'LEHRA, UTTAR PRADESH',
    masterId: 17413,
  },
  {
    type: 'cityName',
    value: 'LALAGUDA GATE, ANDHRA PRADESH',
    masterId: 13097,
  },
  {
    type: 'cityName',
    value: 'LALGOPALGANJ, UTTAR PRADESH',
    masterId: 13101,
  },
  {
    type: 'cityName',
    value: 'LINGIRI, KARNATAKA',
    masterId: 18004,
  },
  {
    type: 'cityName',
    value: 'LANGTING, ASSAM',
    masterId: 13113,
  },
  {
    type: 'cityName',
    value: 'LINGARAJ TMP RD, ORISSA',
    masterId: 17547,
  },
  {
    type: 'cityName',
    value: 'LAHING, ASSAM',
    masterId: 18894,
  },
  {
    type: 'cityName',
    value: 'LEHRAGAGA, PUNJAB',
    masterId: 13134,
  },
  {
    type: 'cityName',
    value: 'LAHABON, JHARKHAND',
    masterId: 13077,
  },
  {
    type: 'cityName',
    value: 'LOTHAL BHURKHL, GUJARAT',
    masterId: 18433,
  },
  {
    type: 'cityName',
    value: 'LOHAGAD, MAHARASHTRA',
    masterId: 17630,
  },
  {
    type: 'cityName',
    value: 'LAHOWAL, ASSAM',
    masterId: 18893,
  },
  {
    type: 'cityName',
    value: 'LAHLI, HARYANA',
    masterId: 13078,
  },
  {
    type: 'cityName',
    value: 'LEHRA MOHABBAT, PUNJAB',
    masterId: 17325,
  },
  {
    type: 'cityName',
    value: 'LACHYAN, MAHARASHTRA',
    masterId: 13073,
  },
  {
    type: 'cityName',
    value: 'LAKSHMANPUR, UTTAR PRADESH',
    masterId: 16445,
  },
  {
    type: 'cityName',
    value: 'LOHARU, HARYANA',
    masterId: 13153,
  },
  {
    type: 'cityName',
    value: 'LOHARWARA, RAJASTHAN',
    masterId: 17123,
  },
  {
    type: 'cityName',
    value: 'LAKSHMIGANJ, UTTAR PRADESH',
    masterId: 16444,
  },
  {
    type: 'cityName',
    value: 'LINGAMGUNTLA, ANDHRA PRADESH',
    masterId: 13145,
  },
  {
    type: 'cityName',
    value: 'LACHMIPUR, UTTAR PRADESH',
    masterId: 17466,
  },
  {
    type: 'cityName',
    value: 'LANJIGARH, ORISSA',
    masterId: 13115,
  },
  {
    type: 'cityName',
    value: 'LANKA, ASSAM',
    masterId: 13116,
  },
  {
    type: 'cityName',
    value: 'LING KOTTURU, BIHAR',
    masterId: 18710,
  },
  {
    type: 'cityName',
    value: 'LAKHABAWAL, GUJARAT',
    masterId: 13079,
  },
  {
    type: 'cityName',
    value: 'DETHAN, GUJARAT',
    masterId: 11302,
  },
  {
    type: 'cityName',
    value: 'CHINTAPARRU, ANDHRA PRADESH',
    masterId: 11115,
  },
  {
    type: 'cityName',
    value: 'LAKHERI, RAJASTHAN',
    masterId: 13082,
  },
  {
    type: 'cityName',
    value: 'LAMSAKHAN, ASSAM',
    masterId: 13112,
  },
  {
    type: 'cityName',
    value: 'LINK JN CABIN, UTTAR PRADESH',
    masterId: 16442,
  },
  {
    type: 'cityName',
    value: 'LAKKADKOT, MAHARASHTRA',
    masterId: 13091,
  },
  {
    type: 'cityName',
    value: 'PUNJISIL, ORISSA',
    masterId: 14503,
  },
  {
    type: 'cityName',
    value: 'BALLIA, BIHAR',
    masterId: 10435,
  },
  {
    type: 'cityName',
    value: 'LAKHNA, CHHATTISGARH',
    masterId: 13087,
  },
  {
    type: 'cityName',
    value: 'LAKHPAT NAGAR, UTTAR PRADESH',
    masterId: 16446,
  },
  {
    type: 'cityName',
    value: 'LAKSHMIKANTPUR, WEST BENGAL',
    masterId: 21248,
  },
  {
    type: 'cityName',
    value: 'LAUKAHA BAZAR, BIHAR',
    masterId: 18711,
  },
  {
    type: 'cityName',
    value: 'LAKHISARAI, BIHAR',
    masterId: 13086,
  },
  {
    type: 'cityName',
    value: 'LUNKARANSAR, RAJASTHAN',
    masterId: 13177,
  },
  {
    type: 'cityName',
    value: 'L NARAYANAPURAM, ANDHRA PRADESH',
    masterId: 20730,
  },
  {
    type: 'cityName',
    value: 'HULKOTI, KARNATAKA',
    masterId: 12040,
  },
  {
    type: 'cityName',
    value: 'LAL KUAN, UTTARAKHAND',
    masterId: 13096,
  },
  {
    type: 'cityName',
    value: 'LAKHEWALI, PUNJAB',
    masterId: 13083,
  },
  {
    type: 'cityName',
    value: 'LAKHAMAPUR, KARNATAKA',
    masterId: 13080,
  },
  {
    type: 'cityName',
    value: 'LAKADIYA, GUJARAT',
    masterId: 18437,
  },
  {
    type: 'cityName',
    value: 'LALBAZAR, ASSAM',
    masterId: 16831,
  },
  {
    type: 'cityName',
    value: 'LALAWADI, MADHYA PRADESH',
    masterId: 17816,
  },
  {
    type: 'cityName',
    value: 'LELIGUMA, ORISSA',
    masterId: 13135,
  },
  {
    type: 'cityName',
    value: 'LILUAH, WEST BENGAL',
    masterId: 16210,
  },
  {
    type: 'cityName',
    value: 'LALGUDI, TAMIL NADU',
    masterId: 13102,
  },
  {
    type: 'cityName',
    value: 'LALGANJ, UTTAR PRADESH',
    masterId: 13099,
  },
  {
    type: 'cityName',
    value: 'LALIT LAKSHMIPR, BIHAR',
    masterId: 18712,
  },
  {
    type: 'cityName',
    value: 'MAWAR, UTTAR PRADESH',
    masterId: 13535,
  },
  {
    type: 'cityName',
    value: 'LALRU, PUNJAB',
    masterId: 17414,
  },
  {
    type: 'cityName',
    value: 'LIMBDI, GUJARAT',
    masterId: 13141,
  },
  {
    type: 'cityName',
    value: 'LAMBIYA, RAJASTHAN',
    masterId: 17126,
  },
  {
    type: 'cityName',
    value: 'HIRANA, GUJARAT',
    masterId: 11998,
  },
  {
    type: 'cityName',
    value: 'LINGANENIDODDI, ANDHRA PRADESH',
    masterId: 13147,
  },
  {
    type: 'cityName',
    value: 'LUMDING, ASSAM',
    masterId: 13173,
  },
  {
    type: 'cityName',
    value: 'LIMKHEDA, GUJARAT',
    masterId: 13144,
  },
  {
    type: 'cityName',
    value: 'LAILAKH MAMALKHA, BIHAR ',
    masterId: 18714,
  },
  {
    type: 'cityName',
    value: 'JAGATPUR, UTTAR PRADESH',
    masterId: 12114,
  },
  {
    type: 'cityName',
    value: 'LILIYA MOTA, GUJARAT',
    masterId: 13139,
  },
  {
    type: 'cityName',
    value: 'ARALADINNI, KARNATAKA',
    masterId: 10233,
  },
  {
    type: 'cityName',
    value: 'LAIMEKURI, ASSAM',
    masterId: 18892,
  },
  {
    type: 'cityName',
    value: 'LAMANA, RAJASTHAN',
    masterId: 13107,
  },
  {
    type: 'cityName',
    value: 'LOHIAN KHAS, PUNJAB',
    masterId: 13155,
  },
  {
    type: 'cityName',
    value: 'LINK CABIN, ORISSA ',
    masterId: 17461,
  },
  {
    type: 'cityName',
    value: 'LONAVALA, MAHARASHTRA',
    masterId: 13161,
  },
  {
    type: 'cityName',
    value: 'LONAND, MAHARASHTRA',
    masterId: 13160,
  },
  {
    type: 'cityName',
    value: 'LOHNA, BIHAR',
    masterId: 18709,
  },
  {
    type: 'cityName',
    value: 'LANGARPETH, MAHARASHTRA',
    masterId: 17631,
  },
  {
    type: 'cityName',
    value: 'LUNI, MADHYA PRADESH',
    masterId: 13175,
  },
  {
    type: 'cityName',
    value: 'LINGTI, MAHARASHTRA',
    masterId: 13149,
  },
  {
    type: 'cityName',
    value: 'LAKHANWARA, MADHYA PRADESH',
    masterId: 20893,
  },
  {
    type: 'cityName',
    value: 'LKO ALAMBAGH W CABIN, UTTAR PRADESH',
    masterId: 16441,
  },
  {
    type: 'cityName',
    value: 'LOLIYA, GUJARAT',
    masterId: 18434,
  },
  {
    type: 'cityName',
    value: 'PALI, MADHYA PRADESH',
    masterId: 14156,
  },
  {
    type: 'cityName',
    value: 'LOHGARA, UTTAR PRADESH',
    masterId: 16440,
  },
  {
    type: 'cityName',
    value: 'LOTTEGOLLAHALLI, KARNATAKA',
    masterId: 18002,
  },
  {
    type: 'cityName',
    value: 'LOHA, RAJASTHAN',
    masterId: 19148,
  },
  {
    type: 'cityName',
    value: 'LOKNATH, WEST BENGAL',
    masterId: 21067,
  },
  {
    type: 'cityName',
    value: 'LOLIEM, GOA',
    masterId: 18569,
  },
  {
    type: 'cityName',
    value: 'LODHMA, JHARKHAND',
    masterId: 18150,
  },
  {
    type: 'cityName',
    value: 'LONI, MAHARASHTRA',
    masterId: 13164,
  },
  {
    type: 'cityName',
    value: 'LOHTA, UTTAR PRADESH',
    masterId: 16439,
  },
  {
    type: 'cityName',
    value: 'OOTY, TAMIL NADU',
    masterId: 14085,
  },
  {
    type: 'cityName',
    value: 'LALAPET, TAMIL NADU',
    masterId: 16832,
  },
  {
    type: 'cityName',
    value: 'LAPANGA, ORISSA',
    masterId: 17463,
  },
  {
    type: 'cityName',
    value: 'LOTAPAHAR, JHARKHAND',
    masterId: 13168,
  },
  {
    type: 'cityName',
    value: 'LINGAMPALLI, ANDHRA PRADESH',
    masterId: 13146,
  },
  {
    type: 'cityName',
    value: 'PIPAR NAVI, GUJARAT',
    masterId: 14411,
  },
  {
    type: 'cityName',
    value: 'LINGAMPET JAGITYAL, TELANGANA',
    masterId: 20995,
  },
  {
    type: 'cityName',
    value: 'NIZ-JARABARI, ASSAM',
    masterId: 14041,
  },
  {
    type: 'cityName',
    value: 'LILAPUR, GUJARAT',
    masterId: 13138,
  },
  {
    type: 'cityName',
    value: 'LONGPATIA, ASSAM',
    masterId: 18967,
  },
  {
    type: 'cityName',
    value: 'LOHARPURWA, UTTAR PRADESH',
    masterId: 16743,
  },
  {
    type: 'cityName',
    value: 'LADPURA, RAJASTHAN',
    masterId: 13076,
  },
  {
    type: 'cityName',
    value: 'LARABAD, JHARKHAND',
    masterId: 20855,
  },
  {
    type: 'cityName',
    value: 'LAR, UTTAR PRADESH',
    masterId: 13120,
  },
  {
    type: 'cityName',
    value: 'LIHURI, ORISSA',
    masterId: 19023,
  },
  {
    type: 'cityName',
    value: 'LAKSAR, UTTARAKHAND',
    masterId: 13093,
  },
  {
    type: 'cityName',
    value: 'UMRI, RAJASTHAN',
    masterId: 15678,
  },
  {
    type: 'cityName',
    value: 'LASALGAON, MAHARASHTRA',
    masterId: 13121,
  },
  {
    type: 'cityName',
    value: 'LUSADIYA, GUJARAT',
    masterId: 18432,
  },
  {
    type: 'cityName',
    value: 'LASERI, RAJASTHAN',
    masterId: 17125,
  },
  {
    type: 'cityName',
    value: 'LAWA SARDARGARH, RAJASTHAN',
    masterId: 17124,
  },
  {
    type: 'cityName',
    value: 'LAVAN SATYAGRHA PH, WEST BENGAL',
    masterId: 21094,
  },
  {
    type: 'cityName',
    value: 'LASUR, MAHARASHTRA',
    masterId: 13122,
  },
  {
    type: 'cityName',
    value: 'LOISINGHA, ORISSA',
    masterId: 13156,
  },
  {
    type: 'cityName',
    value: 'LAHAVIT, MAHARASHTRA',
    masterId: 17632,
  },
  {
    type: 'cityName',
    value: 'LATHIDAD, GUJARAT',
    masterId: 13126,
  },
  {
    type: 'cityName',
    value: 'LATAGURI JN, WEST BENGAL',
    masterId: 21104,
  },
  {
    type: 'cityName',
    value: 'LATEHAR, JHARKHAND',
    masterId: 13123,
  },
  {
    type: 'cityName',
    value: 'LATTERI, TAMIL NADU',
    masterId: 16951,
  },
  {
    type: 'cityName',
    value: 'LATHIKATA, ORISSA',
    masterId: 17462,
  },
  {
    type: 'cityName',
    value: 'LATEMDA, WEST BENGAL',
    masterId: 18153,
  },
  {
    type: 'cityName',
    value: 'LAKHTAR, GUJARAT',
    masterId: 13090,
  },
  {
    type: 'cityName',
    value: 'LATUR, MAHARASHTRA',
    masterId: 13127,
  },
  {
    type: 'cityName',
    value: 'LOTARVA, GUJARAT',
    masterId: 20793,
  },
  {
    type: 'cityName',
    value: 'LUNI, RAJASTHAN',
    masterId: 13176,
  },
  {
    type: 'cityName',
    value: 'LUSA, UTTAR PRADESH',
    masterId: 13181,
  },
  {
    type: 'cityName',
    value: 'LOK VIDYAPITH NAGAR, UTTAR PRADESH',
    masterId: 16438,
  },
  {
    type: 'cityName',
    value: 'LORWADA, GUJARAT',
    masterId: 18542,
  },
  {
    type: 'cityName',
    value: 'ALNAVAR, KARNATAKA',
    masterId: 10115,
  },
  {
    type: 'cityName',
    value: 'LUKWASA, MADHYA PRADESH',
    masterId: 13172,
  },
  {
    type: 'cityName',
    value: 'LAKWA, ASSAM',
    masterId: 13095,
  },
  {
    type: 'cityName',
    value: 'LAKSHANNATH, ORISSA',
    masterId: 17465,
  },
  {
    type: 'cityName',
    value: 'LUNSERIYA, GUJARAT',
    masterId: 13179,
  },
  {
    type: 'cityName',
    value: 'LAYABAD, JHARKHAND',
    masterId: 18152,
  },
  {
    type: 'cityName',
    value: 'MADHA, MAHARASHTRA',
    masterId: 13205,
  },
  {
    type: 'cityName',
    value: 'MAVAL, RAJASTHAN',
    masterId: 17112,
  },
  {
    type: 'cityName',
    value: 'MANDI BAMORA, MADHYA PRADESH',
    masterId: 13397,
  },
  {
    type: 'cityName',
    value: 'MABBI, BIHAR',
    masterId: 18707,
  },
  {
    type: 'cityName',
    value: 'MAHBUBABAD, ANDHRA PRADESH',
    masterId: 13246,
  },
  {
    type: 'cityName',
    value: 'MABAN, MADHYA PRADESH',
    masterId: 17815,
  },
  {
    type: 'cityName',
    value: 'MANGULI P H, ORISSA',
    masterId: 17458,
  },
  {
    type: 'cityName',
    value: 'MADDUR, KARNATAKA',
    masterId: 13204,
  },
  {
    type: 'cityName',
    value: 'MAONDA, RAJASTHAN',
    masterId: 17116,
  },
  {
    type: 'cityName',
    value: 'MADHURE, MAHARASHTRA',
    masterId: 18001,
  },
  {
    type: 'cityName',
    value: 'MAEL, JHARKHAND',
    masterId: 18148,
  },
  {
    type: 'cityName',
    value: 'MANUR, TAMIL NADU',
    masterId: 20979,
  },
  {
    type: 'cityName',
    value: 'MANGALAGIRI, ANDHRA PRADESH',
    masterId: 13411,
  },
  {
    type: 'cityName',
    value: 'MANIKGARH, MAHARASHTRA',
    masterId: 13431,
  },
  {
    type: 'cityName',
    value: 'MADHOGANJ, UTTAR PRADESH',
    masterId: 16742,
  },
  {
    type: 'cityName',
    value: 'MAHE, PUDUCHERRY',
    masterId: 13249,
  },
  {
    type: 'cityName',
    value: 'MAHOLI, UTTAR PRADESH',
    masterId: 16428,
  },
  {
    type: 'cityName',
    value: 'MEHSI, BIHAR',
    masterId: 13561,
  },
  {
    type: 'cityName',
    value: 'MAJHERGRAM, KARNATAKA',
    masterId: 20867,
  },
  {
    type: 'cityName',
    value: 'MALLIKPUR, MADHYA PRADESH',
    masterId: 20892,
  },
  {
    type: 'cityName',
    value: 'MOKHAMPURA, RAJASTHAN',
    masterId: 17108,
  },
  {
    type: 'cityName',
    value: 'MARARIKULAM, KERALA',
    masterId: 13481,
  },
  {
    type: 'cityName',
    value: 'MANIKPURA, UTTAR PRADESH',
    masterId: 21041,
  },
  {
    type: 'cityName',
    value: 'HIRANCHIPA, MADHYA PRADESH',
    masterId: 12000,
  },
  {
    type: 'cityName',
    value: 'MALA, UTTAR PRADESH',
    masterId: 17917,
  },
  {
    type: 'cityName',
    value: 'MALIA, GUJARAT',
    masterId: 13318,
  },
  {
    type: 'cityName',
    value: 'MALKAPUR, MADHYA PRADESH',
    masterId: 13324,
  },
  {
    type: 'cityName',
    value: 'DIBBANADODDI, ANDHRA PRADESH',
    masterId: 11420,
  },
  {
    type: 'cityName',
    value: 'MALLUR, TAMIL NADU',
    masterId: 16943,
  },
  {
    type: 'cityName',
    value: 'DABHADA, GUJARAT',
    masterId: 11176,
  },
  {
    type: 'cityName',
    value: 'MANA, MAHARASHTRA',
    masterId: 16241,
  },
  {
    type: 'cityName',
    value: 'MANDURAI, TAMIL NADU',
    masterId: 20989,
  },
  {
    type: 'cityName',
    value: 'MANESAR, ORISSA ',
    masterId: 18290,
  },
  {
    type: 'cityName',
    value: 'MAHANAGAR, WEST BENGAL',
    masterId: 13244,
  },
  {
    type: 'cityName',
    value: 'MANINAGAR, BIHAR',
    masterId: 18428,
  },
  {
    type: 'cityName',
    value: 'MANKI, KARNATAKA',
    masterId: 13444,
  },
  {
    type: 'cityName',
    value: 'MANU, TRIPURA',
    masterId: 16788,
  },
  {
    type: 'cityName',
    value: 'GOA, GOA',
    masterId: 11726,
  },
  {
    type: 'cityName',
    value: 'MORAPPUR, TAMIL NADU',
    masterId: 13643,
  },
  {
    type: 'cityName',
    value: 'MALLANUR, ANDHRA PRADESH',
    masterId: 13329,
  },
  {
    type: 'cityName',
    value: 'MAISAR KHANA, PUNJAB',
    masterId: 17320,
  },
  {
    type: 'cityName',
    value: 'MAU, UTTAR PRADESH',
    masterId: 13520,
  },
  {
    type: 'cityName',
    value: 'MAUR, PUNJAB',
    masterId: 13528,
  },
  {
    type: 'cityName',
    value: 'MARIAMMAN KOVIL, TAMIL NADU',
    masterId: 16935,
  },
  {
    type: 'cityName',
    value: 'MAYAPUR, WEST BENGAL',
    masterId: 21222,
  },
  {
    type: 'cityName',
    value: 'MAYAR, HARYANA',
    masterId: 18367,
  },
  {
    type: 'cityName',
    value: 'MANGRA, JHARKHAND',
    masterId: 18697,
  },
  {
    type: 'cityName',
    value: 'MORADABAD, UTTAR PRADESH',
    masterId: 13637,
  },
  {
    type: 'cityName',
    value: 'MAHOBA, UTTAR PRADESH',
    masterId: 13262,
  },
  {
    type: 'cityName',
    value: 'MURSHIDABAD, WEST BENGAL',
    masterId: 13751,
  },
  {
    type: 'cityName',
    value: 'MAHANANDA BGE, WEST BENGAL',
    masterId: 16236,
  },
  {
    type: 'cityName',
    value: 'MUSTABADA, ANDHRA PRADESH',
    masterId: 13760,
  },
  {
    type: 'cityName',
    value: 'MUNABAO, RAJASTHAN',
    masterId: 13715,
  },
  {
    type: 'cityName',
    value: 'MAIBANG, ASSAM',
    masterId: 13276,
  },
  {
    type: 'cityName',
    value: 'MARWAR BAGRA, RAJASTHAN',
    masterId: 20965,
  },
  {
    type: 'cityName',
    value: 'MADHUBANI, BIHAR',
    masterId: 13212,
  },
  {
    type: 'cityName',
    value: 'MANUBOLU, ANDHRA PRADESH',
    masterId: 13469,
  },
  {
    type: 'cityName',
    value: 'BHINMAL, RAJASTHAN',
    masterId: 10755,
  },
  {
    type: 'cityName',
    value: 'MAHBUBNAGAR, TELANGANA',
    masterId: 13247,
  },
  {
    type: 'cityName',
    value: 'MOIRABARI, ASSAM',
    masterId: 18884,
  },
  {
    type: 'cityName',
    value: 'BHAIDPUR, UTTAR PRADESH',
    masterId: 10678,
  },
  {
    type: 'cityName',
    value: 'MARWAR BALIA, RAJASTHAN',
    masterId: 19145,
  },
  {
    type: 'cityName',
    value: 'MARWAR BIRTHI, RAJASTHAN',
    masterId: 17115,
  },
  {
    type: 'cityName',
    value: 'MELPATTAM BAKKAM, TAMIL NADU',
    masterId: 16929,
  },
  {
    type: 'cityName',
    value: 'MIRZAPUR BCHAUD, HARYANA',
    masterId: 18288,
  },
  {
    type: 'cityName',
    value: 'MALWARA, RAJASTHAN',
    masterId: 20969,
  },
  {
    type: 'cityName',
    value: 'MANDI DABWALI, HARYANA',
    masterId: 13398,
  },
  {
    type: 'cityName',
    value: 'MANDAPAM CAMP, TAMIL NADU',
    masterId: 16941,
  },
  {
    type: 'cityName',
    value: 'MECHEDA, WEST BENGAL',
    masterId: 13542,
  },
  {
    type: 'cityName',
    value: 'MANIK CHAURI, CHHATTISGARH ',
    masterId: 18605,
  },
  {
    type: 'cityName',
    value: 'MANCHERIAL, ANDHRA PRADESH',
    masterId: 13368,
  },
  {
    type: 'cityName',
    value: 'MANJATTIDAL, TAMIL NADU',
    masterId: 16938,
  },
  {
    type: 'cityName',
    value: 'MANIMANGALAM, ANDHRA PRADESH',
    masterId: 16939,
  },
  {
    type: 'cityName',
    value: 'MACHERLA, ANDHRA PRADESH',
    masterId: 13189,
  },
  {
    type: 'cityName',
    value: 'MANCHILI, ANDHRA PRADESH',
    masterId: 20732,
  },
  {
    type: 'cityName',
    value: 'RANIPET, TAMIL NADU',
    masterId: 14663,
  },
  {
    type: 'cityName',
    value: 'MOTIHARI BYPASS, BIHAR',
    masterId: 18811,
  },
  {
    type: 'cityName',
    value: 'JARODA CHARNA, RAJASTHAN',
    masterId: 12202,
  },
  {
    type: 'cityName',
    value: 'JOGENDRA, MADHYA PRADESH',
    masterId: 12277,
  },
  {
    type: 'cityName',
    value: 'MECHERI ROAD, TAMIL NADU',
    masterId: 13543,
  },
  {
    type: 'cityName',
    value: 'MULAKALACHERUVU, ANDHRA PRADESH',
    masterId: 13703,
  },
  {
    type: 'cityName',
    value: 'MACHARYA, UTTAR PRADESH',
    masterId: 13186,
  },
  {
    type: 'cityName',
    value: 'NIDUBROLU, ANDHRA PRADESH',
    masterId: 13998,
  },
  {
    type: 'cityName',
    value: 'MAHABUANG, JHARKHAND',
    masterId: 18147,
  },
  {
    type: 'cityName',
    value: 'MANDHANA, UTTAR PRADESH',
    masterId: 16417,
  },
  {
    type: 'cityName',
    value: 'MADHABPUR, WEST BENGAL',
    masterId: 21178,
  },
  {
    type: 'cityName',
    value: 'MALAD GAON, MAHARASHTRA',
    masterId: 17731,
  },
  {
    type: 'cityName',
    value: 'MANDIDEEP, MADHYA PRADESH',
    masterId: 13399,
  },
  {
    type: 'cityName',
    value: 'MAKHDUMPUR, BIHAR',
    masterId: 13289,
  },
  {
    type: 'cityName',
    value: 'MURADI, ANDHRA PRADESH',
    masterId: 19060,
  },
  {
    type: 'cityName',
    value: 'MANDAL GHAT, WEST BENGAL',
    masterId: 16110,
  },
  {
    type: 'cityName',
    value: 'MANENDRAGARH, MADHYA PRADESH',
    masterId: 13410,
  },
  {
    type: 'cityName',
    value: 'MANDHAR, CHHATTISGARH',
    masterId: 13391,
  },
  {
    type: 'cityName',
    value: 'MADHADA, GUJARAT',
    masterId: 18430,
  },
  {
    type: 'cityName',
    value: 'MUHAMMADGANJ, JHARKHAND',
    masterId: 13691,
  },
  {
    type: 'cityName',
    value: 'MADHUKUNDA, WEST BENGAL ',
    masterId: 16114,
  },
  {
    type: 'cityName',
    value: 'MADUKKARAI, TAMIL NADU',
    masterId: 16950,
  },
  {
    type: 'cityName',
    value: 'MODUKURU, ANDHRA PRADESH',
    masterId: 13610,
  },
  {
    type: 'cityName',
    value: 'MANDAL, RAJASTHAN',
    masterId: 13374,
  },
  {
    type: 'cityName',
    value: 'MUNDLANA, HARYANA',
    masterId: 18366,
  },
  {
    type: 'cityName',
    value: 'MANDAR HILL, BIHAR',
    masterId: 18698,
  },
  {
    type: 'cityName',
    value: 'MUDDENAHALLI, KARNATAKA',
    masterId: 18086,
  },
  {
    type: 'cityName',
    value: 'MEDINIPUR, WEST BENGAL',
    masterId: 13548,
  },
  {
    type: 'cityName',
    value: 'MODINAGAR, UTTAR PRADESH',
    masterId: 13606,
  },
  {
    type: 'cityName',
    value: 'MANDPIYA, RAJASTHAN',
    masterId: 17258,
  },
  {
    type: 'cityName',
    value: 'MADHOPUR, PUNJAB',
    masterId: 13211,
  },
  {
    type: 'cityName',
    value: 'MANDAPADU, ANDHRA PRADESH',
    masterId: 13378,
  },
  {
    type: 'cityName',
    value: 'MADANAPUR, ANDHRA PRADESH',
    masterId: 17629,
  },
  {
    type: 'cityName',
    value: 'MODPUR, GUJARAT',
    masterId: 13607,
  },
  {
    type: 'cityName',
    value: 'MADHIRA, ANDHRA PRADESH',
    masterId: 13210,
  },
  {
    type: 'cityName',
    value: 'MEDRA, GUJARAT',
    masterId: 18540,
  },
  {
    type: 'cityName',
    value: 'MANDSAUR, MADHYA PRADESH',
    masterId: 13403,
  },
  {
    type: 'cityName',
    value: 'MODASA, GUJARAT',
    masterId: 13604,
  },
  {
    type: 'cityName',
    value: 'MADHYA MADARIHAT, WEST BENGAL',
    masterId: 16209,
  },
  {
    type: 'cityName',
    value: 'MADHURA NAGAR, ANDHRA PRADESH',
    masterId: 16809,
  },
  {
    type: 'cityName',
    value: 'MAHENDRA VADI, TAMIL NADU',
    masterId: 16948,
  },
  {
    type: 'cityName',
    value: 'MAHADEOKHEDI, MADHYA PRADESH',
    masterId: 13235,
  },
  {
    type: 'cityName',
    value: 'MANDAVALLI, ANDHRA PRADESH',
    masterId: 13386,
  },
  {
    type: 'cityName',
    value: 'MADHAVNAGAR, MAHARASHTRA',
    masterId: 17628,
  },
  {
    type: 'cityName',
    value: 'MUNDWA, RAJASTHAN',
    masterId: 13726,
  },
  {
    type: 'cityName',
    value: 'MUDARIA, MADHYA PRADESH',
    masterId: 17802,
  },
  {
    type: 'cityName',
    value: 'MASAIPET, ANDHRA PRADESH',
    masterId: 13499,
  },
  {
    type: 'cityName',
    value: 'MEDCHAL, ANDHRA PRADESH',
    masterId: 13546,
  },
  {
    type: 'cityName',
    value: 'MITHAI, BIHAR',
    masterId: 16733,
  },
  {
    type: 'cityName',
    value: 'VANCHIMANIYACHI, TAMIL NADU',
    masterId: 15767,
  },
  {
    type: 'cityName',
    value: 'MELAKKONNAKKULM, TAMIL NADU',
    masterId: 20990,
  },
  {
    type: 'cityName',
    value: 'MAU AIMMA, UTTAR PRADESH',
    masterId: 13521,
  },
  {
    type: 'cityName',
    value: 'MEENAPUR, BIHAR',
    masterId: 17554,
  },
  {
    type: 'cityName',
    value: 'MAHIDPUR, MADHYA PRADESH',
    masterId: 13255,
  },
  {
    type: 'cityName',
    value: 'MALETHU KANAK, UTTAR PRADESH',
    masterId: 16419,
  },
  {
    type: 'cityName',
    value: 'METPANJRA, MAHARASHTRA',
    masterId: 17618,
  },
  {
    type: 'cityName',
    value: 'MALERKOTLA, PUNJAB',
    masterId: 13313,
  },
  {
    type: 'cityName',
    value: 'METHI TIKUR, UTTAR PRADESH',
    masterId: 16734,
  },
  {
    type: 'cityName',
    value: 'MENDU, UTTAR PRADESH',
    masterId: 16735,
  },
  {
    type: 'cityName',
    value: 'MUKERIAN, PUNJAB',
    masterId: 13692,
  },
  {
    type: 'cityName',
    value: 'MUKURIA, BIHAR ',
    masterId: 18691,
  },
  {
    type: 'cityName',
    value: 'MUSTAFABAD, HARYANA',
    masterId: 18286,
  },
  {
    type: 'cityName',
    value: 'MONABARI, ASSAM',
    masterId: 18965,
  },
  {
    type: 'cityName',
    value: 'MEHRAULI, UTTAR PRADESH',
    masterId: 18586,
  },
  {
    type: 'cityName',
    value: 'MUSAFIRKHANA, UTTAR PRADESH',
    masterId: 13756,
  },
  {
    type: 'cityName',
    value: 'MAHALAM, PUNJAB',
    masterId: 17411,
  },
  {
    type: 'cityName',
    value: 'MUZAFFARPUR, BIHAR',
    masterId: 13768,
  },
  {
    type: 'cityName',
    value: 'MAHROI, MADHYA PRADESH',
    masterId: 13263,
  },
  {
    type: 'cityName',
    value: 'MADARAHA, UTTAR PRADESH',
    masterId: 16437,
  },
  {
    type: 'cityName',
    value: 'MALAHAR, WEST BENGAL',
    masterId: 16112,
  },
  {
    type: 'cityName',
    value: 'ESI HOSPITAL, PUNJAB',
    masterId: 17421,
  },
  {
    type: 'cityName',
    value: 'FULBARI, WEST BENGAL',
    masterId: 11580,
  },
  {
    type: 'cityName',
    value: 'MUDIGUBBA, ANDHRA PRADESH',
    masterId: 13681,
  },
  {
    type: 'cityName',
    value: 'SAREGAON, MAHARASHTRA',
    masterId: 14949,
  },
  {
    type: 'cityName',
    value: 'MUGAD, KARNATAKA',
    masterId: 17997,
  },
  {
    type: 'cityName',
    value: 'MIGRENDISA, ASSAM',
    masterId: 13583,
  },
  {
    type: 'cityName',
    value: 'MANDAGERE, KARNATAKA',
    masterId: 13371,
  },
  {
    type: 'cityName',
    value: 'BAGLI, MADHYA PRADESH',
    masterId: 10375,
  },
  {
    type: 'cityName',
    value: 'MANIGACHI, BIHAR',
    masterId: 18812,
  },
  {
    type: 'cityName',
    value: 'MULAGUNNATHUKAVU, KERALA',
    masterId: 17915,
  },
  {
    type: 'cityName',
    value: 'MUNGIAKAMI, TRIPURA ',
    masterId: 16781,
  },
  {
    type: 'cityName',
    value: 'MANISINGH KA PURA, UTTAR PRADESH',
    masterId: 21045,
  },
  {
    type: 'cityName',
    value: 'MUGALALLI, KARNATAKA',
    masterId: 13686,
  },
  {
    type: 'cityName',
    value: 'MANIGRAM, WEST BENGAL',
    masterId: 13430,
  },
  {
    type: 'cityName',
    value: 'MANGLI, RAJASTHAN',
    masterId: 17257,
  },
  {
    type: 'cityName',
    value: 'MURAGACHA, WEST BENGAL',
    masterId: 13739,
  },
  {
    type: 'cityName',
    value: 'MCCLUSKIEGANJ, JHARKHAND',
    masterId: 13540,
  },
  {
    type: 'cityName',
    value: 'MUNDA GOPAL ASH, UTTAR PRADESH',
    masterId: 16707,
  },
  {
    type: 'cityName',
    value: 'MAGARPATTI, BIHAR',
    masterId: 18816,
  },
  {
    type: 'cityName',
    value: 'MONGHYR, BIHAR',
    masterId: 20755,
  },
  {
    type: 'cityName',
    value: 'MAGARDOH, MADHYA PRADESH',
    masterId: 17814,
  },
  {
    type: 'cityName',
    value: 'MANGROLLA, GUJARAT',
    masterId: 13425,
  },
  {
    type: 'cityName',
    value: 'MAGARPUR, UTTAR PRADESH',
    masterId: 16741,
  },
  {
    type: 'cityName',
    value: 'MUGHAL SARAI, UTTAR PRADESH',
    masterId: 13688,
  },
  {
    type: 'cityName',
    value: 'MAGRA HAT, WEST BENGAL',
    masterId: 21201,
  },
  {
    type: 'cityName',
    value: 'MOLAGAVALLI, ANDHRA PRADESH',
    masterId: 19020,
  },
  {
    type: 'cityName',
    value: 'MAGARWARA, UTTAR PRADESH',
    masterId: 16435,
  },
  {
    type: 'cityName',
    value: 'MAHNGARWAL DOABA, PUNJAB',
    masterId: 17322,
  },
  {
    type: 'cityName',
    value: 'MAHGAVAN, UTTAR PRADESH',
    masterId: 16429,
  },
  {
    type: 'cityName',
    value: 'MAHARAJGANJ, BIHAR',
    masterId: 16434,
  },
  {
    type: 'cityName',
    value: 'MAREHRA, UTTAR PRADESH',
    masterId: 16409,
  },
  {
    type: 'cityName',
    value: 'MOHADI PRGN LNG, MAHARASHTRA',
    masterId: 16043,
  },
  {
    type: 'cityName',
    value: 'MAHADEVA, UTTAR PRADESH',
    masterId: 18815,
  },
  {
    type: 'cityName',
    value: 'MAHABUBNAGAR TO, ANDHRA PRADESH',
    masterId: 13232,
  },
  {
    type: 'cityName',
    value: 'MAHTHA BAZAR, UTTAR PRADESH',
    masterId: 16427,
  },
  {
    type: 'cityName',
    value: 'MAHEMDABAD, GUJARAT',
    masterId: 13250,
  },
  {
    type: 'cityName',
    value: 'MAHDEIYA, MADHYA PRADESH',
    masterId: 16431,
  },
  {
    type: 'cityName',
    value: 'MAHADIA PH, ORISSA',
    masterId: 17460,
  },
  {
    type: 'cityName',
    value: 'MAHADEVAPURA, GUJARAT',
    masterId: 18000,
  },
  {
    type: 'cityName',
    value: 'MOHARI, RAJASTHAN',
    masterId: 17409,
  },
  {
    type: 'cityName',
    value: 'MAGHAR, UTTAR PRADESH',
    masterId: 13228,
  },
  {
    type: 'cityName',
    value: 'MAHESHRA, UTTAR PRADESH',
    masterId: 16430,
  },
  {
    type: 'cityName',
    value: 'MANIHARI, BIHAR',
    masterId: 18695,
  },
  {
    type: 'cityName',
    value: 'MAHAJAN, RAJASTHAN',
    masterId: 13238,
  },
  {
    type: 'cityName',
    value: 'MOHKHUTI, ASSAM',
    masterId: 18885,
  },
  {
    type: 'cityName',
    value: 'MAHWAL, BIHAR ',
    masterId: 18702,
  },
  {
    type: 'cityName',
    value: 'MAHIMBA, MAHARASHTRA',
    masterId: 17626,
  },
  {
    type: 'cityName',
    value: 'MAHANADI, WEST BENGAL',
    masterId: 13243,
  },
  {
    type: 'cityName',
    value: 'MAHPUR, UTTAR PRADESH',
    masterId: 17321,
  },
  {
    type: 'cityName',
    value: 'MHOW, MADHYA PRADESH',
    masterId: 13580,
  },
  {
    type: 'cityName',
    value: 'MUHAMMADPUR, BIHAR',
    masterId: 20757,
  },
  {
    type: 'cityName',
    value: 'MOHOPE, MAHARASHTRA',
    masterId: 16044,
  },
  {
    type: 'cityName',
    value: 'MAHIARPUR, BIHAR',
    masterId: 18704,
  },
  {
    type: 'cityName',
    value: 'MAHUDA, JHARKHAND',
    masterId: 13267,
  },
  {
    type: 'cityName',
    value: 'MAHENDRAGARH, HARYANA',
    masterId: 13251,
  },
  {
    type: 'cityName',
    value: 'MACHHRAULI, HARYANA',
    masterId: 18292,
  },
  {
    type: 'cityName',
    value: 'MAHRAIL, BIHAR ',
    masterId: 18703,
  },
  {
    type: 'cityName',
    value: 'MAHENDRANATH, BIHAR',
    masterId: 18705,
  },
  {
    type: 'cityName',
    value: 'MAHESHPUR, JHARKHAND',
    masterId: 18219,
  },
  {
    type: 'cityName',
    value: 'MANJHI, BIHAR',
    masterId: 13440,
  },
  {
    type: 'cityName',
    value: 'MALIHATI TBR, WEST BENGAL',
    masterId: 16235,
  },
  {
    type: 'cityName',
    value: 'MANHERU, HARYANA',
    masterId: 13427,
  },
  {
    type: 'cityName',
    value: 'MAHUDHA, GUJARAT',
    masterId: 18429,
  },
  {
    type: 'cityName',
    value: 'MEHUWALA, HARYANA',
    masterId: 18289,
  },
  {
    type: 'cityName',
    value: 'MOHANPUR, JHARKHAND',
    masterId: 16400,
  },
  {
    type: 'cityName',
    value: 'MAHUVA, GUJARAT',
    masterId: 13274,
  },
  {
    type: 'cityName',
    value: 'MANIA, RAJASTHAN ',
    masterId: 17117,
  },
  {
    type: 'cityName',
    value: 'RAIRU NARROW GAUGE, MADHYA PRADESH',
    masterId: 17788,
  },
  {
    type: 'cityName',
    value: 'MIANGRAM, WEST BENGAL',
    masterId: 16107,
  },
  {
    type: 'cityName',
    value: 'MADHI, GUJARAT',
    masterId: 13209,
  },
  {
    type: 'cityName',
    value: 'MEHRAWAN, UTTAR PRADESH',
    masterId: 13559,
  },
  {
    type: 'cityName',
    value: 'MAJHDIA, WEST BENGAL',
    masterId: 21141,
  },
  {
    type: 'cityName',
    value: 'MANIKUL, JHARKHAND',
    masterId: 13433,
  },
  {
    type: 'cityName',
    value: 'MANIRAM, UTTAR PRADESH',
    masterId: 16414,
  },
  {
    type: 'cityName',
    value: 'MIHINPURA, UTTAR PRADESH',
    masterId: 13585,
  },
  {
    type: 'cityName',
    value: 'MIANA, MADHYA PRADESH',
    masterId: 13581,
  },
  {
    type: 'cityName',
    value: 'MAIKALGANJ, UTTAR PRADESH',
    masterId: 13278,
  },
  {
    type: 'cityName',
    value: 'MOLISAR, RAJASTHAN',
    masterId: 17107,
  },
  {
    type: 'cityName',
    value: 'MIDHAKUR, UTTAR PRADESH',
    masterId: 13582,
  },
  {
    type: 'cityName',
    value: 'MAIJAPUR, UTTAR PRADESH',
    masterId: 16740,
  },
  {
    type: 'cityName',
    value: 'MITHA, GUJARAT',
    masterId: 18539,
  },
  {
    type: 'cityName',
    value: 'MARIPAT, UTTAR PRADESH',
    masterId: 21008,
  },
  {
    type: 'cityName',
    value: 'MIGHAUNA, UTTAR PRADESH',
    masterId: 16403,
  },
  {
    type: 'cityName',
    value: 'MANIYAN, BIHAR',
    masterId: 17885,
  },
  {
    type: 'cityName',
    value: 'MARWAR, RAJASTHAN',
    masterId: 13498,
  },
  {
    type: 'cityName',
    value: 'MEJA ROAD, UTTAR PRADESH',
    masterId: 13562,
  },
  {
    type: 'cityName',
    value: 'MAJBAT, ASSAM',
    masterId: 16045,
  },
  {
    type: 'cityName',
    value: 'MUNJAL, WEST BENGAL',
    masterId: 18604,
  },
  {
    type: 'cityName',
    value: 'MALKAJGIRI, ANDHRA PRADESH',
    masterId: 13322,
  },
  {
    type: 'cityName',
    value: 'MAJHAGAWAN, MADHYA PRADESH',
    masterId: 13287,
  },
  {
    type: 'cityName',
    value: 'MAJHGAWAN PHATAK, MADHYA PRADESH',
    masterId: 17811,
  },
  {
    type: 'cityName',
    value: 'MAJU, UTTAR PRADESH',
    masterId: 21059,
  },
  {
    type: 'cityName',
    value: 'MAJADA, UTTAR PRADESH',
    masterId: 16423,
  },
  {
    type: 'cityName',
    value: 'MAJHIARI, UTTAR PRADESH',
    masterId: 17810,
  },
  {
    type: 'cityName',
    value: 'NAUGARHWA, BIHAR',
    masterId: 13919,
  },
  {
    type: 'cityName',
    value: 'MANJHAULIGRAM HALT, BIHAR',
    masterId: 20739,
  },
  {
    type: 'cityName',
    value: 'MAKUM, ASSAM',
    masterId: 13297,
  },
  {
    type: 'cityName',
    value: 'MAJRI NANGAL, RAJASTHAN',
    masterId: 17120,
  },
  {
    type: 'cityName',
    value: 'MAJORDA, GOA',
    masterId: 18570,
  },
  {
    type: 'cityName',
    value: 'MAHARAJPUR, JHARKHAND',
    masterId: 17813,
  },
  {
    type: 'cityName',
    value: 'MANJHRA PURAB, UTTAR PRADESH',
    masterId: 16413,
  },
  {
    type: 'cityName',
    value: 'MINJUR, TAMIL NADU',
    masterId: 16926,
  },
  {
    type: 'cityName',
    value: 'PALASGAON, MAHARASHTRA',
    masterId: 14149,
  },
  {
    type: 'cityName',
    value: 'MANJESHWAR, KERALA',
    masterId: 13439,
  },
  {
    type: 'cityName',
    value: 'MAJERHAT, PUNJAB',
    masterId: 20951,
  },
  {
    type: 'cityName',
    value: 'MAJITHA, PUNJAB',
    masterId: 20939,
  },
  {
    type: 'cityName',
    value: 'MARAMJHIRI, MADHYA PRADESH',
    masterId: 13479,
  },
  {
    type: 'cityName',
    value: 'MIRANPUR KATRA, UTTAR PRADESH',
    masterId: 13590,
  },
  {
    type: 'cityName',
    value: 'MOKAMEH, BIHAR',
    masterId: 13624,
  },
  {
    type: 'cityName',
    value: 'MANKATHA, BIHAR',
    masterId: 13443,
  },
  {
    type: 'cityName',
    value: 'MANWALA KOT BAK, PUNJAB',
    masterId: 17314,
  },
  {
    type: 'cityName',
    value: 'MAKSHI, MADHYA PRADESH',
    masterId: 13294,
  },
  {
    type: 'cityName',
    value: 'MARKUNDI, MADHYA PRADESH',
    masterId: 16737,
  },
  {
    type: 'cityName',
    value: 'MAKUDI, MAHARASHTRA',
    masterId: 13296,
  },
  {
    type: 'cityName',
    value: 'MORKADHANA, MADHYA PRADESH',
    masterId: 13652,
  },
  {
    type: 'cityName',
    value: 'MANAK NAGAR, UTTAR PRADESH',
    masterId: 16418,
  },
  {
    type: 'cityName',
    value: 'MALAKHERA, RAJASTHAN',
    masterId: 13299,
  },
  {
    type: 'cityName',
    value: 'MAKHI, UTTAR PRADESH',
    masterId: 17319,
  },
  {
    type: 'cityName',
    value: 'MARWAR KHARA, RAJASTHAN',
    masterId: 17114,
  },
  {
    type: 'cityName',
    value: 'MAKKAJIPALLI, ANDHRA PRADESH',
    masterId: 19077,
  },
  {
    type: 'cityName',
    value: 'MAKLIDRUG, KARNATAKA',
    masterId: 13292,
  },
  {
    type: 'cityName',
    value: 'MAKRAULI, UTTAR PRADESH',
    masterId: 16739,
  },
  {
    type: 'cityName',
    value: 'MARIKUPPAM, KARNATAKA',
    masterId: 18087,
  },
  {
    type: 'cityName',
    value: 'GAUDADIA, ORISSA',
    masterId: 11669,
  },
  {
    type: 'cityName',
    value: 'MUKTAPUR, BIHAR',
    masterId: 16046,
  },
  {
    type: 'cityName',
    value: 'MALIKPETH, MAHARASHTRA',
    masterId: 13320,
  },
  {
    type: 'cityName',
    value: 'MADDIKERA, ANDHRA PRADESH',
    masterId: 13202,
  },
  {
    type: 'cityName',
    value: 'MANGLIYAWAS, RAJASTHAN',
    masterId: 13421,
  },
  {
    type: 'cityName',
    value: 'SIDAPUT, ORISSA',
    masterId: 15138,
  },
  {
    type: 'cityName',
    value: 'MALLIKPUR, WEST BENGAL',
    masterId: 13335,
  },
  {
    type: 'cityName',
    value: 'RAJAKHEDI, MADHYA PRADESH',
    masterId: 14568,
  },
  {
    type: 'cityName',
    value: 'MUKTSAR, PUNJAB',
    masterId: 13700,
  },
  {
    type: 'cityName',
    value: 'MUKHASAPARUR, TAMIL NADU',
    masterId: 16923,
  },
  {
    type: 'cityName',
    value: 'MOKALSAR, RAJASTHAN',
    masterId: 13623,
  },
  {
    type: 'cityName',
    value: 'MUKHTIAR BALWAR, MADHYA PRADESH',
    masterId: 13695,
  },
  {
    type: 'cityName',
    value: 'MUKTESHWAR, ORISSA',
    masterId: 16253,
  },
  {
    type: 'cityName',
    value: 'MALKAPUR, MAHARASHTRA',
    masterId: 13325,
  },
  {
    type: 'cityName',
    value: 'MAKARWADI, RAJASTHAN',
    masterId: 17119,
  },
  {
    type: 'cityName',
    value: 'UDPURA, RAJASTHAN',
    masterId: 15646,
  },
  {
    type: 'cityName',
    value: 'MEKKUDI, TAMIL NADU',
    masterId: 16932,
  },
  {
    type: 'cityName',
    value: 'MAHKEPAR, MADHYA PRADESH',
    masterId: 17812,
  },
  {
    type: 'cityName',
    value: 'MALANPUR, MADHYA PRADESH',
    masterId: 13304,
  },
  {
    type: 'cityName',
    value: 'MODANIMB, MAHARASHTRA',
    masterId: 13602,
  },
  {
    type: 'cityName',
    value: 'MALKISAR, RAJASTHAN',
    masterId: 13327,
  },
  {
    type: 'cityName',
    value: 'FIROZPUR, UTTAR PRADESH',
    masterId: 11576,
  },
  {
    type: 'cityName',
    value: 'MADLAUDA, HARYANA',
    masterId: 18291,
  },
  {
    type: 'cityName',
    value: 'MALDA, WEST BENGAL',
    masterId: 13309,
  },
  {
    type: 'cityName',
    value: 'KACHARIYA, MADHYA PRADESH',
    masterId: 12306,
  },
  {
    type: 'cityName',
    value: 'MANDALGARH, RAJASTHAN',
    masterId: 13375,
  },
  {
    type: 'cityName',
    value: 'NANCHERAL, ANDHRA PRADESH',
    masterId: 13854,
  },
  {
    type: 'cityName',
    value: 'MOHANLALGANJ, UTTAR PRADESH',
    masterId: 13618,
  },
  {
    type: 'cityName',
    value: 'MALUKA, JHARKHAND',
    masterId: 18145,
  },
  {
    type: 'cityName',
    value: 'MULEWAL KHAIRA, PUNJAB ',
    masterId: 17313,
  },
  {
    type: 'cityName',
    value: 'MALIKPUR, UTTAR PRADESH',
    masterId: 18699,
  },
  {
    type: 'cityName',
    value: 'MALTHAN, MAHARASHTRA',
    masterId: 13341,
  },
  {
    type: 'cityName',
    value: 'MALLEMADUGU, TELANGANA',
    masterId: 16830,
  },
  {
    type: 'cityName',
    value: 'MELMARUVATHUR, TAMIL NADU',
    masterId: 13568,
  },
  {
    type: 'cityName',
    value: 'MAILANI, UTTAR PRADESH',
    masterId: 13279,
  },
  {
    type: 'cityName',
    value: 'MALANCHA, WEST BENGAL',
    masterId: 13302,
  },
  {
    type: 'cityName',
    value: 'MALUR, KARNATAKA',
    masterId: 13342,
  },
  {
    type: 'cityName',
    value: 'MALLAPUR, KARNATAKA',
    masterId: 13332,
  },
  {
    type: 'cityName',
    value: 'MALIPUR, UTTAR PRADESH',
    masterId: 13321,
  },
  {
    type: 'cityName',
    value: 'MALKERA, JHARKHAND',
    masterId: 18218,
  },
  {
    type: 'cityName',
    value: 'MALKHED, MAHARASHTRA',
    masterId: 18089,
  },
  {
    type: 'cityName',
    value: 'MALASA, UTTAR PRADESH',
    masterId: 16420,
  },
  {
    type: 'cityName',
    value: 'MALLASANDRA, KARNATAKA',
    masterId: 18088,
  },
  {
    type: 'cityName',
    value: 'MALSAILU, MAHARASHTRA',
    masterId: 17622,
  },
  {
    type: 'cityName',
    value: 'MALATIPATPUR, ORISSA',
    masterId: 17459,
  },
  {
    type: 'cityName',
    value: 'MELATTUR, KERALA',
    masterId: 13566,
  },
  {
    type: 'cityName',
    value: 'MALLARPUR, WEST BENGAL',
    masterId: 13333,
  },
  {
    type: 'cityName',
    value: 'MALLAWAN, UTTAR PRADESH',
    masterId: 16738,
  },
  {
    type: 'cityName',
    value: 'MULLANPUR DAKHA, PUNJAB ',
    masterId: 17312,
  },
  {
    type: 'cityName',
    value: 'MAULA ALI, ANDHRA PRADESH',
    masterId: 13526,
  },
  {
    type: 'cityName',
    value: 'MALIYA, WEST BENGAL',
    masterId: 21219,
  },
  {
    type: 'cityName',
    value: 'MELNARIYAPPANUR, TAMIL NADU',
    masterId: 16930,
  },
  {
    type: 'cityName',
    value: 'MALARNA, RAJASTHAN',
    masterId: 13307,
  },
  {
    type: 'cityName',
    value: 'MUHAMMADABAD, UTTAR PRADESH',
    masterId: 13690,
  },
  {
    type: 'cityName',
    value: 'MAHMUDABAD, UTTAR PRADESH',
    masterId: 13261,
  },
  {
    type: 'cityName',
    value: 'MAHAMANDIR, RAJASTHAN',
    masterId: 17121,
  },
  {
    type: 'cityName',
    value: 'RAGHAIDIH, JHARKHAND',
    masterId: 14538,
  },
  {
    type: 'cityName',
    value: 'MUTHALAMADA, KERALA',
    masterId: 17914,
  },
  {
    type: 'cityName',
    value: 'MUL, MAHARASHTRA',
    masterId: 13702,
  },
  {
    type: 'cityName',
    value: 'MADHYAMGRAM, WEST BENGAL',
    masterId: 21151,
  },
  {
    type: 'cityName',
    value: 'MAHADANAPURAM, TAMIL NADU',
    masterId: 13234,
  },
  {
    type: 'cityName',
    value: 'MEKRA MEMERKHAB, BIHAR',
    masterId: 13563,
  },
  {
    type: 'cityName',
    value: 'MAHUAMILAN, JHARKHAND',
    masterId: 18146,
  },
  {
    type: 'cityName',
    value: 'MANDAPAM, TAMIL NADU',
    masterId: 13380,
  },
  {
    type: 'cityName',
    value: 'MAMBALAPATTU, TAMIL NADU',
    masterId: 16942,
  },
  {
    type: 'cityName',
    value: 'MANTAPAMPALLE, ANDHRA PRADESH',
    masterId: 13464,
  },
  {
    type: 'cityName',
    value: 'MANMAD, MAHARASHTRA',
    masterId: 13446,
  },
  {
    type: 'cityName',
    value: 'MANDASA, ANDHRA PRADESH',
    masterId: 13384,
  },
  {
    type: 'cityName',
    value: 'MUGMA, JHARKHAND',
    masterId: 18217,
  },
  {
    type: 'cityName',
    value: 'MAHALI MARUP, JHARKHAND',
    masterId: 13240,
  },
  {
    type: 'cityName',
    value: 'MURGAMAHADEV RD, ORISSA',
    masterId: 16047,
  },
  {
    type: 'cityName',
    value: 'MATHANIA, RAJASTHAN',
    masterId: 13512,
  },
  {
    type: 'cityName',
    value: 'MANDAMARI, ANDHRA PRADESH',
    masterId: 13376,
  },
  {
    type: 'cityName',
    value: 'MANKAR, WEST BENGAL',
    masterId: 13442,
  },
  {
    type: 'cityName',
    value: 'MADANKATA, JHARKHAND',
    masterId: 13197,
  },
  {
    type: 'cityName',
    value: 'MONACHERRA, ASSAM',
    masterId: 16782,
  },
  {
    type: 'cityName',
    value: 'MUNDERWA, UTTAR PRADESH',
    masterId: 13718,
  },
  {
    type: 'cityName',
    value: 'MANDURA, MAHARASHTRA ',
    masterId: 17621,
  },
  {
    type: 'cityName',
    value: 'MANDIR HASAUD, CHHATTISGARH',
    masterId: 13400,
  },
  {
    type: 'cityName',
    value: 'MENDIPATHAR, MEGHALAYA ',
    masterId: 17552,
  },
  {
    type: 'cityName',
    value: 'MANDI, UTTAR PRADESH',
    masterId: 13395,
  },
  {
    type: 'cityName',
    value: 'MANSI, BIHAR',
    masterId: 13463,
  },
  {
    type: 'cityName',
    value: 'MANDA ROAD, UTTAR PRADESH',
    masterId: 13370,
  },
  {
    type: 'cityName',
    value: 'MOHAN NAGAR, RAJASTHAN',
    masterId: 16401,
  },
  {
    type: 'cityName',
    value: 'MUNSHIRHAT, HIMACHAL PRADESH',
    masterId: 20823,
  },
  {
    type: 'cityName',
    value: 'MINDHA, RAJASTHAN',
    masterId: 17884,
  },
  {
    type: 'cityName',
    value: 'MANGAON, MAHARASHTRA',
    masterId: 13417,
  },
  {
    type: 'cityName',
    value: 'MANOHARGANJ, UTTAR PRADESH',
    masterId: 13453,
  },
  {
    type: 'cityName',
    value: 'MANJALPUR, UTTAR PRADESH',
    masterId: 18541,
  },
  {
    type: 'cityName',
    value: 'MIYONKA BARA, RAJASTHAN',
    masterId: 17109,
  },
  {
    type: 'cityName',
    value: 'MANIKALAN TRAIN, UTTAR PRADESH',
    masterId: 16415,
  },
  {
    type: 'cityName',
    value: 'GUNAKI, KARNATAKA',
    masterId: 11835,
  },
  {
    type: 'cityName',
    value: 'MANAMADURAI, TAMIL NADU',
    masterId: 13355,
  },
  {
    type: 'cityName',
    value: 'MANI MAU, UTTAR PRADESH',
    masterId: 16416,
  },
  {
    type: 'cityName',
    value: 'MANANPUR, BIHAR',
    masterId: 13357,
  },
  {
    type: 'cityName',
    value: 'MINAPUR, PUNJAB',
    masterId: 20930,
  },
  {
    type: 'cityName',
    value: 'MUNGILIPATTU, ANDHRA PRADESH',
    masterId: 19018,
  },
  {
    type: 'cityName',
    value: 'MAINPURI, UTTAR PRADESH',
    masterId: 13282,
  },
  {
    type: 'cityName',
    value: 'MAKKHANPUR, UTTAR PRADESH',
    masterId: 16422,
  },
  {
    type: 'cityName',
    value: 'MANSAHI, BIHAR',
    masterId: 18693,
  },
  {
    type: 'cityName',
    value: 'MANAKSAR, RAJASTHAN',
    masterId: 13352,
  },
  {
    type: 'cityName',
    value: 'MULANTHURUTHY, KERALA',
    masterId: 13704,
  },
  {
    type: 'cityName',
    value: 'MUNDIKOTA, MAHARASHTRA',
    masterId: 13722,
  },
  {
    type: 'cityName',
    value: 'MANNANUR, KERALA',
    masterId: 17916,
  },
  {
    type: 'cityName',
    value: 'MUNGAOLI, MADHYA PRADESH',
    masterId: 13728,
  },
  {
    type: 'cityName',
    value: 'MANWAL, PUNJAB ',
    masterId: 17316,
  },
  {
    type: 'cityName',
    value: 'MANGANALLUR, TAMIL NADU',
    masterId: 16940,
  },
  {
    type: 'cityName',
    value: 'MANKARAI, KERALA',
    masterId: 16937,
  },
  {
    type: 'cityName',
    value: 'MANANI, UTTAR PRADESH',
    masterId: 19172,
  },
  {
    type: 'cityName',
    value: 'KOLEGAON, MAHARASHTRA',
    masterId: 12840,
  },
  {
    type: 'cityName',
    value: 'MANOPAD, ANDHRA PRADESH',
    masterId: 13457,
  },
  {
    type: 'cityName',
    value: 'MONIPUR BAGAN, ASSAM',
    masterId: 18882,
  },
  {
    type: 'cityName',
    value: 'MANOHARABAD, ANDHRA PRADESH',
    masterId: 13452,
  },
  {
    type: 'cityName',
    value: 'MOABUND, ASSAM ',
    masterId: 18886,
  },
  {
    type: 'cityName',
    value: 'CHAKDUKHARAN, UTTAR PRADESH',
    masterId: 10957,
  },
  {
    type: 'cityName',
    value: 'MOHIUDDINNAGAR, BIHAR',
    masterId: 13622,
  },
  {
    type: 'cityName',
    value: 'MOGA, PUNJAB',
    masterId: 13611,
  },
  {
    type: 'cityName',
    value: 'MORI BERA, RAJASTHAN',
    masterId: 13648,
  },
  {
    type: 'cityName',
    value: 'MOHANA, MADHYA PRADESH',
    masterId: 17456,
  },
  {
    type: 'cityName',
    value: 'MULI, GUJARAT',
    masterId: 13707,
  },
  {
    type: 'cityName',
    value: 'MAMAN, UTTAR PRADESH',
    masterId: 16048,
  },
  {
    type: 'cityName',
    value: 'MOLAKALMURU, KARNATAKA',
    masterId: 13628,
  },
  {
    type: 'cityName',
    value: 'MODRAN, RAJASTHAN',
    masterId: 13609,
  },
  {
    type: 'cityName',
    value: 'MONGLAJHORA, ASSAM',
    masterId: 18883,
  },
  {
    type: 'cityName',
    value: 'MOHANUR, KARNATAKA',
    masterId: 13619,
  },
  {
    type: 'cityName',
    value: 'MUDDANUR, ANDHRA PRADESH',
    masterId: 13674,
  },
  {
    type: 'cityName',
    value: 'MOHANPUR, RAJASTHAN',
    masterId: 16399,
  },
  {
    type: 'cityName',
    value: 'SULTANPUR, BIHAR',
    masterId: 15329,
  },
  {
    type: 'cityName',
    value: 'MORAIYA, GUJARAT',
    masterId: 18425,
  },
  {
    type: 'cityName',
    value: 'MALOUT, PUNJAB',
    masterId: 13337,
  },
  {
    type: 'cityName',
    value: 'MOTA, UTTAR PRADESH',
    masterId: 18424,
  },
  {
    type: 'cityName',
    value: 'MOTICHUR, UTTARAKHAND',
    masterId: 13665,
  },
  {
    type: 'cityName',
    value: 'MOTIGANJ, UTTAR PRADESH',
    masterId: 16397,
  },
  {
    type: 'cityName',
    value: 'MOTH, UTTAR PRADESH',
    masterId: 13659,
  },
  {
    type: 'cityName',
    value: 'MANOHARPUR, JHARKHAND',
    masterId: 13454,
  },
  {
    type: 'cityName',
    value: 'MANANWALA, PUNJAB',
    masterId: 13359,
  },
  {
    type: 'cityName',
    value: 'MOHRA, HARYANA ',
    masterId: 18287,
  },
  {
    type: 'cityName',
    value: 'MUZAFFARNAGAR, UTTAR PRADESH',
    masterId: 13767,
  },
  {
    type: 'cityName',
    value: 'MELAPALAYAM, TAMIL NADU',
    masterId: 16931,
  },
  {
    type: 'cityName',
    value: 'SAMUDRAM, TAMIL NADU',
    masterId: 14882,
  },
  {
    type: 'cityName',
    value: 'MUTTAMPATTI, TAMIL NADU',
    masterId: 16920,
  },
  {
    type: 'cityName',
    value: 'MADPUR, WEST BENGAL',
    masterId: 17412,
  },
  {
    type: 'cityName',
    value: 'MALATIPUR, WEST BENGAL',
    masterId: 21161,
  },
  {
    type: 'cityName',
    value: 'MIRPUR, UTTAR PRADESH',
    masterId: 17110,
  },
  {
    type: 'cityName',
    value: 'MANPUR NAGARIA, UTTAR PRADESH',
    masterId: 16411,
  },
  {
    type: 'cityName',
    value: 'MUNDHA PANDE, UTTAR PRADESH',
    masterId: 13719,
  },
  {
    type: 'cityName',
    value: 'MELPATTI, TAMIL NADU',
    masterId: 16928,
  },
  {
    type: 'cityName',
    value: 'MADANPUR, WEST BENGAL',
    masterId: 13198,
  },
  {
    type: 'cityName',
    value: 'MADANAPALLE, ANDHRA PRADESH',
    masterId: 13195,
  },
  {
    type: 'cityName',
    value: 'MINNAMPALLI, TAMIL NADU',
    masterId: 16925,
  },
  {
    type: 'cityName',
    value: 'MOORTHIPALAYAM, TAMIL NADU',
    masterId: 13635,
  },
  {
    type: 'cityName',
    value: 'MAHIPAL, WEST BENGAL',
    masterId: 13256,
  },
  {
    type: 'cityName',
    value: 'MEPPULIYUR, TAMIL NADU',
    masterId: 16927,
  },
  {
    type: 'cityName',
    value: 'MADHYAMPUR, WEST BENGAL',
    masterId: 21243,
  },
  {
    type: 'cityName',
    value: 'MAJUNUPUR NAVADA HAL, BIHAR',
    masterId: 19076,
  },
  {
    type: 'cityName',
    value: 'MANPUR, BIHAR',
    masterId: 18694,
  },
  {
    type: 'cityName',
    value: 'MAHAMMAD PUR, ASSAM',
    masterId: 18706,
  },
  {
    type: 'cityName',
    value: 'MATHURAPUR RD, WEST BENGAL',
    masterId: 21179,
  },
  {
    type: 'cityName',
    value: 'MANGALAMPETA, ANDHRA PRADESH',
    masterId: 19061,
  },
  {
    type: 'cityName',
    value: 'MEDAPADU, ANDHRA PRADESH',
    masterId: 13544,
  },
  {
    type: 'cityName',
    value: 'MAINPURI KACHERI, UTTAR PRADESH',
    masterId: 16424,
  },
  {
    type: 'cityName',
    value: 'NEW MADANPUR, JHARKHAND',
    masterId: 18139,
  },
  {
    type: 'cityName',
    value: 'MURARPUR, UTTAR PRADESH',
    masterId: 13742,
  },
  {
    type: 'cityName',
    value: 'MANNARGUDI, TAMIL NADU',
    masterId: 13450,
  },
  {
    type: 'cityName',
    value: 'MATODA, GUJARAT ',
    masterId: 18427,
  },
  {
    type: 'cityName',
    value: 'MUNDKA, DELHI',
    masterId: 18585,
  },
  {
    type: 'cityName',
    value: 'MOHAMMADKHERA, MADHYA PRADESH',
    masterId: 13617,
  },
  {
    type: 'cityName',
    value: 'MILANGARH, WEST BENGAL',
    masterId: 16106,
  },
  {
    type: 'cityName',
    value: 'MIRKHAL, MAHARASHTRA',
    masterId: 13593,
  },
  {
    type: 'cityName',
    value: 'MANYAMKONDA, ANDHRA PRADESH',
    masterId: 13474,
  },
  {
    type: 'cityName',
    value: 'MUNROTURUTTU, KERALA',
    masterId: 13732,
  },
  {
    type: 'cityName',
    value: 'MAKRANDPUR, UTTAR PRADESH',
    masterId: 16421,
  },
  {
    type: 'cityName',
    value: 'BHIMNAGAR, KARNATAKA',
    masterId: 10750,
  },
  {
    type: 'cityName',
    value: 'MALSIAN SHAHKHT, PUNJAB',
    masterId: 13340,
  },
  {
    type: 'cityName',
    value: 'MURUKKUMPUZHA, KERALA',
    masterId: 13755,
  },
  {
    type: 'cityName',
    value: 'MALLANNAGAR, UTTAR PRADESH',
    masterId: 16711,
  },
  {
    type: 'cityName',
    value: 'MERAL, JHARKHAND',
    masterId: 13573,
  },
  {
    type: 'cityName',
    value: 'MOTA JADRA, GUJARAT',
    masterId: 18423,
  },
  {
    type: 'cityName',
    value: 'MARTUR, KARNATAKA',
    masterId: 13495,
  },
  {
    type: 'cityName',
    value: 'MORENA, MADHYA PRADESH',
    masterId: 13647,
  },
  {
    type: 'cityName',
    value: 'HULIGI, KARNATAKA',
    masterId: 12039,
  },
  {
    type: 'cityName',
    value: 'GHANTABAHALI, ORISSA',
    masterId: 11688,
  },
  {
    type: 'cityName',
    value: 'MARICHETHAL, KARNATAKA',
    masterId: 17999,
  },
  {
    type: 'cityName',
    value: 'MORDAR, MADHYA PRADESH',
    masterId: 13646,
  },
  {
    type: 'cityName',
    value: 'MERAMANDALI, ORISSA',
    masterId: 13574,
  },
  {
    type: 'cityName',
    value: 'MURADPUR(HALT), UTTAR PRADESH',
    masterId: 21053,
  },
  {
    type: 'cityName',
    value: 'MAVALLI, KARNATAKA',
    masterId: 13529,
  },
  {
    type: 'cityName',
    value: 'MANAURI, UTTAR PRADESH',
    masterId: 13364,
  },
  {
    type: 'cityName',
    value: 'MARPALLI, ANDHRA PRADESH',
    masterId: 13492,
  },
  {
    type: 'cityName',
    value: 'MARGHERITA, ASSAM',
    masterId: 13487,
  },
  {
    type: 'cityName',
    value: 'MIRYALAGUDA, TELANGANA',
    masterId: 13595,
  },
  {
    type: 'cityName',
    value: 'MAURIGRAM, WEST BENGAL',
    masterId: 21233,
  },
  {
    type: 'cityName',
    value: 'MURAHARA, BIHAR ',
    masterId: 18690,
  },
  {
    type: 'cityName',
    value: 'MORAN, ASSAM',
    masterId: 13640,
  },
  {
    type: 'cityName',
    value: 'MURLIGANJ, BIHAR',
    masterId: 13749,
  },
  {
    type: 'cityName',
    value: 'MIRAJ, MAHARASHTRA',
    masterId: 13589,
  },
  {
    type: 'cityName',
    value: 'MARKAPUR, ANDHRA PRADESH',
    masterId: 13490,
  },
  {
    type: 'cityName',
    value: 'NAVSARI, GUJARAT',
    masterId: 13931,
  },
  {
    type: 'cityName',
    value: 'MURLI, JHARKHAND',
    masterId: 18143,
  },
  {
    type: 'cityName',
    value: 'MAMANDURU, ANDHRA PRADESH',
    masterId: 13347,
  },
  {
    type: 'cityName',
    value: 'DANTODA, MADHYA PRADESH',
    masterId: 11227,
  },
  {
    type: 'cityName',
    value: 'MORINDA, PUNJAB',
    masterId: 13649,
  },
  {
    type: 'cityName',
    value: 'MORA, UTTAR PRADESH',
    masterId: 16731,
  },
  {
    type: 'cityName',
    value: 'MARAMPALLI, ANDHRA PRADESH',
    masterId: 13480,
  },
  {
    type: 'cityName',
    value: 'MAU RANIPUR, UTTAR PRADESH',
    masterId: 13522,
  },
  {
    type: 'cityName',
    value: 'MATHARI, JHARKHAND',
    masterId: 16109,
  },
  {
    type: 'cityName',
    value: 'BHADISWAR, WEST BENGAL',
    masterId: 10662,
  },
  {
    type: 'cityName',
    value: 'MORSHI, MAHARASHTRA ',
    masterId: 17612,
  },
  {
    type: 'cityName',
    value: 'MATHURA, UTTAR PRADESH',
    masterId: 13514,
  },
  {
    type: 'cityName',
    value: 'MURAITHA, BIHAR',
    masterId: 20772,
  },
  {
    type: 'cityName',
    value: 'MIRTHAL, PUNJAB',
    masterId: 13594,
  },
  {
    type: 'cityName',
    value: 'MURTI, MAHARASHTRA',
    masterId: 13752,
  },
  {
    type: 'cityName',
    value: 'MARSUL, MAHARASHTRA',
    masterId: 17620,
  },
  {
    type: 'cityName',
    value: 'GUMPHAWADI, MAHARASHTRA',
    masterId: 11832,
  },
  {
    type: 'cityName',
    value: 'MERIYANA, GUJARAT',
    masterId: 18426,
  },
  {
    type: 'cityName',
    value: 'MIRZA, ASSAM',
    masterId: 18888,
  },
  {
    type: 'cityName',
    value: 'MASAGRAM, WEST BENGAL',
    masterId: 21214,
  },
  {
    type: 'cityName',
    value: 'MHASODA DONGAR, MAHARASHTRA',
    masterId: 17616,
  },
  {
    type: 'cityName',
    value: 'MASNODIH, BIHAR',
    masterId: 18144,
  },
  {
    type: 'cityName',
    value: 'MAHISADAL, WEST BENGAL',
    masterId: 21227,
  },
  {
    type: 'cityName',
    value: 'MASUDAN, BIHAR',
    masterId: 13504,
  },
  {
    type: 'cityName',
    value: 'MURSHADPUR, UTTAR PRADESH',
    masterId: 17610,
  },
  {
    type: 'cityName',
    value: 'MASANI, UTTAR PRADESH',
    masterId: 21049,
  },
  {
    type: 'cityName',
    value: 'MAHESANA, GUJARAT',
    masterId: 13252,
  },
  {
    type: 'cityName',
    value: 'MUSHARWA, BIHAR',
    masterId: 18689,
  },
  {
    type: 'cityName',
    value: 'MAHESHKHUNT, BIHAR',
    masterId: 13253,
  },
  {
    type: 'cityName',
    value: 'MACHCHALANDAPUR, WEST BENGAL',
    masterId: 21247,
  },
  {
    type: 'cityName',
    value: 'MAHASAMUND, CHHATTISGARH',
    masterId: 13245,
  },
  {
    type: 'cityName',
    value: 'MISSAMARI, ASSAM',
    masterId: 18887,
  },
  {
    type: 'cityName',
    value: 'MURSAN, UTTAR PRADESH',
    masterId: 16395,
  },
  {
    type: 'cityName',
    value: 'MASODHA, UTTAR PRADESH',
    masterId: 16408,
  },
  {
    type: 'cityName',
    value: 'MANSURPUR, UTTAR PRADESH',
    masterId: 16410,
  },
  {
    type: 'cityName',
    value: 'MARWAR RATANPRA, RAJASTHAN',
    masterId: 20970,
  },
  {
    type: 'cityName',
    value: 'WANYACHIWADI, MAHARASHTRA',
    masterId: 15943,
  },
  {
    type: 'cityName',
    value: 'MURHESI RAMPUR, UTTAR PRADESH',
    masterId: 16396,
  },
  {
    type: 'cityName',
    value: 'DASARAHALLI, KARNATAKA',
    masterId: 18044,
  },
  {
    type: 'cityName',
    value: 'MAHESHARI SNDHN, PUNJAB',
    masterId: 17323,
  },
  {
    type: 'cityName',
    value: 'MASIT, UTTAR PRADESH',
    masterId: 13500,
  },
  {
    type: 'cityName',
    value: 'MISRIKH TIRATH, UTTAR PRADESH',
    masterId: 16402,
  },
  {
    type: 'cityName',
    value: 'MOSUR, TAMIL NADU',
    masterId: 20978,
  },
  {
    type: 'cityName',
    value: 'MUSTARA, UTTAR PRADESH',
    masterId: 17883,
  },
  {
    type: 'cityName',
    value: 'MASKANWA, UTTAR PRADESH',
    masterId: 13501,
  },
  {
    type: 'cityName',
    value: 'MASANIWALA, RAJASTHAN',
    masterId: 17113,
  },
  {
    type: 'cityName',
    value: 'MANSA, PUNJAB',
    masterId: 13461,
  },
  {
    type: 'cityName',
    value: 'MATERA, UTTAR PRADESH',
    masterId: 16736,
  },
  {
    type: 'cityName',
    value: 'MATHELA, MADHYA PRADESH',
    masterId: 17807,
  },
  {
    type: 'cityName',
    value: 'MATLABPUR, UTTAR PRADESH',
    masterId: 16405,
  },
  {
    type: 'cityName',
    value: 'MATHIA BARGHAT, UTTAR PRADESH',
    masterId: 16406,
  },
  {
    type: 'cityName',
    value: 'MEERUT, UTTAR PRADESH',
    masterId: 13551,
  },
  {
    type: 'cityName',
    value: 'MERTA, RAJASTHAN',
    masterId: 13575,
  },
  {
    type: 'cityName',
    value: 'MALTEKDI, MAHARASHTRA',
    masterId: 17730,
  },
  {
    type: 'cityName',
    value: 'METTUR, TAMIL NADU',
    masterId: 13578,
  },
  {
    type: 'cityName',
    value: 'MERTALA PHALEYA HALT, WEST BENGAL',
    masterId: 21187,
  },
  {
    type: 'cityName',
    value: 'MUTHANI, BIHAR',
    masterId: 18688,
  },
  {
    type: 'cityName',
    value: 'MATAUNDH, UTTAR PRADESH',
    masterId: 16407,
  },
  {
    type: 'cityName',
    value: 'MITHAPUR, GUJARAT',
    masterId: 13600,
  },
  {
    type: 'cityName',
    value: 'MITAWAL, UTTAR PRADESH',
    masterId: 17805,
  },
  {
    type: 'cityName',
    value: 'MOTIJHEEL, MADHYA PRADESH',
    masterId: 19070,
  },
  {
    type: 'cityName',
    value: 'MOTERJHAR, ASSAM',
    masterId: 18880,
  },
  {
    type: 'cityName',
    value: 'MAILAM, TAMIL NADU',
    masterId: 16947,
  },
  {
    type: 'cityName',
    value: 'MACHILIPATNAM, ANDHRA PRADESH',
    masterId: 13190,
  },
  {
    type: 'cityName',
    value: 'MOTIMARI, TELANGANA',
    masterId: 19165,
  },
  {
    type: 'cityName',
    value: 'TIRUMAILAI, TAMIL NADU',
    masterId: 20993,
  },
  {
    type: 'cityName',
    value: 'MATTAGAJPUR, ORISSA ',
    masterId: 17457,
  },
  {
    type: 'cityName',
    value: 'MUTHARASANALLUR, TAMIL NADU',
    masterId: 16921,
  },
  {
    type: 'cityName',
    value: 'MAITHA, UTTAR PRADESH',
    masterId: 21010,
  },
  {
    type: 'cityName',
    value: 'METTUPALAYAM, TAMIL NADU',
    masterId: 13577,
  },
  {
    type: 'cityName',
    value: 'MOTIPURA CHAUKI, RAJASTHAN ',
    masterId: 17106,
  },
  {
    type: 'cityName',
    value: 'RAIMEHATPUR, HIMACHAL PRADESH',
    masterId: 14560,
  },
  {
    type: 'cityName',
    value: 'MOTIPUR, BIHAR',
    masterId: 13667,
  },
  {
    type: 'cityName',
    value: 'MATIGARA, WEST BENGAL',
    masterId: 21102,
  },
  {
    type: 'cityName',
    value: 'MATMAARI, KARNATAKA',
    masterId: 13518,
  },
  {
    type: 'cityName',
    value: 'MATHUR, TAMIL NADU',
    masterId: 19162,
  },
  {
    type: 'cityName',
    value: 'METALKUNTA, TELANGANA',
    masterId: 16808,
  },
  {
    type: 'cityName',
    value: 'MITEWANI, MAHARASHTRA',
    masterId: 17614,
  },
  {
    type: 'cityName',
    value: 'MULTAI, MADHYA PRADESH',
    masterId: 13710,
  },
  {
    type: 'cityName',
    value: 'MAKANSAR, GUJARAT',
    masterId: 20810,
  },
  {
    type: 'cityName',
    value: 'MUSRA, CHHATTISGARH',
    masterId: 13758,
  },
  {
    type: 'cityName',
    value: 'MULLURKARA, KERALA',
    masterId: 17943,
  },
  {
    type: 'cityName',
    value: 'MURADNAGAR, UTTAR PRADESH',
    masterId: 13738,
  },
  {
    type: 'cityName',
    value: 'MUDKHED, MAHARASHTRA',
    masterId: 13683,
  },
  {
    type: 'cityName',
    value: 'MOGRA, WEST BENGAL',
    masterId: 13613,
  },
  {
    type: 'cityName',
    value: 'MAHUGARHA, MADHYA PRADESH',
    masterId: 13268,
  },
  {
    type: 'cityName',
    value: 'MAHUGAON, ASSAM',
    masterId: 17886,
  },
  {
    type: 'cityName',
    value: 'MANUGURU, TELANGANA',
    masterId: 13470,
  },
  {
    type: 'cityName',
    value: 'DHARMPUR, UTTAR PRADESH',
    masterId: 16573,
  },
  {
    type: 'cityName',
    value: 'MUNUMAKA, ANDHRA PRADESH',
    masterId: 13733,
  },
  {
    type: 'cityName',
    value: 'CHOMBALA, KERALA',
    masterId: 17931,
  },
  {
    type: 'cityName',
    value: 'MULKI, KARNATAKA',
    masterId: 13708,
  },
  {
    type: 'cityName',
    value: 'MANGAPATNAM, ANDHRA PRADESH',
    masterId: 13418,
  },
  {
    type: 'cityName',
    value: 'MASANGAON, MADHYA PRADESH',
    masterId: 17809,
  },
  {
    type: 'cityName',
    value: 'MUDHIPAR, CHHATTISGARH',
    masterId: 13678,
  },
  {
    type: 'cityName',
    value: 'MUPA, ASSAM',
    masterId: 13734,
  },
  {
    type: 'cityName',
    value: 'MARUDUR, TAMIL NADU',
    masterId: 17037,
  },
  {
    type: 'cityName',
    value: 'MANKAPUR, UTTAR PRADESH',
    masterId: 13441,
  },
  {
    type: 'cityName',
    value: 'MURI, JHARKHAND',
    masterId: 13745,
  },
  {
    type: 'cityName',
    value: 'MANKUNDU, UTTAR PRADESH',
    masterId: 21002,
  },
  {
    type: 'cityName',
    value: 'MAHUAWA KHURD, UTTAR PRADESH',
    masterId: 16425,
  },
  {
    type: 'cityName',
    value: 'MATHURAPUR, JHARKHAND',
    masterId: 13516,
  },
  {
    type: 'cityName',
    value: 'MUGAIYUR, TAMIL NADU',
    masterId: 16924,
  },
  {
    type: 'cityName',
    value: 'MOHIUDDINPUR, UTTAR PRADESH',
    masterId: 16398,
  },
  {
    type: 'cityName',
    value: 'MAYILADUTHURAI, TAMIL NADU',
    masterId: 13537,
  },
  {
    type: 'cityName',
    value: 'MALAKA VEMALA, ANDHRA PRADESH',
    masterId: 19022,
  },
  {
    type: 'cityName',
    value: 'MAVINAKERE, KARNATAKA ',
    masterId: 17998,
  },
  {
    type: 'cityName',
    value: 'MULVAD, KARNATAKA',
    masterId: 13712,
  },
  {
    type: 'cityName',
    value: 'MUNDHEWADI, MAHARASHTRA',
    masterId: 13720,
  },
  {
    type: 'cityName',
    value: 'MANABAR, ORISSA',
    masterId: 13350,
  },
  {
    type: 'cityName',
    value: 'BALIPUJARIPUT, ORISSA',
    masterId: 10431,
  },
  {
    type: 'cityName',
    value: 'MANTATTI, ANDHRA PRADESH',
    masterId: 13465,
  },
  {
    type: 'cityName',
    value: 'MORBI, GUJARAT',
    masterId: 13644,
  },
  {
    type: 'cityName',
    value: 'MAVLI, RAJASTHAN',
    masterId: 13534,
  },
  {
    type: 'cityName',
    value: 'MAHAWAN KHOR, UTTAR PRADESH',
    masterId: 16432,
  },
  {
    type: 'cityName',
    value: 'MALAVLI, MAHARASHTRA',
    masterId: 17623,
  },
  {
    type: 'cityName',
    value: 'MAVELIKKARA, KERALA',
    masterId: 13531,
  },
  {
    type: 'cityName',
    value: 'THOOTHUKUDI, TAMIL NADU',
    masterId: 15534,
  },
  {
    type: 'cityName',
    value: 'MANWATH, MAHARASHTRA',
    masterId: 13473,
  },
  {
    type: 'cityName',
    value: 'MOKASA KALAVAPUDI, ANDHRA PRADESH',
    masterId: 19021,
  },
  {
    type: 'cityName',
    value: 'VELIPPALAYAM, TAMIL NADU',
    masterId: 16846,
  },
  {
    type: 'cityName',
    value: 'MAIVADI, TAMIL NADU',
    masterId: 16945,
  },
  {
    type: 'cityName',
    value: 'MAHESHI, BIHAR',
    masterId: 18814,
  },
  {
    type: 'cityName',
    value: 'GANGUBUDI, ANDHRA PRADESH',
    masterId: 11641,
  },
  {
    type: 'cityName',
    value: 'MAIRWA, BIHAR',
    masterId: 13283,
  },
  {
    type: 'cityName',
    value: 'MANDAWA, MADHYA PRADESH',
    masterId: 17118,
  },
  {
    type: 'cityName',
    value: 'MOWAD, MAHARASHTRA ',
    masterId: 17611,
  },
  {
    type: 'cityName',
    value: 'CHANDER VIHAR, DELHI',
    masterId: 18582,
  },
  {
    type: 'cityName',
    value: 'MHASAVAD, MAHARASHTRA ',
    masterId: 17617,
  },
  {
    type: 'cityName',
    value: 'MEWANAWADA, UTTAR PRADESH',
    masterId: 16404,
  },
  {
    type: 'cityName',
    value: 'MAGARDAHA, UTTAR PRADESH',
    masterId: 16436,
  },
  {
    type: 'cityName',
    value: 'MINDALA, MAHARASHTRA',
    masterId: 17615,
  },
  {
    type: 'cityName',
    value: 'MALWAN, UTTAR PRADESH',
    masterId: 13345,
  },
  {
    type: 'cityName',
    value: 'KATARWAR, MADHYA PRADESH',
    masterId: 12590,
  },
  {
    type: 'cityName',
    value: 'MORDAD TANDA, MAHARASHTRA',
    masterId: 16049,
  },
  {
    type: 'cityName',
    value: 'MAHARANI PASCHIM, UTTAR PRADESH',
    masterId: 16433,
  },
  {
    type: 'cityName',
    value: 'MOTARI, ORISSA',
    masterId: 17455,
  },
  {
    type: 'cityName',
    value: 'KHARHARKUDA, CHHATTISGARH',
    masterId: 12722,
  },
  {
    type: 'cityName',
    value: 'LOHAWAT, RAJASTHAN',
    masterId: 13154,
  },
  {
    type: 'cityName',
    value: 'MAHRAWAL, UTTAR PRADESH',
    masterId: 21003,
  },
  {
    type: 'cityName',
    value: 'MAHWA, RAJASTHAN',
    masterId: 13275,
  },
  {
    type: 'cityName',
    value: 'MALLANWALA KHAS, PUNJAB',
    masterId: 13330,
  },
  {
    type: 'cityName',
    value: 'MAILARAM, ANDHRA PRADESH',
    masterId: 13280,
  },
  {
    type: 'cityName',
    value: 'MAHISHADAHARI, WEST BENGAL',
    masterId: 16113,
  },
  {
    type: 'cityName',
    value: 'MARAUDA, CHHATTISGARH',
    masterId: 13482,
  },
  {
    type: 'cityName',
    value: 'MAKHU, PUNJAB',
    masterId: 13291,
  },
  {
    type: 'cityName',
    value: 'MANGURJAN, BIHAR ',
    masterId: 18696,
  },
  {
    type: 'cityName',
    value: 'MANDRAK, UTTAR PRADESH',
    masterId: 13402,
  },
  {
    type: 'cityName',
    value: 'MOKHOLI, RAJASTHAN',
    masterId: 13626,
  },
  {
    type: 'cityName',
    value: 'MEENATCHIPURAM, TAMIL NADU ',
    masterId: 16933,
  },
  {
    type: 'cityName',
    value: 'MARIANI, ASSAM',
    masterId: 13489,
  },
  {
    type: 'cityName',
    value: 'MORTHALA, RAJASTHAN',
    masterId: 18538,
  },
  {
    type: 'cityName',
    value: 'MALUPOTA, PUNJAB',
    masterId: 17318,
  },
  {
    type: 'cityName',
    value: 'MAHUR, ASSAM',
    masterId: 13273,
  },
  {
    type: 'cityName',
    value: 'MOHASA, MADHYA PRADESH',
    masterId: 17803,
  },
  {
    type: 'cityName',
    value: 'MALAKPET, ANDHRA PRADESH',
    masterId: 13301,
  },
  {
    type: 'cityName',
    value: 'MAHADEVSAL, JHARKHAND',
    masterId: 20859,
  },
  {
    type: 'cityName',
    value: 'MAHUARIYA, UTTAR PRADESH',
    masterId: 16426,
  },
  {
    type: 'cityName',
    value: 'MOHDARA, MAHARASHTRA ',
    masterId: 17613,
  },
  {
    type: 'cityName',
    value: 'MALLIYAM, TAMIL NADU',
    masterId: 16944,
  },
  {
    type: 'cityName',
    value: 'MANDYA, KARNATAKA',
    masterId: 13408,
  },
  {
    type: 'cityName',
    value: 'MANDERDISA, ASSAM',
    masterId: 13390,
  },
  {
    type: 'cityName',
    value: 'MANDHALI, PUNJAB ',
    masterId: 17317,
  },
  {
    type: 'cityName',
    value: 'KARJAN, GUJARAT',
    masterId: 12554,
  },
  {
    type: 'cityName',
    value: 'MAYURHAT, WEST BENGAL',
    masterId: 21143,
  },
  {
    type: 'cityName',
    value: 'MAHIJI, MAHARASHTRA',
    masterId: 17627,
  },
  {
    type: 'cityName',
    value: 'MAYAKONDA, KARNATAKA',
    masterId: 13536,
  },
  {
    type: 'cityName',
    value: 'YAPADINNE, ANDHRA PRADESH',
    masterId: 15976,
  },
  {
    type: 'cityName',
    value: 'MEMARI, WEST BENGAL',
    masterId: 16108,
  },
  {
    type: 'cityName',
    value: 'MORIDHAL GHAT, WEST BENGAL',
    masterId: 18881,
  },
  {
    type: 'cityName',
    value: 'MUNDIYAMPAKKAM, TAMIL NADU',
    masterId: 16922,
  },
  {
    type: 'cityName',
    value: 'MAIHAR, MADHYA PRADESH',
    masterId: 13277,
  },
  {
    type: 'cityName',
    value: 'MAYANUR, TAMIL NADU',
    masterId: 16934,
  },
  {
    type: 'cityName',
    value: 'METYAL SOHAR, WEST BENGAL',
    masterId: 13579,
  },
  {
    type: 'cityName',
    value: 'MAYYANAD, KERALA',
    masterId: 13539,
  },
  {
    type: 'cityName',
    value: 'MEZENGA, ASSAM',
    masterId: 18889,
  },
  {
    type: 'cityName',
    value: 'MAHULI, MAHARASHTRA ',
    masterId: 17625,
  },
  {
    type: 'cityName',
    value: 'MIRZACHEUKI, JHARKHAND',
    masterId: 13597,
  },
  {
    type: 'cityName',
    value: 'MANJURGARHI, UTTAR PRADESH',
    masterId: 16412,
  },
  {
    type: 'cityName',
    value: 'MAUHARI, MADHYA PRADESH',
    masterId: 13524,
  },
  {
    type: 'cityName',
    value: 'MAJHAULI, MADHYA PRADESH',
    masterId: 18700,
  },
  {
    type: 'cityName',
    value: 'MIRZAPALLI, ANDHRA PRADESH',
    masterId: 13598,
  },
  {
    type: 'cityName',
    value: 'MUZZAMPUR NRYN, UTTAR PRADESH',
    masterId: 13769,
  },
  {
    type: 'cityName',
    value: 'MAZHOM, JAMMU AND KASHMIR',
    masterId: 20836,
  },
  {
    type: 'cityName',
    value: 'MAJGAON, ASSAM',
    masterId: 18890,
  },
  {
    type: 'cityName',
    value: 'MURTIZAPUR, MAHARASHTRA',
    masterId: 13753,
  },
  {
    type: 'cityName',
    value: 'JONAI, ASSAM',
    masterId: 12282,
  },
  {
    type: 'cityName',
    value: 'MARANDAHALLI, TAMIL NADU',
    masterId: 16936,
  },
  {
    type: 'cityName',
    value: 'MARALAHALLI, KARNATAKA',
    masterId: 20863,
  },
  {
    type: 'cityName',
    value: 'MATATILA, MADHYA PRADESH',
    masterId: 17808,
  },
  {
    type: 'cityName',
    value: 'MACHAPUR, ORISSA',
    masterId: 16810,
  },
  {
    type: 'cityName',
    value: 'JAJPUR, ORISSA',
    masterId: 17489,
  },
  {
    type: 'cityName',
    value: 'NAGBHIR, MAHARASHTRA',
    masterId: 13803,
  },
  {
    type: 'cityName',
    value: 'NAGBHIR JUNCTION, MAHARASHTRA',
    masterId: 17608,
  },
  {
    type: 'cityName',
    value: 'NAWA, RAJASTHAN',
    masterId: 13934,
  },
  {
    type: 'cityName',
    value: 'NAGDA, MADHYA PRADESH',
    masterId: 13804,
  },
  {
    type: 'cityName',
    value: 'NAGARAGALI, KARNATAKA',
    masterId: 17995,
  },
  {
    type: 'cityName',
    value: 'NANGI, WEST BENGAL',
    masterId: 21251,
  },
  {
    type: 'cityName',
    value: 'NAKSALBARI, WEST BENGAL',
    masterId: 16050,
  },
  {
    type: 'cityName',
    value: 'NAIK DIH, UTTAR PRADESH',
    masterId: 16394,
  },
  {
    type: 'cityName',
    value: 'ALPUR, WEST BENGAL',
    masterId: 16231,
  },
  {
    type: 'cityName',
    value: 'NAMRUP, ASSAM',
    masterId: 13851,
  },
  {
    type: 'cityName',
    value: 'NANDGAON, MAHARASHTRA',
    masterId: 13859,
  },
  {
    type: 'cityName',
    value: 'NANA, RAJASTHAN',
    masterId: 13853,
  },
  {
    type: 'cityName',
    value: 'NANDIKOOR, KARNATAKA',
    masterId: 18085,
  },
  {
    type: 'cityName',
    value: 'NARANPUR, ORISSA',
    masterId: 13884,
  },
  {
    type: 'cityName',
    value: 'NARA, HARYANA',
    masterId: 18282,
  },
  {
    type: 'cityName',
    value: 'NASRALA, PUNJAB',
    masterId: 17410,
  },
  {
    type: 'cityName',
    value: 'GOBBURUPALEM, ANDHRA PRADESH',
    masterId: 11729,
  },
  {
    type: 'cityName',
    value: 'NADAPURAM, KERALA',
    masterId: 13784,
  },
  {
    type: 'cityName',
    value: 'BADNERA, MAHARASHTRA',
    masterId: 10353,
  },
  {
    type: 'cityName',
    value: 'NAWANDGI, ANDHRA PRADESH',
    masterId: 13939,
  },
  {
    type: 'cityName',
    value: 'NAWAN, RAJASTHAN',
    masterId: 13938,
  },
  {
    type: 'cityName',
    value: 'NAZIRPUR, BIHAR',
    masterId: 13951,
  },
  {
    type: 'cityName',
    value: 'NIMBHORA, MAHARASHTRA',
    masterId: 14015,
  },
  {
    type: 'cityName',
    value: 'NABHA, PUNJAB',
    masterId: 13781,
  },
  {
    type: 'cityName',
    value: 'NABAGRAM, WEST BENGAL',
    masterId: 21213,
  },
  {
    type: 'cityName',
    value: 'NAJIBABAD, UTTAR PRADESH',
    masterId: 13827,
  },
  {
    type: 'cityName',
    value: 'NEW BARRACKPORE, WEST BENGAL',
    masterId: 21150,
  },
  {
    type: 'cityName',
    value: 'NABINAGAR, BIHAR',
    masterId: 13782,
  },
  {
    type: 'cityName',
    value: 'NIMBAHERA, RAJASTHAN',
    masterId: 14012,
  },
  {
    type: 'cityName',
    value: 'NADBAI, RAJASTHAN',
    masterId: 13786,
  },
  {
    type: 'cityName',
    value: 'NUNGAMBAKKAM, WEST BENGAL',
    masterId: 21129,
  },
  {
    type: 'cityName',
    value: 'NABA GRAM KANKURHATI, WEST BENGAL',
    masterId: 16105,
  },
  {
    type: 'cityName',
    value: 'NIMBAL, KARNATAKA',
    masterId: 14014,
  },
  {
    type: 'cityName',
    value: 'NAVABPALEM, ANDHRA PRADESH',
    masterId: 13923,
  },
  {
    type: 'cityName',
    value: 'NIBHAPUR, UTTAR PRADESH',
    masterId: 16387,
  },
  {
    type: 'cityName',
    value: 'BAIRAGACHI, WEST BENGAL',
    masterId: 10401,
  },
  {
    type: 'cityName',
    value: 'BONGAIGAON, ASSAM',
    masterId: 10886,
  },
  {
    type: 'cityName',
    value: 'NABA RAYNAGAR HALT, WEST BENGAL',
    masterId: 21196,
  },
  {
    type: 'cityName',
    value: 'NEW BENESWAR, WEST BENGAL',
    masterId: 16101,
  },
  {
    type: 'cityName',
    value: 'NAYABAGIRTHIPUR, ORISSA',
    masterId: 17451,
  },
  {
    type: 'cityName',
    value: 'NARASAMBUDI, KARNATAKA',
    masterId: 19016,
  },
  {
    type: 'cityName',
    value: 'NIBKARORI, UTTAR PRADESH',
    masterId: 16386,
  },
  {
    type: 'cityName',
    value: 'NIJBARGANG, ASSAM',
    masterId: 18876,
  },
  {
    type: 'cityName',
    value: 'NIZCHATIA, ASSAM',
    masterId: 18875,
  },
  {
    type: 'cityName',
    value: 'NEW COOCH BEHAR, WEST BENGAL',
    masterId: 13981,
  },
  {
    type: 'cityName',
    value: 'NEW CHANGRABANDHA, WEST BENGAL',
    masterId: 21107,
  },
  {
    type: 'cityName',
    value: 'NLACHRVURU, ANDHRA PRADESH',
    masterId: 19080,
  },
  {
    type: 'cityName',
    value: 'NAKACHARI, ASSAM',
    masterId: 13828,
  },
  {
    type: 'cityName',
    value: 'NAGERCOIL, TAMIL NADU',
    masterId: 13805,
  },
  {
    type: 'cityName',
    value: 'NACHINDA PH, WEST BENGAL',
    masterId: 21092,
  },
  {
    type: 'cityName',
    value: 'NISCHINDAPUR, WEST BENGAL',
    masterId: 21256,
  },
  {
    type: 'cityName',
    value: 'NALLACHERUVU, ANDHRA PRADESH',
    masterId: 13842,
  },
  {
    type: 'cityName',
    value: 'NADIAD, GUJARAT',
    masterId: 13787,
  },
  {
    type: 'cityName',
    value: 'NABADWIP, WEST BENGAL',
    masterId: 13780,
  },
  {
    type: 'cityName',
    value: 'NANDURBAR, MAHARASHTRA',
    masterId: 13866,
  },
  {
    type: 'cityName',
    value: 'NIDADAVOLU, ANDHRA PRADESH',
    masterId: 13992,
  },
  {
    type: 'cityName',
    value: 'NANDRE, MAHARASHTRA',
    masterId: 17729,
  },
  {
    type: 'cityName',
    value: 'NANDAHGANJA, WEST BENGAL',
    masterId: 21083,
  },
  {
    type: 'cityName',
    value: 'NINDHAR BENAR, RAJASTHAN',
    masterId: 17103,
  },
  {
    type: 'cityName',
    value: 'ISOPUR, UTTAR PRADESH',
    masterId: 12088,
  },
  {
    type: 'cityName',
    value: 'NAKHAS, UTTAR PRADESH',
    masterId: 19069,
  },
  {
    type: 'cityName',
    value: 'DACHEPALLE, ANDHRA PRADESH',
    masterId: 11186,
  },
  {
    type: 'cityName',
    value: 'NANDAKUMAR P.H., WEST BENGAL',
    masterId: 21095,
  },
  {
    type: 'cityName',
    value: 'NANDYAL, ANDHRA PRADESH',
    masterId: 13867,
  },
  {
    type: 'cityName',
    value: 'NEW DELHI, DELHI',
    masterId: 13982,
  },
  {
    type: 'cityName',
    value: 'NIDAMANURU, ANDHRA PRADESH',
    masterId: 19014,
  },
  {
    type: 'cityName',
    value: 'NARDANA, MAHARASHTRA',
    masterId: 13892,
  },
  {
    type: 'cityName',
    value: 'NANDAPUR, MAHARASHTRA',
    masterId: 17453,
  },
  {
    type: 'cityName',
    value: 'NUDURUPADU, ANDHRA PRADESH',
    masterId: 14057,
  },
  {
    type: 'cityName',
    value: 'NANGAL DEGROTA, HARYANA',
    masterId: 18285,
  },
  {
    type: 'cityName',
    value: 'NATHDWARA, RAJASTHAN',
    masterId: 13914,
  },
  {
    type: 'cityName',
    value: 'NADAUL, BIHAR',
    masterId: 13785,
  },
  {
    type: 'cityName',
    value: 'NIDUVANDA, KARNATAKA',
    masterId: 17989,
  },
  {
    type: 'cityName',
    value: 'NADWAN, BIHAR',
    masterId: 13790,
  },
  {
    type: 'cityName',
    value: 'NANDI, KARNATAKA',
    masterId: 17994,
  },
  {
    type: 'cityName',
    value: 'TIKKAVARAM, ANDHRA PRADESH',
    masterId: 15553,
  },
  {
    type: 'cityName',
    value: 'NANDED, MAHARASHTRA',
    masterId: 13858,
  },
  {
    type: 'cityName',
    value: 'NEMAM, KERALA',
    masterId: 17033,
  },
  {
    type: 'cityName',
    value: 'NEEMA, BIHAR',
    masterId: 18682,
  },
  {
    type: 'cityName',
    value: 'NEORA, BIHAR',
    masterId: 13967,
  },
  {
    type: 'cityName',
    value: 'NENPUR, GUJARAT',
    masterId: 13966,
  },
  {
    type: 'cityName',
    value: 'NER, BIHAR',
    masterId: 18681,
  },
  {
    type: 'cityName',
    value: 'NERI, UTTAR PRADESH',
    masterId: 19173,
  },
  {
    type: 'cityName',
    value: 'NIVARI, UTTAR PRADESH',
    masterId: 14037,
  },
  {
    type: 'cityName',
    value: 'FARAKKA, WEST BENGAL',
    masterId: 11560,
  },
  {
    type: 'cityName',
    value: 'NINGALA, GUJARAT',
    masterId: 14021,
  },
  {
    type: 'cityName',
    value: 'NAGAON, ASSAM',
    masterId: 13792,
  },
  {
    type: 'cityName',
    value: 'NAWABGANJ, UTTAR PRADESH',
    masterId: 13935,
  },
  {
    type: 'cityName',
    value: 'NAGARDEVLA, MAHARASHTRA',
    masterId: 17609,
  },
  {
    type: 'cityName',
    value: 'NAGRA DHAM PH, MAHARASHTRA',
    masterId: 20900,
  },
  {
    type: 'cityName',
    value: 'NAGAR, CHHATTISGARH',
    masterId: 13794,
  },
  {
    type: 'cityName',
    value: 'NAGARNABI, JHARKHAND',
    masterId: 16103,
  },
  {
    type: 'cityName',
    value: 'NAGINA, UTTAR PRADESH',
    masterId: 13807,
  },
  {
    type: 'cityName',
    value: 'NAGESHWADI, MAHARASHTRA',
    masterId: 17607,
  },
  {
    type: 'cityName',
    value: 'NAGAL, UTTAR PRADESH',
    masterId: 19181,
  },
  {
    type: 'cityName',
    value: 'NAGLATULA, RAJASTHAN',
    masterId: 13809,
  },
  {
    type: 'cityName',
    value: 'NAGASAMUDRAM, ANDHRA PRADESH',
    masterId: 19017,
  },
  {
    type: 'cityName',
    value: 'NEW GUMANDEV, GUJARAT ',
    masterId: 18421,
  },
  {
    type: 'cityName',
    value: 'NEW GARH MADHOPUR, ORISSA',
    masterId: 17450,
  },
  {
    type: 'cityName',
    value: 'NAGAUR, RAJASTHAN',
    masterId: 13801,
  },
  {
    type: 'cityName',
    value: 'ANNIGERI, KARNATAKA',
    masterId: 10219,
  },
  {
    type: 'cityName',
    value: 'NILGIRI ROAD, ORISSA',
    masterId: 16891,
  },
  {
    type: 'cityName',
    value: 'GURAVWADI, MAHARASHTRA',
    masterId: 11854,
  },
  {
    type: 'cityName',
    value: 'NAGAPATTINAM, TAMIL NADU',
    masterId: 13793,
  },
  {
    type: 'cityName',
    value: 'NEW GITALDAHA, WEST BENGAL',
    masterId: 16099,
  },
  {
    type: 'cityName',
    value: 'NAGOTHANE, MAHARASHTRA',
    masterId: 13811,
  },
  {
    type: 'cityName',
    value: 'NAUGANWAN, MADHYA PRADESH',
    masterId: 20877,
  },
  {
    type: 'cityName',
    value: 'NOGANWAN, PUNJAB',
    masterId: 20929,
  },
  {
    type: 'cityName',
    value: 'NATH GANJ, BIHAR',
    masterId: 20749,
  },
  {
    type: 'cityName',
    value: 'NAGJHARI, MAHARASHTRA',
    masterId: 17454,
  },
  {
    type: 'cityName',
    value: 'NAIHATI, WEST BENGAL',
    masterId: 13823,
  },
  {
    type: 'cityName',
    value: 'NOH BACHHAMDI, RAJASTHAN',
    masterId: 17102,
  },
  {
    type: 'cityName',
    value: 'NIHASTA, UTTAR PRADESH',
    masterId: 16384,
  },
  {
    type: 'cityName',
    value: 'JAGDISHPUR, UTTAR PRADESH',
    masterId: 12118,
  },
  {
    type: 'cityName',
    value: 'NAHARKATIA, ASSAM',
    masterId: 13818,
  },
  {
    type: 'cityName',
    value: 'HAFLONG, ASSAM',
    masterId: 11886,
  },
  {
    type: 'cityName',
    value: 'NAHARLAGUN, ANDAMAN AND NICOBAR ISLANDS',
    masterId: 13819,
  },
  {
    type: 'cityName',
    value: 'NANDOL DEHEGAM, GUJARAT',
    masterId: 18422,
  },
  {
    type: 'cityName',
    value: 'NIGOHA, UTTAR PRADESH',
    masterId: 14001,
  },
  {
    type: 'cityName',
    value: 'NOHAR, RAJASTHAN',
    masterId: 14047,
  },
  {
    type: 'cityName',
    value: 'NALHATI, WEST BENGAL',
    masterId: 13840,
  },
  {
    type: 'cityName',
    value: 'NARTHAR, UTTAR PRADESH',
    masterId: 16389,
  },
  {
    type: 'cityName',
    value: 'SHYADANAHALLI, KARNATAKA',
    masterId: 15134,
  },
  {
    type: 'cityName',
    value: 'NAYDONGRI, MAHARASHTRA',
    masterId: 17605,
  },
  {
    type: 'cityName',
    value: 'JANJGIR, CHHATTISGARH',
    masterId: 12192,
  },
  {
    type: 'cityName',
    value: 'NIDUR, TAMIL NADU',
    masterId: 16916,
  },
  {
    type: 'cityName',
    value: 'NIDHI, MAHARASHTRA',
    masterId: 13996,
  },
  {
    type: 'cityName',
    value: 'NILAJE, MAHARASHTRA',
    masterId: 14004,
  },
  {
    type: 'cityName',
    value: 'NILAMBUR, KERALA',
    masterId: 14005,
  },
  {
    type: 'cityName',
    value: 'DAFAHAT, WEST BENGAL',
    masterId: 11189,
  },
  {
    type: 'cityName',
    value: 'NIMDIH, JHARKHAND',
    masterId: 14017,
  },
  {
    type: 'cityName',
    value: 'NEEMRANA, ORISSA',
    masterId: 17256,
  },
  {
    type: 'cityName',
    value: 'NIZAMPUR, RAJASTHAN',
    masterId: 17604,
  },
  {
    type: 'cityName',
    value: 'NIGAURA, MADHYA PRADESH',
    masterId: 14000,
  },
  {
    type: 'cityName',
    value: 'NIRA, MAHARASHTRA',
    masterId: 14028,
  },
  {
    type: 'cityName',
    value: 'NAIKOT, UTTAR PRADESH',
    masterId: 16393,
  },
  {
    type: 'cityName',
    value: 'NABIPUR, GUJARAT',
    masterId: 13783,
  },
  {
    type: 'cityName',
    value: 'VESURLE, MAHARASHTRA',
    masterId: 15858,
  },
  {
    type: 'cityName',
    value: 'NAGJUA, JHARKHAND',
    masterId: 18142,
  },
  {
    type: 'cityName',
    value: 'NIJBARI, WEST BENGAL',
    masterId: 16098,
  },
  {
    type: 'cityName',
    value: 'NAOJAN, ASSAM',
    masterId: 18878,
  },
  {
    type: 'cityName',
    value: 'SILIGURI, WEST BENGAL',
    masterId: 15166,
  },
  {
    type: 'cityName',
    value: 'NASHIK, MAHARASHTRA',
    masterId: 13911,
  },
  {
    type: 'cityName',
    value: 'NAGRAKATA, WEST BENGAL',
    masterId: 16102,
  },
  {
    type: 'cityName',
    value: 'NARKATIA BAZAR, BIHAR',
    masterId: 18684,
  },
  {
    type: 'cityName',
    value: 'NEKONDA, ANDHRA PRADESH',
    masterId: 13960,
  },
  {
    type: 'cityName',
    value: 'NAKKANADODDI, ANDHRA PRADESH',
    masterId: 13831,
  },
  {
    type: 'cityName',
    value: 'NARKATIAGANJ, BIHAR',
    masterId: 13896,
  },
  {
    type: 'cityName',
    value: 'NATHUKHERI, MADHYA PRADESH',
    masterId: 17882,
  },
  {
    type: 'cityName',
    value: 'NAIKHEDI, MADHYA PRADESH',
    masterId: 13824,
  },
  {
    type: 'cityName',
    value: 'NARIKKUDI, TAMIL NADU',
    masterId: 20991,
  },
  {
    type: 'cityName',
    value: 'NEOLI KALAN, HARYANA',
    masterId: 18279,
  },
  {
    type: 'cityName',
    value: 'NIRAKARPUR, ORISSA',
    masterId: 14029,
  },
  {
    type: 'cityName',
    value: 'NIMAR KHERI, MADHYA PRADESH',
    masterId: 14011,
  },
  {
    type: 'cityName',
    value: 'DEHURIPADA, ORISSA',
    masterId: 11276,
  },
  {
    type: 'cityName',
    value: 'NANCHERLA, ANDHRA PRADESH',
    masterId: 16806,
  },
  {
    type: 'cityName',
    value: 'NILAMBAZAR, ASSAM',
    masterId: 18963,
  },
  {
    type: 'cityName',
    value: 'NALANDA, BIHAR',
    masterId: 13835,
  },
  {
    type: 'cityName',
    value: 'NALGONDA, ANDHRA PRADESH',
    masterId: 13838,
  },
  {
    type: 'cityName',
    value: 'NANGAL, PUNJAB',
    masterId: 13868,
  },
  {
    type: 'cityName',
    value: 'NAULTHA, HARYANA ',
    masterId: 18280,
  },
  {
    type: 'cityName',
    value: 'NAMLI, MADHYA PRADESH',
    masterId: 13850,
  },
  {
    type: 'cityName',
    value: 'NILOKHERI, HARYANA',
    masterId: 14009,
  },
  {
    type: 'cityName',
    value: 'NALKATA, TRIPURA',
    masterId: 16787,
  },
  {
    type: 'cityName',
    value: 'NAILALUNG, ASSAM',
    masterId: 18879,
  },
  {
    type: 'cityName',
    value: 'NULEMURU, KARNATAKA',
    masterId: 17987,
  },
  {
    type: 'cityName',
    value: 'NORTH LAKHIMPUR, ASSAM',
    masterId: 14052,
  },
  {
    type: 'cityName',
    value: 'NALLAPADU, ANDHRA PRADESH',
    masterId: 13844,
  },
  {
    type: 'cityName',
    value: 'NANGAL PATHANI, HARYANA',
    masterId: 18283,
  },
  {
    type: 'cityName',
    value: 'NELLORE, ANDHRA PRADESH',
    masterId: 13963,
  },
  {
    type: 'cityName',
    value: 'NIYALISHPARA, WEST BENGAL',
    masterId: 16095,
  },
  {
    type: 'cityName',
    value: 'NALBARI, ASSAM',
    masterId: 13836,
  },
  {
    type: 'cityName',
    value: 'NAIMISHARANYA, UTTAR PRADESH',
    masterId: 16392,
  },
  {
    type: 'cityName',
    value: 'NIRMALI, BIHAR',
    masterId: 18680,
  },
  {
    type: 'cityName',
    value: 'MAYURBHANJ, ORISSA',
    masterId: 16208,
  },
  {
    type: 'cityName',
    value: 'KHERLA, RAJASTHAN',
    masterId: 12747,
  },
  {
    type: 'cityName',
    value: 'NEW MORINDA, PUNJAB',
    masterId: 16051,
  },
  {
    type: 'cityName',
    value: 'NIMO, WEST BENGAL',
    masterId: 21071,
  },
  {
    type: 'cityName',
    value: 'NIMIAGHAT, JHARKHAND',
    masterId: 20843,
  },
  {
    type: 'cityName',
    value: 'NELAMANGALA, KARNATAKA',
    masterId: 18084,
  },
  {
    type: 'cityName',
    value: 'NIMSHIRGAON, MAHARASHTRA',
    masterId: 14019,
  },
  {
    type: 'cityName',
    value: 'NUMALIGARH, ASSAM',
    masterId: 14061,
  },
  {
    type: 'cityName',
    value: 'NEEMUCH, MADHYA PRADESH',
    masterId: 13958,
  },
  {
    type: 'cityName',
    value: 'NIDAMANGALAM, TAMIL NADU',
    masterId: 13993,
  },
  {
    type: 'cityName',
    value: 'NEEM KA THANA, RAJASTHAN',
    masterId: 13957,
  },
  {
    type: 'cityName',
    value: 'NAMKHANA, WEST BENGAL',
    masterId: 21259,
  },
  {
    type: 'cityName',
    value: 'NAMAKKAL, TAMIL NADU',
    masterId: 13847,
  },
  {
    type: 'cityName',
    value: 'NELLIMARIA, ANDHRA PRADESH',
    masterId: 19078,
  },
  {
    type: 'cityName',
    value: 'NEMAKALLU, ANDHRA PRADESH',
    masterId: 19015,
  },
  {
    type: 'cityName',
    value: 'NEW MISAMARI, ASSAM',
    masterId: 13984,
  },
  {
    type: 'cityName',
    value: 'NAMANASAMUDHRAM, TAMIL NADU',
    masterId: 17036,
  },
  {
    type: 'cityName',
    value: 'MORANKARI, ASSAM',
    masterId: 13642,
  },
  {
    type: 'cityName',
    value: 'MAYNAGURI, WEST BENGAL',
    masterId: 13538,
  },
  {
    type: 'cityName',
    value: 'NEW MAL, WEST BENGAL',
    masterId: 13983,
  },
  {
    type: 'cityName',
    value: 'NANDURA, MAHARASHTRA',
    masterId: 13865,
  },
  {
    type: 'cityName',
    value: 'NAUGACHIA, BIHAR',
    masterId: 13917,
  },
  {
    type: 'cityName',
    value: 'NONERA, MADHYA PRADESH',
    masterId: 14050,
  },
  {
    type: 'cityName',
    value: 'NAYA NANGAL, PUNJAB',
    masterId: 13942,
  },
  {
    type: 'cityName',
    value: 'NANAKSAR, PUNJAB',
    masterId: 17310,
  },
  {
    type: 'cityName',
    value: 'NARNAUL, HARYANA',
    masterId: 13898,
  },
  {
    type: 'cityName',
    value: 'NANNILAM, TAMIL NADU',
    masterId: 16919,
  },
  {
    type: 'cityName',
    value: 'NANGUNERI, TAMIL NADU',
    masterId: 13870,
  },
  {
    type: 'cityName',
    value: 'NANDANI LAGUNIA, BIHAR',
    masterId: 18687,
  },
  {
    type: 'cityName',
    value: 'NANPARA, UTTAR PRADESH',
    masterId: 13874,
  },
  {
    type: 'cityName',
    value: 'NONAPAR, UTTAR PRADESH',
    masterId: 16382,
  },
  {
    type: 'cityName',
    value: 'NARAYANPUR, BIHAR',
    masterId: 13890,
  },
  {
    type: 'cityName',
    value: 'NANGAL MUNDI, HARYANA',
    masterId: 18284,
  },
  {
    type: 'cityName',
    value: 'TATWARA, RAJASTHAN',
    masterId: 15457,
  },
  {
    type: 'cityName',
    value: 'NANAUTA, UTTAR PRADESH',
    masterId: 16390,
  },
  {
    type: 'cityName',
    value: 'NOBANDA, WEST BENGAL',
    masterId: 21127,
  },
  {
    type: 'cityName',
    value: 'NIGOHI, UTTAR PRADESH',
    masterId: 16385,
  },
  {
    type: 'cityName',
    value: 'BADORA, MADHYA PRADESH',
    masterId: 10356,
  },
  {
    type: 'cityName',
    value: 'NOKHA, RAJASTHAN',
    masterId: 14049,
  },
  {
    type: 'cityName',
    value: 'NIYOL, GUJARAT',
    masterId: 14040,
  },
  {
    type: 'cityName',
    value: 'NOLBARI, MEGHALAYA',
    masterId: 19132,
  },
  {
    type: 'cityName',
    value: 'NOLI, UTTAR PRADESH',
    masterId: 17101,
  },
  {
    type: 'cityName',
    value: 'NOAMUNDI, JHARKHAND',
    masterId: 14046,
  },
  {
    type: 'cityName',
    value: 'SBI BUS STOP, BIHAR',
    masterId: 17586,
  },
  {
    type: 'cityName',
    value: 'NAWAPARA ROAD, CHHATTISGARH',
    masterId: 13940,
  },
  {
    type: 'cityName',
    value: 'NURPURA, RAJASTHAN',
    masterId: 18241,
  },
  {
    type: 'cityName',
    value: 'NIPANIA, CHHATTISGARH',
    masterId: 14025,
  },
  {
    type: 'cityName',
    value: 'NICHITPUR, JHARKHAND',
    masterId: 18215,
  },
  {
    type: 'cityName',
    value: 'PANAKUDI, TAMIL NADU',
    masterId: 14184,
  },
  {
    type: 'cityName',
    value: 'NANDIYAMPAKKAM, TAMIL NADU',
    masterId: 20987,
  },
  {
    type: 'cityName',
    value: 'NAGULAPALLI, ANDHRA PRADESH',
    masterId: 13815,
  },
  {
    type: 'cityName',
    value: 'NELLIKKUPPAM, TAMIL NADU',
    masterId: 17034,
  },
  {
    type: 'cityName',
    value: 'NARAYAN PAKURIA MURA, WEST BENGAL',
    masterId: 21084,
  },
  {
    type: 'cityName',
    value: 'NEPANAGAR, MADHYA PRADESH',
    masterId: 13968,
  },
  {
    type: 'cityName',
    value: 'NEPALGANJ, UTTAR PRADESH',
    masterId: 16388,
  },
  {
    type: 'cityName',
    value: 'NAGPUR, CHHATTISGARH',
    masterId: 13812,
  },
  {
    type: 'cityName',
    value: 'NAPASAR, RAJASTHAN',
    masterId: 13877,
  },
  {
    type: 'cityName',
    value: 'NARASINGAMPET, TAMIL NADU',
    masterId: 16918,
  },
  {
    type: 'cityName',
    value: 'NIMPURA TH YARD, WEST BENGAL',
    masterId: 16096,
  },
  {
    type: 'cityName',
    value: 'NADIAPUR, TRIPURA',
    masterId: 16104,
  },
  {
    type: 'cityName',
    value: 'NIPANI VADGAON, MAHARASHTRA',
    masterId: 14024,
  },
  {
    type: 'cityName',
    value: 'NARENDRAPUR, PUNJAB',
    masterId: 17452,
  },
  {
    type: 'cityName',
    value: 'NEW DOMOHANI, WEST BENGAL',
    masterId: 16100,
  },
  {
    type: 'cityName',
    value: 'NARAJMARTHAPUR, ORISSA',
    masterId: 13881,
  },
  {
    type: 'cityName',
    value: 'GITAKUNJ, MAHARASHTRA',
    masterId: 11725,
  },
  {
    type: 'cityName',
    value: 'NUNKHAR, UTTAR PRADESH',
    masterId: 16381,
  },
  {
    type: 'cityName',
    value: 'NARODA, GUJARAT',
    masterId: 18537,
  },
  {
    type: 'cityName',
    value: 'NAGIREDDIPALLI, ANDHRA PRADESH',
    masterId: 13808,
  },
  {
    type: 'cityName',
    value: 'NANDALUR, ANDHRA PRADESH',
    masterId: 13855,
  },
  {
    type: 'cityName',
    value: 'NERALEKATTE, KARNATAKA',
    masterId: 17991,
  },
  {
    type: 'cityName',
    value: 'ALARPUR, ORISSA',
    masterId: 10097,
  },
  {
    type: 'cityName',
    value: 'NARGANJO, BIHAR',
    masterId: 18686,
  },
  {
    type: 'cityName',
    value: 'LIMBODA, MADHYA PRADESH',
    masterId: 13142,
  },
  {
    type: 'cityName',
    value: 'NARAINA, RAJASTHAN',
    masterId: 13880,
  },
  {
    type: 'cityName',
    value: 'NARIMOGARU, KARNATAKA',
    masterId: 17992,
  },
  {
    type: 'cityName',
    value: 'NARAIKKINAR, TAMIL NADU',
    masterId: 13879,
  },
  {
    type: 'cityName',
    value: 'NARI KHETRI, RAJASTHAN',
    masterId: 19144,
  },
  {
    type: 'cityName',
    value: 'NARKOPI, JHARKHAND',
    masterId: 18216,
  },
  {
    type: 'cityName',
    value: 'NARKHED, MAHARASHTRA',
    masterId: 13897,
  },
  {
    type: 'cityName',
    value: 'NERAL, MAHARASHTRA',
    masterId: 13972,
  },
  {
    type: 'cityName',
    value: 'NORLA ROAD, ORISSA',
    masterId: 14051,
  },
  {
    type: 'cityName',
    value: 'KHOSLA, PUNJAB',
    masterId: 12767,
  },
  {
    type: 'cityName',
    value: 'NARHAN, BIHAR',
    masterId: 18810,
  },
  {
    type: 'cityName',
    value: 'NURNAGAR, UTTAR PRADESH',
    masterId: 16206,
  },
  {
    type: 'cityName',
    value: 'NAKODAR, PUNJAB',
    masterId: 13834,
  },
  {
    type: 'cityName',
    value: 'NARSIPATNAM, ANDHRA PRADESH',
    masterId: 13906,
  },
  {
    type: 'cityName',
    value: 'NARENDRAPUR HALT, WEST BENGAL',
    masterId: 21172,
  },
  {
    type: 'cityName',
    value: 'NAGARUR, ANDHRA PRADESH',
    masterId: 13800,
  },
  {
    type: 'cityName',
    value: 'MIRGANJ, UTTAR PRADESH',
    masterId: 13591,
  },
  {
    type: 'cityName',
    value: 'NEW RUNNISAIDPUR HAL, BIHAR',
    masterId: 20762,
  },
  {
    type: 'cityName',
    value: 'NARASIMHAPURA, ORISSA',
    masterId: 17993,
  },
  {
    type: 'cityName',
    value: 'NARASARAOPET, ANDHRA PRADESH',
    masterId: 13886,
  },
  {
    type: 'cityName',
    value: 'NARIYAR, BIHAR',
    masterId: 18685,
  },
  {
    type: 'cityName',
    value: 'NARWANA, HARYANA',
    masterId: 13909,
  },
  {
    type: 'cityName',
    value: 'NARWASI, RAJASTHAN',
    masterId: 17105,
  },
  {
    type: 'cityName',
    value: 'NOADAR DHAL, WEST BENGAL',
    masterId: 14045,
  },
  {
    type: 'cityName',
    value: 'BANDLAPALLE, ANDHRA PRADESH',
    masterId: 10474,
  },
  {
    type: 'cityName',
    value: 'NIPANIYA, MADHYA PRADESH',
    masterId: 14026,
  },
  {
    type: 'cityName',
    value: 'NISHANGARA, UTTAR PRADESH',
    masterId: 16383,
  },
  {
    type: 'cityName',
    value: 'NASIRABAD, RAJASTHAN',
    masterId: 13913,
  },
  {
    type: 'cityName',
    value: 'NIKURSINI, WEST BENGAL',
    masterId: 16097,
  },
  {
    type: 'cityName',
    value: 'NAGARSUL, MAHARASHTRA',
    masterId: 13799,
  },
  {
    type: 'cityName',
    value: 'DOABA, PUNJAB',
    masterId: 17372,
  },
  {
    type: 'cityName',
    value: 'NISUI, UTTAR PRADESH',
    masterId: 14032,
  },
  {
    type: 'cityName',
    value: 'NPA SHVRAMPALLI, ANDHRA PRADESH',
    masterId: 14055,
  },
  {
    type: 'cityName',
    value: 'NARSIPURAM, ANDHRA PRADESH',
    masterId: 13907,
  },
  {
    type: 'cityName',
    value: 'NETRA, WEST BENGAL',
    masterId: 13979,
  },
  {
    type: 'cityName',
    value: 'KHARKHARI, UTTAR PRADESH',
    masterId: 16463,
  },
  {
    type: 'cityName',
    value: 'NARTHAMALAI, TAMIL NADU',
    masterId: 16917,
  },
  {
    type: 'cityName',
    value: 'NAR TOWN, GUJARAT',
    masterId: 20804,
  },
  {
    type: 'cityName',
    value: 'NITTUR, KARNATAKA',
    masterId: 17988,
  },
  {
    type: 'cityName',
    value: 'NEW TINSUKIA, ASSAM',
    masterId: 13985,
  },
  {
    type: 'cityName',
    value: 'NIGATPUR, UTTAR PRADESH',
    masterId: 19166,
  },
  {
    type: 'cityName',
    value: 'NAUTANWA, UTTAR PRADESH',
    masterId: 13922,
  },
  {
    type: 'cityName',
    value: 'NETAWAL, RAJASTHAN',
    masterId: 17104,
  },
  {
    type: 'cityName',
    value: 'NATHWANA, RAJASTHAN',
    masterId: 13915,
  },
  {
    type: 'cityName',
    value: 'NARSINGHPUR, MADHYA PRADESH',
    masterId: 13905,
  },
  {
    type: 'cityName',
    value: 'NUA, RAJASTHAN',
    masterId: 17100,
  },
  {
    type: 'cityName',
    value: 'NURABAD, MADHYA PRADESH',
    masterId: 17800,
  },
  {
    type: 'cityName',
    value: 'NAUGARH, UTTAR PRADESH',
    masterId: 13918,
  },
  {
    type: 'cityName',
    value: 'NUJELLA, ANDHRA PRADESH',
    masterId: 14060,
  },
  {
    type: 'cityName',
    value: 'NAGAR UNTARI, JHARKHAND',
    masterId: 13795,
  },
  {
    type: 'cityName',
    value: 'NAGULAVANCHA, TELANGANA',
    masterId: 16807,
  },
  {
    type: 'cityName',
    value: 'NAGAMANGALA, KARNATAKA',
    masterId: 17996,
  },
  {
    type: 'cityName',
    value: 'NAYAGAON, MADHYA PRADESH',
    masterId: 13944,
  },
  {
    type: 'cityName',
    value: 'NEYVELI, TAMIL NADU',
    masterId: 13987,
  },
  {
    type: 'cityName',
    value: 'NAWALGOHAN, MAHARASHTRA',
    masterId: 17606,
  },
  {
    type: 'cityName',
    value: 'NAVADE ROAD, MAHARASHTRA',
    masterId: 13924,
  },
  {
    type: 'cityName',
    value: 'NAVIPET, ANDHRA PRADESH',
    masterId: 13930,
  },
  {
    type: 'cityName',
    value: 'NALWAR, KARNATAKA',
    masterId: 13846,
  },
  {
    type: 'cityName',
    value: 'MAHUAGAON, MADHYA PRADESH',
    masterId: 13266,
  },
  {
    type: 'cityName',
    value: 'NWBV CABIN, ANDHRA PRADESH',
    masterId: 19013,
  },
  {
    type: 'cityName',
    value: 'NAYANAGAR, BIHAR',
    masterId: 18683,
  },
  {
    type: 'cityName',
    value: 'NAWADA, BIHAR',
    masterId: 13936,
  },
  {
    type: 'cityName',
    value: 'NAWADIH, JHARKHAND',
    masterId: 18141,
  },
  {
    type: 'cityName',
    value: 'NAWALGARH, RAJASTHAN',
    masterId: 13937,
  },
  {
    type: 'cityName',
    value: 'NOAPARA MAHISHASUR, WEST BENGAL',
    masterId: 16094,
  },
  {
    type: 'cityName',
    value: 'NANWAN, HARYANA',
    masterId: 18365,
  },
  {
    type: 'cityName',
    value: 'NAUPADA, ANDHRA PRADESH',
    masterId: 13921,
  },
  {
    type: 'cityName',
    value: 'PAHADI, MADHYA PRADESH',
    masterId: 14125,
  },
  {
    type: 'cityName',
    value: 'NAWAL SHAHI, JHARKHAND',
    masterId: 18140,
  },
  {
    type: 'cityName',
    value: 'NAVAPUR, GUJARAT',
    masterId: 13927,
  },
  {
    type: 'cityName',
    value: 'NIDAGHATTA, KARNATAKA',
    masterId: 17990,
  },
  {
    type: 'cityName',
    value: 'NUAGAON, ORISSA',
    masterId: 14056,
  },
  {
    type: 'cityName',
    value: 'NARAINGARH, WEST BENGAL',
    masterId: 18281,
  },
  {
    type: 'cityName',
    value: 'NAYAGARH, ORISSA',
    masterId: 13947,
  },
  {
    type: 'cityName',
    value: 'NELLAYI, KERALA',
    masterId: 17913,
  },
  {
    type: 'cityName',
    value: 'KHARDIYAN, RAJASTHAN',
    masterId: 12719,
  },
  {
    type: 'cityName',
    value: 'NIYAMATPUR, BIHAR',
    masterId: 18678,
  },
  {
    type: 'cityName',
    value: 'DABHAON, UTTAR PRADESH',
    masterId: 11177,
  },
  {
    type: 'cityName',
    value: 'NAYAGAON, BIHAR',
    masterId: 13943,
  },
  {
    type: 'cityName',
    value: 'SULLURUPETA, ANDHRA PRADESH',
    masterId: 15326,
  },
  {
    type: 'cityName',
    value: 'NAYATOLA, BIHAR',
    masterId: 17801,
  },
  {
    type: 'cityName',
    value: 'NEYYATTINKARA, KERALA',
    masterId: 13988,
  },
  {
    type: 'cityName',
    value: 'NIZAMABAD, TELANGANA',
    masterId: 14042,
  },
  {
    type: 'cityName',
    value: 'NUZVID, ANDHRA PRADESH',
    masterId: 14064,
  },
  {
    type: 'cityName',
    value: 'NAZARBAG, GUJARAT',
    masterId: 20812,
  },
  {
    type: 'cityName',
    value: 'NIYAJPUR, BIHAR',
    masterId: 18679,
  },
  {
    type: 'cityName',
    value: 'NAZIRA, ASSAM',
    masterId: 18964,
  },
  {
    type: 'cityName',
    value: 'NAZARETH, TAMIL NADU',
    masterId: 13949,
  },
  {
    type: 'cityName',
    value: 'OBALAPURAM, ANDHRA PRADESH',
    masterId: 19012,
  },
  {
    type: 'cityName',
    value: 'OBULAVARIPALLI, ANDHRA PRADESH',
    masterId: 14070,
  },
  {
    type: 'cityName',
    value: 'ODHANIYA, RAJASTHAN',
    masterId: 17099,
  },
  {
    type: 'cityName',
    value: 'OCHIRA, KERALA',
    masterId: 19118,
  },
  {
    type: 'cityName',
    value: 'OD, GUJARAT',
    masterId: 19092,
  },
  {
    type: 'cityName',
    value: 'OODLABARI, WEST BENGAL',
    masterId: 16093,
  },
  {
    type: 'cityName',
    value: 'ODDANCHATRAM, TAMIL NADU',
    masterId: 14071,
  },
  {
    type: 'cityName',
    value: 'OBAIDULLAGANJ, MADHYA PRADESH',
    masterId: 14067,
  },
  {
    type: 'cityName',
    value: 'ODHA, MAHARASHTRA',
    masterId: 18420,
  },
  {
    type: 'cityName',
    value: 'ONDA, WEST BENGAL',
    masterId: 14080,
  },
  {
    type: 'cityName',
    value: 'ODURU, ANDHRA PRADESH',
    masterId: 19011,
  },
  {
    type: 'cityName',
    value: 'ODELA, ANDHRA PRADESH',
    masterId: 14072,
  },
  {
    type: 'cityName',
    value: 'OEL, UTTAR PRADESH',
    masterId: 16380,
  },
  {
    type: 'cityName',
    value: 'ONGOLE, ANDHRA PRADESH',
    masterId: 14082,
  },
  {
    type: 'cityName',
    value: 'OORGAUM, KARNATAKA',
    masterId: 17986,
  },
  {
    type: 'cityName',
    value: 'OHAN, UTTAR PRADESH',
    masterId: 16732,
  },
  {
    type: 'cityName',
    value: 'OKHAMADHI, GUJARAT',
    masterId: 14075,
  },
  {
    type: 'cityName',
    value: 'OKHA, GUJARAT',
    masterId: 14074,
  },
  {
    type: 'cityName',
    value: 'OLAKKUR, TAMIL NADU',
    masterId: 16915,
  },
  {
    type: 'cityName',
    value: 'OLAPUR, BIHAR',
    masterId: 19085,
  },
  {
    type: 'cityName',
    value: 'OLLUR, KERALA',
    masterId: 17941,
  },
  {
    type: 'cityName',
    value: 'MORTAKKA, MADHYA PRADESH',
    masterId: 13654,
  },
  {
    type: 'cityName',
    value: 'OMALUR, TAMIL NADU',
    masterId: 14078,
  },
  {
    type: 'cityName',
    value: 'OLD MALDA, WEST BENGAL',
    masterId: 14076,
  },
  {
    type: 'cityName',
    value: 'UNNAO, UTTAR PRADESH',
    masterId: 15695,
  },
  {
    type: 'cityName',
    value: 'AUNLAJORI JN, ODISHA',
    masterId: 20915,
  },
  {
    type: 'cityName',
    value: 'COONOOR, TAMIL NADU',
    masterId: 11166,
  },
  {
    type: 'cityName',
    value: 'UPPAL, ANDHRA PRADESH',
    masterId: 15699,
  },
  {
    type: 'cityName',
    value: 'ORAI, UTTAR PRADESH',
    masterId: 14086,
  },
  {
    type: 'cityName',
    value: 'ORACHHA, MADHYA PRADESH',
    masterId: 17799,
  },
  {
    type: 'cityName',
    value: 'ORDI, RAJASTHAN',
    masterId: 17255,
  },
  {
    type: 'cityName',
    value: 'ORE, BIHAR',
    masterId: 18677,
  },
  {
    type: 'cityName',
    value: 'ORGA, JHARKHAND',
    masterId: 14089,
  },
  {
    type: 'cityName',
    value: 'HADONAHALLI, KARNATAKA',
    masterId: 11883,
  },
  {
    type: 'cityName',
    value: 'ORKI, RAJASTHAN',
    masterId: 17097,
  },
  {
    type: 'cityName',
    value: 'ORR, MADHYA PRADESH',
    masterId: 14090,
  },
  {
    type: 'cityName',
    value: 'ORWARA, UTTAR PRADESH',
    masterId: 18536,
  },
  {
    type: 'cityName',
    value: 'BHOYARA, MAHARASHTRA',
    masterId: 10777,
  },
  {
    type: 'cityName',
    value: 'OSIAN, RAJASTHAN',
    masterId: 14091,
  },
  {
    type: 'cityName',
    value: 'OSRA, MADHYA PRADESH',
    masterId: 20883,
  },
  {
    type: 'cityName',
    value: 'OOTWAR, RAJASTHAN',
    masterId: 17098,
  },
  {
    type: 'cityName',
    value: 'OTTAKKOVIL, TAMIL NADU',
    masterId: 16913,
  },
  {
    type: 'cityName',
    value: 'OATING, ASSAM',
    masterId: 18874,
  },
  {
    type: 'cityName',
    value: 'OTTAPPALAM, KERALA',
    masterId: 14095,
  },
  {
    type: 'cityName',
    value: 'MOTURU, ANDHRA PRADESH',
    masterId: 19019,
  },
  {
    type: 'cityName',
    value: 'OTHIVAKKAM, TAMIL NADU',
    masterId: 16914,
  },
  {
    type: 'cityName',
    value: 'PATAS, MAHARASHTRA',
    masterId: 14282,
  },
  {
    type: 'cityName',
    value: 'PALA, MAHARASHTRA',
    masterId: 19129,
  },
  {
    type: 'cityName',
    value: 'PARDI, GUJARAT',
    masterId: 14247,
  },
  {
    type: 'cityName',
    value: 'PIPRADIH, JHARKHAND',
    masterId: 19107,
  },
  {
    type: 'cityName',
    value: 'PALANA, RAJASTHAN',
    masterId: 14144,
  },
  {
    type: 'cityName',
    value: 'PENNADA AGRHRM, ANDHRA PRADESH',
    masterId: 14350,
  },
  {
    type: 'cityName',
    value: 'PAWAI, MADHYA PRADESH',
    masterId: 14320,
  },
  {
    type: 'cityName',
    value: 'PALI A, BIHAR',
    masterId: 20783,
  },
  {
    type: 'cityName',
    value: 'PARAJ, WEST BENGAL',
    masterId: 16204,
  },
  {
    type: 'cityName',
    value: 'PAKALA, ANDHRA PRADESH',
    masterId: 14130,
  },
  {
    type: 'cityName',
    value: 'PALASNER, MADHYA PRADESH',
    masterId: 17603,
  },
  {
    type: 'cityName',
    value: 'PALAYAM, TAMIL NADU',
    masterId: 16911,
  },
  {
    type: 'cityName',
    value: 'PALUR, TAMIL NADU',
    masterId: 17031,
  },
  {
    type: 'cityName',
    value: 'PANAPAKAM, ANDHRA PRADESH',
    masterId: 14185,
  },
  {
    type: 'cityName',
    value: 'PANAGARH, WEST BENGAL',
    masterId: 14182,
  },
  {
    type: 'cityName',
    value: 'KENNALU, KARNATAKA',
    masterId: 12652,
  },
  {
    type: 'cityName',
    value: 'PANOLI, GUJARAT',
    masterId: 14217,
  },
  {
    type: 'cityName',
    value: 'PITHAPURAM, ANDHRA PRADESH',
    masterId: 14431,
  },
  {
    type: 'cityName',
    value: 'PALAT POTHARAM, TELANGANA',
    masterId: 16805,
  },
  {
    type: 'cityName',
    value: 'PADIYA NAQLA, UTTARAKHAND',
    masterId: 16377,
  },
  {
    type: 'cityName',
    value: 'PANDHURNA, MADHYA PRADESH',
    masterId: 14202,
  },
  {
    type: 'cityName',
    value: 'PATHRAD, MAHARASHTRA',
    masterId: 14296,
  },
  {
    type: 'cityName',
    value: 'PARAKHEDA, MADHYA PRADESH',
    masterId: 17795,
  },
  {
    type: 'cityName',
    value: 'PASUR, TAMIL NADU',
    masterId: 16908,
  },
  {
    type: 'cityName',
    value: 'PARASSALA, KERALA',
    masterId: 14238,
  },
  {
    type: 'cityName',
    value: 'PANISAGAR, TRIPURA',
    masterId: 16780,
  },
  {
    type: 'cityName',
    value: 'PANDURANGA SWAMY ROA, TELANGANA',
    masterId: 20999,
  },
  {
    type: 'cityName',
    value: 'PATA, UTTAR PRADESH',
    masterId: 21013,
  },
  {
    type: 'cityName',
    value: 'PARSA TIWARI, UTTAR PRADESH',
    masterId: 16369,
  },
  {
    type: 'cityName',
    value: 'PATAM, BIHAR',
    masterId: 18808,
  },
  {
    type: 'cityName',
    value: 'PARAMJEEVAR TARAJEEV, BIHAR',
    masterId: 20764,
  },
  {
    type: 'cityName',
    value: 'PURNA, MAHARASHTRA',
    masterId: 14512,
  },
  {
    type: 'cityName',
    value: 'PEDANA, ANDHRA PRADESH',
    masterId: 14330,
  },
  {
    type: 'cityName',
    value: 'PAVI, GUJARAT',
    masterId: 18415,
  },
  {
    type: 'cityName',
    value: 'P AVATAPALLE, ANDHRA PRADESH',
    masterId: 14099,
  },
  {
    type: 'cityName',
    value: 'BAIDYANATHPUR, WEST BENGAL',
    masterId: 10393,
  },
  {
    type: 'cityName',
    value: 'PATTI, PUNJAB',
    masterId: 20949,
  },
  {
    type: 'cityName',
    value: 'PAYYANUR, KERALA',
    masterId: 14324,
  },
  {
    type: 'cityName',
    value: 'PAZHAYANGADI, KERALA',
    masterId: 14327,
  },
  {
    type: 'cityName',
    value: 'PUNTAMBA, MAHARASHTRA',
    masterId: 14505,
  },
  {
    type: 'cityName',
    value: 'MANDI, WEST BENGAL',
    masterId: 13396,
  },
  {
    type: 'cityName',
    value: 'PARBATONIA, JHARKHAND',
    masterId: 18136,
  },
  {
    type: 'cityName',
    value: 'PARVATSAR, RAJASTHAN',
    masterId: 19146,
  },
  {
    type: 'cityName',
    value: 'P BRAHMADEVAM H, ANDHRA PRADESH',
    masterId: 14100,
  },
  {
    type: 'cityName',
    value: 'PILIBHIT, UTTAR PRADESH',
    masterId: 14398,
  },
  {
    type: 'cityName',
    value: 'PARTAPGARH, UTTAR PRADESH',
    masterId: 14266,
  },
  {
    type: 'cityName',
    value: 'PBNWA JASMHNDAR, HARYANA',
    masterId: 18272,
  },
  {
    type: 'cityName',
    value: 'PMBAKVL SHANDY, TAMIL NADU',
    masterId: 14433,
  },
  {
    type: 'cityName',
    value: 'PATHSALA, ASSAM',
    masterId: 14300,
  },
  {
    type: 'cityName',
    value: 'PAMBAN, TAMIL NADU',
    masterId: 14178,
  },
  {
    type: 'cityName',
    value: 'PARBHANI, MAHARASHTRA',
    masterId: 14244,
  },
  {
    type: 'cityName',
    value: 'PEMBARTI, ANDHRA PRADESH',
    masterId: 14345,
  },
  {
    type: 'cityName',
    value: 'PORBANDAR, GUJARAT',
    masterId: 14454,
  },
  {
    type: 'cityName',
    value: 'PALIBA, ORISSA',
    masterId: 14159,
  },
  {
    type: 'cityName',
    value: 'PANTNAGAR, UTTARAKHAND',
    masterId: 14222,
  },
  {
    type: 'cityName',
    value: 'PORABAZAR, WEST BENGAL',
    masterId: 21207,
  },
  {
    type: 'cityName',
    value: 'PACHORA, MAHARASHTRA',
    masterId: 14106,
  },
  {
    type: 'cityName',
    value: 'PRACHI JUNCTION, GUJARAT',
    masterId: 18413,
  },
  {
    type: 'cityName',
    value: 'PACHHAPUR, KARNATAKA',
    masterId: 14104,
  },
  {
    type: 'cityName',
    value: 'PACHRUKHI, BIHAR',
    masterId: 18676,
  },
  {
    type: 'cityName',
    value: 'PACHACHAKUPAM, TAMIL NADU',
    masterId: 16912,
  },
  {
    type: 'cityName',
    value: 'PULICHERLA, ANDHRA PRADESH',
    masterId: 14483,
  },
  {
    type: 'cityName',
    value: 'PACHAURI, MADHYA PRADESH',
    masterId: 14103,
  },
  {
    type: 'cityName',
    value: 'PAVURCHUTRAM, TAMIL NADU',
    masterId: 19154,
  },
  {
    type: 'cityName',
    value: 'PACHAR MALIKPURA, RAJASTHAN',
    masterId: 17096,
  },
  {
    type: 'cityName',
    value: 'PANCHPIPALIYA, MADHYA PRADESH',
    masterId: 14191,
  },
  {
    type: 'cityName',
    value: 'PALAYAMKOTTAI, TAMIL NADU',
    masterId: 17032,
  },
  {
    type: 'cityName',
    value: 'PICHKURIRDHAL, WEST BENGAL',
    masterId: 14392,
  },
  {
    type: 'cityName',
    value: 'PANCHRA, WEST BENGAL',
    masterId: 16090,
  },
  {
    type: 'cityName',
    value: 'PANCHTALAVDA, GUJARAT',
    masterId: 18418,
  },
  {
    type: 'cityName',
    value: 'PUDUCHATRAM, TAMIL NADU',
    masterId: 16900,
  },
  {
    type: 'cityName',
    value: 'MOKHASAKALVAPUDI, ANDHRA PRADESH',
    masterId: 13625,
  },
  {
    type: 'cityName',
    value: 'PALACODE, TAMIL NADU',
    masterId: 14136,
  },
  {
    type: 'cityName',
    value: 'JAMALPUR, WEST BENGAL',
    masterId: 12168,
  },
  {
    type: 'cityName',
    value: 'PIPARCITY, RAJASTHAN',
    masterId: 17088,
  },
  {
    type: 'cityName',
    value: 'POCHARAM, ANDHRA PRADESH',
    masterId: 14435,
  },
  {
    type: 'cityName',
    value: 'PHARDHAN, UTTAR PRADESH',
    masterId: 16360,
  },
  {
    type: 'cityName',
    value: 'PANDUA, WEST BENGAL',
    masterId: 14204,
  },
  {
    type: 'cityName',
    value: 'PADUBIDRI, KARNATAKA',
    masterId: 14119,
  },
  {
    type: 'cityName',
    value: 'PADAMPUR, GUJARAT',
    masterId: 17095,
  },
  {
    type: 'cityName',
    value: 'PARADGAON, MAHARASHTRA',
    masterId: 14228,
  },
  {
    type: 'cityName',
    value: 'PONDUGULA, ANDHRA PRADESH',
    masterId: 14447,
  },
  {
    type: 'cityName',
    value: 'PUDUNAGARAM, KERALA',
    masterId: 17938,
  },
  {
    type: 'cityName',
    value: 'PADHEGOAN, MAHARASHTRA',
    masterId: 14112,
  },
  {
    type: 'cityName',
    value: 'PADADHARI, GUJARAT',
    masterId: 14108,
  },
  {
    type: 'cityName',
    value: 'PALASHARI, MAHARASHTRA',
    masterId: 18873,
  },
  {
    type: 'cityName',
    value: 'PERIYANAICKENPALAYAM, TAMIL NADU',
    masterId: 16905,
  },
  {
    type: 'cityName',
    value: 'PEDAKAKANI, ANDHRA PRADESH',
    masterId: 14328,
  },
  {
    type: 'cityName',
    value: 'PUDUKKOTTAI, TAMIL NADU',
    masterId: 14475,
  },
  {
    type: 'cityName',
    value: 'PENDEKALLU, ANDHRA PRADESH',
    masterId: 14348,
  },
  {
    type: 'cityName',
    value: 'PADMA, JHARKHAND',
    masterId: 18138,
  },
  {
    type: 'cityName',
    value: 'PEDDADINNE, ANDHRA PRADESH',
    masterId: 14335,
  },
  {
    type: 'cityName',
    value: 'PADNUR, KARNATAKA',
    masterId: 14113,
  },
  {
    type: 'cityName',
    value: 'PUDURU, ANDHRA PRADESH',
    masterId: 14477,
  },
  {
    type: 'cityName',
    value: 'PADSE, MAHARASHTRA',
    masterId: 14117,
  },
  {
    type: 'cityName',
    value: 'PADAPAHAR, JHARKHAND',
    masterId: 18214,
  },
  {
    type: 'cityName',
    value: 'PADMAPUKAR, WEST BENGAL',
    masterId: 21224,
  },
  {
    type: 'cityName',
    value: 'PEDDAPALLI, ANDHRA PRADESH',
    masterId: 14337,
  },
  {
    type: 'cityName',
    value: 'PURANDARPUR, UTTAR PRADESH',
    masterId: 16088,
  },
  {
    type: 'cityName',
    value: 'PADLA, RAJASTHAN',
    masterId: 18278,
  },
  {
    type: 'cityName',
    value: 'PAYAGPUR, UTTAR PRADESH',
    masterId: 14322,
  },
  {
    type: 'cityName',
    value: 'DEORAI, UTTAR PRADESH',
    masterId: 11286,
  },
  {
    type: 'cityName',
    value: 'PINDARSI, HARYANA',
    masterId: 18269,
  },
  {
    type: 'cityName',
    value: 'PEDDASANA, ANDHRA PRADESH',
    masterId: 19008,
  },
  {
    type: 'cityName',
    value: 'GURRAMPALEM, ANDHRA PRADESH',
    masterId: 11866,
  },
  {
    type: 'cityName',
    value: 'PONDURU, ANDHRA PRADESH',
    masterId: 14448,
  },
  {
    type: 'cityName',
    value: 'PANDAUL, BIHAR',
    masterId: 14196,
  },
  {
    type: 'cityName',
    value: 'PAYRADANGA, WEST BENGAL',
    masterId: 14323,
  },
  {
    type: 'cityName',
    value: 'PONDICHERRY, PUDUCHERRY',
    masterId: 14446,
  },
  {
    type: 'cityName',
    value: 'PETTAI, TAMIL NADU',
    masterId: 17027,
  },
  {
    type: 'cityName',
    value: 'PENCHARTHAL, TRIPURA',
    masterId: 16779,
  },
  {
    type: 'cityName',
    value: 'PATHARDIH, JHARKHAND',
    masterId: 14290,
  },
  {
    type: 'cityName',
    value: 'PERANI, TAMIL NADU',
    masterId: 17029,
  },
  {
    type: 'cityName',
    value: 'POLIREDDY PALEM, ANDHRA PRADESH',
    masterId: 19006,
  },
  {
    type: 'cityName',
    value: 'PERALAM, TAMIL NADU',
    masterId: 14355,
  },
  {
    type: 'cityName',
    value: 'PEN, MAHARASHTRA',
    masterId: 14346,
  },
  {
    type: 'cityName',
    value: 'PHEPHNA, UTTAR PRADESH',
    masterId: 14385,
  },
  {
    type: 'cityName',
    value: 'PHESAR, BIHAR',
    masterId: 14386,
  },
  {
    type: 'cityName',
    value: 'PANDETOLA, BIHAR',
    masterId: 18670,
  },
  {
    type: 'cityName',
    value: 'PERASHANNUR, KERALA',
    masterId: 17910,
  },
  {
    type: 'cityName',
    value: 'PIPARALA, GUJARAT',
    masterId: 18533,
  },
  {
    type: 'cityName',
    value: 'PHAPHAMAU, UTTAR PRADESH',
    masterId: 14384,
  },
  {
    type: 'cityName',
    value: 'PACHOR ROAD, MADHYA PRADESH',
    masterId: 14105,
  },
  {
    type: 'cityName',
    value: 'POTHAHI, BIHAR',
    masterId: 18807,
  },
  {
    type: 'cityName',
    value: 'PUJARIPUT, ORISSA',
    masterId: 14478,
  },
  {
    type: 'cityName',
    value: 'GAVHA, MAHARASHTRA',
    masterId: 11679,
  },
  {
    type: 'cityName',
    value: 'PAGARA, MADHYA PRADESH',
    masterId: 14124,
  },
  {
    type: 'cityName',
    value: 'PANCHGACHIA, BIHAR',
    masterId: 16091,
  },
  {
    type: 'cityName',
    value: 'PAGIDIRAI, ANDHRA PRADESH',
    masterId: 19010,
  },
  {
    type: 'cityName',
    value: 'PENGANGA, MAHARASHTRA',
    masterId: 17727,
  },
  {
    type: 'cityName',
    value: 'PARAPPANANGADI, KERALA',
    masterId: 14236,
  },
  {
    type: 'cityName',
    value: 'PILIBANGA, RAJASTHAN',
    masterId: 14397,
  },
  {
    type: 'cityName',
    value: 'PAGDHAL, MADHYA PRADESH',
    masterId: 17797,
  },
  {
    type: 'cityName',
    value: 'PERUGAMANI, TAMIL NADU',
    masterId: 17028,
  },
  {
    type: 'cityName',
    value: 'PUNJAIPUGALUR, TAMIL NADU',
    masterId: 14501,
  },
  {
    type: 'cityName',
    value: 'PIDUGURALLA, ANDHRA PRADESH',
    masterId: 14393,
  },
  {
    type: 'cityName',
    value: 'PALAKKAD, KERALA',
    masterId: 14137,
  },
  {
    type: 'cityName',
    value: 'PHAGWARA, PUNJAB',
    masterId: 14380,
  },
  {
    type: 'cityName',
    value: 'PERUNGUZHI, KERALA',
    masterId: 14373,
  },
  {
    type: 'cityName',
    value: 'PANOH, HIMACHAL PRADESH ',
    masterId: 18240,
  },
  {
    type: 'cityName',
    value: 'PATHARIA, MADHYA PRADESH',
    masterId: 14291,
  },
  {
    type: 'cityName',
    value: 'PANCHOT, GUJARAT',
    masterId: 18419,
  },
  {
    type: 'cityName',
    value: 'DIBIYAPUR, UTTAR PRADESH',
    masterId: 11421,
  },
  {
    type: 'cityName',
    value: 'PAHALEJA, BIHAR',
    masterId: 18675,
  },
  {
    type: 'cityName',
    value: 'BARCHAPARI, ASSAM',
    masterId: 10517,
  },
  {
    type: 'cityName',
    value: 'PUNDARAKH, BIHAR',
    masterId: 14497,
  },
  {
    type: 'cityName',
    value: 'PAHLEJAGHAT, BIHAR',
    masterId: 18674,
  },
  {
    type: 'cityName',
    value: 'PATHAPATNAM, ANDHRA PRADESH',
    masterId: 19055,
  },
  {
    type: 'cityName',
    value: 'PUKHRAYAN, UTTAR PRADESH',
    masterId: 14479,
  },
  {
    type: 'cityName',
    value: 'PARDHANDE, MAHARASHTRA',
    masterId: 17599,
  },
  {
    type: 'cityName',
    value: 'PHILLAUR, PUNJAB',
    masterId: 14387,
  },
  {
    type: 'cityName',
    value: 'FEROZE SHAH, PUNJAB',
    masterId: 17368,
  },
  {
    type: 'cityName',
    value: 'PIRTHIGANJ, UTTAR PRADESH',
    masterId: 16357,
  },
  {
    type: 'cityName',
    value: 'PEHOWA, HARYANA',
    masterId: 18271,
  },
  {
    type: 'cityName',
    value: 'PATHAKPUR, UTTAR PRADESH',
    masterId: 16730,
  },
  {
    type: 'cityName',
    value: 'PHARIHA, UTTAR PRADESH',
    masterId: 16359,
  },
  {
    type: 'cityName',
    value: 'PADLI, MAHARASHTRA',
    masterId: 17798,
  },
  {
    type: 'cityName',
    value: 'PIPRAIGAON, MADHYA PRADESH',
    masterId: 14424,
  },
  {
    type: 'cityName',
    value: 'PARICHHA, UTTAR PRADESH',
    masterId: 16371,
  },
  {
    type: 'cityName',
    value: 'PILIGHAT, MADHYA PRADESH',
    masterId: 19126,
  },
  {
    type: 'cityName',
    value: 'PARIHARA, RAJASTHAN',
    masterId: 18668,
  },
  {
    type: 'cityName',
    value: 'DODDIPALLE, ANDHRA PRADESH',
    masterId: 11449,
  },
  {
    type: 'cityName',
    value: 'PILOL, GUJARAT ',
    masterId: 18414,
  },
  {
    type: 'cityName',
    value: 'PIPLIA, MADHYA PRADESH',
    masterId: 14416,
  },
  {
    type: 'cityName',
    value: 'PIRO, BIHAR',
    masterId: 18663,
  },
  {
    type: 'cityName',
    value: 'PISKA, JHARKHAND',
    masterId: 18133,
  },
  {
    type: 'cityName',
    value: 'PALITANA, GUJARAT',
    masterId: 14160,
  },
  {
    type: 'cityName',
    value: 'PINGLI, MAHARASHTRA',
    masterId: 14408,
  },
  {
    type: 'cityName',
    value: 'PEPPEGANJ, UTTAR PRADESH',
    masterId: 16362,
  },
  {
    type: 'cityName',
    value: 'PAJIAN, PUNJAB',
    masterId: 17309,
  },
  {
    type: 'cityName',
    value: 'PANIAJOB, MAHARASHTRA',
    masterId: 14212,
  },
  {
    type: 'cityName',
    value: 'PANJGAM, JAMMU AND KASHMIR',
    masterId: 20830,
  },
  {
    type: 'cityName',
    value: 'PIRJHALAR, MADHYA PRADESH',
    masterId: 20881,
  },
  {
    type: 'cityName',
    value: 'PANJKOSI, RAJASTHAN',
    masterId: 17308,
  },
  {
    type: 'cityName',
    value: 'PANJHAN, MAHARASHTRA',
    masterId: 17600,
  },
  {
    type: 'cityName',
    value: 'PJP ROAD HALT, TELANGANA',
    masterId: 20998,
  },
  {
    type: 'cityName',
    value: 'PANGRI, MAHARASHTRA',
    masterId: 14210,
  },
  {
    type: 'cityName',
    value: 'PARA JANI HALT, UTTAR PRADESH',
    masterId: 21019,
  },
  {
    type: 'cityName',
    value: 'PAKNI, MAHARASHTRA',
    masterId: 14133,
  },
  {
    type: 'cityName',
    value: 'PRADHANKHUNTA, JHARKHAND',
    masterId: 18132,
  },
  {
    type: 'cityName',
    value: 'PATHARKHOLA, ASSAM',
    masterId: 14292,
  },
  {
    type: 'cityName',
    value: 'PEEPLI KA BAS, RAJASTHAN',
    masterId: 17253,
  },
  {
    type: 'cityName',
    value: 'PAKRA, JHARKHAND',
    masterId: 18672,
  },
  {
    type: 'cityName',
    value: 'VASUDEVAPURAM, ANDHRA PRADESH',
    masterId: 15804,
  },
  {
    type: 'cityName',
    value: 'PILLU KHERA, HARYANA',
    masterId: 18270,
  },
  {
    type: 'cityName',
    value: 'PIMPAR KHED, MAHARASHTRA',
    masterId: 17597,
  },
  {
    type: 'cityName',
    value: 'POKLA, JHARKHAND',
    masterId: 14440,
  },
  {
    type: 'cityName',
    value: 'PAKKI, PUNJAB',
    masterId: 14132,
  },
  {
    type: 'cityName',
    value: 'PAPINAYAKANAHALL, KARNATAKA',
    masterId: 14226,
  },
  {
    type: 'cityName',
    value: 'PAKHNA, UTTAR PRADESH',
    masterId: 16375,
  },
  {
    type: 'cityName',
    value: 'POKHARNI NRSNHA, MAHARASHTRA',
    masterId: 14438,
  },
  {
    type: 'cityName',
    value: 'PALAKOLLU, ANDHRA PRADESH',
    masterId: 14139,
  },
  {
    type: 'cityName',
    value: 'PEDAKURAPADU, ANDHRA PRADESH',
    masterId: 14329,
  },
  {
    type: 'cityName',
    value: 'PATTIKKAD, KERALA',
    masterId: 14312,
  },
  {
    type: 'cityName',
    value: 'PAKUR, JHARKHAND',
    masterId: 14134,
  },
  {
    type: 'cityName',
    value: 'PARSAKHERA, UTTAR PRADESH',
    masterId: 14261,
  },
  {
    type: 'cityName',
    value: 'PAKARA ROAD, MADHYA PRADESH',
    masterId: 14131,
  },
  {
    type: 'cityName',
    value: 'PANSKURA, WEST BENGAL',
    masterId: 14220,
  },
  {
    type: 'cityName',
    value: 'PILKHUWA, UTTAR PRADESH',
    masterId: 14399,
  },
  {
    type: 'cityName',
    value: 'PAKHRAULI, UTTAR PRADESH',
    masterId: 16374,
  },
  {
    type: 'cityName',
    value: 'PILKHANI, UTTAR PRADESH',
    masterId: 18364,
  },
  {
    type: 'cityName',
    value: 'PALIA, MADHYA PRADESH',
    masterId: 20887,
  },
  {
    type: 'cityName',
    value: 'PALSIT, WEST BENGAL',
    masterId: 21069,
  },
  {
    type: 'cityName',
    value: 'PHALODI, RAJASTHAN',
    masterId: 14381,
  },
  {
    type: 'cityName',
    value: 'PALDHI, MAHARASHTRA',
    masterId: 14152,
  },
  {
    type: 'cityName',
    value: 'PIPLEE, GUJARAT',
    masterId: 17792,
  },
  {
    type: 'cityName',
    value: 'PIALI, WEST BENGAL',
    masterId: 21174,
  },
  {
    type: 'cityName',
    value: 'PALIGARH, UTTAR PRADESH',
    masterId: 19182,
  },
  {
    type: 'cityName',
    value: 'PARALAKHEMUNDI, ORISSA',
    masterId: 17449,
  },
  {
    type: 'cityName',
    value: 'PALHAWAS, HARYANA',
    masterId: 18277,
  },
  {
    type: 'cityName',
    value: 'PETTAVAITHALAI, TAMIL NADU',
    masterId: 14379,
  },
  {
    type: 'cityName',
    value: 'PALEJ, GUJARAT',
    masterId: 14153,
  },
  {
    type: 'cityName',
    value: 'PALIA KALAN, UTTAR PRADESH',
    masterId: 14158,
  },
  {
    type: 'cityName',
    value: 'PARLI, KERALA',
    masterId: 19121,
  },
  {
    type: 'cityName',
    value: 'PANELI MOTI, GUJARAT ',
    masterId: 18416,
  },
  {
    type: 'cityName',
    value: 'PULIYAMANGALAM, TAMIL NADU',
    masterId: 20977,
  },
  {
    type: 'cityName',
    value: 'PALANI, TAMIL NADU',
    masterId: 14145,
  },
  {
    type: 'cityName',
    value: 'PULGAON, MAHARASHTRA',
    masterId: 14481,
  },
  {
    type: 'cityName',
    value: 'PHULPUR, UTTAR PRADESH',
    masterId: 14391,
  },
  {
    type: 'cityName',
    value: 'PALAPPURAM, KERALA',
    masterId: 14147,
  },
  {
    type: 'cityName',
    value: 'BHOJPUR, UTTAR PRADESH',
    masterId: 10764,
  },
  {
    type: 'cityName',
    value: 'PALASINGI, ORISSA',
    masterId: 19059,
  },
  {
    type: 'cityName',
    value: 'PALSANA, RAJASTHAN',
    masterId: 14172,
  },
  {
    type: 'cityName',
    value: 'PIRTHALA LLAUDA, HARYANA',
    masterId: 18268,
  },
  {
    type: 'cityName',
    value: 'PATAKOTTACHERUVU, ANDHRA PRADESH',
    masterId: 14278,
  },
  {
    type: 'cityName',
    value: 'PALSHI, MAHARASHTRA',
    masterId: 17602,
  },
  {
    type: 'cityName',
    value: 'PALLEVADA, ANDHRA PRADESH',
    masterId: 16829,
  },
  {
    type: 'cityName',
    value: 'PINGLESHWAR, MADHYA PRADESH',
    masterId: 14407,
  },
  {
    type: 'cityName',
    value: 'PHULWARIA, UTTAR PRADESH',
    masterId: 16729,
  },
  {
    type: 'cityName',
    value: 'PLASSEY, WEST BENGAL',
    masterId: 14432,
  },
  {
    type: 'cityName',
    value: 'PULLAMBADI, TAMIL NADU',
    masterId: 16898,
  },
  {
    type: 'cityName',
    value: 'PAMIDI, ANDHRA PRADESH',
    masterId: 19058,
  },
  {
    type: 'cityName',
    value: 'PARAO MAHNA, PUNJAB ',
    masterId: 17307,
  },
  {
    type: 'cityName',
    value: 'PARAMAKUDI, TAMIL NADU',
    masterId: 14232,
  },
  {
    type: 'cityName',
    value: 'PIMPALKHUTI, MAHARASHTRA',
    masterId: 14402,
  },
  {
    type: 'cityName',
    value: 'PANDARAVADAI, TAMIL NADU',
    masterId: 14195,
  },
  {
    type: 'cityName',
    value: 'PARSEHRA, UTTAR PRADESH',
    masterId: 16368,
  },
  {
    type: 'cityName',
    value: 'PAMAN, UTTAR PRADESH',
    masterId: 14175,
  },
  {
    type: 'cityName',
    value: 'PANDOLI, RAJASTHAN',
    masterId: 18417,
  },
  {
    type: 'cityName',
    value: 'PAMPORA, JAMMU AND KASHMIR',
    masterId: 20833,
  },
  {
    type: 'cityName',
    value: 'PREMPUR, UTTAR PRADESH',
    masterId: 21032,
  },
  {
    type: 'cityName',
    value: 'PARMANAND, PUNJAB',
    masterId: 17306,
  },
  {
    type: 'cityName',
    value: 'FARIDPUR, UTTAR PRADESH',
    masterId: 11565,
  },
  {
    type: 'cityName',
    value: 'PARMALKASA, CHHATTISGARH ',
    masterId: 18603,
  },
  {
    type: 'cityName',
    value: 'PULLAMPET, ANDHRA PRADESH',
    masterId: 14491,
  },
  {
    type: 'cityName',
    value: 'PARMANANDPUR, BIHAR',
    masterId: 14256,
  },
  {
    type: 'cityName',
    value: 'PALI, RAJASTHAN',
    masterId: 14157,
  },
  {
    type: 'cityName',
    value: 'PANBARI, ASSAM',
    masterId: 14187,
  },
  {
    type: 'cityName',
    value: 'PATNA, BIHAR',
    masterId: 14303,
  },
  {
    type: 'cityName',
    value: 'PANCHEBERIA, WEST BENGAL',
    masterId: 21146,
  },
  {
    type: 'cityName',
    value: 'GAURELLA, CHHATTISGARH',
    masterId: 11671,
  },
  {
    type: 'cityName',
    value: 'ERAIYUR, TAMIL NADU',
    masterId: 11532,
  },
  {
    type: 'cityName',
    value: 'PANDILLAPALLI, TELANGANA',
    masterId: 16804,
  },
  {
    type: 'cityName',
    value: 'PANDORI, GUJARAT',
    masterId: 20803,
  },
  {
    type: 'cityName',
    value: 'PRANTIK, WEST BENGAL',
    masterId: 14465,
  },
  {
    type: 'cityName',
    value: 'PANGAON, MAHARASHTRA',
    masterId: 14207,
  },
  {
    type: 'cityName',
    value: 'PANANGUDI, TAMIL NADU',
    masterId: 19163,
  },
  {
    type: 'cityName',
    value: 'PANCHGRAM, ASSAM',
    masterId: 14189,
  },
  {
    type: 'cityName',
    value: 'PINGORA, RAJASTHAN',
    masterId: 17252,
  },
  {
    type: 'cityName',
    value: 'PANHAI, UTTAR PRADESH',
    masterId: 16373,
  },
  {
    type: 'cityName',
    value: 'PANIHAR, MADHYA PRADESH',
    masterId: 17796,
  },
  {
    type: 'cityName',
    value: 'PURAINI, UTTAR PRADESH',
    masterId: 18806,
  },
  {
    type: 'cityName',
    value: 'PANYAM, ANDHRA PRADESH',
    masterId: 14224,
  },
  {
    type: 'cityName',
    value: 'ISRI, JHARKHAND',
    masterId: 12089,
  },
  {
    type: 'cityName',
    value: 'PANIPAT, HARYANA',
    masterId: 14213,
  },
  {
    type: 'cityName',
    value: 'PANPALI, ORISSA',
    masterId: 14218,
  },
  {
    type: 'cityName',
    value: 'PANPANA, ORISSA',
    masterId: 19057,
  },
  {
    type: 'cityName',
    value: 'PUNNAPRA, KERALA',
    masterId: 17909,
  },
  {
    type: 'cityName',
    value: 'THRISSUR, KERALA',
    masterId: 15540,
  },
  {
    type: 'cityName',
    value: 'PANIARA, UTTAR PRADESH',
    masterId: 16205,
  },
  {
    type: 'cityName',
    value: 'PUNSIA, BIHAR',
    masterId: 14504,
  },
  {
    type: 'cityName',
    value: 'PANGRA SHINDE, MAHARASHTRA',
    masterId: 17728,
  },
  {
    type: 'cityName',
    value: 'PANITOLA, ASSAM',
    masterId: 18871,
  },
  {
    type: 'cityName',
    value: 'PALANPUR, GUJARAT',
    masterId: 14146,
  },
  {
    type: 'cityName',
    value: 'PUNPUN GHAT, BIHAR ',
    masterId: 18660,
  },
  {
    type: 'cityName',
    value: 'PANEWADI, MAHARASHTRA',
    masterId: 17601,
  },
  {
    type: 'cityName',
    value: 'PANCHARATNA, ASSAM',
    masterId: 18872,
  },
  {
    type: 'cityName',
    value: 'ABDULLAPUR, MADHYA PRADESH',
    masterId: 10010,
  },
  {
    type: 'cityName',
    value: 'PANIAHWA, UTTAR PRADESH',
    masterId: 14211,
  },
  {
    type: 'cityName',
    value: 'PARANGIPETTAI, TAMIL NADU',
    masterId: 16910,
  },
  {
    type: 'cityName',
    value: 'PALLEKONA, ANDHRA PRADESH',
    masterId: 14165,
  },
  {
    type: 'cityName',
    value: 'PAWAPURI, BIHAR',
    masterId: 14321,
  },
  {
    type: 'cityName',
    value: 'PIPARSAND, UTTAR PRADESH',
    masterId: 16728,
  },
  {
    type: 'cityName',
    value: 'PONPADI, TAMIL NADU',
    masterId: 16902,
  },
  {
    type: 'cityName',
    value: 'POKHRAN, RAJASTHAN',
    masterId: 14439,
  },
  {
    type: 'cityName',
    value: 'PEOKOL, UTTAR PRADESH',
    masterId: 16363,
  },
  {
    type: 'cityName',
    value: 'PUNTOTTAM, TAMIL NADU',
    masterId: 16896,
  },
  {
    type: 'cityName',
    value: 'PONNERI, TAMIL NADU',
    masterId: 16903,
  },
  {
    type: 'cityName',
    value: 'POTLAPADU, ANDHRA PRADESH',
    masterId: 14461,
  },
  {
    type: 'cityName',
    value: 'PIPLOD, RAJASTHAN',
    masterId: 14418,
  },
  {
    type: 'cityName',
    value: 'PORA, UTTAR PRADESH',
    masterId: 18662,
  },
  {
    type: 'cityName',
    value: 'POTHIA, BIHAR',
    masterId: 16052,
  },
  {
    type: 'cityName',
    value: 'PADRAUNA, UTTAR PRADESH',
    masterId: 14115,
  },
  {
    type: 'cityName',
    value: 'POLA-PATTHAR, MADHYA PRADESH',
    masterId: 17791,
  },
  {
    type: 'cityName',
    value: 'POLLACHI, TAMIL NADU',
    masterId: 14443,
  },
  {
    type: 'cityName',
    value: 'POTUL, MAHARASHTRA',
    masterId: 14463,
  },
  {
    type: 'cityName',
    value: 'PURANPUR, UTTAR PRADESH',
    masterId: 14508,
  },
  {
    type: 'cityName',
    value: 'PIPRA, BIHAR',
    masterId: 14422,
  },
  {
    type: 'cityName',
    value: 'PARTABPURA, PUNJAB',
    masterId: 17305,
  },
  {
    type: 'cityName',
    value: 'PIPRAICH, UTTAR PRADESH',
    masterId: 14423,
  },
  {
    type: 'cityName',
    value: 'PIPALWALI CHOWK, MADHYA PRADESH',
    masterId: 17793,
  },
  {
    type: 'cityName',
    value: 'PIPLOD, GUJARAT',
    masterId: 14417,
  },
  {
    type: 'cityName',
    value: 'PANCHPATIA DEORIA, BIHAR',
    masterId: 18671,
  },
  {
    type: 'cityName',
    value: 'PANDU PINDARA, HARYANA',
    masterId: 18276,
  },
  {
    type: 'cityName',
    value: 'PIPRADIH, BIHAR',
    masterId: 18134,
  },
  {
    type: 'cityName',
    value: 'PAINTEPUR, UTTAR PRADESH',
    masterId: 16376,
  },
  {
    type: 'cityName',
    value: 'PAPRERA, RAJASTHAN',
    masterId: 17254,
  },
  {
    type: 'cityName',
    value: 'PIPLODA BAGLA, MADHYA PRADESH',
    masterId: 14419,
  },
  {
    type: 'cityName',
    value: 'PRINCEP GHAT, WEST BENGAL',
    masterId: 21131,
  },
  {
    type: 'cityName',
    value: 'PIPRIDIH, UTTAR PRADESH',
    masterId: 16358,
  },
  {
    type: 'cityName',
    value: 'PIPARIYA, MADHYA PRADESH',
    masterId: 14412,
  },
  {
    type: 'cityName',
    value: 'POPHLAJ, MAHARASHTRA',
    masterId: 14453,
  },
  {
    type: 'cityName',
    value: 'PHAPHRAKUND, UTTAR PRADESH',
    masterId: 16361,
  },
  {
    type: 'cityName',
    value: 'PIMPLA CHAURE, MAHARASHTRA',
    masterId: 17596,
  },
  {
    type: 'cityName',
    value: 'PIPLI, GUJARAT',
    masterId: 14414,
  },
  {
    type: 'cityName',
    value: 'PANDURANGAPURAM, ANDHRA PRADESH',
    masterId: 14205,
  },
  {
    type: 'cityName',
    value: 'PAPPINISSERI, KERALA',
    masterId: 17940,
  },
  {
    type: 'cityName',
    value: 'SALVA, RAJASTHAN',
    masterId: 14859,
  },
  {
    type: 'cityName',
    value: 'PIPRAHAN, BIHAR',
    masterId: 18665,
  },
  {
    type: 'cityName',
    value: 'PIPILIYA ROAD, GUJARAT',
    masterId: 20815,
  },
  {
    type: 'cityName',
    value: 'PIRPAINTI, JHARKHAND',
    masterId: 14427,
  },
  {
    type: 'cityName',
    value: 'PIPRITHAN, BIHAR',
    masterId: 18664,
  },
  {
    type: 'cityName',
    value: 'PUSHPATHUR, TAMIL NADU',
    masterId: 16895,
  },
  {
    type: 'cityName',
    value: 'PEEPARPUR, UTTAR PRADESH',
    masterId: 16364,
  },
  {
    type: 'cityName',
    value: 'PACHPERWA, UTTAR PRADESH',
    masterId: 16378,
  },
  {
    type: 'cityName',
    value: 'PAPATAPALLI, TELANGANA',
    masterId: 16803,
  },
  {
    type: 'cityName',
    value: 'PEDDAMPET, ANDHRA PRADESH',
    masterId: 14336,
  },
  {
    type: 'cityName',
    value: 'PRANPUR, BIHAR',
    masterId: 18661,
  },
  {
    type: 'cityName',
    value: 'PINDKEPAR, MAHARASHTRA',
    masterId: 17595,
  },
  {
    type: 'cityName',
    value: 'PINDIAL, ANDHRA PRADESH',
    masterId: 14405,
  },
  {
    type: 'cityName',
    value: 'PARIAWAN K.K.RD, UTTAR PRADESH',
    masterId: 14249,
  },
  {
    type: 'cityName',
    value: 'PUNIYAVANT, GUJARAT',
    masterId: 18412,
  },
  {
    type: 'cityName',
    value: 'PARHANA MAU, MADHYA PRADESH',
    masterId: 17794,
  },
  {
    type: 'cityName',
    value: 'PABLI KHAS, UTTAR PRADESH',
    masterId: 16379,
  },
  {
    type: 'cityName',
    value: 'PUNDIBARI, WEST BENGAL',
    masterId: 16202,
  },
  {
    type: 'cityName',
    value: 'PALLA ROAD, WEST BENGAL',
    masterId: 21217,
  },
  {
    type: 'cityName',
    value: 'PARBATI, MADHYA PRADESH',
    masterId: 14242,
  },
  {
    type: 'cityName',
    value: 'PRATAP BAGH, MAHARASHTRA',
    masterId: 20901,
  },
  {
    type: 'cityName',
    value: 'PARSA BAZAR, BIHAR',
    masterId: 18666,
  },
  {
    type: 'cityName',
    value: 'PERECHERLA, ANDHRA PRADESH',
    masterId: 14362,
  },
  {
    type: 'cityName',
    value: 'PORADANGA, WEST BENGAL',
    masterId: 16089,
  },
  {
    type: 'cityName',
    value: 'PARADOL, MADHYA PRADESH',
    masterId: 14230,
  },
  {
    type: 'cityName',
    value: 'PARADIP, ORISSA',
    masterId: 14229,
  },
  {
    type: 'cityName',
    value: 'PAHARA, UTTAR PRADESH',
    masterId: 17094,
  },
  {
    type: 'cityName',
    value: 'PARSIPUR, UTTAR PRADESH',
    masterId: 14263,
  },
  {
    type: 'cityName',
    value: 'PAHRJA GANGUR, BIHAR',
    masterId: 18673,
  },
  {
    type: 'cityName',
    value: 'PATHRI, UTTARAKHAND',
    masterId: 14299,
  },
  {
    type: 'cityName',
    value: 'PRANTIJ, GUJARAT',
    masterId: 18532,
  },
  {
    type: 'cityName',
    value: 'PARKHAM, UTTAR PRADESH',
    masterId: 16370,
  },
  {
    type: 'cityName',
    value: 'PURUA KHERA, UTTAR PRADESH',
    masterId: 14514,
  },
  {
    type: 'cityName',
    value: 'PARKANHATTI, KARNATAKA',
    masterId: 17985,
  },
  {
    type: 'cityName',
    value: 'PARIKKAL, TAMIL NADU',
    masterId: 16909,
  },
  {
    type: 'cityName',
    value: 'POLUR, TAMIL NADU',
    masterId: 14444,
  },
  {
    type: 'cityName',
    value: 'PARLI, MAHARASHTRA',
    masterId: 14255,
  },
  {
    type: 'cityName',
    value: 'PEERUMADARA, UTTARAKHAND',
    masterId: 16240,
  },
  {
    type: 'cityName',
    value: 'PARAUNA, UTTAR PRADESH',
    masterId: 18809,
  },
  {
    type: 'cityName',
    value: 'PURNIA, BIHAR',
    masterId: 14513,
  },
  {
    type: 'cityName',
    value: 'PERINAD, KERALA',
    masterId: 17939,
  },
  {
    type: 'cityName',
    value: 'PRITAM NAGAR, MADHYA PRADESH',
    masterId: 20878,
  },
  {
    type: 'cityName',
    value: 'PORJANPUR, MADHYA PRADESH',
    masterId: 16053,
  },
  {
    type: 'cityName',
    value: 'PERIYANAGA THUNAI, TAMIL NADU',
    masterId: 16906,
  },
  {
    type: 'cityName',
    value: 'PAHARPUR, BIHAR',
    masterId: 14127,
  },
  {
    type: 'cityName',
    value: 'PT. RAM PRASAD BISMIL PARK, UTTAR PRADESH',
    masterId: 16354,
  },
  {
    type: 'cityName',
    value: 'PURULIA, WEST BENGAL',
    masterId: 14515,
  },
  {
    type: 'cityName',
    value: 'PANDRASALI, JHARKHAND',
    masterId: 18137,
  },
  {
    type: 'cityName',
    value: 'PRASADPUR, UTTAR PRADESH',
    masterId: 16203,
  },
  {
    type: 'cityName',
    value: 'PAHARSAR, RAJASTHAN',
    masterId: 17093,
  },
  {
    type: 'cityName',
    value: 'PANRUTI, TAMIL NADU',
    masterId: 14219,
  },
  {
    type: 'cityName',
    value: 'PIRTALA, WEST BENGAL',
    masterId: 14428,
  },
  {
    type: 'cityName',
    value: 'PRATAP NAGAR, GUJARAT',
    masterId: 17251,
  },
  {
    type: 'cityName',
    value: 'PARTAPUR, UTTAR PRADESH',
    masterId: 14267,
  },
  {
    type: 'cityName',
    value: 'PARLU, RAJASTHAN',
    masterId: 17092,
  },
  {
    type: 'cityName',
    value: 'PRITHWIRAJPUR, RAJASTHAN',
    masterId: 17087,
  },
  {
    type: 'cityName',
    value: 'PUKKIRAVARI, TAMIL NADU',
    masterId: 16899,
  },
  {
    type: 'cityName',
    value: 'PARWAKHURD, MAHARASHTRA',
    masterId: 17598,
  },
  {
    type: 'cityName',
    value: 'PAREWADI, MAHARASHTRA',
    masterId: 14248,
  },
  {
    type: 'cityName',
    value: 'PARAIYA, BIHAR',
    masterId: 18669,
  },
  {
    type: 'cityName',
    value: 'PARSA, UTTAR PRADESH',
    masterId: 18667,
  },
  {
    type: 'cityName',
    value: 'BALAPUR, MAHARASHTRA',
    masterId: 10420,
  },
  {
    type: 'cityName',
    value: 'KASIBUGGA, ANDHRA PRADESH',
    masterId: 12583,
  },
  {
    type: 'cityName',
    value: 'PURBASTHALI, WEST BENGAL',
    masterId: 14510,
  },
  {
    type: 'cityName',
    value: 'PARSABAD, JHARKHAND',
    masterId: 14259,
  },
  {
    type: 'cityName',
    value: 'PARSODA, MAHARASHTRA',
    masterId: 14264,
  },
  {
    type: 'cityName',
    value: 'PASIVEDALA, ANDHRA PRADESH',
    masterId: 14276,
  },
  {
    type: 'cityName',
    value: 'PUSAULI, BIHAR',
    masterId: 14518,
  },
  {
    type: 'cityName',
    value: 'PATRASAF, WEST BENGAL',
    masterId: 21119,
  },
  {
    type: 'cityName',
    value: 'PATASAHI, ORISSA',
    masterId: 17448,
  },
  {
    type: 'cityName',
    value: 'PARISAL, RAJASTHAN',
    masterId: 14252,
  },
  {
    type: 'cityName',
    value: 'PARSOLI, RAJASTHAN',
    masterId: 14265,
  },
  {
    type: 'cityName',
    value: 'PASALAPUDI, ANDHRA PRADESH',
    masterId: 19056,
  },
  {
    type: 'cityName',
    value: 'PARSENDI, UTTAR PRADESH',
    masterId: 16367,
  },
  {
    type: 'cityName',
    value: 'MAKDAWAN, MADHYA PRADESH',
    masterId: 13288,
  },
  {
    type: 'cityName',
    value: 'PRASANNAYANAPAL, ANDHRA PRADESH',
    masterId: 14466,
  },
  {
    type: 'cityName',
    value: 'SONDIHA, BIHAR',
    masterId: 15271,
  },
  {
    type: 'cityName',
    value: 'GANMOR, JHARKHAND',
    masterId: 11645,
  },
  {
    type: 'cityName',
    value: 'PARSNEU, RAJASTHAN',
    masterId: 17091,
  },
  {
    type: 'cityName',
    value: 'PARSAUNI, BIHAR',
    masterId: 20759,
  },
  {
    type: 'cityName',
    value: 'PATLI, HARYANA',
    masterId: 17303,
  },
  {
    type: 'cityName',
    value: 'PATIALA, PUNJAB',
    masterId: 14302,
  },
  {
    type: 'cityName',
    value: 'PATIA P.H, ORISSA',
    masterId: 17447,
  },
  {
    type: 'cityName',
    value: 'PATULI, WEST BENGAL',
    masterId: 17446,
  },
  {
    type: 'cityName',
    value: 'PATTAMBI, KERALA',
    masterId: 14311,
  },
  {
    type: 'cityName',
    value: 'PETLAD JN, GUJARAT',
    masterId: 20802,
  },
  {
    type: 'cityName',
    value: 'PATIALA CANTT, PUNJAB',
    masterId: 17304,
  },
  {
    type: 'cityName',
    value: 'PATRANGA, UTTAR PRADESH',
    masterId: 14307,
  },
  {
    type: 'cityName',
    value: 'PATOHAN, MADHYA PRADESH',
    masterId: 18239,
  },
  {
    type: 'cityName',
    value: 'PATIALI, UTTAR PRADESH',
    masterId: 19183,
  },
  {
    type: 'cityName',
    value: 'PATHANKOT, PUNJAB',
    masterId: 14287,
  },
  {
    type: 'cityName',
    value: 'PATHARKANDI, ASSAM',
    masterId: 18962,
  },
  {
    type: 'cityName',
    value: 'POTKAPALLI, ANDHRA PRADESH',
    masterId: 14460,
  },
  {
    type: 'cityName',
    value: 'PATIPUKUR, WEST BENGAL',
    masterId: 21136,
  },
  {
    type: 'cityName',
    value: 'PATILADAHA, ASSAM',
    masterId: 18961,
  },
  {
    type: 'cityName',
    value: 'PATHOLI, UTTAR PRADESH',
    masterId: 14295,
  },
  {
    type: 'cityName',
    value: 'PUTLUR HALT, TAMIL NADU',
    masterId: 20982,
  },
  {
    type: 'cityName',
    value: 'PATAN, GUJARAT',
    masterId: 14279,
  },
  {
    type: 'cityName',
    value: 'PATEL NAGAR, DELHI',
    masterId: 18577,
  },
  {
    type: 'cityName',
    value: 'BORKHEDI, MADHYA PRADESH',
    masterId: 10895,
  },
  {
    type: 'cityName',
    value: 'PRATABPUR, UTTAR PRADESH',
    masterId: 16355,
  },
  {
    type: 'cityName',
    value: 'PATARA, UTTAR PRADESH',
    masterId: 14281,
  },
  {
    type: 'cityName',
    value: 'PATHRALA, PUNJAB',
    masterId: 14297,
  },
  {
    type: 'cityName',
    value: 'PATRATU, JHARKHAND',
    masterId: 14308,
  },
  {
    type: 'cityName',
    value: 'PUTALAPATTU, ANDHRA PRADESH',
    masterId: 14520,
  },
  {
    type: 'cityName',
    value: 'PATTAN, JAMMU AND KASHMIR',
    masterId: 20837,
  },
  {
    type: 'cityName',
    value: 'PARTUR, MAHARASHTRA',
    masterId: 14270,
  },
  {
    type: 'cityName',
    value: 'MADANPURA, MADHYA PRADESH',
    masterId: 13199,
  },
  {
    type: 'cityName',
    value: 'PATIYARA, UTTAR PRADESH',
    masterId: 16366,
  },
  {
    type: 'cityName',
    value: 'PATSUL, MAHARASHTRA',
    masterId: 14309,
  },
  {
    type: 'cityName',
    value: 'PATCHUR, TAMIL NADU',
    masterId: 14284,
  },
  {
    type: 'cityName',
    value: 'PULLA, ANDHRA PRADESH',
    masterId: 14489,
  },
  {
    type: 'cityName',
    value: 'PHANDA, MADHYA PRADESH',
    masterId: 14383,
  },
  {
    type: 'cityName',
    value: 'PUDI, ANDHRA PRADESH',
    masterId: 19005,
  },
  {
    type: 'cityName',
    value: 'PAUTA, UTTAR PRADESH',
    masterId: 16365,
  },
  {
    type: 'cityName',
    value: 'PUNGUDI, TAMIL NADU',
    masterId: 16897,
  },
  {
    type: 'cityName',
    value: 'PUSHKAR TERMINUS, RAJASTHAN',
    masterId: 17086,
  },
  {
    type: 'cityName',
    value: 'PUDUKAD, KERALA',
    masterId: 14473,
  },
  {
    type: 'cityName',
    value: 'RAMPURA PHUL, PUNJAB',
    masterId: 14637,
  },
  {
    type: 'cityName',
    value: 'PALLIPPURAM, KERALA',
    masterId: 17911,
  },
  {
    type: 'cityName',
    value: 'PENUMARRU, ANDHRA PRADESH',
    masterId: 14354,
  },
  {
    type: 'cityName',
    value: 'PUNDI, ANDHRA PRADESH',
    masterId: 14498,
  },
  {
    type: 'cityName',
    value: 'PUNE, MAHARASHTRA',
    masterId: 14499,
  },
  {
    type: 'cityName',
    value: 'PIR UMROD, MADHYA PRADESH',
    masterId: 14425,
  },
  {
    type: 'cityName',
    value: 'PURANIGUDAM, ASSAM',
    masterId: 18869,
  },
  {
    type: 'cityName',
    value: 'PURI, ORISSA',
    masterId: 14511,
  },
  {
    type: 'cityName',
    value: 'PHUSRO, JHARKHAND',
    masterId: 16055,
  },
  {
    type: 'cityName',
    value: 'PUSLA, MAHARASHTRA',
    masterId: 17594,
  },
  {
    type: 'cityName',
    value: 'PUTTUR, ANDHRA PRADESH',
    masterId: 14527,
  },
  {
    type: 'cityName',
    value: 'PUNALUR, TAMIL NADU',
    masterId: 14495,
  },
  {
    type: 'cityName',
    value: 'PATUWAS MEHRANA, HARYANA ',
    masterId: 18273,
  },
  {
    type: 'cityName',
    value: 'PAUWARA HALT, CHHATTISGARH',
    masterId: 20787,
  },
  {
    type: 'cityName',
    value: 'PARASIA, MADHYA PRADESH',
    masterId: 14237,
  },
  {
    type: 'cityName',
    value: 'PHULAGURI, ASSAM',
    masterId: 18960,
  },
  {
    type: 'cityName',
    value: 'PALLAVARAM, ANDHRA PRADESH',
    masterId: 20734,
  },
  {
    type: 'cityName',
    value: 'PEDAVADLAPUDI, ANDHRA PRADESH',
    masterId: 14333,
  },
  {
    type: 'cityName',
    value: 'PASUPATHIKOIL, TAMIL NADU',
    masterId: 17030,
  },
  {
    type: 'cityName',
    value: 'PAVUNJUR, TAMIL NADU',
    masterId: 16907,
  },
  {
    type: 'cityName',
    value: 'PARVATHIPURAM, ANDHRA PRADESH',
    masterId: 14272,
  },
  {
    type: 'cityName',
    value: 'PANDHARPUR, MAHARASHTRA',
    masterId: 14200,
  },
  {
    type: 'cityName',
    value: 'PIRAVAM ROAD, KERALA',
    masterId: 14426,
  },
  {
    type: 'cityName',
    value: 'PARAVUR, KERALA',
    masterId: 14241,
  },
  {
    type: 'cityName',
    value: 'PARVEZEPUR, RAJASTHAN',
    masterId: 18274,
  },
  {
    type: 'cityName',
    value: 'PIRWA, RAJASTHAN',
    masterId: 16356,
  },
  {
    type: 'cityName',
    value: 'PRAWAI BROHMSTHAN HA, BIHAR',
    masterId: 18564,
  },
  {
    type: 'cityName',
    value: 'PALWAL, HARYANA',
    masterId: 14174,
  },
  {
    type: 'cityName',
    value: 'PALPARA, WEST BENGAL',
    masterId: 16092,
  },
  {
    type: 'cityName',
    value: 'PERUNDURAI, TAMIL NADU',
    masterId: 14371,
  },
  {
    type: 'cityName',
    value: 'PEDAPARIYA, ANDHRA PRADESH',
    masterId: 19009,
  },
  {
    type: 'cityName',
    value: 'PALLIYADI, TAMIL NADU',
    masterId: 14168,
  },
  {
    type: 'cityName',
    value: 'PAYLI, RAJASTHAN',
    masterId: 17090,
  },
  {
    type: 'cityName',
    value: 'PIYALA BLOCK HUT, HARYANA',
    masterId: 18267,
  },
  {
    type: 'cityName',
    value: 'PAYYOLI, KERALA',
    masterId: 14325,
  },
  {
    type: 'cityName',
    value: 'PEYANAPALLE, ANDHRA PRADESH',
    masterId: 19007,
  },
  {
    type: 'cityName',
    value: 'QADIAN, PUNJAB',
    masterId: 19554,
  },
  {
    type: 'cityName',
    value: 'QUAZIGUND, JAMMU AND KASHMIR',
    masterId: 20826,
  },
  {
    type: 'cityName',
    value: 'KOYILANDY, KERALA',
    masterId: 12944,
  },
  {
    type: 'cityName',
    value: 'KOLLAM, KERALA',
    masterId: 12848,
  },
  {
    type: 'cityName',
    value: 'KILA RAIPUR, PUNJAB',
    masterId: 12780,
  },
  {
    type: 'cityName',
    value: 'KANSRAO, UTTARAKHAND',
    masterId: 12510,
  },
  {
    type: 'cityName',
    value: 'QUTABPUR, HARYANA',
    masterId: 18266,
  },
  {
    type: 'cityName',
    value: 'KUCHESAR, UTTAR PRADESH',
    masterId: 16745,
  },
  {
    type: 'cityName',
    value: 'RAIPUR, CHHATTISGARH',
    masterId: 14561,
  },
  {
    type: 'cityName',
    value: 'RAMPADA, GUJARAT',
    masterId: 14630,
  },
  {
    type: 'cityName',
    value: 'BARARA, HARYANA',
    masterId: 10510,
  },
  {
    type: 'cityName',
    value: 'RAIGIR, ANDHRA PRADESH',
    masterId: 14558,
  },
  {
    type: 'cityName',
    value: 'RAJAGAMBEERAM, TAMIL NADU',
    masterId: 16894,
  },
  {
    type: 'cityName',
    value: 'VADGAON NILA, MAHARASHTRA',
    masterId: 16084,
  },
  {
    type: 'cityName',
    value: 'RAMGARH, RAJASTHAN',
    masterId: 16084,
  },
  {
    type: 'cityName',
    value: 'RAHA, ASSAM',
    masterId: 18601,
  },
  {
    type: 'cityName',
    value: 'RAIBHA, UTTAR PRADESH',
    masterId: 16353,
  },
  {
    type: 'cityName',
    value: 'REDHAKHOL, ORISSA',
    masterId: 14714,
  },
  {
    type: 'cityName',
    value: 'RAJPIPLA, GUJARAT',
    masterId: 18530,
  },
  {
    type: 'cityName',
    value: 'NIKHAREWADI, MAHARASHTRA',
    masterId: 14003,
  },
  {
    type: 'cityName',
    value: 'RAMKOT, UTTAR PRADESH',
    masterId: 16726,
  },
  {
    type: 'cityName',
    value: 'RETHORAKALAN, MADHYA PRADESH',
    masterId: 14728,
  },
  {
    type: 'cityName',
    value: 'REPALLE, ANDHRA PRADESH',
    masterId: 14727,
  },
  {
    type: 'cityName',
    value: 'RAMAPURAM-CHENNAI, ANDHRA PRADESH',
    masterId: 17026,
  },
  {
    type: 'cityName',
    value: 'RAMVA, UTTAR PRADESH',
    masterId: 21028,
  },
  {
    type: 'cityName',
    value: 'RAMAIPUR, UTTAR PRADESH',
    masterId: 16348,
  },
  {
    type: 'cityName',
    value: 'RANI, RAJASTHAN',
    masterId: 14658,
  },
  {
    type: 'cityName',
    value: 'RASIPURAM, TAMIL NADU',
    masterId: 14679,
  },
  {
    type: 'cityName',
    value: 'RAY, JHARKHAND',
    masterId: 14700,
  },
  {
    type: 'cityName',
    value: 'RAYA, PRADESH',
    masterId: 19134,
  },
  {
    type: 'cityName',
    value: 'RAMBHA, ORISSA',
    masterId: 14612,
  },
  {
    type: 'cityName',
    value: 'TARAUNA, UTTAR PRADESH',
    masterId: 15445,
  },
  {
    type: 'cityName',
    value: 'RAIBAG, KARNATAKA',
    masterId: 14554,
  },
  {
    type: 'cityName',
    value: 'ROBERTSGANJ, UTTAR PRADESH',
    masterId: 14745,
  },
  {
    type: 'cityName',
    value: 'RAJBANDH, WEST BENGAL',
    masterId: 16201,
  },
  {
    type: 'cityName',
    value: 'RAIBOJHA, UTTAR PRADESH',
    masterId: 16352,
  },
  {
    type: 'cityName',
    value: 'BAHODAKHERA, UTTAR PRADESH',
    masterId: 10390,
  },
  {
    type: 'cityName',
    value: 'RAEBARELI, UTTAR PRADESH',
    masterId: 14536,
  },
  {
    type: 'cityName',
    value: 'RIBDA, GUJARAT',
    masterId: 18405,
  },
  {
    type: 'cityName',
    value: 'RUPBAS, RAJASTHAN',
    masterId: 14770,
  },
  {
    type: 'cityName',
    value: 'RAMBHADRAPUR, BIHAR',
    masterId: 14613,
  },
  {
    type: 'cityName',
    value: 'RAICHUR, KARNATAKA',
    masterId: 14555,
  },
  {
    type: 'cityName',
    value: 'RENTACHINTALA, ANDHRA PRADESH',
    masterId: 19002,
  },
  {
    type: 'cityName',
    value: 'RAIL COACH FACTORY, PUNJAB',
    masterId: 16351,
  },
  {
    type: 'cityName',
    value: 'RACHAGUNNERI, ANDHRA PRADESH',
    masterId: 19004,
  },
  {
    type: 'cityName',
    value: 'RICHUGHUTU, JHARKHAND',
    masterId: 18212,
  },
  {
    type: 'cityName',
    value: 'RANAYALGADRI, MADHYA PRADESH',
    masterId: 14646,
  },
  {
    type: 'cityName',
    value: 'RAMACHANDRAPURAM, UTTAR PRADESH',
    masterId: 16828,
  },
  {
    type: 'cityName',
    value: 'RATAR CHATTAR, PUNJAB',
    masterId: 20944,
  },
  {
    type: 'cityName',
    value: 'RAMCHAURA, UTTAR PRADESH',
    masterId: 18805,
  },
  {
    type: 'cityName',
    value: 'RAGHUNATHPUR, ORISSA',
    masterId: 14544,
  },
  {
    type: 'cityName',
    value: 'RAM DAYALU NAGAR, BIHAR',
    masterId: 18659,
  },
  {
    type: 'cityName',
    value: 'RIKHABDEV, RAJASTHAN',
    masterId: 17080,
  },
  {
    type: 'cityName',
    value: 'SONIPAT, HARYANA',
    masterId: 15277,
  },
  {
    type: 'cityName',
    value: 'RUNDHI, HARYANA',
    masterId: 18261,
  },
  {
    type: 'cityName',
    value: 'RADHAGAON, JHARKHAND',
    masterId: 18131,
  },
  {
    type: 'cityName',
    value: 'RAYADURG, ANDHRA PRADESH',
    masterId: 14703,
  },
  {
    type: 'cityName',
    value: 'RADHANPUR, GUJARAT',
    masterId: 14534,
  },
  {
    type: 'cityName',
    value: 'KARDI, KARNATAKA',
    masterId: 19114,
  },
  {
    type: 'cityName',
    value: 'RUDAULI, UTTAR PRADESH',
    masterId: 14762,
  },
  {
    type: 'cityName',
    value: 'RAMAGUNDAM, ANDHRA PRADESH',
    masterId: 14600,
  },
  {
    type: 'cityName',
    value: 'RUDAIN, UTTAR PRADESH',
    masterId: 16336,
  },
  {
    type: 'cityName',
    value: 'RADHIKAPUR, WEST BENGAL',
    masterId: 14535,
  },
  {
    type: 'cityName',
    value: 'RAMDEVRA, RAJASTHAN',
    masterId: 14616,
  },
  {
    type: 'cityName',
    value: 'RAMDAS, PUNJAB',
    masterId: 20943,
  },
  {
    type: 'cityName',
    value: 'RAVTHA ROAD, RAJASTHAN',
    masterId: 14695,
  },
  {
    type: 'cityName',
    value: 'RADHAMOHANPUR, WEST BENGAL',
    masterId: 16087,
  },
  {
    type: 'cityName',
    value: 'RAMPUR DUMRA, BIHAR',
    masterId: 14635,
  },
  {
    type: 'cityName',
    value: 'RADHA BALAMPUR, UTTAR PRADESH',
    masterId: 16727,
  },
  {
    type: 'cityName',
    value: 'REWARI, HARYANA',
    masterId: 14736,
  },
  {
    type: 'cityName',
    value: 'RECHNI ROAD, ANDHRA PRADESH',
    masterId: 14711,
  },
  {
    type: 'cityName',
    value: 'REGUPALEM, ANDHRA PRADESH',
    masterId: 14717,
  },
  {
    type: 'cityName',
    value: 'RITHI, MADHYA PRADESH',
    masterId: 14742,
  },
  {
    type: 'cityName',
    value: 'REJINAGAR, WEST BENGAL',
    masterId: 14718,
  },
  {
    type: 'cityName',
    value: 'REDDIGUDEM, ANDHRA PRADESH',
    masterId: 14712,
  },
  {
    type: 'cityName',
    value: 'REMA, JHARKHAND',
    masterId: 16339,
  },
  {
    type: 'cityName',
    value: 'REN, RAJASTHAN',
    masterId: 14721,
  },
  {
    type: 'cityName',
    value: 'RENHAT, MADHYA PRADESH',
    masterId: 17783,
  },
  {
    type: 'cityName',
    value: 'RASAULI, UTTAR PRADESH',
    masterId: 16345,
  },
  {
    type: 'cityName',
    value: 'RENTIA, GUJARAT',
    masterId: 18406,
  },
  {
    type: 'cityName',
    value: 'REWA, MADHYA PRADESH',
    masterId: 14735,
  },
  {
    type: 'cityName',
    value: 'RAFALESHWAR, GUJARAT',
    masterId: 20811,
  },
  {
    type: 'cityName',
    value: 'RAFIGANJ, BIHAR',
    masterId: 14537,
  },
  {
    type: 'cityName',
    value: 'RAFINAGAR, UTTAR PRADESH',
    masterId: 19184,
  },
  {
    type: 'cityName',
    value: 'RAJGHAT NARORA, UTTAR PRADESH',
    masterId: 14582,
  },
  {
    type: 'cityName',
    value: 'RAJGODA, WEST BENGAL',
    masterId: 21097,
  },
  {
    type: 'cityName',
    value: 'RAMGANGA, UTTAR PRADESH',
    masterId: 14621,
  },
  {
    type: 'cityName',
    value: 'RAJGIR, BIHAR',
    masterId: 14584,
  },
  {
    type: 'cityName',
    value: 'RAYAGADA, ORISSA',
    masterId: 14704,
  },
  {
    type: 'cityName',
    value: 'RADOGARH, MADHYA PRADESH',
    masterId: 19127,
  },
  {
    type: 'cityName',
    value: 'RAMAGIRI, KARNATAKA',
    masterId: 14599,
  },
  {
    type: 'cityName',
    value: 'RAIGANJ, WEST BENGAL',
    masterId: 14556,
  },
  {
    type: 'cityName',
    value: 'RANGJULI, ASSAM',
    masterId: 18867,
  },
  {
    type: 'cityName',
    value: 'RENGALI, ORISSA',
    masterId: 14722,
  },
  {
    type: 'cityName',
    value: 'RAGHOULI, UTTAR PRADESH',
    masterId: 17790,
  },
  {
    type: 'cityName',
    value: 'RANGAPURAM, ANDHRA PRADESH',
    masterId: 14652,
  },
  {
    type: 'cityName',
    value: 'RAGHUNATHGARH, RAJASTHAN',
    masterId: 17250,
  },
  {
    type: 'cityName',
    value: 'ROTEGAON, MAHARASHTRA',
    masterId: 14757,
  },
  {
    type: 'cityName',
    value: 'RAGHUNATHPALLI, ANDHRA PRADESH',
    masterId: 14542,
  },
  {
    type: 'cityName',
    value: 'RAGHAVAPURAM, ANDHRA PRADESH',
    masterId: 14539,
  },
  {
    type: 'cityName',
    value: 'RAIGAD, GUJARAT',
    masterId: 17726,
  },
  {
    type: 'cityName',
    value: 'REENGUS, RAJASTHAN',
    masterId: 14715,
  },
  {
    type: 'cityName',
    value: 'RAJGHAT, ORISSA ',
    masterId: 17442,
  },
  {
    type: 'cityName',
    value: 'MAUDAHA, UTTAR PRADESH',
    masterId: 13523,
  },
  {
    type: 'cityName',
    value: 'RAGHUNATHBARI, WEST BENGAL',
    masterId: 21239,
  },
  {
    type: 'cityName',
    value: 'RANAGHAT, WEST BENGAL',
    masterId: 14641,
  },
  {
    type: 'cityName',
    value: 'KULDIHA, JHARKHAND',
    masterId: 12990,
  },
  {
    type: 'cityName',
    value: 'RAJGARH, RAJASTHAN',
    masterId: 14581,
  },
  {
    type: 'cityName',
    value: 'RAKHI, RAJASTHAN',
    masterId: 20961,
  },
  {
    type: 'cityName',
    value: 'RAHAMA, ORISSA',
    masterId: 14547,
  },
  {
    type: 'cityName',
    value: 'ROSHANPUR, UTTAR PRADESH',
    masterId: 14756,
  },
  {
    type: 'cityName',
    value: 'RAJHURA, JHARKHAND',
    masterId: 19110,
  },
  {
    type: 'cityName',
    value: 'ROHIRA, PUNJAB',
    masterId: 17301,
  },
  {
    type: 'cityName',
    value: 'RAIGARH, CHHATTISGARH',
    masterId: 14557,
  },
  {
    type: 'cityName',
    value: 'RIGA, BIHAR',
    masterId: 20766,
  },
  {
    type: 'cityName',
    value: 'RAIKHEDA, MADHYA PRADESH',
    masterId: 18625,
  },
  {
    type: 'cityName',
    value: 'RISHIKUND, BIHAR',
    masterId: 18656,
  },
  {
    type: 'cityName',
    value: 'RAJIM, CHHATTISGARH',
    masterId: 18598,
  },
  {
    type: 'cityName',
    value: 'RISHRA, UTTARAKHAND',
    masterId: 21063,
  },
  {
    type: 'cityName',
    value: 'RAWAT GANJ, UTTAR PRADESH',
    masterId: 17176,
  },
  {
    type: 'cityName',
    value: 'KEWAN, BIHAR',
    masterId: 12668,
  },
  {
    type: 'cityName',
    value: 'RAJNAGAR, MADHYA PRADESH',
    masterId: 19122,
  },
  {
    type: 'cityName',
    value: 'RAJAPUR, ANDHRA PRADESH',
    masterId: 14575,
  },
  {
    type: 'cityName',
    value: 'RAJABERA, JHARKHAND',
    masterId: 18130,
  },
  {
    type: 'cityName',
    value: 'RAJPARDI, GUJARAT',
    masterId: 18531,
  },
  {
    type: 'cityName',
    value: 'AMBHUA, WEST BENGAL',
    masterId: 10151,
  },
  {
    type: 'cityName',
    value: 'RAJATHAGARH, ORISSA',
    masterId: 17443,
  },
  {
    type: 'cityName',
    value: 'RAJAWARI, UTTAR PRADESH',
    masterId: 16350,
  },
  {
    type: 'cityName',
    value: 'RAJA KA SAHASPR, UTTAR PRADESH',
    masterId: 14565,
  },
  {
    type: 'cityName',
    value: 'RAJMAHAL, JHARKHAND',
    masterId: 18129,
  },
  {
    type: 'cityName',
    value: 'RAJALUKAH, ODISHA',
    masterId: 20910,
  },
  {
    type: 'cityName',
    value: 'RAJMALPUR, UTTAR PRADESH',
    masterId: 16349,
  },
  {
    type: 'cityName',
    value: 'RAJNANDGAON, CHHATTISGARH',
    masterId: 14589,
  },
  {
    type: 'cityName',
    value: 'SIMARIYA, BIHAR',
    masterId: 15170,
  },
  {
    type: 'cityName',
    value: 'RAJAMPET, ANDHRA PRADESH',
    masterId: 14571,
  },
  {
    type: 'cityName',
    value: 'RAJAPALAYAM, TAMIL NADU',
    masterId: 14574,
  },
  {
    type: 'cityName',
    value: 'RAJALDESAR, RAJASTHAN',
    masterId: 14569,
  },
  {
    type: 'cityName',
    value: 'MALER, RAJASTHAN',
    masterId: 13312,
  },
  {
    type: 'cityName',
    value: 'RAJEWADI, MAHARASHTRA',
    masterId: 17593,
  },
  {
    type: 'cityName',
    value: 'RAJAHMUNDRY, ANDHRA PRADESH',
    masterId: 14567,
  },
  {
    type: 'cityName',
    value: 'ROORKEE, UTTARAKHAND',
    masterId: 14754,
  },
  {
    type: 'cityName',
    value: 'RUKADI, MAHARASHTRA',
    masterId: 14764,
  },
  {
    type: 'cityName',
    value: 'RAKHIAL, GUJARAT',
    masterId: 18529,
  },
  {
    type: 'cityName',
    value: 'RAMKANALI, WEST BENGAL',
    masterId: 16200,
  },
  {
    type: 'cityName',
    value: 'RAKHITPUR, JHARKHAND',
    masterId: 19104,
  },
  {
    type: 'cityName',
    value: 'RATANGRH KNKWAL, PUNJAB',
    masterId: 17302,
  },
  {
    type: 'cityName',
    value: 'RAMKOLA, UTTAR PRADESH',
    masterId: 14625,
  },
  {
    type: 'cityName',
    value: 'RATI KA NAGLA, UTTAR PRADESH',
    masterId: 16343,
  },
  {
    type: 'cityName',
    value: 'RANI GALI, UTTAR PRADESH',
    masterId: 16239,
  },
  {
    type: 'cityName',
    value: 'RISHIKESH, UTTARAKHAND',
    masterId: 14740,
  },
  {
    type: 'cityName',
    value: 'RAJKHARSAWAN, JHARKHAND',
    masterId: 14585,
  },
  {
    type: 'cityName',
    value: 'RUKHI, HARYANA',
    masterId: 17588,
  },
  {
    type: 'cityName',
    value: 'KOTHARIYA, GUJARAT',
    masterId: 18439,
  },
  {
    type: 'cityName',
    value: 'RAJKIYAWAS KHURD, RAJASTHAN',
    masterId: 14586,
  },
  {
    type: 'cityName',
    value: 'RAJULA, GUJARAT',
    masterId: 14595,
  },
  {
    type: 'cityName',
    value: 'RELANGI, ANDHRA PRADESH',
    masterId: 14719,
  },
  {
    type: 'cityName',
    value: 'ROHAL KHURD, MADHYA PRADESH',
    masterId: 17782,
  },
  {
    type: 'cityName',
    value: 'REGADIPALLI , ANDHRA PRADESH',
    masterId: 14716,
  },
  {
    type: 'cityName',
    value: 'RAYALACHERUVU, ANDHRA PRADESH',
    masterId: 14705,
  },
  {
    type: 'cityName',
    value: 'HARLAPUR, KARNATAKA',
    masterId: 18096,
  },
  {
    type: 'cityName',
    value: 'RAILA, RAJASTHAN',
    masterId: 17085,
  },
  {
    type: 'cityName',
    value: 'ROMANA ALBEL SINGH, PUNJAB',
    masterId: 17300,
  },
  {
    type: 'cityName',
    value: 'RAMANUJAMPALLI, ANDHRA PRADESH',
    masterId: 19003,
  },
  {
    type: 'cityName',
    value: 'RAJMANE, MAHARASHTRA',
    masterId: 16056,
  },
  {
    type: 'cityName',
    value: 'RAMGANJ MANDI, RAJASTHAN',
    masterId: 14622,
  },
  {
    type: 'cityName',
    value: 'RAMPURA BERI, RAJASTHAN',
    masterId: 14636,
  },
  {
    type: 'cityName',
    value: 'RAMANATHAPURAM, TAMIL NADU',
    masterId: 14604,
  },
  {
    type: 'cityName',
    value: 'BATAUA, JHARKHAND',
    masterId: 10584,
  },
  {
    type: 'cityName',
    value: 'RAMGANJ, UTTAR PRADESH',
    masterId: 17083,
  },
  {
    type: 'cityName',
    value: 'RAMANAGARAM, KARNATAKA',
    masterId: 14603,
  },
  {
    type: 'cityName',
    value: 'RANGMAHAL, RAJASTHAN',
    masterId: 14656,
  },
  {
    type: 'cityName',
    value: 'RAMRAJATALA, WEST BENGAL',
    masterId: 16083,
  },
  {
    type: 'cityName',
    value: 'RAM NAGAR J K, JAMMU AND KASHMIR',
    masterId: 14597,
  },
  {
    type: 'cityName',
    value: 'RAMESWARAM, TAMIL NADU',
    masterId: 14620,
  },
  {
    type: 'cityName',
    value: 'RAMAN, PUNJAB',
    masterId: 14601,
  },
  {
    type: 'cityName',
    value: 'RAMANNAPETA, ANDHRA PRADESH',
    masterId: 14610,
  },
  {
    type: 'cityName',
    value: 'RAHMAT NAGAR, UTTAR PRADESH',
    masterId: 16086,
  },
  {
    type: 'cityName',
    value: 'SASURVE, MAHARASHTRA',
    masterId: 14964,
  },
  {
    type: 'cityName',
    value: 'RAMPUR, WEST BENGAL',
    masterId: 14634,
  },
  {
    type: 'cityName',
    value: 'RAMPAHARI, MADHYA PRADESH',
    masterId: 17787,
  },
  {
    type: 'cityName',
    value: 'RAMPURHAT, JHARKHAND',
    masterId: 16199,
  },
  {
    type: 'cityName',
    value: 'RAMNAGAR, UTTARAKHAND',
    masterId: 14626,
  },
  {
    type: 'cityName',
    value: 'RAMNAGAR, WEST BENGAL',
    masterId: 14627,
  },
  {
    type: 'cityName',
    value: 'RAMSINGHPUR, RAJASTHAN',
    masterId: 16346,
  },
  {
    type: 'cityName',
    value: 'RAMGARH, JHARKHAND',
    masterId: 14623,
  },
  {
    type: 'cityName',
    value: 'RAMPUR, UTTAR PRADESH',
    masterId: 14633,
  },
  {
    type: 'cityName',
    value: 'RAMAVARAPADU, ANDHRA PRADESH',
    masterId: 19054,
  },
  {
    type: 'cityName',
    value: 'ROSHAN MAU, UTTAR PRADESH',
    masterId: 21020,
  },
  {
    type: 'cityName',
    value: 'RAMSAR, RAJASTHAN',
    masterId: 17082,
  },
  {
    type: 'cityName',
    value: 'RUKMAPUR, ANDHRA PRADESH',
    masterId: 14765,
  },
  {
    type: 'cityName',
    value: 'ROUTHPURAM, ANDHRA PRADESH',
    masterId: 19001,
  },
  {
    type: 'cityName',
    value: 'RATNAGIRI, MAHARASHTRA',
    masterId: 14689,
  },
  {
    type: 'cityName',
    value: 'ROHANA KALAN, UTTAR PRADESH',
    masterId: 16337,
  },
  {
    type: 'cityName',
    value: 'RANPURA, RAJASTHAN',
    masterId: 19147,
  },
  {
    type: 'cityName',
    value: 'RANA BORDI, GUJARAT',
    masterId: 18410,
  },
  {
    type: 'cityName',
    value: 'RAHENBHATA, ORISSA',
    masterId: 14550,
  },
  {
    type: 'cityName',
    value: 'RANJANIWADI, MAHARASHTRA',
    masterId: 14668,
  },
  {
    type: 'cityName',
    value: 'RANIGANJ, WEST BENGAL',
    masterId: 14660,
  },
  {
    type: 'cityName',
    value: 'RANGALITING, ASSAM',
    masterId: 14649,
  },
  {
    type: 'cityName',
    value: 'RAINAGAR, WEST BENGAL',
    masterId: 21108,
  },
  {
    type: 'cityName',
    value: 'RANGAPANI, WEST BENGAL',
    masterId: 18868,
  },
  {
    type: 'cityName',
    value: 'RANOLISHISHU, RAJASTHAN',
    masterId: 17081,
  },
  {
    type: 'cityName',
    value: 'RUNIJA, MADHYA PRADESH',
    masterId: 20879,
  },
  {
    type: 'cityName',
    value: 'RUNKUTA, UTTAR PRADESH',
    masterId: 16335,
  },
  {
    type: 'cityName',
    value: 'RANALA, MAHARASHTRA',
    masterId: 14643,
  },
  {
    type: 'cityName',
    value: 'RAJANUKUNTE, KARNATAKA',
    masterId: 14573,
  },
  {
    type: 'cityName',
    value: 'RANOLI, GUJARAT',
    masterId: 14670,
  },
  {
    type: 'cityName',
    value: 'MIHIJAM, WEST BENGAL',
    masterId: 13584,
  },
  {
    type: 'cityName',
    value: 'RENUKOOT, UTTAR PRADESH',
    masterId: 14725,
  },
  {
    type: 'cityName',
    value: 'RANIBENNUR, KARNATAKA',
    masterId: 14659,
  },
  {
    type: 'cityName',
    value: 'RANIPUR, UTTAR PRADESH',
    masterId: 18409,
  },
  {
    type: 'cityName',
    value: 'SAWAIMADHOPUR, RAJASTHAN',
    masterId: 14994,
  },
  {
    type: 'cityName',
    value: 'RANITAL, ORISSA',
    masterId: 18238,
  },
  {
    type: 'cityName',
    value: 'RATNAPUR, MADHYA PRADESH',
    masterId: 17725,
  },
  {
    type: 'cityName',
    value: 'RANIWARA, RAJASTHAN',
    masterId: 14664,
  },
  {
    type: 'cityName',
    value: 'RENWAL, RAJASTHAN',
    masterId: 16057,
  },
  {
    type: 'cityName',
    value: 'RANIPATRA, BIHAR',
    masterId: 18658,
  },
  {
    type: 'cityName',
    value: 'RANGIA, ASSAM',
    masterId: 14654,
  },
  {
    type: 'cityName',
    value: 'ROSERA, BIHAR',
    masterId: 14755,
  },
  {
    type: 'cityName',
    value: 'RAJGHATA, CHHATTISGARH',
    masterId: 14583,
  },
  {
    type: 'cityName',
    value: 'ROHA, MAHARASHTRA',
    masterId: 14747,
  },
  {
    type: 'cityName',
    value: 'ROHAD NAGAR, HARYANA',
    masterId: 18262,
  },
  {
    type: 'cityName',
    value: 'REOTI, BIHAR',
    masterId: 14726,
  },
  {
    type: 'cityName',
    value: 'ROHTAK, HARYANA',
    masterId: 14751,
  },
  {
    type: 'cityName',
    value: 'RAJULI, MAHARASHTRA ',
    masterId: 17592,
  },
  {
    type: 'cityName',
    value: 'RORA, UTTAR PRADESH',
    masterId: 17299,
  },
  {
    type: 'cityName',
    value: 'RAJOSI, RAJASTHAN',
    masterId: 17084,
  },
  {
    type: 'cityName',
    value: 'ROZA, UTTAR PRADESH',
    masterId: 14761,
  },
  {
    type: 'cityName',
    value: 'RANGAPARA NORTH, ANDAMAN AND NICOBAR ISLANDS',
    masterId: 14651,
  },
  {
    type: 'cityName',
    value: 'RUPNAGAR, PUNJAB',
    masterId: 14771,
  },
  {
    type: 'cityName',
    value: 'RUPASIBARI, ASSAM',
    masterId: 18865,
  },
  {
    type: 'cityName',
    value: 'RUPOND, MADHYA PRADESH',
    masterId: 14772,
  },
  {
    type: 'cityName',
    value: 'RASULPURGOGAMAU, UTTAR PRADESH',
    masterId: 16344,
  },
  {
    type: 'cityName',
    value: 'RAIPUR, HARYANA',
    masterId: 18264,
  },
  {
    type: 'cityName',
    value: 'ROOPAHELI, RAJASTHAN',
    masterId: 17248,
  },
  {
    type: 'cityName',
    value: 'RAJPURA, PUNJAB',
    masterId: 14593,
  },
  {
    type: 'cityName',
    value: 'RAVALPALI KALAN, ANDHRA PRADESH',
    masterId: 14691,
  },
  {
    type: 'cityName',
    value: 'PERIGAVARAM, ANDHRA PRADESH',
    masterId: 14363,
  },
  {
    type: 'cityName',
    value: 'RAMPUR MANIHARAN, UTTAR PRADESH',
    masterId: 16347,
  },
  {
    type: 'cityName',
    value: 'RAWATPUR, UTTAR PRADESH',
    masterId: 16341,
  },
  {
    type: 'cityName',
    value: 'BILAT, ORISSA',
    masterId: 10825,
  },
  {
    type: 'cityName',
    value: 'RAPARLA HALT, ANDHRA PRADESH',
    masterId: 14675,
  },
  {
    type: 'cityName',
    value: 'RUDRAPUR SIDCUL, UTTARAKHAND',
    masterId: 19185,
  },
  {
    type: 'cityName',
    value: 'RUPAI, ASSAM',
    masterId: 16334,
  },
  {
    type: 'cityName',
    value: 'UDAIPUR, RAJASTHAN',
    masterId: 15637,
  },
  {
    type: 'cityName',
    value: 'RADHAKISHOREPUR, ORISSA',
    masterId: 17445,
  },
  {
    type: 'cityName',
    value: 'RICHHA, UTTAR PRADESH',
    masterId: 16338,
  },
  {
    type: 'cityName',
    value: 'BIRUR, KARNATAKA',
    masterId: 10848,
  },
  {
    type: 'cityName',
    value: 'RANGAREDDY GUDA, ANDHRA PRADESH',
    masterId: 14653,
  },
  {
    type: 'cityName',
    value: 'RAHURI, MAHARASHTRA',
    masterId: 14552,
  },
  {
    type: 'cityName',
    value: 'RAMARAJU PALLI, ANDHRA PRADESH',
    masterId: 14611,
  },
  {
    type: 'cityName',
    value: 'REWRAL, MAHARASHTRA',
    masterId: 14738,
  },
  {
    type: 'cityName',
    value: 'RAIRANGPUR, ODISHA',
    masterId: 20916,
  },
  {
    type: 'cityName',
    value: 'RAGHURAJ SINGH, UTTAR PRADESH',
    masterId: 14546,
  },
  {
    type: 'cityName',
    value: 'RAYARU, MADHYA PRADESH',
    masterId: 17785,
  },
  {
    type: 'cityName',
    value: 'RORANWALA, PUNJAB',
    masterId: 17298,
  },
  {
    type: 'cityName',
    value: 'RISIA, UTTAR PRADESH',
    masterId: 14741,
  },
  {
    type: 'cityName',
    value: 'CHIRPOLI, CHHATTISGARH',
    masterId: 11127,
  },
  {
    type: 'cityName',
    value: 'RAMSAGAR, WEST BENGAL',
    masterId: 14638,
  },
  {
    type: 'cityName',
    value: 'RATAN SHAHAR, RAJASTHAN',
    masterId: 17249,
  },
  {
    type: 'cityName',
    value: 'RAISI, UTTARAKHAND',
    masterId: 14563,
  },
  {
    type: 'cityName',
    value: 'MIYANA, MADHYA PRADESH',
    masterId: 17804,
  },
  {
    type: 'cityName',
    value: 'RAJ SUNAKHALA, ORISSA',
    masterId: 17444,
  },
  {
    type: 'cityName',
    value: 'RASULPUR, WEST BENGAL',
    masterId: 21070,
  },
  {
    type: 'cityName',
    value: 'RASMADA, CHHATTISGARH ',
    masterId: 18597,
  },
  {
    type: 'cityName',
    value: 'RAMGOVINDSINGH MAHU, BIHAR',
    masterId: 18851,
  },
  {
    type: 'cityName',
    value: 'RAI SINGH NAGAR, RAJASTHAN',
    masterId: 14553,
  },
  {
    type: 'cityName',
    value: 'RASRA, UTTAR PRADESH',
    masterId: 14681,
  },
  {
    type: 'cityName',
    value: 'RAMESHWAR NAGAR, GUJARAT ',
    masterId: 18411,
  },
  {
    type: 'cityName',
    value: 'RASAYANI, MAHARASHTRA',
    masterId: 14678,
  },
  {
    type: 'cityName',
    value: 'ROHAT, RAJASTHAN',
    masterId: 14748,
  },
  {
    type: 'cityName',
    value: 'RUTHIYAI, MADHYA PRADESH',
    masterId: 14775,
  },
  {
    type: 'cityName',
    value: 'RAJA TALAB, UTTAR PRADESH',
    masterId: 18599,
  },
  {
    type: 'cityName',
    value: 'RANGTONG, WEST BENGAL',
    masterId: 14657,
  },
  {
    type: 'cityName',
    value: 'RATANGARH, RAJASTHAN',
    masterId: 14684,
  },
  {
    type: 'cityName',
    value: 'RATANGAON, MADHYA PRADESH',
    masterId: 17786,
  },
  {
    type: 'cityName',
    value: 'MALWASI, MADHYA PRADESH',
    masterId: 13346,
  },
  {
    type: 'cityName',
    value: 'RANTEJ, GUJARAT',
    masterId: 18408,
  },
  {
    type: 'cityName',
    value: 'RAMTEK, MAHARASHTRA ',
    masterId: 17591,
  },
  {
    type: 'cityName',
    value: 'RATLAM, MADHYA PRADESH',
    masterId: 14688,
  },
  {
    type: 'cityName',
    value: 'RETANG, ORISSA',
    masterId: 17440,
  },
  {
    type: 'cityName',
    value: 'BACHHPUR, UTTAR PRADESH',
    masterId: 10334,
  },
  {
    type: 'cityName',
    value: 'RAMNATHPUR, ASSAM',
    masterId: 18128,
  },
  {
    type: 'cityName',
    value: 'NEW RAMNATH PUR, ASSAM',
    masterId: 18579,
  },
  {
    type: 'cityName',
    value: 'RAHATWAS, MADHYA PRADESH',
    masterId: 17789,
  },
  {
    type: 'cityName',
    value: 'RATONA, MADHYA PRADESH',
    masterId: 17899,
  },
  {
    type: 'cityName',
    value: 'RENIGUNTA, ANDHRA PRADESH',
    masterId: 14723,
  },
  {
    type: 'cityName',
    value: 'RASULABAD, UTTAR PRADESH',
    masterId: 14682,
  },
  {
    type: 'cityName',
    value: 'RAJLU GARHI, HARYANA',
    masterId: 18263,
  },
  {
    type: 'cityName',
    value: 'RUKNIBERA, WEST BENGAL',
    masterId: 14766,
  },
  {
    type: 'cityName',
    value: 'RANUJ, GUJARAT',
    masterId: 18528,
  },
  {
    type: 'cityName',
    value: 'RAULI, ORISSA',
    masterId: 14690,
  },
  {
    type: 'cityName',
    value: 'DOHRI, UTTAR PRADESH',
    masterId: 11450,
  },
  {
    type: 'cityName',
    value: 'RUPAHIGAON, ASSAM',
    masterId: 18866,
  },
  {
    type: 'cityName',
    value: 'RUDRAPUR, UTTARAKHAND',
    masterId: 14763,
  },
  {
    type: 'cityName',
    value: 'RANPUR, GUJARAT',
    masterId: 14671,
  },
  {
    type: 'cityName',
    value: 'RURA, UTTAR PRADESH',
    masterId: 14774,
  },
  {
    type: 'cityName',
    value: 'MORSAND, BIHAR',
    masterId: 13653,
  },
  {
    type: 'cityName',
    value: 'RATNAL, GUJARAT',
    masterId: 18527,
  },
  {
    type: 'cityName',
    value: 'RAVER, MAHARASHTRA',
    masterId: 14692,
  },
  {
    type: 'cityName',
    value: 'RAVIKAMPADU, ANDHRA PRADESH',
    masterId: 14693,
  },
  {
    type: 'cityName',
    value: 'REVELGANJ GHAT, BIHAR',
    masterId: 18657,
  },
  {
    type: 'cityName',
    value: 'RAIPUR R-V BLOCK HUT, CHHATTISGARH',
    masterId: 18600,
  },
  {
    type: 'cityName',
    value: 'RAJA BHAT KHAWA, WEST BENGAL',
    masterId: 16085,
  },
  {
    type: 'cityName',
    value: 'RAVINDRAKHANI, ANDHRA PRADESH',
    masterId: 14694,
  },
  {
    type: 'cityName',
    value: 'RAVANASAMUDRAM, TAMIL NADU',
    masterId: 16893,
  },
  {
    type: 'cityName',
    value: 'RAUTARA, BIHAR',
    masterId: 16198,
  },
  {
    type: 'cityName',
    value: 'ROWRIAH SDG, ASSAM',
    masterId: 14759,
  },
  {
    type: 'cityName',
    value: 'SHYOPURA, RAJASTHAN',
    masterId: 15136,
  },
  {
    type: 'cityName',
    value: 'RAIWALA, UTTARAKHAND',
    masterId: 14564,
  },
  {
    type: 'cityName',
    value: 'RANAVAV, GUJARAT',
    masterId: 14645,
  },
  {
    type: 'cityName',
    value: 'ROWTA BAGAN, ASSAM',
    masterId: 18959,
  },
  {
    type: 'cityName',
    value: 'RAXAUL, BIHAR',
    masterId: 14699,
  },
  {
    type: 'cityName',
    value: 'ROOMA, UTTAR PRADESH',
    masterId: 21034,
  },
  {
    type: 'cityName',
    value: 'RAMSAN, GUJARAT',
    masterId: 20796,
  },
  {
    type: 'cityName',
    value: 'RANGAPAHAR, NAGALAND ',
    masterId: 17549,
  },
  {
    type: 'cityName',
    value: 'RANGAPAHAR CRS, NAGALAND',
    masterId: 18573,
  },
  {
    type: 'cityName',
    value: 'RAYAKA, GUJARAT',
    masterId: 18407,
  },
  {
    type: 'cityName',
    value: 'RAYAKOTTAI, TAMIL NADU',
    masterId: 16892,
  },
  {
    type: 'cityName',
    value: 'RAYANAPADU, ANDHRA PRADESH',
    masterId: 14707,
  },
  {
    type: 'cityName',
    value: 'RASURIYA, UTTAR PRADESH',
    masterId: 14683,
  },
  {
    type: 'cityName',
    value: 'RAYATPURA, MADHYA PRADESH',
    masterId: 17784,
  },
  {
    type: 'cityName',
    value: 'RAZAGANJ, UTTAR PRADESH',
    masterId: 16340,
  },
  {
    type: 'cityName',
    value: 'RAUZAGAON, UTTAR PRADESH',
    masterId: 16342,
  },
  {
    type: 'cityName',
    value: 'SRIRANGAPATNA, KARNATAKA',
    masterId: 15299,
  },
  {
    type: 'cityName',
    value: 'SALEM, TAMIL NADU',
    masterId: 14847,
  },
  {
    type: 'cityName',
    value: 'SATHIAON, UTTAR PRADESH',
    masterId: 14971,
  },
  {
    type: 'cityName',
    value: 'SANTHAMAGULURU, ANDHRA PRADESH',
    masterId: 14920,
  },
  {
    type: 'cityName',
    value: 'PIPARSEVA, MADHYA PRADESH',
    masterId: 14413,
  },
  {
    type: 'cityName',
    value: 'SONADA, WEST BENGAL',
    masterId: 15264,
  },
  {
    type: 'cityName',
    value: 'SAIDAPUR, TELANGANA',
    masterId: 14815,
  },
  {
    type: 'cityName',
    value: 'SALKANPUR, UTTAR PRADESH',
    masterId: 17778,
  },
  {
    type: 'cityName',
    value: 'SANGRUR, PUNJAB',
    masterId: 14904,
  },
  {
    type: 'cityName',
    value: 'SAGMA, MADHYA PRADESH',
    masterId: 18211,
  },
  {
    type: 'cityName',
    value: 'SHRIRAJNAGAR, UTTAR PRADESH',
    masterId: 15129,
  },
  {
    type: 'cityName',
    value: 'SAPHALE, MAHARASHTRA',
    masterId: 14929,
  },
  {
    type: 'cityName',
    value: 'SATHI, BIHAR',
    masterId: 18804,
  },
  {
    type: 'cityName',
    value: 'SAHELI, MADHYA PRADESH',
    masterId: 14806,
  },
  {
    type: 'cityName',
    value: 'SAHAJPUR, GUJARAT',
    masterId: 17779,
  },
  {
    type: 'cityName',
    value: 'SAHERI, UTTAR PRADESH',
    masterId: 17296,
  },
  {
    type: 'cityName',
    value: 'SARAI, BIHAR',
    masterId: 14933,
  },
  {
    type: 'cityName',
    value: 'SAHJHA, BIHAR',
    masterId: 18651,
  },
  {
    type: 'cityName',
    value: 'SANKHEDA-BAHDARPURA, GUJARAT',
    masterId: 18400,
  },
  {
    type: 'cityName',
    value: 'SUPRAKANDI, ASSAM',
    masterId: 18979,
  },
  {
    type: 'cityName',
    value: 'SALWA, MAHARASHTRA',
    masterId: 14860,
  },
  {
    type: 'cityName',
    value: 'SALAR, WEST BENGAL',
    masterId: 14839,
  },
  {
    type: 'cityName',
    value: 'SALI, RAJASTHAN',
    masterId: 14849,
  },
  {
    type: 'cityName',
    value: 'SALEM MARKET, TAMIL NADU',
    masterId: 16890,
  },
  {
    type: 'cityName',
    value: 'SANDILA, UTTAR PRADESH',
    masterId: 14892,
  },
  {
    type: 'cityName',
    value: 'SANHA, BIHAR',
    masterId: 18647,
  },
  {
    type: 'cityName',
    value: 'SANKH, MADHYA PRADESH',
    masterId: 17587,
  },
  {
    type: 'cityName',
    value: 'SARDARNAGAR, UTTAR PRADESH',
    masterId: 14945,
  },
  {
    type: 'cityName',
    value: 'SAGONI, MADHYA PRADESH',
    masterId: 14801,
  },
  {
    type: 'cityName',
    value: 'SATTENAPALLE, ANDHRA PRADESH',
    masterId: 14977,
  },
  {
    type: 'cityName',
    value: 'SAPE WAMNE, MAHARASHTRA',
    masterId: 14927,
  },
  {
    type: 'cityName',
    value: 'SARANGPUR, GUJARAT',
    masterId: 19087,
  },
  {
    type: 'cityName',
    value: 'SUGAPAHARI, JHARKHAND',
    masterId: 18117,
  },
  {
    type: 'cityName',
    value: 'KALYANPUR, UTTAR PRADESH',
    masterId: 12433,
  },
  {
    type: 'cityName',
    value: 'KILKIPURA, RAJASTHAN',
    masterId: 12783,
  },
  {
    type: 'cityName',
    value: 'SASAN GIR, GUJARAT',
    masterId: 14959,
  },
  {
    type: 'cityName',
    value: 'SAHIBZADA ASNGR, PUNJAB',
    masterId: 14809,
  },
  {
    type: 'cityName',
    value: 'SALIYA, GUJARAT',
    masterId: 14852,
  },
  {
    type: 'cityName',
    value: 'SATAR, BIHAR',
    masterId: 18644,
  },
  {
    type: 'cityName',
    value: 'SANAND, GUJARAT',
    masterId: 14885,
  },
  {
    type: 'cityName',
    value: 'SAVDA, MAHARASHTRA',
    masterId: 14992,
  },
  {
    type: 'cityName',
    value: 'SURIYAWA, UTTAR PRADESH',
    masterId: 15362,
  },
  {
    type: 'cityName',
    value: 'SOHANSARA, HARYANA',
    masterId: 18248,
  },
  {
    type: 'cityName',
    value: 'SAYAMA, GUJARAT',
    masterId: 20807,
  },
  {
    type: 'cityName',
    value: 'SARAI BHOPAT, UTTAR PRADESH',
    masterId: 21016,
  },
  {
    type: 'cityName',
    value: 'MANA, CHHATTISGARH',
    masterId: 16242,
  },
  {
    type: 'cityName',
    value: 'SBB JOGULAMBA H, TELANGANA',
    masterId: 15004,
  },
  {
    type: 'cityName',
    value: 'BENGALURU, KARNATAKA',
    masterId: 10636,
  },
  {
    type: 'cityName',
    value: 'BANGALORE, KARNATAKA',
    masterId: 10636,
  },
  {
    type: 'cityName',
    value: 'SLEEMANABAD, MADHYA PRADESH',
    masterId: 15243,
  },
  {
    type: 'cityName',
    value: 'SABDALPUR JN., BIHAR',
    masterId: 20754,
  },
  {
    type: 'cityName',
    value: 'SORBHOG, ASSAM',
    masterId: 15282,
  },
  {
    type: 'cityName',
    value: 'SAHIBGANJ, JHARKHAND',
    masterId: 14807,
  },
  {
    type: 'cityName',
    value: 'SHRAVANABELAGOLA, KARNATAKA',
    masterId: 15123,
  },
  {
    type: 'cityName',
    value: 'SISSIBORGAON, ASSAM',
    masterId: 18859,
  },
  {
    type: 'cityName',
    value: 'SUBHAS GRAM, WEST BENGAL',
    masterId: 21177,
  },
  {
    type: 'cityName',
    value: 'SULEBHAVI, KARNATAKA',
    masterId: 17970,
  },
  {
    type: 'cityName',
    value: 'SUBRAHMANYA RD, KARNATAKA',
    masterId: 15306,
  },
  {
    type: 'cityName',
    value: 'SABARMATI, GUJARAT',
    masterId: 14781,
  },
  {
    type: 'cityName',
    value: 'SARAI BANJARA, PUNJAB',
    masterId: 20927,
  },
  {
    type: 'cityName',
    value: 'SHAHBAZ QULI, UTTAR PRADESH',
    masterId: 16316,
  },
  {
    type: 'cityName',
    value: 'SABALGARH, MADHYA PRADESH',
    masterId: 17781,
  },
  {
    type: 'cityName',
    value: 'SHRIBALAJI, RAJASTHAN',
    masterId: 15126,
  },
  {
    type: 'cityName',
    value: 'LATHI, RAJASTHAN',
    masterId: 13125,
  },
  {
    type: 'cityName',
    value: 'SONBARSA KACHAHARI, BIHAR',
    masterId: 15268,
  },
  {
    type: 'cityName',
    value: 'SUBARNA MRIGI, WEST BENGAL',
    masterId: 15305,
  },
  {
    type: 'cityName',
    value: 'SRI VIJAYNAGAR, RAJASTHAN',
    masterId: 17062,
  },
  {
    type: 'cityName',
    value: 'SAMBALPUR, ORISSA',
    masterId: 14873,
  },
  {
    type: 'cityName',
    value: 'SAMBHAR, RAJASTHAN',
    masterId: 14874,
  },
  {
    type: 'cityName',
    value: 'SARBAHARA, CHHATTISGARH',
    masterId: 14943,
  },
  {
    type: 'cityName',
    value: 'SIMRI, BIHAR',
    masterId: 15175,
  },
  {
    type: 'cityName',
    value: 'MAHAL, JHARKHAND',
    masterId: 13239,
  },
  {
    type: 'cityName',
    value: 'SISWA BAZAR, UTTAR PRADESH',
    masterId: 15224,
  },
  {
    type: 'cityName',
    value: 'HYDERABAD, TELANGANA',
    masterId: 12049,
  },
  {
    type: 'cityName',
    value: 'SALCHAPRA, ASSAM',
    masterId: 14844,
  },
  {
    type: 'cityName',
    value: 'SENCHOA, ASSAM',
    masterId: 15018,
  },
  {
    type: 'cityName',
    value: 'SANCHI, MADHYA PRADESH',
    masterId: 14888,
  },
  {
    type: 'cityName',
    value: 'SALICHAUKA ROAD, MADHYA PRADESH',
    masterId: 14850,
  },
  {
    type: 'cityName',
    value: 'SILCHAR, ASSAM',
    masterId: 15164,
  },
  {
    type: 'cityName',
    value: 'SIMHACHALAM, ANDHRA PRADESH',
    masterId: 19053,
  },
  {
    type: 'cityName',
    value: 'SONDHA, MADHYA PRADESH',
    masterId: 15270,
  },
  {
    type: 'cityName',
    value: 'SATANA, MAHARASHTRA',
    masterId: 14965,
  },
  {
    type: 'cityName',
    value: 'SIRNAPALLI, TELANGANA',
    masterId: 16801,
  },
  {
    type: 'cityName',
    value: 'SUCHI PIND, PUNJAB',
    masterId: 17407,
  },
  {
    type: 'cityName',
    value: 'SHYAMA CHARANPUR HAL, ORISSA',
    masterId: 19075,
  },
  {
    type: 'cityName',
    value: 'SHAM CHAURASI, PUNJAB',
    masterId: 17291,
  },
  {
    type: 'cityName',
    value: 'SENGOTTAI, TAMIL NADU',
    masterId: 15021,
  },
  {
    type: 'cityName',
    value: 'SUKHCHAIN, HARYANA',
    masterId: 18246,
  },
  {
    type: 'cityName',
    value: 'SACHIWALAYA, BIHAR',
    masterId: 18654,
  },
  {
    type: 'cityName',
    value: 'SUNDHIAMAU, UTTAR PRADESH',
    masterId: 16291,
  },
  {
    type: 'cityName',
    value: 'SHAHABAD, KARNATAKA',
    masterId: 15039,
  },
  {
    type: 'cityName',
    value: 'SINDRIBLOCK HUT, JHARKHAND',
    masterId: 15189,
  },
  {
    type: 'cityName',
    value: 'SAIDABAD, UTTAR PRADESH',
    masterId: 16725,
  },
  {
    type: 'cityName',
    value: 'SINDHAVADAR, GUJARAT',
    masterId: 15183,
  },
  {
    type: 'cityName',
    value: 'BAZIDPUR, BIHAR',
    masterId: 10601,
  },
  {
    type: 'cityName',
    value: 'DERAJSAR, RAJASTHAN',
    masterId: 11292,
  },
  {
    type: 'cityName',
    value: 'SAHADAI BUZURG, BIHAR',
    masterId: 18652,
  },
  {
    type: 'cityName',
    value: 'PUNDALSAR, RAJASTHAN',
    masterId: 14496,
  },
  {
    type: 'cityName',
    value: 'SARADHANA, RAJASTHAN',
    masterId: 14931,
  },
  {
    type: 'cityName',
    value: 'SIDHARI, UTTAR PRADESH',
    masterId: 16308,
  },
  {
    type: 'cityName',
    value: 'SANDHANIDHAR, GUJARAT',
    masterId: 18402,
  },
  {
    type: 'cityName',
    value: 'SAGARDIGHI, WEST BENGAL',
    masterId: 14800,
  },
  {
    type: 'cityName',
    value: 'SHAHDOL, MADHYA PRADESH',
    masterId: 15045,
  },
  {
    type: 'cityName',
    value: 'SWADHINPUR, WEST BENGAL',
    masterId: 16072,
  },
  {
    type: 'cityName',
    value: 'SUNDLAK, RAJASTHAN',
    masterId: 17245,
  },
  {
    type: 'cityName',
    value: 'SADULPUR, RAJASTHAN',
    masterId: 14791,
  },
  {
    type: 'cityName',
    value: 'SURAREDDIPALEM, ANDHRA PRADESH',
    masterId: 15352,
  },
  {
    type: 'cityName',
    value: 'SUDAMDIH, WEST BENGAL',
    masterId: 15307,
  },
  {
    type: 'cityName',
    value: 'SIDHMUKH, RAJASTHAN',
    masterId: 17067,
  },
  {
    type: 'cityName',
    value: 'SHOLAVANDAN, TAMIL NADU',
    masterId: 15119,
  },
  {
    type: 'cityName',
    value: 'SEYDUNGANALLUR, TAMIL NADU',
    masterId: 15035,
  },
  {
    type: 'cityName',
    value: 'SUDHRANA, HARYANA',
    masterId: 15309,
  },
  {
    type: 'cityName',
    value: 'SADULSHAHR, RAJASTHAN',
    masterId: 14792,
  },
  {
    type: 'cityName',
    value: 'SADAT, UTTAR PRADESH',
    masterId: 14789,
  },
  {
    type: 'cityName',
    value: 'SADURA, JAMMU AND KASHMIR',
    masterId: 20827,
  },
  {
    type: 'cityName',
    value: 'SOMIDEVIPALLE, ANDHRA PRADESH',
    masterId: 15258,
  },
  {
    type: 'cityName',
    value: 'SOLDEVANAHALLI, KARNATAKA',
    masterId: 17975,
  },
  {
    type: 'cityName',
    value: 'SADHOO GARH, PUNJAB',
    masterId: 20928,
  },
  {
    type: 'cityName',
    value: 'SINDHAR, PUNJAB',
    masterId: 18363,
  },
  {
    type: 'cityName',
    value: 'SON NAGAR, BIHAR',
    masterId: 15263,
  },
  {
    type: 'cityName',
    value: 'SHEDBAL, KARNATAKA',
    masterId: 15069,
  },
  {
    type: 'cityName',
    value: 'SONEPUR, BIHAR',
    masterId: 15273,
  },
  {
    type: 'cityName',
    value: 'SHEGAON, MAHARASHTRA',
    masterId: 15071,
  },
  {
    type: 'cityName',
    value: 'SEVAGRAM, MAHARASHTRA',
    masterId: 15030,
  },
  {
    type: 'cityName',
    value: 'SEHORE, MADHYA PRADESH',
    masterId: 15012,
  },
  {
    type: 'cityName',
    value: 'SHENDRI, MAHARASHTRA',
    masterId: 15077,
  },
  {
    type: 'cityName',
    value: 'SARKHEJ, GUJARAT',
    masterId: 18399,
  },
  {
    type: 'cityName',
    value: 'SANKRAIL, WEST BENGAL',
    masterId: 16196,
  },
  {
    type: 'cityName',
    value: 'SELOO, MAHARASHTRA',
    masterId: 15013,
  },
  {
    type: 'cityName',
    value: 'SEDAM, KARNATAKA',
    masterId: 15007,
  },
  {
    type: 'cityName',
    value: 'SENAPUR, KARNATAKA',
    masterId: 15017,
  },
  {
    type: 'cityName',
    value: 'SEOHARA, UTTAR PRADESH',
    masterId: 15023,
  },
  {
    type: 'cityName',
    value: 'SODEPUR, WEST BENGAL',
    masterId: 15246,
  },
  {
    type: 'cityName',
    value: 'SEPON, ASSAM',
    masterId: 18958,
  },
  {
    type: 'cityName',
    value: 'SHERPUR, UTTAR PRADESH',
    masterId: 16252,
  },
  {
    type: 'cityName',
    value: 'SEKHA, PUNJAB',
    masterId: 17292,
  },
  {
    type: 'cityName',
    value: 'SAMAYANALLUR, TAMIL NADU',
    masterId: 16888,
  },
  {
    type: 'cityName',
    value: 'SEMARI, RAJASTHAN',
    masterId: 16317,
  },
  {
    type: 'cityName',
    value: 'SETTIHALLI, KARNATAKA',
    masterId: 15029,
  },
  {
    type: 'cityName',
    value: 'SENDRA, RAJASTHAN',
    masterId: 15020,
  },
  {
    type: 'cityName',
    value: 'SITHALAVAI, TAMIL NADU',
    masterId: 17020,
  },
  {
    type: 'cityName',
    value: 'SEHAL, UTTAR PRADESH',
    masterId: 16723,
  },
  {
    type: 'cityName',
    value: 'SERONI, MADHYA PRADESH',
    masterId: 17774,
  },
  {
    type: 'cityName',
    value: 'SETTIGUNTA, ANDHRA PRADESH',
    masterId: 15028,
  },
  {
    type: 'cityName',
    value: 'SUNHERA, UTTAR PRADESH',
    masterId: 16290,
  },
  {
    type: 'cityName',
    value: 'SAINTALA, ORISSA',
    masterId: 14818,
  },
  {
    type: 'cityName',
    value: 'SAFIDON, HARYANA',
    masterId: 18260,
  },
  {
    type: 'cityName',
    value: 'SANODIYA, RAJASTHAN',
    masterId: 17247,
  },
  {
    type: 'cityName',
    value: 'SAFEDABAD, UTTAR PRADESH',
    masterId: 14794,
  },
  {
    type: 'cityName',
    value: 'SIKER, ORISSA',
    masterId: 17433,
  },
  {
    type: 'cityName',
    value: 'SUNAM, PUNJAB',
    masterId: 15338,
  },
  {
    type: 'cityName',
    value: 'SAFIPUR, UTTAR PRADESH',
    masterId: 16333,
  },
  {
    type: 'cityName',
    value: 'SAFARI, ASSAM',
    masterId: 18653,
  },
  {
    type: 'cityName',
    value: 'SARANGPUR, MADHYA PRADESH',
    masterId: 14940,
  },
  {
    type: 'cityName',
    value: 'SAFILGUDA, ANDHRA PRADESH',
    masterId: 14795,
  },
  {
    type: 'cityName',
    value: 'SINDURIA KACHARI, MADHYA PRADESH',
    masterId: 17765,
  },
  {
    type: 'cityName',
    value: 'SHAHGARH, UTTAR PRADESH',
    masterId: 17773,
  },
  {
    type: 'cityName',
    value: 'GUMAN SINGH PURA, PUNJAB',
    masterId: 17168,
  },
  {
    type: 'cityName',
    value: 'SAREIGRAM, MADHYA PRADESH',
    masterId: 14950,
  },
  {
    type: 'cityName',
    value: 'SURGAON BANJARI, MADHYA PRADESH',
    masterId: 15359,
  },
  {
    type: 'cityName',
    value: 'SAONGI, MADHYA PRADESH',
    masterId: 20874,
  },
  {
    type: 'cityName',
    value: 'SONGADH, GUJARAT',
    masterId: 15274,
  },
  {
    type: 'cityName',
    value: 'SIGADAM, ANDHRA PRADESH',
    masterId: 15149,
  },
  {
    type: 'cityName',
    value: 'SAGADAPATA, ORISSA',
    masterId: 14796,
  },
  {
    type: 'cityName',
    value: 'SANKARI, TAMIL NADU',
    masterId: 14908,
  },
  {
    type: 'cityName',
    value: 'SANGAT, PUNJAB',
    masterId: 14900,
  },
  {
    type: 'cityName',
    value: 'SULTANGANJ, BIHAR',
    masterId: 15328,
  },
  {
    type: 'cityName',
    value: 'SAFDARGANJ, UTTAR PRADESH',
    masterId: 14793,
  },
  {
    type: 'cityName',
    value: 'SRUNGAVRUKSHAM, ANDHRA PRADESH',
    masterId: 15304,
  },
  {
    type: 'cityName',
    value: 'SUGAULI, BIHAR',
    masterId: 15310,
  },
  {
    type: 'cityName',
    value: 'SANGOLA, MAHARASHTRA',
    masterId: 14902,
  },
  {
    type: 'cityName',
    value: 'SENGULAM, TAMIL NADU',
    masterId: 16885,
  },
  {
    type: 'cityName',
    value: 'SINGAMPATTY, TAMIL NADU',
    masterId: 16882,
  },
  {
    type: 'cityName',
    value: 'SHRIGONDA, MAHARASHTRA',
    masterId: 15127,
  },
  {
    type: 'cityName',
    value: 'SHRI GANGANAGAR, RAJASTHAN',
    masterId: 15125,
  },
  {
    type: 'cityName',
    value: 'SAUGOR, MADHYA PRADESH',
    masterId: 14984,
  },
  {
    type: 'cityName',
    value: 'SOHAGPUR, MADHYA PRADESH',
    masterId: 15248,
  },
  {
    type: 'cityName',
    value: 'SANGAMESHWAR, MAHARASHTRA',
    masterId: 14895,
  },
  {
    type: 'cityName',
    value: 'SANGARIA, RAJASTHAN',
    masterId: 14899,
  },
  {
    type: 'cityName',
    value: 'SARAGAON RD HLT, CHHATTISGARH',
    masterId: 14932,
  },
  {
    type: 'cityName',
    value: 'SULGARE, MAHARASHTRA',
    masterId: 17576,
  },
  {
    type: 'cityName',
    value: 'SINGRAULI, MADHYA PRADESH',
    masterId: 15197,
  },
  {
    type: 'cityName',
    value: 'SINGARAM, ORISSA',
    masterId: 15192,
  },
  {
    type: 'cityName',
    value: 'SINGHIRAMPUR, UTTAR PRADESH',
    masterId: 16305,
  },
  {
    type: 'cityName',
    value: 'SANGER, JAMMU AND KASHMIR',
    masterId: 17076,
  },
  {
    type: 'cityName',
    value: 'SHOGHI, HIMACHAL PRADESH',
    masterId: 15118,
  },
  {
    type: 'cityName',
    value: 'SARGACHHI, WEST BENGAL',
    masterId: 14953,
  },
  {
    type: 'cityName',
    value: 'SINGWAL, RAJASTHAN',
    masterId: 17066,
  },
  {
    type: 'cityName',
    value: 'SHAMGARH, MADHYA PRADESH',
    masterId: 15058,
  },
  {
    type: 'cityName',
    value: 'SHAHAD, MAHARASHTRA',
    masterId: 17721,
  },
  {
    type: 'cityName',
    value: 'SAHEBTALA HALT, WEST BENGAL',
    masterId: 21188,
  },
  {
    type: 'cityName',
    value: 'SIBAICHANDI, WEST BENGAL',
    masterId: 21215,
  },
  {
    type: 'cityName',
    value: 'SHIBLOON, WEST BENGAL',
    masterId: 16078,
  },
  {
    type: 'cityName',
    value: 'SAHARSA, BIHAR',
    masterId: 14804,
  },
  {
    type: 'cityName',
    value: 'SHAHBAD, HARYANA',
    masterId: 15044,
  },
  {
    type: 'cityName',
    value: 'JHAGAR, MADHYA PRADESH',
    masterId: 12240,
  },
  {
    type: 'cityName',
    value: 'SHEORAPHULI, WEST BENGAL',
    masterId: 15083,
  },
  {
    type: 'cityName',
    value: 'SHISHO, BIHAR',
    masterId: 20770,
  },
  {
    type: 'cityName',
    value: 'SHIRUD, MAHARASHTRA',
    masterId: 16059,
  },
  {
    type: 'cityName',
    value: 'SHAHGANJ, UTTAR PRADESH',
    masterId: 15046,
  },
  {
    type: 'cityName',
    value: 'SHRI GHASINAGAR, RAJASTHAN',
    masterId: 17069,
  },
  {
    type: 'cityName',
    value: 'SHAPUR, GUJARAT',
    masterId: 15068,
  },
  {
    type: 'cityName',
    value: 'SINGANALLUR, TAMIL NADU',
    masterId: 17022,
  },
  {
    type: 'cityName',
    value: 'SHINDAWANE, MAHARASHTRA',
    masterId: 17583,
  },
  {
    type: 'cityName',
    value: 'SAHAJIPUR, UTTAR PRADESH',
    masterId: 16331,
  },
  {
    type: 'cityName',
    value: 'SHEIKHPURA, BIHAR',
    masterId: 15073,
  },
  {
    type: 'cityName',
    value: 'SHANKRUL, WEST BENGAL',
    masterId: 21115,
  },
  {
    type: 'cityName',
    value: 'SHOLAKA, HARYANA',
    masterId: 18251,
  },
  {
    type: 'cityName',
    value: 'SHIROOR, KARNATAKA',
    masterId: 15096,
  },
  {
    type: 'cityName',
    value: 'SHYAMSUNDER, WEST BENGAL',
    masterId: 21109,
  },
  {
    type: 'cityName',
    value: 'RAILWAY, HARYANA',
    masterId: 18265,
  },
  {
    type: 'cityName',
    value: 'SHIVNAGAR, UTTAR PRADESH',
    masterId: 16060,
  },
  {
    type: 'cityName',
    value: 'SHADNAGAR, TELANGANA',
    masterId: 15037,
  },
  {
    type: 'cityName',
    value: 'SHEO SINGH PURA, RAJASTHAN',
    masterId: 15079,
  },
  {
    type: 'cityName',
    value: 'SIHORA, MADHYA PRADESH',
    masterId: 15154,
  },
  {
    type: 'cityName',
    value: 'SHARMA, UTTAR PRADESH',
    masterId: 18641,
  },
  {
    type: 'cityName',
    value: 'SAHARSRAKUND, MAHARASHTRA',
    masterId: 14805,
  },
  {
    type: 'cityName',
    value: 'SAMBHAL, UTTAR PRADESH',
    masterId: 16326,
  },
  {
    type: 'cityName',
    value: 'SILGHAT, ASSAM',
    masterId: 15165,
  },
  {
    type: 'cityName',
    value: 'BANAVARAM, TAMIL NADU',
    masterId: 10463,
  },
  {
    type: 'cityName',
    value: 'SHIVANI, KARNATAKA',
    masterId: 15110,
  },
  {
    type: 'cityName',
    value: 'SAMHON, UTTAR PRADESH',
    masterId: 21014,
  },
  {
    type: 'cityName',
    value: 'SAHUWALA, RAJASTHAN',
    masterId: 18259,
  },
  {
    type: 'cityName',
    value: 'SHUKARULLAHPUR, UTTAR PRADESH',
    masterId: 16309,
  },
  {
    type: 'cityName',
    value: 'SAKHARAYAPATNA, KARNATAKA',
    masterId: 17983,
  },
  {
    type: 'cityName',
    value: 'SHIMLA, HIMACHAL PRADESH',
    masterId: 15088,
  },
  {
    type: 'cityName',
    value: 'NIJHURA, BIHAR',
    masterId: 14002,
  },
  {
    type: 'cityName',
    value: 'SHIVLAKHA, GUJARAT',
    masterId: 18525,
  },
  {
    type: 'cityName',
    value: 'SONIK, UTTAR PRADESH',
    masterId: 16296,
  },
  {
    type: 'cityName',
    value: 'SIDDHPUR, GUJARAT',
    masterId: 15144,
  },
  {
    type: 'cityName',
    value: 'SIDDAMANAHALLI, ANDHRA PRADESH',
    masterId: 17978,
  },
  {
    type: 'cityName',
    value: 'SIRLI, MAHARASHTRA',
    masterId: 18594,
  },
  {
    type: 'cityName',
    value: 'SIHO, BIHAR',
    masterId: 15151,
  },
  {
    type: 'cityName',
    value: 'SITIMANI, KARNATAKA',
    masterId: 17976,
  },
  {
    type: 'cityName',
    value: 'SIKRODA KWANRI, MADHYA PRADESH',
    masterId: 17769,
  },
  {
    type: 'cityName',
    value: 'SIKAR, RAJASTHAN',
    masterId: 15157,
  },
  {
    type: 'cityName',
    value: 'SAKHIGOPAL, ORISSA',
    masterId: 14825,
  },
  {
    type: 'cityName',
    value: 'SILAO, BIHAR',
    masterId: 15161,
  },
  {
    type: 'cityName',
    value: 'SILLARI, RAJASTHAN',
    masterId: 17768,
  },
  {
    type: 'cityName',
    value: 'SHRI AMIRGADH, GUJARAT',
    masterId: 18396,
  },
  {
    type: 'cityName',
    value: 'SRI NAGAR, JAMMU AND KASHMIR',
    masterId: 20834,
  },
  {
    type: 'cityName',
    value: 'SINI, JHARKHAND',
    masterId: 15199,
  },
  {
    type: 'cityName',
    value: 'SAMKHIYALI, GUJARAT',
    masterId: 14876,
  },
  {
    type: 'cityName',
    value: 'SURAIMANPUR, UTTAR PRADESH',
    masterId: 15347,
  },
  {
    type: 'cityName',
    value: 'SINGHOOKHARIA, JHARKHAND',
    masterId: 18208,
  },
  {
    type: 'cityName',
    value: 'SIHAPAR, UTTAR PRADESH',
    masterId: 15150,
  },
  {
    type: 'cityName',
    value: 'CHAKBEDA, UTTAR PRADESH',
    masterId: 10954,
  },
  {
    type: 'cityName',
    value: 'SIRHIND, PUNJAB',
    masterId: 15207,
  },
  {
    type: 'cityName',
    value: 'SIRHI ITARA, UTTAR PRADESH',
    masterId: 16304,
  },
  {
    type: 'cityName',
    value: 'SISONA, UTTAR PRADESH',
    masterId: 16301,
  },
  {
    type: 'cityName',
    value: 'SHIRRAVDE, MAHARASHTRA',
    masterId: 15098,
  },
  {
    type: 'cityName',
    value: 'SIRRI, CHHATTISGARH',
    masterId: 18593,
  },
  {
    type: 'cityName',
    value: 'SIJUA, JHARKHAND',
    masterId: 18122,
  },
  {
    type: 'cityName',
    value: 'SAO JOSE DE AREAL, GOA',
    masterId: 18567,
  },
  {
    type: 'cityName',
    value: 'SRI JHADESHWAR, ORISSA',
    masterId: 17431,
  },
  {
    type: 'cityName',
    value: 'SANJARPUR, UTTAR PRADESH',
    masterId: 16325,
  },
  {
    type: 'cityName',
    value: 'SAJANVAR, GUJARAT ',
    masterId: 18403,
  },
  {
    type: 'cityName',
    value: 'SARAY JAGDISH, UTTAR PRADESH',
    masterId: 16322,
  },
  {
    type: 'cityName',
    value: 'SANJAY GRAM COLONY, BIHAR',
    masterId: 18255,
  },
  {
    type: 'cityName',
    value: 'SANJHA, BIHAR',
    masterId: 18127,
  },
  {
    type: 'cityName',
    value: 'KAMAL MARG, WEST BENGAL',
    masterId: 16753,
  },
  {
    type: 'cityName',
    value: 'SGM JAGARLAMUDI, ANDHRA PRADESH',
    masterId: 15036,
  },
  {
    type: 'cityName',
    value: 'SAJUMA, HARYANA',
    masterId: 18258,
  },
  {
    type: 'cityName',
    value: 'SANJAN, GUJARAT',
    masterId: 14905,
  },
  {
    type: 'cityName',
    value: 'SUJANPUR, PUNJAB',
    masterId: 15313,
  },
  {
    type: 'cityName',
    value: 'SHUJALPUR, MADHYA PRADESH',
    masterId: 15133,
  },
  {
    type: 'cityName',
    value: 'SUJALPUR, WEST BENGAL',
    masterId: 21090,
  },
  {
    type: 'cityName',
    value: 'SUJATA PURAM, KARNATAKA ',
    masterId: 17971,
  },
  {
    type: 'cityName',
    value: 'SURJYAPUR, WEST BENGAL',
    masterId: 21182,
  },
  {
    type: 'cityName',
    value: 'SURAJPUR, CHHATTISGARH',
    masterId: 15349,
  },
  {
    type: 'cityName',
    value: 'SAJERPAR, WEST BENGAL',
    masterId: 16082,
  },
  {
    type: 'cityName',
    value: 'GADHDA SHAMLAJI, GUJARAT',
    masterId: 18479,
  },
  {
    type: 'cityName',
    value: 'SALEMGARHMASANI, RAJASTHAN',
    masterId: 17078,
  },
  {
    type: 'cityName',
    value: 'SHUJAATPUR, UTTAR PRADESH',
    masterId: 15132,
  },
  {
    type: 'cityName',
    value: 'SANJHAULI, BIHAR',
    masterId: 18646,
  },
  {
    type: 'cityName',
    value: 'SAKHUN, RAJASTHAN',
    masterId: 14826,
  },
  {
    type: 'cityName',
    value: 'SIKANDRA RAO, UTTAR PRADESH',
    masterId: 15156,
  },
  {
    type: 'cityName',
    value: 'PARA, TRIPURA',
    masterId: 18275,
  },
  {
    type: 'cityName',
    value: 'SHIKOHABAD, UTTAR PRADESH',
    masterId: 15086,
  },
  {
    type: 'cityName',
    value: 'SHANKARPUR BHADAURA, MADHYA PRADESH',
    masterId: 17772,
  },
  {
    type: 'cityName',
    value: 'SAKHOTI TANDA, UTTAR PRADESH',
    masterId: 16329,
  },
  {
    type: 'cityName',
    value: 'SAKTIGARH, UTTAR PRADESH',
    masterId: 21001,
  },
  {
    type: 'cityName',
    value: 'SAKTESGARH, UTTAR PRADESH',
    masterId: 14831,
  },
  {
    type: 'cityName',
    value: 'SAKRI, BIHAR',
    masterId: 14828,
  },
  {
    type: 'cityName',
    value: 'SAHIBPUR KML, BIHAR',
    masterId: 14808,
  },
  {
    type: 'cityName',
    value: 'SRI KRISHNA JANAM ST, UTTAR PRADESH',
    masterId: 21048,
  },
  {
    type: 'cityName',
    value: 'SIKKAL, TAMIL NADU',
    masterId: 17023,
  },
  {
    type: 'cityName',
    value: 'SINGAPERUMAL KOIL, TAMIL NADU',
    masterId: 17021,
  },
  {
    type: 'cityName',
    value: 'SUKALI ., MADHYA PRADESH',
    masterId: 17577,
  },
  {
    type: 'cityName',
    value: 'SHANKARPUR, UTTAR PRADESH',
    masterId: 16238,
  },
  {
    type: 'cityName',
    value: 'SAKLESHPUR, KARNATAKA',
    masterId: 14827,
  },
  {
    type: 'cityName',
    value: 'SINGARAYAKONDA, ANDHRA PRADESH',
    masterId: 15193,
  },
  {
    type: 'cityName',
    value: 'BADLAPUR, UTTAR PRADESH',
    masterId: 10349,
  },
  {
    type: 'cityName',
    value: 'KHURUNTI, ORISSA',
    masterId: 12775,
  },
  {
    type: 'cityName',
    value: 'SHAKAR NAGAR, TELANGANA',
    masterId: 16827,
  },
  {
    type: 'cityName',
    value: 'SHANKARPALLI, ANDHRA PRADESH',
    masterId: 15065,
  },
  {
    type: 'cityName',
    value: 'KALYANPURA, RAJASTHAN',
    masterId: 17148,
  },
  {
    type: 'cityName',
    value: 'SIKARPAI, ORISSA',
    masterId: 16061,
  },
  {
    type: 'cityName',
    value: 'SIKANDARPUR, UTTAR PRADESH',
    masterId: 15155,
  },
  {
    type: 'cityName',
    value: 'SIKARIA, BIHAR',
    masterId: 20742,
  },
  {
    type: 'cityName',
    value: 'SALEKASA, MAHARASHTRA',
    masterId: 14846,
  },
  {
    type: 'cityName',
    value: 'SIKOSA, CHHATTISGARH',
    masterId: 20788,
  },
  {
    type: 'cityName',
    value: 'SAKTI, CHHATTISGARH',
    masterId: 14833,
  },
  {
    type: 'cityName',
    value: 'SHAKTI NAGAR, UTTAR PRADESH',
    masterId: 15056,
  },
  {
    type: 'cityName',
    value: 'SIKRODA, MADHYA PRADESH',
    masterId: 17770,
  },
  {
    type: 'cityName',
    value: 'SANKVAL, GOA',
    masterId: 18568,
  },
  {
    type: 'cityName',
    value: 'SHEIKHUPUR, UTTAR PRADESH',
    masterId: 16312,
  },
  {
    type: 'cityName',
    value: 'SARKARA, UTTARAKHAND',
    masterId: 16320,
  },
  {
    type: 'cityName',
    value: 'SIRPUR KAGAZNGR, ANDHRA PRADESH',
    masterId: 15215,
  },
  {
    type: 'cityName',
    value: 'SALBONI, WEST BENGAL',
    masterId: 14843,
  },
  {
    type: 'cityName',
    value: 'SALAI BANWA, UTTAR PRADESH',
    masterId: 16328,
  },
  {
    type: 'cityName',
    value: 'SAKALDIHA, UTTAR PRADESH',
    masterId: 14822,
  },
  {
    type: 'cityName',
    value: 'LUPUNG, JHARKHAND',
    masterId: 13180,
  },
  {
    type: 'cityName',
    value: 'SIMLAGARH, WEST BENGAL',
    masterId: 21238,
  },
  {
    type: 'cityName',
    value: 'SULERJAVALGE, KARNATAKA',
    masterId: 15323,
  },
  {
    type: 'cityName',
    value: 'SHELGAON, MAHARASHTRA',
    masterId: 15075,
  },
  {
    type: 'cityName',
    value: 'SIMALUGURI, ASSAM',
    masterId: 15169,
  },
  {
    type: 'cityName',
    value: 'SILIYARI, CHHATTISGARH',
    masterId: 15167,
  },
  {
    type: 'cityName',
    value: 'SALHANA, MADHYA PRADESH',
    masterId: 18237,
  },
  {
    type: 'cityName',
    value: 'SANGLI, MAHARASHTRA',
    masterId: 14901,
  },
  {
    type: 'cityName',
    value: 'SAKRIGALI, JHARKHAND',
    masterId: 14830,
  },
  {
    type: 'cityName',
    value: 'SANDAL KALAN, HARYANA',
    masterId: 18256,
  },
  {
    type: 'cityName',
    value: 'SALKA, CHHATTISGARH',
    masterId: 14853,
  },
  {
    type: 'cityName',
    value: 'SALAKATI, ASSAM',
    masterId: 18864,
  },
  {
    type: 'cityName',
    value: 'SOMALAPURAM, ANDHRA PRADESH',
    masterId: 15253,
  },
  {
    type: 'cityName',
    value: 'SULTANPUR, UTTAR PRADESH',
    masterId: 15331,
  },
  {
    type: 'cityName',
    value: 'SALAUNA, BIHAR',
    masterId: 18649,
  },
  {
    type: 'cityName',
    value: 'SAMARLAKOTA, ANDHRA PRADESH',
    masterId: 14867,
  },
  {
    type: 'cityName',
    value: 'SALONA, ASSAM',
    masterId: 17723,
  },
  {
    type: 'cityName',
    value: 'SHELU, MAHARASHTRA ',
    masterId: 17585,
  },
  {
    type: 'cityName',
    value: 'SALPA, MAHARASHTRA',
    masterId: 16080,
  },
  {
    type: 'cityName',
    value: 'SIVALINGAPURAM, ANDHRA PRADESH',
    masterId: 15236,
  },
  {
    type: 'cityName',
    value: 'SALOGRA, HIMACHAL PRADESH',
    masterId: 14855,
  },
  {
    type: 'cityName',
    value: 'SARLA, ORISSA',
    masterId: 18125,
  },
  {
    type: 'cityName',
    value: 'SURLA, ORISSA',
    masterId: 18996,
  },
  {
    type: 'cityName',
    value: 'SALARPUR, UTTAR PRADESH',
    masterId: 16327,
  },
  {
    type: 'cityName',
    value: 'SALANPUR, WEST BENGAL',
    masterId: 14838,
  },
  {
    type: 'cityName',
    value: 'SILAUT, BIHAR',
    masterId: 15163,
  },
  {
    type: 'cityName',
    value: 'SILLAKKUDI, TAMIL NADU',
    masterId: 16883,
  },
  {
    type: 'cityName',
    value: 'SASALU, KARNATAKA',
    masterId: 17981,
  },
  {
    type: 'cityName',
    value: 'SANDALPUR, MADHYA PRADESH',
    masterId: 17881,
  },
  {
    type: 'cityName',
    value: 'SOHAWAL, UTTAR PRADESH',
    masterId: 15249,
  },
  {
    type: 'cityName',
    value: 'SILAWAR, UTTAR PRADESH',
    masterId: 16307,
  },
  {
    type: 'cityName',
    value: 'SELENGHAT, ASSAM',
    masterId: 18862,
  },
  {
    type: 'cityName',
    value: 'SAMALPATTI, TAMIL NADU',
    masterId: 14866,
  },
  {
    type: 'cityName',
    value: 'SOLARI, ORISSA',
    masterId: 17432,
  },
  {
    type: 'cityName',
    value: 'ANDHIRAMPARA, WEST BENGAL',
    masterId: 10198,
  },
  {
    type: 'cityName',
    value: 'HATSIMLA, WEST BENGAL',
    masterId: 11970,
  },
  {
    type: 'cityName',
    value: 'PATAUNDA, RAJASTHAN',
    masterId: 14283,
  },
  {
    type: 'cityName',
    value: 'SIMBHAOLI, UTTAR PRADESH',
    masterId: 15171,
  },
  {
    type: 'cityName',
    value: 'SAMBA, JAMMU AND KASHMIR',
    masterId: 14872,
  },
  {
    type: 'cityName',
    value: 'SHYAM CHAK, WEST BENGAL',
    masterId: 16195,
  },
  {
    type: 'cityName',
    value: 'SIMEN CHAPORI, ASSAM',
    masterId: 18860,
  },
  {
    type: 'cityName',
    value: 'CHARANMAHADEVI, TAMIL NADU',
    masterId: 19152,
  },
  {
    type: 'cityName',
    value: 'SHAHBAD MOHD PUR, DELHI',
    masterId: 18575,
  },
  {
    type: 'cityName',
    value: 'SHIMOGA, KARNATAKA',
    masterId: 15089,
  },
  {
    type: 'cityName',
    value: 'SAMAR GOPALPUR, HARYANA',
    masterId: 18257,
  },
  {
    type: 'cityName',
    value: 'SAMAGURI, ASSAM',
    masterId: 18863,
  },
  {
    type: 'cityName',
    value: 'SIMRAHA, BIHAR ',
    masterId: 18638,
  },
  {
    type: 'cityName',
    value: 'SITAMARHI, BIHAR',
    masterId: 15227,
  },
  {
    type: 'cityName',
    value: 'SAMALKHA, HARYANA',
    masterId: 14864,
  },
  {
    type: 'cityName',
    value: 'SOMANKATTI, KARNATAKA',
    masterId: 17974,
  },
  {
    type: 'cityName',
    value: 'SAMLAYA, GUJARAT',
    masterId: 14877,
  },
  {
    type: 'cityName',
    value: 'SHIMILIAGUDA, ANDHRA PRADESH',
    masterId: 15087,
  },
  {
    type: 'cityName',
    value: 'SALIAMANGALAM, TAMIL NADU',
    masterId: 16889,
  },
  {
    type: 'cityName',
    value: 'SARMATANR, JHARKHAND',
    masterId: 20853,
  },
  {
    type: 'cityName',
    value: 'SOMATANE, MAHARASHTRA',
    masterId: 15255,
  },
  {
    type: 'cityName',
    value: 'SOMNATH, GUJARAT',
    masterId: 15260,
  },
  {
    type: 'cityName',
    value: 'SHRI MAKRI NATH NAGAR, RAJASTHAN',
    masterId: 17068,
  },
  {
    type: 'cityName',
    value: 'SEMAPUR, BIHAR',
    masterId: 15015,
  },
  {
    type: 'cityName',
    value: 'SHAMBHUPURA, RAJASTHAN',
    masterId: 15057,
  },
  {
    type: 'cityName',
    value: 'SHYAMPURA, RAJASTHAN',
    masterId: 15135,
  },
  {
    type: 'cityName',
    value: 'SHRIMADHOPUR, RAJASTHAN',
    masterId: 15128,
  },
  {
    type: 'cityName',
    value: 'SHAMLI, UTTAR PRADESH',
    masterId: 15060,
  },
  {
    type: 'cityName',
    value: 'SAMDHARI, RAJASTHAN',
    masterId: 14875,
  },
  {
    type: 'cityName',
    value: 'SUMRERI, MADHYA PRADESH',
    masterId: 15337,
  },
  {
    type: 'cityName',
    value: 'SALAMATPUR, MADHYA PRADESH',
    masterId: 14837,
  },
  {
    type: 'cityName',
    value: 'SAMUKTALA, WEST BENGAL',
    masterId: 16197,
  },
  {
    type: 'cityName',
    value: 'SAHEED MATANGINI, WEST BENGAL',
    masterId: 21096,
  },
  {
    type: 'cityName',
    value: 'SIMARIA, MADHYA PRADESH',
    masterId: 17766,
  },
  {
    type: 'cityName',
    value: 'SHAMBHU, PUNJAB',
    masterId: 17290,
  },
  {
    type: 'cityName',
    value: 'SUMAOLI, MADHYA PRADESH',
    masterId: 17763,
  },
  {
    type: 'cityName',
    value: 'G.BOMMASANDRA, KARNATAKA',
    masterId: 11584,
  },
  {
    type: 'cityName',
    value: 'SIMURALI, WEST BENGAL',
    masterId: 15177,
  },
  {
    type: 'cityName',
    value: 'SARAI MIR, UTTAR PRADESH',
    masterId: 14936,
  },
  {
    type: 'cityName',
    value: 'SUKNA, WEST BENGAL',
    masterId: 15319,
  },
  {
    type: 'cityName',
    value: 'DASANAPURA, GUJARAT',
    masterId: 18101,
  },
  {
    type: 'cityName',
    value: 'SONA ARJUNPUR, UTTAR PRADESH',
    masterId: 16298,
  },
  {
    type: 'cityName',
    value: 'SRINAGAR, RAJASTHAN',
    masterId: 15293,
  },
  {
    type: 'cityName',
    value: 'SATNAUR BADESRON, PUNJAB',
    masterId: 17293,
  },
  {
    type: 'cityName',
    value: 'SUNDERABAD, MADHYA PRADESH',
    masterId: 20880,
  },
  {
    type: 'cityName',
    value: 'CHHAPAIYA, UTTAR PRADESH',
    masterId: 11056,
  },
  {
    type: 'cityName',
    value: 'SINGHRA, ASSAM',
    masterId: 18250,
  },
  {
    type: 'cityName',
    value: 'SONDIMRA, WEST BENGAL',
    masterId: 18118,
  },
  {
    type: 'cityName',
    value: 'SINDHUDURG, MAHARASHTRA',
    masterId: 15185,
  },
  {
    type: 'cityName',
    value: 'SENDURAI, TAMIL NADU',
    masterId: 16886,
  },
  {
    type: 'cityName',
    value: 'SINDRI, JHARKHAND',
    masterId: 18121,
  },
  {
    type: 'cityName',
    value: 'SANDAI, UTTAR PRADESH',
    masterId: 17777,
  },
  {
    type: 'cityName',
    value: 'SHENOLI, MAHARASHTRA',
    masterId: 17584,
  },
  {
    type: 'cityName',
    value: 'SINGHPUR, MADHYA PRADESH',
    masterId: 15196,
  },
  {
    type: 'cityName',
    value: 'SANGANNAPUR, MAHARASHTRA',
    masterId: 14897,
  },
  {
    type: 'cityName',
    value: 'SAUNSHI, KARNATAKA',
    masterId: 14987,
  },
  {
    type: 'cityName',
    value: 'SANKHAI, GUJARAT',
    masterId: 16079,
  },
  {
    type: 'cityName',
    value: 'SANHATI, WEST BENGAL',
    masterId: 21169,
  },
  {
    type: 'cityName',
    value: 'SINDI, MAHARASHTRA',
    masterId: 15186,
  },
  {
    type: 'cityName',
    value: 'SATH NARAINI, UTTAR PRADESH',
    masterId: 21027,
  },
  {
    type: 'cityName',
    value: 'PARSAMAL, MAHARASHTRA',
    masterId: 14262,
  },
  {
    type: 'cityName',
    value: 'SONKHAMB, MAHARASHTRA',
    masterId: 17578,
  },
  {
    type: 'cityName',
    value: 'SUNEHTI KHARKHR, UTTAR PRADESH',
    masterId: 16702,
  },
  {
    type: 'cityName',
    value: 'SANKARAGUMMANUR, ANDHRA PRADESH',
    masterId: 19000,
  },
  {
    type: 'cityName',
    value: 'SANKARANKOVIL, TAMIL NADU',
    masterId: 14907,
  },
  {
    type: 'cityName',
    value: 'SANKA, WEST BENGAL',
    masterId: 14906,
  },
  {
    type: 'cityName',
    value: 'SANKRA, CHHATTISGARH',
    masterId: 18596,
  },
  {
    type: 'cityName',
    value: 'SAHNEWAL, PUNJAB',
    masterId: 14811,
  },
  {
    type: 'cityName',
    value: 'SANTALPUR, GUJARAT',
    masterId: 14919,
  },
  {
    type: 'cityName',
    value: 'SITANAGARAM VIZIANAGARAM , ANDHRA PRADESH',
    masterId: 15228,
  },
  {
    type: 'cityName',
    value: 'SINDRI MARSHALLING, JHARKHAND',
    masterId: 19111,
  },
  {
    type: 'cityName',
    value: 'SONEGAON, MAHARASHTRA',
    masterId: 15272,
  },
  {
    type: 'cityName',
    value: 'SOMANUR, TAMIL NADU',
    masterId: 16880,
  },
  {
    type: 'cityName',
    value: 'SHANKAPUR, TELANGANA',
    masterId: 16802,
  },
  {
    type: 'cityName',
    value: 'SHANKARPUR, JHARKHAND',
    masterId: 15066,
  },
  {
    type: 'cityName',
    value: 'SHYAMNAGAR, WEST BENGAL',
    masterId: 16077,
  },
  {
    type: 'cityName',
    value: 'SANWARA, UTTAR PRADESH',
    masterId: 17074,
  },
  {
    type: 'cityName',
    value: 'SANSARTALI, ORISSA',
    masterId: 17436,
  },
  {
    type: 'cityName',
    value: 'SANSARPUR, MADHYA PRADESH',
    masterId: 14917,
  },
  {
    type: 'cityName',
    value: 'VIRRA, UTTAR PRADESH',
    masterId: 15898,
  },
  {
    type: 'cityName',
    value: 'SAINAGAR SHIRDI, MAHARASHTRA',
    masterId: 14817,
  },
  {
    type: 'cityName',
    value: 'SHIRDI, MAHARASHTRA',
    masterId: 14817,
  },
  {
    type: 'cityName',
    value: 'SONSHELU, MAHARASHTRA',
    masterId: 15279,
  },
  {
    type: 'cityName',
    value: 'SONASAN, GUJARAT',
    masterId: 18395,
  },
  {
    type: 'cityName',
    value: 'SAINTHIA, WEST BENGAL',
    masterId: 14819,
  },
  {
    type: 'cityName',
    value: 'SANTALDIH, WEST BENGAL',
    masterId: 14918,
  },
  {
    type: 'cityName',
    value: 'SONTHALIYA, RAJASTHAN',
    masterId: 17246,
  },
  {
    type: 'cityName',
    value: 'SANGRAMPUR, WEST BENGAL',
    masterId: 21205,
  },
  {
    type: 'cityName',
    value: 'SOUNDAD, MAHARASHTRA',
    masterId: 15285,
  },
  {
    type: 'cityName',
    value: 'KANHEGAON, MAHARASHTRA',
    masterId: 12488,
  },
  {
    type: 'cityName',
    value: 'JAFRABAD, UTTAR PRADESH',
    masterId: 12104,
  },
  {
    type: 'cityName',
    value: 'SONIYANA, RAJASTHAN',
    masterId: 17064,
  },
  {
    type: 'cityName',
    value: 'SHERGANJ, UTTAR PRADESH',
    masterId: 17880,
  },
  {
    type: 'cityName',
    value: 'SOMRA, WEST BENGAL',
    masterId: 15262,
  },
  {
    type: 'cityName',
    value: 'SILANIBARI, ASSAM',
    masterId: 18861,
  },
  {
    type: 'cityName',
    value: 'SOJAT, RAJASTHAN',
    masterId: 15250,
  },
  {
    type: 'cityName',
    value: 'SHEOPUR KALAN, MADHYA PRADESH',
    masterId: 17771,
  },
  {
    type: 'cityName',
    value: 'SURATGARH, RAJASTHAN',
    masterId: 15354,
  },
  {
    type: 'cityName',
    value: 'JAUTUKBAHAL, ORISSA',
    masterId: 12216,
  },
  {
    type: 'cityName',
    value: 'SIROHI, RAJASTHAN',
    masterId: 15214,
  },
  {
    type: 'cityName',
    value: 'SOHAAL, PUNJAB',
    masterId: 19068,
  },
  {
    type: 'cityName',
    value: 'SAROJINI NAGAR, GUJARAT',
    masterId: 20818,
  },
  {
    type: 'cityName',
    value: 'SIHOR, GUJARAT',
    masterId: 15153,
  },
  {
    type: 'cityName',
    value: 'SOVABAZAR-AHIRITOLA, WEST BENGAL',
    masterId: 21065,
  },
  {
    type: 'cityName',
    value: 'SOMNA, UTTAR PRADESH',
    masterId: 15259,
  },
  {
    type: 'cityName',
    value: 'SONAMUKHI, WEST BENGAL',
    masterId: 21122,
  },
  {
    type: 'cityName',
    value: 'SONI, MADHYA PRADESH',
    masterId: 15276,
  },
  {
    type: 'cityName',
    value: 'SHIVPURA, UTTAR PRADESH',
    masterId: 15113,
  },
  {
    type: 'cityName',
    value: 'BIRIDI-SOMPUR, KARNATAKA',
    masterId: 17515,
  },
  {
    type: 'cityName',
    value: 'SONAGIR, MADHYA PRADESH',
    masterId: 15265,
  },
  {
    type: 'cityName',
    value: 'SORAI, MADHYA PRADESH',
    masterId: 16719,
  },
  {
    type: 'cityName',
    value: 'SORO, ORISSA',
    masterId: 15283,
  },
  {
    type: 'cityName',
    value: 'SOMESAR, RAJASTHAN',
    masterId: 15256,
  },
  {
    type: 'cityName',
    value: 'SHOHRATGARH, UTTAR PRADESH',
    masterId: 16310,
  },
  {
    type: 'cityName',
    value: 'SUPAUL, BIHAR',
    masterId: 15344,
  },
  {
    type: 'cityName',
    value: 'SAIDAPET, BIHAR',
    masterId: 20778,
  },
  {
    type: 'cityName',
    value: 'S PANAMBAKKAM, TAMIL NADU',
    masterId: 20980,
  },
  {
    type: 'cityName',
    value: 'SONEKPUR, UTTAR PRADESH',
    masterId: 16297,
  },
  {
    type: 'cityName',
    value: 'SITAPUR, UTTAR PRADESH',
    masterId: 15229,
  },
  {
    type: 'cityName',
    value: 'SUPEDI, GUJARAT',
    masterId: 15346,
  },
  {
    type: 'cityName',
    value: 'SINGHPUR DUMRA, MADHYA PRADESH',
    masterId: 17764,
  },
  {
    type: 'cityName',
    value: 'SHEOPRASADNAGER, CHHATTISGARH',
    masterId: 15081,
  },
  {
    type: 'cityName',
    value: 'SARAI GOPAL, UTTAR PRADESH',
    masterId: 16324,
  },
  {
    type: 'cityName',
    value: 'SAMPIGE, KARNATAKA',
    masterId: 18083,
  },
  {
    type: 'cityName',
    value: 'SHAMPURHALLI, KARNATAKA',
    masterId: 17980,
  },
  {
    type: 'cityName',
    value: 'SAMASTIPUR, BIHAR',
    masterId: 14868,
  },
  {
    type: 'cityName',
    value: 'SAIDPUR JALALABAD HA, PUNJAB',
    masterId: 20936,
  },
  {
    type: 'cityName',
    value: 'SAPEKHATI, ASSAM',
    masterId: 14928,
  },
  {
    type: 'cityName',
    value: 'SUNDERAPERUMAL KOVIL, TAMIL NADU',
    masterId: 16878,
  },
  {
    type: 'cityName',
    value: 'PANJIPARA, WEST BENGAL',
    masterId: 14215,
  },
  {
    type: 'cityName',
    value: 'SHAHJAHANPUR, UTTAR PRADESH',
    masterId: 15047,
  },
  {
    type: 'cityName',
    value: 'SURPURA, RAJASTHAN',
    masterId: 15365,
  },
  {
    type: 'cityName',
    value: 'SHAHPUR, BIHAR',
    masterId: 15048,
  },
  {
    type: 'cityName',
    value: 'SUDHNIPUR, UTTAR PRADESH',
    masterId: 16294,
  },
  {
    type: 'cityName',
    value: 'SORUPETA, ASSAM',
    masterId: 18858,
  },
  {
    type: 'cityName',
    value: 'SONARPUR JN, WEST BENGAL',
    masterId: 20919,
  },
  {
    type: 'cityName',
    value: 'SILLIPUR, RAJASTHAN',
    masterId: 17767,
  },
  {
    type: 'cityName',
    value: 'KARLAKONA, ORISSA',
    masterId: 12561,
  },
  {
    type: 'cityName',
    value: 'SEETHAPURAM, ORISSA',
    masterId: 18999,
  },
  {
    type: 'cityName',
    value: 'SALEMPUR, BIHAR',
    masterId: 18648,
  },
  {
    type: 'cityName',
    value: 'SARPESWAR PH, ORISSA',
    masterId: 17434,
  },
  {
    type: 'cityName',
    value: 'SOMPETA, ANDHRA PRADESH',
    masterId: 15261,
  },
  {
    type: 'cityName',
    value: 'SILAPATHAR, ASSAM',
    masterId: 15162,
  },
  {
    type: 'cityName',
    value: 'SIVAPUR, KARNATAKA',
    masterId: 19115,
  },
  {
    type: 'cityName',
    value: 'BALAPARA-II, ASSAM',
    masterId: 10419,
  },
  {
    type: 'cityName',
    value: 'SARSONPURI, CHHATTISGARH',
    masterId: 18595,
  },
  {
    type: 'cityName',
    value: 'SIPAYA, UTTAR PRADESH',
    masterId: 18637,
  },
  {
    type: 'cityName',
    value: 'SAMPLA, HARYANA',
    masterId: 14879,
  },
  {
    type: 'cityName',
    value: 'SINGABAD, WEST BENGAL',
    masterId: 16075,
  },
  {
    type: 'cityName',
    value: 'SATHIRAKUDI, TAMIL NADU',
    masterId: 16887,
  },
  {
    type: 'cityName',
    value: 'SAMRALA, MAHARASHTRA',
    masterId: 14880,
  },
  {
    type: 'cityName',
    value: 'SUKRITIPUR, ASSAM',
    masterId: 15320,
  },
  {
    type: 'cityName',
    value: 'SAILA KHURD, PUNJAB',
    masterId: 17294,
  },
  {
    type: 'cityName',
    value: 'SONTALAI, MADHYA PRADESH',
    masterId: 15280,
  },
  {
    type: 'cityName',
    value: 'SARAI KANSRAI, UTTAR PRADESH',
    masterId: 14935,
  },
  {
    type: 'cityName',
    value: 'SALAGAON, ORISSA',
    masterId: 17437,
  },
  {
    type: 'cityName',
    value: 'SULTANPUR, PUNJAB',
    masterId: 15330,
  },
  {
    type: 'cityName',
    value: 'SIGSIGI, JHARKHAND',
    masterId: 18123,
  },
  {
    type: 'cityName',
    value: 'SEMRA, BIHAR',
    masterId: 18643,
  },
  {
    type: 'cityName',
    value: 'WAZEERABAD, RAJASTHAN',
    masterId: 15958,
  },
  {
    type: 'cityName',
    value: 'SEHARA BAZAR, WEST BENGAL',
    masterId: 21111,
  },
  {
    type: 'cityName',
    value: 'SHRIMAD DWKPURI, UTTAR PRADESH',
    masterId: 16705,
  },
  {
    type: 'cityName',
    value: 'SAHARANPUR, UTTAR PRADESH',
    masterId: 14803,
  },
  {
    type: 'cityName',
    value: 'SAGAR, KARNATAKA',
    masterId: 14797,
  },
  {
    type: 'cityName',
    value: 'SURAJGARH, RAJASTHAN',
    masterId: 15348,
  },
  {
    type: 'cityName',
    value: 'TIRUCHIRAPPALLI, TAMIL NADU',
    masterId: 15577,
  },
  {
    type: 'cityName',
    value: 'SARGIPALI, ORISSA',
    masterId: 17531,
  },
  {
    type: 'cityName',
    value: 'SALMARI, BIHAR',
    masterId: 14854,
  },
  {
    type: 'cityName',
    value: 'GOTEGAON, MADHYA PRADESH',
    masterId: 11785,
  },
  {
    type: 'cityName',
    value: 'SHANKARGARH, MADHYA PRADESH',
    masterId: 15064,
  },
  {
    type: 'cityName',
    value: 'SURAJ KUNDA, UTTAR PRADESH',
    masterId: 16717,
  },
  {
    type: 'cityName',
    value: 'SIRJAM, WEST BENGAL',
    masterId: 15210,
  },
  {
    type: 'cityName',
    value: 'TEGHARI, WEST BENGAL',
    masterId: 15460,
  },
  {
    type: 'cityName',
    value: 'SAMRAU, RAJASTHAN',
    masterId: 17077,
  },
  {
    type: 'cityName',
    value: 'SEMARKHERI, MADHYA PRADESH',
    masterId: 15016,
  },
  {
    type: 'cityName',
    value: 'SHEREKAN, RAJASTHAN',
    masterId: 17070,
  },
  {
    type: 'cityName',
    value: 'SALAR KHURD, UTTAR PRADESH',
    masterId: 18650,
  },
  {
    type: 'cityName',
    value: 'SAROLA, MAHARASHTRA',
    masterId: 14955,
  },
  {
    type: 'cityName',
    value: 'SARNA, PUNJAB',
    masterId: 18236,
  },
  {
    type: 'cityName',
    value: 'SEMRAO, BIHAR',
    masterId: 16709,
  },
  {
    type: 'cityName',
    value: 'SIRSI, UTTAR PRADESH',
    masterId: 16303,
  },
  {
    type: 'cityName',
    value: 'SRIRAMPURAM, ANDHRA PRADESH',
    masterId: 15298,
  },
  {
    type: 'cityName',
    value: 'SARMATHURA, RAJASTHAN ',
    masterId: 17073,
  },
  {
    type: 'cityName',
    value: 'SORON, UTTAR PRADESH',
    masterId: 15284,
  },
  {
    type: 'cityName',
    value: 'SRIRAMNAGAR, ANDHRA PRADESH',
    masterId: 16010,
  },
  {
    type: 'cityName',
    value: 'SIRATHU, UTTAR PRADESH',
    masterId: 15205,
  },
  {
    type: 'cityName',
    value: 'SERAMPORE, WEST BENGAL',
    masterId: 15026,
  },
  {
    type: 'cityName',
    value: 'SRIRAMPUR, ASSAM',
    masterId: 18957,
  },
  {
    type: 'cityName',
    value: 'SWAROOPGANJ, RAJASTHAN',
    masterId: 15369,
  },
  {
    type: 'cityName',
    value: 'SIRIPURAM, ANDHRA PRADESH',
    masterId: 15209,
  },
  {
    type: 'cityName',
    value: 'SRIPANI, ASSAM',
    masterId: 18857,
  },
  {
    type: 'cityName',
    value: 'SARUPSAR, RAJASTHAN',
    masterId: 17072,
  },
  {
    type: 'cityName',
    value: 'SRIPUR, WEST BENGAL',
    masterId: 16073,
  },
  {
    type: 'cityName',
    value: 'SHORANUR, KERALA',
    masterId: 15120,
  },
  {
    type: 'cityName',
    value: 'SURER, RAJASTHAN',
    masterId: 15358,
  },
  {
    type: 'cityName',
    value: 'SARSI, BIHAR',
    masterId: 17776,
  },
  {
    type: 'cityName',
    value: 'SIRSALA, RAJASTHAN',
    masterId: 19138,
  },
  {
    type: 'cityName',
    value: 'SATTUR, TAMIL NADU',
    masterId: 14978,
  },
  {
    type: 'cityName',
    value: 'SOOROTHEE, RAJASTHAN',
    masterId: 17063,
  },
  {
    type: 'cityName',
    value: 'CHERTHALA, KERALA',
    masterId: 11044,
  },
  {
    type: 'cityName',
    value: 'SIBSAGAR, ASSAM',
    masterId: 15137,
  },
  {
    type: 'cityName',
    value: 'SALEMPUR, UTTAR PRADESH',
    masterId: 14848,
  },
  {
    type: 'cityName',
    value: 'SHRAVANUR, KARNATAKA',
    masterId: 17979,
  },
  {
    type: 'cityName',
    value: 'SIRUVATHUR, TAMIL NADU',
    masterId: 16881,
  },
  {
    type: 'cityName',
    value: 'SERAULIM, GOA',
    masterId: 18566,
  },
  {
    type: 'cityName',
    value: 'SRIKARANPUR, RAJASTHAN',
    masterId: 15290,
  },
  {
    type: 'cityName',
    value: 'SIRARI, BIHAR',
    masterId: 15204,
  },
  {
    type: 'cityName',
    value: 'SARDARGARH, RAJASTHAN',
    masterId: 19149,
  },
  {
    type: 'cityName',
    value: 'SHIRSOLI, MAHARASHTRA',
    masterId: 17582,
  },
  {
    type: 'cityName',
    value: 'SIRSA, HARYANA',
    masterId: 15217,
  },
  {
    type: 'cityName',
    value: 'SONACHARA, WEST BENGAL',
    masterId: 21100,
  },
  {
    type: 'cityName',
    value: 'SHAMSABAD, UTTAR PRADESH',
    masterId: 16314,
  },
  {
    type: 'cityName',
    value: 'SHAMSHABAD TOWN, UTTAR PRADESH',
    masterId: 21038,
  },
  {
    type: 'cityName',
    value: 'SHIRSUPHAL, MAHARASHTRA',
    masterId: 15099,
  },
  {
    type: 'cityName',
    value: 'SHIU SAGAR, BIHAR',
    masterId: 18640,
  },
  {
    type: 'cityName',
    value: 'SURSARAIGHAT JHARA, MADHYA PRADESH',
    masterId: 17762,
  },
  {
    type: 'cityName',
    value: 'SISAI GULABRAI, UTTAR PRADESH',
    masterId: 16302,
  },
  {
    type: 'cityName',
    value: 'SIRSAI, MAHARASHTRA',
    masterId: 17065,
  },
  {
    type: 'cityName',
    value: 'SUISA, WEST BENGAL',
    masterId: 15311,
  },
  {
    type: 'cityName',
    value: 'SISARKA, UTTAR PRADESH',
    masterId: 15223,
  },
  {
    type: 'cityName',
    value: 'SUSKAL, GUJARAT',
    masterId: 18524,
  },
  {
    type: 'cityName',
    value: 'SIRSAUL, UTTAR PRADESH',
    masterId: 21033,
  },
  {
    type: 'cityName',
    value: 'SASARAM, BIHAR',
    masterId: 14960,
  },
  {
    type: 'cityName',
    value: 'SHANSON, ORISSA',
    masterId: 16313,
  },
  {
    type: 'cityName',
    value: 'SREE APARTMENT, KARNATAKA',
    masterId: 17973,
  },
  {
    type: 'cityName',
    value: 'SATSANG NAGAR HALT, JHARKHAND',
    masterId: 20862,
  },
  {
    type: 'cityName',
    value: 'SHAHID SURAJ NARAYAN SINGH, BIHAR',
    masterId: 18642,
  },
  {
    type: 'cityName',
    value: 'SANTOSHPUR, ANDHRA PRADESH',
    masterId: 20735,
  },
  {
    type: 'cityName',
    value: 'SADASHIVAPET RD, ANDHRA PRADESH',
    masterId: 14787,
  },
  {
    type: 'cityName',
    value: 'SATISH SAMANTA PH, WEST BENGAL',
    masterId: 21226,
  },
  {
    type: 'cityName',
    value: 'SAI P NILAYAM, ANDHRA PRADESH',
    masterId: 14812,
  },
  {
    type: 'cityName',
    value: 'SADASIBAPUR, ORISSA',
    masterId: 17438,
  },
  {
    type: 'cityName',
    value: 'SARERI, RAJASTHAN',
    masterId: 14952,
  },
  {
    type: 'cityName',
    value: 'SHASAN ROAD, WEST BENGAL',
    masterId: 21185,
  },
  {
    type: 'cityName',
    value: 'SASAMUSA, BIHAR',
    masterId: 18645,
  },
  {
    type: 'cityName',
    value: 'SASWAD, MAHARASHTRA',
    masterId: 17722,
  },
  {
    type: 'cityName',
    value: 'SARSAWA, UTTAR PRADESH',
    masterId: 16319,
  },
  {
    type: 'cityName',
    value: 'SADDA SINGHWALA, PUNJAB',
    masterId: 17297,
  },
  {
    type: 'cityName',
    value: 'SATNA, MADHYA PRADESH',
    masterId: 14976,
  },
  {
    type: 'cityName',
    value: 'SHANTIPUR, WEST BENGAL',
    masterId: 20922,
  },
  {
    type: 'cityName',
    value: 'SATBERIA HALT, WEST BENGAL',
    masterId: 21199,
  },
  {
    type: 'cityName',
    value: 'SULTHANABAD, TELANGANA',
    masterId: 20994,
  },
  {
    type: 'cityName',
    value: 'TANDIBEDA, ORISSA',
    masterId: 15425,
  },
  {
    type: 'cityName',
    value: 'SITAFALMANDI B, TELANGANA',
    masterId: 20997,
  },
  {
    type: 'cityName',
    value: 'SATADHAR, GUJARAT',
    masterId: 18398,
  },
  {
    type: 'cityName',
    value: 'SAGARAKATTE, KARNATAKA',
    masterId: 17984,
  },
  {
    type: 'cityName',
    value: 'SATHAJAGAT, BIHAR',
    masterId: 14969,
  },
  {
    type: 'cityName',
    value: 'SASTHAMCOTTA, KERALA',
    masterId: 14963,
  },
  {
    type: 'cityName',
    value: 'SULTANPUR-KALIAWAS, HARYANA',
    masterId: 18305,
  },
  {
    type: 'cityName',
    value: 'SIMULTALA, BIHAR',
    masterId: 15176,
  },
  {
    type: 'cityName',
    value: 'SITLAPUR PH, WEST BENGAL',
    masterId: 21091,
  },
  {
    type: 'cityName',
    value: 'SITOULI, MADHYA PRADESH',
    masterId: 16299,
  },
  {
    type: 'cityName',
    value: 'SITALPUR, BIHAR',
    masterId: 15226,
  },
  {
    type: 'cityName',
    value: 'SITARAMPUR, WEST BENGAL',
    masterId: 15230,
  },
  {
    type: 'cityName',
    value: 'SATNALI, HARYANA',
    masterId: 18254,
  },
  {
    type: 'cityName',
    value: 'SITALNAGAR, RAJASTHAN',
    masterId: 19067,
  },
  {
    type: 'cityName',
    value: 'SITAFAL MANDI, ANDHRA PRADESH',
    masterId: 15225,
  },
  {
    type: 'cityName',
    value: 'SEETHAMPETA, ANDHRA PRADESH',
    masterId: 15008,
  },
  {
    type: 'cityName',
    value: 'SATARA, MAHARASHTRA',
    masterId: 14967,
  },
  {
    type: 'cityName',
    value: 'SITAPUR KACHEHRI, UTTAR PRADESH',
    masterId: 16300,
  },
  {
    type: 'cityName',
    value: 'SHAITANSINGHNGR, RAJASTHAN',
    masterId: 17071,
  },
  {
    type: 'cityName',
    value: 'SATULURU, ANDHRA PRADESH',
    masterId: 14980,
  },
  {
    type: 'cityName',
    value: 'SATYAVADA, ANDHRA PRADESH',
    masterId: 20733,
  },
  {
    type: 'cityName',
    value: 'SATWAR, BIHAR',
    masterId: 14981,
  },
  {
    type: 'cityName',
    value: 'SATRAON, UTTAR PRADESH',
    masterId: 16318,
  },
  {
    type: 'cityName',
    value: 'DHADKINALA, WEST BENGAL',
    masterId: 11329,
  },
  {
    type: 'cityName',
    value: 'SUBHAGPUR, UTTAR PRADESH',
    masterId: 16718,
  },
  {
    type: 'cityName',
    value: 'SUDHANI, BIHAR',
    masterId: 15308,
  },
  {
    type: 'cityName',
    value: 'SUMMADEVI, ANDHRA PRADESH',
    masterId: 18997,
  },
  {
    type: 'cityName',
    value: 'SULEHALLI, KARNATAKA',
    masterId: 15322,
  },
  {
    type: 'cityName',
    value: 'SUI, HARYANA',
    masterId: 18247,
  },
  {
    type: 'cityName',
    value: 'SARJU, UTTAR PRADESH',
    masterId: 18126,
  },
  {
    type: 'cityName',
    value: 'SUJANGARH, RAJASTHAN',
    masterId: 15312,
  },
  {
    type: 'cityName',
    value: 'SUJRA, UTTAR PRADESH',
    masterId: 16293,
  },
  {
    type: 'cityName',
    value: 'SUKU, ORISSA',
    masterId: 15321,
  },
  {
    type: 'cityName',
    value: 'SULADHAL, KARNATAKA',
    masterId: 18082,
  },
  {
    type: 'cityName',
    value: 'SULHANI, PUNJAB',
    masterId: 17289,
  },
  {
    type: 'cityName',
    value: 'SUMMIT, MAHARASHTRA',
    masterId: 17575,
  },
  {
    type: 'cityName',
    value: 'SUMER, MADHYA PRADESH',
    masterId: 15334,
  },
  {
    type: 'cityName',
    value: 'SUNAMAI, UTTAR PRADESH',
    masterId: 16292,
  },
  {
    type: 'cityName',
    value: 'SHRUNGAVARPUKTA, ANDHRA PRADESH',
    masterId: 15131,
  },
  {
    type: 'cityName',
    value: 'SOLAPUR, MAHARASHTRA',
    masterId: 15252,
  },
  {
    type: 'cityName',
    value: 'SURI, WEST BENGAL',
    masterId: 15360,
  },
  {
    type: 'cityName',
    value: 'SURELI, RAJASTHAN',
    masterId: 15356,
  },
  {
    type: 'cityName',
    value: 'SURATPURA, RAJASTHAN',
    masterId: 20959,
  },
  {
    type: 'cityName',
    value: 'SURERA, HARYANA',
    masterId: 17059,
  },
  {
    type: 'cityName',
    value: 'SULTANA, RAJASTHAN',
    masterId: 17061,
  },
  {
    type: 'cityName',
    value: 'SENGATHURAI - SULUR, TAMIL NADU',
    masterId: 17025,
  },
  {
    type: 'cityName',
    value: 'SUKHISEWANIYAN, MADHYA PRADESH',
    masterId: 15315,
  },
  {
    type: 'cityName',
    value: 'SUDIYUR, TAMIL NADU',
    masterId: 16879,
  },
  {
    type: 'cityName',
    value: 'SUBANSIRI, ASSAM',
    masterId: 18856,
  },
  {
    type: 'cityName',
    value: 'SIWAN, BIHAR',
    masterId: 15239,
  },
  {
    type: 'cityName',
    value: 'SUWASRA, MADHYA PRADESH',
    masterId: 15368,
  },
  {
    type: 'cityName',
    value: 'SAVNI, GUJARAT ',
    masterId: 18397,
  },
  {
    type: 'cityName',
    value: 'KACHAHARI, BIHAR',
    masterId: 18824,
  },
  {
    type: 'cityName',
    value: 'SARWARI, MAHARASHTRA',
    masterId: 14958,
  },
  {
    type: 'cityName',
    value: 'SHMATA VD KATRA, JAMMU AND KASHMIR',
    masterId: 16062,
  },
  {
    type: 'cityName',
    value: 'SRI VENKATAPERUMAL R, ANDHRA PRADESH',
    masterId: 18998,
  },
  {
    type: 'cityName',
    value: 'SAWALGI, KARNATAKA',
    masterId: 14995,
  },
  {
    type: 'cityName',
    value: 'SIVAGANGA, TAMIL NADU',
    masterId: 15232,
  },
  {
    type: 'cityName',
    value: 'BIKRAMPUR, WEST BENGAL',
    masterId: 10820,
  },
  {
    type: 'cityName',
    value: 'SHISHWINHALLIï¿½, KARNATAKA',
    masterId: 15103,
  },
  {
    type: 'cityName',
    value: 'SAGARPALI, UTTAR PRADESH',
    masterId: 16332,
  },
  {
    type: 'cityName',
    value: 'SAVARKUNDLA, GUJARAT',
    masterId: 14991,
  },
  {
    type: 'cityName',
    value: 'SIVAKASI, TAMIL NADU',
    masterId: 15234,
  },
  {
    type: 'cityName',
    value: 'SEVALIYA, GUJARAT',
    masterId: 15031,
  },
  {
    type: 'cityName',
    value: 'SHIVANGAON, MAHARASHTRA',
    masterId: 15109,
  },
  {
    type: 'cityName',
    value: 'SAVANUR, KARNATAKA',
    masterId: 14989,
  },
  {
    type: 'cityName',
    value: 'SANVRAD, RAJASTHAN',
    masterId: 17075,
  },
  {
    type: 'cityName',
    value: 'S VENKTESWRPALM, ANDHRA PRADESH',
    masterId: 14776,
  },
  {
    type: 'cityName',
    value: 'SRIVILLIPUTHUR, TAMIL NADU',
    masterId: 15303,
  },
  {
    type: 'cityName',
    value: 'SIVOK, WEST BENGAL',
    masterId: 16074,
  },
  {
    type: 'cityName',
    value: 'MATHURAPUR, BIHAR',
    masterId: 13515,
  },
  {
    type: 'cityName',
    value: 'SRINIVASPUR, KARNATAKA',
    masterId: 17972,
  },
  {
    type: 'cityName',
    value: 'SHIVPURA, MADHYA PRADESH',
    masterId: 15112,
  },
  {
    type: 'cityName',
    value: 'SEVUR, TAMIL NADU',
    masterId: 17024,
  },
  {
    type: 'cityName',
    value: 'SRIVAIKUNTAM, TAMIL NADU',
    masterId: 15302,
  },
  {
    type: 'cityName',
    value: 'SHIVANI SHIVAR, MAHARASHTRA',
    masterId: 17580,
  },
  {
    type: 'cityName',
    value: 'SAVARDA, MAHARASHTRA',
    masterId: 14990,
  },
  {
    type: 'cityName',
    value: 'SARAI HARKHU, UTTAR PRADESH',
    masterId: 16323,
  },
  {
    type: 'cityName',
    value: 'SEHRAMAU, UTTAR PRADESH',
    masterId: 16722,
  },
  {
    type: 'cityName',
    value: 'SAHJANWA, UTTAR PRADESH',
    masterId: 14810,
  },
  {
    type: 'cityName',
    value: 'SEWAR, RAJASTHAN',
    masterId: 16721,
  },
  {
    type: 'cityName',
    value: 'SHIVRAMPUR, UTTAR PRADESH',
    masterId: 15116,
  },
  {
    type: 'cityName',
    value: 'SANAWAD, MADHYA PRADESH',
    masterId: 14886,
  },
  {
    type: 'cityName',
    value: 'SIWAHA, HARYANA',
    masterId: 18249,
  },
  {
    type: 'cityName',
    value: 'SIWAITH, UTTAR PRADESH',
    masterId: 15238,
  },
  {
    type: 'cityName',
    value: 'BHUNDANA, RAJASTHAN',
    masterId: 10784,
  },
  {
    type: 'cityName',
    value: 'SIDHWAN, PUNJAB',
    masterId: 17408,
  },
  {
    type: 'cityName',
    value: 'SWAMIMALAI, TAMIL NADU',
    masterId: 17019,
  },
  {
    type: 'cityName',
    value: 'MAJULI, ASSAM',
    masterId: 18966,
  },
  {
    type: 'cityName',
    value: 'SIWANA, RAJASTHAN',
    masterId: 15240,
  },
  {
    type: 'cityName',
    value: 'SANWARA, HIMACHAL PRADESH',
    masterId: 14925,
  },
  {
    type: 'cityName',
    value: 'SEWAPURI, UTTAR PRADESH',
    masterId: 15033,
  },
  {
    type: 'cityName',
    value: 'MAHULDIHA, JHARKHAND',
    masterId: 13269,
  },
  {
    type: 'cityName',
    value: 'SAHAWAR, UTTAR PRADESH',
    masterId: 16330,
  },
  {
    type: 'cityName',
    value: 'SUWANSA, UTTAR PRADESH',
    masterId: 16716,
  },
  {
    type: 'cityName',
    value: 'SHIVWALA TEHU, UTTAR PRADESH',
    masterId: 16311,
  },
  {
    type: 'cityName',
    value: 'SAWANTWADI, MAHARASHTRA',
    masterId: 14997,
  },
  {
    type: 'cityName',
    value: 'SHAHNAGAR, UTTAR PRADESH',
    masterId: 16706,
  },
  {
    type: 'cityName',
    value: 'SAIDANWALA, PUNJAB',
    masterId: 17295,
  },
  {
    type: 'cityName',
    value: 'SAGPHATA, MADHYA PRADESH',
    masterId: 17780,
  },
  {
    type: 'cityName',
    value: 'SAMBRE, KARNATAKA',
    masterId: 17982,
  },
  {
    type: 'cityName',
    value: 'SONDALIA, WEST BENGAL',
    masterId: 21155,
  },
  {
    type: 'cityName',
    value: 'SIDULI, WEST BENGAL',
    masterId: 16076,
  },
  {
    type: 'cityName',
    value: 'SHILA KHERI, HARYANA',
    masterId: 18252,
  },
  {
    type: 'cityName',
    value: 'SHOBHAPUR, MADHYA PRADESH',
    masterId: 17879,
  },
  {
    type: 'cityName',
    value: 'KUTUNIA, ORISSA',
    masterId: 13067,
  },
  {
    type: 'cityName',
    value: 'SANKOPARA, WEST BENGAL',
    masterId: 14912,
  },
  {
    type: 'cityName',
    value: 'SUAHERI, UTTAR PRADESH',
    masterId: 16295,
  },
  {
    type: 'cityName',
    value: 'SERNDANUR, TAMIL NADU',
    masterId: 19155,
  },
  {
    type: 'cityName',
    value: 'SALBARI, WEST BENGAL',
    masterId: 16081,
  },
  {
    type: 'cityName',
    value: 'SOPORE, JAMMU AND KASHMIR',
    masterId: 20839,
  },
  {
    type: 'cityName',
    value: 'SIRKAZHI, TAMIL NADU',
    masterId: 15212,
  },
  {
    type: 'cityName',
    value: 'AMGAWAN, MADHYA PRADESH',
    masterId: 10158,
  },
  {
    type: 'cityName',
    value: 'SARAI CHANDI, UTTAR PRADESH',
    masterId: 14934,
  },
  {
    type: 'cityName',
    value: 'SINDEWAHI, MAHARASHTRA',
    masterId: 17720,
  },
  {
    type: 'cityName',
    value: 'SEMAI, MADHYA PRADESH',
    masterId: 17775,
  },
  {
    type: 'cityName',
    value: 'BHARTI BHAWAN CAMPUS, UTTAR PRADESH',
    masterId: 18781,
  },
  {
    type: 'cityName',
    value: 'SAIDKHANPUR, UTTAR PRADESH',
    masterId: 16724,
  },
  {
    type: 'cityName',
    value: 'SALPURA, RAJASTHAN',
    masterId: 14856,
  },
  {
    type: 'cityName',
    value: 'SAVALYAPURAM, ANDHRA PRADESH',
    masterId: 14988,
  },
  {
    type: 'cityName',
    value: 'SAYAN, GUJARAT',
    masterId: 15001,
  },
  {
    type: 'cityName',
    value: 'SIROLIYA, MADHYA PRADESH',
    masterId: 17878,
  },
  {
    type: 'cityName',
    value: 'SINHAN, GUJARAT',
    masterId: 15198,
  },
  {
    type: 'cityName',
    value: 'SARAYAN, UTTAR PRADESH',
    masterId: 16321,
  },
  {
    type: 'cityName',
    value: 'SINDURWA, UTTAR PRADESH',
    masterId: 16306,
  },
  {
    type: 'cityName',
    value: 'SAIYID SARAWAN, UTTAR PRADESH',
    masterId: 14821,
  },
  {
    type: 'cityName',
    value: 'SONAI, UTTAR PRADESH',
    masterId: 17579,
  },
  {
    type: 'cityName',
    value: 'SALAWAS, RAJASTHAN',
    masterId: 14841,
  },
  {
    type: 'cityName',
    value: 'SAROTRA, GUJARAT',
    masterId: 18526,
  },
  {
    type: 'cityName',
    value: 'SONARDIH, JHARKHAND',
    masterId: 18119,
  },
  {
    type: 'cityName',
    value: 'SATBAHINI, JHARKHAND',
    masterId: 18124,
  },
  {
    type: 'cityName',
    value: 'SUR KHAND KA KHERA, RAJASTHAN',
    masterId: 17060,
  },
  {
    type: 'cityName',
    value: 'SHAHBAZNAGAR, UTTAR PRADESH',
    masterId: 16315,
  },
  {
    type: 'cityName',
    value: 'SARUPATHAR, ASSAM',
    masterId: 14956,
  },
  {
    type: 'cityName',
    value: 'SHIVADI, TAMIL NADU',
    masterId: 17581,
  },
  {
    type: 'cityName',
    value: 'SILAK JHORI, CHHATTISGARH',
    masterId: 15160,
  },
  {
    type: 'cityName',
    value: 'SABIRA, ORISSA',
    masterId: 17439,
  },
  {
    type: 'cityName',
    value: 'TANUR, KERALA',
    masterId: 15434,
  },
  {
    type: 'cityName',
    value: 'TADLA PUSAPALLI, ANDHRA PRADESH',
    masterId: 15383,
  },
  {
    type: 'cityName',
    value: 'TALABURU, JHARKHAND',
    masterId: 18115,
  },
  {
    type: 'cityName',
    value: 'TATICHERLA, ANDHRA PRADESH',
    masterId: 18994,
  },
  {
    type: 'cityName',
    value: 'TADALI, MAHARASHTRA',
    masterId: 15375,
  },
  {
    type: 'cityName',
    value: 'TARAKESWAR, MAHARASHTRA',
    masterId: 20904,
  },
  {
    type: 'cityName',
    value: 'TAKU, MADHYA PRADESH',
    masterId: 15396,
  },
  {
    type: 'cityName',
    value: 'TALLA, RAJASTHAN',
    masterId: 20971,
  },
  {
    type: 'cityName',
    value: 'THALL, BIHAR',
    masterId: 16792,
  },
  {
    type: 'cityName',
    value: 'TARANA, MADHYA PRADESH',
    masterId: 15439,
  },
  {
    type: 'cityName',
    value: 'DAMDA, WEST BENGAL',
    masterId: 11216,
  },
  {
    type: 'cityName',
    value: 'TAPANG, ORISSA',
    masterId: 19066,
  },
  {
    type: 'cityName',
    value: 'TAPA, PUNJAB',
    masterId: 15435,
  },
  {
    type: 'cityName',
    value: 'TARSA, MAHARASHTRA',
    masterId: 15451,
  },
  {
    type: 'cityName',
    value: 'THASRA, GUJARAT',
    masterId: 18389,
  },
  {
    type: 'cityName',
    value: 'THUMMANAMGUTTA, ANDHRA PRADESH',
    masterId: 15543,
  },
  {
    type: 'cityName',
    value: 'JAMSHEDPUR, JHARKHAND',
    masterId: 12181,
  },
  {
    type: 'cityName',
    value: 'TATI, JHARKHAND',
    masterId: 18113,
  },
  {
    type: 'cityName',
    value: 'TALALA, GUJARAT',
    masterId: 15399,
  },
  {
    type: 'cityName',
    value: 'THALAIYUTHU, TAMIL NADU',
    masterId: 17017,
  },
  {
    type: 'cityName',
    value: 'TARGAON, MAHARASHTRA',
    masterId: 15447,
  },
  {
    type: 'cityName',
    value: 'THARBITIA, BIHAR',
    masterId: 18634,
  },
  {
    type: 'cityName',
    value: 'TIMBA, GUJARAT',
    masterId: 18387,
  },
  {
    type: 'cityName',
    value: 'TRIBENI, WEST BENGAL',
    masterId: 15606,
  },
  {
    type: 'cityName',
    value: 'TILBHITA, JHARKHAND',
    masterId: 18112,
  },
  {
    type: 'cityName',
    value: 'TELIBANDHA, CHHATTISGARH',
    masterId: 18592,
  },
  {
    type: 'cityName',
    value: 'TATIBAHAR, ASSAM',
    masterId: 15455,
  },
  {
    type: 'cityName',
    value: 'TARCHERRA BRLRM, RAJASTHAN',
    masterId: 16704,
  },
  {
    type: 'cityName',
    value: 'TIMARNI, MADHYA PRADESH',
    masterId: 15562,
  },
  {
    type: 'cityName',
    value: 'TAIABPUR, BIHAR',
    masterId: 16063,
  },
  {
    type: 'cityName',
    value: 'TALBAHAT, MADHYA PRADESH',
    masterId: 15402,
  },
  {
    type: 'cityName',
    value: 'THANABHAWAN, UTTAR PRADESH',
    masterId: 16282,
  },
  {
    type: 'cityName',
    value: 'THARBAN, MAHARASHTRA',
    masterId: 17571,
  },
  {
    type: 'cityName',
    value: 'TIMBARVA, GUJARAT',
    masterId: 15563,
  },
  {
    type: 'cityName',
    value: 'TILBHUM, ASSAM',
    masterId: 18855,
  },
  {
    type: 'cityName',
    value: 'TIRUCHCHULI, TAMIL NADU',
    masterId: 20992,
  },
  {
    type: 'cityName',
    value: 'ULLERAHALLI, KARNATAKA',
    masterId: 15664,
  },
  {
    type: 'cityName',
    value: 'TIRUCHENDUR, TAMIL NADU',
    masterId: 15575,
  },
  {
    type: 'cityName',
    value: 'TIRUCHANUR, ANDHRA PRADESH',
    masterId: 19052,
  },
  {
    type: 'cityName',
    value: 'TADEPALLIGUDEM, ANDHRA PRADESH',
    masterId: 15379,
  },
  {
    type: 'cityName',
    value: 'TINDHARIA, WEST BENGAL',
    masterId: 15568,
  },
  {
    type: 'cityName',
    value: 'TADUKU, ANDHRA PRADESH',
    masterId: 18995,
  },
  {
    type: 'cityName',
    value: 'TUNDLA, UTTAR PRADESH',
    masterId: 15622,
  },
  {
    type: 'cityName',
    value: 'TILDANGA, JHARKHAND',
    masterId: 15559,
  },
  {
    type: 'cityName',
    value: 'TANDA, PUNJAB',
    masterId: 15423,
  },
  {
    type: 'cityName',
    value: 'TODARPUR, UTTAR PRADESH',
    masterId: 15594,
  },
  {
    type: 'cityName',
    value: 'TODIKKAPULAM, KERALA',
    masterId: 17905,
  },
  {
    type: 'cityName',
    value: 'TIRUVIDAIMARUTHUR, TAMIL NADU',
    masterId: 16860,
  },
  {
    type: 'cityName',
    value: 'TANDUR, ANDHRA PRADESH',
    masterId: 15426,
  },
  {
    type: 'cityName',
    value: 'THONDEBAVI, KARNATAKA',
    masterId: 15532,
  },
  {
    type: 'cityName',
    value: 'TANDWAL, HARYANA',
    masterId: 18361,
  },
  {
    type: 'cityName',
    value: 'TAREGANA, BIHAR',
    masterId: 15446,
  },
  {
    type: 'cityName',
    value: 'TRIVEDIGANJ, UTTAR PRADESH',
    masterId: 16275,
  },
  {
    type: 'cityName',
    value: 'TEKKALI, ANDHRA PRADESH',
    masterId: 15464,
  },
  {
    type: 'cityName',
    value: 'TELO, JHARKHAND',
    masterId: 15470,
  },
  {
    type: 'cityName',
    value: 'TELIA, BIHAR',
    masterId: 16193,
  },
  {
    type: 'cityName',
    value: 'TIRUNELVELI, TAMIL NADU',
    masterId: 15579,
  },
  {
    type: 'cityName',
    value: 'TEEGAON, MADHYA PRADESH',
    masterId: 17757,
  },
  {
    type: 'cityName',
    value: 'TEMPA, MAHARASHTRA',
    masterId: 17572,
  },
  {
    type: 'cityName',
    value: 'TETULMARI, JHARKHAND',
    masterId: 15478,
  },
  {
    type: 'cityName',
    value: 'BAGDOB, BIHAR',
    masterId: 10368,
  },
  {
    type: 'cityName',
    value: 'TEGHRA, BIHAR',
    masterId: 15461,
  },
  {
    type: 'cityName',
    value: 'TANGARBASULI, JHARKHAND',
    masterId: 18114,
  },
  {
    type: 'cityName',
    value: 'THANGUNDI, KARNATAKA',
    masterId: 17967,
  },
  {
    type: 'cityName',
    value: 'MORAKOLONG, ASSAM',
    masterId: 13638,
  },
  {
    type: 'cityName',
    value: 'TITAGARH, WEST BENGAL',
    masterId: 16192,
  },
  {
    type: 'cityName',
    value: 'TUGGALI, ANDHRA PRADESH',
    masterId: 15611,
  },
  {
    type: 'cityName',
    value: 'TANGARMUNDA, ORISSA',
    masterId: 15427,
  },
  {
    type: 'cityName',
    value: 'TULJAPUR, MAHARASHTRA',
    masterId: 15614,
  },
  {
    type: 'cityName',
    value: 'TENGANMUDA, CHHATTISGARH',
    masterId: 15473,
  },
  {
    type: 'cityName',
    value: 'TANGIRIAPAL, ORISSA',
    masterId: 15429,
  },
  {
    type: 'cityName',
    value: 'TINAI GHAT, KARNATAKA',
    masterId: 17965,
  },
  {
    type: 'cityName',
    value: 'TARIGOPPULA, ANDHRA PRADESH',
    masterId: 15448,
  },
  {
    type: 'cityName',
    value: 'TINICH, UTTAR PRADESH',
    masterId: 16277,
  },
  {
    type: 'cityName',
    value: 'SAREN, BIHAR',
    masterId: 14951,
  },
  {
    type: 'cityName',
    value: 'THANGADH, GUJARAT',
    masterId: 15498,
  },
  {
    type: 'cityName',
    value: 'BIHPUR, BIHAR',
    masterId: 10808,
  },
  {
    type: 'cityName',
    value: 'THAWE, BIHAR',
    masterId: 15503,
  },
  {
    type: 'cityName',
    value: 'THALERA, RAJASTHAN',
    masterId: 17244,
  },
  {
    type: 'cityName',
    value: 'TALHERI BUZURG, UTTAR PRADESH',
    masterId: 16288,
  },
  {
    type: 'cityName',
    value: 'THALLAK, KARNATAKA',
    masterId: 15488,
  },
  {
    type: 'cityName',
    value: 'THIRUVALAM, TAMIL NADU',
    masterId: 16870,
  },
  {
    type: 'cityName',
    value: 'HAMIRA, RAJASTHAN',
    masterId: 17166,
  },
  {
    type: 'cityName',
    value: 'PALRI, RAJASTHAN',
    masterId: 14171,
  },
  {
    type: 'cityName',
    value: 'TOLAHUNSE, KARNATAKA',
    masterId: 19116,
  },
  {
    type: 'cityName',
    value: 'TULIN, WEST BENGAL',
    masterId: 16068,
  },
  {
    type: 'cityName',
    value: 'TAHERPUR, WEST BENGAL',
    masterId: 15389,
  },
  {
    type: 'cityName',
    value: 'TIPPAPUR, TELANGANA',
    masterId: 16798,
  },
  {
    type: 'cityName',
    value: 'THARA, MADHYA PRADESH',
    masterId: 18390,
  },
  {
    type: 'cityName',
    value: 'THURIA, MADHYA PRADESH',
    masterId: 15546,
  },
  {
    type: 'cityName',
    value: 'BURUJUGUDA, ORISSA',
    masterId: 10930,
  },
  {
    type: 'cityName',
    value: 'THARWAI, UTTAR PRADESH',
    masterId: 16713,
  },
  {
    type: 'cityName',
    value: 'THOVALAI, TAMIL NADU',
    masterId: 16866,
  },
  {
    type: 'cityName',
    value: 'THADI, ANDHRA PRADESH',
    masterId: 15480,
  },
  {
    type: 'cityName',
    value: 'TIRUNINRAVUR, TAMIL NADU',
    masterId: 20975,
  },
  {
    type: 'cityName',
    value: 'TILAIYA, BIHAR',
    masterId: 15554,
  },
  {
    type: 'cityName',
    value: 'TIBI, RAJASTHAN',
    masterId: 18359,
  },
  {
    type: 'cityName',
    value: 'THIMMACHIPURAM, TAMIL NADU',
    masterId: 16873,
  },
  {
    type: 'cityName',
    value: 'TAGDI, GUJARAT',
    masterId: 18523,
  },
  {
    type: 'cityName',
    value: 'TITLAGARH, ORISSA',
    masterId: 15591,
  },
  {
    type: 'cityName',
    value: 'TIHU, ASSAM',
    masterId: 15551,
  },
  {
    type: 'cityName',
    value: 'TINGRAI, ASSAM',
    masterId: 18854,
  },
  {
    type: 'cityName',
    value: 'TEEKH, HARYANA',
    masterId: 16237,
  },
  {
    type: 'cityName',
    value: 'TILRATH, BIHAR',
    masterId: 18632,
  },
  {
    type: 'cityName',
    value: 'THATTAPPARAI, TAMIL NADU',
    masterId: 16874,
  },
  {
    type: 'cityName',
    value: 'TIRUR, KERALA',
    masterId: 15583,
  },
  {
    type: 'cityName',
    value: 'TISHI, MAHARASHTRA',
    masterId: 15588,
  },
  {
    type: 'cityName',
    value: 'TALIT, WEST BENGAL',
    masterId: 15410,
  },
  {
    type: 'cityName',
    value: 'TILARU, ANDHRA PRADESH',
    masterId: 15556,
  },
  {
    type: 'cityName',
    value: 'TIWARI, RAJASTHAN',
    masterId: 15592,
  },
  {
    type: 'cityName',
    value: 'THANJAVUR, TAMIL NADU',
    masterId: 15499,
  },
  {
    type: 'cityName',
    value: 'TAJPUR DEHMA, UTTAR PRADESH',
    masterId: 16289,
  },
  {
    type: 'cityName',
    value: 'TAJGADH, GUJARAT',
    masterId: 19099,
  },
  {
    type: 'cityName',
    value: 'THURINJAPURAM, TAMIL NADU',
    masterId: 16864,
  },
  {
    type: 'cityName',
    value: 'TAJPUR, MADHYA PRADESH',
    masterId: 15390,
  },
  {
    type: 'cityName',
    value: 'TUMKUR, KARNATAKA',
    masterId: 15617,
  },
  {
    type: 'cityName',
    value: 'TEHARKA, UTTAR PRADESH',
    masterId: 16714,
  },
  {
    type: 'cityName',
    value: 'TUPKADIH, JHARKHAND',
    masterId: 15626,
  },
  {
    type: 'cityName',
    value: 'TEKKABIGHA, BIHAR',
    masterId: 15463,
  },
  {
    type: 'cityName',
    value: 'T.SAKIBANDA, ANDHRA PRADESH',
    masterId: 15373,
  },
  {
    type: 'cityName',
    value: 'THAKURKUCHI, ASSAM',
    masterId: 15481,
  },
  {
    type: 'cityName',
    value: 'TARIKERE, KARNATAKA',
    masterId: 15449,
  },
  {
    type: 'cityName',
    value: 'THAKURGANJ, BIHAR',
    masterId: 16064,
  },
  {
    type: 'cityName',
    value: 'AMBAGADIA, ORISSA',
    masterId: 10137,
  },
  {
    type: 'cityName',
    value: 'TAKHA, UTTAR PRADESH',
    masterId: 17761,
  },
  {
    type: 'cityName',
    value: 'TAKARKHEDE, MAHARASHTRA',
    masterId: 15392,
  },
  {
    type: 'cityName',
    value: 'TAKLI, MAHARASHTRA',
    masterId: 17574,
  },
  {
    type: 'cityName',
    value: 'TIKANI, BIHAR',
    masterId: 18633,
  },
  {
    type: 'cityName',
    value: 'TARRAKALAN, MADHYA PRADESH',
    masterId: 17758,
  },
  {
    type: 'cityName',
    value: 'TIKAMGARH, MADHYA PRADESH ',
    masterId: 17756,
  },
  {
    type: 'cityName',
    value: 'TAKLIMIYA, MAHARASHTRA',
    masterId: 15395,
  },
  {
    type: 'cityName',
    value: 'TANKUPPA, BIHAR',
    masterId: 15432,
  },
  {
    type: 'cityName',
    value: 'THAKURNAGAR, WEST BENGAL',
    masterId: 21245,
  },
  {
    type: 'cityName',
    value: 'TOKKOTTU, KARNATAKA',
    masterId: 19117,
  },
  {
    type: 'cityName',
    value: 'TAKIPUR, WEST BENGAL',
    masterId: 17288,
  },
  {
    type: 'cityName',
    value: 'TIKIRAPAL, ORISSA',
    masterId: 17430,
  },
  {
    type: 'cityName',
    value: 'TURKAPALLI, ANDHRA PRADESH',
    masterId: 16796,
  },
  {
    type: 'cityName',
    value: 'THRIKARIPUR, KERALA',
    masterId: 15538,
  },
  {
    type: 'cityName',
    value: 'TAKARI, MAHARASHTRA',
    masterId: 15391,
  },
  {
    type: 'cityName',
    value: 'TIKRA PH, WEST BENGAL',
    masterId: 21087,
  },
  {
    type: 'cityName',
    value: 'MASURIPADARA, ORISSA',
    masterId: 13507,
  },
  {
    type: 'cityName',
    value: 'TIKAULI RAWATPUR, UTTAR PRADESH',
    masterId: 16281,
  },
  {
    type: 'cityName',
    value: 'TAKHRAU, UTTAR PRADESH',
    masterId: 16715,
  },
  {
    type: 'cityName',
    value: 'TOKISUD, JHARKHAND',
    masterId: 18209,
  },
  {
    type: 'cityName',
    value: 'THIKKODI, KERALA',
    masterId: 17907,
  },
  {
    type: 'cityName',
    value: 'THAKURBARI, ASSAM',
    masterId: 16070,
  },
  {
    type: 'cityName',
    value: 'TANAKALLU, ANDHRA PRADESH',
    masterId: 15422,
  },
  {
    type: 'cityName',
    value: 'TAPPAKHAJURIA, UTTAR PRADESH',
    masterId: 16286,
  },
  {
    type: 'cityName',
    value: 'TEKNIWAS, BIHAR',
    masterId: 18635,
  },
  {
    type: 'cityName',
    value: 'TIKEKARWADI, MAHARASHTRA',
    masterId: 15552,
  },
  {
    type: 'cityName',
    value: 'THIKARIA, MADHYA PRADESH',
    masterId: 17056,
  },
  {
    type: 'cityName',
    value: 'TILONIYA, RAJASTHAN',
    masterId: 15561,
  },
  {
    type: 'cityName',
    value: 'TITWALA, MAHARASHTRA',
    masterId: 17568,
  },
  {
    type: 'cityName',
    value: 'TULSI ASHRAM, UTTAR PRADESH',
    masterId: 16274,
  },
  {
    type: 'cityName',
    value: 'CHHAPAR, RAJASTHAN',
    masterId: 11057,
  },
  {
    type: 'cityName',
    value: 'TILDA, CHHATTISGARH',
    masterId: 15558,
  },
  {
    type: 'cityName',
    value: 'TALGARIA, JHARKHAND',
    masterId: 15408,
  },
  {
    type: 'cityName',
    value: 'TOLLY GANJ, KARNATAKA',
    masterId: 20866,
  },
  {
    type: 'cityName',
    value: 'TALAGUPPA, KARNATAKA',
    masterId: 15397,
  },
  {
    type: 'cityName',
    value: 'TULASI NAGAR, UTTAR PRADESH',
    masterId: 16826,
  },
  {
    type: 'cityName',
    value: 'TILHAR, UTTAR PRADESH',
    masterId: 15560,
  },
  {
    type: 'cityName',
    value: 'TALCHER, ORISSA',
    masterId: 15403,
  },
  {
    type: 'cityName',
    value: 'TALWARA JHEEL, RAJASTHAN',
    masterId: 17058,
  },
  {
    type: 'cityName',
    value: 'TALJHARI, JHARKHAND',
    masterId: 15411,
  },
  {
    type: 'cityName',
    value: 'KHAJURI, UTTAR PRADESH',
    masterId: 12686,
  },
  {
    type: 'cityName',
    value: 'TALAP, ASSAM',
    masterId: 17937,
  },
  {
    type: 'cityName',
    value: 'TRISULAM, UTTAR PRADESH',
    masterId: 21054,
  },
  {
    type: 'cityName',
    value: 'TRILOCHAN MAHDO, UTTAR PRADESH',
    masterId: 16703,
  },
  {
    type: 'cityName',
    value: 'TALAMADUGU, TELANGANA',
    masterId: 16800,
  },
  {
    type: 'cityName',
    value: 'TELIAMURA, TRIPURA',
    masterId: 16786,
  },
  {
    type: 'cityName',
    value: 'TALNI, MAHARASHTRA',
    masterId: 17719,
  },
  {
    type: 'cityName',
    value: 'TILAUNCHI, UTTAR PRADESH',
    masterId: 16279,
  },
  {
    type: 'cityName',
    value: 'ALANALLUR, TAMIL NADU',
    masterId: 17935,
  },
  {
    type: 'cityName',
    value: 'TALANDU, WEST BENGAL',
    masterId: 15401,
  },
  {
    type: 'cityName',
    value: 'TULSIPUR, UTTAR PRADESH',
    masterId: 15615,
  },
  {
    type: 'cityName',
    value: 'BETTAHALSOOR, KARNATAKA',
    masterId: 18061,
  },
  {
    type: 'cityName',
    value: 'TILATI, MAHARASHTRA',
    masterId: 15557,
  },
  {
    type: 'cityName',
    value: 'TARLAPADU, ANDHRA PRADESH',
    masterId: 15450,
  },
  {
    type: 'cityName',
    value: 'HAIAGHAT, BIHAR',
    masterId: 11890,
  },
  {
    type: 'cityName',
    value: 'TALDI, WEST BENGAL',
    masterId: 21194,
  },
  {
    type: 'cityName',
    value: 'THALASSERY, KERALA',
    masterId: 15484,
  },
  {
    type: 'cityName',
    value: 'TALAVLI, MADHYA PRADESH',
    masterId: 17573,
  },
  {
    type: 'cityName',
    value: 'TAMURIA, BIHAR',
    masterId: 17760,
  },
  {
    type: 'cityName',
    value: 'TEMBURU, ANDHRA PRADESH',
    masterId: 18993,
  },
  {
    type: 'cityName',
    value: 'TALAMANCHI, ANDHRA PRADESH',
    masterId: 15400,
  },
  {
    type: 'cityName',
    value: 'TALMADLA, TELANGANA',
    masterId: 16799,
  },
  {
    type: 'cityName',
    value: 'THAMLA MOGANA, RAJASTHAN ',
    masterId: 17057,
  },
  {
    type: 'cityName',
    value: 'TIN MILE HAT, WEST BENGAL',
    masterId: 16069,
  },
  {
    type: 'cityName',
    value: 'TIRUMALPUR, TAMIL NADU',
    masterId: 16863,
  },
  {
    type: 'cityName',
    value: 'TUMMALCHEREVU, ANDHRA PRADESH',
    masterId: 15618,
  },
  {
    type: 'cityName',
    value: 'TAMARAIPADI, TAMIL NADU',
    masterId: 17018,
  },
  {
    type: 'cityName',
    value: 'THIMMAPURAM, ANDHRA PRADESH',
    masterId: 18990,
  },
  {
    type: 'cityName',
    value: 'TIRUMALAIRAYAN PATTINAM H, PUDUCHERRY',
    masterId: 20925,
  },
  {
    type: 'cityName',
    value: 'TUMBALLI, KERALA',
    masterId: 18081,
  },
  {
    type: 'cityName',
    value: 'TIRUMANGALAM, TAMIL NADU',
    masterId: 15578,
  },
  {
    type: 'cityName',
    value: 'TUMSAR, MAHARASHTRA',
    masterId: 15621,
  },
  {
    type: 'cityName',
    value: 'TIMTALA, MAHARASHTRA',
    masterId: 17570,
  },
  {
    type: 'cityName',
    value: 'TIRUMANTHIKUNAM, TAMIL NADU',
    masterId: 16862,
  },
  {
    type: 'cityName',
    value: 'TINDIVANAM, TAMIL NADU',
    masterId: 15569,
  },
  {
    type: 'cityName',
    value: 'TIRUMULLAIVAYIL, TAMIL NADU',
    masterId: 20974,
  },
  {
    type: 'cityName',
    value: 'TIMMAPUR, ANDHRA PRADESH',
    masterId: 15566,
  },
  {
    type: 'cityName',
    value: 'TAMLUK, WEST BENGAL',
    masterId: 15421,
  },
  {
    type: 'cityName',
    value: 'GOTAN, TAMIL NADU',
    masterId: 11784,
  },
  {
    type: 'cityName',
    value: 'THANESAR, HARYANA',
    masterId: 18360,
  },
  {
    type: 'cityName',
    value: 'TORANAGALLU, KARNATAKA',
    masterId: 15599,
  },
  {
    type: 'cityName',
    value: 'TONDALAGOPAVARAM, TELANGANA',
    masterId: 16797,
  },
  {
    type: 'cityName',
    value: 'THONDANOOR, TAMIL NADU',
    masterId: 17966,
  },
  {
    type: 'cityName',
    value: 'TINKHEDA, MAHARASHTRA',
    masterId: 17755,
  },
  {
    type: 'cityName',
    value: 'THANDARAI, TAMIL NADU',
    masterId: 16876,
  },
  {
    type: 'cityName',
    value: 'TAJNAGAR, HARYANA',
    masterId: 18362,
  },
  {
    type: 'cityName',
    value: 'TANUKU, ANDHRA PRADESH',
    masterId: 15433,
  },
  {
    type: 'cityName',
    value: 'TANGLA, ASSAM',
    masterId: 16065,
  },
  {
    type: 'cityName',
    value: 'TIRUVANNAMALAI, TAMIL NADU',
    masterId: 15586,
  },
  {
    type: 'cityName',
    value: 'TONDIARPET, TAMIL NADU',
    masterId: 16857,
  },
  {
    type: 'cityName',
    value: 'TEJNARAYANPUR, BIHAR',
    masterId: 18636,
  },
  {
    type: 'cityName',
    value: 'TANGUTURU, ANDHRA PRADESH',
    masterId: 15431,
  },
  {
    type: 'cityName',
    value: 'TENARI, BIHAR',
    masterId: 17957,
  },
  {
    type: 'cityName',
    value: 'TENNERU, ANDHRA PRADESH',
    masterId: 18992,
  },
  {
    type: 'cityName',
    value: 'DINNAPATTI, TAMIL NADU',
    masterId: 16990,
  },
  {
    type: 'cityName',
    value: 'NETTOOR, KERALA',
    masterId: 17912,
  },
  {
    type: 'cityName',
    value: 'TINDAULI, UTTAR PRADESH',
    masterId: 16278,
  },
  {
    type: 'cityName',
    value: 'THAPAR NAGAR, JHARKHAND',
    masterId: 17286,
  },
  {
    type: 'cityName',
    value: 'TARAK NAGAR, WEST BENGAL',
    masterId: 21142,
  },
  {
    type: 'cityName',
    value: 'TTIRUVALANGADU, TAMIL NADU',
    masterId: 20976,
  },
  {
    type: 'cityName',
    value: 'TALOD, GUJARAT',
    masterId: 19096,
  },
  {
    type: 'cityName',
    value: 'SEWARHI, UTTAR PRADESH',
    masterId: 15034,
  },
  {
    type: 'cityName',
    value: 'KONDALAMPATTI, TAMIL NADU',
    masterId: 16957,
  },
  {
    type: 'cityName',
    value: 'TAPASI, WEST BENGAL',
    masterId: 21099,
  },
  {
    type: 'cityName',
    value: 'TITUR, MAHARASHTRA',
    masterId: 17569,
  },
  {
    type: 'cityName',
    value: 'TORNIYA, GUJARAT',
    masterId: 19097,
  },
  {
    type: 'cityName',
    value: 'TORI, JHARKHAND',
    masterId: 15600,
  },
  {
    type: 'cityName',
    value: 'AMPAPURAM, ANDHRA PRADESH',
    masterId: 10171,
  },
  {
    type: 'cityName',
    value: 'TRILOKPUR, UTTAR PRADESH',
    masterId: 18235,
  },
  {
    type: 'cityName',
    value: 'THIRUPPACHETHI, TAMIL NADU',
    masterId: 16871,
  },
  {
    type: 'cityName',
    value: 'TIRUCHRPLI PLKI, TAMIL NADU',
    masterId: 16835,
  },
  {
    type: 'cityName',
    value: 'TARAPITH, WEST BENGAL',
    masterId: 15441,
  },
  {
    type: 'cityName',
    value: 'TIPLING, ASSAM',
    masterId: 18956,
  },
  {
    type: 'cityName',
    value: 'TINPAHAR, JHARKHAND',
    masterId: 15570,
  },
  {
    type: 'cityName',
    value: 'TIPKAIBANDAR, ASSAM',
    masterId: 15572,
  },
  {
    type: 'cityName',
    value: 'TIKIAPARA, WEST BENGAL',
    masterId: 21080,
  },
  {
    type: 'cityName',
    value: 'THOTTIPALAYAM, TAMIL NADU',
    masterId: 16867,
  },
  {
    type: 'cityName',
    value: 'TALOJA PANCHAND, MAHARASHTRA',
    masterId: 15416,
  },
  {
    type: 'cityName',
    value: 'TANTPUR, UTTAR PRADESH',
    masterId: 16287,
  },
  {
    type: 'cityName',
    value: 'THOPPUR, TAMIL NADU',
    masterId: 16868,
  },
  {
    type: 'cityName',
    value: 'THIPPARTHI, ANDHRA PRADESH',
    masterId: 15510,
  },
  {
    type: 'cityName',
    value: 'PARPA, CHHATTISGARH',
    masterId: 14258,
  },
  {
    type: 'cityName',
    value: 'TIRUPATTUR, TAMIL NADU',
    masterId: 15581,
  },
  {
    type: 'cityName',
    value: 'TIRUPATI, ANDHRA PRADESH',
    masterId: 15580,
  },
  {
    type: 'cityName',
    value: 'TINPHERIA, UTTAR PRADESH',
    masterId: 16276,
  },
  {
    type: 'cityName',
    value: 'TADIKALAPUDI, ANDHRA PRADESH',
    masterId: 15380,
  },
  {
    type: 'cityName',
    value: 'TAPRI, UTTAR PRADESH',
    masterId: 15437,
  },
  {
    type: 'cityName',
    value: 'TAKIYA, UTTAR PRADESH',
    masterId: 15394,
  },
  {
    type: 'cityName',
    value: 'THEH QALANDAR, PUNJAB',
    masterId: 17285,
  },
  {
    type: 'cityName',
    value: 'TELAM, ASSAM',
    masterId: 18624,
  },
  {
    type: 'cityName',
    value: 'KOLLURI, UTTAR PRADESH',
    masterId: 12853,
  },
  {
    type: 'cityName',
    value: 'TEKTAR, BIHAR',
    masterId: 20771,
  },
  {
    type: 'cityName',
    value: 'TARUR, MAHARASHTRA',
    masterId: 15452,
  },
  {
    type: 'cityName',
    value: 'TANGRA, PUNJAB',
    masterId: 15430,
  },
  {
    type: 'cityName',
    value: 'PATRADI, WEST BENGAL',
    masterId: 14306,
  },
  {
    type: 'cityName',
    value: 'THIRUVERUMBUR, TAMIL NADU',
    masterId: 15526,
  },
  {
    type: 'cityName',
    value: 'TARABARI, ASSAM',
    masterId: 16194,
  },
  {
    type: 'cityName',
    value: 'TIRODI, MADHYA PRADESH',
    masterId: 17754,
  },
  {
    type: 'cityName',
    value: 'TIKRI, UTTAR PRADESH',
    masterId: 16280,
  },
  {
    type: 'cityName',
    value: 'TAROPA, GUJARAT',
    masterId: 18392,
  },
  {
    type: 'cityName',
    value: 'TARIASUJAN, UTTAR PRADESH',
    masterId: 16284,
  },
  {
    type: 'cityName',
    value: 'THIRUKOILURE, TAMIL NADU',
    masterId: 15514,
  },
  {
    type: 'cityName',
    value: 'MAHULPATI, ORISSA',
    masterId: 13272,
  },
  {
    type: 'cityName',
    value: 'TIRUVALLUR, TAMIL NADU',
    masterId: 15585,
  },
  {
    type: 'cityName',
    value: 'THIRUNAGESWARAM, TAMIL NADU',
    masterId: 16872,
  },
  {
    type: 'cityName',
    value: 'TARAON, UTTAR PRADESH',
    masterId: 16285,
  },
  {
    type: 'cityName',
    value: 'TIRORA, MAHARASHTRA',
    masterId: 15574,
  },
  {
    type: 'cityName',
    value: 'TARAPUR JN, GUJARAT',
    masterId: 20805,
  },
  {
    type: 'cityName',
    value: 'TARAORI, HARYANA',
    masterId: 15440,
  },
  {
    type: 'cityName',
    value: 'MURIA, BIHAR',
    masterId: 13746,
  },
  {
    type: 'cityName',
    value: 'TARSAI, GUJARAT',
    masterId: 18391,
  },
  {
    type: 'cityName',
    value: 'TIRUTTANI, TAMIL NADU',
    masterId: 15584,
  },
  {
    type: 'cityName',
    value: 'THIRUVALLA, KERALA',
    masterId: 15523,
  },
  {
    type: 'cityName',
    value: 'TIRUVIZHA, KERALA',
    masterId: 17906,
  },
  {
    type: 'cityName',
    value: 'TARAVATA, MADHYA PRADESH',
    masterId: 17759,
  },
  {
    type: 'cityName',
    value: 'TOLRA, JHARKHAND',
    masterId: 18111,
  },
  {
    type: 'cityName',
    value: 'TISUA, UTTAR PRADESH',
    masterId: 15589,
  },
  {
    type: 'cityName',
    value: 'BHADRA, RAJASTHAN',
    masterId: 18342,
  },
  {
    type: 'cityName',
    value: 'BINDKI, UTTAR PRADESH',
    masterId: 10839,
  },
  {
    type: 'cityName',
    value: 'TENKASI, TAMIL NADU',
    masterId: 15475,
  },
  {
    type: 'cityName',
    value: 'TINSUKIA, ASSAM',
    masterId: 15571,
  },
  {
    type: 'cityName',
    value: 'TSUNDURU, ANDHRA PRADESH',
    masterId: 15610,
  },
  {
    type: 'cityName',
    value: 'TALLI SAIDASAHU, PUNJAB',
    masterId: 17287,
  },
  {
    type: 'cityName',
    value: 'TITTE, TAMIL NADU',
    masterId: 16858,
  },
  {
    type: 'cityName',
    value: 'TITABAR, ASSAM',
    masterId: 15590,
  },
  {
    type: 'cityName',
    value: 'TURTIPAR, UTTAR PRADESH',
    masterId: 16273,
  },
  {
    type: 'cityName',
    value: 'TETELIA, ASSAM',
    masterId: 15477,
  },
  {
    type: 'cityName',
    value: 'TARN TARAN, PUNJAB',
    masterId: 19346,
  },
  {
    type: 'cityName',
    value: 'THATHANKULAM, TAMIL NADU',
    masterId: 16875,
  },
  {
    type: 'cityName',
    value: 'TIPTUR, KARNATAKA',
    masterId: 15573,
  },
  {
    type: 'cityName',
    value: 'MOCHERLA, ANDHRA PRADESH',
    masterId: 13601,
  },
  {
    type: 'cityName',
    value: 'TUKAITHAD, MAHARASHTRA',
    masterId: 15613,
  },
  {
    type: 'cityName',
    value: 'TADIPATRI, ANDHRA PRADESH',
    masterId: 15382,
  },
  {
    type: 'cityName',
    value: 'THIRUNAVAYA, KERALA',
    masterId: 15519,
  },
  {
    type: 'cityName',
    value: 'LODHI, MAHARASHTRA',
    masterId: 18587,
  },
  {
    type: 'cityName',
    value: 'THALANGAI, TAMIL NADU',
    masterId: 16877,
  },
  {
    type: 'cityName',
    value: 'TANIJAN, ASSAM',
    masterId: 16148,
  },
  {
    type: 'cityName',
    value: 'TIRALDIH, WEST BENGAL',
    masterId: 16066,
  },
  {
    type: 'cityName',
    value: 'TOHANA, HARYANA',
    masterId: 15596,
  },
  {
    type: 'cityName',
    value: 'TUNG, WEST BENGAL',
    masterId: 15623,
  },
  {
    type: 'cityName',
    value: 'TUNI, ANDHRA PRADESH',
    masterId: 15625,
  },
  {
    type: 'cityName',
    value: 'TIRUPPUR, TAMIL NADU',
    masterId: 15582,
  },
  {
    type: 'cityName',
    value: 'TURKI, BIHAR',
    masterId: 18803,
  },
  {
    type: 'cityName',
    value: 'THUVVUR, KERALA',
    masterId: 15549,
  },
  {
    type: 'cityName',
    value: 'THURAVOOR, KERALA',
    masterId: 15545,
  },
  {
    type: 'cityName',
    value: 'TUWA, GUJARAT',
    masterId: 18522,
  },
  {
    type: 'cityName',
    value: 'BARI, JHARKHAND',
    masterId: 10536,
  },
  {
    type: 'cityName',
    value: 'THIRUTHURAIYUR, TAMIL NADU',
    masterId: 17016,
  },
  {
    type: 'cityName',
    value: 'THIRUVANANTHAPURAM, KERALA',
    masterId: 15524,
  },
  {
    type: 'cityName',
    value: 'TAVARGATTI, KARNATAKA',
    masterId: 17969,
  },
  {
    type: 'cityName',
    value: 'TADWAL, MAHARASHTRA',
    masterId: 15384,
  },
  {
    type: 'cityName',
    value: 'TIRUPPUVANAM, TAMIL NADU',
    masterId: 16861,
  },
  {
    type: 'cityName',
    value: 'THIRUVENNAINALLUR, TAMIL NADU',
    masterId: 16869,
  },
  {
    type: 'cityName',
    value: 'THIRUVARUR, TAMIL NADU',
    masterId: 15525,
  },
  {
    type: 'cityName',
    value: 'TALAIVASAL, TAMIL NADU',
    masterId: 19156,
  },
  {
    type: 'cityName',
    value: 'TIRUVOTTIYUR, TAMIL NADU',
    masterId: 16859,
  },
  {
    type: 'cityName',
    value: 'TURIGANJ, BIHAR',
    masterId: 15628,
  },
  {
    type: 'cityName',
    value: 'TOTEWAHI, MAHARASHTRA',
    masterId: 18109,
  },
  {
    type: 'cityName',
    value: 'TILWARA, RAJASTHAN',
    masterId: 17055,
  },
  {
    type: 'cityName',
    value: 'THUVAVI, GUJARAT',
    masterId: 18388,
  },
  {
    type: 'cityName',
    value: 'TADA, ANDHRA PRADESH',
    masterId: 15374,
  },
  {
    type: 'cityName',
    value: 'THANDAVAPURA, KARNATAKA ',
    masterId: 17968,
  },
  {
    type: 'cityName',
    value: 'THULUKKAPATTI, TAMIL NADU',
    masterId: 17015,
  },
  {
    type: 'cityName',
    value: 'TENYA, WEST BENGAL',
    masterId: 16071,
  },
  {
    type: 'cityName',
    value: 'TIRUMAYAM, TAMIL NADU',
    masterId: 19157,
  },
  {
    type: 'cityName',
    value: 'THOZHUPEDU, TAMIL NADU',
    masterId: 16865,
  },
  {
    type: 'cityName',
    value: 'THAKAZHI, KERALA',
    masterId: 17908,
  },
  {
    type: 'cityName',
    value: 'TURKI ROAD, MADHYA PRADESH',
    masterId: 15629,
  },
  {
    type: 'cityName',
    value: 'UPLETA, GUJARAT',
    masterId: 15698,
  },
  {
    type: 'cityName',
    value: 'UPPALA, KERALA',
    masterId: 15700,
  },
  {
    type: 'cityName',
    value: 'USKA BAZAR, UTTAR PRADESH',
    masterId: 16712,
  },
  {
    type: 'cityName',
    value: 'AMBALA , HARYANA',
    masterId: 10142,
  },
  {
    type: 'cityName',
    value: 'HUBLI, KARNATAKA',
    masterId: 12037,
  },
  {
    type: 'cityName',
    value: 'UBARNI, UTTAR PRADESH',
    masterId: 16272,
  },
  {
    type: 'cityName',
    value: 'UMARGAM, GUJARAT',
    masterId: 15668,
  },
  {
    type: 'cityName',
    value: 'UCHANA, HARYANA',
    masterId: 15634,
  },
  {
    type: 'cityName',
    value: 'UNCHI BASSI, PUNJAB',
    masterId: 15686,
  },
  {
    type: 'cityName',
    value: 'UNCHAULIA, UTTAR PRADESH',
    masterId: 16265,
  },
  {
    type: 'cityName',
    value: 'UCHIPPULI, TAMIL NADU',
    masterId: 19158,
  },
  {
    type: 'cityName',
    value: 'UNCHAHAR, UTTAR PRADESH',
    masterId: 15684,
  },
  {
    type: 'cityName',
    value: 'UDUPI, KARNATAKA',
    masterId: 15648,
  },
  {
    type: 'cityName',
    value: 'UDGIR, MAHARASHTRA',
    masterId: 15642,
  },
  {
    type: 'cityName',
    value: 'UDYANKHERI, MADHYA PRADESH',
    masterId: 17752,
  },
  {
    type: 'cityName',
    value: 'UDAIPUR KHURD, UTTAR PRADESH',
    masterId: 17054,
  },
  {
    type: 'cityName',
    value: 'ANDAL, WEST BENGAL',
    masterId: 10195,
  },
  {
    type: 'cityName',
    value: 'UNDASA MADHAWPU, MADHYA PRADESH',
    masterId: 15687,
  },
  {
    type: 'cityName',
    value: 'UDAIPURA, MADHYA PRADESH ',
    masterId: 17753,
  },
  {
    type: 'cityName',
    value: 'AMDARA, MADHYA PRADESH',
    masterId: 10154,
  },
  {
    type: 'cityName',
    value: 'UDUMALAIPPETTAI, TAMIL NADU',
    masterId: 19159,
  },
  {
    type: 'cityName',
    value: 'UPPUGUNDURU, ANDHRA PRADESH',
    masterId: 15705,
  },
  {
    type: 'cityName',
    value: 'UGAON, MAHARASHTRA',
    masterId: 17567,
  },
  {
    type: 'cityName',
    value: 'UGNA, BIHAR',
    masterId: 18630,
  },
  {
    type: 'cityName',
    value: 'UGARPUR, UTTAR PRADESH',
    masterId: 16270,
  },
  {
    type: 'cityName',
    value: 'UGAR, KARNATAKA',
    masterId: 15649,
  },
  {
    type: 'cityName',
    value: 'UGU, UTTAR PRADESH',
    masterId: 16269,
  },
  {
    type: 'cityName',
    value: 'UGWE, MAHARASHTRA',
    masterId: 15651,
  },
  {
    type: 'cityName',
    value: 'UNA, HIMACHAL PRADESH',
    masterId: 15680,
  },
  {
    type: 'cityName',
    value: 'UDHAMPUR, JAMMU AND KASHMIR',
    masterId: 15644,
  },
  {
    type: 'cityName',
    value: 'UCHAHERA, MADHYA PRADESH',
    masterId: 15633,
  },
  {
    type: 'cityName',
    value: 'RAMANKA, GUJARAT',
    masterId: 14608,
  },
  {
    type: 'cityName',
    value: 'UNJHA, GUJARAT',
    masterId: 15693,
  },
  {
    type: 'cityName',
    value: 'UJHANI, UTTAR PRADESH',
    masterId: 15652,
  },
  {
    type: 'cityName',
    value: 'UJJAIN, MADHYA PRADESH',
    masterId: 15655,
  },
  {
    type: 'cityName',
    value: 'UJIARPUR, BIHAR',
    masterId: 15653,
  },
  {
    type: 'cityName',
    value: 'UKHRA, WEST BENGAL',
    masterId: 15658,
  },
  {
    type: 'cityName',
    value: 'UKSHI, MAHARASHTRA',
    masterId: 15660,
  },
  {
    type: 'cityName',
    value: 'ULINDAKONDA, ANDHRA PRADESH',
    masterId: 19051,
  },
  {
    type: 'cityName',
    value: 'UTTARKASHI, ASSAM',
    masterId: 16251,
  },
  {
    type: 'cityName',
    value: 'UKHALI, MAHARASHTRA',
    masterId: 15657,
  },
  {
    type: 'cityName',
    value: 'UKLANA, HARYANA',
    masterId: 15659,
  },
  {
    type: 'cityName',
    value: 'UDALKACHAR, MADHYA PRADESH',
    masterId: 15639,
  },
  {
    type: 'cityName',
    value: 'UTHAMAR KOVIL, TAMIL NADU',
    masterId: 16856,
  },
  {
    type: 'cityName',
    value: 'BASAULI, UTTAR PRADESH',
    masterId: 10570,
  },
  {
    type: 'cityName',
    value: 'UDALGURI, ASSAM',
    masterId: 16067,
  },
  {
    type: 'cityName',
    value: 'ULLAL, KARNATAKA',
    masterId: 15663,
  },
  {
    type: 'cityName',
    value: 'URLAM, ANDHRA PRADESH',
    masterId: 18989,
  },
  {
    type: 'cityName',
    value: 'ULNA BHARI, UTTAR PRADESH',
    masterId: 16268,
  },
  {
    type: 'cityName',
    value: 'KULTI, WEST BENGAL',
    masterId: 12996,
  },
  {
    type: 'cityName',
    value: 'ULUNDURPET, TAMIL NADU',
    masterId: 15667,
  },
  {
    type: 'cityName',
    value: 'UMARDASHI, GUJARAT',
    masterId: 18385,
  },
  {
    type: 'cityName',
    value: 'OSMANABAD, MAHARASHTRA',
    masterId: 14092,
  },
  {
    type: 'cityName',
    value: 'UMED, RAJASTHAN',
    masterId: 15673,
  },
  {
    type: 'cityName',
    value: 'UTTANGAL MANGALAM, TAMIL NADU',
    masterId: 16855,
  },
  {
    type: 'cityName',
    value: 'UMRETH, GUJARAT',
    masterId: 18383,
  },
  {
    type: 'cityName',
    value: 'UMALLA, GUJARAT',
    masterId: 18386,
  },
  {
    type: 'cityName',
    value: 'UMRAM, TELANGANA',
    masterId: 17566,
  },
  {
    type: 'cityName',
    value: 'AMBLIYASAN, GUJARAT ',
    masterId: 18517,
  },
  {
    type: 'cityName',
    value: 'UMESH NAGAR, BIHAR',
    masterId: 17751,
  },
  {
    type: 'cityName',
    value: 'UMARIA, MADHYA PRADESH',
    masterId: 15669,
  },
  {
    type: 'cityName',
    value: 'UMRA, RAJASTHAN',
    masterId: 18384,
  },
  {
    type: 'cityName',
    value: 'UMRI, MAHARASHTRA',
    masterId: 15677,
  },
  {
    type: 'cityName',
    value: 'UDAIRAMSAR, RAJASTHAN',
    masterId: 15638,
  },
  {
    type: 'cityName',
    value: 'UNA, GUJARAT',
    masterId: 15679,
  },
  {
    type: 'cityName',
    value: 'UNCHDIH, UTTAR PRADESH',
    masterId: 15685,
  },
  {
    type: 'cityName',
    value: 'UNDI, ANDHRA PRADESH',
    masterId: 15688,
  },
  {
    type: 'cityName',
    value: 'UNHEL, MADHYA PRADESH',
    masterId: 15691,
  },
  {
    type: 'cityName',
    value: 'UNAULA, UTTAR PRADESH',
    masterId: 16266,
  },
  {
    type: 'cityName',
    value: 'UMROLI, MAHARASHTRA',
    masterId: 20894,
  },
  {
    type: 'cityName',
    value: 'UTTARPARA, RAJASTHAN',
    masterId: 20958,
  },
  {
    type: 'cityName',
    value: 'ULAVAPADU, ANDHRA PRADESH',
    masterId: 15661,
  },
  {
    type: 'cityName',
    value: 'UPPALUR, ANDHRA PRADESH',
    masterId: 19050,
  },
  {
    type: 'cityName',
    value: 'USMANPUR, MAHARASHTRA',
    masterId: 15713,
  },
  {
    type: 'cityName',
    value: 'UPPALWAI, TELANGANA',
    masterId: 16825,
  },
  {
    type: 'cityName',
    value: 'UMDANAGAR, ANDHRA PRADESH',
    masterId: 15672,
  },
  {
    type: 'cityName',
    value: 'UNTARE ROAD, JHARKHAND',
    masterId: 15696,
  },
  {
    type: 'cityName',
    value: 'UREN, BIHAR',
    masterId: 15710,
  },
  {
    type: 'cityName',
    value: 'URULI, MAHARASHTRA',
    masterId: 15712,
  },
  {
    type: 'cityName',
    value: 'UNJALUR, TAMIL NADU',
    masterId: 15692,
  },
  {
    type: 'cityName',
    value: 'URMA, WEST BENGAL',
    masterId: 15711,
  },
  {
    type: 'cityName',
    value: 'UDAIRAMPUR, UTTAR PRADESH',
    masterId: 21058,
  },
  {
    type: 'cityName',
    value: 'UGRASENPUR, UTTAR PRADESH',
    masterId: 15650,
  },
  {
    type: 'cityName',
    value: 'UMRED, MAHARASHTRA',
    masterId: 17565,
  },
  {
    type: 'cityName',
    value: 'USIA KHAS, UTTAR PRADESH',
    masterId: 21000,
  },
  {
    type: 'cityName',
    value: 'USRA, GUJARAT',
    masterId: 18110,
  },
  {
    type: 'cityName',
    value: 'MAHSONA, UTTAR PRADESH',
    masterId: 13264,
  },
  {
    type: 'cityName',
    value: 'UTTARSANDA, GUJARAT',
    masterId: 15717,
  },
  {
    type: 'cityName',
    value: 'UTTARLAI, RAJASTHAN',
    masterId: 15716,
  },
  {
    type: 'cityName',
    value: 'UTTAR RADHANAGAR HAL, WEST BENGAL',
    masterId: 21204,
  },
  {
    type: 'cityName',
    value: 'TRIPURA, UTTAR PRADESH',
    masterId: 16785,
  },
  {
    type: 'cityName',
    value: 'UTRAHTIA, UTTAR PRADESH',
    masterId: 15715,
  },
  {
    type: 'cityName',
    value: 'RENTLAV, GUJARAT',
    masterId: 14724,
  },
  {
    type: 'cityName',
    value: 'URBAN, JHARKHAND',
    masterId: 17964,
  },
  {
    type: 'cityName',
    value: 'UDWANT NAGAR, BIHAR',
    masterId: 18631,
  },
  {
    type: 'cityName',
    value: 'BHAGA, JHARKHAND',
    masterId: 10674,
  },
  {
    type: 'cityName',
    value: 'VARUD, MAHARASHTRA',
    masterId: 17718,
  },
  {
    type: 'cityName',
    value: 'VADALI, GUJARAT',
    masterId: 19098,
  },
  {
    type: 'cityName',
    value: 'VARKALA, KERALA',
    masterId: 15792,
  },
  {
    type: 'cityName',
    value: 'VADAL, GUJARAT',
    masterId: 15728,
  },
  {
    type: 'cityName',
    value: 'VADHVANA, GUJARAT',
    masterId: 18381,
  },
  {
    type: 'cityName',
    value: 'VAPI, GUJARAT',
    masterId: 15784,
  },
  {
    type: 'cityName',
    value: 'VALAPATTANAM, KERALA',
    masterId: 15755,
  },
  {
    type: 'cityName',
    value: 'VIDYA NAGAR, TELANGANA',
    masterId: 18080,
  },
  {
    type: 'cityName',
    value: 'VAIKOM, KERALA',
    masterId: 15749,
  },
  {
    type: 'cityName',
    value: 'VATLUR, ANDHRA PRADESH',
    masterId: 15807,
  },
  {
    type: 'cityName',
    value: 'VAYALAR, KERALA',
    masterId: 17936,
  },
  {
    type: 'cityName',
    value: 'BOBBILI, ANDHRA PRADESH',
    masterId: 10861,
  },
  {
    type: 'cityName',
    value: 'VALLABHNAGAR, RAJASTHAN',
    masterId: 17052,
  },
  {
    type: 'cityName',
    value: 'VAMBORI, MAHARASHTRA',
    masterId: 15764,
  },
  {
    type: 'cityName',
    value: 'NAPANE, MAHARASHTRA',
    masterId: 13876,
  },
  {
    type: 'cityName',
    value: 'VIROCHANNAGAR, GUJARAT',
    masterId: 15896,
  },
  {
    type: 'cityName',
    value: 'VAGADIYA, GUJARAT',
    masterId: 15744,
  },
  {
    type: 'cityName',
    value: 'VASAD, GUJARAT',
    masterId: 15797,
  },
  {
    type: 'cityName',
    value: 'VENDODU, ANDHRA PRADESH',
    masterId: 15844,
  },
  {
    type: 'cityName',
    value: 'VEDCHHA, GUJARAT',
    masterId: 15816,
  },
  {
    type: 'cityName',
    value: 'VELDURTHI, ANDHRA PRADESH',
    masterId: 15829,
  },
  {
    type: 'cityName',
    value: 'VADANAM KURUSHSHI HA, KERALA',
    masterId: 19047,
  },
  {
    type: 'cityName',
    value: 'VAITHEESWARANKOVIL, TAMIL NADU',
    masterId: 15751,
  },
  {
    type: 'cityName',
    value: 'VADAMADURAI, TAMIL NADU',
    masterId: 16854,
  },
  {
    type: 'cityName',
    value: 'VADGAON, MAHARASHTRA',
    masterId: 15736,
  },
  {
    type: 'cityName',
    value: 'VADIPATTI, TAMIL NADU',
    masterId: 17014,
  },
  {
    type: 'cityName',
    value: 'KARMATAR, JHARKHAND',
    masterId: 12564,
  },
  {
    type: 'cityName',
    value: 'VEER, MAHARASHTRA',
    masterId: 15817,
  },
  {
    type: 'cityName',
    value: 'VELLIANAI, TAMIL NADU',
    masterId: 16844,
  },
  {
    type: 'cityName',
    value: 'VELLARAKKAD, KERALA',
    masterId: 17903,
  },
  {
    type: 'cityName',
    value: 'VELLANUR, TAMIL NADU',
    masterId: 16845,
  },
  {
    type: 'cityName',
    value: 'VERNA, GOA',
    masterId: 18565,
  },
  {
    type: 'cityName',
    value: 'VELLUR, TAMIL NADU',
    masterId: 16842,
  },
  {
    type: 'cityName',
    value: 'VIRAMGAM, GUJARAT',
    masterId: 15891,
  },
  {
    type: 'cityName',
    value: 'VEPAGUNTA, ANDHRA PRADESH',
    masterId: 18986,
  },
  {
    type: 'cityName',
    value: 'VALAPPADI, TAMIL NADU',
    masterId: 15756,
  },
  {
    type: 'cityName',
    value: 'VAGHLI, MAHARASHTRA',
    masterId: 17564,
  },
  {
    type: 'cityName',
    value: 'VINNAMANGALAM, TAMIL NADU',
    masterId: 16838,
  },
  {
    type: 'cityName',
    value: 'VANGAON, MAHARASHTRA',
    masterId: 15772,
  },
  {
    type: 'cityName',
    value: 'UNGUTURU, ANDHRA PRADESH',
    masterId: 15690,
  },
  {
    type: 'cityName',
    value: 'BLOCK CABIN CHAKKI, BIHAR',
    masterId: 20785,
  },
  {
    type: 'cityName',
    value: 'VIHIRGAON, MAHARASHTRA',
    masterId: 15866,
  },
  {
    type: 'cityName',
    value: 'VILLIANUR, PUDUCHERRY',
    masterId: 17429,
  },
  {
    type: 'cityName',
    value: 'VILAVADE, MAHARASHTRA',
    masterId: 15885,
  },
  {
    type: 'cityName',
    value: 'TAMHANE, MAHARASHTRA',
    masterId: 15419,
  },
  {
    type: 'cityName',
    value: 'VEJENDLA, ANDHRA PRADESH',
    masterId: 15822,
  },
  {
    type: 'cityName',
    value: 'VIJPADI, GUJARAT',
    masterId: 18375,
  },
  {
    type: 'cityName',
    value: 'VEJALKA, GUJARAT',
    masterId: 18376,
  },
  {
    type: 'cityName',
    value: 'VIJAIPUR, MADHYA PRADESH',
    masterId: 15867,
  },
  {
    type: 'cityName',
    value: 'VIJAYPUR, JAMMU AND KASHMIR',
    masterId: 15875,
  },
  {
    type: 'cityName',
    value: 'VIJAYANAGAR, MAHARASHTRA',
    masterId: 19130,
  },
  {
    type: 'cityName',
    value: 'VIKARABAD, ANDHRA PRADESH',
    masterId: 15878,
  },
  {
    type: 'cityName',
    value: 'BAKHRABAD, WEST BENGAL',
    masterId: 16180,
  },
  {
    type: 'cityName',
    value: 'VAVADI KHURD, GUJARAT',
    masterId: 18519,
  },
  {
    type: 'cityName',
    value: 'VIKHRAN, MAHARASHTRA',
    masterId: 15879,
  },
  {
    type: 'cityName',
    value: 'VENKATAGIRI, ANDHRA PRADESH',
    masterId: 15850,
  },
  {
    type: 'cityName',
    value: 'VENKATESAPURAM, TAMIL NADU',
    masterId: 17010,
  },
  {
    type: 'cityName',
    value: 'VINUKONDA, ANDHRA PRADESH',
    masterId: 15888,
  },
  {
    type: 'cityName',
    value: 'VALMIKINAGAR, BIHAR',
    masterId: 18987,
  },
  {
    type: 'cityName',
    value: 'VARAKALPATTU, TAMIL NADU',
    masterId: 17012,
  },
  {
    type: 'cityName',
    value: 'VYNKATNAGAR, MADHYA PRADESH',
    masterId: 15920,
  },
  {
    type: 'cityName',
    value: 'VENKATACHALAM, ANDHRA PRADESH',
    masterId: 15849,
  },
  {
    type: 'cityName',
    value: 'V N RAJUVARIPTA, ANDHRA PRADESH',
    masterId: 19048,
  },
  {
    type: 'cityName',
    value: 'VILAD, MAHARASHTRA',
    masterId: 15883,
  },
  {
    type: 'cityName',
    value: 'BAVLA, GUJARAT',
    masterId: 10593,
  },
  {
    type: 'cityName',
    value: 'VAYALPADU, ANDHRA PRADESH',
    masterId: 15810,
  },
  {
    type: 'cityName',
    value: 'VALADI, TAMIL NADU',
    masterId: 16853,
  },
  {
    type: 'cityName',
    value: 'VALADAR, GUJARAT',
    masterId: 18379,
  },
  {
    type: 'cityName',
    value: 'VELLALACHERUVU, ANDHRA PRADESH',
    masterId: 15833,
  },
  {
    type: 'cityName',
    value: 'VALIGONDA, ANDHRA PRADESH',
    masterId: 15758,
  },
  {
    type: 'cityName',
    value: 'VALLIKKUNNU, KERALA',
    masterId: 15760,
  },
  {
    type: 'cityName',
    value: 'VILLIVAKKAM, TAMIL NADU',
    masterId: 16839,
  },
  {
    type: 'cityName',
    value: 'VELLAYIL, KERALA',
    masterId: 17902,
  },
  {
    type: 'cityName',
    value: 'VELANKANNI, TAMIL NADU',
    masterId: 15826,
  },
  {
    type: 'cityName',
    value: 'ULLI, TAMIL NADU',
    masterId: 15665,
  },
  {
    type: 'cityName',
    value: 'VADALI LUTER, GUJARAT',
    masterId: 18382,
  },
  {
    type: 'cityName',
    value: 'VADALUR, TAMIL NADU',
    masterId: 15730,
  },
  {
    type: 'cityName',
    value: 'VALLIVEDU, ANDHRA PRADESH',
    masterId: 18988,
  },
  {
    type: 'cityName',
    value: 'VALLIOOR, TAMIL NADU',
    masterId: 15761,
  },
  {
    type: 'cityName',
    value: 'VALLABH VDYANGR, GUJARAT',
    masterId: 20798,
  },
  {
    type: 'cityName',
    value: 'VIKRAMGARH ALOT, MADHYA PRADESH',
    masterId: 15880,
  },
  {
    type: 'cityName',
    value: 'GADEPUDI, ANDHRA PRADESH',
    masterId: 11589,
  },
  {
    type: 'cityName',
    value: 'VALLAMPADUGAI, TAMIL NADU',
    masterId: 16850,
  },
  {
    type: 'cityName',
    value: 'VEMURU, ANDHRA PRADESH',
    masterId: 15843,
  },
  {
    type: 'cityName',
    value: 'VANIYAMBADI, TAMIL NADU',
    masterId: 15774,
  },
  {
    type: 'cityName',
    value: 'VARANGAON, MAHARASHTRA',
    masterId: 15788,
  },
  {
    type: 'cityName',
    value: 'VANIYAMBALAM, KERALA',
    masterId: 15775,
  },
  {
    type: 'cityName',
    value: 'VENDRA, ANDHRA PRADESH',
    masterId: 15845,
  },
  {
    type: 'cityName',
    value: 'DHALAIBIL, ASSAM',
    masterId: 11331,
  },
  {
    type: 'cityName',
    value: 'VANGAL, TAMIL NADU',
    masterId: 16849,
  },
  {
    type: 'cityName',
    value: 'VANJIPALAYAM, TAMIL NADU',
    masterId: 17013,
  },
  {
    type: 'cityName',
    value: 'ONTIMITTA, ANDHRA PRADESH',
    masterId: 14083,
  },
  {
    type: 'cityName',
    value: 'BANAUR, UTTAR PRADESH',
    masterId: 16658,
  },
  {
    type: 'cityName',
    value: 'DEVANUR, KARNATAKA',
    masterId: 18042,
  },
  {
    type: 'cityName',
    value: 'DUMANA, GUJARAT',
    masterId: 11481,
  },
  {
    type: 'cityName',
    value: 'VISHNUPURAM, ANDHRA PRADESH',
    masterId: 15906,
  },
  {
    type: 'cityName',
    value: 'VONDH, GUJARAT',
    masterId: 18374,
  },
  {
    type: 'cityName',
    value: 'SIDIGINAMOLA, ANDHRA PRADESH',
    masterId: 15148,
  },
  {
    type: 'cityName',
    value: 'MALKALIPUR, BIHAR',
    masterId: 13323,
  },
  {
    type: 'cityName',
    value: 'VENTRAPRAGADA, ANDHRA PRADESH',
    masterId: 15854,
  },
  {
    type: 'cityName',
    value: 'VACHASPATI NAGAR, BIHAR',
    masterId: 18629,
  },
  {
    type: 'cityName',
    value: 'KALLUPATTY, TAMIL NADU',
    masterId: 16976,
  },
  {
    type: 'cityName',
    value: 'VENKATAMPALLI, ANDHRA PRADESH',
    masterId: 15851,
  },
  {
    type: 'cityName',
    value: 'BHURKUNDA, UTTAR PRADESH',
    masterId: 10789,
  },
  {
    type: 'cityName',
    value: 'VISAPUR, MAHARASHTRA',
    masterId: 15902,
  },
  {
    type: 'cityName',
    value: 'VIRUDHUNAGAR, TAMIL NADU',
    masterId: 15900,
  },
  {
    type: 'cityName',
    value: 'VELPURU, ANDHRA PRADESH',
    masterId: 15837,
  },
  {
    type: 'cityName',
    value: 'VALAVANUR, TAMIL NADU',
    masterId: 16851,
  },
  {
    type: 'cityName',
    value: 'VRINDABAN, UTTAR PRADESH',
    masterId: 16263,
  },
  {
    type: 'cityName',
    value: 'VAREDIA, GUJARAT',
    masterId: 15789,
  },
  {
    type: 'cityName',
    value: 'VIKRAMNAGAR, MADHYA PRADESH',
    masterId: 15881,
  },
  {
    type: 'cityName',
    value: 'VIRBHADRA, UTTARAKHAND',
    masterId: 15894,
  },
  {
    type: 'cityName',
    value: 'VIRUDHACHALAM, TAMIL NADU',
    masterId: 15899,
  },
  {
    type: 'cityName',
    value: 'VERAVAL, GUJARAT',
    masterId: 15856,
  },
  {
    type: 'cityName',
    value: 'VEERANI PARK, TAMIL NADU',
    masterId: 16848,
  },
  {
    type: 'cityName',
    value: 'VARNAMA, GUJARAT',
    masterId: 15793,
  },
  {
    type: 'cityName',
    value: 'VANGANUR, ANDHRA PRADESH',
    masterId: 15771,
  },
  {
    type: 'cityName',
    value: 'VEERAPANDI RING, TAMIL NADU',
    masterId: 17011,
  },
  {
    type: 'cityName',
    value: 'VEERARAKKIYAM, TAMIL NADU',
    masterId: 16847,
  },
  {
    type: 'cityName',
    value: 'VIRPUR, GUJARAT',
    masterId: 15897,
  },
  {
    type: 'cityName',
    value: 'VRIDDHACHALM, TAMIL NADU',
    masterId: 19164,
  },
  {
    type: 'cityName',
    value: 'VIRAVADA, GUJARAT',
    masterId: 19049,
  },
  {
    type: 'cityName',
    value: 'VEERAVALLI, ANDHRA PRADESH',
    masterId: 15819,
  },
  {
    type: 'cityName',
    value: 'VARAHI, GUJARAT',
    masterId: 18378,
  },
  {
    type: 'cityName',
    value: 'VASIND, MAHARASHTRA',
    masterId: 17563,
  },
  {
    type: 'cityName',
    value: 'VISAKHAPATNAM, ANDHRA PRADESH',
    masterId: 15901,
  },
  {
    type: 'cityName',
    value: 'PADRI, MADHYA PRADESH',
    masterId: 14116,
  },
  {
    type: 'cityName',
    value: 'BISHNUPUR, WEST BENGAL',
    masterId: 10851,
  },
  {
    type: 'cityName',
    value: 'VISAVADAR, GUJARAT',
    masterId: 15903,
  },
  {
    type: 'cityName',
    value: 'VENKATAGIRIKOTE, KARNATAKA',
    masterId: 17963,
  },
  {
    type: 'cityName',
    value: 'BHETAGURI, WEST BENGAL',
    masterId: 16171,
  },
  {
    type: 'cityName',
    value: 'VARTEJ, GUJARAT',
    masterId: 15795,
  },
  {
    type: 'cityName',
    value: 'VALLATTOLNAGAR, KERALA',
    masterId: 17904,
  },
  {
    type: 'cityName',
    value: 'VADTAL SWAMNRYN, GUJARAT',
    masterId: 18393,
  },
  {
    type: 'cityName',
    value: 'VAITARNA, MAHARASHTRA',
    masterId: 15750,
  },
  {
    type: 'cityName',
    value: 'VASTRAPUR, GUJARAT',
    masterId: 18520,
  },
  {
    type: 'cityName',
    value: 'VALANTARAVAI, TAMIL NADU',
    masterId: 16852,
  },
  {
    type: 'cityName',
    value: 'VAGHPURA, GUJARAT',
    masterId: 18380,
  },
  {
    type: 'cityName',
    value: 'GANDHINAGAR, MAHARASHTRA',
    masterId: 11622,
  },
  {
    type: 'cityName',
    value: 'VARVALA, GUJARAT',
    masterId: 15796,
  },
  {
    type: 'cityName',
    value: 'VIVEKANAND PURI, DELHI',
    masterId: 18574,
  },
  {
    type: 'cityName',
    value: 'VEERAVASARAM, ANDHRA PRADESH',
    masterId: 15821,
  },
  {
    type: 'cityName',
    value: 'VIKRAVANDI, TAMIL NADU',
    masterId: 16840,
  },
  {
    type: 'cityName',
    value: 'VIRAVANALLUR, TAMIL NADU',
    masterId: 19160,
  },
  {
    type: 'cityName',
    value: 'VAVERA, GUJARAT',
    masterId: 18377,
  },
  {
    type: 'cityName',
    value: 'VIDURASHWATHA, KARNATAKA',
    masterId: 15865,
  },
  {
    type: 'cityName',
    value: 'VADOD, GUJARAT',
    masterId: 15740,
  },
  {
    type: 'cityName',
    value: 'VELLPAPALYAM, TAMIL NADU',
    masterId: 16843,
  },
  {
    type: 'cityName',
    value: 'VYARA, GUJARAT',
    masterId: 15918,
  },
  {
    type: 'cityName',
    value: 'SALAIYA, MADHYA PRADESH',
    masterId: 14835,
  },
  {
    type: 'cityName',
    value: 'CHANDITARA, UTTAR PRADESH',
    masterId: 10985,
  },
  {
    type: 'cityName',
    value: 'VIJAYAMANGALAM, TAMIL NADU',
    masterId: 16841,
  },
  {
    type: 'cityName',
    value: 'VIZIANAGARAM, ANDHRA PRADESH',
    masterId: 15914,
  },
  {
    type: 'cityName',
    value: 'VAZEERPUR, UTTAR PRADESH',
    masterId: 16264,
  },
  {
    type: 'cityName',
    value: 'BALWA, GUJARAT',
    masterId: 18789,
  },
  {
    type: 'cityName',
    value: 'WADI, KARNATAKA',
    masterId: 15925,
  },
  {
    type: 'cityName',
    value: 'WADODA, MAHARASHTRA',
    masterId: 17717,
  },
  {
    type: 'cityName',
    value: 'WAIR, UTTAR PRADESH',
    masterId: 15931,
  },
  {
    type: 'cityName',
    value: 'WANI, MAHARASHTRA',
    masterId: 15940,
  },
  {
    type: 'cityName',
    value: 'WADHWAN, GUJARAT',
    masterId: 15924,
  },
  {
    type: 'cityName',
    value: 'WIMCO NAGAR, TAMIL NADU',
    masterId: 20984,
  },
  {
    type: 'cityName',
    value: 'WADRENGDISA, ASSAM',
    masterId: 15927,
  },
  {
    type: 'cityName',
    value: 'WADEGAON, MAHARASHTRA',
    masterId: 17561,
  },
  {
    type: 'cityName',
    value: 'WANDER JATANA, PUNJAB',
    masterId: 17284,
  },
  {
    type: 'cityName',
    value: 'WANDAL, KARNATAKA',
    masterId: 17961,
  },
  {
    type: 'cityName',
    value: 'RD, MAHARASHTRA',
    masterId: 14710,
  },
  {
    type: 'cityName',
    value: 'WADIARAM, ANDHRA PRADESH',
    masterId: 15926,
  },
  {
    type: 'cityName',
    value: 'TADAVALE, MAHARASHTRA',
    masterId: 15377,
  },
  {
    type: 'cityName',
    value: 'WELLINGTON, TAMIL NADU',
    masterId: 15960,
  },
  {
    type: 'cityName',
    value: 'WENA, BIHAR',
    masterId: 15961,
  },
  {
    type: 'cityName',
    value: 'WAGHOLI, MAHARASHTRA',
    masterId: 17559,
  },
  {
    type: 'cityName',
    value: 'WAGHODA, MAHARASHTRA',
    masterId: 17560,
  },
  {
    type: 'cityName',
    value: 'WARISGANJ, UTTAR PRADESH',
    masterId: 16261,
  },
  {
    type: 'cityName',
    value: 'WEST ST, KERALA',
    masterId: 16836,
  },
  {
    type: 'cityName',
    value: 'WASHIM, MAHARASHTRA',
    masterId: 15951,
  },
  {
    type: 'cityName',
    value: 'WIRUR, MAHARASHTRA',
    masterId: 15962,
  },
  {
    type: 'cityName',
    value: 'WALAJABAD, TAMIL NADU',
    masterId: 16837,
  },
  {
    type: 'cityName',
    value: 'AMMOOR, TAMIL NADU',
    masterId: 10168,
  },
  {
    type: 'cityName',
    value: 'WAKAV, MAHARASHTRA',
    masterId: 15933,
  },
  {
    type: 'cityName',
    value: 'WADAKKANCHERY, KERALA',
    masterId: 15923,
  },
  {
    type: 'cityName',
    value: 'WANKANER, GUJARAT',
    masterId: 15941,
  },
  {
    type: 'cityName',
    value: 'WARANGAL, TELANGANA',
    masterId: 15944,
  },
  {
    type: 'cityName',
    value: 'WALGAON, MAHARASHTRA',
    masterId: 17716,
  },
  {
    type: 'cityName',
    value: 'WALHA, MAHARASHTRA',
    masterId: 17558,
  },
  {
    type: 'cityName',
    value: 'WAN ROAD, MAHARASHTRA',
    masterId: 15937,
  },
  {
    type: 'cityName',
    value: 'WANEGAON, MAHARASHTRA',
    masterId: 15938,
  },
  {
    type: 'cityName',
    value: 'WARUD ORANGE CITY, MAHARASHTRA',
    masterId: 17750,
  },
  {
    type: 'cityName',
    value: 'WANGAPALLI, ANDHRA PRADESH',
    masterId: 15939,
  },
  {
    type: 'cityName',
    value: 'WANPARTI ROAD, ANDHRA PRADESH',
    masterId: 15942,
  },
  {
    type: 'cityName',
    value: 'WARDHA, MAHARASHTRA',
    masterId: 15947,
  },
  {
    type: 'cityName',
    value: 'WALAYAR, KERALA',
    masterId: 15935,
  },
  {
    type: 'cityName',
    value: 'W R S COLONY PH, CHHATTISGARH',
    masterId: 15922,
  },
  {
    type: 'cityName',
    value: 'WARIGAON NEWADA, UTTAR PRADESH',
    masterId: 16262,
  },
  {
    type: 'cityName',
    value: 'WARASEONI, MADHYA PRADESH',
    masterId: 19204,
  },
  {
    type: 'cityName',
    value: 'WARORA, MAHARASHTRA',
    masterId: 15949,
  },
  {
    type: 'cityName',
    value: 'WARISALIGANJ, BIHAR',
    masterId: 15948,
  },
  {
    type: 'cityName',
    value: 'WADSA, MAHARASHTRA',
    masterId: 15928,
  },
  {
    type: 'cityName',
    value: 'WASHIMBE, MAHARASHTRA',
    masterId: 15952,
  },
  {
    type: 'cityName',
    value: 'WASUD, MAHARASHTRA',
    masterId: 17556,
  },
  {
    type: 'cityName',
    value: 'VANSJALIYA, GUJARAT',
    masterId: 15781,
  },
  {
    type: 'cityName',
    value: 'JAM WANTHALI, GUJARAT',
    masterId: 12165,
  },
  {
    type: 'cityName',
    value: 'WATHAR, MAHARASHTRA',
    masterId: 15953,
  },
  {
    type: 'cityName',
    value: 'WANABAR HALT, BIHAR',
    masterId: 20743,
  },
  {
    type: 'cityName',
    value: 'VAVANIYA, GUJARAT',
    masterId: 20817,
  },
  {
    type: 'cityName',
    value: 'WAZIRGANJ, BIHAR',
    masterId: 15959,
  },
  {
    type: 'cityName',
    value: 'BIKRAMGANJ, BIHAR',
    masterId: 18838,
  },
  {
    type: 'cityName',
    value: 'YELIYUR, KARNATAKA',
    masterId: 15985,
  },
  {
    type: 'cityName',
    value: 'YERRAGUNTLA, ANDHRA PRADESH',
    masterId: 15998,
  },
  {
    type: 'cityName',
    value: 'KAULKHED, MAHARASHTRA',
    masterId: 17735,
  },
  {
    type: 'cityName',
    value: 'YADAVALLI, ANDHRA PRADESH',
    masterId: 18985,
  },
  {
    type: 'cityName',
    value: 'YAKUT GANJ, UTTAR PRADESH',
    masterId: 16259,
  },
  {
    type: 'cityName',
    value: 'YADUDIH, JHARKHAND',
    masterId: 20852,
  },
  {
    type: 'cityName',
    value: 'YADALAPUR, KARNATAKA',
    masterId: 17662,
  },
  {
    type: 'cityName',
    value: 'YADAMANGALA, KARNATAKA',
    masterId: 15966,
  },
  {
    type: 'cityName',
    value: 'YEDAPALLY, TELANGANA',
    masterId: 16794,
  },
  {
    type: 'cityName',
    value: 'YADVENDRANAGAR, UTTAR PRADESH',
    masterId: 16260,
  },
  {
    type: 'cityName',
    value: 'YUSUFPUR, UTTAR PRADESH',
    masterId: 16001,
  },
  {
    type: 'cityName',
    value: 'YERRA GOPPA, KARNATAKA',
    masterId: 17959,
  },
  {
    type: 'cityName',
    value: 'YERRAGUDIPAD, ANDHRA PRADESH',
    masterId: 15995,
  },
  {
    type: 'cityName',
    value: 'YELGUR, ANDHRA PRADESH',
    masterId: 15984,
  },
  {
    type: 'cityName',
    value: 'YADUGRAM BH, JHARKHAND',
    masterId: 20848,
  },
  {
    type: 'cityName',
    value: 'YAMUNANAGAR, HARYANA',
    masterId: 15972,
  },
  {
    type: 'cityName',
    value: 'YEOLA, MAHARASHTRA',
    masterId: 15991,
  },
  {
    type: 'cityName',
    value: 'YALAVIGI, KARNATAKA',
    masterId: 15971,
  },
  {
    type: 'cityName',
    value: 'KALAVALAPUDI, ANDHRA PRADESH',
    masterId: 12384,
  },
  {
    type: 'cityName',
    value: 'YELLAMANCHILI, ANDHRA PRADESH',
    masterId: 15986,
  },
  {
    type: 'cityName',
    value: 'YENUGONDA, TELANGANA',
    masterId: 16793,
  },
  {
    type: 'cityName',
    value: 'ERRUPALEM, ANDHRA PRADESH',
    masterId: 11539,
  },
  {
    type: 'cityName',
    value: 'YERPEDU, ANDHRA PRADESH',
    masterId: 15994,
  },
  {
    type: 'cityName',
    value: 'YERMARUS, KARNATAKA',
    masterId: 17960,
  },
  {
    type: 'cityName',
    value: 'YEDASHI, MAHARASHTRA',
    masterId: 15981,
  },
  {
    type: 'cityName',
    value: 'YAVAT, MAHARASHTRA',
    masterId: 15978,
  },
  {
    type: 'cityName',
    value: 'YAWARPURA, GUJARAT',
    masterId: 20806,
  },
  {
    type: 'cityName',
    value: 'ZARAP, MAHARASHTRA',
    masterId: 16006,
  },
  {
    type: 'cityName',
    value: 'WALLEPUR, ANDHRA PRADESH',
    masterId: 15936,
  },
  {
    type: 'cityName',
    value: 'HISAMPUR, UTTAR PRADESH',
    masterId: 12005,
  },
  {
    type: 'cityName',
    value: 'JANGAON, ANDHRA PRADESH',
    masterId: 12189,
  },
  {
    type: 'cityName',
    value: 'ZAMANIA, UTTAR PRADESH',
    masterId: 16003,
  },
  {
    type: 'cityName',
    value: 'JINDPURA, UTTAR PRADESH',
    masterId: 16493,
  },
  {
    type: 'cityName',
    value: 'ZARPUR PALI, HARYANA ',
    masterId: 18245,
  },
  {
    type: 'cityName',
    value: 'ZAMPANI HALT, ANDHRA PRADESH',
    masterId: 16004,
  },
  {
    type: 'cityName',
    value: 'KANDUKURU, ANDHRA PRADESH',
    masterId: 12479,
  },
  {
    type: 'cityName',
    value: 'RAILWAY BUS STOP, RAJASTHAN',
    masterId: 18576,
  },
  {
    type: 'cityName',
    value: 'JIRADEI, BIHAR',
    masterId: 12269,
  },
  {
    type: 'cityName',
    value: 'ZAWAR, RAJASTHAN',
    masterId: 16007,
  },
  {
    type: 'cityName',
    value: 'MANGALWAR, RAJASTHAN',
    masterId: 13416,
  },
  {
    type: 'cityName',
    value: 'KOTHAMANGALAM, KERALA',
    masterId: 12913,
  },
  {
    type: 'cityName',
    value: 'KULASEKHARAM, TAMIL NADU',
    masterId: 12989,
  },
  {
    type: 'cityName',
    value: 'KAWARDHA, CHHATTISGARH',
    masterId: 12625,
  },
  {
    type: 'cityName',
    value: 'GUMMUDIPOONDI, TAMIL NADU',
    masterId: 11831,
  },
  {
    type: 'cityName',
    value: 'LEDO, ASSAM',
    masterId: 13132,
  },
  {
    type: 'cityName',
    value: 'RAIGUNJ, WEST BENGAL',
    masterId: 14559,
  },
  {
    type: 'cityName',
    value: 'THIRUMANGALAM, TAMIL NADU',
    masterId: 15515,
  },
  {
    type: 'cityName',
    value: 'SANTINIKETAN, WEST BENGAL',
    masterId: 14922,
  },
  {
    type: 'cityName',
    value: 'HIPPARAGI, KARNATAKA',
    masterId: 11995,
  },
  {
    type: 'cityName',
    value: 'KATHARI, RAJASTHAN',
    masterId: 12595,
  },
  {
    type: 'cityName',
    value: 'KUNDHELI, GUJARAT',
    masterId: 13023,
  },
  {
    type: 'cityName',
    value: 'SANGOLE, MAHARASHTRA',
    masterId: 14903,
  },
  {
    type: 'cityName',
    value: 'PAVOORCHATRAM, TAMIL NADU',
    masterId: 14318,
  },
  {
    type: 'cityName',
    value: 'PANAGAR, MADHYA PRADESH',
    masterId: 14181,
  },
  {
    type: 'cityName',
    value: 'JAWRA, UTTAR PRADESH',
    masterId: 12222,
  },
  {
    type: 'cityName',
    value: 'KOTDA, GUJARAT',
    masterId: 12907,
  },
  {
    type: 'cityName',
    value: 'KAMAVARAPUKOTA, ANDHRA PRADESH',
    masterId: 12446,
  },
  {
    type: 'cityName',
    value: 'HAMPI, KARNATAKA',
    masterId: 11910,
  },
  {
    type: 'cityName',
    value: 'PERUMANALLUR, TAMIL NADU',
    masterId: 14369,
  },
  {
    type: 'cityName',
    value: 'UPPILIAPURAM, TAMIL NADU',
    masterId: 15702,
  },
  {
    type: 'cityName',
    value: 'HEBRI, KARNATAKA',
    masterId: 11976,
  },
  {
    type: 'cityName',
    value: 'SANOSARA, GUJARAT',
    masterId: 14915,
  },
  {
    type: 'cityName',
    value: 'JANKIA, ORISSA',
    masterId: 12194,
  },
  {
    type: 'cityName',
    value: 'RAJUR, MAHARASHTRA',
    masterId: 14596,
  },
  {
    type: 'cityName',
    value: 'RAWATSAR, RAJASTHAN',
    masterId: 14698,
  },
  {
    type: 'cityName',
    value: 'MARUTHUVAKUDI, TAMIL NADU',
    masterId: 13497,
  },
  {
    type: 'cityName',
    value: 'MADAKASIRA, ANDHRA PRADESH',
    masterId: 13193,
  },
  {
    type: 'cityName',
    value: 'RAJNAGAR, BIHAR',
    masterId: 14588,
  },
  {
    type: 'cityName',
    value: 'UDHAGAMANDALAM, TAMIL NADU',
    masterId: 15643,
  },
  {
    type: 'cityName',
    value: 'KANDARAMANIKAM, TAMIL NADU',
    masterId: 12473,
  },
  {
    type: 'cityName',
    value: 'POTTALPUDUR, TAMIL NADU',
    masterId: 14462,
  },
  {
    type: 'cityName',
    value: 'MATHAL, GUJARAT',
    masterId: 13511,
  },
  {
    type: 'cityName',
    value: 'KOKRUD, MAHARASHTRA',
    masterId: 12834,
  },
  {
    type: 'cityName',
    value: 'ARASARKULAM, TAMIL NADU',
    masterId: 10239,
  },
  {
    type: 'cityName',
    value: 'UDUMALPET, TAMIL NADU',
    masterId: 15647,
  },
  {
    type: 'cityName',
    value: 'RANIGAON, RAJASTHAN',
    masterId: 14662,
  },
  {
    type: 'cityName',
    value: 'IDAIKAL, TAMIL NADU',
    masterId: 12057,
  },
  {
    type: 'cityName',
    value: 'VADUGAPATTI, TAMIL NADU',
    masterId: 15742,
  },
  {
    type: 'cityName',
    value: 'MOGRALPUTHUR, KERALA',
    masterId: 13614,
  },
  {
    type: 'cityName',
    value: 'BADAMI, KARNATAKA',
    masterId: 10337,
  },
  {
    type: 'cityName',
    value: 'ERUMELI SOUTH, KERALA',
    masterId: 11540,
  },
  {
    type: 'cityName',
    value: 'ORATHANADU, TAMIL NADU',
    masterId: 14088,
  },
  {
    type: 'cityName',
    value: 'MAMSA, GUJARAT',
    masterId: 13349,
  },
  {
    type: 'cityName',
    value: 'KELWA, RAJASTHAN',
    masterId: 12645,
  },
  {
    type: 'cityName',
    value: 'MUKUNDGARH, RAJASTHAN',
    masterId: 13701,
  },
  {
    type: 'cityName',
    value: 'JAISINGHPUR, HIMACHAL PRADESH',
    masterId: 12132,
  },
  {
    type: 'cityName',
    value: 'EETHAKOTA, ANDHRA PRADESH',
    masterId: 11520,
  },
  {
    type: 'cityName',
    value: 'YENDAPALLI, ANDHRA PRADESH',
    masterId: 15990,
  },
  {
    type: 'cityName',
    value: 'SITARGANJ, UTTARAKHAND',
    masterId: 15231,
  },
  {
    type: 'cityName',
    value: 'SONAULI, BIHAR',
    masterId: 15267,
  },
  {
    type: 'cityName',
    value: 'KUMBASHI, KARNATAKA',
    masterId: 13004,
  },
  {
    type: 'cityName',
    value: 'SULUR, TAMIL NADU',
    masterId: 15333,
  },
  {
    type: 'cityName',
    value: 'BHANPURA, MADHYA PRADESH',
    masterId: 10698,
  },
  {
    type: 'cityName',
    value: 'TIRUCHENGODE, TAMIL NADU',
    masterId: 15576,
  },
  {
    type: 'cityName',
    value: 'DUDHAI, GUJARAT',
    masterId: 11473,
  },
  {
    type: 'cityName',
    value: 'KOSI, UTTAR PRADESH',
    masterId: 12893,
  },
  {
    type: 'cityName',
    value: 'SAMALKOT, ANDHRA PRADESH',
    masterId: 14865,
  },
  {
    type: 'cityName',
    value: 'KOTTAMPATTY, TAMIL NADU',
    masterId: 12933,
  },
  {
    type: 'cityName',
    value: 'RAJASINGAMANGALAM, TAMIL NADU',
    masterId: 14577,
  },
  {
    type: 'cityName',
    value: 'AGOMANI, ASSAM',
    masterId: 18955,
  },
  {
    type: 'cityName',
    value: 'BODDAVARA, ANDHRA PRADESH',
    masterId: 19040,
  },
  {
    type: 'cityName',
    value: 'SASNI, UTTAR PRADESH',
    masterId: 14962,
  },
  {
    type: 'cityName',
    value: 'NAVAGAM, GUJARAT',
    masterId: 13925,
  },
  {
    type: 'cityName',
    value: 'KERA, GUJARAT',
    masterId: 12654,
  },
  {
    type: 'cityName',
    value: 'ACHARA, MAHARASHTRA',
    masterId: 10017,
  },
  {
    type: 'cityName',
    value: 'KURAVILANGAD, KERALA',
    masterId: 13036,
  },
  {
    type: 'cityName',
    value: 'BELVAI, KARNATAKA',
    masterId: 10633,
  },
  {
    type: 'cityName',
    value: 'GHATOL, RAJASTHAN',
    masterId: 11699,
  },
  {
    type: 'cityName',
    value: 'BIDASAR, RAJASTHAN',
    masterId: 10803,
  },
  {
    type: 'cityName',
    value: 'CHANDWAD, MAHARASHTRA',
    masterId: 10999,
  },
  {
    type: 'cityName',
    value: 'KALASA, KARNATAKA',
    masterId: 12379,
  },
  {
    type: 'cityName',
    value: 'KOPPA, KARNATAKA',
    masterId: 12879,
  },
  {
    type: 'cityName',
    value: 'ASHTA, MADHYA PRADESH',
    masterId: 10270,
  },
  {
    type: 'cityName',
    value: 'BHANDARIYA, GUJARAT',
    masterId: 10695,
  },
  {
    type: 'cityName',
    value: 'BHOJPUR, BIHAR',
    masterId: 10763,
  },
  {
    type: 'cityName',
    value: 'BALEHONNUR, KARNATAKA',
    masterId: 10426,
  },
  {
    type: 'cityName',
    value: 'CHHOKARWARA, RAJASTHAN',
    masterId: 11066,
  },
  {
    type: 'cityName',
    value: 'BADNAWAR, MADHYA PRADESH',
    masterId: 10352,
  },
  {
    type: 'cityName',
    value: 'KATTAPPANA, KERALA',
    masterId: 12609,
  },
  {
    type: 'cityName',
    value: 'KALIGIRI, ANDHRA PRADESH',
    masterId: 12396,
  },
  {
    type: 'cityName',
    value: 'ADIYAKKAMANGALAM, TAMIL NADU',
    masterId: 10034,
  },
  {
    type: 'cityName',
    value: 'MOODBIDRI, KARNATAKA',
    masterId: 13632,
  },
  {
    type: 'cityName',
    value: 'VEMPALLI, ANDHRA PRADESH',
    masterId: 15841,
  },
  {
    type: 'cityName',
    value: 'PEDHDA, GUJARAT',
    masterId: 14340,
  },
  {
    type: 'cityName',
    value: 'DATARDI, GUJARAT',
    masterId: 11248,
  },
  {
    type: 'cityName',
    value: 'VILLUPURAM, TAMIL NADU',
    masterId: 15886,
  },
  {
    type: 'cityName',
    value: 'KILIMANOOR, KERALA',
    masterId: 12782,
  },
  {
    type: 'cityName',
    value: 'KOPPAM , KERALA',
    masterId: 12881,
  },
  {
    type: 'cityName',
    value: 'SRINAGAR, JAMMU AND KASHMIR',
    masterId: 15292,
  },
  {
    type: 'cityName',
    value: 'JADKAL, KARNATAKA',
    masterId: 12102,
  },
  {
    type: 'cityName',
    value: 'DHANGALA, GUJARAT',
    masterId: 11348,
  },
  {
    type: 'cityName',
    value: 'JARWAL, UTTAR PRADESH',
    masterId: 12203,
  },
  {
    type: 'cityName',
    value: 'REVAS, GUJARAT',
    masterId: 14730,
  },
  {
    type: 'cityName',
    value: 'JAMNER, MAHARASHTRA',
    masterId: 12179,
  },
  {
    type: 'cityName',
    value: 'HAZARIBAG, JHARKHAND',
    masterId: 11974,
  },
  {
    type: 'cityName',
    value: 'DAGGUBADU, ANDHRA PRADESH',
    masterId: 11191,
  },
  {
    type: 'cityName',
    value: 'BAGODAR, JHARKHAND',
    masterId: 10377,
  },
  {
    type: 'cityName',
    value: 'UPPINANGADI, KARNATAKA',
    masterId: 15703,
  },
  {
    type: 'cityName',
    value: 'CHERKUMILLI, ANDHRA PRADESH',
    masterId: 11042,
  },
  {
    type: 'cityName',
    value: 'MONIPPALLY, KERALA',
    masterId: 13629,
  },
  {
    type: 'cityName',
    value: 'UTTUR, MAHARASHTRA',
    masterId: 15718,
  },
  {
    type: 'cityName',
    value: 'TALLAPUDI, ANDHRA PRADESH',
    masterId: 15413,
  },
  {
    type: 'cityName',
    value: 'CHILAKALLU, ANDHRA PRADESH',
    masterId: 11086,
  },
  {
    type: 'cityName',
    value: 'ATKOT, GUJARAT',
    masterId: 10293,
  },
  {
    type: 'cityName',
    value: 'CHATHANNOOR, KERALA',
    masterId: 11016,
  },
  {
    type: 'cityName',
    value: 'PATTAMADAI, TAMIL NADU',
    masterId: 14310,
  },
  {
    type: 'cityName',
    value: 'TARAPUR, GUJARAT',
    masterId: 15442,
  },
  {
    type: 'cityName',
    value: 'MULANUR, TAMIL NADU',
    masterId: 13705,
  },
  {
    type: 'cityName',
    value: 'DEOLA, MAHARASHTRA',
    masterId: 11282,
  },
  {
    type: 'cityName',
    value: 'SUNDANKOTTAI, TAMIL NADU',
    masterId: 15340,
  },
  {
    type: 'cityName',
    value: 'KANGAYAM, TAMIL NADU',
    masterId: 12482,
  },
  {
    type: 'cityName',
    value: 'DERISANAMCOPE, TAMIL NADU',
    masterId: 11293,
  },
  {
    type: 'cityName',
    value: 'GARAGAPARRU, ANDHRA PRADESH',
    masterId: 11649,
  },
  {
    type: 'cityName',
    value: 'NOIDA, UTTAR PRADESH',
    masterId: 14048,
  },
  {
    type: 'cityName',
    value: 'GADHINGLAJ, MAHARASHTRA',
    masterId: 11591,
  },
  {
    type: 'cityName',
    value: 'MOHALI, PUNJAB',
    masterId: 13616,
  },
  {
    type: 'cityName',
    value: 'DUGLA, CHHATTISGARH',
    masterId: 11478,
  },
  {
    type: 'cityName',
    value: 'THONDI, TAMIL NADU',
    masterId: 15533,
  },
  {
    type: 'cityName',
    value: 'KHOOR, RAJASTHAN',
    masterId: 12764,
  },
  {
    type: 'cityName',
    value: 'NIMMAKURU, ANDHRA PRADESH',
    masterId: 14018,
  },
  {
    type: 'cityName',
    value: 'BHATEWAR, RAJASTHAN',
    masterId: 10714,
  },
  {
    type: 'cityName',
    value: 'DEOLI, RAJASTHAN',
    masterId: 11285,
  },
  {
    type: 'cityName',
    value: 'VAYOR, GUJARAT',
    masterId: 15811,
  },
  {
    type: 'cityName',
    value: 'MANOLLI, KARNATAKA',
    masterId: 13455,
  },
  {
    type: 'cityName',
    value: 'KAMUDI, TAMIL NADU',
    masterId: 12459,
  },
  {
    type: 'cityName',
    value: 'BANTUMILLI, ANDHRA PRADESH',
    masterId: 10493,
  },
  {
    type: 'cityName',
    value: 'VADLAMUDI, ANDHRA PRADESH',
    masterId: 15738,
  },
  {
    type: 'cityName',
    value: 'MURUD, MAHARASHTRA',
    masterId: 13754,
  },
  {
    type: 'cityName',
    value: 'KALADY, KERALA',
    masterId: 12368,
  },
  {
    type: 'cityName',
    value: 'KOMMURU, ANDHRA PRADESH',
    masterId: 12863,
  },
  {
    type: 'cityName',
    value: 'BILGI, KARNATAKA',
    masterId: 10828,
  },
  {
    type: 'cityName',
    value: 'MOGALTURU, ANDHRA PRADESH',
    masterId: 13612,
  },
  {
    type: 'cityName',
    value: 'LOKAPUR, KARNATAKA',
    masterId: 13157,
  },
  {
    type: 'cityName',
    value: 'SEETHANAGARAM, ANDHRA PRADESH',
    masterId: 15009,
  },
  {
    type: 'cityName',
    value: 'CHITHRADURGA RD, KARNATAKA',
    masterId: 11133,
  },
  {
    type: 'cityName',
    value: 'UDI MORE, UTTAR PRADESH',
    masterId: 16271,
  },
  {
    type: 'cityName',
    value: 'POTHAVARAM, ANDHRA PRADESH',
    masterId: 14458,
  },
  {
    type: 'cityName',
    value: 'MANNAEKHELLI, KARNATAKA',
    masterId: 13447,
  },
  {
    type: 'cityName',
    value: 'GOGAMEDI, RAJASTHAN',
    masterId: 11734,
  },
  {
    type: 'cityName',
    value: 'EDAPPAL, KERALA',
    masterId: 11515,
  },
  {
    type: 'cityName',
    value: 'MEGHPAR, GUJARAT',
    masterId: 13554,
  },
  {
    type: 'cityName',
    value: 'TIMMAPURAM, ANDHRA PRADESH',
    masterId: 15567,
  },
  {
    type: 'cityName',
    value: 'SANVAV, GUJARAT',
    masterId: 14923,
  },
  {
    type: 'cityName',
    value: 'LUXETTIPET, TELANGANA',
    masterId: 13184,
  },
  {
    type: 'cityName',
    value: 'MADAGUPATTI, TAMIL NADU',
    masterId: 13192,
  },
  {
    type: 'cityName',
    value: 'RATHALI, HARYANA',
    masterId: 14687,
  },
  {
    type: 'cityName',
    value: 'KAMLAPUR, MAHARASHTRA',
    masterId: 12448,
  },
  {
    type: 'cityName',
    value: 'INFOSYS RD, KARNATAKA',
    masterId: 12073,
  },
  {
    type: 'cityName',
    value: 'GUNDMI VILLAGE, KARNATAKA',
    masterId: 11841,
  },
  {
    type: 'cityName',
    value: 'SARDARSHAHAR, RAJASTHAN',
    masterId: 14946,
  },
  {
    type: 'cityName',
    value: 'VANIYAMKULAM, KERALA',
    masterId: 15776,
  },
  {
    type: 'cityName',
    value: 'PATODA, MAHARASHTRA',
    masterId: 14304,
  },
  {
    type: 'cityName',
    value: 'SINGHANA, MADHYA PRADESH',
    masterId: 15195,
  },
  {
    type: 'cityName',
    value: 'MENAR, RAJASTHAN',
    masterId: 13570,
  },
  {
    type: 'cityName',
    value: 'KUSHALNAGAR, KARNATAKA',
    masterId: 13051,
  },
  {
    type: 'cityName',
    value: 'NIWAI, UTTAR PRADESH',
    masterId: 14038,
  },
  {
    type: 'cityName',
    value: 'PANDAVAPURA, KARNATAKA',
    masterId: 14197,
  },
  {
    type: 'cityName',
    value: 'JAFARABAD, GUJARAT',
    masterId: 12103,
  },
  {
    type: 'cityName',
    value: 'GARGOTI, MAHARASHTRA',
    masterId: 11650,
  },
  {
    type: 'cityName',
    value: 'KAIKATTI, TAMIL NADU',
    masterId: 12348,
  },
  {
    type: 'cityName',
    value: 'ANNAMBHOTLAVARI PALEM, ANDHRA PRADESH',
    masterId: 10216,
  },
  {
    type: 'cityName',
    value: 'REVDAR, RAJASTHAN',
    masterId: 14732,
  },
  {
    type: 'cityName',
    value: 'ANBINNAGARAM, TAMIL NADU',
    masterId: 10193,
  },
  {
    type: 'cityName',
    value: 'WAKAD, MAHARASHTRA',
    masterId: 15932,
  },
  {
    type: 'cityName',
    value: 'KALUGUMALAI, TAMIL NADU',
    masterId: 12428,
  },
  {
    type: 'cityName',
    value: 'SINGAMPUNARI, TAMIL NADU',
    masterId: 15190,
  },
  {
    type: 'cityName',
    value: 'AUNDHA NAGNATH, MAHARASHTRA',
    masterId: 10305,
  },
  {
    type: 'cityName',
    value: 'DONGAON, MAHARASHTRA',
    masterId: 11459,
  },
  {
    type: 'cityName',
    value: 'CHIKHALI, GUJARAT',
    masterId: 11078,
  },
  {
    type: 'cityName',
    value: 'DUDDUKURU, ANDHRA PRADESH',
    masterId: 11472,
  },
  {
    type: 'cityName',
    value: 'SIDHPUR, GUJARAT',
    masterId: 15147,
  },
  {
    type: 'cityName',
    value: 'SEETHARAMAPURAM, ANDHRA PRADESH',
    masterId: 15011,
  },
  {
    type: 'cityName',
    value: 'ASHTI, MAHARASHTRA',
    masterId: 10272,
  },
  {
    type: 'cityName',
    value: 'KALAVARA, KARNATAKA',
    masterId: 12385,
  },
  {
    type: 'cityName',
    value: 'ARDAVARAM, ANDHRA PRADESH',
    masterId: 10242,
  },
  {
    type: 'cityName',
    value: 'T.KALLUPATTI, TAMIL NADU',
    masterId: 15372,
  },
  {
    type: 'cityName',
    value: 'MADIKERI, KARNATAKA',
    masterId: 13214,
  },
  {
    type: 'cityName',
    value: 'VADVIYALA, GUJARAT',
    masterId: 15743,
  },
  {
    type: 'cityName',
    value: 'AUSHA, WEST BENGAL',
    masterId: 10312,
  },
  {
    type: 'cityName',
    value: 'GORANTLA, ANDHRA PRADESH',
    masterId: 11772,
  },
  {
    type: 'cityName',
    value: 'SAMATAR, HIMACHAL PRADESH',
    masterId: 14869,
  },
  {
    type: 'cityName',
    value: 'KUDAVASAL, TAMIL NADU',
    masterId: 12973,
  },
  {
    type: 'cityName',
    value: 'DHARUHERA, HARYANA',
    masterId: 11375,
  },
  {
    type: 'cityName',
    value: 'BALDIYA, RAJASTHAN',
    masterId: 10424,
  },
  {
    type: 'cityName',
    value: 'BINKADKATTI, KARNATAKA',
    masterId: 18060,
  },
  {
    type: 'cityName',
    value: 'KANIGIRI, ANDHRA PRADESH',
    masterId: 12489,
  },
  {
    type: 'cityName',
    value: 'MAVJINJAVA, GUJARAT',
    masterId: 13533,
  },
  {
    type: 'cityName',
    value: 'RAMANGULI, KARNATAKA',
    masterId: 14606,
  },
  {
    type: 'cityName',
    value: 'THIRTHAHALLI, KARNATAKA',
    masterId: 15511,
  },
  {
    type: 'cityName',
    value: 'KHAVADI, MAHARASHTRA',
    masterId: 12737,
  },
  {
    type: 'cityName',
    value: 'KUCHIPUDI, ANDHRA PRADESH',
    masterId: 12967,
  },
  {
    type: 'cityName',
    value: 'BHANDARA, MAHARASHTRA',
    masterId: 10694,
  },
  {
    type: 'cityName',
    value: 'MEDARAMETLA, ANDHRA PRADESH',
    masterId: 13545,
  },
  {
    type: 'cityName',
    value: 'THAMMAMPATTI, TAMIL NADU',
    masterId: 15493,
  },
  {
    type: 'cityName',
    value: 'NH947, GUJARAT',
    masterId: 13991,
  },
  {
    type: 'cityName',
    value: 'ZAHEERABAD, TELANGANA',
    masterId: 16002,
  },
  {
    type: 'cityName',
    value: 'ADIRAMPATTINAM, TAMIL NADU',
    masterId: 10032,
  },
  {
    type: 'cityName',
    value: 'POLAKI, ANDHRA PRADESH',
    masterId: 14442,
  },
  {
    type: 'cityName',
    value: 'SULLIA, KARNATAKA',
    masterId: 15324,
  },
  {
    type: 'cityName',
    value: 'HALADY, KARNATAKA',
    masterId: 11896,
  },
  {
    type: 'cityName',
    value: 'RID, RAJASTHAN',
    masterId: 14739,
  },
  {
    type: 'cityName',
    value: 'SALIGRAMA, KARNATAKA',
    masterId: 14851,
  },
  {
    type: 'cityName',
    value: 'BANAVASI, KARNATAKA',
    masterId: 10464,
  },
  {
    type: 'cityName',
    value: 'GADHSISA, GUJARAT',
    masterId: 11592,
  },
  {
    type: 'cityName',
    value: 'BADIYADKA, KERALA',
    masterId: 10345,
  },
  {
    type: 'cityName',
    value: 'LINGSUGUR, KARNATAKA',
    masterId: 13148,
  },
  {
    type: 'cityName',
    value: 'NERALAKATTE, KARNATAKA',
    masterId: 13973,
  },
  {
    type: 'cityName',
    value: 'VANKAYALAPADU, ANDHRA PRADESH',
    masterId: 15777,
  },
  {
    type: 'cityName',
    value: 'KASAL, MAHARASHTRA',
    masterId: 12576,
  },
  {
    type: 'cityName',
    value: 'VANKIYA, GUJARAT',
    masterId: 15778,
  },
  {
    type: 'cityName',
    value: 'KUMILY, KERALA',
    masterId: 13009,
  },
  {
    type: 'cityName',
    value: 'HOSAGADDE, KARNATAKA',
    masterId: 12026,
  },
  {
    type: 'cityName',
    value: 'GAJENDRAGAD, KARNATAKA',
    masterId: 11604,
  },
  {
    type: 'cityName',
    value: 'GUNDRAN, GUJARAT',
    masterId: 11842,
  },
  {
    type: 'cityName',
    value: 'CHIPURUPALLI, ANDHRA PRADESH',
    masterId: 11119,
  },
  {
    type: 'cityName',
    value: 'JUVVALAPALEM, ANDHRA PRADESH',
    masterId: 12300,
  },
  {
    type: 'cityName',
    value: 'SHANKARANARAYANA, KARNATAKA',
    masterId: 15063,
  },
  {
    type: 'cityName',
    value: 'PILANI, RAJASTHAN',
    masterId: 14394,
  },
  {
    type: 'cityName',
    value: 'KUKNOOR, KARNATAKA',
    masterId: 12984,
  },
  {
    type: 'cityName',
    value: 'NIDGUNDI, KARNATAKA',
    masterId: 13995,
  },
  {
    type: 'cityName',
    value: 'KENJOOR, KARNATAKA',
    masterId: 12651,
  },
  {
    type: 'cityName',
    value: 'SANGAM, TELANGANA',
    masterId: 14893,
  },
  {
    type: 'cityName',
    value: 'BASAVAPATNA, KARNATAKA',
    masterId: 10573,
  },
  {
    type: 'cityName',
    value: 'KHERWARA, RAJASTHAN',
    masterId: 12749,
  },
  {
    type: 'cityName',
    value: 'KALLIDAIKURCHI, TAMIL NADU',
    masterId: 12416,
  },
  {
    type: 'cityName',
    value: 'ELESWARAM, ANDHRA PRADESH',
    masterId: 11528,
  },
  {
    type: 'cityName',
    value: 'MIRJAN, KARNATAKA',
    masterId: 13592,
  },
  {
    type: 'cityName',
    value: 'DHABRA, RAJASTHAN',
    masterId: 11327,
  },
  {
    type: 'cityName',
    value: 'NELLYADI, KARNATAKA',
    masterId: 13964,
  },
  {
    type: 'cityName',
    value: 'HANUMAN JUNCTION, ANDHRA PRADESH',
    masterId: 11915,
  },
  {
    type: 'cityName',
    value: 'BANNADKA, KARNATAKA',
    masterId: 10483,
  },
  {
    type: 'cityName',
    value: 'VADLAMANNADU, ANDHRA PRADESH',
    masterId: 15737,
  },
  {
    type: 'cityName',
    value: 'GUDALUR, TAMIL NADU',
    masterId: 11801,
  },
  {
    type: 'cityName',
    value: 'KOMAROLU, ANDHRA PRADESH',
    masterId: 12861,
  },
  {
    type: 'cityName',
    value: 'THALWAD - TURA - SAYALA RD, RAJASTHAN',
    masterId: 15490,
  },
  {
    type: 'cityName',
    value: 'BHINGRAD, GUJARAT',
    masterId: 10754,
  },
  {
    type: 'cityName',
    value: 'MUKKAMALA, ANDHRA PRADESH',
    masterId: 13697,
  },
  {
    type: 'cityName',
    value: 'NARGUND, KARNATAKA',
    masterId: 13895,
  },
  {
    type: 'cityName',
    value: 'MALLAPPALLY, KERALA',
    masterId: 13331,
  },
  {
    type: 'cityName',
    value: 'PAUPARAPATTI, TAMIL NADU',
    masterId: 14316,
  },
  {
    type: 'cityName',
    value: 'BHAVANIPARA, GUJARAT',
    masterId: 10726,
  },
  {
    type: 'cityName',
    value: 'RAZOLE, ANDHRA PRADESH',
    masterId: 14709,
  },
  {
    type: 'cityName',
    value: 'MASUR, KARNATAKA',
    masterId: 13505,
  },
  {
    type: 'cityName',
    value: 'KINNYA, KARNATAKA',
    masterId: 12789,
  },
  {
    type: 'cityName',
    value: 'CHERUKUWADA, ANDHRA PRADESH',
    masterId: 11047,
  },
  {
    type: 'cityName',
    value: 'HARSOL, GUJARAT',
    masterId: 11951,
  },
  {
    type: 'cityName',
    value: 'AATHUR, TAMIL NADU',
    masterId: 10009,
  },
  {
    type: 'cityName',
    value: 'BANNADY, KARNATAKA',
    masterId: 10484,
  },
  {
    type: 'cityName',
    value: 'SUNDER NAGAR, JHARKHAND',
    masterId: 15341,
  },
  {
    type: 'cityName',
    value: 'SAUNDA, JHARKHAND',
    masterId: 14985,
  },
  {
    type: 'cityName',
    value: 'KATTUMAVADI, TAMIL NADU',
    masterId: 12610,
  },
  {
    type: 'cityName',
    value: 'NAGULLANKA, ANDHRA PRADESH',
    masterId: 13816,
  },
  {
    type: 'cityName',
    value: 'PATHRI, MAHARASHTRA',
    masterId: 14298,
  },
  {
    type: 'cityName',
    value: 'BHILA, GUJARAT',
    masterId: 10738,
  },
  {
    type: 'cityName',
    value: 'MANTHA, MAHARASHTRA',
    masterId: 13466,
  },
  {
    type: 'cityName',
    value: 'PARATWADA, MAHARASHTRA',
    masterId: 14239,
  },
  {
    type: 'cityName',
    value: 'KAMLIGHAT, RAJASTHAN',
    masterId: 12449,
  },
  {
    type: 'cityName',
    value: 'KHAMBHA, GUJARAT',
    masterId: 12699,
  },
  {
    type: 'cityName',
    value: 'JAGALLUR, KARNATAKA',
    masterId: 12107,
  },
  {
    type: 'cityName',
    value: 'MANI, KARNATAKA',
    masterId: 13428,
  },
  {
    type: 'cityName',
    value: 'CUMBAM, TAMIL NADU',
    masterId: 11171,
  },
  {
    type: 'cityName',
    value: 'KAMMARPALLY, TELANGANA',
    masterId: 12452,
  },
  {
    type: 'cityName',
    value: 'HB HALLI, KARNATAKA',
    masterId: 11975,
  },
  {
    type: 'cityName',
    value: 'MADH - RAYYA, PUNJAB',
    masterId: 17324,
  },
  {
    type: 'cityName',
    value: 'NARORA, UTTAR PRADESH',
    masterId: 13899,
  },
  {
    type: 'cityName',
    value: 'VADAGAM, GUJARAT',
    masterId: 15724,
  },
  {
    type: 'cityName',
    value: 'RASALIYA, GUJARAT',
    masterId: 14676,
  },
  {
    type: 'cityName',
    value: 'THODUPUZHA, KERALA',
    masterId: 15529,
  },
  {
    type: 'cityName',
    value: 'KUTANA, GUJARAT',
    masterId: 13058,
  },
  {
    type: 'cityName',
    value: 'BHADGAON, MAHARASHTRA',
    masterId: 10661,
  },
  {
    type: 'cityName',
    value: 'PATRA, UTTAR PRADESH',
    masterId: 14305,
  },
  {
    type: 'cityName',
    value: 'KG CHAVADI, TAMIL NADU',
    masterId: 12669,
  },
  {
    type: 'cityName',
    value: 'BELTHANGADY, KARNATAKA',
    masterId: 10630,
  },
  {
    type: 'cityName',
    value: 'VAGHANIYA, GUJARAT',
    masterId: 15745,
  },
  {
    type: 'cityName',
    value: 'AANSODAR, GUJARAT',
    masterId: 10007,
  },
  {
    type: 'cityName',
    value: 'SERNDAMANGALAM, TAMIL NADU',
    masterId: 15027,
  },
  {
    type: 'cityName',
    value: 'PAROLA, MAHARASHTRA',
    masterId: 14257,
  },
  {
    type: 'cityName',
    value: 'CHAVADI, TAMIL NADU',
    masterId: 11027,
  },
  {
    type: 'cityName',
    value: 'HUNGUND, KARNATAKA',
    masterId: 12043,
  },
  {
    type: 'cityName',
    value: 'BARLOOT, RAJASTHAN',
    masterId: 10545,
  },
  {
    type: 'cityName',
    value: 'PARCHOOR, ANDHRA PRADESH',
    masterId: 14246,
  },
  {
    type: 'cityName',
    value: 'BHUNTAR, HIMACHAL PRADESH',
    masterId: 10785,
  },
  {
    type: 'cityName',
    value: 'SHAHUNAGAR RD, MAHARASHTRA',
    masterId: 15052,
  },
  {
    type: 'cityName',
    value: 'BALUSSERY, KERALA',
    masterId: 10445,
  },
  {
    type: 'cityName',
    value: 'SHAJHANPUR, UTTAR PRADESH',
    masterId: 15055,
  },
  {
    type: 'cityName',
    value: 'KOLLURU, ANDHRA PRADESH',
    masterId: 12854,
  },
  {
    type: 'cityName',
    value: 'HUKKERI, KARNATAKA',
    masterId: 12038,
  },
  {
    type: 'cityName',
    value: 'KOTTARAKKARA, KERALA',
    masterId: 12935,
  },
  {
    type: 'cityName',
    value: 'THUCKALAY, TAMIL NADU',
    masterId: 15541,
  },
  {
    type: 'cityName',
    value: 'KONAJE, KARNATAKA',
    masterId: 12864,
  },
  {
    type: 'cityName',
    value: 'SURNAGAR, GUJARAT',
    masterId: 15363,
  },
  {
    type: 'cityName',
    value: 'OMERGA, MAHARASHTRA',
    masterId: 14079,
  },
  {
    type: 'cityName',
    value: 'JAMKHANDI, KARNATAKA',
    masterId: 12174,
  },
  {
    type: 'cityName',
    value: 'JAGANNAPETA, ANDHRA PRADESH',
    masterId: 12110,
  },
  {
    type: 'cityName',
    value: 'CHINNA MANNUR, TAMIL NADU',
    masterId: 11107,
  },
  {
    type: 'cityName',
    value: 'DUNGARGARH, RAJASTHAN',
    masterId: 11491,
  },
  {
    type: 'cityName',
    value: 'SAYALA, RAJASTHAN',
    masterId: 14999,
  },
  {
    type: 'cityName',
    value: 'COURTALLAM, TAMIL NADU',
    masterId: 11167,
  },
  {
    type: 'cityName',
    value: 'EDAMON, KERALA',
    masterId: 11513,
  },
  {
    type: 'cityName',
    value: 'DHARNI, MAHARASHTRA',
    masterId: 11373,
  },
  {
    type: 'cityName',
    value: 'SAKRI, MADHYA PRADESH',
    masterId: 14829,
  },
  {
    type: 'cityName',
    value: 'KAITHAPPOYIL, KERALA',
    masterId: 12353,
  },
  {
    type: 'cityName',
    value: 'KOKKARNE-MUDDUR RD, KARNATAKA',
    masterId: 12832,
  },
  {
    type: 'cityName',
    value: 'MARAVANTHE, KARNATAKA',
    masterId: 13484,
  },
  {
    type: 'cityName',
    value: 'NAVALGUND, KARNATAKA',
    masterId: 13926,
  },
  {
    type: 'cityName',
    value: 'KATHGAL, KARNATAKA',
    masterId: 12596,
  },
  {
    type: 'cityName',
    value: 'THATTARMADAM, TAMIL NADU',
    masterId: 15502,
  },
  {
    type: 'cityName',
    value: 'DHORIMANNA, RAJASTHAN',
    masterId: 11403,
  },
  {
    type: 'cityName',
    value: 'BUDHEL, GUJARAT',
    masterId: 10915,
  },
  {
    type: 'cityName',
    value: 'THOTTIYAM, TAMIL NADU',
    masterId: 15537,
  },
  {
    type: 'cityName',
    value: 'TADIKONDA, ANDHRA PRADESH',
    masterId: 15381,
  },
  {
    type: 'cityName',
    value: 'KALGHATGI, KARNATAKA',
    masterId: 12391,
  },
  {
    type: 'cityName',
    value: 'NAPOKLU, KARNATAKA',
    masterId: 13878,
  },
  {
    type: 'cityName',
    value: 'PULPALLY, KERALA',
    masterId: 14493,
  },
  {
    type: 'cityName',
    value: 'ATMAKUR, ANDHRA PRADESH',
    masterId: 10295,
  },
  {
    type: 'cityName',
    value: 'SUPE, MAHARASHTRA',
    masterId: 15345,
  },
  {
    type: 'cityName',
    value: 'VELLATURU, ANDHRA PRADESH',
    masterId: 15834,
  },
  {
    type: 'cityName',
    value: 'RAMSIN, RAJASTHAN',
    masterId: 14639,
  },
  {
    type: 'cityName',
    value: 'MALEGAON, MAHARASHTRA',
    masterId: 13311,
  },
  {
    type: 'cityName',
    value: 'PALLAMKURU, ANDHRA PRADESH',
    masterId: 14162,
  },
  {
    type: 'cityName',
    value: 'RAGHUDEVAPURAM, ANDHRA PRADESH',
    masterId: 14540,
  },
  {
    type: 'cityName',
    value: 'ARARIA, BIHAR',
    masterId: 10238,
  },
  {
    type: 'cityName',
    value: 'TALLADA, TELANGANA',
    masterId: 15412,
  },
  {
    type: 'cityName',
    value: 'BHANGARH, RAJASTHAN',
    masterId: 10696,
  },
  {
    type: 'cityName',
    value: 'PARAMANKURICHI, TAMIL NADU',
    masterId: 14233,
  },
  {
    type: 'cityName',
    value: 'POTHENCODE, KERALA',
    masterId: 14459,
  },
  {
    type: 'cityName',
    value: 'PINDWARA, RAJASTHAN',
    masterId: 14406,
  },
  {
    type: 'cityName',
    value: 'THIMMARAJU PALEM, ANDHRA PRADESH',
    masterId: 15508,
  },
  {
    type: 'cityName',
    value: 'SHIVAKODU, ANDHRA PRADESH',
    masterId: 15106,
  },
  {
    type: 'cityName',
    value: 'VEERAKERALAMPUDUR, TAMIL NADU',
    masterId: 15818,
  },
  {
    type: 'cityName',
    value: 'MANGRULPIR, MAHARASHTRA',
    masterId: 13426,
  },
  {
    type: 'cityName',
    value: 'PAHALGAM PACKAGE, JAMMU AND KASHMIR',
    masterId: 14126,
  },
  {
    type: 'cityName',
    value: 'BIDADA, GUJARAT',
    masterId: 10798,
  },
  {
    type: 'cityName',
    value: 'KALLA, ANDHRA PRADESH',
    masterId: 12403,
  },
  {
    type: 'cityName',
    value: 'PERINJANAM, KERALA',
    masterId: 14364,
  },
  {
    type: 'cityName',
    value: 'CHENTHRAPINI, KERALA',
    masterId: 11039,
  },
  {
    type: 'cityName',
    value: 'PUTALIYA(DADMA), GUJARAT',
    masterId: 14521,
  },
  {
    type: 'cityName',
    value: 'BADOLI, GUJARAT',
    masterId: 10355,
  },
  {
    type: 'cityName',
    value: 'VADA, MAHARASHTRA',
    masterId: 15722,
  },
  {
    type: 'cityName',
    value: 'KOTHAPETA, ANDHRA PRADESH',
    masterId: 12916,
  },
  {
    type: 'cityName',
    value: 'JASOL, RAJASTHAN',
    masterId: 12206,
  },
  {
    type: 'cityName',
    value: 'KAMANAYAKKANPATTI, TAMIL NADU',
    masterId: 12441,
  },
  {
    type: 'cityName',
    value: 'AJANTA, MAHARASHTRA',
    masterId: 10066,
  },
  {
    type: 'cityName',
    value: 'KODUVALLY, KERALA',
    masterId: 12825,
  },
  {
    type: 'cityName',
    value: 'ANATHAVARAM, ANDHRA PRADESH',
    masterId: 10191,
  },
  {
    type: 'cityName',
    value: 'CHILAMKUR, ANDHRA PRADESH',
    masterId: 11088,
  },
  {
    type: 'cityName',
    value: 'BANAHATTI, KARNATAKA',
    masterId: 10457,
  },
  {
    type: 'cityName',
    value: 'BHUVA, GUJARAT',
    masterId: 10792,
  },
  {
    type: 'cityName',
    value: 'KUCHWADA, MADHYA PRADESH',
    masterId: 12969,
  },
  {
    type: 'cityName',
    value: 'METPALLY, TELANGANA',
    masterId: 13576,
  },
  {
    type: 'cityName',
    value: 'KOTHARA, GUJARAT',
    masterId: 12917,
  },
  {
    type: 'cityName',
    value: 'AMBAJOGAI, MAHARASHTRA',
    masterId: 10141,
  },
  {
    type: 'cityName',
    value: 'ALANG, GUJARAT',
    masterId: 10091,
  },
  {
    type: 'cityName',
    value: 'ASIND, RAJASTHAN',
    masterId: 10274,
  },
  {
    type: 'cityName',
    value: 'KOLLIPARA, ANDHRA PRADESH',
    masterId: 12851,
  },
  {
    type: 'cityName',
    value: 'KUTHAR, HIMACHAL PRADESH',
    masterId: 13059,
  },
  {
    type: 'cityName',
    value: 'BADHADA, MADHYA PRADESH',
    masterId: 10342,
  },
  {
    type: 'cityName',
    value: 'PHIDING, ASSAM',
    masterId: 18870,
  },
  {
    type: 'cityName',
    value: 'UMBRAJ, MAHARASHTRA',
    masterId: 15671,
  },
  {
    type: 'cityName',
    value: 'RANAKANDOLA, GUJARAT',
    masterId: 14642,
  },
  {
    type: 'cityName',
    value: 'PATHANAPURAM, KERALA',
    masterId: 14286,
  },
  {
    type: 'cityName',
    value: 'MAMIDIKUDUDRU, ANDHRA PRADESH',
    masterId: 13348,
  },
  {
    type: 'cityName',
    value: 'MUDALUR, TAMIL NADU',
    masterId: 13672,
  },
  {
    type: 'cityName',
    value: 'MANGOD, MADHYA PRADESH',
    masterId: 13422,
  },
  {
    type: 'cityName',
    value: 'KHANDELA, RAJASTHAN',
    masterId: 12709,
  },
  {
    type: 'cityName',
    value: 'SHAPAR, GUJARAT',
    masterId: 15067,
  },
  {
    type: 'cityName',
    value: 'TORREDU, ANDHRA PRADESH',
    masterId: 15602,
  },
  {
    type: 'cityName',
    value: 'RAMDHARI, GUJARAT',
    masterId: 14617,
  },
  {
    type: 'cityName',
    value: 'KADUTHURUTHY, KERALA',
    masterId: 12336,
  },
  {
    type: 'cityName',
    value: 'BAYAD, GUJARAT',
    masterId: 10596,
  },
  {
    type: 'cityName',
    value: 'ILKAL, KARNATAKA',
    masterId: 12063,
  },
  {
    type: 'cityName',
    value: 'GOVADA, ANDHRA PRADESH',
    masterId: 11790,
  },
  {
    type: 'cityName',
    value: 'DEVARPALLI, ANDHRA PRADESH',
    masterId: 11315,
  },
  {
    type: 'cityName',
    value: 'SHANKARAGHATTA, KARNATAKA',
    masterId: 15062,
  },
  {
    type: 'cityName',
    value: 'GURUVAYANKERE, KARNATAKA',
    masterId: 11871,
  },
  {
    type: 'cityName',
    value: 'PANNANKULAM, TAMIL NADU',
    masterId: 14216,
  },
  {
    type: 'cityName',
    value: 'KUDUREMUKHA, KARNATAKA',
    masterId: 12979,
  },
  {
    type: 'cityName',
    value: 'ALMATTI, KARNATAKA',
    masterId: 10114,
  },
  {
    type: 'cityName',
    value: 'HATHKHAMBA, MAHARASHTRA',
    masterId: 11964,
  },
  {
    type: 'cityName',
    value: 'GOJARIYA, GUJARAT',
    masterId: 11740,
  },
  {
    type: 'cityName',
    value: 'PADUKONE, KARNATAKA',
    masterId: 14121,
  },
  {
    type: 'cityName',
    value: 'KERUR, KARNATAKA',
    masterId: 12657,
  },
  {
    type: 'cityName',
    value: 'JINNURU, ANDHRA PRADESH',
    masterId: 12266,
  },
  {
    type: 'cityName',
    value: 'JAIRAM VERMA NAGAR, UTTAR PRADESH',
    masterId: 12128,
  },
  {
    type: 'cityName',
    value: 'NANDALURU, ANDHRA PRADESH',
    masterId: 13856,
  },
  {
    type: 'cityName',
    value: 'NAGORE, MAHARASHTRA',
    masterId: 13810,
  },
  {
    type: 'cityName',
    value: 'PANCHTALAVADA, GUJARAT',
    masterId: 14193,
  },
  {
    type: 'cityName',
    value: 'KALAVAD, GUJARAT',
    masterId: 12383,
  },
  {
    type: 'cityName',
    value: 'NATTA RAMESWARAM, ANDHRA PRADESH',
    masterId: 13916,
  },
  {
    type: 'cityName',
    value: 'HATTI, KARNATAKA',
    masterId: 11971,
  },
  {
    type: 'cityName',
    value: 'AMARESHWAR, GUJARAT',
    masterId: 10128,
  },
  {
    type: 'cityName',
    value: 'NALEGAON, MAHARASHTRA',
    masterId: 13837,
  },
  {
    type: 'cityName',
    value: 'BHILADA, GUJARAT',
    masterId: 10740,
  },
  {
    type: 'cityName',
    value: 'SRISAILAM, ANDHRA PRADESH',
    masterId: 15300,
  },
  {
    type: 'cityName',
    value: 'AINAPUR, KARNATAKA',
    masterId: 10061,
  },
  {
    type: 'cityName',
    value: 'BRIJGHAT, UTTAR PRADESH',
    masterId: 10910,
  },
  {
    type: 'cityName',
    value: 'KUNNAMANGALAM, KERALA',
    masterId: 13027,
  },
  {
    type: 'cityName',
    value: 'KANGANANKULAM, TAMIL NADU',
    masterId: 12481,
  },
  {
    type: 'cityName',
    value: 'SRIRAM NAGAR, ANDHRA PRADESH',
    masterId: 15296,
  },
  {
    type: 'cityName',
    value: 'DHARAPURAM, TAMIL NADU',
    masterId: 11362,
  },
  {
    type: 'cityName',
    value: 'KOKKANTI, ANDHRA PRADESH',
    masterId: 12831,
  },
  {
    type: 'cityName',
    value: 'REVENDRAPADU, ANDHRA PRADESH',
    masterId: 14734,
  },
  {
    type: 'cityName',
    value: 'KADA, GUJARAT',
    masterId: 12311,
  },
  {
    type: 'cityName',
    value: 'MADANGERI, KARNATAKA',
    masterId: 13196,
  },
  {
    type: 'cityName',
    value: 'BHADKHA, RAJASTHAN',
    masterId: 10663,
  },
  {
    type: 'cityName',
    value: 'VENOOR, KARNATAKA',
    masterId: 15853,
  },
  {
    type: 'cityName',
    value: 'NAKKAPALLI, ANDHRA PRADESH',
    masterId: 13832,
  },
  {
    type: 'cityName',
    value: 'KHAKHBAI, GUJARAT',
    masterId: 12691,
  },
  {
    type: 'cityName',
    value: 'KEER KI CHOWKI, RAJASTHAN',
    masterId: 12640,
  },
  {
    type: 'cityName',
    value: 'AALAMURU, ANDHRA PRADESH',
    masterId: 10005,
  },
  {
    type: 'cityName',
    value: 'PALLADAM, TAMIL NADU',
    masterId: 14161,
  },
  {
    type: 'cityName',
    value: 'THURIMELLA, ANDHRA PRADESH',
    masterId: 15547,
  },
  {
    type: 'cityName',
    value: 'NER, MAHARASHTRA',
    masterId: 13970,
  },
  {
    type: 'cityName',
    value: 'KINATHUKADAVU, TAMIL NADU',
    masterId: 12786,
  },
  {
    type: 'cityName',
    value: 'KANJI, TAMIL NADU',
    masterId: 12493,
  },
  {
    type: 'cityName',
    value: 'BEHROR, RAJASTHAN',
    masterId: 10610,
  },
  {
    type: 'cityName',
    value: 'DARYAPUR, MAHARASHTRA',
    masterId: 11243,
  },
  {
    type: 'cityName',
    value: 'KARAPA, ANDHRA PRADESH',
    masterId: 12539,
  },
  {
    type: 'cityName',
    value: 'SURYAPET, TELANGANA',
    masterId: 15367,
  },
  {
    type: 'cityName',
    value: 'PANVEL, MAHARASHTRA',
    masterId: 14223,
  },
  {
    type: 'cityName',
    value: 'NEDIYIRUPPU, KERALA',
    masterId: 13953,
  },
  {
    type: 'cityName',
    value: 'KHEDBRAHMA, GUJARAT',
    masterId: 12741,
  },
  {
    type: 'cityName',
    value: 'POSANA, RAJASTHAN',
    masterId: 14456,
  },
  {
    type: 'cityName',
    value: 'INKOLLU, ANDHRA PRADESH',
    masterId: 12076,
  },
  {
    type: 'cityName',
    value: 'MALAPPURAM, KERALA',
    masterId: 13306,
  },
  {
    type: 'cityName',
    value: 'MUKHANI, UTTARAKHAND',
    masterId: 13693,
  },
  {
    type: 'cityName',
    value: 'ANAKKARA, KERALA',
    masterId: 10182,
  },
  {
    type: 'cityName',
    value: 'SIMHADRIPURAM, ANDHRA PRADESH',
    masterId: 15173,
  },
  {
    type: 'cityName',
    value: 'DUDHALA, GUJARAT',
    masterId: 11474,
  },
  {
    type: 'cityName',
    value: 'MUDETI, GUJARAT',
    masterId: 13677,
  },
  {
    type: 'cityName',
    value: 'KUTHUPARAMBA, KERALA',
    masterId: 13061,
  },
  {
    type: 'cityName',
    value: 'PARIPPALLY, KERALA',
    masterId: 14251,
  },
  {
    type: 'cityName',
    value: 'KALYANPURA, GUJARAT',
    masterId: 12435,
  },
  {
    type: 'cityName',
    value: 'KUTTIYADI, KERALA',
    masterId: 13066,
  },
  {
    type: 'cityName',
    value: 'RANGAMPETA, ANDHRA PRADESH',
    masterId: 14650,
  },
  {
    type: 'cityName',
    value: 'PATTUKKOTTAI, TAMIL NADU',
    masterId: 14314,
  },
  {
    type: 'cityName',
    value: 'KHAKHAR, UTTAR PRADESH',
    masterId: 12689,
  },
  {
    type: 'cityName',
    value: 'KEELAKARAI, TAMIL NADU',
    masterId: 12638,
  },
  {
    type: 'cityName',
    value: 'KHETRI, RAJASTHAN',
    masterId: 12752,
  },
  {
    type: 'cityName',
    value: 'KURUGODU, KARNATAKA',
    masterId: 13046,
  },
  {
    type: 'cityName',
    value: 'YERRAGUNTAPALLY, ANDHRA PRADESH',
    masterId: 15997,
  },
  {
    type: 'cityName',
    value: 'NAKIREKAL, TELANGANA',
    masterId: 13830,
  },
  {
    type: 'cityName',
    value: 'KULLU, HIMACHAL PRADESH',
    masterId: 12994,
  },
  {
    type: 'cityName',
    value: 'YELBURGA, KARNATAKA',
    masterId: 15983,
  },
  {
    type: 'cityName',
    value: 'ATKURU, ANDHRA PRADESH',
    masterId: 10294,
  },
  {
    type: 'cityName',
    value: 'DAPOLI, MAHARASHTRA',
    masterId: 11230,
  },
  {
    type: 'cityName',
    value: 'MUNDAKAYAM, KERALA',
    masterId: 13716,
  },
  {
    type: 'cityName',
    value: 'KURUKKAL PATTI, TAMIL NADU',
    masterId: 13047,
  },
  {
    type: 'cityName',
    value: 'NIDAMOLU, ANDHRA PRADESH',
    masterId: 13994,
  },
  {
    type: 'cityName',
    value: 'JAM, TELANGANA',
    masterId: 12163,
  },
  {
    type: 'cityName',
    value: 'GHATI, HIMACHAL PRADESH',
    masterId: 11695,
  },
  {
    type: 'cityName',
    value: 'DAVANAGERE, KARNATAKA',
    masterId: 11258,
  },
  {
    type: 'cityName',
    value: 'SAMAYAPURAM, TAMIL NADU',
    masterId: 14871,
  },
  {
    type: 'cityName',
    value: 'SABLA, RAJASTHAN',
    masterId: 14783,
  },
  {
    type: 'cityName',
    value: 'VELUR, TAMIL NADU',
    masterId: 15838,
  },
  {
    type: 'cityName',
    value: 'KHAREDA, GUJARAT',
    masterId: 12720,
  },
  {
    type: 'cityName',
    value: 'BHIM, RAJASTHAN',
    masterId: 10745,
  },
  {
    type: 'cityName',
    value: 'DARSI, ANDHRA PRADESH',
    masterId: 11240,
  },
  {
    type: 'cityName',
    value: 'GONIKOPPAL, KARNATAKA',
    masterId: 11763,
  },
  {
    type: 'cityName',
    value: 'WAI, MAHARASHTRA',
    masterId: 15930,
  },
  {
    type: 'cityName',
    value: 'SATUDAD, GUJARAT',
    masterId: 14979,
  },
  {
    type: 'cityName',
    value: 'VISHALA-PATHEDI MARG, RAJASTHAN',
    masterId: 15904,
  },
  {
    type: 'cityName',
    value: 'PALVANCHA, TELANGANA',
    masterId: 14173,
  },
  {
    type: 'cityName',
    value: 'SAGAR, MADHYA PRADESH',
    masterId: 14798,
  },
  {
    type: 'cityName',
    value: 'VELICHERU, ANDHRA PRADESH',
    masterId: 15831,
  },
  {
    type: 'cityName',
    value: 'MUNDRA, GUJARAT',
    masterId: 13724,
  },
  {
    type: 'cityName',
    value: 'CHOKI, GUJARAT',
    masterId: 11144,
  },
  {
    type: 'cityName',
    value: 'MUDARANGADI, KARNATAKA',
    masterId: 13673,
  },
  {
    type: 'cityName',
    value: 'KALABURAGI, KARNATAKA',
    masterId: 12366,
  },
  {
    type: 'cityName',
    value: 'DEORI, CHHATTISGARH',
    masterId: 11287,
  },
  {
    type: 'cityName',
    value: 'V.KOTA, ANDHRA PRADESH',
    masterId: 15720,
  },
  {
    type: 'cityName',
    value: 'VIVEKANANDA NAGAR, MAHARASHTRA',
    masterId: 17962,
  },
  {
    type: 'cityName',
    value: 'BANDARULANKA, ANDHRA PRADESH',
    masterId: 10469,
  },
  {
    type: 'cityName',
    value: 'KULAPPULLY, KERALA',
    masterId: 12987,
  },
  {
    type: 'cityName',
    value: 'CHINCHINAADA, ANDHRA PRADESH',
    masterId: 11101,
  },
  {
    type: 'cityName',
    value: 'LOHA, MAHARASHTRA',
    masterId: 13151,
  },
  {
    type: 'cityName',
    value: 'PUDUCHERRY, PUDUCHERRY',
    masterId: 14472,
  },
  {
    type: 'cityName',
    value: 'PANDHARKAWADA, MAHARASHTRA',
    masterId: 14199,
  },
  {
    type: 'cityName',
    value: 'PERAVURANI, TAMIL NADU',
    masterId: 14360,
  },
  {
    type: 'cityName',
    value: 'GULAR, RAJASTHAN',
    masterId: 11821,
  },
  {
    type: 'cityName',
    value: 'KOTTHURU, ANDHRA PRADESH',
    masterId: 12937,
  },
  {
    type: 'cityName',
    value: 'DEAULGAON RAJA, MAHARASHTRA',
    masterId: 11263,
  },
  {
    type: 'cityName',
    value: 'CHETTIYAPATHU, TAMIL NADU',
    masterId: 11050,
  },
  {
    type: 'cityName',
    value: 'CHERUTHURUTHY, KERALA',
    masterId: 11048,
  },
  {
    type: 'cityName',
    value: 'PATHIRIPALA KONGAD RD, KERALA',
    masterId: 14293,
  },
  {
    type: 'cityName',
    value: 'GUNDU GOLANU, ANDHRA PRADESH',
    masterId: 11844,
  },
  {
    type: 'cityName',
    value: 'ADYAR, KARNATAKA',
    masterId: 10040,
  },
  {
    type: 'cityName',
    value: 'KAHURKHEDE, MAHARASHTRA',
    masterId: 12343,
  },
  {
    type: 'cityName',
    value: 'KAZHAKOOTTAM, KERALA',
    masterId: 12633,
  },
  {
    type: 'cityName',
    value: 'LAM, ANDHRA PRADESH',
    masterId: 13106,
  },
  {
    type: 'cityName',
    value: 'HEMMADI, KARNATAKA',
    masterId: 11980,
  },
  {
    type: 'cityName',
    value: 'MALANKA, GUJARAT',
    masterId: 13303,
  },
  {
    type: 'cityName',
    value: 'NALIYA, GUJARAT',
    masterId: 13841,
  },
  {
    type: 'cityName',
    value: 'KALLIANPUR, KARNATAKA',
    masterId: 12415,
  },
  {
    type: 'cityName',
    value: 'SRIPERUMBUDUR, TAMIL NADU',
    masterId: 15295,
  },
  {
    type: 'cityName',
    value: 'YEDULAPALLI, TELANGANA',
    masterId: 15982,
  },
  {
    type: 'cityName',
    value: 'RAMJI KA GOL, RAJASTHAN',
    masterId: 14624,
  },
  {
    type: 'cityName',
    value: 'CHICHOLA, CHHATTISGARH',
    masterId: 11072,
  },
  {
    type: 'cityName',
    value: 'DEVLA, GUJARAT',
    masterId: 11320,
  },
  {
    type: 'cityName',
    value: 'PALA, KERALA',
    masterId: 14135,
  },
  {
    type: 'cityName',
    value: 'UBALANKA, ANDHRA PRADESH',
    masterId: 15632,
  },
  {
    type: 'cityName',
    value: 'PONKUNNAM, KERALA',
    masterId: 14449,
  },
  {
    type: 'cityName',
    value: 'VANI GAAM, GUJARAT',
    masterId: 15773,
  },
  {
    type: 'cityName',
    value: 'JEEVANA, UTTAR PRADESH',
    masterId: 12227,
  },
  {
    type: 'cityName',
    value: 'JOJAWAR, RAJASTHAN',
    masterId: 12280,
  },
  {
    type: 'cityName',
    value: 'MATTANNUR, KERALA',
    masterId: 13519,
  },
  {
    type: 'cityName',
    value: 'GULLAPUR, KARNATAKA',
    masterId: 11826,
  },
  {
    type: 'cityName',
    value: 'SINDAGI, KARNATAKA',
    masterId: 15179,
  },
  {
    type: 'cityName',
    value: 'VELLAKULAM, TAMIL NADU',
    masterId: 15832,
  },
  {
    type: 'cityName',
    value: 'GOPICHETTIPALAYAM, TAMIL NADU',
    masterId: 11769,
  },
  {
    type: 'cityName',
    value: 'KALUNEERKULAM, TAMIL NADU',
    masterId: 12429,
  },
  {
    type: 'cityName',
    value: 'PALGHAR, MAHARASHTRA',
    masterId: 14155,
  },
  {
    type: 'cityName',
    value: 'KANDAVALLI, KARNATAKA',
    masterId: 12474,
  },
  {
    type: 'cityName',
    value: 'MEDIKONDURU, ANDHRA PRADESH',
    masterId: 13547,
  },
  {
    type: 'cityName',
    value: 'ISLAND, GUJARAT',
    masterId: 19065,
  },
  {
    type: 'cityName',
    value: 'SATYANARAYANA PURAM, ANDHRA PRADESH',
    masterId: 14982,
  },
  {
    type: 'cityName',
    value: 'SALAYA, GUJARAT',
    masterId: 14842,
  },
  {
    type: 'cityName',
    value: 'SINDKHEDRAJA, MAHARASHTRA',
    masterId: 15188,
  },
  {
    type: 'cityName',
    value: 'SINGANUR, TAMIL NADU',
    masterId: 15191,
  },
  {
    type: 'cityName',
    value: 'MUDIGERE, KARNATAKA',
    masterId: 13680,
  },
  {
    type: 'cityName',
    value: 'MANGELI, MADHYA PRADESH',
    masterId: 13420,
  },
  {
    type: 'cityName',
    value: 'MATA NO MADH, GUJARAT',
    masterId: 13508,
  },
  {
    type: 'cityName',
    value: 'THIRUVADANAI, TAMIL NADU',
    masterId: 15522,
  },
  {
    type: 'cityName',
    value: 'JAMKHED, MAHARASHTRA',
    masterId: 12175,
  },
  {
    type: 'cityName',
    value: 'GOMTI KA CHAURAHA, RAJASTHAN',
    masterId: 11759,
  },
  {
    type: 'cityName',
    value: 'JARIKATTE, KARNATAKA',
    masterId: 12201,
  },
  {
    type: 'cityName',
    value: 'AYODHYA, UTTAR PRADESH',
    masterId: 10321,
  },
  {
    type: 'cityName',
    value: 'IDAGUNJI, KARNATAKA',
    masterId: 12056,
  },
  {
    type: 'cityName',
    value: 'VUTCHILI, ANDHRA PRADESH',
    masterId: 15916,
  },
  {
    type: 'cityName',
    value: 'TRASI, KARNATAKA',
    masterId: 15605,
  },
  {
    type: 'cityName',
    value: 'PITHAMPUR, MADHYA PRADESH',
    masterId: 14430,
  },
  {
    type: 'cityName',
    value: 'MURICKASSERY, KERALA',
    masterId: 13747,
  },
  {
    type: 'cityName',
    value: 'VAMANAPURAM, KERALA',
    masterId: 15763,
  },
  {
    type: 'cityName',
    value: 'AVIDI, ANDHRA PRADESH',
    masterId: 10316,
  },
  {
    type: 'cityName',
    value: 'EDLAPADU, ANDHRA PRADESH',
    masterId: 11517,
  },
  {
    type: 'cityName',
    value: 'JATRODA, GUJARAT',
    masterId: 12213,
  },
  {
    type: 'cityName',
    value: 'KOTDI, GUJARAT',
    masterId: 12908,
  },
  {
    type: 'cityName',
    value: 'GOPIGANJ, UTTAR PRADESH',
    masterId: 11770,
  },
  {
    type: 'cityName',
    value: 'NARSANNAPETA, ANDHRA PRADESH',
    masterId: 13902,
  },
  {
    type: 'cityName',
    value: 'BOTLAGUDUR, ANDHRA PRADESH',
    masterId: 10901,
  },
  {
    type: 'cityName',
    value: 'KUTTIKKANAM, KERALA',
    masterId: 13064,
  },
  {
    type: 'cityName',
    value: 'ASHPUR, WEST BENGAL',
    masterId: 10269,
  },
  {
    type: 'cityName',
    value: 'LATHI, GUJARAT',
    masterId: 13124,
  },
  {
    type: 'cityName',
    value: 'REWATRA, RAJASTHAN',
    masterId: 14737,
  },
  {
    type: 'cityName',
    value: 'SHIVANA, MAHARASHTRA',
    masterId: 15108,
  },
  {
    type: 'cityName',
    value: 'VANNIKONENDAL, TAMIL NADU',
    masterId: 15779,
  },
  {
    type: 'cityName',
    value: 'CHANDRAI, RAJASTHAN',
    masterId: 10990,
  },
  {
    type: 'cityName',
    value: 'VIREGAON, MAHARASHTRA',
    masterId: 15895,
  },
  {
    type: 'cityName',
    value: 'AMET, RAJASTHAN',
    masterId: 10155,
  },
  {
    type: 'cityName',
    value: 'DHARAMSHALA, HIMACHAL PRADESH',
    masterId: 11359,
  },
  {
    type: 'cityName',
    value: 'MARAYOOR, KERALA',
    masterId: 13485,
  },
  {
    type: 'cityName',
    value: 'YAKUTPURA KCG, ANDHRA PRADESH',
    masterId: 15969,
  },
  {
    type: 'cityName',
    value: 'THANWALA, RAJASTHAN',
    masterId: 15500,
  },
  {
    type: 'cityName',
    value: 'MAHABALESHWAR, MAHARASHTRA',
    masterId: 13229,
  },
  {
    type: 'cityName',
    value: 'ANKOLVADI, GUJARAT',
    masterId: 10214,
  },
  {
    type: 'cityName',
    value: 'KALAKADA, ANDHRA PRADESH',
    masterId: 12369,
  },
  {
    type: 'cityName',
    value: 'AHMED NAGAR, MAHARASHTRA',
    masterId: 10054,
  },
  {
    type: 'cityName',
    value: 'GALIVEEDU, ANDHRA PRADESH',
    masterId: 11612,
  },
  {
    type: 'cityName',
    value: 'KAVANT, GUJARAT',
    masterId: 12618,
  },
  {
    type: 'cityName',
    value: 'UNADI, GUJARAT',
    masterId: 15681,
  },
  {
    type: 'cityName',
    value: 'TEJPURA, GUJARAT',
    masterId: 15462,
  },
  {
    type: 'cityName',
    value: 'AMBAJIPETA, ANDHRA PRADESH',
    masterId: 10140,
  },
  {
    type: 'cityName',
    value: 'VITHON, GUJARAT',
    masterId: 15911,
  },
  {
    type: 'cityName',
    value: 'VAZHAKULAM, KERALA',
    masterId: 15812,
  },
  {
    type: 'cityName',
    value: 'NIPANI, KARNATAKA',
    masterId: 14022,
  },
  {
    type: 'cityName',
    value: 'AMBA, WEST BENGAL',
    masterId: 10136,
  },
  {
    type: 'cityName',
    value: 'KOLLUR, KARNATAKA',
    masterId: 12852,
  },
  {
    type: 'cityName',
    value: 'MANDANGAD, MAHARASHTRA',
    masterId: 13377,
  },
  {
    type: 'cityName',
    value: 'DARWHA, MAHARASHTRA',
    masterId: 11242,
  },
  {
    type: 'cityName',
    value: 'KHOMBHDI NANI, GUJARAT',
    masterId: 12762,
  },
  {
    type: 'cityName',
    value: 'BHADROD, GUJARAT',
    masterId: 10671,
  },
  {
    type: 'cityName',
    value: 'SULTAN BATHERY, KERALA',
    masterId: 15327,
  },
  {
    type: 'cityName',
    value: 'MUTHUKULATHUR, TAMIL NADU',
    masterId: 13762,
  },
  {
    type: 'cityName',
    value: 'CHENNUR, ANDHRA PRADESH',
    masterId: 11038,
  },
  {
    type: 'cityName',
    value: 'BIJOLIA, RAJASTHAN',
    masterId: 10812,
  },
  {
    type: 'cityName',
    value: 'AMINGAD, KARNATAKA',
    masterId: 10161,
  },
  {
    type: 'cityName',
    value: 'KONANDOOR, KARNATAKA',
    masterId: 12865,
  },
  {
    type: 'cityName',
    value: 'BANSWARA, RAJASTHAN',
    masterId: 10491,
  },
  {
    type: 'cityName',
    value: 'UNAGATLA, ANDHRA PRADESH',
    masterId: 15682,
  },
  {
    type: 'cityName',
    value: 'DANTRA, RAJASTHAN',
    masterId: 17190,
  },
  {
    type: 'cityName',
    value: 'CHIMAKURTHY, ANDHRA PRADESH',
    masterId: 11099,
  },
  {
    type: 'cityName',
    value: 'DUTTALUR, ANDHRA PRADESH',
    masterId: 11501,
  },
  {
    type: 'cityName',
    value: 'MALEWAD, MAHARASHTRA',
    masterId: 13315,
  },
  {
    type: 'cityName',
    value: 'GIRGADHADA, GUJARAT',
    masterId: 11722,
  },
  {
    type: 'cityName',
    value: 'PERUNGALATHUR, TAMIL NADU',
    masterId: 14372,
  },
  {
    type: 'cityName',
    value: 'KUSHTAGI, KARNATAKA',
    masterId: 13052,
  },
  {
    type: 'cityName',
    value: 'PATHAPADU, ANDHRA PRADESH',
    masterId: 14288,
  },
  {
    type: 'cityName',
    value: 'WATTAR, MAHARASHTRA',
    masterId: 15954,
  },
  {
    type: 'cityName',
    value: 'HONNAVAR, KARNATAKA',
    masterId: 12021,
  },
  {
    type: 'cityName',
    value: 'TALEGAON DABHADE, MAHARASHTRA',
    masterId: 15405,
  },
  {
    type: 'cityName',
    value: 'DARAMLI, GUJARAT',
    masterId: 11233,
  },
  {
    type: 'cityName',
    value: 'ZERO PHATA-PURNA RD, MAHARASHTRA',
    masterId: 16008,
  },
  {
    type: 'cityName',
    value: 'PERLA, KERALA',
    masterId: 14368,
  },
  {
    type: 'cityName',
    value: 'SIDDHAPUR, MAHARASHTRA',
    masterId: 15143,
  },
  {
    type: 'cityName',
    value: 'COLACHEL, TAMIL NADU',
    masterId: 11163,
  },
  {
    type: 'cityName',
    value: 'TUNGABHADRA DAM, KARNATAKA',
    masterId: 15624,
  },
  {
    type: 'cityName',
    value: 'MUDRADY, KARNATAKA',
    masterId: 13684,
  },
  {
    type: 'cityName',
    value: 'PADAMATA PALEM, ANDHRA PRADESH',
    masterId: 14110,
  },
  {
    type: 'cityName',
    value: 'MUPPAVARAM, ANDHRA PRADESH',
    masterId: 13736,
  },
  {
    type: 'cityName',
    value: 'CHANDRASEKHARAPURAM, ANDHRA PRADESH',
    masterId: 10995,
  },
  {
    type: 'cityName',
    value: 'HAVTAD, GUJARAT',
    masterId: 11973,
  },
  {
    type: 'cityName',
    value: 'PRATHIPADU, ANDHRA PRADESH',
    masterId: 14470,
  },
  {
    type: 'cityName',
    value: 'DAYAPAR, GUJARAT',
    masterId: 11261,
  },
  {
    type: 'cityName',
    value: 'MUSSOORIE, UTTARAKHAND',
    masterId: 13759,
  },
  {
    type: 'cityName',
    value: 'LAXMESHWAR, KARNATAKA',
    masterId: 13130,
  },
  {
    type: 'cityName',
    value: 'PUTHUPPALLY, KERALA',
    masterId: 14525,
  },
  {
    type: 'cityName',
    value: 'BADLAPUR, MAHARASHTRA',
    masterId: 10348,
  },
  {
    type: 'cityName',
    value: 'AJARA, MAHARASHTRA',
    masterId: 10068,
  },
  {
    type: 'cityName',
    value: 'SADABAD, UTTAR PRADESH',
    masterId: 14786,
  },
  {
    type: 'cityName',
    value: 'MALAD, MAHARASHTRA',
    masterId: 13298,
  },
  {
    type: 'cityName',
    value: 'MASTHIKATTE, KARNATAKA',
    masterId: 13503,
  },
  {
    type: 'cityName',
    value: 'AMGURI SANG, ASSAM',
    masterId: 10160,
  },
  {
    type: 'cityName',
    value: 'WADWANI, MAHARASHTRA',
    masterId: 15929,
  },
  {
    type: 'cityName',
    value: 'KUMUDAVALLI, ANDHRA PRADESH',
    masterId: 13015,
  },
  {
    type: 'cityName',
    value: 'PERIYAKULAM, TAMIL NADU',
    masterId: 14366,
  },
  {
    type: 'cityName',
    value: 'GUDIMANGALAM, TAMIL NADU',
    masterId: 11806,
  },
  {
    type: 'cityName',
    value: 'MALLIAKARAI, TAMIL NADU',
    masterId: 13334,
  },
  {
    type: 'cityName',
    value: 'THIRUTHANI, TAMIL NADU',
    masterId: 15520,
  },
  {
    type: 'cityName',
    value: 'CHAGALAMARRI, ANDHRA PRADESH',
    masterId: 10947,
  },
  {
    type: 'cityName',
    value: 'GANGADA, ANDHRA PRADESH',
    masterId: 11626,
  },
  {
    type: 'cityName',
    value: 'JEELUGUMILLI, ANDHRA PRADESH',
    masterId: 12226,
  },
  {
    type: 'cityName',
    value: 'KOTHURU, ANDHRA PRADESH',
    masterId: 12922,
  },
  {
    type: 'cityName',
    value: 'GARIYADHAR, GUJARAT',
    masterId: 11661,
  },
  {
    type: 'cityName',
    value: 'KOHIMA, NAGALAND',
    masterId: 12826,
  },
  {
    type: 'cityName',
    value: 'PULIYANMALA, KERALA',
    masterId: 14487,
  },
  {
    type: 'cityName',
    value: 'HALIYAL, KARNATAKA',
    masterId: 11903,
  },
  {
    type: 'cityName',
    value: 'SRIRAMANAGARA, KARNATAKA',
    masterId: 15297,
  },
  {
    type: 'cityName',
    value: 'DEWARIYA, UTTAR PRADESH',
    masterId: 11324,
  },
  {
    type: 'cityName',
    value: 'MOUNT ABU, RAJASTHAN',
    masterId: 13669,
  },
  {
    type: 'cityName',
    value: 'PATHANAMTHITTA, KERALA',
    masterId: 14285,
  },
  {
    type: 'cityName',
    value: 'THALAVAIPURAM, TAMIL NADU',
    masterId: 15485,
  },
  {
    type: 'cityName',
    value: 'GUDAVALLI, ANDHRA PRADESH',
    masterId: 11802,
  },
  {
    type: 'cityName',
    value: 'SIRSALA, MAHARASHTRA',
    masterId: 15218,
  },
  {
    type: 'cityName',
    value: 'TALIKOTI, KARNATAKA',
    masterId: 15409,
  },
  {
    type: 'cityName',
    value: 'ALANGUDI, TAMIL NADU',
    masterId: 10092,
  },
  {
    type: 'cityName',
    value: 'NAMBURU, ANDHRA PRADESH',
    masterId: 13849,
  },
  {
    type: 'cityName',
    value: 'VUYYURU, ANDHRA PRADESH',
    masterId: 15917,
  },
  {
    type: 'cityName',
    value: 'LOOR, RAJASTHAN',
    masterId: 13166,
  },
  {
    type: 'cityName',
    value: 'RAMPAR, GUJARAT',
    masterId: 14631,
  },
  {
    type: 'cityName',
    value: 'JAKKARAM, ANDHRA PRADESH',
    masterId: 12148,
  },
  {
    type: 'cityName',
    value: 'AURAIYA, UTTAR PRADESH',
    masterId: 10309,
  },
  {
    type: 'cityName',
    value: 'BARHAN, MAHARASHTRA',
    masterId: 10530,
  },
  {
    type: 'cityName',
    value: 'KEKRI, RAJASTHAN',
    masterId: 12642,
  },
  {
    type: 'cityName',
    value: 'KODAIKANAL, TAMIL NADU',
    masterId: 12811,
  },
  {
    type: 'cityName',
    value: 'MOTA SURKA, GUJARAT',
    masterId: 13658,
  },
  {
    type: 'cityName',
    value: 'SABARIMALA, KERALA',
    masterId: 14780,
  },
  {
    type: 'cityName',
    value: 'KUCHAMAN CITY, RAJASTHAN',
    masterId: 12966,
  },
  {
    type: 'cityName',
    value: 'DEVADURGA, KARNATAKA',
    masterId: 11304,
  },
  {
    type: 'cityName',
    value: 'GOLLAPALEM, ANDHRA PRADESH',
    masterId: 11753,
  },
  {
    type: 'cityName',
    value: 'BEMETARA, CHHATTISGARH',
    masterId: 10635,
  },
  {
    type: 'cityName',
    value: 'RANASTHALAM, ANDHRA PRADESH',
    masterId: 14644,
  },
  {
    type: 'cityName',
    value: 'NH234, TAMIL NADU',
    masterId: 13990,
  },
  {
    type: 'cityName',
    value: 'PUDUKADAI, TAMIL NADU',
    masterId: 14474,
  },
  {
    type: 'cityName',
    value: 'CHHAPARA, MADHYA PRADESH',
    masterId: 11058,
  },
  {
    type: 'cityName',
    value: 'MUNIRABAD, KARNATAKA',
    masterId: 13730,
  },
  {
    type: 'cityName',
    value: 'MOONNUPEEDIKA, KERALA',
    masterId: 13634,
  },
  {
    type: 'cityName',
    value: 'S.K. VARMANAGAR, GUJARAT',
    masterId: 14777,
  },
  {
    type: 'cityName',
    value: 'JAWALA, MAHARASHTRA',
    masterId: 12220,
  },
  {
    type: 'cityName',
    value: 'ANANTHAPALLI, ANDHRA PRADESH',
    masterId: 10189,
  },
  {
    type: 'cityName',
    value: 'ERAMALLOOR, KERALA',
    masterId: 11534,
  },
  {
    type: 'cityName',
    value: 'SONARI, MAHARASHTRA',
    masterId: 15266,
  },
  {
    type: 'cityName',
    value: 'SAKEGAON, MAHARASHTRA',
    masterId: 14824,
  },
  {
    type: 'cityName',
    value: 'POKURU, ANDHRA PRADESH',
    masterId: 14441,
  },
  {
    type: 'cityName',
    value: 'LOLLA, ANDHRA PRADESH',
    masterId: 13158,
  },
  {
    type: 'cityName',
    value: 'BAJWAS, RAJASTHAN',
    masterId: 10407,
  },
  {
    type: 'cityName',
    value: 'MUSIRI, TAMIL NADU',
    masterId: 13757,
  },
  {
    type: 'cityName',
    value: 'AREEKODE, KERALA',
    masterId: 10243,
  },
  {
    type: 'cityName',
    value: 'SAIBRAKATTE RD, KARNATAKA',
    masterId: 14813,
  },
  {
    type: 'cityName',
    value: 'MOPIDEVI, ANDHRA PRADESH',
    masterId: 13636,
  },
  {
    type: 'cityName',
    value: 'VASAI, MAHARASHTRA',
    masterId: 15798,
  },
  {
    type: 'cityName',
    value: 'CHALLAPALLI, ANDHRA PRADESH',
    masterId: 10970,
  },
  {
    type: 'cityName',
    value: 'MARTURU, ANDHRA PRADESH',
    masterId: 13496,
  },
  {
    type: 'cityName',
    value: 'JONNADA, ANDHRA PRADESH',
    masterId: 12283,
  },
  {
    type: 'cityName',
    value: 'UPRAMAL, RAJASTHAN',
    masterId: 17053,
  },
  {
    type: 'cityName',
    value: 'TRISSNAPPILLY, KERALA',
    masterId: 15608,
  },
  {
    type: 'cityName',
    value: 'KOLERU, ANDHRA PRADESH',
    masterId: 12842,
  },
  {
    type: 'cityName',
    value: 'LUVARIYA, GUJARAT',
    masterId: 13183,
  },
  {
    type: 'cityName',
    value: 'VADDIPARRU, ANDHRA PRADESH',
    masterId: 15735,
  },
  {
    type: 'cityName',
    value: 'NUJADI, KARNATAKA',
    masterId: 14058,
  },
  {
    type: 'cityName',
    value: 'JAMPANI, ANDHRA PRADESH',
    masterId: 12180,
  },
  {
    type: 'cityName',
    value: 'HOSMAR, KARNATAKA',
    masterId: 12032,
  },
  {
    type: 'cityName',
    value: 'ACHANTA, ANDHRA PRADESH',
    masterId: 10016,
  },
  {
    type: 'cityName',
    value: 'DEOLI, MAHARASHTRA',
    masterId: 11284,
  },
  {
    type: 'cityName',
    value: 'MIMISAL, TAMIL NADU',
    masterId: 13587,
  },
  {
    type: 'cityName',
    value: 'BELAVADI, KARNATAKA',
    masterId: 10619,
  },
  {
    type: 'cityName',
    value: 'LUVARA, GUJARAT',
    masterId: 13182,
  },
  {
    type: 'cityName',
    value: 'GANAPAVARAM, ANDHRA PRADESH',
    masterId: 11617,
  },
  {
    type: 'cityName',
    value: 'GANDHAV, RAJASTHAN',
    masterId: 11619,
  },
  {
    type: 'cityName',
    value: 'KARAMCHEDU, ANDHRA PRADESH',
    masterId: 12532,
  },
  {
    type: 'cityName',
    value: 'BANSWADA, TELANGANA',
    masterId: 10490,
  },
  {
    type: 'cityName',
    value: 'DUVVA, ANDHRA PRADESH',
    masterId: 11503,
  },
  {
    type: 'cityName',
    value: 'MOTA CHARODIYA, GUJARAT',
    masterId: 13657,
  },
  {
    type: 'cityName',
    value: 'RAJA NAGARAM, ANDHRA PRADESH',
    masterId: 14566,
  },
  {
    type: 'cityName',
    value: 'LAPALIYA, GUJARAT',
    masterId: 13119,
  },
  {
    type: 'cityName',
    value: 'KANNAD, MAHARASHTRA',
    masterId: 12503,
  },
  {
    type: 'cityName',
    value: 'KALLAKURU, ANDHRA PRADESH',
    masterId: 12409,
  },
  {
    type: 'cityName',
    value: 'VELLUMBARUM, MAHARASHTRA',
    masterId: 15836,
  },
  {
    type: 'cityName',
    value: 'TARAPUR, MAHARASHTRA',
    masterId: 15443,
  },
  {
    type: 'cityName',
    value: 'MELANTHABETTU, KARNATAKA',
    masterId: 13564,
  },
  {
    type: 'cityName',
    value: 'MANWAL, JAMMU AND KASHMIR',
    masterId: 17315,
  },
  {
    type: 'cityName',
    value: 'AGUMBE, KARNATAKA',
    masterId: 10049,
  },
  {
    type: 'cityName',
    value: 'ALASAN, RAJASTHAN',
    masterId: 10098,
  },
  {
    type: 'cityName',
    value: 'SAMADHIYALA, GUJARAT',
    masterId: 14861,
  },
  {
    type: 'cityName',
    value: 'ARYANKAVU, KERALA',
    masterId: 10262,
  },
  {
    type: 'cityName',
    value: 'HATKHAMBA, MAHARASHTRA',
    masterId: 11968,
  },
  {
    type: 'cityName',
    value: 'JAGARLAMUDI, ANDHRA PRADESH',
    masterId: 12111,
  },
  {
    type: 'cityName',
    value: 'PANGALA, KARNATAKA',
    masterId: 14206,
  },
  {
    type: 'cityName',
    value: 'KAUSANI, UTTARAKHAND',
    masterId: 12614,
  },
  {
    type: 'cityName',
    value: 'GOKHARVALA MOTA, GUJARAT',
    masterId: 11745,
  },
  {
    type: 'cityName',
    value: 'SINNAR, MAHARASHTRA',
    masterId: 15200,
  },
  {
    type: 'cityName',
    value: 'RABKAVI BANHATTI, KARNATAKA',
    masterId: 14529,
  },
  {
    type: 'cityName',
    value: 'KALIDINDI, ANDHRA PRADESH',
    masterId: 12395,
  },
  {
    type: 'cityName',
    value: 'PERIYAPATNA, KARNATAKA',
    masterId: 14367,
  },
  {
    type: 'cityName',
    value: 'SONKHED, MAHARASHTRA',
    masterId: 15278,
  },
  {
    type: 'cityName',
    value: 'SHELAPUR, KARNATAKA',
    masterId: 15074,
  },
  {
    type: 'cityName',
    value: 'DEVIPATTINAM, TAMIL NADU',
    masterId: 11319,
  },
  {
    type: 'cityName',
    value: 'VADNAGAR, GUJARAT',
    masterId: 15739,
  },
  {
    type: 'cityName',
    value: 'PANDHRO, GUJARAT',
    masterId: 14201,
  },
  {
    type: 'cityName',
    value: 'PAMBA, KERALA',
    masterId: 14177,
  },
  {
    type: 'cityName',
    value: 'SILLOD, MAHARASHTRA',
    masterId: 15168,
  },
  {
    type: 'cityName',
    value: 'RAJASTHAN, RAJASTHAN',
    masterId: 14578,
  },
  {
    type: 'cityName',
    value: 'KHAMBADAKONE, KARNATAKA',
    masterId: 12698,
  },
  {
    type: 'cityName',
    value: 'SANTHU, RAJASTHAN',
    masterId: 14921,
  },
  {
    type: 'cityName',
    value: 'HORNADU, KARNATAKA',
    masterId: 12024,
  },
  {
    type: 'cityName',
    value: 'KUDAVALI, MAHARASHTRA',
    masterId: 12972,
  },
  {
    type: 'cityName',
    value: 'NANDIKUR, KARNATAKA',
    masterId: 13861,
  },
  {
    type: 'cityName',
    value: 'KAYANKULAM, TAMIL NADU',
    masterId: 12629,
  },
  {
    type: 'cityName',
    value: 'KINGAON, MAHARASHTRA',
    masterId: 12787,
  },
  {
    type: 'cityName',
    value: 'THADACH, GUJARAT',
    masterId: 15479,
  },
  {
    type: 'cityName',
    value: 'SAMAGOGA, GUJARAT',
    masterId: 14862,
  },
  {
    type: 'cityName',
    value: 'KOLLAMKODE, TAMIL NADU',
    masterId: 12850,
  },
  {
    type: 'cityName',
    value: 'DHANLA, RAJASTHAN',
    masterId: 11350,
  },
  {
    type: 'cityName',
    value: 'DUDU, RAJASTHAN',
    masterId: 11476,
  },
  {
    type: 'cityName',
    value: 'MADURANTHAKAM, TAMIL NADU',
    masterId: 13218,
  },
  {
    type: 'cityName',
    value: 'PEERMADE, KERALA',
    masterId: 14342,
  },
  {
    type: 'cityName',
    value: 'KORHA, BIHAR',
    masterId: 12887,
  },
  {
    type: 'cityName',
    value: 'SHENKOTTAI, TAMIL NADU',
    masterId: 15078,
  },
  {
    type: 'cityName',
    value: 'DHUMA, MADHYA PRADESH',
    masterId: 11413,
  },
  {
    type: 'cityName',
    value: 'KADRA, KARNATAKA',
    masterId: 12334,
  },
  {
    type: 'cityName',
    value: 'HOSABETTU, KARNATAKA',
    masterId: 12025,
  },
  {
    type: 'cityName',
    value: 'KRISHNARAJPETE, KARNATAKA',
    masterId: 12960,
  },
  {
    type: 'cityName',
    value: 'YARAGATTI, KARNATAKA',
    masterId: 15977,
  },
  {
    type: 'cityName',
    value: 'VIJAPADI, GUJARAT',
    masterId: 15868,
  },
  {
    type: 'cityName',
    value: 'MUTTAGI, KARNATAKA',
    masterId: 13764,
  },
  {
    type: 'cityName',
    value: 'CHOPDA, MAHARASHTRA',
    masterId: 11148,
  },
  {
    type: 'cityName',
    value: 'MUNNAR, KERALA',
    masterId: 13731,
  },
  {
    type: 'cityName',
    value: 'CHETTUVA, KERALA',
    masterId: 11051,
  },
  {
    type: 'cityName',
    value: 'HADALA, GUJARAT',
    masterId: 11880,
  },
  {
    type: 'cityName',
    value: 'BAMNOD, MAHARASHTRA',
    masterId: 10452,
  },
  {
    type: 'cityName',
    value: 'KOOTHATTUKULAM, KERALA',
    masterId: 12874,
  },
  {
    type: 'cityName',
    value: 'BHANKHEDE PR. EDLABAD, MAHARASHTRA',
    masterId: 10697,
  },
  {
    type: 'cityName',
    value: 'MAJRI KHADAN, MAHARASHTRA ',
    masterId: 17624,
  },
  {
    type: 'cityName',
    value: 'VANSADA, GUJARAT',
    masterId: 15780,
  },
  {
    type: 'cityName',
    value: 'VISSANNAPETAA, ANDHRA PRADESH',
    masterId: 15908,
  },
  {
    type: 'cityName',
    value: 'KHAMBHADA, GUJARAT',
    masterId: 12700,
  },
  {
    type: 'cityName',
    value: 'MALLAIAH PETA, ANDHRA PRADESH',
    masterId: 13328,
  },
  {
    type: 'cityName',
    value: 'KANKOT MOTA, GUJARAT',
    masterId: 12501,
  },
  {
    type: 'cityName',
    value: 'KALLAM, MAHARASHTRA',
    masterId: 12411,
  },
  {
    type: 'cityName',
    value: 'SIRUMUGAI, TAMIL NADU',
    masterId: 15221,
  },
  {
    type: 'cityName',
    value: 'VADANAPPALLY, KERALA',
    masterId: 15731,
  },
  {
    type: 'cityName',
    value: 'TASGAON, MAHARASHTRA',
    masterId: 15453,
  },
  {
    type: 'cityName',
    value: 'MORAMPUDI, ANDHRA PRADESH',
    masterId: 13639,
  },
  {
    type: 'cityName',
    value: 'KARALAPALEM, ANDHRA PRADESH',
    masterId: 12530,
  },
  {
    type: 'cityName',
    value: 'NOWDURU, ANDHRA PRADESH',
    masterId: 14054,
  },
  {
    type: 'cityName',
    value: 'NARANPAR, GUJARAT',
    masterId: 13883,
  },
  {
    type: 'cityName',
    value: 'PEDHA BHEEMAVARAM, ANDHRA PRADESH',
    masterId: 14339,
  },
  {
    type: 'cityName',
    value: 'RAMDURG, KARNATAKA',
    masterId: 14618,
  },
  {
    type: 'cityName',
    value: 'PENDLIMARRI, ANDHRA PRADESH',
    masterId: 14349,
  },
  {
    type: 'cityName',
    value: 'POTHAKALANVILAI, TAMIL NADU',
    masterId: 14457,
  },
  {
    type: 'cityName',
    value: 'PHULPARAS, BIHAR',
    masterId: 14390,
  },
  {
    type: 'cityName',
    value: 'KUDAL, MAHARASHTRA',
    masterId: 12970,
  },
  {
    type: 'cityName',
    value: 'BRAHMANA CHERUVU, ANDHRA PRADESH',
    masterId: 10903,
  },
  {
    type: 'cityName',
    value: 'KARUKACHAL, KERALA',
    masterId: 12569,
  },
  {
    type: 'cityName',
    value: 'KHAWASA, MADHYA PRADESH',
    masterId: 12739,
  },
  {
    type: 'cityName',
    value: 'VANTHLI, GUJARAT',
    masterId: 15782,
  },
  {
    type: 'cityName',
    value: 'GERUSOPPA, KARNATAKA',
    masterId: 11684,
  },
  {
    type: 'cityName',
    value: 'VEPPANKADU, TAMIL NADU',
    masterId: 15855,
  },
  {
    type: 'cityName',
    value: 'BHORINGDA, GUJARAT',
    masterId: 10775,
  },
  {
    type: 'cityName',
    value: 'BHAKRI, RAJASTHAN',
    masterId: 10684,
  },
  {
    type: 'cityName',
    value: 'SAYALGUDI, TAMIL NADU',
    masterId: 15000,
  },
  {
    type: 'cityName',
    value: 'NUTHALAPADU, ANDHRA PRADESH',
    masterId: 14063,
  },
  {
    type: 'cityName',
    value: 'SHIRODA, MAHARASHTRA',
    masterId: 15095,
  },
  {
    type: 'cityName',
    value: 'DWARAKA TIRUMALA, ANDHRA PRADESH',
    masterId: 11506,
  },
  {
    type: 'cityName',
    value: 'CHERANMAHADEVI, TAMIL NADU',
    masterId: 11040,
  },
  {
    type: 'cityName',
    value: 'HALOL, GUJARAT',
    masterId: 11905,
  },
  {
    type: 'cityName',
    value: 'KULASEKARAPATTINAM, TAMIL NADU',
    masterId: 12988,
  },
  {
    type: 'cityName',
    value: 'PALASA, ANDHRA PRADESH',
    masterId: 14148,
  },
  {
    type: 'cityName',
    value: 'KAGAL, MAHARASHTRA',
    masterId: 12338,
  },
  {
    type: 'cityName',
    value: 'MANCHIKERI, KARNATAKA',
    masterId: 13369,
  },
  {
    type: 'cityName',
    value: 'KUDLIGI, KARNATAKA',
    masterId: 12976,
  },
  {
    type: 'cityName',
    value: 'KALSARI, GUJARAT',
    masterId: 12427,
  },
  {
    type: 'cityName',
    value: 'CHOPAN, UTTAR PRADESH',
    masterId: 11147,
  },
  {
    type: 'cityName',
    value: 'NAKHATRANA, GUJARAT',
    masterId: 13829,
  },
  {
    type: 'cityName',
    value: 'KHATRAJ, GUJARAT',
    masterId: 12735,
  },
  {
    type: 'cityName',
    value: 'AVINASHI, TAMIL NADU',
    masterId: 10317,
  },
  {
    type: 'cityName',
    value: 'DHEBAR, GUJARAT',
    masterId: 11383,
  },
  {
    type: 'cityName',
    value: 'VATHAR, MAHARASHTRA',
    masterId: 15806,
  },
  {
    type: 'cityName',
    value: 'TIMBI, GUJARAT',
    masterId: 15565,
  },
  {
    type: 'cityName',
    value: 'FARANGIPETE, KARNATAKA',
    masterId: 11561,
  },
  {
    type: 'cityName',
    value: 'UPPARIGUDA, TELANGANA',
    masterId: 15701,
  },
  {
    type: 'cityName',
    value: 'NAVUDURU, ANDHRA PRADESH',
    masterId: 13932,
  },
  {
    type: 'cityName',
    value: 'TUMMIDI, ANDHRA PRADESH',
    masterId: 15620,
  },
  {
    type: 'cityName',
    value: 'URAVAKONDA, ANDHRA PRADESH',
    masterId: 15709,
  },
  {
    type: 'cityName',
    value: 'BHORDA, RAJASTHAN',
    masterId: 10774,
  },
  {
    type: 'cityName',
    value: 'RANEBENNUR, KARNATAKA',
    masterId: 14648,
  },
  {
    type: 'cityName',
    value: 'SINGARAYAPALEM, ANDHRA PRADESH',
    masterId: 15194,
  },
  {
    type: 'cityName',
    value: 'GULEDAGUDDA, KARNATAKA',
    masterId: 11824,
  },
  {
    type: 'cityName',
    value: 'JASPARA, GUJARAT',
    masterId: 12207,
  },
  {
    type: 'cityName',
    value: 'ATREYAPURAM, ANDHRA PRADESH',
    masterId: 10296,
  },
  {
    type: 'cityName',
    value: 'PAVTHI, GUJARAT',
    masterId: 14319,
  },
  {
    type: 'cityName',
    value: 'MEGH NAGAR, MADHYA PRADESH',
    masterId: 13552,
  },
  {
    type: 'cityName',
    value: 'KHADI, MADHYA PRADESH',
    masterId: 12675,
  },
  {
    type: 'cityName',
    value: 'CHAVAKKAD, KERALA',
    masterId: 11028,
  },
  {
    type: 'cityName',
    value: 'OTTAPALAM, KERALA',
    masterId: 14093,
  },
  {
    type: 'cityName',
    value: 'LANKALA KODERU, ANDHRA PRADESH',
    masterId: 13117,
  },
  {
    type: 'cityName',
    value: 'SINDKHED RAJA, MAHARASHTRA',
    masterId: 15187,
  },
  {
    type: 'cityName',
    value: 'PODURU, ANDHRA PRADESH',
    masterId: 14437,
  },
  {
    type: 'cityName',
    value: 'GADHADA, GUJARAT',
    masterId: 11590,
  },
  {
    type: 'cityName',
    value: 'SARWAR, RAJASTHAN',
    masterId: 14957,
  },
  {
    type: 'cityName',
    value: 'SOMANDEPALLI, ANDHRA PRADESH',
    masterId: 15254,
  },
  {
    type: 'cityName',
    value: 'RAYAN, WEST BENGAL',
    masterId: 14706,
  },
  {
    type: 'cityName',
    value: 'SAYLA, GUJARAT',
    masterId: 15002,
  },
  {
    type: 'cityName',
    value: 'MUDUPERAR, KARNATAKA',
    masterId: 13685,
  },
  {
    type: 'cityName',
    value: 'MEHKAR, MAHARASHTRA',
    masterId: 13558,
  },
  {
    type: 'cityName',
    value: 'LAMJANA, MAHARASHTRA',
    masterId: 13111,
  },
  {
    type: 'cityName',
    value: 'ADOOR, KERALA',
    masterId: 10036,
  },
  {
    type: 'cityName',
    value: 'KOLITHAD, GUJARAT',
    masterId: 12845,
  },
  {
    type: 'cityName',
    value: 'MURAMALLA, ANDHRA PRADESH',
    masterId: 13740,
  },
  {
    type: 'cityName',
    value: 'PAMARRU, ANDHRA PRADESH',
    masterId: 14176,
  },
  {
    type: 'cityName',
    value: 'ATTINGAL, KERALA',
    masterId: 10300,
  },
  {
    type: 'cityName',
    value: 'T. NARSAPURAM, ANDHRA PRADESH',
    masterId: 15371,
  },
  {
    type: 'cityName',
    value: 'MANARCADU, KERALA',
    masterId: 13362,
  },
  {
    type: 'cityName',
    value: 'SHEGOAN, TAMIL NADU',
    masterId: 15072,
  },
  {
    type: 'cityName',
    value: 'PONNUR, ANDHRA PRADESH',
    masterId: 14451,
  },
  {
    type: 'cityName',
    value: 'KHERALU, GUJARAT',
    masterId: 12745,
  },
  {
    type: 'cityName',
    value: 'KANCHARLAVARIPALLE, ANDHRA PRADESH',
    masterId: 12468,
  },
  {
    type: 'cityName',
    value: 'AUDUMBARNAGAR, MAHARASHTRA',
    masterId: 10303,
  },
  {
    type: 'cityName',
    value: 'KALLIMANDAYAM, TAMIL NADU',
    masterId: 12417,
  },
  {
    type: 'cityName',
    value: 'MATHILAKAM, KERALA',
    masterId: 13513,
  },
  {
    type: 'cityName',
    value: 'NANUDI, GUJARAT',
    masterId: 13875,
  },
  {
    type: 'cityName',
    value: 'DHARDI, GUJARAT',
    masterId: 11363,
  },
  {
    type: 'cityName',
    value: 'THOTTILPALAM, KERALA',
    masterId: 15536,
  },
  {
    type: 'cityName',
    value: 'LOSAL, RAJASTHAN',
    masterId: 13167,
  },
  {
    type: 'cityName',
    value: 'MUNDKUR, KARNATAKA',
    masterId: 13723,
  },
  {
    type: 'cityName',
    value: 'MAKSI, MADHYA PRADESH',
    masterId: 13295,
  },
  {
    type: 'cityName',
    value: 'DEVPAR-YAKSH, GUJARAT',
    masterId: 11321,
  },
  {
    type: 'cityName',
    value: 'ROOKRI, HARYANA',
    masterId: 14753,
  },
  {
    type: 'cityName',
    value: 'VANDSE, KARNATAKA',
    masterId: 15770,
  },
  {
    type: 'cityName',
    value: 'MOVVA, ANDHRA PRADESH',
    masterId: 13670,
  },
  {
    type: 'cityName',
    value: 'AMRAPUR, GUJARAT',
    masterId: 10173,
  },
  {
    type: 'cityName',
    value: 'PANDALAM, KERALA',
    masterId: 14194,
  },
  {
    type: 'cityName',
    value: 'MALLIPATTINAM, TAMIL NADU',
    masterId: 13336,
  },
  {
    type: 'cityName',
    value: 'MURADABAD, UTTAR PRADESH',
    masterId: 13737,
  },
  {
    type: 'cityName',
    value: 'PASARLAPUDI, ANDHRA PRADESH',
    masterId: 14274,
  },
  {
    type: 'cityName',
    value: 'MANOOR, KARNATAKA',
    masterId: 13456,
  },
  {
    type: 'cityName',
    value: 'HOSANGADI, KARNATAKA',
    masterId: 12028,
  },
  {
    type: 'cityName',
    value: 'KAVALAKKI, KARNATAKA',
    masterId: 12615,
  },
  {
    type: 'cityName',
    value: 'GUTTI, KARNATAKA',
    masterId: 11876,
  },
  {
    type: 'cityName',
    value: 'GUNDALA, GUJARAT',
    masterId: 11836,
  },
  {
    type: 'cityName',
    value: 'RETURU, ANDHRA PRADESH',
    masterId: 14729,
  },
  {
    type: 'cityName',
    value: 'BHADER, GUJARAT',
    masterId: 10660,
  },
  {
    type: 'cityName',
    value: 'SIRIPALLI, ANDHRA PRADESH',
    masterId: 15208,
  },
  {
    type: 'cityName',
    value: 'PANCHGANI, MAHARASHTRA',
    masterId: 14188,
  },
  {
    type: 'cityName',
    value: 'NIWALI, MAHARASHTRA',
    masterId: 14039,
  },
  {
    type: 'cityName',
    value: 'MARAMANAHALLI, KARNATAKA',
    masterId: 13478,
  },
  {
    type: 'cityName',
    value: 'MALSHIKA, GUJARAT',
    masterId: 13339,
  },
  {
    type: 'cityName',
    value: 'BHATIA, GUJARAT',
    masterId: 10715,
  },
  {
    type: 'cityName',
    value: 'PIPALAVA, GUJARAT',
    masterId: 14410,
  },
  {
    type: 'cityName',
    value: 'BESTAVARIPETA, ANDHRA PRADESH',
    masterId: 10643,
  },
  {
    type: 'cityName',
    value: 'ANEKERE, KARNATAKA',
    masterId: 10200,
  },
  {
    type: 'cityName',
    value: 'LUNKI, GUJARAT',
    masterId: 13178,
  },
  {
    type: 'cityName',
    value: 'BILIYA, RAJASTHAN',
    masterId: 10832,
  },
  {
    type: 'cityName',
    value: 'PANAVADALI CHATRAM, TAMIL NADU',
    masterId: 14186,
  },
  {
    type: 'cityName',
    value: 'YERNAGUDEM, ANDHRA PRADESH',
    masterId: 15993,
  },
  {
    type: 'cityName',
    value: 'VITTAL, KARNATAKA',
    masterId: 15912,
  },
  {
    type: 'cityName',
    value: 'MACHAVARAM, TELANGANA',
    masterId: 13187,
  },
  {
    type: 'cityName',
    value: 'NANI KHAKHAR, GUJARAT',
    masterId: 13871,
  },
  {
    type: 'cityName',
    value: 'TANGI, ORISSA',
    masterId: 15428,
  },
  {
    type: 'cityName',
    value: 'KORUKOLLU, ANDHRA PRADESH',
    masterId: 12889,
  },
  {
    type: 'cityName',
    value: 'DOLASA, GUJARAT',
    masterId: 11453,
  },
  {
    type: 'cityName',
    value: 'JODRASTE, KARNATAKA',
    masterId: 12274,
  },
  {
    type: 'cityName',
    value: 'BHALGAM, GUJARAT',
    masterId: 10686,
  },
  {
    type: 'cityName',
    value: 'LANVA, GUJARAT',
    masterId: 13118,
  },
  {
    type: 'cityName',
    value: 'MANJARSUMBHA, MAHARASHTRA',
    masterId: 13437,
  },
  {
    type: 'cityName',
    value: 'OTWALA, RAJASTHAN',
    masterId: 14096,
  },
  {
    type: 'cityName',
    value: 'GHODEGAON, MAHARASHTRA',
    masterId: 11705,
  },
  {
    type: 'cityName',
    value: 'NETRAMLI, GUJARAT',
    masterId: 13980,
  },
  {
    type: 'cityName',
    value: 'ALLUR, ANDHRA PRADESH',
    masterId: 10112,
  },
  {
    type: 'cityName',
    value: 'BAGDU, GUJARAT',
    masterId: 10370,
  },
  {
    type: 'cityName',
    value: 'PADU, KARNATAKA',
    masterId: 14118,
  },
  {
    type: 'cityName',
    value: 'THIRUNAGAR, TAMIL NADU',
    masterId: 15517,
  },
  {
    type: 'cityName',
    value: 'VIJJESHWARAM, ANDHRA PRADESH',
    masterId: 15876,
  },
  {
    type: 'cityName',
    value: 'KOMALI, ANDHRA PRADESH',
    masterId: 19062,
  },
  {
    type: 'cityName',
    value: 'THEKKADY, KERALA',
    masterId: 15504,
  },
  {
    type: 'cityName',
    value: 'VENKATESWARAPURAM, TAMIL NADU',
    masterId: 15852,
  },
  {
    type: 'cityName',
    value: 'DHANSHA, HIMACHAL PRADESH',
    masterId: 11353,
  },
  {
    type: 'cityName',
    value: 'CHOUTUPPAL, TELANGANA',
    masterId: 11155,
  },
  {
    type: 'cityName',
    value: 'KALLEDA, TELANGANA',
    masterId: 12413,
  },
  {
    type: 'cityName',
    value: 'AVERSA, KARNATAKA',
    masterId: 10315,
  },
  {
    type: 'cityName',
    value: 'ALATHUR, ANDHRA PRADESH',
    masterId: 10099,
  },
  {
    type: 'cityName',
    value: 'DIU, DAMAN AND DIU',
    masterId: 11442,
  },
  {
    type: 'cityName',
    value: 'NARSAPURAM, ANDHRA PRADESH',
    masterId: 13904,
  },
  {
    type: 'cityName',
    value: 'KHIMSAR, RAJASTHAN',
    masterId: 12755,
  },
  {
    type: 'cityName',
    value: 'PACHORE, MADHYA PRADESH',
    masterId: 14107,
  },
  {
    type: 'cityName',
    value: 'KOZHENCHERY, KERALA',
    masterId: 12946,
  },
  {
    type: 'cityName',
    value: 'VALLABHIPUR, GUJARAT',
    masterId: 15759,
  },
  {
    type: 'cityName',
    value: 'SARAPAKA, TELANGANA',
    masterId: 14941,
  },
  {
    type: 'cityName',
    value: 'CHAUKE, MAHARASHTRA',
    masterId: 11023,
  },
  {
    type: 'cityName',
    value: 'NADOL, RAJASTHAN',
    masterId: 13788,
  },
  {
    type: 'cityName',
    value: 'KALPAKKAM, TAMIL NADU',
    masterId: 12424,
  },
  {
    type: 'cityName',
    value: 'MANDI, HIMACHAL PRADESH',
    masterId: 13394,
  },
  {
    type: 'cityName',
    value: 'VARAGANI, ANDHRA PRADESH',
    masterId: 15785,
  },
  {
    type: 'cityName',
    value: 'ARNI, MAHARASHTRA',
    masterId: 10251,
  },
  {
    type: 'cityName',
    value: 'CHILODA, GUJARAT',
    masterId: 11095,
  },
  {
    type: 'cityName',
    value: 'PATHUR, TAMIL NADU',
    masterId: 14301,
  },
  {
    type: 'cityName',
    value: 'SANALIYA, GUJARAT',
    masterId: 14884,
  },
  {
    type: 'cityName',
    value: 'DUVURU, ANDHRA PRADESH',
    masterId: 11502,
  },
  {
    type: 'cityName',
    value: 'KATRENIKONA, ANDHRA PRADESH',
    masterId: 12607,
  },
  {
    type: 'cityName',
    value: 'THUVARANKURICHI, TAMIL NADU',
    masterId: 15548,
  },
  {
    type: 'cityName',
    value: 'UDAYAGIRI, ANDHRA PRADESH',
    masterId: 15641,
  },
  {
    type: 'cityName',
    value: 'TUMMAPUDI, ANDHRA PRADESH',
    masterId: 15619,
  },
  {
    type: 'cityName',
    value: 'SUKHPAR, GUJARAT',
    masterId: 15316,
  },
  {
    type: 'cityName',
    value: 'HARDOI , UTTAR PRADESH',
    masterId: 11927,
  },
  {
    type: 'cityName',
    value: 'BAGDOGRA, WEST BENGAL',
    masterId: 10369,
  },
  {
    type: 'cityName',
    value: 'NIVALI PHATA, MAHARASHTRA',
    masterId: 14036,
  },
  {
    type: 'cityName',
    value: 'ARALVAIMOZHI, TAMIL NADU',
    masterId: 10234,
  },
  {
    type: 'cityName',
    value: 'VIJAPUR, GUJARAT',
    masterId: 15869,
  },
  {
    type: 'cityName',
    value: 'MADAGA, KARNATAKA',
    masterId: 13191,
  },
  {
    type: 'cityName',
    value: 'LAKHNADON, MADHYA PRADESH',
    masterId: 13088,
  },
  {
    type: 'cityName',
    value: 'SHIKARIPUR, KARNATAKA',
    masterId: 15085,
  },
  {
    type: 'cityName',
    value: 'PALODA, RAJASTHAN',
    masterId: 14170,
  },
  {
    type: 'cityName',
    value: 'RAMACHANDRAPURAM, ANDHRA PRADESH',
    masterId: 14598,
  },
  {
    type: 'cityName',
    value: 'SIDDAPUR, KARNATAKA',
    masterId: 15140,
  },
  {
    type: 'cityName',
    value: 'HALDIPUR, KARNATAKA',
    masterId: 11900,
  },
  {
    type: 'cityName',
    value: 'BEED, MADHYA PRADESH',
    masterId: 10606,
  },
  {
    type: 'cityName',
    value: 'KUMPA KAMAT, MAHARASHTRA',
    masterId: 13011,
  },
  {
    type: 'cityName',
    value: 'SAMTER, GUJARAT',
    masterId: 14881,
  },
  {
    type: 'cityName',
    value: 'SAMATRA, GUJARAT',
    masterId: 14870,
  },
  {
    type: 'cityName',
    value: 'KAYATHAR, TAMIL NADU',
    masterId: 12631,
  },
  {
    type: 'cityName',
    value: 'VASUDEVANALLUR, TAMIL NADU',
    masterId: 15803,
  },
  {
    type: 'cityName',
    value: 'AMBAJI, GUJARAT',
    masterId: 10139,
  },
  {
    type: 'cityName',
    value: 'DATHA, GUJARAT',
    masterId: 11249,
  },
  {
    type: 'cityName',
    value: 'YANAM, PUDUCHERRY',
    masterId: 15974,
  },
  {
    type: 'cityName',
    value: 'DHROL, GUJARAT',
    masterId: 11405,
  },
  {
    type: 'cityName',
    value: 'CHAKRA, GUJARAT',
    masterId: 10959,
  },
  {
    type: 'cityName',
    value: 'WATTUR PHATA, MAHARASHTRA',
    masterId: 15955,
  },
  {
    type: 'cityName',
    value: 'VEDANGI, ANDHRA PRADESH',
    masterId: 15813,
  },
  {
    type: 'cityName',
    value: 'SOUTHEGOWDANAHALLI, KARNATAKA',
    masterId: 15286,
  },
  {
    type: 'cityName',
    value: 'SONDA, KARNATAKA',
    masterId: 15269,
  },
  {
    type: 'cityName',
    value: 'JHABUA, MADHYA PRADESH',
    masterId: 12239,
  },
  {
    type: 'cityName',
    value: 'SONGIR, MAHARASHTRA',
    masterId: 15275,
  },
  {
    type: 'cityName',
    value: 'BAIJNATH, HIMACHAL PRADESH',
    masterId: 10395,
  },
  {
    type: 'cityName',
    value: 'PALAKONDA, ANDHRA PRADESH',
    masterId: 14140,
  },
  {
    type: 'cityName',
    value: 'RACHURU, ANDHRA PRADESH',
    masterId: 14532,
  },
  {
    type: 'cityName',
    value: 'RAVULAPALEM, ANDHRA PRADESH',
    masterId: 14696,
  },
  {
    type: 'cityName',
    value: 'PRODDATUR, ANDHRA PRADESH',
    masterId: 14471,
  },
  {
    type: 'cityName',
    value: 'SHIRAGUPPI, KARNATAKA',
    masterId: 15090,
  },
  {
    type: 'cityName',
    value: 'THIRUTHURAIPOONDI, TAMIL NADU',
    masterId: 15521,
  },
  {
    type: 'cityName',
    value: 'ANNAVARAPADU, ANDHRA PRADESH',
    masterId: 10218,
  },
  {
    type: 'cityName',
    value: 'ANIDA, GUJARAT',
    masterId: 10207,
  },
  {
    type: 'cityName',
    value: 'DASPA, RAJASTHAN',
    masterId: 11245,
  },
  {
    type: 'cityName',
    value: 'THENI, TAMIL NADU',
    masterId: 15505,
  },
  {
    type: 'cityName',
    value: 'VETTICHIRA, KERALA',
    masterId: 15861,
  },
  {
    type: 'cityName',
    value: 'MACHAVARAM BRIDGE, ANDHRA PRADESH',
    masterId: 13188,
  },
  {
    type: 'cityName',
    value: 'NARAKODURU, ANDHRA PRADESH',
    masterId: 13882,
  },
  {
    type: 'cityName',
    value: 'BHUJPUR, GUJARAT',
    masterId: 10783,
  },
  {
    type: 'cityName',
    value: 'AMARAVATI, ANDHRA PRADESH',
    masterId: 10126,
  },
  {
    type: 'cityName',
    value: 'KAKANI, ANDHRA PRADESH',
    masterId: 12358,
  },
  {
    type: 'cityName',
    value: 'VIRALIMALAI, TAMIL NADU',
    masterId: 15890,
  },
  {
    type: 'cityName',
    value: 'KOTHAPALLI, ANDHRA PRADESH',
    masterId: 12915,
  },
  {
    type: 'cityName',
    value: 'SHIV, RAJASTHAN',
    masterId: 15104,
  },
  {
    type: 'cityName',
    value: 'JAGUN, ASSAM',
    masterId: 12124,
  },
  {
    type: 'cityName',
    value: 'DAHINSARA, GUJARAT',
    masterId: 11195,
  },
  {
    type: 'cityName',
    value: 'VALASAN, GUJARAT',
    masterId: 15757,
  },
  {
    type: 'cityName',
    value: 'TATANIYA, GUJARAT',
    masterId: 15454,
  },
  {
    type: 'cityName',
    value: 'DEVALIYA, GUJARAT',
    masterId: 11308,
  },
  {
    type: 'cityName',
    value: 'KABULSHAH, PUNJAB',
    masterId: 12304,
  },
  {
    type: 'cityName',
    value: 'KONNUR, KARNATAKA',
    masterId: 12872,
  },
  {
    type: 'cityName',
    value: 'DHANJI, CHHATTISGARH',
    masterId: 11349,
  },
  {
    type: 'cityName',
    value: 'WYRA, TELANGANA',
    masterId: 15964,
  },
  {
    type: 'cityName',
    value: 'JOYA, UTTAR PRADESH',
    masterId: 12287,
  },
  {
    type: 'cityName',
    value: 'NANDIVELUGU, ANDHRA PRADESH',
    masterId: 13864,
  },
  {
    type: 'cityName',
    value: 'KADAYAM, TAMIL NADU',
    masterId: 12326,
  },
  {
    type: 'cityName',
    value: 'KODALI, ANDHRA PRADESH',
    masterId: 12814,
  },
  {
    type: 'cityName',
    value: 'BAYYANA GUDEM, TELANGANA',
    masterId: 10599,
  },
  {
    type: 'cityName',
    value: 'BAILHONGAL, KARNATAKA',
    masterId: 10397,
  },
  {
    type: 'cityName',
    value: 'DHOLERA, GUJARAT',
    masterId: 11397,
  },
  {
    type: 'cityName',
    value: 'PALLU, RAJASTHAN',
    masterId: 14169,
  },
  {
    type: 'cityName',
    value: 'PULAVANVAYAL, TAMIL NADU',
    masterId: 14480,
  },
  {
    type: 'cityName',
    value: 'OACHIRA, KERALA',
    masterId: 14066,
  },
  {
    type: 'cityName',
    value: 'ANDALUR, TAMIL NADU',
    masterId: 10196,
  },
  {
    type: 'cityName',
    value: 'EDAMUTTAM, KERALA',
    masterId: 11514,
  },
  {
    type: 'cityName',
    value: 'MADDIPADU, ANDHRA PRADESH',
    masterId: 13203,
  },
  {
    type: 'cityName',
    value: 'PERUMBAVOOR, KERALA',
    masterId: 14370,
  },
  {
    type: 'cityName',
    value: 'JASNAGAR, RAJASTHAN',
    masterId: 12205,
  },
  {
    type: 'cityName',
    value: 'KODAKARA, KERALA',
    masterId: 12813,
  },
  {
    type: 'cityName',
    value: 'UDANGUDI, TAMIL NADU',
    masterId: 15640,
  },
  {
    type: 'cityName',
    value: 'DEBHARI, GUJARAT',
    masterId: 11266,
  },
  {
    type: 'cityName',
    value: 'GURGUNTA - HUTTI RD, KARNATAKA',
    masterId: 11857,
  },
  {
    type: 'cityName',
    value: 'RAJSAMAND, RAJASTHAN',
    masterId: 14594,
  },
  {
    type: 'cityName',
    value: 'ROHISHA, GUJARAT',
    masterId: 14750,
  },
  {
    type: 'cityName',
    value: 'BAJEGOLI, KARNATAKA',
    masterId: 10403,
  },
  {
    type: 'cityName',
    value: 'ERVADI, TAMIL NADU',
    masterId: 11541,
  },
  {
    type: 'cityName',
    value: 'HARIHAR, KARNATAKA',
    masterId: 11933,
  },
  {
    type: 'cityName',
    value: 'BHARUDI, GUJARAT',
    masterId: 10709,
  },
  {
    type: 'cityName',
    value: 'MUTTUCHIRA, KERALA',
    masterId: 13765,
  },
  {
    type: 'cityName',
    value: 'PALAMPUR, HIMACHAL PRADESH',
    masterId: 14143,
  },
  {
    type: 'cityName',
    value: 'DAHEJ, GUJARAT',
    masterId: 11194,
  },
  {
    type: 'cityName',
    value: 'KRISHNAYAPALEM, ANDHRA PRADESH',
    masterId: 12962,
  },
  {
    type: 'cityName',
    value: 'MAJDIA, WEST BENGAL',
    masterId: 13286,
  },
  {
    type: 'cityName',
    value: 'PARAVOOR, KERALA',
    masterId: 14240,
  },
  {
    type: 'cityName',
    value: 'GOGUNDA, RAJASTHAN',
    masterId: 11736,
  },
  {
    type: 'cityName',
    value: 'AGATRAI, GUJARAT',
    masterId: 10043,
  },
  {
    type: 'cityName',
    value: 'PARVALA, GUJARAT',
    masterId: 14271,
  },
  {
    type: 'cityName',
    value: 'BATWA, GUJARAT',
    masterId: 10589,
  },
  {
    type: 'cityName',
    value: 'SALUMBAR, RAJASTHAN',
    masterId: 14857,
  },
  {
    type: 'cityName',
    value: 'CHANDOLU, ANDHRA PRADESH',
    masterId: 10986,
  },
  {
    type: 'cityName',
    value: 'VADAKKENCHERRY, KERALA',
    masterId: 15727,
  },
  {
    type: 'cityName',
    value: 'KESARIYA, GUJARAT',
    masterId: 12659,
  },
  {
    type: 'cityName',
    value: 'GANGAVATHI, KARNATAKA',
    masterId: 11635,
  },
  {
    type: 'cityName',
    value: 'KARANJA, MAHARASHTRA',
    masterId: 12534,
  },
  {
    type: 'cityName',
    value: 'RAJOURI, JAMMU AND KASHMIR',
    masterId: 14591,
  },
  {
    type: 'cityName',
    value: 'SALUR, ANDHRA PRADESH',
    masterId: 14858,
  },
  {
    type: 'cityName',
    value: 'REDDYPALEM, ANDHRA PRADESH',
    masterId: 14713,
  },
  {
    type: 'cityName',
    value: 'PAIGA, UTTAR PRADESH',
    masterId: 14129,
  },
  {
    type: 'cityName',
    value: 'RAMANATTUKARA, KERALA',
    masterId: 14605,
  },
  {
    type: 'cityName',
    value: 'KALLADIKUPPAM, TAMIL NADU',
    masterId: 12405,
  },
  {
    type: 'cityName',
    value: 'SNAL BOLLONG, ASSAM',
    masterId: 17551,
  },
  {
    type: 'cityName',
    value: 'KANGEYAMPATTI, TAMIL NADU',
    masterId: 12483,
  },
  {
    type: 'cityName',
    value: 'THOTTEKKAD, KERALA',
    masterId: 15535,
  },
  {
    type: 'cityName',
    value: 'GUNNAUR, UTTAR PRADESH',
    masterId: 11848,
  },
  {
    type: 'cityName',
    value: 'BANAGANAPALLI, ANDHRA PRADESH',
    masterId: 10456,
  },
  {
    type: 'cityName',
    value: 'NAMSAI, ARUNACHAL PRADESH',
    masterId: 13852,
  },
  {
    type: 'cityName',
    value: 'TAGARAPUVALASA, ANDHRA PRADESH',
    masterId: 15387,
  },
  {
    type: 'cityName',
    value: 'PETHA, MAHARASHTRA',
    masterId: 14377,
  },
  {
    type: 'cityName',
    value: 'FATEHGANJ, UTTAR PRADESH',
    masterId: 11567,
  },
  {
    type: 'cityName',
    value: 'BAR, GUJARAT',
    masterId: 10497,
  },
  {
    type: 'cityName',
    value: 'KALLAMBALAM, KERALA',
    masterId: 12412,
  },
  {
    type: 'cityName',
    value: 'HOSANAGAR, KARNATAKA',
    masterId: 12027,
  },
  {
    type: 'cityName',
    value: 'MAHIPALACHERUVU, ANDHRA PRADESH',
    masterId: 13257,
  },
  {
    type: 'cityName',
    value: 'PIPLYA MANDI, MADHYA PRADESH',
    masterId: 14420,
  },
  {
    type: 'cityName',
    value: 'BODANA, RAJASTHAN',
    masterId: 10863,
  },
  {
    type: 'cityName',
    value: 'BIDKALKATTE, KARNATAKA',
    masterId: 10804,
  },
  {
    type: 'cityName',
    value: 'SATLASANA, GUJARAT',
    masterId: 14975,
  },
  {
    type: 'cityName',
    value: 'BAGGAR, RAJASTHAN',
    masterId: 10371,
  },
  {
    type: 'cityName',
    value: 'KAMREJ, GUJARAT',
    masterId: 12456,
  },
  {
    type: 'cityName',
    value: 'KAJIPET, TELANGANA',
    masterId: 12356,
  },
  {
    type: 'cityName',
    value: 'MANKUWA, GUJARAT',
    masterId: 13445,
  },
  {
    type: 'cityName',
    value: 'WAYANAD, KERALA',
    masterId: 15956,
  },
  {
    type: 'cityName',
    value: 'ANDHERI, MAHARASHTRA',
    masterId: 10197,
  },
  {
    type: 'cityName',
    value: 'KOYYALAGUDEM, ANDHRA PRADESH',
    masterId: 12945,
  },
  {
    type: 'cityName',
    value: 'THUMDI, GUJARAT',
    masterId: 15542,
  },
  {
    type: 'cityName',
    value: 'KHEENVSAR, RAJASTHAN',
    masterId: 12744,
  },
  {
    type: 'cityName',
    value: 'MARAVAMANGALAM, TAMIL NADU',
    masterId: 13483,
  },
  {
    type: 'cityName',
    value: 'ABIRAMAM, TAMIL NADU',
    masterId: 10013,
  },
  {
    type: 'cityName',
    value: 'MELKAR, KARNATAKA',
    masterId: 13567,
  },
  {
    type: 'cityName',
    value: 'RAMANKARY, KERALA',
    masterId: 14609,
  },
  {
    type: 'cityName',
    value: 'TEKKATTE, KARNATAKA',
    masterId: 15465,
  },
  {
    type: 'cityName',
    value: 'MAHAD, MAHARASHTRA',
    masterId: 13233,
  },
  {
    type: 'cityName',
    value: 'NAHARLAGUN, ARUNACHAL PRADESH',
    masterId: 13820,
  },
  {
    type: 'cityName',
    value: 'PARADEEP, ORISSA',
    masterId: 14227,
  },
  {
    type: 'cityName',
    value: 'PARKALA HIGH SCHOOL, KARNATAKA',
    masterId: 14254,
  },
  {
    type: 'cityName',
    value: 'BHUVANAGIRI, TELANGANA',
    masterId: 10793,
  },
  {
    type: 'cityName',
    value: 'PENUGONDA, ANDHRA PRADESH',
    masterId: 14351,
  },
  {
    type: 'cityName',
    value: 'ATEGAON, MAHARASHTRA',
    masterId: 10286,
  },
  {
    type: 'cityName',
    value: 'SHEDUBHAR, GUJARAT',
    masterId: 15070,
  },
  {
    type: 'cityName',
    value: 'BABRA, GUJARAT',
    masterId: 10330,
  },
  {
    type: 'cityName',
    value: 'CHAK RAKWALA, JAMMU AND KASHMIR',
    masterId: 19072,
  },
  {
    type: 'cityName',
    value: 'PENUKONDA, ANDHRA PRADESH',
    masterId: 14352,
  },
  {
    type: 'cityName',
    value: 'MULOOR, KARNATAKA',
    masterId: 13709,
  },
  {
    type: 'cityName',
    value: 'ASADHA, UTTAR PRADESH',
    masterId: 10263,
  },
  {
    type: 'cityName',
    value: 'CHICKMAGALURU, KARNATAKA',
    masterId: 11073,
  },
  {
    type: 'cityName',
    value: 'VITA, MAHARASHTRA',
    masterId: 15909,
  },
  {
    type: 'cityName',
    value: 'KONNI, KERALA',
    masterId: 12870,
  },
  {
    type: 'cityName',
    value: 'TALWANA, GUJARAT',
    masterId: 15417,
  },
  {
    type: 'cityName',
    value: 'DHAR, MADHYA PRADESH',
    masterId: 11357,
  },
  {
    type: 'cityName',
    value: 'MANDHARAKUPPAM, TAMIL NADU',
    masterId: 13392,
  },
  {
    type: 'cityName',
    value: 'AURAD, KARNATAKA',
    masterId: 10307,
  },
  {
    type: 'cityName',
    value: 'MEHANDIPUR, RAJASTHAN',
    masterId: 13556,
  },
  {
    type: 'cityName',
    value: 'KUTIYANA, GUJARAT',
    masterId: 13062,
  },
  {
    type: 'cityName',
    value: 'AASPUR, UTTAR PRADESH',
    masterId: 10008,
  },
  {
    type: 'cityName',
    value: 'PERAMBALUR, TAMIL NADU',
    masterId: 14356,
  },
  {
    type: 'cityName',
    value: 'ALWARKURICHI, TAMIL NADU',
    masterId: 10121,
  },
  {
    type: 'cityName',
    value: 'CHOTISADRI, RAJASTHAN',
    masterId: 11152,
  },
  {
    type: 'cityName',
    value: 'KOTAGIRI, TAMIL NADU',
    masterId: 12901,
  },
  {
    type: 'cityName',
    value: 'DAULATPURA, RAJASTHAN',
    masterId: 11253,
  },
  {
    type: 'cityName',
    value: 'PULLETIKURRU, ANDHRA PRADESH',
    masterId: 14492,
  },
  {
    type: 'cityName',
    value: 'DAWALESWARAM, ANDHRA PRADESH',
    masterId: 11260,
  },
  {
    type: 'cityName',
    value: 'NAGARA, KARNATAKA',
    masterId: 13796,
  },
  {
    type: 'cityName',
    value: 'YAMUNOTRI, HIMACHAL PRADESH',
    masterId: 15973,
  },
  {
    type: 'cityName',
    value: 'DEVARKULAM, TAMIL NADU',
    masterId: 11314,
  },
  {
    type: 'cityName',
    value: 'DHAMAPUR, MAHARASHTRA',
    masterId: 11335,
  },
  {
    type: 'cityName',
    value: 'ITA NAGAR, ARUNACHAL PRADESH',
    masterId: 12090,
  },
  {
    type: 'cityName',
    value: 'NAINITAL, UTTARAKHAND',
    masterId: 13825,
  },
  {
    type: 'cityName',
    value: 'ANPARA, UTTAR PRADESH',
    masterId: 10221,
  },
  {
    type: 'cityName',
    value: 'MANDLA, MADHYA PRADESH',
    masterId: 13401,
  },
  {
    type: 'cityName',
    value: 'PADUKKAPATHU, TAMIL NADU',
    masterId: 14120,
  },
  {
    type: 'cityName',
    value: 'MYDUKUR, ANDHRA PRADESH',
    masterId: 13770,
  },
  {
    type: 'cityName',
    value: 'GOLLAGUDEM, ANDHRA PRADESH',
    masterId: 11751,
  },
  {
    type: 'cityName',
    value: 'YELLAPUR, KARNATAKA',
    masterId: 15987,
  },
  {
    type: 'cityName',
    value: 'SEONI, MADHYA PRADESH',
    masterId: 15024,
  },
  {
    type: 'cityName',
    value: 'MUDHOL, KARNATAKA',
    masterId: 13679,
  },
  {
    type: 'cityName',
    value: 'SRICITY, ANDHRA PRADESH',
    masterId: 15287,
  },
  {
    type: 'cityName',
    value: 'BARHALGANJ, UTTAR PRADESH',
    masterId: 10529,
  },
  {
    type: 'cityName',
    value: 'SAGWARA, RAJASTHAN',
    masterId: 14802,
  },
  {
    type: 'cityName',
    value: 'KHARWANDI, MAHARASHTRA',
    masterId: 12729,
  },
  {
    type: 'cityName',
    value: 'MANGALAPURAM, KERALA',
    masterId: 13412,
  },
  {
    type: 'cityName',
    value: 'ANUPURAM, TAMIL NADU',
    masterId: 10226,
  },
  {
    type: 'cityName',
    value: 'APPAPURAM, ANDHRA PRADESH',
    masterId: 10227,
  },
  {
    type: 'cityName',
    value: 'PUSHKAR, RAJASTHAN',
    masterId: 14519,
  },
  {
    type: 'cityName',
    value: 'BORAKHEDI, MAHARASHTRA',
    masterId: 10887,
  },
  {
    type: 'cityName',
    value: 'VIJAYANAGAR, KARNATAKA',
    masterId: 15871,
  },
  {
    type: 'cityName',
    value: 'MOTI KHAKHAR, GUJARAT',
    masterId: 13663,
  },
  {
    type: 'cityName',
    value: 'GANPATIPULE, MAHARASHTRA',
    masterId: 11648,
  },
  {
    type: 'cityName',
    value: 'HIRIYUR, KARNATAKA',
    masterId: 12003,
  },
  {
    type: 'cityName',
    value: 'KHADARA, UTTAR PRADESH',
    masterId: 12672,
  },
  {
    type: 'cityName',
    value: 'ENIKEPADU, ANDHRA PRADESH',
    masterId: 11531,
  },
  {
    type: 'cityName',
    value: 'BASAVAKALYAN, KARNATAKA',
    masterId: 10571,
  },
  {
    type: 'cityName',
    value: 'SANKESHWARA, KARNATAKA',
    masterId: 14911,
  },
  {
    type: 'cityName',
    value: 'SIYAVAT TO BHANDAVPUR TALIYANA JEEVANA RD, RAJASTHAN',
    masterId: 15242,
  },
  {
    type: 'cityName',
    value: 'BARMAN MOTA, GUJARAT',
    masterId: 10546,
  },
  {
    type: 'cityName',
    value: 'GURUVAYOOR, KERALA',
    masterId: 11872,
  },
  {
    type: 'cityName',
    value: 'KOCHI, KERALA',
    masterId: 12806,
  },
  {
    type: 'cityName',
    value: 'PACHAL, MAHARASHTRA',
    masterId: 14102,
  },
  {
    type: 'cityName',
    value: 'TONK, RAJASTHAN',
    masterId: 15597,
  },
  {
    type: 'cityName',
    value: 'RADHANAGARI, MAHARASHTRA',
    masterId: 14533,
  },
  {
    type: 'cityName',
    value: 'RANNI, KERALA',
    masterId: 14669,
  },
  {
    type: 'cityName',
    value: 'KARUMATHAMPATTI, TAMIL NADU',
    masterId: 12571,
  },
  {
    type: 'cityName',
    value: 'PALAKODERU, ANDHRA PRADESH',
    masterId: 14138,
  },
  {
    type: 'cityName',
    value: 'TELAPROLU, ANDHRA PRADESH',
    masterId: 15466,
  },
  {
    type: 'cityName',
    value: 'DUNGALA, GUJARAT',
    masterId: 11489,
  },
  {
    type: 'cityName',
    value: 'KANJIRAPPALLY, KERALA',
    masterId: 12495,
  },
  {
    type: 'cityName',
    value: 'CHANNAGIRI, KARNATAKA',
    masterId: 11002,
  },
  {
    type: 'cityName',
    value: 'UJIRE, KARNATAKA',
    masterId: 15654,
  },
  {
    type: 'cityName',
    value: 'VEDARANYAM, TAMIL NADU',
    masterId: 15814,
  },
  {
    type: 'cityName',
    value: 'MADALMOHI, MAHARASHTRA',
    masterId: 13194,
  },
  {
    type: 'cityName',
    value: 'SALASAR, RAJASTHAN',
    masterId: 14840,
  },
  {
    type: 'cityName',
    value: 'PEKERU, ANDHRA PRADESH',
    masterId: 14343,
  },
  {
    type: 'cityName',
    value: 'TENKAMIJAR, KARNATAKA',
    masterId: 15474,
  },
  {
    type: 'cityName',
    value: 'KALIAKKAVILAI, TAMIL NADU',
    masterId: 12394,
  },
  {
    type: 'cityName',
    value: 'VILASA, ANDHRA PRADESH',
    masterId: 15884,
  },
  {
    type: 'cityName',
    value: 'MORJAR, GUJARAT',
    masterId: 13650,
  },
  {
    type: 'cityName',
    value: 'MEGNANAPURAM, TAMIL NADU',
    masterId: 13555,
  },
  {
    type: 'cityName',
    value: 'SARDARGADH, GUJARAT',
    masterId: 14944,
  },
  {
    type: 'cityName',
    value: 'CHINNA OGIRALA, ANDHRA PRADESH',
    masterId: 11108,
  },
  {
    type: 'cityName',
    value: 'VANA TIRUPATHI, TAMIL NADU',
    masterId: 15765,
  },
  {
    type: 'cityName',
    value: 'GAVSE, MAHARASHTRA',
    masterId: 11680,
  },
  {
    type: 'cityName',
    value: 'PALLATHUR, TAMIL NADU',
    masterId: 14164,
  },
  {
    type: 'cityName',
    value: 'NADUVAKURICHI, TAMIL NADU',
    masterId: 13789,
  },
  {
    type: 'cityName',
    value: 'CHIKKALA, ANDHRA PRADESH',
    masterId: 11082,
  },
  {
    type: 'cityName',
    value: 'JARTI, ORISSA',
    masterId: 16244,
  },
  {
    type: 'cityName',
    value: 'AIZAWL, MIZORAM',
    masterId: 10065,
  },
  {
    type: 'cityName',
    value: 'IMAGICA, MAHARASHTRA',
    masterId: 12064,
  },
  {
    type: 'cityName',
    value: 'KOTESHWAR, KARNATAKA',
    masterId: 12910,
  },
  {
    type: 'cityName',
    value: 'JANGAREDDIGUDEM, ANDHRA PRADESH',
    masterId: 12190,
  },
  {
    type: 'cityName',
    value: 'THIRUNALLAR, PUDUCHERRY',
    masterId: 15518,
  },
  {
    type: 'cityName',
    value: 'PARITALA, ANDHRA PRADESH',
    masterId: 14253,
  },
  {
    type: 'cityName',
    value: 'DEESA, GUJARAT',
    masterId: 11268,
  },
  {
    type: 'cityName',
    value: 'KOTHAGUDEM, TELANGANA',
    masterId: 12912,
  },
  {
    type: 'cityName',
    value: 'RAMANIYA, RAJASTHAN',
    masterId: 14607,
  },
  {
    type: 'cityName',
    value: 'VEKARIYA, GUJARAT',
    masterId: 15823,
  },
  {
    type: 'cityName',
    value: 'PANTHAWADA, GUJARAT',
    masterId: 14221,
  },
  {
    type: 'cityName',
    value: 'DARSHADI, GUJARAT',
    masterId: 11239,
  },
  {
    type: 'cityName',
    value: 'AURAI, UTTAR PRADESH',
    masterId: 10308,
  },
  {
    type: 'cityName',
    value: 'JETPUR NAVAGADH, GUJARAT',
    masterId: 12234,
  },
  {
    type: 'cityName',
    value: 'HUNTERGANJ, JHARKHAND',
    masterId: 12046,
  },
  {
    type: 'cityName',
    value: 'PEEPARA, RAJASTHAN',
    masterId: 14341,
  },
  {
    type: 'cityName',
    value: 'SIVAGIRI, TAMIL NADU',
    masterId: 15233,
  },
  {
    type: 'cityName',
    value: 'PALLAPATTI, TAMIL NADU',
    masterId: 14163,
  },
  {
    type: 'cityName',
    value: 'MAHUA, BIHAR',
    masterId: 13265,
  },
  {
    type: 'cityName',
    value: 'VARANGA, KARNATAKA',
    masterId: 15787,
  },
  {
    type: 'cityName',
    value: 'KHARIYA, UTTAR PRADESH',
    masterId: 12724,
  },
  {
    type: 'cityName',
    value: 'AYARKUNNAM, KERALA',
    masterId: 10319,
  },
  {
    type: 'cityName',
    value: 'AMARGADH, GUJARAT',
    masterId: 10129,
  },
  {
    type: 'cityName',
    value: 'DOMBIVLI, MAHARASHTRA',
    masterId: 11455,
  },
  {
    type: 'cityName',
    value: 'MANDAPALLI, ANDHRA PRADESH',
    masterId: 13379,
  },
  {
    type: 'cityName',
    value: 'KALASAPADU, ANDHRA PRADESH',
    masterId: 12381,
  },
  {
    type: 'cityName',
    value: 'SHIVPURI RD, MADHYA PRADESH',
    masterId: 15115,
  },
  {
    type: 'cityName',
    value: 'KILPADY, KARNATAKA',
    masterId: 12784,
  },
  {
    type: 'cityName',
    value: 'PUNGANUR, ANDHRA PRADESH',
    masterId: 14500,
  },
  {
    type: 'cityName',
    value: 'SIVASAGAR, ASSAM',
    masterId: 15237,
  },
  {
    type: 'cityName',
    value: 'AALPURA, RAJASTHAN',
    masterId: 10006,
  },
  {
    type: 'cityName',
    value: 'RAJGARH, MADHYA PRADESH',
    masterId: 14580,
  },
  {
    type: 'cityName',
    value: 'THURAIYUR, TAMIL NADU',
    masterId: 15544,
  },
  {
    type: 'cityName',
    value: 'PEDAPULIVARRU, ANDHRA PRADESH',
    masterId: 14332,
  },
  {
    type: 'cityName',
    value: 'PANCHKULA, HARYANA',
    masterId: 14190,
  },
  {
    type: 'cityName',
    value: 'NAIDUPETA, ANDHRA PRADESH',
    masterId: 13822,
  },
  {
    type: 'cityName',
    value: 'NO.2 BORDONDI, ASSAM',
    masterId: 14044,
  },
  {
    type: 'cityName',
    value: 'DEVAKOTTAI, TAMIL NADU',
    masterId: 11305,
  },
  {
    type: 'cityName',
    value: 'KADANGA MARUR, KARNATAKA',
    masterId: 12321,
  },
  {
    type: 'cityName',
    value: 'UNDURU, ANDHRA PRADESH',
    masterId: 15689,
  },
  {
    type: 'cityName',
    value: 'MANDAPETA, ANDHRA PRADESH',
    masterId: 13381,
  },
  {
    type: 'cityName',
    value: 'TODIYA, GUJARAT',
    masterId: 15595,
  },
  {
    type: 'cityName',
    value: 'NEPPALLI, ANDHRA PRADESH',
    masterId: 13969,
  },
  {
    type: 'cityName',
    value: 'MANIMALA, KERALA',
    masterId: 13434,
  },
  {
    type: 'cityName',
    value: 'THALLURU, KARNATAKA',
    masterId: 15489,
  },
  {
    type: 'cityName',
    value: 'DABPAL, CHHATTISGARH',
    masterId: 18628,
  },
  {
    type: 'cityName',
    value: 'AMRISTSAR, PUNJAB',
    masterId: 10176,
  },
  {
    type: 'cityName',
    value: 'BEVAR, RAJASTHAN',
    masterId: 10651,
  },
  {
    type: 'cityName',
    value: 'ADDANKI, ANDHRA PRADESH',
    masterId: 10024,
  },
  {
    type: 'cityName',
    value: 'MUKTAINAGAR, MAHARASHTRA',
    masterId: 13698,
  },
  {
    type: 'cityName',
    value: 'SAKARIYA, MADHYA PRADESH',
    masterId: 17079,
  },
  {
    type: 'cityName',
    value: 'MAHABALIPURAM, TAMIL NADU',
    masterId: 13230,
  },
  {
    type: 'cityName',
    value: 'MUDDUNURU, TELANGANA',
    masterId: 13676,
  },
  {
    type: 'cityName',
    value: 'THINGAL NAGAR, TAMIL NADU',
    masterId: 15509,
  },
  {
    type: 'cityName',
    value: 'GARLAVALASA, ANDHRA PRADESH',
    masterId: 11664,
  },
  {
    type: 'cityName',
    value: 'SIKRI, HARYANA',
    masterId: 15159,
  },
  {
    type: 'cityName',
    value: 'NAGURU, ANDHRA PRADESH',
    masterId: 13817,
  },
  {
    type: 'cityName',
    value: 'LALAULI, UTTAR PRADESH',
    masterId: 13098,
  },
  {
    type: 'cityName',
    value: 'GUNDLUPETE, KARNATAKA',
    masterId: 11840,
  },
  {
    type: 'cityName',
    value: 'DAVANGERE, KARNATAKA',
    masterId: 11259,
  },
  {
    type: 'cityName',
    value: 'MALHARGARH, MADHYA PRADESH',
    masterId: 13316,
  },
  {
    type: 'cityName',
    value: 'DAHITHARA, GUJARAT',
    masterId: 11196,
  },
  {
    type: 'cityName',
    value: 'MANDAWARIYA, RAJASTHAN',
    masterId: 13389,
  },
  {
    type: 'cityName',
    value: 'HAJIRADHAR, GUJARAT',
    masterId: 11894,
  },
  {
    type: 'cityName',
    value: 'TALOD, MADHYA PRADESH',
    masterId: 15415,
  },
  {
    type: 'cityName',
    value: 'CHILPHI, CHHATTISGARH',
    masterId: 11096,
  },
  {
    type: 'cityName',
    value: 'TALLURU, ANDHRA PRADESH',
    masterId: 15414,
  },
  {
    type: 'cityName',
    value: 'RAYA, UTTAR PRADESH',
    masterId: 14701,
  },
  {
    type: 'cityName',
    value: 'HAROGOLIGE, KARNATAKA',
    masterId: 11947,
  },
  {
    type: 'cityName',
    value: 'BRAHMAVAR, KARNATAKA',
    masterId: 10907,
  },
  {
    type: 'cityName',
    value: 'SIYANA, UTTAR PRADESH',
    masterId: 15241,
  },
  {
    type: 'cityName',
    value: 'PADARSHINGA, GUJARAT',
    masterId: 14111,
  },
  {
    type: 'cityName',
    value: 'NEWASA FATA, MAHARASHTRA',
    masterId: 13986,
  },
  {
    type: 'cityName',
    value: 'SUNTIKOPPA, KARNATAKA',
    masterId: 15343,
  },
  {
    type: 'cityName',
    value: 'KHADADHAR, GUJARAT',
    masterId: 12671,
  },
  {
    type: 'cityName',
    value: 'JEVARGI, KARNATAKA',
    masterId: 12236,
  },
  {
    type: 'cityName',
    value: 'ARYAD SOUTH, KERALA',
    masterId: 10261,
  },
  {
    type: 'cityName',
    value: 'NALUMAVADI, TAMIL NADU',
    masterId: 13845,
  },
  {
    type: 'cityName',
    value: 'KHAKHAD, RAJASTHAN',
    masterId: 12688,
  },
  {
    type: 'cityName',
    value: 'MUNGANDA, ANDHRA PRADESH',
    masterId: 13727,
  },
  {
    type: 'cityName',
    value: 'ATHANI, KARNATAKA',
    masterId: 10287,
  },
  {
    type: 'cityName',
    value: 'KARKALA, KARNATAKA',
    masterId: 12556,
  },
  {
    type: 'cityName',
    value: 'PITHALPUR, GUJARAT',
    masterId: 14429,
  },
  {
    type: 'cityName',
    value: 'JAAM, MADHYA PRADESH',
    masterId: 12097,
  },
  {
    type: 'cityName',
    value: 'SADASHIVPET, TELANGANA',
    masterId: 14788,
  },
  {
    type: 'cityName',
    value: 'BUDUGUMPA CROSS, KARNATAKA',
    masterId: 10919,
  },
  {
    type: 'cityName',
    value: 'SURATHKAL, KARNATAKA',
    masterId: 15355,
  },
  {
    type: 'cityName',
    value: 'ALLAMPURAM, ANDHRA PRADESH',
    masterId: 10110,
  },
  {
    type: 'cityName',
    value: 'BAD, UTTAR PRADESH',
    masterId: 10336,
  },
  {
    type: 'cityName',
    value: 'SHORAPUR, KARNATAKA',
    masterId: 15121,
  },
  {
    type: 'cityName',
    value: 'AGAR, RAJASTHAN',
    masterId: 10041,
  },
  {
    type: 'cityName',
    value: 'KUDI, KARNATAKA',
    masterId: 12975,
  },
  {
    type: 'cityName',
    value: 'MOKSHAGUNDAM, ANDHRA PRADESH',
    masterId: 13627,
  },
  {
    type: 'cityName',
    value: 'PAMPADY, KERALA',
    masterId: 14179,
  },
  {
    type: 'cityName',
    value: 'PARALI, KERALA',
    masterId: 14231,
  },
  {
    type: 'cityName',
    value: 'MENDARDA, GUJARAT',
    masterId: 13571,
  },
  {
    type: 'cityName',
    value: 'MANJERI, KERALA',
    masterId: 13438,
  },
  {
    type: 'cityName',
    value: 'PERUVANTHANAM, KERALA',
    masterId: 14375,
  },
  {
    type: 'cityName',
    value: 'BHURAKHIYA, GUJARAT',
    masterId: 10787,
  },
  {
    type: 'cityName',
    value: 'VENJARAMOODU, KERALA',
    masterId: 15848,
  },
  {
    type: 'cityName',
    value: 'KORATTY, KERALA',
    masterId: 12884,
  },
  {
    type: 'cityName',
    value: 'AMBARDI, GUJARAT',
    masterId: 10147,
  },
  {
    type: 'cityName',
    value: 'SHAHPUR, KARNATAKA',
    masterId: 15049,
  },
  {
    type: 'cityName',
    value: 'VIRAR, MAHARASHTRA',
    masterId: 15892,
  },
  {
    type: 'cityName',
    value: 'TUFANGANJ, WEST BENGAL',
    masterId: 16191,
  },
  {
    type: 'cityName',
    value: 'SHIRUR, MAHARASHTRA',
    masterId: 15101,
  },
  {
    type: 'cityName',
    value: 'CHOMU, RAJASTHAN',
    masterId: 11146,
  },
  {
    type: 'cityName',
    value: 'KALIKIRI, ANDHRA PRADESH',
    masterId: 12397,
  },
  {
    type: 'cityName',
    value: 'BORALA, GUJARAT',
    masterId: 10888,
  },
  {
    type: 'cityName',
    value: 'SALDI, GUJARAT',
    masterId: 14845,
  },
  {
    type: 'cityName',
    value: 'OLIYA, GUJARAT',
    masterId: 14077,
  },
  {
    type: 'cityName',
    value: 'BEENAGANJ, MADHYA PRADESH',
    masterId: 10607,
  },
  {
    type: 'cityName',
    value: 'VEMAVARAM, ANDHRA PRADESH',
    masterId: 15840,
  },
  {
    type: 'cityName',
    value: 'DHAMEL, GUJARAT',
    masterId: 11337,
  },
  {
    type: 'cityName',
    value: 'PATANVAV, GUJARAT',
    masterId: 14280,
  },
  {
    type: 'cityName',
    value: 'PUTHIAMPUTHUR, TAMIL NADU',
    masterId: 14524,
  },
  {
    type: 'cityName',
    value: 'KAMPLI, KARNATAKA',
    masterId: 12453,
  },
  {
    type: 'cityName',
    value: 'KADGANCHI, KARNATAKA',
    masterId: 12329,
  },
  {
    type: 'cityName',
    value: 'PARSAD, RAJASTHAN',
    masterId: 14260,
  },
  {
    type: 'cityName',
    value: 'MULUR, KARNATAKA',
    masterId: 13711,
  },
  {
    type: 'cityName',
    value: 'NILAMEL, KERALA',
    masterId: 14006,
  },
  {
    type: 'cityName',
    value: 'GAYABARI, WEST BENGAL',
    masterId: 16145,
  },
  {
    type: 'cityName',
    value: 'MENGALWA, RAJASTHAN',
    masterId: 13572,
  },
  {
    type: 'cityName',
    value: 'BHACHAU, GUJARAT',
    masterId: 10656,
  },
  {
    type: 'cityName',
    value: 'MANTRALAYAM, ANDHRA PRADESH',
    masterId: 13468,
  },
  {
    type: 'cityName',
    value: 'KOOTHANALLUR, TAMIL NADU',
    masterId: 12873,
  },
  {
    type: 'cityName',
    value: 'RAMOJI FILM CITY, TELANGANA',
    masterId: 14629,
  },
  {
    type: 'cityName',
    value: 'PUNALUR, KERALA',
    masterId: 14494,
  },
  {
    type: 'cityName',
    value: 'MANIPAL, KARNATAKA',
    masterId: 13435,
  },
  {
    type: 'cityName',
    value: 'GOLLALAKODERU, ANDHRA PRADESH',
    masterId: 11752,
  },
  {
    type: 'cityName',
    value: 'AVINASHIPALAYAM, TAMIL NADU',
    masterId: 10318,
  },
  {
    type: 'cityName',
    value: 'KANDIKUPPA, ANDHRA PRADESH',
    masterId: 12475,
  },
  {
    type: 'cityName',
    value: 'THIRUKKURUNGUDI, TAMIL NADU',
    masterId: 15513,
  },
  {
    type: 'cityName',
    value: 'UCHIPULI, TAMIL NADU',
    masterId: 15636,
  },
  {
    type: 'cityName',
    value: 'KUNDAPUR, KARNATAKA',
    masterId: 13019,
  },
  {
    type: 'cityName',
    value: 'MANNAKALLI, KERALA',
    masterId: 13449,
  },
  {
    type: 'cityName',
    value: 'MADATHUKULAM, TAMIL NADU',
    masterId: 13201,
  },
  {
    type: 'cityName',
    value: 'SHIRPUR, MAHARASHTRA',
    masterId: 15097,
  },
  {
    type: 'cityName',
    value: 'RAHATA, MAHARASHTRA',
    masterId: 14548,
  },
  {
    type: 'cityName',
    value: 'MANDHOLI, RAJASTHAN',
    masterId: 13393,
  },
  {
    type: 'cityName',
    value: 'SHIRUR, KARNATAKA',
    masterId: 15100,
  },
  {
    type: 'cityName',
    value: 'SATHUPALLI, TELANGANA',
    masterId: 14972,
  },
  {
    type: 'cityName',
    value: 'RANIYALA, GUJARAT',
    masterId: 14665,
  },
  {
    type: 'cityName',
    value: 'GAMBHOI, GUJARAT',
    masterId: 11614,
  },
  {
    type: 'cityName',
    value: 'SARAIGARH, BIHAR',
    masterId: 14937,
  },
  {
    type: 'cityName',
    value: 'KANGRA, HIMACHAL PRADESH',
    masterId: 12485,
  },
  {
    type: 'cityName',
    value: 'GAJAPATHINAGARAM, ANDHRA PRADESH',
    masterId: 11602,
  },
  {
    type: 'cityName',
    value: 'DEVALI, MAHARASHTRA',
    masterId: 11307,
  },
  {
    type: 'cityName',
    value: 'BEGAR, KARNATAKA',
    masterId: 10608,
  },
  {
    type: 'cityName',
    value: 'TURUKWADI, MAHARASHTRA',
    masterId: 15630,
  },
  {
    type: 'cityName',
    value: 'SASIHITHLU, KARNATAKA',
    masterId: 14961,
  },
  {
    type: 'cityName',
    value: 'SIDDHANTAM, ANDHRA PRADESH',
    masterId: 15142,
  },
  {
    type: 'cityName',
    value: 'DABOK, RAJASTHAN',
    masterId: 11183,
  },
  {
    type: 'cityName',
    value: 'AYOOR, KERALA',
    masterId: 10322,
  },
  {
    type: 'cityName',
    value: 'MAULASAR, RAJASTHAN',
    masterId: 13527,
  },
  {
    type: 'cityName',
    value: 'AUNTA BUILDING, BIHAR',
    masterId: 18798,
  },
  {
    type: 'cityName',
    value: 'BHELLA, ASSAM',
    masterId: 10735,
  },
  {
    type: 'cityName',
    value: 'UMARKHED, MAHARASHTRA',
    masterId: 15670,
  },
  {
    type: 'cityName',
    value: 'BALLARI, KARNATAKA',
    masterId: 10434,
  },
  {
    type: 'cityName',
    value: 'KUKKE SUBRAMANYA RD, KARNATAKA',
    masterId: 12981,
  },
  {
    type: 'cityName',
    value: 'NANJANAGUDU, KARNATAKA',
    masterId: 13872,
  },
  {
    type: 'cityName',
    value: 'KHARA, GUJARAT',
    masterId: 12716,
  },
  {
    type: 'cityName',
    value: 'SACHERIPETE, KARNATAKA',
    masterId: 14784,
  },
  {
    type: 'cityName',
    value: 'GAGANBAWDA, MAHARASHTRA',
    masterId: 11597,
  },
  {
    type: 'cityName',
    value: 'KODAGU, KARNATAKA',
    masterId: 12809,
  },
  {
    type: 'cityName',
    value: 'SHAHAPUR, KARNATAKA',
    masterId: 15043,
  },
  {
    type: 'cityName',
    value: 'DOLATPAR, GUJARAT',
    masterId: 11454,
  },
  {
    type: 'cityName',
    value: 'VADACHERI, TAMIL NADU',
    masterId: 15723,
  },
  {
    type: 'cityName',
    value: 'CHINTPURNI, HIMACHAL PRADESH',
    masterId: 11117,
  },
  {
    type: 'cityName',
    value: 'KATAPADY, KARNATAKA',
    masterId: 12587,
  },
  {
    type: 'cityName',
    value: 'CHINTALAPUDI, ANDHRA PRADESH',
    masterId: 11113,
  },
  {
    type: 'cityName',
    value: 'BATHALAPALLI, ANDHRA PRADESH',
    masterId: 10585,
  },
  {
    type: 'cityName',
    value: 'SANJALI, GUJARAT',
    masterId: 18401,
  },
  {
    type: 'cityName',
    value: 'KARLAPALEM, ANDHRA PRADESH',
    masterId: 12562,
  },
  {
    type: 'cityName',
    value: 'ARAVAKURICHI, TAMIL NADU',
    masterId: 10240,
  },
  {
    type: 'cityName',
    value: 'UNAVA, GUJARAT',
    masterId: 15683,
  },
  {
    type: 'cityName',
    value: 'SAGARA, KARNATAKA',
    masterId: 14799,
  },
  {
    type: 'cityName',
    value: 'PATHARDI, MAHARASHTRA',
    masterId: 14289,
  },
  {
    type: 'cityName',
    value: 'MUKHED, MAHARASHTRA',
    masterId: 13694,
  },
  {
    type: 'cityName',
    value: 'KAVALKINARU, TAMIL NADU',
    masterId: 12617,
  },
  {
    type: 'cityName',
    value: 'VEMAGIRI, ANDHRA PRADESH',
    masterId: 15839,
  },
  {
    type: 'cityName',
    value: 'THANDAVANKADU, TAMIL NADU',
    masterId: 15494,
  },
  {
    type: 'cityName',
    value: 'PASUVANTHANAI, TAMIL NADU',
    masterId: 14277,
  },
  {
    type: 'cityName',
    value: 'NANDASAN, GUJARAT',
    masterId: 13857,
  },
  {
    type: 'cityName',
    value: 'DOOPADA KATTE, KARNATAKA',
    masterId: 11463,
  },
  {
    type: 'cityName',
    value: 'VENGURLA-SHIRODA, MAHARASHTRA',
    masterId: 15847,
  },
  {
    type: 'cityName',
    value: 'KUNDA, UTTAR PRADESH',
    masterId: 13016,
  },
  {
    type: 'cityName',
    value: 'VEKRA, GUJARAT',
    masterId: 15824,
  },
  {
    type: 'cityName',
    value: 'SARKHADIYA, GUJARAT',
    masterId: 14954,
  },
  {
    type: 'cityName',
    value: 'ADIMALI, KERALA',
    masterId: 10030,
  },
  {
    type: 'cityName',
    value: 'KALAYARKOIL, TAMIL NADU',
    masterId: 12387,
  },
  {
    type: 'cityName',
    value: 'MORTHAD, TELANGANA',
    masterId: 13655,
  },
  {
    type: 'cityName',
    value: 'ALATHUR, KERALA',
    masterId: 10100,
  },
  {
    type: 'cityName',
    value: 'NELLIMARLA, ANDHRA PRADESH',
    masterId: 13962,
  },
  {
    type: 'cityName',
    value: 'RAYACHOTI, ANDHRA PRADESH',
    masterId: 14702,
  },
  {
    type: 'cityName',
    value: 'SHIRIYARA, KARNATAKA',
    masterId: 15094,
  },
  {
    type: 'cityName',
    value: 'MURDESHWAR, KARNATAKA',
    masterId: 13744,
  },
  {
    type: 'cityName',
    value: 'PERURU, ANDHRA PRADESH',
    masterId: 14374,
  },
  {
    type: 'cityName',
    value: 'KHADEWADI, MAHARASHTRA',
    masterId: 12674,
  },
  {
    type: 'cityName',
    value: 'BHUTDI, GUJARAT',
    masterId: 10791,
  },
  {
    type: 'cityName',
    value: 'HIRIADKA, KARNATAKA',
    masterId: 12002,
  },
  {
    type: 'cityName',
    value: 'SANGAREDDY, TELANGANA',
    masterId: 14898,
  },
  {
    type: 'cityName',
    value: 'KOTTAIPATTINAM, TAMIL NADU',
    masterId: 12929,
  },
  {
    type: 'cityName',
    value: 'ALAND, KARNATAKA',
    masterId: 10090,
  },
  {
    type: 'cityName',
    value: 'NERI, MAHARASHTRA',
    masterId: 13974,
  },
  {
    type: 'cityName',
    value: 'NAGAJ, MAHARASHTRA',
    masterId: 13791,
  },
  {
    type: 'cityName',
    value: 'MANAKUNNAM, KERALA',
    masterId: 13353,
  },
  {
    type: 'cityName',
    value: 'MATAL, HIMACHAL PRADESH',
    masterId: 13510,
  },
  {
    type: 'cityName',
    value: 'JAMVALA, GUJARAT',
    masterId: 12186,
  },
  {
    type: 'cityName',
    value: 'PETLAWAD, MADHYA PRADESH',
    masterId: 14378,
  },
  {
    type: 'cityName',
    value: 'NANDIGAMA, ANDHRA PRADESH',
    masterId: 13860,
  },
  {
    type: 'cityName',
    value: 'PURATHUR, KERALA',
    masterId: 14509,
  },
  {
    type: 'cityName',
    value: 'DHARAMPUR, GUJARAT',
    masterId: 11358,
  },
  {
    type: 'cityName',
    value: 'DHAMNOD, MADHYA PRADESH',
    masterId: 11338,
  },
  {
    type: 'cityName',
    value: 'GOWRIPATNAM, ANDHRA PRADESH',
    masterId: 11798,
  },
  {
    type: 'cityName',
    value: 'PARIGI, ANDHRA PRADESH',
    masterId: 14250,
  },
  {
    type: 'cityName',
    value: 'VALANCHERY, KERALA',
    masterId: 15754,
  },
  {
    type: 'cityName',
    value: 'PIMPALGAON, MAHARASHTRA',
    masterId: 14401,
  },
  {
    type: 'cityName',
    value: 'DESALPAR, GUJARAT',
    masterId: 11295,
  },
  {
    type: 'cityName',
    value: 'TEMBHURNI, MAHARASHTRA',
    masterId: 15471,
  },
  {
    type: 'cityName',
    value: 'MURARI, ANDHRA PRADESH',
    masterId: 13741,
  },
  {
    type: 'cityName',
    value: 'MANSAR, MAHARASHTRA',
    masterId: 13462,
  },
  {
    type: 'cityName',
    value: 'ALWARTHIRUNAGARI, TAMIL NADU',
    masterId: 10122,
  },
  {
    type: 'cityName',
    value: 'VELAVADAR, GUJARAT',
    masterId: 15827,
  },
  {
    type: 'cityName',
    value: 'KODUNGOOR, KERALA',
    masterId: 12823,
  },
  {
    type: 'cityName',
    value: 'HARIJ, GUJARAT',
    masterId: 11936,
  },
  {
    type: 'cityName',
    value: 'CUMBUM, TAMIL NADU',
    masterId: 11173,
  },
  {
    type: 'cityName',
    value: 'KALLADKA, KARNATAKA',
    masterId: 12406,
  },
  {
    type: 'cityName',
    value: 'UZHAVOOR MONIPALLY RD, KERALA',
    masterId: 15719,
  },
  {
    type: 'cityName',
    value: 'DORIGALLU, ANDHRA PRADESH',
    masterId: 11465,
  },
  {
    type: 'cityName',
    value: 'MOTIVAVDI, GUJARAT',
    masterId: 13668,
  },
  {
    type: 'cityName',
    value: 'CHANDIKOL, ORISSA',
    masterId: 10983,
  },
  {
    type: 'cityName',
    value: 'DIGRAS, MAHARASHTRA',
    masterId: 11428,
  },
  {
    type: 'cityName',
    value: 'BULBAR, KARNATAKA',
    masterId: 10922,
  },
  {
    type: 'cityName',
    value: 'SIRALKOPPA, KARNATAKA',
    masterId: 15203,
  },
  {
    type: 'cityName',
    value: 'PAZHAYAKAYAL, TAMIL NADU',
    masterId: 14326,
  },
  {
    type: 'cityName',
    value: 'MOTHI, MADHYA PRADESH',
    masterId: 13662,
  },
  {
    type: 'cityName',
    value: 'DEVIKOT, RAJASTHAN',
    masterId: 11317,
  },
  {
    type: 'cityName',
    value: 'KODAI ROAD, TAMIL NADU',
    masterId: 12810,
  },
  {
    type: 'cityName',
    value: 'ALLAVARAM, ANDHRA PRADESH',
    masterId: 10111,
  },
  {
    type: 'cityName',
    value: 'THAMARASSERY, KERALA',
    masterId: 15491,
  },
  {
    type: 'cityName',
    value: 'BILYALA, GUJARAT',
    masterId: 10836,
  },
  {
    type: 'cityName',
    value: 'VETTAVALAM, TAMIL NADU',
    masterId: 15860,
  },
  {
    type: 'cityName',
    value: 'PULIYANKUDI, TAMIL NADU',
    masterId: 14486,
  },
  {
    type: 'cityName',
    value: 'PEDDAPURAM, ANDHRA PRADESH',
    masterId: 14338,
  },
  {
    type: 'cityName',
    value: 'NAVAPUR, MAHARASHTRA',
    masterId: 13928,
  },
  {
    type: 'cityName',
    value: 'KOVALAM, KERALA',
    masterId: 12940,
  },
  {
    type: 'cityName',
    value: 'MANDWA, MADHYA PRADESH',
    masterId: 13406,
  },
  {
    type: 'cityName',
    value: 'GHANTVAD, GUJARAT',
    masterId: 11689,
  },
  {
    type: 'cityName',
    value: 'VINJAMUR, ANDHRA PRADESH',
    masterId: 15887,
  },
  {
    type: 'cityName',
    value: 'KOLHAR, KARNATAKA',
    masterId: 12844,
  },
  {
    type: 'cityName',
    value: 'KULITHALAI, TAMIL NADU',
    masterId: 12993,
  },
  {
    type: 'cityName',
    value: 'RAJPARA, GUJARAT',
    masterId: 14592,
  },
  {
    type: 'cityName',
    value: 'KENPURA, RAJASTHAN',
    masterId: 12653,
  },
  {
    type: 'cityName',
    value: 'HOOVINA HADAGALI, KARNATAKA',
    masterId: 12023,
  },
  {
    type: 'cityName',
    value: 'NAKODA, RAJASTHAN',
    masterId: 13833,
  },
  {
    type: 'cityName',
    value: 'PERAVARAM, ANDHRA PRADESH',
    masterId: 14359,
  },
  {
    type: 'cityName',
    value: 'KUNKAVAV, GUJARAT',
    masterId: 13025,
  },
  {
    type: 'cityName',
    value: 'HUBALI-DHARWAD, KARNATAKA',
    masterId: 12036,
  },
  {
    type: 'cityName',
    value: 'BALSAR, HIMACHAL PRADESH',
    masterId: 10441,
  },
  {
    type: 'cityName',
    value: 'PALAMANER, ANDHRA PRADESH',
    masterId: 14142,
  },
  {
    type: 'cityName',
    value: 'AMRUTHALUR, ANDHRA PRADESH',
    masterId: 10179,
  },
  {
    type: 'cityName',
    value: 'THALIPARAMBA, KERALA',
    masterId: 15487,
  },
  {
    type: 'cityName',
    value: 'MAIN ROAD GANGOLLI, KARNATAKA',
    masterId: 13281,
  },
  {
    type: 'cityName',
    value: 'CHAGALLU, ANDHRA PRADESH',
    masterId: 10948,
  },
  {
    type: 'cityName',
    value: 'KHIRSARA, GUJARAT',
    masterId: 12758,
  },
  {
    type: 'cityName',
    value: 'SANOOR, KARNATAKA',
    masterId: 14914,
  },
  {
    type: 'cityName',
    value: 'THOKOTTU, KARNATAKA',
    masterId: 15530,
  },
  {
    type: 'cityName',
    value: 'PADYARABETTU, KARNATAKA',
    masterId: 14123,
  },
  {
    type: 'cityName',
    value: 'PULLAD, KERALA',
    masterId: 14490,
  },
  {
    type: 'cityName',
    value: 'ITTAMOZHI, TAMIL NADU',
    masterId: 12096,
  },
  {
    type: 'cityName',
    value: 'CHOTRA, GUJARAT',
    masterId: 11153,
  },
  {
    type: 'cityName',
    value: 'GUNDYA, KARNATAKA',
    masterId: 11846,
  },
  {
    type: 'cityName',
    value: 'KANOD, RAJASTHAN',
    masterId: 12507,
  },
  {
    type: 'cityName',
    value: 'MANDVI, GUJARAT',
    masterId: 13405,
  },
  {
    type: 'cityName',
    value: 'CHIKKABALLAPURA, KARNATAKA',
    masterId: 11080,
  },
  {
    type: 'cityName',
    value: 'TISGOAN, MAHARASHTRA',
    masterId: 15587,
  },
  {
    type: 'cityName',
    value: 'THODAR, KARNATAKA',
    masterId: 15528,
  },
  {
    type: 'cityName',
    value: 'WAYANGANI, MAHARASHTRA',
    masterId: 15957,
  },
  {
    type: 'cityName',
    value: 'VELANGI, ANDHRA PRADESH',
    masterId: 15825,
  },
  {
    type: 'cityName',
    value: 'TELGAON, MAHARASHTRA',
    masterId: 15468,
  },
  {
    type: 'cityName',
    value: 'BANAVARA, KARNATAKA',
    masterId: 10462,
  },
  {
    type: 'cityName',
    value: 'BHINDER, RAJASTHAN',
    masterId: 10753,
  },
  {
    type: 'cityName',
    value: 'DESURI, RAJASTHAN',
    masterId: 11301,
  },
  {
    type: 'cityName',
    value: 'PANIYA, GUJARAT',
    masterId: 14214,
  },
  {
    type: 'cityName',
    value: 'CHITAL, GUJARAT',
    masterId: 11128,
  },
  {
    type: 'cityName',
    value: 'E.KOTA, ANDHRA PRADESH',
    masterId: 11510,
  },
  {
    type: 'cityName',
    value: 'BAGRA, RAJASTHAN',
    masterId: 10378,
  },
  {
    type: 'cityName',
    value: 'ALAMURU, ANDHRA PRADESH',
    masterId: 10089,
  },
  {
    type: 'cityName',
    value: 'ALANTHALAI, TAMIL NADU',
    masterId: 10095,
  },
  {
    type: 'cityName',
    value: 'TAKHATGARH, RAJASTHAN',
    masterId: 15393,
  },
  {
    type: 'cityName',
    value: 'KOLENCHERY, KERALA',
    masterId: 12841,
  },
  {
    type: 'cityName',
    value: 'ALLAGADDA, ANDHRA PRADESH',
    masterId: 10108,
  },
  {
    type: 'cityName',
    value: 'HALEKATTE, KARNATAKA',
    masterId: 11902,
  },
  {
    type: 'cityName',
    value: 'BHANJPUR, ORISSA',
    masterId: 17518,
  },
  {
    type: 'cityName',
    value: 'DANTIWADA, GUJARAT',
    masterId: 11226,
  },
  {
    type: 'cityName',
    value: 'SHRIRAMPUR, MAHARASHTRA',
    masterId: 15130,
  },
  {
    type: 'cityName',
    value: 'HARPANAHALLI, KARNATAKA',
    masterId: 11949,
  },
  {
    type: 'cityName',
    value: 'KADATCHAPURAM, TAMIL NADU',
    masterId: 12323,
  },
  {
    type: 'cityName',
    value: 'ALURU, ANDHRA PRADESH',
    masterId: 10117,
  },
  {
    type: 'cityName',
    value: 'SANODAR, GUJARAT',
    masterId: 14913,
  },
  {
    type: 'cityName',
    value: 'MAKHIYALA, GUJARAT',
    masterId: 13290,
  },
  {
    type: 'cityName',
    value: 'ARTHUNKAL, KERALA',
    masterId: 10256,
  },
  {
    type: 'cityName',
    value: 'TURBHE, MAHARASHTRA',
    masterId: 15627,
  },
  {
    type: 'cityName',
    value: 'PULIAMPATTI, TAMIL NADU',
    masterId: 14482,
  },
  {
    type: 'cityName',
    value: 'VANTIMITTA, ANDHRA PRADESH',
    masterId: 15783,
  },
  {
    type: 'cityName',
    value: 'KAMAREDDY, TELANGANA',
    masterId: 12444,
  },
  {
    type: 'cityName',
    value: 'VELE, MAHARASHTRA',
    masterId: 15830,
  },
  {
    type: 'cityName',
    value: 'MUMMIDIVARAM, ANDHRA PRADESH',
    masterId: 13714,
  },
  {
    type: 'cityName',
    value: 'SAMPEKATTE-KOLLUR RD, KARNATAKA',
    masterId: 14878,
  },
  {
    type: 'cityName',
    value: 'PARTIBAMIYUR, TAMIL NADU',
    masterId: 14269,
  },
  {
    type: 'cityName',
    value: 'SORABA, KARNATAKA',
    masterId: 15281,
  },
  {
    type: 'cityName',
    value: 'KANBHA, GUJARAT',
    masterId: 12467,
  },
  {
    type: 'cityName',
    value: 'BHATNAVILLI, ANDHRA PRADESH',
    masterId: 10719,
  },
  {
    type: 'cityName',
    value: 'KUVADVA, GUJARAT',
    masterId: 13068,
  },
  {
    type: 'cityName',
    value: 'KALATHOOR, KERALA',
    masterId: 12382,
  },
  {
    type: 'cityName',
    value: 'NERUR, MAHARASHTRA',
    masterId: 13977,
  },
  {
    type: 'cityName',
    value: 'ARANTHANGI, TAMIL NADU',
    masterId: 10237,
  },
  {
    type: 'cityName',
    value: 'VARIKUNTAPADU, ANDHRA PRADESH',
    masterId: 15791,
  },
  {
    type: 'cityName',
    value: 'CHINTAPARTHI, ANDHRA PRADESH',
    masterId: 11116,
  },
  {
    type: 'cityName',
    value: 'PERAVALI, ANDHRA PRADESH',
    masterId: 14358,
  },
  {
    type: 'cityName',
    value: 'DATRANA, GUJARAT',
    masterId: 11251,
  },
  {
    type: 'cityName',
    value: 'BANGARUPALYEM, ANDHRA PRADESH',
    masterId: 10476,
  },
  {
    type: 'cityName',
    value: 'IRITTY, KERALA',
    masterId: 12080,
  },
  {
    type: 'cityName',
    value: 'BAMBAVADE, MAHARASHTRA',
    masterId: 10447,
  },
  {
    type: 'cityName',
    value: 'BABAPUR, GUJARAT',
    masterId: 10325,
  },
  {
    type: 'cityName',
    value: 'TANDA, UTTAR PRADESH',
    masterId: 15424,
  },
  {
    type: 'cityName',
    value: 'AGIRIPALLY, ANDHRA PRADESH',
    masterId: 10046,
  },
  {
    type: 'cityName',
    value: 'HIMMATH NAGAR, GUJARAT',
    masterId: 11987,
  },
  {
    type: 'cityName',
    value: 'SHIVGANJ, RAJASTHAN',
    masterId: 15111,
  },
  {
    type: 'cityName',
    value: 'TATIPAKA, ANDHRA PRADESH',
    masterId: 15456,
  },
  {
    type: 'cityName',
    value: 'RAMOD, GUJARAT',
    masterId: 14628,
  },
  {
    type: 'cityName',
    value: 'BHAVANI, TAMIL NADU',
    masterId: 10724,
  },
  {
    type: 'cityName',
    value: 'SHEOPUR, MADHYA PRADESH',
    masterId: 15082,
  },
  {
    type: 'cityName',
    value: 'RAZAM, ANDHRA PRADESH',
    masterId: 14708,
  },
  {
    type: 'cityName',
    value: 'ATHANI, KERALA',
    masterId: 10288,
  },
  {
    type: 'cityName',
    value: 'PERAMBRA, KERALA',
    masterId: 14357,
  },
  {
    type: 'cityName',
    value: 'ICHALKARANJI, MAHARASHTRA',
    masterId: 12052,
  },
  {
    type: 'cityName',
    value: 'BATLAGUNDU, TAMIL NADU',
    masterId: 10587,
  },
  {
    type: 'cityName',
    value: 'LAKHAN PUR, UTTAR PRADESH',
    masterId: 13081,
  },
  {
    type: 'cityName',
    value: 'PATHIYARAKKARA, KERALA',
    masterId: 14294,
  },
  {
    type: 'cityName',
    value: 'YERRAVARAM, ANDHRA PRADESH',
    masterId: 15999,
  },
  {
    type: 'cityName',
    value: 'ANJANGAON, MAHARASHTRA',
    masterId: 10208,
  },
  {
    type: 'cityName',
    value: 'DEHRA, HARYANA',
    masterId: 11271,
  },
  {
    type: 'cityName',
    value: 'UJJANI, MAHARASHTRA',
    masterId: 15656,
  },
  {
    type: 'cityName',
    value: 'SHIRVA, KARNATAKA',
    masterId: 15102,
  },
  {
    type: 'cityName',
    value: 'KUPPAMPATTI, TAMIL NADU',
    masterId: 13033,
  },
  {
    type: 'cityName',
    value: 'T KALATHUR TO TRICHY RD, TAMIL NADU',
    masterId: 15370,
  },
  {
    type: 'cityName',
    value: 'RON, KARNATAKA',
    masterId: 14752,
  },
  {
    type: 'cityName',
    value: 'MURINGUR VADAKKUMMURI, KERALA',
    masterId: 13748,
  },
  {
    type: 'cityName',
    value: 'JAYAL, RAJASTHAN',
    masterId: 12223,
  },
  {
    type: 'cityName',
    value: 'LIMDA, GUJARAT',
    masterId: 13143,
  },
  {
    type: 'cityName',
    value: 'PARAPPADI, TAMIL NADU',
    masterId: 14235,
  },
  {
    type: 'cityName',
    value: 'UMRALA, GUJARAT',
    masterId: 15676,
  },
  {
    type: 'cityName',
    value: 'ADEKHA, JHARKHAND',
    masterId: 10026,
  },
  {
    type: 'cityName',
    value: 'LAMBIYA, UTTAR PRADESH',
    masterId: 13109,
  },
  {
    type: 'cityName',
    value: 'BHAIRUMBE, KARNATAKA',
    masterId: 10681,
  },
  {
    type: 'cityName',
    value: 'NIPANI-MAHALINGPUR RD, KARNATAKA',
    masterId: 14023,
  },
  {
    type: 'cityName',
    value: 'PAUR, BIHAR',
    masterId: 14317,
  },
  {
    type: 'cityName',
    value: 'SHIRALA, MAHARASHTRA',
    masterId: 15091,
  },
  {
    type: 'cityName',
    value: 'PRANTIJ, RAJASTHAN',
    masterId: 14464,
  },
  {
    type: 'cityName',
    value: 'JUNA SAVAR, GUJARAT',
    masterId: 12293,
  },
  {
    type: 'cityName',
    value: 'BAILUR, KARNATAKA',
    masterId: 10399,
  },
  {
    type: 'cityName',
    value: 'PEDDA OGIRALA, ANDHRA PRADESH',
    masterId: 14334,
  },
  {
    type: 'cityName',
    value: 'KAGWAD, KARNATAKA',
    masterId: 12339,
  },
  {
    type: 'cityName',
    value: 'KHATRA, WEST BENGAL',
    masterId: 12734,
  },
  {
    type: 'cityName',
    value: 'NDA JUNCTION, MAHARASHTRA',
    masterId: 13952,
  },
  {
    type: 'cityName',
    value: 'ASHTA, MAHARASHTRA',
    masterId: 10271,
  },
  {
    type: 'cityName',
    value: 'KOTHANALLOOR, KERALA',
    masterId: 12914,
  },
  {
    type: 'cityName',
    value: 'GHATABILLOD, MADHYA PRADESH',
    masterId: 11691,
  },
  {
    type: 'cityName',
    value: 'PINJORE, HARYANA',
    masterId: 14409,
  },
  {
    type: 'cityName',
    value: 'VICTOR, GUJARAT',
    masterId: 15863,
  },
  {
    type: 'cityName',
    value: 'VIRASIGAMANI, TAMIL NADU',
    masterId: 15893,
  },
  {
    type: 'cityName',
    value: 'NAGARAM, ANDHRA PRADESH',
    masterId: 13797,
  },
  {
    type: 'cityName',
    value: 'AMBARNATH, MAHARASHTRA',
    masterId: 10149,
  },
  {
    type: 'cityName',
    value: 'DHOKADVA, GUJARAT',
    masterId: 11394,
  },
  {
    type: 'cityName',
    value: 'KALLACHI, KERALA',
    masterId: 12404,
  },
  {
    type: 'cityName',
    value: 'SANDHOLI, HARYANA',
    masterId: 14891,
  },
  {
    type: 'cityName',
    value: 'SENDHWA, MADHYA PRADESH',
    masterId: 15019,
  },
  {
    type: 'cityName',
    value: 'BEDHIYA, GUJARAT',
    masterId: 10605,
  },
  {
    type: 'cityName',
    value: 'KARAIMEDU, TAMIL NADU',
    masterId: 12527,
  },
  {
    type: 'cityName',
    value: 'KALYAN, MAHARASHTRA',
    masterId: 12432,
  },
  {
    type: 'cityName',
    value: 'KAKUMANU, ANDHRA PRADESH',
    masterId: 12364,
  },
  {
    type: 'cityName',
    value: 'THIKRI, MADHYA PRADESH',
    masterId: 15507,
  },
  {
    type: 'cityName',
    value: 'URAMBU, TAMIL NADU',
    masterId: 15708,
  },
  {
    type: 'cityName',
    value: 'MUTHUPETTAI, TAMIL NADU',
    masterId: 13763,
  },
  {
    type: 'cityName',
    value: 'KUWARIYA, RAJASTHAN',
    masterId: 13069,
  },
  {
    type: 'cityName',
    value: 'JAMBUDA, GUJARAT',
    masterId: 12171,
  },
  {
    type: 'cityName',
    value: 'NIRMAL, TELANGANA',
    masterId: 14031,
  },
  {
    type: 'cityName',
    value: 'CHANNARAYAPATTANA, KARNATAKA',
    masterId: 11005,
  },
  {
    type: 'cityName',
    value: 'SAWARDE, MAHARASHTRA',
    masterId: 14998,
  },
  {
    type: 'cityName',
    value: 'DEVAR HIPPARGI, KARNATAKA',
    masterId: 11309,
  },
  {
    type: 'cityName',
    value: 'TADEPALLI, ANDHRA PRADESH',
    masterId: 15378,
  },
  {
    type: 'cityName',
    value: 'AMBALAPPUZHA, KERALA',
    masterId: 10143,
  },
  {
    type: 'cityName',
    value: 'PANSAR, GUJARAT',
    masterId: 18534,
  },
  {
    type: 'cityName',
    value: 'KOOTTANAD, KERALA',
    masterId: 12875,
  },
  {
    type: 'cityName',
    value: 'PANCHPIPLA, GUJARAT',
    masterId: 14192,
  },
  {
    type: 'cityName',
    value: 'NAGESHREE, GUJARAT',
    masterId: 13806,
  },
  {
    type: 'cityName',
    value: 'KALLAKURICHI, TAMIL NADU',
    masterId: 12408,
  },
  {
    type: 'cityName',
    value: 'UDMA, KERALA',
    masterId: 15645,
  },
  {
    type: 'cityName',
    value: 'MADHAVARAM, ANDHRA PRADESH',
    masterId: 13206,
  },
  {
    type: 'cityName',
    value: 'BORRAMPALEM, ANDHRA PRADESH',
    masterId: 10898,
  },
  {
    type: 'cityName',
    value: 'VAIBHAVWADI, MAHARASHTRA',
    masterId: 15747,
  },
  {
    type: 'cityName',
    value: 'JHALRAPATAN, RAJASTHAN',
    masterId: 12246,
  },
  {
    type: 'cityName',
    value: 'PORUMAMILLA, ANDHRA PRADESH',
    masterId: 14455,
  },
  {
    type: 'cityName',
    value: 'HEMAL, GUJARAT',
    masterId: 11979,
  },
  {
    type: 'cityName',
    value: 'RAIPURIYA, RAJASTHAN',
    masterId: 14562,
  },
  {
    type: 'cityName',
    value: 'DOMMERU, ANDHRA PRADESH',
    masterId: 11456,
  },
  {
    type: 'cityName',
    value: 'KURUDAMPALAYAM, TAMIL NADU',
    masterId: 13045,
  },
  {
    type: 'cityName',
    value: 'MUPKAL, TELANGANA',
    masterId: 13735,
  },
  {
    type: 'cityName',
    value: 'LONI, UTTAR PRADESH',
    masterId: 13165,
  },
  {
    type: 'cityName',
    value: 'MUKTHESWARAM, ANDHRA PRADESH',
    masterId: 13699,
  },
  {
    type: 'cityName',
    value: 'KURNAD, KARNATAKA',
    masterId: 13041,
  },
  {
    type: 'cityName',
    value: 'NITTE, KARNATAKA',
    masterId: 14034,
  },
  {
    type: 'cityName',
    value: 'SHAHADA, MAHARASHTRA',
    masterId: 15041,
  },
  {
    type: 'cityName',
    value: 'MANAMELKUDI, TAMIL NADU',
    masterId: 13356,
  },
  {
    type: 'cityName',
    value: 'SARATH, JHARKHAND',
    masterId: 14942,
  },
  {
    type: 'cityName',
    value: 'KIDANGOOR, KERALA',
    masterId: 12779,
  },
  {
    type: 'cityName',
    value: 'SAPAR, GUJARAT',
    masterId: 14926,
  },
  {
    type: 'cityName',
    value: 'ULLIYERI, KERALA',
    masterId: 15666,
  },
  {
    type: 'cityName',
    value: 'TAPRA, RAJASTHAN',
    masterId: 15436,
  },
  {
    type: 'cityName',
    value: 'NARAYANAPURAM, ANDHRA PRADESH',
    masterId: 13889,
  },
  {
    type: 'cityName',
    value: 'CHUNDI, ANDHRA PRADESH',
    masterId: 11157,
  },
  {
    type: 'cityName',
    value: 'MUKKAM, KERALA',
    masterId: 13696,
  },
  {
    type: 'cityName',
    value: 'TAGDI UNCHADI RD, GUJARAT',
    masterId: 15388,
  },
  {
    type: 'cityName',
    value: 'VEDASANDUR, TAMIL NADU',
    masterId: 15815,
  },
  {
    type: 'cityName',
    value: 'BALKONDA, TELANGANA',
    masterId: 10433,
  },
  {
    type: 'cityName',
    value: 'NANDIMANDALAM, ANDHRA PRADESH',
    masterId: 13862,
  },
  {
    type: 'cityName',
    value: 'MANEKWADA, GUJARAT',
    masterId: 13409,
  },
  {
    type: 'cityName',
    value: 'MALKIPURAM, ANDHRA PRADESH',
    masterId: 13326,
  },
  {
    type: 'cityName',
    value: 'ENGANDIYOOR, KERALA',
    masterId: 11530,
  },
  {
    type: 'cityName',
    value: 'ARAWALI, MAHARASHTRA',
    masterId: 10241,
  },
  {
    type: 'cityName',
    value: 'GODHAVADAR, GUJARAT',
    masterId: 11732,
  },
  {
    type: 'cityName',
    value: 'KRISHNANAGAR, WEST BENGAL',
    masterId: 12956,
  },
  {
    type: 'cityName',
    value: 'KARUKUTTY, KERALA',
    masterId: 12570,
  },
  {
    type: 'cityName',
    value: 'KAIGA, KARNATAKA',
    masterId: 12344,
  },
  {
    type: 'cityName',
    value: 'KAIJ, MAHARASHTRA',
    masterId: 12345,
  },
  {
    type: 'cityName',
    value: 'GURRAM KONDA, ANDHRA PRADESH',
    masterId: 11865,
  },
  {
    type: 'cityName',
    value: 'KHAMGAON, MAHARASHTRA',
    masterId: 12703,
  },
  {
    type: 'cityName',
    value: 'HUNSUR, KARNATAKA',
    masterId: 12045,
  },
  {
    type: 'cityName',
    value: 'THANDLA, MADHYA PRADESH',
    masterId: 15495,
  },
  {
    type: 'cityName',
    value: 'BAJIPURA, GUJARAT',
    masterId: 10404,
  },
  {
    type: 'cityName',
    value: 'ALANGULAM, TAMIL NADU',
    masterId: 10093,
  },
  {
    type: 'cityName',
    value: 'KANKIPADU, ANDHRA PRADESH',
    masterId: 12500,
  },
  {
    type: 'cityName',
    value: 'BADRINATH, UTTARAKHAND',
    masterId: 10357,
  },
  {
    type: 'cityName',
    value: 'MDR, RAJASTHAN',
    masterId: 13541,
  },
  {
    type: 'cityName',
    value: 'BICHHIWARA, RAJASTHAN',
    masterId: 10796,
  },
  {
    type: 'cityName',
    value: 'KADAMANCHALI, ANDHRA PRADESH',
    masterId: 12317,
  },
  {
    type: 'cityName',
    value: 'MALPARA, GUJARAT',
    masterId: 13338,
  },
  {
    type: 'cityName',
    value: 'NEDUMKANDAM, KERALA',
    masterId: 13954,
  },
  {
    type: 'cityName',
    value: 'KONDOTTY, KERALA',
    masterId: 12869,
  },
  {
    type: 'cityName',
    value: 'PERINTHALMANNA, KERALA',
    masterId: 14365,
  },
  {
    type: 'cityName',
    value: 'KODAMANCHILI, ANDHRA PRADESH',
    masterId: 12815,
  },
  {
    type: 'cityName',
    value: 'DUBACHERLA, ANDHRA PRADESH',
    masterId: 11469,
  },
  {
    type: 'cityName',
    value: 'CHITHODE, TAMIL NADU',
    masterId: 11132,
  },
  {
    type: 'cityName',
    value: 'AKKALKOT, MAHARASHTRA',
    masterId: 10079,
  },
  {
    type: 'cityName',
    value: 'KRANKACH, GUJARAT',
    masterId: 12949,
  },
  {
    type: 'cityName',
    value: 'KHAJIPETA, ANDHRA PRADESH',
    masterId: 12684,
  },
  {
    type: 'cityName',
    value: 'KOLARAS, MADHYA PRADESH',
    masterId: 12838,
  },
  {
    type: 'cityName',
    value: 'ILAYANGUDI, TAMIL NADU',
    masterId: 12061,
  },
  {
    type: 'cityName',
    value: 'KANIPAKAM, ANDHRA PRADESH',
    masterId: 12490,
  },
  {
    type: 'cityName',
    value: 'VELAYUTHAMPALAYAM, TAMIL NADU',
    masterId: 15828,
  },
  {
    type: 'cityName',
    value: 'VASHI, MAHARASHTRA',
    masterId: 15801,
  },
  {
    type: 'cityName',
    value: 'RAJANAGARAM, ANDHRA PRADESH',
    masterId: 14572,
  },
  {
    type: 'cityName',
    value: 'SUNDERNAGAR, HIMACHAL PRADESH',
    masterId: 15342,
  },
  {
    type: 'cityName',
    value: 'MAGADI, KARNATAKA',
    masterId: 13226,
  },
  {
    type: 'cityName',
    value: 'SINDARLI, RAJASTHAN',
    masterId: 15181,
  },
  {
    type: 'cityName',
    value: 'RAWATBHATA, RAJASTHAN',
    masterId: 14697,
  },
  {
    type: 'cityName',
    value: 'ALAGIAMANDAPAM, TAMIL NADU',
    masterId: 10085,
  },
  {
    type: 'cityName',
    value: 'KEELAPAVOOR, TAMIL NADU',
    masterId: 12639,
  },
  {
    type: 'cityName',
    value: 'GADULI, GUJARAT',
    masterId: 11595,
  },
  {
    type: 'cityName',
    value: 'CHITTUR, KARNATAKA',
    masterId: 11140,
  },
  {
    type: 'cityName',
    value: 'SOANPET, TELANGANA',
    masterId: 15244,
  },
  {
    type: 'cityName',
    value: 'SHANISHINGNAPUR, MAHARASHTRA',
    masterId: 15061,
  },
  {
    type: 'cityName',
    value: 'JINTUR, MAHARASHTRA',
    masterId: 12268,
  },
  {
    type: 'cityName',
    value: 'AVANIGADDA, ANDHRA PRADESH',
    masterId: 10314,
  },
  {
    type: 'cityName',
    value: 'MELASEVAL, TAMIL NADU',
    masterId: 13565,
  },
  {
    type: 'cityName',
    value: 'VADAPALLI, ANDHRA PRADESH',
    masterId: 15732,
  },
  {
    type: 'cityName',
    value: 'TARALA, ORISSA',
    masterId: 15438,
  },
  {
    type: 'cityName',
    value: 'MEENAGADI, KERALA',
    masterId: 13550,
  },
  {
    type: 'cityName',
    value: 'KORUTLA, TELANGANA',
    masterId: 12891,
  },
  {
    type: 'cityName',
    value: 'BULDANA, MAHARASHTRA',
    masterId: 10923,
  },
  {
    type: 'cityName',
    value: 'YAVATMAL, MAHARASHTRA',
    masterId: 15979,
  },
  {
    type: 'cityName',
    value: 'SIRWAR, KARNATAKA',
    masterId: 15222,
  },
  {
    type: 'cityName',
    value: 'VYAS, PUNJAB',
    masterId: 15919,
  },
  {
    type: 'cityName',
    value: 'MANAVALAKURICHI, TAMIL NADU',
    masterId: 13366,
  },
  {
    type: 'cityName',
    value: 'SALAL, GUJARAT',
    masterId: 14836,
  },
  {
    type: 'cityName',
    value: 'BALIYA, RAJASTHAN',
    masterId: 10432,
  },
  {
    type: 'cityName',
    value: 'LONGADI, GUJARAT',
    masterId: 13163,
  },
  {
    type: 'cityName',
    value: 'VANARAMUTTI, TAMIL NADU',
    masterId: 15766,
  },
  {
    type: 'cityName',
    value: 'CHHOTI, ORISSA',
    masterId: 11067,
  },
  {
    type: 'cityName',
    value: 'ANKALI, KARNATAKA',
    masterId: 10211,
  },
  {
    type: 'cityName',
    value: 'MIRA BHAYANDAR, MAHARASHTRA',
    masterId: 13588,
  },
  {
    type: 'cityName',
    value: 'RANJANGAON, MAHARASHTRA',
    masterId: 14666,
  },
  {
    type: 'cityName',
    value: 'MOTI MARAD, GUJARAT',
    masterId: 13664,
  },
  {
    type: 'cityName',
    value: 'BAHVNAGAR, GUJARAT',
    masterId: 10392,
  },
  {
    type: 'cityName',
    value: 'VYTHIRI, KERALA',
    masterId: 15921,
  },
  {
    type: 'cityName',
    value: 'MAOLI, MADHYA PRADESH',
    masterId: 13475,
  },
  {
    type: 'cityName',
    value: 'MANI NAGAR, TAMIL NADU',
    masterId: 13429,
  },
  {
    type: 'cityName',
    value: 'SAMALAJI, GUJARAT',
    masterId: 14863,
  },
  {
    type: 'cityName',
    value: 'OTTAPIDARAM, TAMIL NADU',
    masterId: 14094,
  },
  {
    type: 'cityName',
    value: 'AJITGARH, GUJARAT',
    masterId: 10071,
  },
  {
    type: 'cityName',
    value: 'PATTIKONDA, ANDHRA PRADESH',
    masterId: 14313,
  },
  {
    type: 'cityName',
    value: 'LETA, RAJASTHAN',
    masterId: 13136,
  },
  {
    type: 'cityName',
    value: 'KOBADI, GUJARAT',
    masterId: 12805,
  },
  {
    type: 'cityName',
    value: 'BHADALI, MAHARASHTRA',
    masterId: 10658,
  },
  {
    type: 'cityName',
    value: 'ATHRADI, KARNATAKA',
    masterId: 10292,
  },
  {
    type: 'cityName',
    value: 'KUNDAL, GUJARAT',
    masterId: 13018,
  },
  {
    type: 'cityName',
    value: 'FULSAR, GUJARAT',
    masterId: 11581,
  },
  {
    type: 'cityName',
    value: 'MURNAD, KARNATAKA',
    masterId: 13750,
  },
  {
    type: 'cityName',
    value: 'MUGURU, KARNATAKA',
    masterId: 13689,
  },
  {
    type: 'cityName',
    value: 'NALLAJERLA, ANDHRA PRADESH',
    masterId: 13843,
  },
  {
    type: 'cityName',
    value: 'DHOKI TOWN, MAHARASHTRA',
    masterId: 11395,
  },
  {
    type: 'cityName',
    value: 'MAHALINGAPUR, KARNATAKA',
    masterId: 13241,
  },
  {
    type: 'cityName',
    value: 'CHAROTI, MAHARASHTRA',
    masterId: 11014,
  },
  {
    type: 'cityName',
    value: 'KHAREPATAN, MAHARASHTRA',
    masterId: 12721,
  },
  {
    type: 'cityName',
    value: 'GOSA, GUJARAT',
    masterId: 11780,
  },
  {
    type: 'cityName',
    value: 'CHALLAVARIPALLI, ANDHRA PRADESH',
    masterId: 19038,
  },
  {
    type: 'cityName',
    value: 'PERDUR, KARNATAKA',
    masterId: 14361,
  },
  {
    type: 'cityName',
    value: 'SAKTHINAGAR, TAMIL NADU',
    masterId: 14832,
  },
  {
    type: 'cityName',
    value: 'UTHAMAPALAYAM, TAMIL NADU',
    masterId: 15714,
  },
  {
    type: 'cityName',
    value: 'KEDAVUR, KERALA',
    masterId: 12637,
  },
  {
    type: 'cityName',
    value: 'ANKADIYA, GUJARAT',
    masterId: 10210,
  },
  {
    type: 'cityName',
    value: 'YALAMUNCHILI LANKA, ANDHRA PRADESH',
    masterId: 15970,
  },
  {
    type: 'cityName',
    value: 'JALALABAD, PUNJAB',
    masterId: 12149,
  },
  {
    type: 'cityName',
    value: 'PENAMALURU, ANDHRA PRADESH',
    masterId: 14347,
  },
  {
    type: 'cityName',
    value: 'JALSOOR, KARNATAKA',
    masterId: 12160,
  },
  {
    type: 'cityName',
    value: 'BHALVAV, GUJARAT',
    masterId: 10691,
  },
  {
    type: 'cityName',
    value: 'BIR, HIMACHAL PRADESH',
    masterId: 10841,
  },
  {
    type: 'cityName',
    value: 'GANDI, ANDHRA PRADESH',
    masterId: 11624,
  },
  {
    type: 'cityName',
    value: 'CHILAKALURIPET, ANDHRA PRADESH',
    masterId: 11087,
  },
  {
    type: 'cityName',
    value: 'THISAYANVILAI, TAMIL NADU',
    masterId: 15527,
  },
  {
    type: 'cityName',
    value: 'BILLADI, KARNATAKA',
    masterId: 10834,
  },
  {
    type: 'cityName',
    value: 'VAIJAPUR, MAHARASHTRA',
    masterId: 15748,
  },
  {
    type: 'cityName',
    value: 'ERATTUPETTA, KERALA',
    masterId: 11536,
  },
  {
    type: 'cityName',
    value: 'CHITVEL, ANDHRA PRADESH',
    masterId: 11142,
  },
  {
    type: 'cityName',
    value: 'TRIVENIGANJ, BIHAR',
    masterId: 15609,
  },
  {
    type: 'cityName',
    value: 'DEULGAON, MAHARASHTRA',
    masterId: 11303,
  },
  {
    type: 'cityName',
    value: 'CHAVAND, GUJARAT',
    masterId: 11029,
  },
  {
    type: 'cityName',
    value: 'NAYA BAZAR, UTTAR PRADESH',
    masterId: 13941,
  },
  {
    type: 'cityName',
    value: 'VEMULAPADU, ANDHRA PRADESH',
    masterId: 15842,
  },
  {
    type: 'cityName',
    value: 'CHINNAMANUR, TAMIL NADU',
    masterId: 11111,
  },
  {
    type: 'cityName',
    value: 'MANCHAKAL, KARNATAKA',
    masterId: 13367,
  },
  {
    type: 'cityName',
    value: 'ERANDOL, MAHARASHTRA',
    masterId: 11535,
  },
  {
    type: 'cityName',
    value: 'MOODUBELLE, KARNATAKA',
    masterId: 13633,
  },
  {
    type: 'cityName',
    value: 'JAMANVAV, GUJARAT',
    masterId: 12169,
  },
  {
    type: 'cityName',
    value: 'KATAR, MAHARASHTRA',
    masterId: 12588,
  },
  {
    type: 'cityName',
    value: 'NARAVI, KARNATAKA',
    masterId: 13887,
  },
  {
    type: 'cityName',
    value: 'RAPAR, GUJARAT',
    masterId: 14674,
  },
  {
    type: 'cityName',
    value: 'CHANDOOR, TELANGANA',
    masterId: 10987,
  },
  {
    type: 'cityName',
    value: 'MALEBENNUR, KARNATAKA',
    masterId: 13310,
  },
  {
    type: 'cityName',
    value: 'SUMERPUR, RAJASTHAN',
    masterId: 15335,
  },
  {
    type: 'cityName',
    value: 'CHINNA DHARAPURAM, TAMIL NADU',
    masterId: 11105,
  },
  {
    type: 'cityName',
    value: 'RAMPARA, GUJARAT',
    masterId: 14632,
  },
  {
    type: 'cityName',
    value: 'LAKHIMPUR KHERI, UTTAR PRADESH',
    masterId: 13085,
  },
  {
    type: 'cityName',
    value: 'KADANDALE, KARNATAKA',
    masterId: 12320,
  },
  {
    type: 'cityName',
    value: 'LAKKAVARAM, ANDHRA PRADESH',
    masterId: 13092,
  },
  {
    type: 'cityName',
    value: 'BADI SADRI RD, RAJASTHAN',
    masterId: 10344,
  },
  {
    type: 'cityName',
    value: 'RUPAIDIHA, UTTAR PRADESH',
    masterId: 14769,
  },
  {
    type: 'cityName',
    value: 'KOILKUNTLA, ANDHRA PRADESH',
    masterId: 12828,
  },
  {
    type: 'cityName',
    value: 'PALEM, TELANGANA',
    masterId: 14154,
  },
  {
    type: 'cityName',
    value: 'AMALAPURAM, ANDHRA PRADESH',
    masterId: 10123,
  },
  {
    type: 'cityName',
    value: 'NASHIRABAD, MAHARASHTRA',
    masterId: 13912,
  },
  {
    type: 'cityName',
    value: 'MEHSANA, GUJARAT',
    masterId: 13560,
  },
  {
    type: 'cityName',
    value: 'MUDINEPALLI, ANDHRA PRADESH',
    masterId: 13682,
  },
  {
    type: 'cityName',
    value: 'SHIVAMOGGA, KARNATAKA',
    masterId: 15107,
  },
  {
    type: 'cityName',
    value: 'BASAVANA BAGEWADI, KARNATAKA',
    masterId: 10572,
  },
  {
    type: 'cityName',
    value: 'JAKKALACHERUVU, ANDHRA PRADESH',
    masterId: 19063,
  },
  {
    type: 'cityName',
    value: 'GAVADKA, GUJARAT',
    masterId: 11678,
  },
  {
    type: 'cityName',
    value: 'SANDERAO, RAJASTHAN',
    masterId: 14890,
  },
  {
    type: 'cityName',
    value: 'MALVAN, MAHARASHTRA',
    masterId: 13343,
  },
  {
    type: 'cityName',
    value: 'PALAM, MAHARASHTRA',
    masterId: 14141,
  },
  {
    type: 'cityName',
    value: 'MANDARTHI, KARNATAKA',
    masterId: 13383,
  },
  {
    type: 'cityName',
    value: 'RAMESHWARAM, TAMIL NADU',
    masterId: 14619,
  },
  {
    type: 'cityName',
    value: 'UPPUNDA, KARNATAKA',
    masterId: 15706,
  },
  {
    type: 'cityName',
    value: 'D.G.PETA, ANDHRA PRADESH',
    masterId: 11175,
  },
  {
    type: 'cityName',
    value: 'TALAJA, GUJARAT',
    masterId: 15398,
  },
  {
    type: 'cityName',
    value: 'AUTHOOR, TAMIL NADU',
    masterId: 10313,
  },
  {
    type: 'cityName',
    value: 'KOTPUTLI, RAJASTHAN',
    masterId: 12926,
  },
  {
    type: 'cityName',
    value: 'KODUNGALLUR, KERALA',
    masterId: 12822,
  },
  {
    type: 'cityName',
    value: 'NEW HARANGAJAO, ASSAM',
    masterId: 18877,
  },
  {
    type: 'cityName',
    value: 'KOLLAM - TIRUMANGALAM RD, TAMIL NADU',
    masterId: 12849,
  },
  {
    type: 'cityName',
    value: 'NEDUMUDY, KERALA',
    masterId: 13955,
  },
  {
    type: 'cityName',
    value: 'BERMOTI - SANGHIPURAM RD, GUJARAT',
    masterId: 10641,
  },
  {
    type: 'cityName',
    value: 'KHICHA, GUJARAT',
    masterId: 12753,
  },
  {
    type: 'cityName',
    value: 'KENICHIRA, KERALA',
    masterId: 12650,
  },
  {
    type: 'cityName',
    value: 'HARIPAR, GUJARAT',
    masterId: 11939,
  },
  {
    type: 'cityName',
    value: 'CHERUKUPALLI, ANDHRA PRADESH',
    masterId: 11046,
  },
  {
    type: 'cityName',
    value: 'MAJALGAON, MAHARASHTRA',
    masterId: 13284,
  },
  {
    type: 'cityName',
    value: 'KULUR, KARNATAKA',
    masterId: 12997,
  },
  {
    type: 'cityName',
    value: 'BELUR, KARNATAKA',
    masterId: 10632,
  },
  {
    type: 'cityName',
    value: 'LAXMANGARH, RAJASTHAN',
    masterId: 13129,
  },
  {
    type: 'cityName',
    value: 'VIRAJPET, KARNATAKA',
    masterId: 15889,
  },
  {
    type: 'cityName',
    value: 'MANAVADAR, GUJARAT',
    masterId: 13365,
  },
  {
    type: 'cityName',
    value: 'PAMURU, ANDHRA PRADESH',
    masterId: 14180,
  },
  {
    type: 'cityName',
    value: 'PIPLI, RAJASTHAN',
    masterId: 14415,
  },
  {
    type: 'cityName',
    value: 'SAIDAPUR, KARNATAKA',
    masterId: 14814,
  },
  {
    type: 'cityName',
    value: 'AIRODY, KARNATAKA',
    masterId: 10062,
  },
  {
    type: 'cityName',
    value: 'BORATA, MADHYA PRADESH',
    masterId: 10889,
  },
  {
    type: 'cityName',
    value: 'JULWANIA, MADHYA PRADESH',
    masterId: 12292,
  },
  {
    type: 'cityName',
    value: 'SIKKA, GUJARAT',
    masterId: 15158,
  },
  {
    type: 'cityName',
    value: 'SANGAM JAGALLAMUDI, ANDHRA PRADESH',
    masterId: 14894,
  },
  {
    type: 'cityName',
    value: 'BYLAKUPPE, KARNATAKA',
    masterId: 10937,
  },
  {
    type: 'cityName',
    value: 'BARVALA, GUJARAT',
    masterId: 10562,
  },
  {
    type: 'cityName',
    value: 'MASKI, KARNATAKA',
    masterId: 13502,
  },
  {
    type: 'cityName',
    value: 'RACHERLA, ANDHRA PRADESH',
    masterId: 14531,
  },
  {
    type: 'cityName',
    value: 'AMRAN, GUJARAT',
    masterId: 10172,
  },
  {
    type: 'cityName',
    value: 'MANAPAD, TAMIL NADU',
    masterId: 13360,
  },
  {
    type: 'cityName',
    value: 'KAYALPATNAM, TAMIL NADU',
    masterId: 12627,
  },
  {
    type: 'cityName',
    value: 'IMPHAL, MANIPUR',
    masterId: 12066,
  },
  {
    type: 'cityName',
    value: 'NENAVA, GUJARAT',
    masterId: 13965,
  },
  {
    type: 'cityName',
    value: 'ASWARAOPETA, TELANGANA',
    masterId: 10283,
  },
  {
    type: 'cityName',
    value: 'KOTTAKKAL, KERALA',
    masterId: 12931,
  },
  {
    type: 'cityName',
    value: 'POONTHOTTAM, TAMIL NADU',
    masterId: 14452,
  },
  {
    type: 'cityName',
    value: 'AHORE, RAJASTHAN',
    masterId: 10059,
  },
  {
    type: 'cityName',
    value: 'MALAKONDA, ANDHRA PRADESH',
    masterId: 13300,
  },
  {
    type: 'cityName',
    value: 'MANVI, KARNATAKA',
    masterId: 13472,
  },
  {
    type: 'cityName',
    value: 'MODHERA, GUJARAT',
    masterId: 13605,
  },
  {
    type: 'cityName',
    value: 'PATUR, MAHARASHTRA',
    masterId: 14315,
  },
  {
    type: 'cityName',
    value: 'KHOMBHDI MOTI, GUJARAT',
    masterId: 12761,
  },
  {
    type: 'cityName',
    value: 'BACHANPALLE, ANDHRA PRADESH',
    masterId: 16823,
  },
  {
    type: 'cityName',
    value: 'MOTHADAKA, ANDHRA PRADESH',
    masterId: 13660,
  },
  {
    type: 'cityName',
    value: 'MOTHARA, GUJARAT',
    masterId: 13661,
  },
  {
    type: 'cityName',
    value: 'KATHIPUDI, ANDHRA PRADESH',
    masterId: 12598,
  },
  {
    type: 'cityName',
    value: 'THALAIVASAL, TAMIL NADU',
    masterId: 15482,
  },
  {
    type: 'cityName',
    value: 'NIMBAJ, RAJASTHAN',
    masterId: 14013,
  },
  {
    type: 'cityName',
    value: 'BAGAUT, RAJASTHAN',
    masterId: 10366,
  },
  {
    type: 'cityName',
    value: 'KODAY, GUJARAT',
    masterId: 12816,
  },
  {
    type: 'cityName',
    value: 'VATAKARA, KERALA',
    masterId: 15805,
  },
  {
    type: 'cityName',
    value: 'KHADIYA, GUJARAT',
    masterId: 12676,
  },
  {
    type: 'cityName',
    value: 'KANCHIKACHERLA, ANDHRA PRADESH',
    masterId: 12469,
  },
  {
    type: 'cityName',
    value: 'VARSADA, GUJARAT',
    masterId: 15794,
  },
  {
    type: 'cityName',
    value: 'NESADI, GUJARAT',
    masterId: 13978,
  },
  {
    type: 'cityName',
    value: 'KRUTHIVENNU, ANDHRA PRADESH',
    masterId: 12964,
  },
  {
    type: 'cityName',
    value: 'NEKNOOR, MAHARASHTRA',
    masterId: 13959,
  },
  {
    type: 'cityName',
    value: 'SANCHORE, RAJASTHAN',
    masterId: 14889,
  },
  {
    type: 'cityName',
    value: 'KUMBALA, KERALA',
    masterId: 13002,
  },
  {
    type: 'cityName',
    value: 'SALAIPUTHUR, TAMIL NADU',
    masterId: 14834,
  },
  {
    type: 'cityName',
    value: 'AMBALLUR, KERALA',
    masterId: 10146,
  },
  {
    type: 'cityName',
    value: 'YEMMIGANUR, ANDHRA PRADESH',
    masterId: 15988,
  },
  {
    type: 'cityName',
    value: 'VADALI, ANDHRA PRADESH',
    masterId: 15729,
  },
  {
    type: 'cityName',
    value: 'UPPOOR, KARNATAKA',
    masterId: 15704,
  },
  {
    type: 'cityName',
    value: 'BARWANI, MADHYA PRADESH',
    masterId: 10567,
  },
  {
    type: 'cityName',
    value: 'MOHAL, HIMACHAL PRADESH',
    masterId: 13615,
  },
  {
    type: 'cityName',
    value: 'SOMESHWAR, KARNATAKA',
    masterId: 15257,
  },
  {
    type: 'cityName',
    value: 'KRISHNAN KOVIL, TAMIL NADU',
    masterId: 12955,
  },
  {
    type: 'cityName',
    value: 'BITA, GUJARAT',
    masterId: 10858,
  },
  {
    type: 'cityName',
    value: 'JAGANNADHAGIRI, ANDHRA PRADESH',
    masterId: 12109,
  },
  {
    type: 'cityName',
    value: 'BARPATOLI, GUJARAT',
    masterId: 10555,
  },
  {
    type: 'cityName',
    value: 'GANGANAGAR, RAJASTHAN',
    masterId: 11631,
  },
  {
    type: 'cityName',
    value: 'SAUNDATTI-YELLAMMA, KARNATAKA',
    masterId: 14986,
  },
  {
    type: 'cityName',
    value: 'VADASSERIKKARA, KERALA',
    masterId: 15733,
  },
  {
    type: 'cityName',
    value: 'GOKARNA, WEST BENGAL',
    masterId: 11743,
  },
  {
    type: 'cityName',
    value: 'NITHIRAVILAI, TAMIL NADU',
    masterId: 14033,
  },
  {
    type: 'cityName',
    value: 'VANDAVASI, TAMIL NADU',
    masterId: 15768,
  },
  {
    type: 'cityName',
    value: 'KINNIGOLI, KARNATAKA',
    masterId: 12788,
  },
  {
    type: 'cityName',
    value: 'DAMALACHERUVU, ANDHRA PRADESH',
    masterId: 11211,
  },
  {
    type: 'cityName',
    value: 'KUKKUNDOOR, KARNATAKA',
    masterId: 12982,
  },
  {
    type: 'cityName',
    value: 'SHAHAJAPUR, MAHARASHTRA',
    masterId: 15042,
  },
  {
    type: 'cityName',
    value: 'RAJAM, ANDHRA PRADESH',
    masterId: 14570,
  },
  {
    type: 'cityName',
    value: 'DHAKI, PUNJAB',
    masterId: 11330,
  },
  {
    type: 'cityName',
    value: 'NAUKA, JHARKHAND',
    masterId: 13920,
  },
  {
    type: 'cityName',
    value: 'SATHANKULAM, TAMIL NADU',
    masterId: 14970,
  },
  {
    type: 'cityName',
    value: 'GARH, MADHYA PRADESH',
    masterId: 11651,
  },
  {
    type: 'cityName',
    value: 'MUNDRIGI, KARNATAKA',
    masterId: 13725,
  },
  {
    type: 'cityName',
    value: 'PEDAPUDI, ANDHRA PRADESH',
    masterId: 14331,
  },
  {
    type: 'cityName',
    value: 'BORI, GUJARAT',
    masterId: 10892,
  },
  {
    type: 'cityName',
    value: 'NUNNA, ANDHRA PRADESH',
    masterId: 14062,
  },
  {
    type: 'cityName',
    value: 'SATHYAMANGALAM, TAMIL NADU',
    masterId: 14973,
  },
  {
    type: 'cityName',
    value: 'PENUMANTRA, ANDHRA PRADESH',
    masterId: 14353,
  },
  {
    type: 'cityName',
    value: 'PUNJAPADAR, GUJARAT',
    masterId: 14502,
  },
  {
    type: 'cityName',
    value: 'JAITARAN, RAJASTHAN',
    masterId: 12133,
  },
  {
    type: 'cityName',
    value: 'KARAMPUDI, ANDHRA PRADESH',
    masterId: 12533,
  },
  {
    type: 'cityName',
    value: 'PALLIVELA, ANDHRA PRADESH',
    masterId: 14167,
  },
  {
    type: 'cityName',
    value: 'YEDAPADAVU, KARNATAKA',
    masterId: 15980,
  },
  {
    type: 'cityName',
    value: 'PINDAKHAI NANI, GUJARAT',
    masterId: 14404,
  },
  {
    type: 'cityName',
    value: 'MANDAL, GUJARAT',
    masterId: 13372,
  },
  {
    type: 'cityName',
    value: 'SURAPURA, KARNATAKA',
    masterId: 15351,
  },
  {
    type: 'cityName',
    value: 'KAVERIPATTINAM, TAMIL NADU',
    masterId: 12621,
  },
  {
    type: 'cityName',
    value: 'HUMCHA, KARNATAKA',
    masterId: 12041,
  },
  {
    type: 'cityName',
    value: 'COYALMANNAM, KERALA',
    masterId: 11168,
  },
  {
    type: 'cityName',
    value: 'KOMARAGIRI PATNAM, ANDHRA PRADESH',
    masterId: 12860,
  },
  {
    type: 'cityName',
    value: 'GAUTRA PATTI NARPAT RAMSI, UTTAR PRADESH',
    masterId: 11677,
  },
  {
    type: 'cityName',
    value: 'VITE, MAHARASHTRA',
    masterId: 15910,
  },
  {
    type: 'cityName',
    value: 'KEDARNATH, UTTARAKHAND',
    masterId: 12636,
  },
  {
    type: 'cityName',
    value: 'SAYRA, RAJASTHAN',
    masterId: 15003,
  },
  {
    type: 'cityName',
    value: 'DUWURU, ANDHRA PRADESH',
    masterId: 11505,
  },
  {
    type: 'cityName',
    value: 'PUTALPATTU, ANDHRA PRADESH',
    masterId: 14522,
  },
  {
    type: 'cityName',
    value: 'JAMMALAMADUGU, ANDHRA PRADESH',
    masterId: 12176,
  },
  {
    type: 'cityName',
    value: 'GOPALAPURAM, ANDHRA PRADESH',
    masterId: 11768,
  },
  {
    type: 'cityName',
    value: 'ERAL, TAMIL NADU',
    masterId: 11533,
  },
  {
    type: 'cityName',
    value: 'DEVGADH, GUJARAT',
    masterId: 11316,
  },
  {
    type: 'cityName',
    value: 'KUMBANAD, KERALA',
    masterId: 13003,
  },
  {
    type: 'cityName',
    value: 'PUSAD, MAHARASHTRA',
    masterId: 14516,
  },
  {
    type: 'cityName',
    value: 'KOMAANAPALLI, ANDHRA PRADESH',
    masterId: 12857,
  },
  {
    type: 'cityName',
    value: 'DAHEGAM, GUJARAT',
    masterId: 11193,
  },
  {
    type: 'cityName',
    value: 'VAJDI, GUJARAT',
    masterId: 15753,
  },
  {
    type: 'cityName',
    value: 'NIMBI, HARYANA',
    masterId: 14016,
  },
  {
    type: 'cityName',
    value: 'MOHANUR, TAMIL NADU',
    masterId: 13620,
  },
  {
    type: 'cityName',
    value: 'DRAKSHARAMAM, ANDHRA PRADESH',
    masterId: 11468,
  },
  {
    type: 'cityName',
    value: 'LANJA, MAHARASHTRA',
    masterId: 13114,
  },
  {
    type: 'cityName',
    value: 'SHAHPURA, RAJASTHAN',
    masterId: 15051,
  },
  {
    type: 'cityName',
    value: 'RAPAKA, ANDHRA PRADESH',
    masterId: 14673,
  },
  {
    type: 'cityName',
    value: 'ATHOTA, ANDHRA PRADESH',
    masterId: 10291,
  },
  {
    type: 'cityName',
    value: 'VEERAVANALLUR, TAMIL NADU',
    masterId: 15820,
  },
  {
    type: 'cityName',
    value: 'SINDHNUR, KARNATAKA',
    masterId: 15184,
  },
  {
    type: 'cityName',
    value: 'DHARMASTHALA, KARNATAKA',
    masterId: 11371,
  },
  {
    type: 'cityName',
    value: 'THIRUMAYAM, TAMIL NADU',
    masterId: 15516,
  },
  {
    type: 'cityName',
    value: 'NAYAGAON, PUNJAB',
    masterId: 13945,
  },
  {
    type: 'cityName',
    value: 'VIJAYNAGAR, GUJARAT',
    masterId: 15874,
  },
  {
    type: 'cityName',
    value: 'THENMALA, KERALA',
    masterId: 15506,
  },
  {
    type: 'cityName',
    value: 'TOOMULURU, ANDHRA PRADESH',
    masterId: 15598,
  },
  {
    type: 'cityName',
    value: 'IRINJALAKUDA, KERALA',
    masterId: 12079,
  },
  {
    type: 'cityName',
    value: 'TRAPAJ, GUJARAT',
    masterId: 15604,
  },
  {
    type: 'cityName',
    value: 'BARKUR, KARNATAKA',
    masterId: 10543,
  },
  {
    type: 'cityName',
    value: 'SIRSI, KARNATAKA',
    masterId: 15219,
  },
  {
    type: 'cityName',
    value: 'KUBA, GUJARAT',
    masterId: 12965,
  },
  {
    type: 'cityName',
    value: 'PALAVANCHA, TELANGANA',
    masterId: 14150,
  },
  {
    type: 'cityName',
    value: 'PALAYAKAYAL, TAMIL NADU',
    masterId: 14151,
  },
  {
    type: 'cityName',
    value: 'NARUKULLAPADU, ANDHRA PRADESH',
    masterId: 13908,
  },
  {
    type: 'cityName',
    value: 'KODAD, TELANGANA',
    masterId: 12807,
  },
  {
    type: 'cityName',
    value: 'SATARDA, MAHARASHTRA',
    masterId: 14968,
  },
  {
    type: 'cityName',
    value: 'NARRAWADA, ANDHRA PRADESH',
    masterId: 13901,
  },
  {
    type: 'cityName',
    value: 'BARGI, MADHYA PRADESH',
    masterId: 10527,
  },
  {
    type: 'cityName',
    value: 'MEDIPALLY, TELANGANA',
    masterId: 13549,
  },
  {
    type: 'cityName',
    value: 'NANDIPADU, ANDHRA PRADESH',
    masterId: 13863,
  },
  {
    type: 'cityName',
    value: 'BAPDA, HARYANA',
    masterId: 10496,
  },
  {
    type: 'cityName',
    value: 'KALLAL, TAMIL NADU',
    masterId: 12410,
  },
  {
    type: 'cityName',
    value: 'BHILODA, GUJARAT',
    masterId: 10743,
  },
  {
    type: 'cityName',
    value: 'NILESHWAR, KERALA',
    masterId: 14008,
  },
  {
    type: 'cityName',
    value: 'THALAYOLAPARAMBU, KERALA',
    masterId: 15486,
  },
  {
    type: 'cityName',
    value: 'PODILI, ANDHRA PRADESH',
    masterId: 14436,
  },
  {
    type: 'cityName',
    value: 'EDURULANKA, ANDHRA PRADESH',
    masterId: 11519,
  },
  {
    type: 'cityName',
    value: 'MALWADA, MAHARASHTRA',
    masterId: 13344,
  },
  {
    type: 'cityName',
    value: 'KARATAGI, KARNATAKA',
    masterId: 12540,
  },
  {
    type: 'cityName',
    value: 'HARALAKUNTE, KARNATAKA',
    masterId: 11921,
  },
  {
    type: 'cityName',
    value: 'BODHGAYA, BIHAR',
    masterId: 10867,
  },
  {
    type: 'cityName',
    value: 'DHULIA, WEST BENGAL',
    masterId: 11410,
  },
  {
    type: 'cityName',
    value: 'SIRKALI, TAMIL NADU',
    masterId: 15211,
  },
  {
    type: 'cityName',
    value: 'KATTA, MAHARASHTRA',
    masterId: 12608,
  },
  {
    type: 'cityName',
    value: 'KANDALLOOR, KERALA',
    masterId: 12472,
  },
  {
    type: 'cityName',
    value: 'PAPANASAM, TAMIL NADU',
    masterId: 14225,
  },
  {
    type: 'cityName',
    value: 'TRAKUDA, GUJARAT',
    masterId: 15603,
  },
  {
    type: 'cityName',
    value: 'OWK, ANDHRA PRADESH',
    masterId: 14097,
  },
  {
    type: 'cityName',
    value: 'KARJAT, MAHARASHTRA',
    masterId: 12555,
  },
  {
    type: 'cityName',
    value: 'CHIKARDA, RAJASTHAN',
    masterId: 11077,
  },
  {
    type: 'cityName',
    value: 'VIJAY, TAMIL NADU',
    masterId: 15870,
  },
  {
    type: 'cityName',
    value: 'VASI, GUJARAT',
    masterId: 15802,
  },
  {
    type: 'cityName',
    value: 'UMMEDABAD, RAJASTHAN',
    masterId: 15675,
  },
  {
    type: 'cityName',
    value: 'ARKULA, KARNATAKA',
    masterId: 10248,
  },
  {
    type: 'cityName',
    value: 'ADIPUR, GUJARAT',
    masterId: 10031,
  },
  {
    type: 'cityName',
    value: 'AHMEDPUR, MAHARASHTRA',
    masterId: 10058,
  },
  {
    type: 'cityName',
    value: 'KUNNAMKULAM, KERALA',
    masterId: 13028,
  },
  {
    type: 'cityName',
    value: 'KALPETTA, KERALA',
    masterId: 12425,
  },
  {
    type: 'cityName',
    value: 'MUNDARA, RAJASTHAN',
    masterId: 13717,
  },
  {
    type: 'cityName',
    value: 'MUVATTUPUZHA, KERALA',
    masterId: 13766,
  },
  {
    type: 'cityName',
    value: 'MANTHADA, TAMIL NADU',
    masterId: 13467,
  },
  {
    type: 'cityName',
    value: 'SIMGA, CHHATTISGARH',
    masterId: 15172,
  },
  {
    type: 'cityName',
    value: 'MANGAVANA, GUJARAT',
    masterId: 13419,
  },
  {
    type: 'cityName',
    value: 'KATAVARAM, ANDHRA PRADESH',
    masterId: 12591,
  },
  {
    type: 'cityName',
    value: 'LIMABDE, GUJARAT',
    masterId: 13140,
  },
  {
    type: 'cityName',
    value: 'SURVA, MADHYA PRADESH',
    masterId: 15366,
  },
  {
    type: 'cityName',
    value: 'NAVUNDA, KARNATAKA',
    masterId: 13933,
  },
  {
    type: 'cityName',
    value: 'V.M.CHATRAM, TAMIL NADU',
    masterId: 15721,
  },
  {
    type: 'cityName',
    value: 'JAGGAMPETA, ANDHRA PRADESH',
    masterId: 12120,
  },
  {
    type: 'cityName',
    value: 'VANDIPERIYAR, KERALA',
    masterId: 15769,
  },
  {
    type: 'cityName',
    value: 'BHARAPAR, GUJARAT',
    masterId: 10702,
  },
  {
    type: 'cityName',
    value: 'MANANTHAVADY, KERALA',
    masterId: 13358,
  },
  {
    type: 'cityName',
    value: 'CHOTIPADOLI, MAHARASHTRA',
    masterId: 17681,
  },
  {
    type: 'cityName',
    value: 'MUGGAULLA, ANDHRA PRADESH',
    masterId: 13687,
  },
  {
    type: 'cityName',
    value: 'GAL KOTDI, GUJARAT',
    masterId: 11610,
  },
  {
    type: 'cityName',
    value: 'VISNAGAR, GUJARAT',
    masterId: 15907,
  },
  {
    type: 'cityName',
    value: 'AJEKAR, KARNATAKA',
    masterId: 10070,
  },
  {
    type: 'cityName',
    value: 'MELUR, TAMIL NADU',
    masterId: 13569,
  },
  {
    type: 'cityName',
    value: 'SHELU BAZAR, MAHARASHTRA',
    masterId: 15076,
  },
  {
    type: 'cityName',
    value: 'JAGTIAL, TELANGANA',
    masterId: 12123,
  },
  {
    type: 'cityName',
    value: 'TERA, GUJARAT',
    masterId: 15476,
  },
  {
    type: 'cityName',
    value: 'BAGASARA, GUJARAT',
    masterId: 10365,
  },
  {
    type: 'cityName',
    value: 'PILWA, RAJASTHAN',
    masterId: 14400,
  },
  {
    type: 'cityName',
    value: 'GOBICHETTIPALAYAM, TAMIL NADU',
    masterId: 11730,
  },
  {
    type: 'cityName',
    value: 'THRIPRAYAR, KERALA',
    masterId: 15539,
  },
  {
    type: 'cityName',
    value: 'GANDEPALLI, ANDHRA PRADESH',
    masterId: 11618,
  },
  {
    type: 'cityName',
    value: 'BABLESHWAR, KARNATAKA',
    masterId: 10329,
  },
  {
    type: 'cityName',
    value: 'NILANGA, MAHARASHTRA',
    masterId: 14007,
  },
  {
    type: 'cityName',
    value: 'SHEOGANJ, RAJASTHAN',
    masterId: 15080,
  },
  {
    type: 'cityName',
    value: 'FAIZPUR, MAHARASHTRA',
    masterId: 11552,
  },
  {
    type: 'cityName',
    value: 'KALAKKAD, TAMIL NADU',
    masterId: 12371,
  },
  {
    type: 'cityName',
    value: 'SIRUGUPPA, KARNATAKA',
    masterId: 15220,
  },
  {
    type: 'cityName',
    value: 'THATIPARRU, ANDHRA PRADESH',
    masterId: 15501,
  },
  {
    type: 'cityName',
    value: 'MANNARKKAD, KERALA',
    masterId: 13451,
  },
  {
    type: 'cityName',
    value: 'SEETHANGOLI, KERALA',
    masterId: 15010,
  },
  {
    type: 'cityName',
    value: 'SRINGERI, KARNATAKA',
    masterId: 15294,
  },
  {
    type: 'cityName',
    value: 'HARSORE, RAJASTHAN',
    masterId: 11953,
  },
  {
    type: 'cityName',
    value: 'KITHORE, UTTAR PRADESH',
    masterId: 12802,
  },
  {
    type: 'cityName',
    value: 'PASIGHAT, ARUNACHAL PRADESH',
    masterId: 14275,
  },
  {
    type: 'cityName',
    value: 'SUKHPUR, MADHYA PRADESH',
    masterId: 15318,
  },
  {
    type: 'cityName',
    value: 'PETH, MAHARASHTRA',
    masterId: 14376,
  },
  {
    type: 'cityName',
    value: 'CHATRA, JHARKHAND',
    masterId: 11017,
  },
  {
    type: 'cityName',
    value: 'KRISHNAGIRI, TAMIL NADU',
    masterId: 12953,
  },
  {
    type: 'cityName',
    value: 'PULIVENDULA, ANDHRA PRADESH',
    masterId: 14484,
  },
  {
    type: 'cityName',
    value: 'BANTWAL, KARNATAKA',
    masterId: 10494,
  },
  {
    type: 'cityName',
    value: 'WAKNAGHAT, HIMACHAL PRADESH',
    masterId: 15934,
  },
  {
    type: 'cityName',
    value: 'HAGARIBOMMANAHALLI, KARNATAKA',
    masterId: 11889,
  },
  {
    type: 'cityName',
    value: 'DANDELI, KARNATAKA',
    masterId: 11220,
  },
  {
    type: 'cityName',
    value: 'MANGALWADA, RAJASTHAN',
    masterId: 13415,
  },
  {
    type: 'cityName',
    value: 'RAMBHADRAPURAM, ANDHRA PRADESH',
    masterId: 14614,
  },
  {
    type: 'cityName',
    value: 'PUSAPADU, ANDHRA PRADESH',
    masterId: 14517,
  },
  {
    type: 'cityName',
    value: 'ANNUR, TAMIL NADU',
    masterId: 10220,
  },
  {
    type: 'cityName',
    value: 'ATHANKARAI, TAMIL NADU',
    masterId: 10289,
  },
  {
    type: 'cityName',
    value: 'YERMAL THENKA, KARNATAKA',
    masterId: 15992,
  },
  {
    type: 'cityName',
    value: 'UCHILA, KARNATAKA',
    masterId: 15635,
  },
  {
    type: 'cityName',
    value: 'BODI, MADHYA PRADESH',
    masterId: 10868,
  },
  {
    type: 'cityName',
    value: 'SINDHANUR, KARNATAKA',
    masterId: 15182,
  },
  {
    type: 'cityName',
    value: 'KILASEVALPATTI, TAMIL NADU',
    masterId: 12781,
  },
  {
    type: 'cityName',
    value: 'GANGOTRI, UTTARAKHAND',
    masterId: 11639,
  },
  {
    type: 'cityName',
    value: 'DHAKA, BANGLADESH',
    masterId: 18763,
  },
  {
    type: 'cityName',
    value: 'LUNAWADA, GUJARAT',
    masterId: 13174,
  },
  {
    type: 'cityName',
    value: 'ISLAMPUR, WEST BENGAL',
    masterId: 12086,
  },
  {
    type: 'cityName',
    value: 'MAVINGUNDI, KARNATAKA',
    masterId: 13532,
  },
  {
    type: 'cityName',
    value: 'KATEEL, KARNATAKA',
    masterId: 12592,
  },
  {
    type: 'cityName',
    value: 'BAGRU, RAJASTHAN',
    masterId: 10381,
  },
  {
    type: 'cityName',
    value: 'KUDUS, MAHARASHTRA',
    masterId: 12980,
  },
  {
    type: 'cityName',
    value: 'PULIYUR, TAMIL NADU',
    masterId: 14488,
  },
  {
    type: 'cityName',
    value: 'RAJAPUR, MAHARASHTRA',
    masterId: 14576,
  },
  {
    type: 'cityName',
    value: 'ARMOOR, TELANGANA',
    masterId: 10249,
  },
  {
    type: 'cityName',
    value: 'MANDWADA, MADHYA PRADESH',
    masterId: 13407,
  },
  {
    type: 'cityName',
    value: 'CHEYYERU, ANDHRA PRADESH',
    masterId: 11052,
  },
  {
    type: 'cityName',
    value: 'PRATAPGARH, RAJASTHAN',
    masterId: 14467,
  },
  {
    type: 'cityName',
    value: 'KHATIMA, UTTARAKHAND',
    masterId: 12733,
  },
  {
    type: 'cityName',
    value: 'MUDDEBIHAL, KARNATAKA',
    masterId: 13675,
  },
  {
    type: 'cityName',
    value: 'MANALI, HIMACHAL PRADESH',
    masterId: 13354,
  },
  {
    type: 'cityName',
    value: 'PIPPARA, ANDHRA PRADESH',
    masterId: 14421,
  },
  {
    type: 'cityName',
    value: 'LAYJA NANA, GUJARAT',
    masterId: 13131,
  },
  {
    type: 'cityName',
    value: 'NIPPANI, KARNATAKA',
    masterId: 14027,
  },
  {
    type: 'cityName',
    value: 'KAVITAM, ANDHRA PRADESH',
    masterId: 12622,
  },
  {
    type: 'cityName',
    value: 'SIVAKODU, ANDHRA PRADESH',
    masterId: 15235,
  },
  {
    type: 'cityName',
    value: 'SURANDAI, TAMIL NADU',
    masterId: 15350,
  },
  {
    type: 'cityName',
    value: 'TODA, GUJARAT',
    masterId: 15593,
  },
  {
    type: 'cityName',
    value: 'SHIRALI, KARNATAKA',
    masterId: 15092,
  },
  {
    type: 'cityName',
    value: 'PADUMARNADU, KARNATAKA',
    masterId: 14122,
  },
  {
    type: 'cityName',
    value: 'MANDAVA, GUJARAT',
    masterId: 13385,
  },
  {
    type: 'cityName',
    value: 'PUTTAPARTHI, ANDHRA PRADESH',
    masterId: 14526,
  },
  {
    type: 'cityName',
    value: 'JAWAL, RAJASTHAN',
    masterId: 12219,
  },
  {
    type: 'cityName',
    value: 'SHAHUWADI, MAHARASHTRA',
    masterId: 15053,
  },
  {
    type: 'cityName',
    value: 'SAPUTARA, GUJARAT',
    masterId: 14930,
  },
  {
    type: 'cityName',
    value: 'SULTHAN BATHERY, KERALA',
    masterId: 15332,
  },
  {
    type: 'cityName',
    value: 'NERIAMANGALAM, KERALA',
    masterId: 13975,
  },
  {
    type: 'cityName',
    value: 'RATDI, GUJARAT',
    masterId: 14686,
  },
  {
    type: 'cityName',
    value: 'ANEGUDDE, KARNATAKA',
    masterId: 10199,
  },
  {
    type: 'cityName',
    value: 'DATALA, MAHARASHTRA',
    masterId: 11247,
  },
  {
    type: 'cityName',
    value: 'NIDUMUKKALA, ANDHRA PRADESH',
    masterId: 13999,
  },
  {
    type: 'cityName',
    value: 'MANDAR, RAJASTHAN',
    masterId: 13382,
  },
  {
    type: 'cityName',
    value: 'HUNSEMAKKI, KARNATAKA',
    masterId: 12044,
  },
  {
    type: 'cityName',
    value: 'YENDAGANDI, ANDHRA PRADESH',
    masterId: 15989,
  },
  {
    type: 'cityName',
    value: 'NAREGAL, KARNATAKA',
    masterId: 13893,
  },
  {
    type: 'cityName',
    value: 'GORENTLA, TELANGANA',
    masterId: 11777,
  },
  {
    type: 'cityName',
    value: 'PANGIDI GUDEM, ANDHRA PRADESH',
    masterId: 14209,
  },
  {
    type: 'cityName',
    value: 'PARBATSAR, RAJASTHAN',
    masterId: 14243,
  },
  {
    type: 'cityName',
    value: 'SANGAMNER, MAHARASHTRA',
    masterId: 14896,
  },
  {
    type: 'cityName',
    value: 'KOTTURU, ANDHRA PRADESH',
    masterId: 12939,
  },
  {
    type: 'cityName',
    value: 'PANDITA VILLURU, ANDHRA PRADESH',
    masterId: 14203,
  },
  {
    type: 'cityName',
    value: 'P. GANNAVARAM, ANDHRA PRADESH',
    masterId: 14101,
  },
  {
    type: 'cityName',
    value: 'BUCHI REDDY PALEM, ANDHRA PRADESH',
    masterId: 10912,
  },
  {
    type: 'cityName',
    value: 'THIRUKADAIYUR, TAMIL NADU',
    masterId: 15512,
  },
  {
    type: 'cityName',
    value: 'SADRI, RAJASTHAN',
    masterId: 14790,
  },
  {
    type: 'cityName',
    value: 'BELMAN, KARNATAKA',
    masterId: 10627,
  },
];
